import {
  Anchor2,
  Branch,
  Button,
  ButtonGroup,
  ButtonGroupSeparator,
  Close,
  Combination_default,
  ComponentsI18nProvider,
  Content,
  Content2,
  CopyButton,
  CopyField,
  Description,
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
  DismissableLayer,
  Divider,
  DrawnCheck,
  InfoTip,
  Item,
  Link,
  Overlay,
  PORTAL_HOST_ATTRIBUTE,
  Popover,
  PopoverAnchor,
  PopoverClose,
  PopoverContent2 as PopoverContent,
  PopoverTrigger2 as PopoverTrigger,
  Portal,
  Portal2,
  Presence,
  Presence2,
  Primitive,
  Primitive2,
  Primitive3,
  Root,
  Root2,
  Root3,
  Root4,
  SKIP,
  SUPPORTED_LOCALES,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  Slot,
  Slottable,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  TextField,
  Title,
  Tooltip,
  Trans,
  Trigger,
  VFileMessage,
  WarningProvider,
  arrow,
  asciiAlpha,
  asciiAlphanumeric,
  asciiControl,
  autoUpdate,
  ccount,
  clamp,
  clsx,
  clsx_default,
  combineExtensions,
  componentsI18n,
  composeEventHandlers,
  composeEventHandlers2,
  composeEventHandlers3,
  composeRefs,
  convert,
  createCollection,
  createContextScope,
  createContextScope2,
  createDialogScope,
  createRovingFocusGroupScope,
  createSlot,
  createSlottable,
  cva,
  dispatchDiscreteCustomEvent,
  escapeStringRegexp,
  factorySpace,
  flip,
  fromMarkdown,
  gfmStrikethrough,
  gfmStrikethroughFromMarkdown,
  gfmStrikethroughToMarkdown,
  gfmTable,
  gfmTableFromMarkdown,
  gfmTableToMarkdown,
  gfmTaskListItem,
  gfmTaskListItemFromMarkdown,
  gfmTaskListItemToMarkdown,
  hide,
  hideOthers,
  limitShift,
  loadComponentsLocale,
  markdownLineEnding,
  markdownLineEndingOrSpace,
  markdownSpace,
  name,
  normalizeIdentifier,
  normalizeLocale,
  offset,
  ok,
  setComponentsLocale,
  shadowPortalContainer,
  shift,
  size,
  textFieldVariants,
  unicodePunctuation,
  unicodeWhitespace,
  unreachable,
  useCallbackRef,
  useComponentsTranslation,
  useComposedRefs,
  useComposedRefs2,
  useControllableState,
  useControllableState2,
  useDirection,
  useDirection2,
  useFloating,
  useId,
  useId2,
  useLayoutEffect2,
  useLayoutEffect22,
  usePrevious,
  useScrollEdges,
  useShadowPortalContainer,
  useSize,
  useTranslation,
  visit,
  visitParents
} from "./chunk-WQBH2OZB.mjs";
import {
  MERCHANT_AGENT_MAX_MESSAGE_LENGTH,
  applyMerchantAgentChunk,
  createMerchantAgentChatState,
  formatMerchantAgentPreviewItems,
  formatMerchantAgentPreviewValue,
  humanizeMerchantAgentIdentifier,
  isMerchantAgentReloadingNotice,
  markMerchantAgentActionDecided,
  markMerchantAgentChangeUndone,
  markMerchantAgentUndoRefused,
  merchantAgentPreviewRowLabel,
  merchantAgentPreviewRows,
  merchantAgentRefusalNotice,
  merchantAgentStateFromDetail,
  merchantAgentUndoRefusal,
  parseMerchantAgentEventStream,
  parseMerchantAgentInline,
  parseMerchantAgentMarkdown,
  readMerchantAgentChange,
  readMerchantAgentEventStream,
  readMerchantAgentPreview,
  readMerchantAgentToolCard,
  resolveMerchantAgentHttpsLink,
  useMerchantAgentChat
} from "./chunk-SRZHE2FJ.mjs";
import {
  __commonJS,
  __export,
  __toESM
} from "./chunk-D57E6H3M.mjs";

// ../../node_modules/.pnpm/inline-style-parser@0.2.7/node_modules/inline-style-parser/cjs/index.js
var require_cjs = __commonJS({
  "../../node_modules/.pnpm/inline-style-parser@0.2.7/node_modules/inline-style-parser/cjs/index.js"(exports, module) {
    "use strict";
    var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
    var NEWLINE_REGEX = /\n/g;
    var WHITESPACE_REGEX = /^\s*/;
    var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
    var COLON_REGEX = /^:\s*/;
    var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
    var SEMICOLON_REGEX = /^[;\s]*/;
    var TRIM_REGEX = /^\s+|\s+$/g;
    var NEWLINE = "\n";
    var FORWARD_SLASH = "/";
    var ASTERISK = "*";
    var EMPTY_STRING = "";
    var TYPE_COMMENT = "comment";
    var TYPE_DECLARATION = "declaration";
    function index2(style, options) {
      if (typeof style !== "string") {
        throw new TypeError("First argument must be a string");
      }
      if (!style) return [];
      options = options || {};
      var lineno = 1;
      var column = 1;
      function updatePosition(str) {
        var lines = str.match(NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf(NEWLINE);
        column = ~i ? str.length - i : column + str.length;
      }
      function position2() {
        var start = { line: lineno, column };
        return function(node) {
          node.position = new Position(start);
          whitespace2();
          return node;
        };
      }
      function Position(start) {
        this.start = start;
        this.end = { line: lineno, column };
        this.source = options.source;
      }
      Position.prototype.content = style;
      function error2(msg) {
        var err = new Error(
          options.source + ":" + lineno + ":" + column + ": " + msg
        );
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else {
          throw err;
        }
      }
      function match(re2) {
        var m = re2.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
      }
      function whitespace2() {
        match(WHITESPACE_REGEX);
      }
      function comments(rules) {
        var c;
        rules = rules || [];
        while (c = comment()) {
          if (c !== false) {
            rules.push(c);
          }
        }
        return rules;
      }
      function comment() {
        var pos = position2();
        if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
        var i = 2;
        while (EMPTY_STRING != style.charAt(i) && (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))) {
          ++i;
        }
        i += 2;
        if (EMPTY_STRING === style.charAt(i - 1)) {
          return error2("End of comment missing");
        }
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
          type: TYPE_COMMENT,
          comment: str
        });
      }
      function declaration() {
        var pos = position2();
        var prop = match(PROPERTY_REGEX);
        if (!prop) return;
        comment();
        if (!match(COLON_REGEX)) return error2("property missing ':'");
        var val = match(VALUE_REGEX);
        var ret = pos({
          type: TYPE_DECLARATION,
          property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
          value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
        });
        match(SEMICOLON_REGEX);
        return ret;
      }
      function declarations() {
        var decls = [];
        comments(decls);
        var decl;
        while (decl = declaration()) {
          if (decl !== false) {
            decls.push(decl);
            comments(decls);
          }
        }
        return decls;
      }
      whitespace2();
      return declarations();
    }
    function trim(str) {
      return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
    }
    module.exports = index2;
  }
});

// ../../node_modules/.pnpm/style-to-object@1.0.14/node_modules/style-to-object/cjs/index.js
var require_cjs2 = __commonJS({
  "../../node_modules/.pnpm/style-to-object@1.0.14/node_modules/style-to-object/cjs/index.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = StyleToObject;
    var inline_style_parser_1 = __importDefault(require_cjs());
    function StyleToObject(style, iterator) {
      let styleObject = null;
      if (!style || typeof style !== "string") {
        return styleObject;
      }
      const declarations = (0, inline_style_parser_1.default)(style);
      const hasIterator = typeof iterator === "function";
      declarations.forEach((declaration) => {
        if (declaration.type !== "declaration") {
          return;
        }
        const { property, value } = declaration;
        if (hasIterator) {
          iterator(property, value, declaration);
        } else if (value) {
          styleObject = styleObject || {};
          styleObject[property] = value;
        }
      });
      return styleObject;
    }
  }
});

// ../../node_modules/.pnpm/style-to-js@1.1.21/node_modules/style-to-js/cjs/utilities.js
var require_utilities = __commonJS({
  "../../node_modules/.pnpm/style-to-js@1.1.21/node_modules/style-to-js/cjs/utilities.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.camelCase = void 0;
    var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
    var HYPHEN_REGEX = /-([a-z])/g;
    var NO_HYPHEN_REGEX = /^[^-]+$/;
    var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
    var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
    var skipCamelCase = function(property) {
      return !property || NO_HYPHEN_REGEX.test(property) || CUSTOM_PROPERTY_REGEX.test(property);
    };
    var capitalize = function(match, character) {
      return character.toUpperCase();
    };
    var trimHyphen = function(match, prefix) {
      return "".concat(prefix, "-");
    };
    var camelCase = function(property, options) {
      if (options === void 0) {
        options = {};
      }
      if (skipCamelCase(property)) {
        return property;
      }
      property = property.toLowerCase();
      if (options.reactCompat) {
        property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
      } else {
        property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
      }
      return property.replace(HYPHEN_REGEX, capitalize);
    };
    exports.camelCase = camelCase;
  }
});

// ../../node_modules/.pnpm/style-to-js@1.1.21/node_modules/style-to-js/cjs/index.js
var require_cjs3 = __commonJS({
  "../../node_modules/.pnpm/style-to-js@1.1.21/node_modules/style-to-js/cjs/index.js"(exports, module) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    var style_to_object_1 = __importDefault(require_cjs2());
    var utilities_1 = require_utilities();
    function StyleToJS(style, options) {
      var output = {};
      if (!style || typeof style !== "string") {
        return output;
      }
      (0, style_to_object_1.default)(style, function(property, value) {
        if (property && value) {
          output[(0, utilities_1.camelCase)(property, options)] = value;
        }
      });
      return output;
    }
    StyleToJS.default = StyleToJS;
    module.exports = StyleToJS;
  }
});

// ../../node_modules/.pnpm/extend@3.0.2/node_modules/extend/index.js
var require_extend = __commonJS({
  "../../node_modules/.pnpm/extend@3.0.2/node_modules/extend/index.js"(exports, module) {
    "use strict";
    var hasOwn = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var defineProperty = Object.defineProperty;
    var gOPD = Object.getOwnPropertyDescriptor;
    var isArray = function isArray2(arr) {
      if (typeof Array.isArray === "function") {
        return Array.isArray(arr);
      }
      return toStr.call(arr) === "[object Array]";
    };
    var isPlainObject2 = function isPlainObject3(obj) {
      if (!obj || toStr.call(obj) !== "[object Object]") {
        return false;
      }
      var hasOwnConstructor = hasOwn.call(obj, "constructor");
      var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
      if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
        return false;
      }
      var key;
      for (key in obj) {
      }
      return typeof key === "undefined" || hasOwn.call(obj, key);
    };
    var setProperty = function setProperty2(target, options) {
      if (defineProperty && options.name === "__proto__") {
        defineProperty(target, options.name, {
          enumerable: true,
          configurable: true,
          value: options.newValue,
          writable: true
        });
      } else {
        target[options.name] = options.newValue;
      }
    };
    var getProperty = function getProperty2(obj, name2) {
      if (name2 === "__proto__") {
        if (!hasOwn.call(obj, name2)) {
          return void 0;
        } else if (gOPD) {
          return gOPD(obj, name2).value;
        }
      }
      return obj[name2];
    };
    module.exports = function extend2() {
      var options, name2, src, copy, copyIsArray, clone;
      var target = arguments[0];
      var i = 1;
      var length = arguments.length;
      var deep = false;
      if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        i = 2;
      }
      if (target == null || typeof target !== "object" && typeof target !== "function") {
        target = {};
      }
      for (; i < length; ++i) {
        options = arguments[i];
        if (options != null) {
          for (name2 in options) {
            src = getProperty(target, name2);
            copy = getProperty(options, name2);
            if (target !== copy) {
              if (deep && copy && (isPlainObject2(copy) || (copyIsArray = isArray(copy)))) {
                if (copyIsArray) {
                  copyIsArray = false;
                  clone = src && isArray(src) ? src : [];
                } else {
                  clone = src && isPlainObject2(src) ? src : {};
                }
                setProperty(target, { name: name2, newValue: extend2(deep, clone, copy) });
              } else if (typeof copy !== "undefined") {
                setProperty(target, { name: name2, newValue: copy });
              }
            }
          }
        }
      }
      return target;
    };
  }
});

// src/components/composite/AlertDialog/AlertDialog.tsx
import * as React2 from "react";

// ../../node_modules/.pnpm/@radix-ui+react-alert-dialog@1.1.15_@types+react-dom@19.2.3_@types+react@19.2.14__@type_6e0a7cb35458ca16bb65361e77642bec/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var ROOT_NAME = "AlertDialog";
var [createAlertDialogContext, createAlertDialogScope] = createContextScope(ROOT_NAME, [
  createDialogScope
]);
var useDialogScope = createDialogScope();
var AlertDialog = (props) => {
  const { __scopeAlertDialog, ...alertDialogProps } = props;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx(Root4, { ...dialogScope, ...alertDialogProps, modal: true });
};
AlertDialog.displayName = ROOT_NAME;
var TRIGGER_NAME = "AlertDialogTrigger";
var AlertDialogTrigger = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...triggerProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ jsx(Trigger, { ...dialogScope, ...triggerProps, ref: forwardedRef });
  }
);
AlertDialogTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "AlertDialogPortal";
var AlertDialogPortal = (props) => {
  const { __scopeAlertDialog, ...portalProps } = props;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx(Portal2, { ...dialogScope, ...portalProps });
};
AlertDialogPortal.displayName = PORTAL_NAME;
var OVERLAY_NAME = "AlertDialogOverlay";
var AlertDialogOverlay = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...overlayProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ jsx(Overlay, { ...dialogScope, ...overlayProps, ref: forwardedRef });
  }
);
AlertDialogOverlay.displayName = OVERLAY_NAME;
var CONTENT_NAME = "AlertDialogContent";
var [AlertDialogContentProvider, useAlertDialogContentContext] = createAlertDialogContext(CONTENT_NAME);
var Slottable2 = createSlottable("AlertDialogContent");
var AlertDialogContent = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, children, ...contentProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    const contentRef = React.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, contentRef);
    const cancelRef = React.useRef(null);
    return /* @__PURE__ */ jsx(
      WarningProvider,
      {
        contentName: CONTENT_NAME,
        titleName: TITLE_NAME,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ jsx(AlertDialogContentProvider, { scope: __scopeAlertDialog, cancelRef, children: /* @__PURE__ */ jsxs(
          Content,
          {
            role: "alertdialog",
            ...dialogScope,
            ...contentProps,
            ref: composedRefs,
            onOpenAutoFocus: composeEventHandlers(contentProps.onOpenAutoFocus, (event) => {
              event.preventDefault();
              cancelRef.current?.focus({ preventScroll: true });
            }),
            onPointerDownOutside: (event) => event.preventDefault(),
            onInteractOutside: (event) => event.preventDefault(),
            children: [
              /* @__PURE__ */ jsx(Slottable2, { children }),
              /* @__PURE__ */ jsx(DescriptionWarning, { contentRef })
            ]
          }
        ) })
      }
    );
  }
);
AlertDialogContent.displayName = CONTENT_NAME;
var TITLE_NAME = "AlertDialogTitle";
var AlertDialogTitle = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...titleProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ jsx(Title, { ...dialogScope, ...titleProps, ref: forwardedRef });
  }
);
AlertDialogTitle.displayName = TITLE_NAME;
var DESCRIPTION_NAME = "AlertDialogDescription";
var AlertDialogDescription = React.forwardRef((props, forwardedRef) => {
  const { __scopeAlertDialog, ...descriptionProps } = props;
  const dialogScope = useDialogScope(__scopeAlertDialog);
  return /* @__PURE__ */ jsx(Description, { ...dialogScope, ...descriptionProps, ref: forwardedRef });
});
AlertDialogDescription.displayName = DESCRIPTION_NAME;
var ACTION_NAME = "AlertDialogAction";
var AlertDialogAction = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...actionProps } = props;
    const dialogScope = useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ jsx(Close, { ...dialogScope, ...actionProps, ref: forwardedRef });
  }
);
AlertDialogAction.displayName = ACTION_NAME;
var CANCEL_NAME = "AlertDialogCancel";
var AlertDialogCancel = React.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAlertDialog, ...cancelProps } = props;
    const { cancelRef } = useAlertDialogContentContext(CANCEL_NAME, __scopeAlertDialog);
    const dialogScope = useDialogScope(__scopeAlertDialog);
    const ref = useComposedRefs(forwardedRef, cancelRef);
    return /* @__PURE__ */ jsx(Close, { ...dialogScope, ...cancelProps, ref });
  }
);
AlertDialogCancel.displayName = CANCEL_NAME;
var DescriptionWarning = ({ contentRef }) => {
  const MESSAGE = `\`${CONTENT_NAME}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${CONTENT_NAME}\` by passing a \`${DESCRIPTION_NAME}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${CONTENT_NAME}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
  React.useEffect(() => {
    const hasDescription = document.getElementById(
      contentRef.current?.getAttribute("aria-describedby")
    );
    if (!hasDescription) console.warn(MESSAGE);
  }, [MESSAGE, contentRef]);
  return null;
};
var Root22 = AlertDialog;
var Trigger2 = AlertDialogTrigger;
var Portal22 = AlertDialogPortal;
var Overlay2 = AlertDialogOverlay;
var Content22 = AlertDialogContent;
var Action = AlertDialogAction;
var Cancel = AlertDialogCancel;
var Title2 = AlertDialogTitle;
var Description2 = AlertDialogDescription;

// src/components/composite/AlertDialog/AlertDialog.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
function cls(...parts) {
  return parts.filter(Boolean).join(" ");
}
var AlertDialogBusyContext = React2.createContext(false);
function AlertDialog2(props) {
  return /* @__PURE__ */ jsx2(Root22, { ...props });
}
AlertDialog2.displayName = "AlertDialog";
function AlertDialogTrigger2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx2(Trigger2, { ref, className: cls("buyscout-alert-dialog__trigger", className), ...props });
}
AlertDialogTrigger2.displayName = "AlertDialogTrigger";
function AlertDialogPortal2(props) {
  return /* @__PURE__ */ jsx2(Portal22, { ...props });
}
AlertDialogPortal2.displayName = "AlertDialogPortal";
function AlertDialogOverlay2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx2(Overlay2, { ref, className: cls("buyscout-alert-dialog__overlay", className), ...props });
}
AlertDialogOverlay2.displayName = "AlertDialogOverlay";
function activeElementOf(node) {
  const root3 = node.getRootNode();
  return root3 instanceof Document || root3 instanceof ShadowRoot ? root3.activeElement : null;
}
function focusIfAble(element2) {
  if (!element2?.isConnected || element2.closest("[inert], [hidden]")) return false;
  if ("disabled" in element2 && element2.disabled === true) return false;
  element2.focus();
  return activeElementOf(element2) === element2;
}
function AlertDialogContent2({
  ref,
  className,
  container,
  busy = false,
  focusFallback,
  onEscapeKeyDown,
  onCloseAutoFocus,
  children,
  ...props
}) {
  const portalContainer = typeof container === "function" ? container() : container ?? void 0;
  const openerRef = React2.useRef(null);
  const contentRef = React2.useCallback((node) => {
    if (ref) ref.current = node;
    if (!node) return;
    const active = activeElementOf(node);
    if (active instanceof HTMLElement && active !== node.ownerDocument.body && !node.contains(active)) {
      openerRef.current = active;
    }
  }, [ref]);
  return /* @__PURE__ */ jsxs2(AlertDialogPortal2, { container: portalContainer, children: [
    /* @__PURE__ */ jsx2(AlertDialogOverlay2, {}),
    /* @__PURE__ */ jsx2(
      Content22,
      {
        ref: contentRef,
        className: cls("buyscout-alert-dialog__content", className),
        onEscapeKeyDown: (event) => {
          onEscapeKeyDown?.(event);
          if (busy) event.preventDefault();
        },
        onCloseAutoFocus: (event) => {
          onCloseAutoFocus?.(event);
          if (event.defaultPrevented) return;
          const opener = openerRef.current;
          openerRef.current = null;
          if (focusIfAble(opener) || focusIfAble(focusFallback?.())) event.preventDefault();
        },
        "aria-busy": busy || void 0,
        ...props,
        children: /* @__PURE__ */ jsx2(AlertDialogBusyContext, { value: busy, children })
      }
    )
  ] });
}
AlertDialogContent2.displayName = "AlertDialogContent";
function AlertDialogHeader({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx2("div", { ref, className: cls("buyscout-alert-dialog__header", className), ...props });
}
AlertDialogHeader.displayName = "AlertDialogHeader";
function AlertDialogFooter({ ref, className, layout = "inline", ...props }) {
  return /* @__PURE__ */ jsx2("div", { ref, className: cls("buyscout-alert-dialog__footer", layout === "stacked" && "buyscout-alert-dialog__footer--stacked", className), ...props });
}
AlertDialogFooter.displayName = "AlertDialogFooter";
function AlertDialogTitle2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx2(Title2, { ref, className: cls("buyscout-alert-dialog__title", className), ...props });
}
AlertDialogTitle2.displayName = "AlertDialogTitle";
function AlertDialogDescription2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx2(
    Description2,
    {
      ref,
      className: cls("buyscout-alert-dialog__description", className),
      ...props
    }
  );
}
AlertDialogDescription2.displayName = "AlertDialogDescription";
var intentToButtonColor = {
  default: "primary",
  destructive: "error"
};
function AlertDialogAction2(props) {
  if (props.asChild) {
    const { asChild: _asChild, ref: ref2, className: className2, children: children2, ...domProps } = props;
    return /* @__PURE__ */ jsx2(
      Action,
      {
        asChild: true,
        ref: ref2,
        className: cls("buyscout-alert-dialog__action", className2),
        ...domProps,
        children: children2
      }
    );
  }
  const { intent = "default", ref, className, children, ...buttonProps } = props;
  return /* @__PURE__ */ jsx2(Action, { asChild: true, children: /* @__PURE__ */ jsx2(
    Button,
    {
      ref,
      variant: "prominent",
      color: intentToButtonColor[intent],
      className: cls("buyscout-alert-dialog__action", className),
      ...buttonProps,
      children
    }
  ) });
}
AlertDialogAction2.displayName = "AlertDialogAction";
function AlertDialogCancel2(props) {
  const busy = React2.use(AlertDialogBusyContext);
  if (props.asChild) {
    const { asChild: _asChild, ref: ref2, className: className2, children: children2, disabled: disabled3, ...domProps } = props;
    return /* @__PURE__ */ jsx2(
      Cancel,
      {
        asChild: true,
        ref: ref2,
        className: cls("buyscout-alert-dialog__cancel", className2),
        disabled: busy || disabled3,
        ...domProps,
        children: children2
      }
    );
  }
  const { ref, className, children, variant, disabled: disabled2, ...buttonProps } = props;
  return /* @__PURE__ */ jsx2(Cancel, { asChild: true, children: /* @__PURE__ */ jsx2(
    Button,
    {
      ref,
      variant: variant ?? "bordered",
      color: "neutral",
      className: cls("buyscout-alert-dialog__cancel", className),
      disabled: busy || disabled2,
      ...buttonProps,
      children
    }
  ) });
}
AlertDialogCancel2.displayName = "AlertDialogCancel";

// src/components/composite/AnnouncementBar/AnnouncementBar.tsx
import { useState } from "react";
import { MdCampaign, MdLink } from "react-icons/md";

// src/components/primitive/Text/Text.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
function Text({
  variant = "body",
  as: Component = "span",
  italic = false,
  className = "",
  children,
  ...rest
}) {
  const variantClass = `buyscout-text--${variant}`;
  const italicClass = italic ? "buyscout-text--italic" : "";
  const combinedClass = `buyscout-text ${variantClass} ${italicClass} ${className}`.trim().replace(/\s+/g, " ");
  return /* @__PURE__ */ jsx3(Component, { className: combinedClass, ...rest, children });
}
Text.displayName = "Text";

// src/components/composite/ChromeDismissButton/ChromeDismissButton.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
function ChromeDismissButton({ className, label, onClick, size: size5, variant = "borderless" }) {
  return /* @__PURE__ */ jsx4(
    Button,
    {
      variant,
      color: "neutral",
      shape: "circle",
      size: size5,
      iconOnly: true,
      "aria-label": label,
      className: clsx_default("buyscout-chrome-dismiss", className),
      onClick: (event) => {
        event.stopPropagation();
        onClick();
      },
      children: /* @__PURE__ */ jsx4("svg", { viewBox: "0 0 24 24", width: "1em", height: "1em", fill: "none", stroke: "currentColor", strokeWidth: 2.2, strokeLinecap: "round", "aria-hidden": "true", children: /* @__PURE__ */ jsx4("path", { d: "M6 6l12 12M18 6L6 18" }) })
    }
  );
}
ChromeDismissButton.displayName = "ChromeDismissButton";

// src/components/composite/AnnouncementBar/AnnouncementBar.tsx
import { Fragment, jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
function AnnouncementBar(props) {
  const { announcements, onClose, onClick, closable, dialogContainer } = props;
  const { t } = useComponentsTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const firstAnnouncement = announcements?.[0];
  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  if (!firstAnnouncement) return null;
  const link2 = firstAnnouncement.type === "Link" ? firstAnnouncement.link : void 0;
  const hasContent = firstAnnouncement.type === "Text" && firstAnnouncement.content;
  return /* @__PURE__ */ jsxs3(Fragment, { children: [
    /* @__PURE__ */ jsx5(
      "div",
      {
        "data-testid": "announcement-bar",
        className: `buyscout-announcement-bar ${props.className || ""}`,
        children: /* @__PURE__ */ jsxs3("div", { className: "buyscout-announcement-bar-container", children: [
          /* @__PURE__ */ jsx5("span", { className: "buyscout-announcement-bar-icon", "aria-hidden": "true", children: /* @__PURE__ */ jsx5(MdCampaign, {}) }),
          /* @__PURE__ */ jsx5("div", { className: "buyscout-announcement-bar-content", children: /* @__PURE__ */ jsx5("div", { className: "buyscout-announcement-bar-message-wrapper", children: /* @__PURE__ */ jsx5(
            Text,
            {
              variant: "body",
              as: "p",
              className: "buyscout-announcement-bar-message",
              children: firstAnnouncement.message
            }
          ) }) }),
          /* @__PURE__ */ jsxs3("div", { className: "buyscout-announcement-bar-actions", children: [
            link2 && /* @__PURE__ */ jsx5(Button, { variant: "prominent", size: "sm", className: "buyscout-announcement-bar-button", asChild: true, children: /* @__PURE__ */ jsxs3("a", { href: link2, target: "_blank", rel: "noopener noreferrer", onClick: () => onClick?.(firstAnnouncement), children: [
              /* @__PURE__ */ jsx5(MdLink, { size: 14, "aria-hidden": "true" }),
              /* @__PURE__ */ jsx5(Text, { variant: "body-sm", as: "span", children: t("announcementBar.view") }),
              /* @__PURE__ */ jsx5("span", { className: "buyscout-announcement-bar-hint", children: t("link.opensInNewTab") })
            ] }) }),
            hasContent && /* @__PURE__ */ jsx5(
              Button,
              {
                variant: "prominent",
                type: "button",
                size: "sm",
                className: "buyscout-announcement-bar-button",
                onClick: () => setDialogOpen(true),
                children: /* @__PURE__ */ jsx5(Text, { variant: "body-sm", as: "span", children: t("announcementBar.view") })
              }
            ),
            closable && /* @__PURE__ */ jsx5(
              ChromeDismissButton,
              {
                className: "buyscout-announcement-bar-close",
                size: "sm",
                label: t("announcementBar.dismissAria"),
                onClick: () => onClose(firstAnnouncement)
              }
            )
          ] })
        ] })
      }
    ),
    firstAnnouncement.content && /* @__PURE__ */ jsx5(Dialog, { modal: false, open: dialogOpen, onOpenChange: (next) => {
      if (!next) handleDialogClose();
    }, children: /* @__PURE__ */ jsxs3(DialogContent, { container: dialogContainer, fullScreenOnMobile: false, children: [
      /* @__PURE__ */ jsx5(DialogHeader, { children: /* @__PURE__ */ jsx5(DialogTitle, { children: firstAnnouncement.message }) }),
      /* @__PURE__ */ jsx5(DialogBody, { className: "buyscout-announcement-bar-dialog-body", children: /* @__PURE__ */ jsx5(DialogDescription, { asChild: true, children: /* @__PURE__ */ jsx5(Text, { variant: "body", as: "p", className: "buyscout-announcement-bar-dialog-content", children: firstAnnouncement.content }) }) }),
      /* @__PURE__ */ jsx5(DialogFooter, { children: /* @__PURE__ */ jsx5(DialogClose, { asChild: true, children: /* @__PURE__ */ jsx5(Button, { variant: "prominent", color: "primary", children: t("announcementBar.ok") }) }) })
    ] }) })
  ] });
}

// src/components/composite/ChatControls/ChatBar/ChatBar.tsx
import * as React133 from "react";
import { useEffect as useEffect52, useRef as useRef73, useState as useState62 } from "react";
import { LuArrowUp, LuAudioLines, LuPlus, LuX } from "react-icons/lu";
import { MdCheckroom } from "react-icons/md";

// ../../node_modules/.pnpm/@radix-ui+react-accordion@1.2.12_@types+react-dom@19.2.3_@types+react@19.2.14__@types+r_4d82d747906d1c9adf9f86c8f2f71923/node_modules/@radix-ui/react-accordion/dist/index.mjs
import React4 from "react";

// ../../node_modules/.pnpm/@radix-ui+react-collapsible@1.1.12_@types+react-dom@19.2.3_@types+react@19.2.14__@types_c02f84d67beea925c4d01ad3e6946c7c/node_modules/@radix-ui/react-collapsible/dist/index.mjs
import * as React3 from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var COLLAPSIBLE_NAME = "Collapsible";
var [createCollapsibleContext, createCollapsibleScope] = createContextScope(COLLAPSIBLE_NAME);
var [CollapsibleProvider, useCollapsibleContext] = createCollapsibleContext(COLLAPSIBLE_NAME);
var Collapsible = React3.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeCollapsible,
      open: openProp,
      defaultOpen,
      disabled: disabled2,
      onOpenChange,
      ...collapsibleProps
    } = props;
    const [open2, setOpen] = useControllableState({
      prop: openProp,
      defaultProp: defaultOpen ?? false,
      onChange: onOpenChange,
      caller: COLLAPSIBLE_NAME
    });
    return /* @__PURE__ */ jsx6(
      CollapsibleProvider,
      {
        scope: __scopeCollapsible,
        disabled: disabled2,
        contentId: useId(),
        open: open2,
        onOpenToggle: React3.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
        children: /* @__PURE__ */ jsx6(
          Primitive2.div,
          {
            "data-state": getState(open2),
            "data-disabled": disabled2 ? "" : void 0,
            ...collapsibleProps,
            ref: forwardedRef
          }
        )
      }
    );
  }
);
Collapsible.displayName = COLLAPSIBLE_NAME;
var TRIGGER_NAME2 = "CollapsibleTrigger";
var CollapsibleTrigger = React3.forwardRef(
  (props, forwardedRef) => {
    const { __scopeCollapsible, ...triggerProps } = props;
    const context = useCollapsibleContext(TRIGGER_NAME2, __scopeCollapsible);
    return /* @__PURE__ */ jsx6(
      Primitive2.button,
      {
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": getState(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        disabled: context.disabled,
        ...triggerProps,
        ref: forwardedRef,
        onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
      }
    );
  }
);
CollapsibleTrigger.displayName = TRIGGER_NAME2;
var CONTENT_NAME2 = "CollapsibleContent";
var CollapsibleContent = React3.forwardRef(
  (props, forwardedRef) => {
    const { forceMount, ...contentProps } = props;
    const context = useCollapsibleContext(CONTENT_NAME2, props.__scopeCollapsible);
    return /* @__PURE__ */ jsx6(Presence, { present: forceMount || context.open, children: ({ present }) => /* @__PURE__ */ jsx6(CollapsibleContentImpl, { ...contentProps, ref: forwardedRef, present }) });
  }
);
CollapsibleContent.displayName = CONTENT_NAME2;
var CollapsibleContentImpl = React3.forwardRef((props, forwardedRef) => {
  const { __scopeCollapsible, present, children, ...contentProps } = props;
  const context = useCollapsibleContext(CONTENT_NAME2, __scopeCollapsible);
  const [isPresent, setIsPresent] = React3.useState(present);
  const ref = React3.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const heightRef = React3.useRef(0);
  const height = heightRef.current;
  const widthRef = React3.useRef(0);
  const width = widthRef.current;
  const isOpen = context.open || isPresent;
  const isMountAnimationPreventedRef = React3.useRef(isOpen);
  const originalStylesRef = React3.useRef(void 0);
  React3.useEffect(() => {
    const rAF = requestAnimationFrame(() => isMountAnimationPreventedRef.current = false);
    return () => cancelAnimationFrame(rAF);
  }, []);
  useLayoutEffect2(() => {
    const node = ref.current;
    if (node) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node.style.transitionDuration,
        animationName: node.style.animationName
      };
      node.style.transitionDuration = "0s";
      node.style.animationName = "none";
      const rect = node.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width;
      if (!isMountAnimationPreventedRef.current) {
        node.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node.style.animationName = originalStylesRef.current.animationName;
      }
      setIsPresent(present);
    }
  }, [context.open, present]);
  return /* @__PURE__ */ jsx6(
    Primitive2.div,
    {
      "data-state": getState(context.open),
      "data-disabled": context.disabled ? "" : void 0,
      id: context.contentId,
      hidden: !isOpen,
      ...contentProps,
      ref: composedRefs,
      style: {
        [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
        [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0,
        ...props.style
      },
      children: isOpen && children
    }
  );
});
function getState(open2) {
  return open2 ? "open" : "closed";
}
var Root5 = Collapsible;
var Trigger3 = CollapsibleTrigger;
var Content3 = CollapsibleContent;

// ../../node_modules/.pnpm/@radix-ui+react-accordion@1.2.12_@types+react-dom@19.2.3_@types+react@19.2.14__@types+r_4d82d747906d1c9adf9f86c8f2f71923/node_modules/@radix-ui/react-accordion/dist/index.mjs
import { jsx as jsx7 } from "react/jsx-runtime";
var ACCORDION_NAME = "Accordion";
var ACCORDION_KEYS = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"];
var [Collection, useCollection, createCollectionScope] = createCollection(ACCORDION_NAME);
var [createAccordionContext, createAccordionScope] = createContextScope(ACCORDION_NAME, [
  createCollectionScope,
  createCollapsibleScope
]);
var useCollapsibleScope = createCollapsibleScope();
var Accordion = React4.forwardRef(
  (props, forwardedRef) => {
    const { type, ...accordionProps } = props;
    const singleProps = accordionProps;
    const multipleProps = accordionProps;
    return /* @__PURE__ */ jsx7(Collection.Provider, { scope: props.__scopeAccordion, children: type === "multiple" ? /* @__PURE__ */ jsx7(AccordionImplMultiple, { ...multipleProps, ref: forwardedRef }) : /* @__PURE__ */ jsx7(AccordionImplSingle, { ...singleProps, ref: forwardedRef }) });
  }
);
Accordion.displayName = ACCORDION_NAME;
var [AccordionValueProvider, useAccordionValueContext] = createAccordionContext(ACCORDION_NAME);
var [AccordionCollapsibleProvider, useAccordionCollapsibleContext] = createAccordionContext(
  ACCORDION_NAME,
  { collapsible: false }
);
var AccordionImplSingle = React4.forwardRef(
  (props, forwardedRef) => {
    const {
      value: valueProp,
      defaultValue,
      onValueChange = () => {
      },
      collapsible = false,
      ...accordionSingleProps
    } = props;
    const [value, setValue] = useControllableState({
      prop: valueProp,
      defaultProp: defaultValue ?? "",
      onChange: onValueChange,
      caller: ACCORDION_NAME
    });
    return /* @__PURE__ */ jsx7(
      AccordionValueProvider,
      {
        scope: props.__scopeAccordion,
        value: React4.useMemo(() => value ? [value] : [], [value]),
        onItemOpen: setValue,
        onItemClose: React4.useCallback(() => collapsible && setValue(""), [collapsible, setValue]),
        children: /* @__PURE__ */ jsx7(AccordionCollapsibleProvider, { scope: props.__scopeAccordion, collapsible, children: /* @__PURE__ */ jsx7(AccordionImpl, { ...accordionSingleProps, ref: forwardedRef }) })
      }
    );
  }
);
var AccordionImplMultiple = React4.forwardRef((props, forwardedRef) => {
  const {
    value: valueProp,
    defaultValue,
    onValueChange = () => {
    },
    ...accordionMultipleProps
  } = props;
  const [value, setValue] = useControllableState({
    prop: valueProp,
    defaultProp: defaultValue ?? [],
    onChange: onValueChange,
    caller: ACCORDION_NAME
  });
  const handleItemOpen = React4.useCallback(
    (itemValue) => setValue((prevValue = []) => [...prevValue, itemValue]),
    [setValue]
  );
  const handleItemClose = React4.useCallback(
    (itemValue) => setValue((prevValue = []) => prevValue.filter((value2) => value2 !== itemValue)),
    [setValue]
  );
  return /* @__PURE__ */ jsx7(
    AccordionValueProvider,
    {
      scope: props.__scopeAccordion,
      value,
      onItemOpen: handleItemOpen,
      onItemClose: handleItemClose,
      children: /* @__PURE__ */ jsx7(AccordionCollapsibleProvider, { scope: props.__scopeAccordion, collapsible: true, children: /* @__PURE__ */ jsx7(AccordionImpl, { ...accordionMultipleProps, ref: forwardedRef }) })
    }
  );
});
var [AccordionImplProvider, useAccordionContext] = createAccordionContext(ACCORDION_NAME);
var AccordionImpl = React4.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAccordion, disabled: disabled2, dir, orientation = "vertical", ...accordionProps } = props;
    const accordionRef = React4.useRef(null);
    const composedRefs = useComposedRefs(accordionRef, forwardedRef);
    const getItems = useCollection(__scopeAccordion);
    const direction = useDirection(dir);
    const isDirectionLTR = direction === "ltr";
    const handleKeyDown = composeEventHandlers(props.onKeyDown, (event) => {
      if (!ACCORDION_KEYS.includes(event.key)) return;
      const target = event.target;
      const triggerCollection = getItems().filter((item) => !item.ref.current?.disabled);
      const triggerIndex = triggerCollection.findIndex((item) => item.ref.current === target);
      const triggerCount = triggerCollection.length;
      if (triggerIndex === -1) return;
      event.preventDefault();
      let nextIndex = triggerIndex;
      const homeIndex = 0;
      const endIndex = triggerCount - 1;
      const moveNext = () => {
        nextIndex = triggerIndex + 1;
        if (nextIndex > endIndex) {
          nextIndex = homeIndex;
        }
      };
      const movePrev = () => {
        nextIndex = triggerIndex - 1;
        if (nextIndex < homeIndex) {
          nextIndex = endIndex;
        }
      };
      switch (event.key) {
        case "Home":
          nextIndex = homeIndex;
          break;
        case "End":
          nextIndex = endIndex;
          break;
        case "ArrowRight":
          if (orientation === "horizontal") {
            if (isDirectionLTR) {
              moveNext();
            } else {
              movePrev();
            }
          }
          break;
        case "ArrowDown":
          if (orientation === "vertical") {
            moveNext();
          }
          break;
        case "ArrowLeft":
          if (orientation === "horizontal") {
            if (isDirectionLTR) {
              movePrev();
            } else {
              moveNext();
            }
          }
          break;
        case "ArrowUp":
          if (orientation === "vertical") {
            movePrev();
          }
          break;
      }
      const clampedIndex = nextIndex % triggerCount;
      triggerCollection[clampedIndex].ref.current?.focus();
    });
    return /* @__PURE__ */ jsx7(
      AccordionImplProvider,
      {
        scope: __scopeAccordion,
        disabled: disabled2,
        direction: dir,
        orientation,
        children: /* @__PURE__ */ jsx7(Collection.Slot, { scope: __scopeAccordion, children: /* @__PURE__ */ jsx7(
          Primitive2.div,
          {
            ...accordionProps,
            "data-orientation": orientation,
            ref: composedRefs,
            onKeyDown: disabled2 ? void 0 : handleKeyDown
          }
        ) })
      }
    );
  }
);
var ITEM_NAME = "AccordionItem";
var [AccordionItemProvider, useAccordionItemContext] = createAccordionContext(ITEM_NAME);
var AccordionItem = React4.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAccordion, value, ...accordionItemProps } = props;
    const accordionContext = useAccordionContext(ITEM_NAME, __scopeAccordion);
    const valueContext = useAccordionValueContext(ITEM_NAME, __scopeAccordion);
    const collapsibleScope = useCollapsibleScope(__scopeAccordion);
    const triggerId = useId();
    const open2 = value && valueContext.value.includes(value) || false;
    const disabled2 = accordionContext.disabled || props.disabled;
    return /* @__PURE__ */ jsx7(
      AccordionItemProvider,
      {
        scope: __scopeAccordion,
        open: open2,
        disabled: disabled2,
        triggerId,
        children: /* @__PURE__ */ jsx7(
          Root5,
          {
            "data-orientation": accordionContext.orientation,
            "data-state": getState2(open2),
            ...collapsibleScope,
            ...accordionItemProps,
            ref: forwardedRef,
            disabled: disabled2,
            open: open2,
            onOpenChange: (open22) => {
              if (open22) {
                valueContext.onItemOpen(value);
              } else {
                valueContext.onItemClose(value);
              }
            }
          }
        )
      }
    );
  }
);
AccordionItem.displayName = ITEM_NAME;
var HEADER_NAME = "AccordionHeader";
var AccordionHeader = React4.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAccordion, ...headerProps } = props;
    const accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
    const itemContext = useAccordionItemContext(HEADER_NAME, __scopeAccordion);
    return /* @__PURE__ */ jsx7(
      Primitive2.h3,
      {
        "data-orientation": accordionContext.orientation,
        "data-state": getState2(itemContext.open),
        "data-disabled": itemContext.disabled ? "" : void 0,
        ...headerProps,
        ref: forwardedRef
      }
    );
  }
);
AccordionHeader.displayName = HEADER_NAME;
var TRIGGER_NAME3 = "AccordionTrigger";
var AccordionTrigger = React4.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAccordion, ...triggerProps } = props;
    const accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
    const itemContext = useAccordionItemContext(TRIGGER_NAME3, __scopeAccordion);
    const collapsibleContext = useAccordionCollapsibleContext(TRIGGER_NAME3, __scopeAccordion);
    const collapsibleScope = useCollapsibleScope(__scopeAccordion);
    return /* @__PURE__ */ jsx7(Collection.ItemSlot, { scope: __scopeAccordion, children: /* @__PURE__ */ jsx7(
      Trigger3,
      {
        "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
        "data-orientation": accordionContext.orientation,
        id: itemContext.triggerId,
        ...collapsibleScope,
        ...triggerProps,
        ref: forwardedRef
      }
    ) });
  }
);
AccordionTrigger.displayName = TRIGGER_NAME3;
var CONTENT_NAME3 = "AccordionContent";
var AccordionContent = React4.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAccordion, ...contentProps } = props;
    const accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
    const itemContext = useAccordionItemContext(CONTENT_NAME3, __scopeAccordion);
    const collapsibleScope = useCollapsibleScope(__scopeAccordion);
    return /* @__PURE__ */ jsx7(
      Content3,
      {
        role: "region",
        "aria-labelledby": itemContext.triggerId,
        "data-orientation": accordionContext.orientation,
        ...collapsibleScope,
        ...contentProps,
        ref: forwardedRef,
        style: {
          ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
          ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
          ...props.style
        }
      }
    );
  }
);
AccordionContent.displayName = CONTENT_NAME3;
function getState2(open2) {
  return open2 ? "open" : "closed";
}
var Root23 = Accordion;
var Item2 = AccordionItem;
var Header = AccordionHeader;
var Trigger22 = AccordionTrigger;
var Content23 = AccordionContent;

// src/components/primitive/Accordion/Accordion.tsx
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
function cls2(...parts) {
  return parts.filter(Boolean).join(" ");
}
var ChevronRightIcon = /* @__PURE__ */ jsx8(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: "buyscout-accordion__chevron-icon",
    children: /* @__PURE__ */ jsx8("path", { fill: "currentColor", d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6z" })
  }
);
function Accordion2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx8(
    Root23,
    {
      ref,
      className: cls2("buyscout-accordion", className),
      ...props
    }
  );
}
Accordion2.displayName = "Accordion";
function AccordionItem2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx8(
    Item2,
    {
      ref,
      className: cls2("buyscout-accordion__item", className),
      ...props
    }
  );
}
AccordionItem2.displayName = "AccordionItem";
function AccordionHeader2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx8(
    Header,
    {
      ref,
      className: cls2("buyscout-accordion__header", className),
      ...props
    }
  );
}
AccordionHeader2.displayName = "AccordionHeader";
function AccordionTrigger2({
  ref,
  className,
  children,
  asChild = false,
  ...props
}) {
  return /* @__PURE__ */ jsxs4(
    Trigger22,
    {
      ref,
      className: cls2("buyscout-accordion__trigger", className),
      asChild,
      ...props,
      children: [
        children,
        !asChild && /* @__PURE__ */ jsx8("span", { className: "buyscout-accordion__chevron", "aria-hidden": "true", children: ChevronRightIcon })
      ]
    }
  );
}
AccordionTrigger2.displayName = "AccordionTrigger";
function AccordionContent2({
  ref,
  className,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx8(
    Content23,
    {
      ref,
      className: cls2("buyscout-accordion__content", className),
      ...props,
      children: /* @__PURE__ */ jsx8("div", { className: "buyscout-accordion__content-inner", children })
    }
  );
}
AccordionContent2.displayName = "AccordionContent";

// src/components/primitive/Autocomplete/Autocomplete.tsx
import * as React5 from "react";
import { MdArrowDropDown } from "react-icons/md";

// src/utils/isImeComposing.ts
function isImeComposing(event) {
  return event.isComposing || event.keyCode === 229;
}

// src/components/primitive/Autocomplete/Autocomplete.tsx
import { jsx as jsx9, jsxs as jsxs5 } from "react/jsx-runtime";
var cx = (...parts) => parts.filter(Boolean).join(" ");
var defaultFilter = (text4, query, keywords) => {
  if (!query) return true;
  const needle = query.toLowerCase();
  return [text4, ...keywords ?? []].some((part) => part.toLowerCase().includes(needle));
};
var AutocompleteContext = React5.createContext(null);
function useAutocompleteContext(component) {
  const ctx = React5.use(AutocompleteContext);
  if (ctx === null) throw new Error(`${component} must be used within <Autocomplete>`);
  return ctx;
}
function Autocomplete({
  value,
  defaultValue,
  onValueChange,
  inputValue,
  defaultInputValue,
  onInputValueChange,
  shouldFilter = true,
  filter = defaultFilter,
  open: open2,
  defaultOpen,
  onOpenChange,
  children,
  ...props
}) {
  const isOpenControlled = open2 !== void 0;
  const [internalOpen, setInternalOpen] = React5.useState(defaultOpen ?? false);
  const isOpen = isOpenControlled ? open2 : internalOpen;
  const isValueControlled = value !== void 0;
  const [internalValue, setInternalValue] = React5.useState(defaultValue);
  const selectedValue = isValueControlled ? value : internalValue;
  const isQueryControlled = inputValue !== void 0;
  const [internalQuery, setInternalQuery] = React5.useState(defaultInputValue ?? "");
  const query = isQueryControlled ? inputValue : internalQuery;
  const [activeId, setActiveId] = React5.useState(null);
  const listboxId = `buyscout-ac-listbox-${React5.useId()}`;
  const listRef = React5.useRef(null);
  const visibilityRef = React5.useRef(/* @__PURE__ */ new Map());
  const [visibleCount, setVisibleCount] = React5.useState(0);
  const [settled, setSettled] = React5.useState(false);
  const registerVisibility = React5.useCallback((id, visible) => {
    const prev = visibilityRef.current.get(id);
    if (prev === visible) return;
    visibilityRef.current.set(id, visible);
    const delta = (visible ? 1 : 0) - (prev === true ? 1 : 0);
    if (delta !== 0) setVisibleCount((count2) => count2 + delta);
  }, []);
  const unregisterVisibility = React5.useCallback((id) => {
    const prev = visibilityRef.current.get(id);
    if (prev === void 0) return;
    visibilityRef.current.delete(id);
    if (prev) setVisibleCount((count2) => count2 - 1);
  }, []);
  const setOpen = React5.useCallback((next) => {
    if (!isOpenControlled) setInternalOpen(next);
    onOpenChange?.(next);
  }, [isOpenControlled, onOpenChange]);
  const setQuery = React5.useCallback((next, reason) => {
    if (!isQueryControlled) setInternalQuery(next);
    onInputValueChange?.(next, { reason });
  }, [isQueryControlled, onInputValueChange]);
  const selectItem = React5.useCallback((nextValue, label) => {
    if (!isValueControlled) setInternalValue(nextValue);
    onValueChange?.(nextValue);
    setQuery(label, "item-press");
    setActiveId(null);
    setOpen(false);
  }, [isValueControlled, onValueChange, setQuery, setOpen]);
  React5.useEffect(() => {
    if (!isOpen) {
      setActiveId(null);
      return;
    }
    const list2 = listRef.current;
    if (list2 === null) return;
    const first = list2.querySelector('[role="option"]:not([hidden]):not([aria-disabled="true"])');
    setActiveId(first?.id ?? null);
  }, [isOpen, query, visibleCount]);
  React5.useEffect(() => {
    setSettled(isOpen);
  }, [isOpen]);
  const ctx = React5.useMemo(() => ({
    query,
    shouldFilter,
    filter,
    selectedValue,
    activeId,
    visibleCount,
    settled,
    listboxId,
    listRef,
    setActiveId,
    selectItem,
    registerVisibility,
    unregisterVisibility
  }), [query, shouldFilter, filter, selectedValue, activeId, visibleCount, settled, listboxId, selectItem, registerVisibility, unregisterVisibility]);
  const handleOpenChange = (next) => setOpen(next);
  return /* @__PURE__ */ jsx9(AutocompleteContext.Provider, { value: ctx, children: /* @__PURE__ */ jsx9(AutocompleteControlContext.Provider, { value: { query, setQuery, isOpen, setOpen }, children: /* @__PURE__ */ jsx9(Root2, { open: isOpen, onOpenChange: handleOpenChange, ...props, children }) }) });
}
Autocomplete.displayName = "Autocomplete";
var AutocompleteControlContext = React5.createContext(null);
function AutocompleteInput({
  ref,
  className,
  size: size5 = "md",
  error: error2 = false,
  hideCaret = false,
  onChange,
  onFocus,
  onKeyDown,
  disabled: disabled2,
  ...props
}) {
  const ctx = useAutocompleteContext("AutocompleteInput");
  const control = React5.use(AutocompleteControlContext);
  if (control === null) throw new Error("AutocompleteInput must be used within <Autocomplete>");
  const { query, setQuery, isOpen, setOpen } = control;
  const inputRef = React5.useRef(null);
  const setInputRef = (node) => {
    inputRef.current = node;
    if (ref) ref.current = node;
  };
  const moveActive = (direction) => {
    const list2 = ctx.listRef.current;
    if (list2 === null) return;
    const options = Array.from(
      list2.querySelectorAll('[role="option"]')
    ).filter((el) => !el.hidden && el.getAttribute("aria-disabled") !== "true");
    if (options.length === 0) {
      ctx.setActiveId(null);
      return;
    }
    const current = options.findIndex((el) => el.id === ctx.activeId);
    let nextIndex;
    if (direction === "first") nextIndex = 0;
    else if (direction === "last") nextIndex = options.length - 1;
    else if (direction === 1) nextIndex = current < 0 ? 0 : (current + 1) % options.length;
    else nextIndex = current <= 0 ? options.length - 1 : current - 1;
    const next = options[nextIndex];
    ctx.setActiveId(next.id);
    next.scrollIntoView({ block: "nearest" });
  };
  const handleKeyDown = (event) => {
    onKeyDown?.(event);
    if (event.defaultPrevented || isImeComposing(event.nativeEvent)) return;
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault();
        if (!isOpen) setOpen(true);
        else moveActive(1);
        break;
      case "ArrowUp":
        event.preventDefault();
        if (!isOpen) setOpen(true);
        else moveActive(-1);
        break;
      case "Home":
        if (isOpen) {
          event.preventDefault();
          moveActive("first");
        }
        break;
      case "End":
        if (isOpen) {
          event.preventDefault();
          moveActive("last");
        }
        break;
      case "Enter":
        if (isOpen && ctx.activeId !== null) {
          const el = ctx.listRef.current?.querySelector(`[role="option"][id="${CSS.escape(ctx.activeId)}"]`);
          if (el) {
            event.preventDefault();
            ctx.selectItem(el.dataset.value ?? "", el.dataset.label || el.textContent || "");
          }
        }
        break;
      case "Escape":
        if (isOpen) {
          event.preventDefault();
          setOpen(false);
        }
        break;
      default:
        break;
    }
  };
  return /* @__PURE__ */ jsx9(Anchor2, { asChild: true, children: /* @__PURE__ */ jsxs5(
    "div",
    {
      role: "presentation",
      className: cx(
        "buyscout-autocomplete__field",
        `buyscout-autocomplete__field--size-${size5}`,
        error2 && "buyscout-autocomplete__field--error",
        disabled2 && "buyscout-autocomplete__field--disabled",
        className
      ),
      onMouseDown: (event) => {
        if (disabled2 || event.target === inputRef.current) return;
        event.preventDefault();
        inputRef.current?.focus();
        if (!isOpen) setOpen(true);
      },
      children: [
        /* @__PURE__ */ jsx9(
          "input",
          {
            ...props,
            ref: setInputRef,
            role: "combobox",
            "aria-expanded": isOpen,
            "aria-controls": isOpen ? ctx.listboxId : void 0,
            "aria-autocomplete": "list",
            "aria-activedescendant": ctx.activeId ?? void 0,
            "aria-invalid": error2 || void 0,
            autoComplete: "off",
            disabled: disabled2,
            value: query,
            className: "buyscout-autocomplete__input",
            onChange: (event) => {
              onChange?.(event);
              setQuery(event.target.value, "input-change");
              if (!isOpen) setOpen(true);
            },
            onFocus: (event) => {
              onFocus?.(event);
              if (!isOpen) setOpen(true);
            },
            onKeyDown: handleKeyDown
          }
        ),
        !hideCaret && /* @__PURE__ */ jsxs5("span", { className: "buyscout-autocomplete__caret", "aria-hidden": "true", children: [
          /* @__PURE__ */ jsx9(MdArrowDropDown, { className: "buyscout-autocomplete__caret-glyph buyscout-autocomplete__caret-glyph--down" }),
          /* @__PURE__ */ jsx9("svg", { className: "buyscout-autocomplete__caret-glyph buyscout-autocomplete__caret-glyph--chevron", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx9("path", { d: "m6 9 6 6 6-6", fill: "none", stroke: "currentColor", strokeWidth: "1.85", strokeLinecap: "round", strokeLinejoin: "round" }) })
        ] })
      ]
    }
  ) });
}
AutocompleteInput.displayName = "AutocompleteInput";
function AutocompleteContent({
  ref,
  className,
  children,
  sideOffset = 6,
  align = "start",
  ...props
}) {
  const ctx = useAutocompleteContext("AutocompleteContent");
  const setListRef = (node) => {
    ctx.listRef.current = node;
    if (ref) ref.current = node;
  };
  return /* @__PURE__ */ jsx9(Portal, { children: /* @__PURE__ */ jsx9(
    Content2,
    {
      ref: setListRef,
      role: "listbox",
      sideOffset,
      align,
      onOpenAutoFocus: (event) => event.preventDefault(),
      onCloseAutoFocus: (event) => event.preventDefault(),
      onInteractOutside: (event) => {
        const target = event.detail.originalEvent.target;
        if (target instanceof Element && target.closest(".buyscout-autocomplete__field")) {
          event.preventDefault();
        }
      },
      className: cx("buyscout-autocomplete__content", className),
      ...props,
      id: ctx.listboxId,
      children
    }
  ) });
}
AutocompleteContent.displayName = "AutocompleteContent";
function AutocompleteItem({
  ref,
  className,
  children,
  value,
  textValue,
  keywords,
  disabled: disabled2 = false,
  onClick,
  onMouseEnter,
  ...props
}) {
  const ctx = useAutocompleteContext("AutocompleteItem");
  const { registerVisibility, unregisterVisibility } = ctx;
  const reactId = React5.useId();
  const id = `buyscout-ac-item-${reactId}`;
  const innerRef = React5.useRef(null);
  const explicitLabel = textValue ?? (typeof children === "string" ? children : void 0);
  const [domLabel, setDomLabel] = React5.useState("");
  React5.useEffect(() => {
    if (explicitLabel !== void 0) return;
    const text4 = innerRef.current?.textContent ?? "";
    setDomLabel((prev) => prev === text4 ? prev : text4);
  }, [explicitLabel]);
  const label = explicitLabel ?? domLabel;
  const visible = !ctx.shouldFilter || label === "" || ctx.filter(label, ctx.query, keywords);
  React5.useEffect(() => {
    registerVisibility(id, visible);
    return () => unregisterVisibility(id);
  }, [id, visible, registerVisibility, unregisterVisibility]);
  const setRefs = (node) => {
    innerRef.current = node;
    if (ref) ref.current = node;
  };
  const isActive = ctx.activeId === id;
  const isSelected = ctx.selectedValue === value;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events -- selection is bound to Enter on the combobox input, which keeps focus while aria-activedescendant tracks this option
    /* @__PURE__ */ jsx9(
      "div",
      {
        ...props,
        ref: setRefs,
        id,
        role: "option",
        tabIndex: -1,
        "data-value": value,
        "data-label": label,
        hidden: !visible,
        "aria-selected": isSelected,
        "aria-disabled": disabled2 || void 0,
        "data-active": isActive || void 0,
        className: cx("buyscout-autocomplete__item", className),
        onMouseDown: (event) => event.preventDefault(),
        onMouseEnter: (event) => {
          onMouseEnter?.(event);
          if (!disabled2) ctx.setActiveId(id);
        },
        onClick: (event) => {
          onClick?.(event);
          if (!disabled2) ctx.selectItem(value, label || (innerRef.current?.textContent ?? ""));
        },
        children
      }
    )
  );
}
AutocompleteItem.displayName = "AutocompleteItem";
function AutocompleteEmpty({ ref, className, children, ...props }) {
  const ctx = useAutocompleteContext("AutocompleteEmpty");
  if (!ctx.settled || ctx.visibleCount > 0) return null;
  return /* @__PURE__ */ jsx9("div", { ref, className: cx("buyscout-autocomplete__empty", className), ...props, children });
}
AutocompleteEmpty.displayName = "AutocompleteEmpty";
function AutocompleteGroup({ ref, className, children, ...props }) {
  return /* @__PURE__ */ jsx9("div", { ref, role: "group", className: cx("buyscout-autocomplete__group", className), ...props, children });
}
AutocompleteGroup.displayName = "AutocompleteGroup";
function AutocompleteLabel({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx9("div", { ref, className: cx("buyscout-autocomplete__label", className), ...props });
}
AutocompleteLabel.displayName = "AutocompleteLabel";

// ../../node_modules/.pnpm/@radix-ui+react-avatar@1.2.0_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_8f2abded34bc714745d1adfffbcafd80/node_modules/@radix-ui/react-avatar/dist/index.mjs
import * as React7 from "react";

// ../../node_modules/.pnpm/@radix-ui+react-context@1.1.4_@types+react@19.2.14_react@19.2.5/node_modules/@radix-ui/react-context/dist/index.mjs
import * as React6 from "react";
import { jsx as jsx10 } from "react/jsx-runtime";
function createContextScope3(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext32(rootComponentName, defaultContext) {
    const BaseContext = React6.createContext(defaultContext);
    BaseContext.displayName = rootComponentName + "Context";
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    const Provider2 = (props) => {
      const { scope, children, ...context } = props;
      const Context = scope?.[scopeName]?.[index2] || BaseContext;
      const value = React6.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ jsx10(Context.Provider, { value, children });
    };
    Provider2.displayName = rootComponentName + "Provider";
    function useContext22(consumerName, scope) {
      const Context = scope?.[scopeName]?.[index2] || BaseContext;
      const context = React6.useContext(Context);
      if (context) return context;
      if (defaultContext !== void 0) return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    return [Provider2, useContext22];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return React6.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = scope?.[scopeName] || scopeContexts;
      return React6.useMemo(
        () => ({ [`__scope${scopeName}`]: { ...scope, [scopeName]: contexts } }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext32, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1) return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return { ...nextScopes2, ...currentScope };
      }, {});
      return React6.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}

// ../../node_modules/.pnpm/@radix-ui+react-avatar@1.2.0_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_8f2abded34bc714745d1adfffbcafd80/node_modules/@radix-ui/react-avatar/dist/index.mjs
import { jsx as jsx11 } from "react/jsx-runtime";
var AVATAR_NAME = "Avatar";
var [createAvatarContext, createAvatarScope] = createContextScope3(AVATAR_NAME);
var STATIC_IMAGE_COUNT_STATE = [
  0,
  () => void 0
];
var [AvatarProvider, useAvatarContext] = createAvatarContext(AVATAR_NAME);
var Avatar = React7.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAvatar, ...avatarProps } = props;
    const [imageLoadingStatus, setImageLoadingStatus] = React7.useState("idle");
    const [imageCount, setImageCount] = useImageCount();
    return /* @__PURE__ */ jsx11(
      AvatarProvider,
      {
        scope: __scopeAvatar,
        imageLoadingStatus,
        setImageLoadingStatus,
        imageCount,
        setImageCount,
        children: /* @__PURE__ */ jsx11(Primitive.span, { ...avatarProps, ref: forwardedRef })
      }
    );
  }
);
Avatar.displayName = AVATAR_NAME;
var IMAGE_NAME = "AvatarImage";
var AvatarImage = React7.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAvatar, src, onLoadingStatusChange, ...imageProps } = props;
    const context = useAvatarContext(IMAGE_NAME, __scopeAvatar);
    useUpdateImageCount(context.setImageCount);
    const imageLoadingStatus = useImageLoadingStatus(src, {
      referrerPolicy: imageProps.referrerPolicy,
      crossOrigin: imageProps.crossOrigin,
      loadingStatus: context.imageLoadingStatus,
      setLoadingStatus: context.setImageLoadingStatus
    });
    const handleLoadingStatusChange = useCallbackRef((status) => {
      onLoadingStatusChange?.(status);
    });
    const loadingStatusRef = React7.useRef(imageLoadingStatus);
    useLayoutEffect22(() => {
      const previousLoadingStatus = loadingStatusRef.current;
      loadingStatusRef.current = imageLoadingStatus;
      if (imageLoadingStatus !== previousLoadingStatus) {
        handleLoadingStatusChange(imageLoadingStatus);
      }
    }, [imageLoadingStatus, handleLoadingStatusChange]);
    return imageLoadingStatus === "loaded" ? /* @__PURE__ */ jsx11(Primitive.img, { ...imageProps, ref: forwardedRef, src }) : null;
  }
);
AvatarImage.displayName = IMAGE_NAME;
var FALLBACK_NAME = "AvatarFallback";
var AvatarFallback = React7.forwardRef(
  (props, forwardedRef) => {
    const { __scopeAvatar, delayMs, ...fallbackProps } = props;
    const context = useAvatarContext(FALLBACK_NAME, __scopeAvatar);
    const [canRender, setCanRender] = React7.useState(delayMs === void 0);
    React7.useEffect(() => {
      if (delayMs !== void 0) {
        const timerId = window.setTimeout(() => setCanRender(true), delayMs);
        return () => window.clearTimeout(timerId);
      }
    }, [delayMs]);
    return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ jsx11(Primitive.span, { ...fallbackProps, ref: forwardedRef }) : null;
  }
);
AvatarFallback.displayName = FALLBACK_NAME;
function useImageLoadingStatus(src, {
  loadingStatus,
  setLoadingStatus,
  referrerPolicy,
  crossOrigin
}) {
  useLayoutEffect22(() => {
    if (!src) {
      setLoadingStatus("error");
      return;
    }
    const image2 = new window.Image();
    const handleLoad = (event) => {
      const image22 = event.currentTarget;
      setLoadingStatus(getImageLoadingStatus(image22));
    };
    const handleError = () => setLoadingStatus("error");
    image2.addEventListener("load", handleLoad);
    image2.addEventListener("error", handleError);
    if (referrerPolicy) {
      image2.referrerPolicy = referrerPolicy;
    }
    image2.crossOrigin = crossOrigin ?? null;
    image2.src = src;
    setLoadingStatus(getImageLoadingStatus(image2));
    return () => {
      image2.removeEventListener("load", handleLoad);
      image2.removeEventListener("error", handleError);
      setLoadingStatus("idle");
    };
  }, [src, crossOrigin, referrerPolicy, setLoadingStatus]);
  return loadingStatus;
}
function getImageLoadingStatus(image2) {
  return image2.complete ? image2.naturalWidth > 0 ? "loaded" : "error" : "loading";
}
function useImageCount() {
  let state = STATIC_IMAGE_COUNT_STATE;
  if (true) {
    state = React7.useState(0);
    const [imageCount] = state;
    const hasWarnedRef = React7.useRef(false);
    React7.useEffect(() => {
      if (imageCount > 1 && !hasWarnedRef.current) {
        hasWarnedRef.current = true;
        console.warn(
          "Avatar: Only one `Avatar.Image` component should be rendered per `Avatar.Root`, but multiple were detected. This will lead to unexpected behavior."
        );
      }
    }, [imageCount]);
  }
  return state;
}
function useUpdateImageCount(setImageCount) {
  if (true) {
    React7.useEffect(() => {
      setImageCount((imageCount) => imageCount + 1);
      return () => {
        setImageCount((imageCount) => imageCount - 1);
      };
    }, [setImageCount]);
  }
}

// src/components/primitive/Avatar/Avatar.tsx
import { jsx as jsx12, jsxs as jsxs6 } from "react/jsx-runtime";
var avatarVariants = cva("buyscout-avatar", {
  variants: {
    size: {
      sm: "buyscout-avatar--size-sm",
      md: "buyscout-avatar--size-md",
      lg: "buyscout-avatar--size-lg"
    },
    tone: {
      gradient: "buyscout-avatar--tone-gradient",
      gold: "buyscout-avatar--tone-gold",
      neutral: "buyscout-avatar--tone-neutral"
    },
    shape: {
      circle: "buyscout-avatar--shape-circle",
      rounded: "buyscout-avatar--shape-rounded"
    },
    // A logo is as often a wide wordmark as a square mark, and cropping one mid-word is worse
    // than letterboxing it, so logos take `contain`; photos and portraits fill with `cover`.
    fit: {
      cover: "buyscout-avatar--fit-cover",
      contain: "buyscout-avatar--fit-contain"
    }
  },
  defaultVariants: {
    size: "md",
    tone: "gradient",
    shape: "circle",
    fit: "cover"
  }
});
function Avatar2({
  ref,
  ...props
}) {
  const { src, alt = "", fallback, size: size5, tone, shape, fit, className, ...rest } = props;
  const classes2 = avatarVariants({ size: size5, tone, shape, fit, className });
  return /* @__PURE__ */ jsxs6(Avatar, { ref, className: classes2, ...rest, children: [
    src && /* @__PURE__ */ jsx12(AvatarImage, { className: "buyscout-avatar__image", src, alt }),
    /* @__PURE__ */ jsx12(AvatarFallback, { className: "buyscout-avatar__fallback", delayMs: src ? 200 : 0, children: fallback })
  ] });
}
Avatar2.displayName = "Avatar";

// src/components/primitive/Badge/Badge.tsx
import { jsx as jsx13, jsxs as jsxs7 } from "react/jsx-runtime";
var badgeVariants = cva("buyscout-badge", {
  variants: {
    variant: {
      solid: "buyscout-badge--variant-solid",
      soft: "buyscout-badge--variant-soft",
      outlined: "buyscout-badge--variant-outlined"
    },
    color: {
      primary: "buyscout-badge--color-primary",
      success: "buyscout-badge--color-success",
      warning: "buyscout-badge--color-warning",
      error: "buyscout-badge--color-error",
      neutral: "buyscout-badge--color-neutral"
    },
    size: {
      sm: "buyscout-badge--size-sm",
      md: "buyscout-badge--size-md"
    },
    count: {
      true: "buyscout-badge--count"
    }
  },
  defaultVariants: {
    variant: "soft",
    color: "neutral",
    size: "md"
  }
});
function Badge({
  ref,
  ...props
}) {
  const { variant, color, size: size5, count: count2 = false, asChild = false, dot = false, className, children, ...rest } = props;
  const Comp = asChild ? Slot : "span";
  const classes2 = badgeVariants({ variant, color, size: size5, count: count2, className });
  return /* @__PURE__ */ jsxs7(Comp, { ref, className: classes2, ...rest, children: [
    dot ? /* @__PURE__ */ jsx13("span", { "aria-hidden": true, className: "buyscout-badge__dot" }) : null,
    /* @__PURE__ */ jsx13(Slottable, { children })
  ] });
}
Badge.displayName = "Badge";

// src/components/primitive/Badge/BadgeOverlay.tsx
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
var indicatorVariants = cva("buyscout-badge-overlay__indicator", {
  variants: {
    color: {
      primary: "buyscout-badge-overlay__indicator--color-primary",
      success: "buyscout-badge-overlay__indicator--color-success",
      error: "buyscout-badge-overlay__indicator--color-error"
    },
    anchor: {
      "top-end": "buyscout-badge-overlay__indicator--anchor-top-end",
      "bottom-end": "buyscout-badge-overlay__indicator--anchor-bottom-end"
    },
    dot: {
      true: "buyscout-badge-overlay__indicator--dot",
      false: ""
    }
  },
  defaultVariants: {
    color: "error",
    anchor: "top-end",
    dot: false
  }
});
function BadgeOverlay({
  ref,
  count: count2,
  max: max2 = 99,
  dot = false,
  showZero = false,
  color,
  anchor,
  className,
  children,
  ...rest
}) {
  const resolved = count2 ?? 0;
  const show2 = dot || resolved > 0 || resolved === 0 && showZero;
  const display = resolved > max2 ? `${max2}+` : `${resolved}`;
  return /* @__PURE__ */ jsxs8("span", { ref, className: ["buyscout-badge-overlay", className].filter(Boolean).join(" "), ...rest, children: [
    children,
    show2 ? /* @__PURE__ */ jsx14("span", { "aria-hidden": true, className: indicatorVariants({ color, anchor, dot }), children: dot ? null : display }) : null
  ] });
}
BadgeOverlay.displayName = "BadgeOverlay";

// src/components/primitive/Callout/Callout.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
function cls3(...parts) {
  return parts.filter(Boolean).join(" ");
}
var calloutVariants = cva("buyscout-callout", {
  variants: {
    color: {
      neutral: "buyscout-callout--color-neutral",
      success: "buyscout-callout--color-success",
      warning: "buyscout-callout--color-warning",
      error: "buyscout-callout--color-error"
    },
    size: {
      sm: "buyscout-callout--size-sm",
      md: "buyscout-callout--size-md"
    }
  },
  defaultVariants: {
    color: "neutral",
    size: "md"
  }
});
function Callout({ ref, color, size: size5, className, ...props }) {
  return /* @__PURE__ */ jsx15("div", { ref, className: calloutVariants({ color, size: size5, className }), ...props });
}
Callout.displayName = "Callout";
function CalloutIcon({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx15("span", { ref, ...props, "aria-hidden": "true", className: cls3("buyscout-callout__chip", className) });
}
CalloutIcon.displayName = "CalloutIcon";
function CalloutContent({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx15("div", { ref, className: cls3("buyscout-callout__content", className), ...props });
}
CalloutContent.displayName = "CalloutContent";
function CalloutTitle({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx15("span", { ref, className: cls3("buyscout-callout__title", className), ...props });
}
CalloutTitle.displayName = "CalloutTitle";
function CalloutBody({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx15("p", { ref, className: cls3("buyscout-callout__body", className), ...props });
}
CalloutBody.displayName = "CalloutBody";
function CalloutList({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx15("ul", { ref, className: cls3("buyscout-callout__list", className), ...props });
}
CalloutList.displayName = "CalloutList";
function CalloutActions({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx15("div", { ref, className: cls3("buyscout-callout__actions", className), ...props });
}
CalloutActions.displayName = "CalloutActions";

// src/components/primitive/Card/Card.tsx
import { jsx as jsx16, jsxs as jsxs9 } from "react/jsx-runtime";
var cardVariants = cva("buyscout-card", {
  variants: {
    variant: {
      glass: "buyscout-card--glass",
      flat: "buyscout-card--flat"
    }
  },
  defaultVariants: {
    variant: "flat"
  }
});
var cardContentVariants = cva("buyscout-card__content", {
  variants: {
    padding: {
      none: "buyscout-card__content--padding-none",
      md: "buyscout-card__content--padding-md"
    }
  },
  defaultVariants: {
    padding: "md"
  }
});
function Card({
  ref,
  variant,
  padding,
  title,
  subheader,
  action,
  children,
  className,
  ...rest
}) {
  const hasHeader = title || subheader || action;
  return /* @__PURE__ */ jsxs9("div", { ref, className: cardVariants({ variant, className }), ...rest, children: [
    hasHeader && /* @__PURE__ */ jsxs9("div", { className: "buyscout-card__header", children: [
      /* @__PURE__ */ jsxs9("div", { className: "buyscout-card__header-text", children: [
        title && /* @__PURE__ */ jsx16(Text, { variant: "heading-2", as: "div", className: "buyscout-card__title", children: title }),
        subheader && /* @__PURE__ */ jsx16(Text, { variant: "body-secondary", as: "div", className: "buyscout-card__subheader", children: subheader })
      ] }),
      action && /* @__PURE__ */ jsx16("div", { className: "buyscout-card__action", children: action })
    ] }),
    children && /* @__PURE__ */ jsx16("div", { className: cardContentVariants({ padding }), children })
  ] });
}
Card.displayName = "Card";
var Card_default = Card;

// src/components/primitive/ChatImageView/ChatImageView.tsx
import { useState as useState6 } from "react";

// src/components/primitive/ImageFrame/ImageFrame.tsx
import * as React8 from "react";

// src/components/primitive/ImageFrame/productBagPath.ts
var PRODUCT_BAG_FILLED_PATH = "M19 6h-2c0-2.8-2.2-5-5-5S7 3.2 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-7-3c1.7 0 3 1.3 3 3H9c0-1.7 1.3-3 3-3m7 17H5V8h14zm-7-8c-1.7 0-3-1.3-3-3H7c0 2.8 2.2 5 5 5s5-2.2 5-5h-2c0 1.7-1.3 3-3 3";

// src/components/primitive/ImageFrame/ProductBagIcon.tsx
import { jsx as jsx17, jsxs as jsxs10 } from "react/jsx-runtime";
function ProductBagIcon({ variant, size: size5 }) {
  if (variant === "filled") {
    return /* @__PURE__ */ jsx17("svg", { width: size5, height: size5, viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true", children: /* @__PURE__ */ jsx17("path", { d: PRODUCT_BAG_FILLED_PATH }) });
  }
  return /* @__PURE__ */ jsxs10("svg", { width: size5, height: size5, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: [
    /* @__PURE__ */ jsx17("path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" }),
    /* @__PURE__ */ jsx17("line", { x1: "3", y1: "6", x2: "21", y2: "6" }),
    /* @__PURE__ */ jsx17("path", { d: "M16 10a4 4 0 0 1-8 0" })
  ] });
}
ProductBagIcon.displayName = "ProductBagIcon";

// src/components/primitive/ImageFrame/ImageFrame.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var imageFrameVariants = cva("buyscout-image-frame", {
  variants: {
    fallback: {
      "bag": "buyscout-image-frame--fallback-bag",
      "bag-filled": "buyscout-image-frame--fallback-bag-filled",
      "alt": "buyscout-image-frame--fallback-alt",
      "none": ""
    }
  },
  defaultVariants: {
    fallback: "none"
  }
});
function ImageFrame({
  ref,
  src,
  srcSet,
  sizes,
  alt,
  fallback = "none",
  loading,
  decoding,
  fetchPriority,
  crossOrigin,
  referrerPolicy,
  className,
  imgClassName,
  onLoad,
  onError,
  ...rest
}) {
  const { t } = useComponentsTranslation();
  const imgRef = React8.useRef(null);
  const key = `${src ?? ""} ${srcSet ?? ""}`;
  const [settled, setSettled] = React8.useState(null);
  const current = settled?.key === key ? settled : null;
  const state = !src ? "error" : current?.state ?? "loading";
  React8.useLayoutEffect(() => {
    const img = imgRef.current;
    if (img?.complete && img.naturalWidth > 0) {
      setSettled({ key, state: "loaded", instant: true });
    }
  }, [key]);
  const handleLoad = (event) => {
    setSettled((prev) => prev?.key === key && prev.state === "loaded" ? prev : { key, state: "loaded", instant: false });
    onLoad?.(event);
  };
  const handleError = (event) => {
    setSettled({ key, state: "error", instant: false });
    onError?.(event);
  };
  let content = null;
  if (state !== "error") {
    content = /* @__PURE__ */ jsx18(
      "img",
      {
        ref: imgRef,
        className: clsx_default("buyscout-image-frame__img", imgClassName),
        src,
        srcSet,
        sizes,
        alt,
        loading,
        decoding,
        fetchPriority,
        crossOrigin,
        referrerPolicy,
        draggable: false,
        onLoad: handleLoad,
        onError: handleError
      }
    );
  } else if (fallback === "alt") {
    content = alt || t("chatMessage.imageUnavailable");
  } else if (fallback === "bag" || fallback === "bag-filled") {
    content = /* @__PURE__ */ jsx18(
      "span",
      {
        className: "buyscout-image-frame__fallback",
        ...alt ? { "role": "img", "aria-label": alt } : { "aria-hidden": true },
        children: /* @__PURE__ */ jsx18(ProductBagIcon, { variant: fallback === "bag" ? "outline" : "filled" })
      }
    );
  }
  return /* @__PURE__ */ jsx18(
    "span",
    {
      ref,
      className: imageFrameVariants({ fallback, className }),
      "data-state": state,
      "data-instant": current?.instant || void 0,
      ...rest,
      children: content
    }
  );
}
ImageFrame.displayName = "ImageFrame";

// src/components/primitive/ChatImageView/ChatImageLightbox.tsx
import * as React9 from "react";
import { MdClose } from "react-icons/md";

// src/components/primitive/ChatImageView/lightboxSwipe.ts
import { useRef as useRef7 } from "react";
var DISMISS_DISTANCE_PX = 120;
var DISMISS_VELOCITY_PX_PER_MS = 0.5;
var FADE_DISTANCE_PX = 320;
var MIN_OPACITY = 0.4;
var VELOCITY_WINDOW_MS = 100;
function releaseVelocity(samples) {
  const last = samples.at(-1);
  if (!last) return 0;
  const first = samples.find((sample) => last.t - sample.t <= VELOCITY_WINDOW_MS) ?? last;
  return last.t > first.t ? (last.y - first.y) / (last.t - first.t) : 0;
}
function swipeDismisses(distance, velocity) {
  return distance >= DISMISS_DISTANCE_PX || distance > 0 && velocity >= DISMISS_VELOCITY_PX_PER_MS;
}
function dragOpacity(distance) {
  return Math.max(MIN_OPACITY, 1 - (1 - MIN_OPACITY) * distance / FADE_DISTANCE_PX);
}
var reducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function useSwipeToDismiss(panel, scrim, dismiss2) {
  const dragRef = useRef7(null);
  const touchesRef = useRef7(/* @__PURE__ */ new Set());
  const paint = (distance) => {
    const opacity = String(dragOpacity(distance));
    for (const element2 of [panel(), scrim()]) {
      if (!element2) continue;
      element2.style.transition = "";
      element2.style.opacity = opacity;
      element2.style.setProperty("--buyscout-lightbox-from-opacity", opacity);
    }
    panel()?.style.setProperty("translate", `0 ${distance}px`);
  };
  const settle = () => {
    for (const element2 of [panel(), scrim()]) {
      if (!element2) continue;
      element2.style.transition = "translate var(--bs-lg-spring-smooth-duration) var(--bs-lg-spring-smooth), opacity var(--bs-lg-spring-smooth-duration) var(--bs-lg-spring-smooth)";
      element2.style.removeProperty("translate");
      element2.style.removeProperty("opacity");
      element2.style.removeProperty("--buyscout-lightbox-from-opacity");
    }
  };
  const end = (event, release2) => {
    touchesRef.current.delete(event.pointerId);
    const current = dragRef.current;
    if (!current || current.id !== event.pointerId) return;
    dragRef.current = null;
    if (current.axis !== "down") return;
    const distance = Math.max(0, event.clientY - current.startY);
    current.samples.push({ y: event.clientY, t: event.timeStamp });
    if (release2 && swipeDismisses(distance, releaseVelocity(current.samples))) dismiss2();
    else if (!reducedMotion()) settle();
  };
  return {
    onPointerDown: (event) => {
      if (event.pointerType !== "touch") return;
      touchesRef.current.add(event.pointerId);
      if (touchesRef.current.size > 1) {
        if (dragRef.current?.axis === "down" && !reducedMotion()) settle();
        dragRef.current = null;
        return;
      }
      dragRef.current = { id: event.pointerId, startX: event.clientX, startY: event.clientY, samples: [{ y: event.clientY, t: event.timeStamp }] };
    },
    onPointerMove: (event) => {
      const current = dragRef.current;
      if (!current || current.id !== event.pointerId) return;
      const dx = event.clientX - current.startX;
      const dy = event.clientY - current.startY;
      if (!current.axis) {
        if (Math.hypot(dx, dy) < 8) return;
        current.axis = dy > Math.abs(dx) ? "down" : "other";
      }
      if (current.axis !== "down") return;
      current.samples.push({ y: event.clientY, t: event.timeStamp });
      if (current.samples.length > 20) current.samples.shift();
      if (!reducedMotion()) paint(Math.max(0, dy));
    },
    onPointerUp: (event) => end(event, true),
    onPointerCancel: (event) => end(event, false)
  };
}

// src/components/primitive/ChatImageView/ChatImageLightbox.tsx
import { jsx as jsx19, jsxs as jsxs11 } from "react/jsx-runtime";
function ChatImageLightbox({
  open: open2,
  onOpenChange,
  url,
  alt,
  className,
  container,
  ref
}) {
  const { t } = useComponentsTranslation();
  const panelRef = React9.useRef(null);
  const scrimRef = React9.useRef(null);
  const attachPanel = React9.useCallback((node) => {
    panelRef.current = node;
    if (ref) ref.current = node;
  }, [ref]);
  const swipe2 = useSwipeToDismiss(() => panelRef.current, () => scrimRef.current, () => onOpenChange(false));
  return /* @__PURE__ */ jsx19(Root4, { open: open2, onOpenChange, children: /* @__PURE__ */ jsxs11(Portal2, { container, children: [
    /* @__PURE__ */ jsx19(Overlay, { ref: scrimRef, className: "buyscout-chat-lightbox-overlay" }),
    /* @__PURE__ */ jsxs11(Content, { ref: attachPanel, className: clsx_default("buyscout-chat-lightbox", className), "aria-describedby": void 0, children: [
      /* @__PURE__ */ jsx19(Title, { className: "buyscout-chat-lightbox-title", children: alt ?? t("chatImage.previewTitle") }),
      /* @__PURE__ */ jsx19("img", { className: "buyscout-chat-lightbox-img", src: url, alt: alt ?? "", ...swipe2 }),
      /* @__PURE__ */ jsx19(Close, { asChild: true, children: /* @__PURE__ */ jsx19(Button, { variant: "glass", color: "neutral", shape: "circle", size: "md", iconOnly: true, "aria-label": t("chatImage.closeAria"), className: "buyscout-chat-lightbox-close", children: /* @__PURE__ */ jsx19(MdClose, { "aria-hidden": true }) }) })
    ] })
  ] }) });
}
ChatImageLightbox.displayName = "ChatImageLightbox";

// src/components/primitive/ChatImageView/lightboxHooks.ts
function useLightboxTriggerProps(alt, open2) {
  const { t } = useComponentsTranslation();
  return {
    "role": "button",
    "tabIndex": 0,
    "aria-label": alt ? t("chatImage.viewLargerAriaNamed", { name: alt }) : t("chatImage.viewLargerAria"),
    "onKeyDown": (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        open2();
      }
    }
  };
}

// src/components/primitive/ChatImageView/ChatImageView.tsx
import { Fragment as Fragment2, jsx as jsx20, jsxs as jsxs12 } from "react/jsx-runtime";
function ChatImageView({
  image: image2,
  className,
  enlargeable = false,
  onLoad,
  onError,
  ref
}) {
  const { url, alt, aspectRatio } = image2;
  const [open2, setOpen] = useState6(false);
  const [container, handleFigureRef] = useShadowPortalContainer(ref);
  const triggerProps = useLightboxTriggerProps(alt, () => setOpen(true));
  const figure = /* @__PURE__ */ jsx20(
    ImageFrame,
    {
      ref: handleFigureRef,
      src: url,
      alt: alt ?? "",
      loading: "lazy",
      className: clsx_default("buyscout-chat-image", enlargeable && "buyscout-chat-image--enlargeable", className),
      imgClassName: "buyscout-chat-image-img",
      onLoad,
      onError,
      style: aspectRatio ? { aspectRatio } : void 0,
      ...enlargeable && { ...triggerProps, onClick: () => setOpen(true) }
    }
  );
  if (!enlargeable) return figure;
  return /* @__PURE__ */ jsxs12(Fragment2, { children: [
    figure,
    /* @__PURE__ */ jsx20(ChatImageLightbox, { open: open2, onOpenChange: setOpen, url, alt, container })
  ] });
}
ChatImageView.displayName = "ChatImageView";

// ../../node_modules/.pnpm/@radix-ui+react-checkbox@1.3.7_@types+react-dom@19.2.3_@types+react@19.2.14__@types+rea_dfb3c901c94da9ee3bffd31143eed9e4/node_modules/@radix-ui/react-checkbox/dist/index.mjs
import * as React12 from "react";

// ../../node_modules/.pnpm/@radix-ui+react-use-previous@1.1.2_@types+react@19.2.14_react@19.2.5/node_modules/@radix-ui/react-use-previous/dist/index.mjs
import * as React10 from "react";
function usePrevious2(value) {
  const ref = React10.useRef({ value, previous: value });
  return React10.useMemo(() => {
    if (ref.current.value !== value) {
      ref.current.previous = ref.current.value;
      ref.current.value = value;
    }
    return ref.current.previous;
  }, [value]);
}

// ../../node_modules/.pnpm/@radix-ui+react-use-size@1.1.2_@types+react@19.2.14_react@19.2.5/node_modules/@radix-ui/react-use-size/dist/index.mjs
import * as React11 from "react";
function useSize2(element2) {
  const [size5, setSize] = React11.useState(void 0);
  useLayoutEffect22(() => {
    if (element2) {
      setSize({ width: element2.offsetWidth, height: element2.offsetHeight });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element2.offsetWidth;
          height = element2.offsetHeight;
        }
        setSize({ width, height });
      });
      resizeObserver.observe(element2, { box: "border-box" });
      return () => resizeObserver.unobserve(element2);
    } else {
      setSize(void 0);
    }
  }, [element2]);
  return size5;
}

// ../../node_modules/.pnpm/@radix-ui+react-checkbox@1.3.7_@types+react-dom@19.2.3_@types+react@19.2.14__@types+rea_dfb3c901c94da9ee3bffd31143eed9e4/node_modules/@radix-ui/react-checkbox/dist/index.mjs
import { Fragment as Fragment3, jsx as jsx21, jsxs as jsxs13 } from "react/jsx-runtime";
var CHECKBOX_NAME = "Checkbox";
var [createCheckboxContext, createCheckboxScope] = createContextScope2(CHECKBOX_NAME);
var [CheckboxProviderImpl, useCheckboxContext] = createCheckboxContext(CHECKBOX_NAME);
function CheckboxProvider(props) {
  const {
    __scopeCheckbox,
    checked: checkedProp,
    children,
    defaultChecked,
    disabled: disabled2,
    form,
    name: name2,
    onCheckedChange,
    required,
    value = "on",
    // @ts-expect-error
    internal_do_not_use_render
  } = props;
  const [checked, setChecked] = useControllableState2({
    prop: checkedProp,
    defaultProp: defaultChecked ?? false,
    onChange: onCheckedChange,
    caller: CHECKBOX_NAME
  });
  const [control, setControl] = React12.useState(null);
  const [bubbleInput, setBubbleInput] = React12.useState(null);
  const hasConsumerStoppedPropagationRef = React12.useRef(false);
  const isFormControl = control ? !!form || !!control.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    true
  );
  const context = {
    checked,
    disabled: disabled2,
    setChecked,
    control,
    setControl,
    name: name2,
    form,
    value,
    hasConsumerStoppedPropagationRef,
    required,
    defaultChecked: isIndeterminate(defaultChecked) ? false : defaultChecked,
    isFormControl,
    bubbleInput,
    setBubbleInput
  };
  return /* @__PURE__ */ jsx21(
    CheckboxProviderImpl,
    {
      scope: __scopeCheckbox,
      ...context,
      children: isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
    }
  );
}
var TRIGGER_NAME4 = "CheckboxTrigger";
var CheckboxTrigger = React12.forwardRef(
  ({ __scopeCheckbox, onKeyDown, onClick, ...checkboxProps }, forwardedRef) => {
    const {
      control,
      value,
      disabled: disabled2,
      checked,
      required,
      setControl,
      setChecked,
      hasConsumerStoppedPropagationRef,
      isFormControl,
      bubbleInput
    } = useCheckboxContext(TRIGGER_NAME4, __scopeCheckbox);
    const composedRefs = useComposedRefs2(forwardedRef, setControl);
    const initialCheckedStateRef = React12.useRef(checked);
    React12.useEffect(() => {
      const form = control?.form;
      if (form) {
        const reset = () => setChecked(initialCheckedStateRef.current);
        form.addEventListener("reset", reset);
        return () => form.removeEventListener("reset", reset);
      }
    }, [control, setChecked]);
    return /* @__PURE__ */ jsx21(
      Primitive3.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": getState3(checked),
        "data-disabled": disabled2 ? "" : void 0,
        disabled: disabled2,
        value,
        ...checkboxProps,
        ref: composedRefs,
        onKeyDown: composeEventHandlers3(onKeyDown, (event) => {
          if (event.key === "Enter") event.preventDefault();
        }),
        onClick: composeEventHandlers3(onClick, (event) => {
          setChecked((prevChecked) => isIndeterminate(prevChecked) ? true : !prevChecked);
          if (bubbleInput && isFormControl) {
            hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
            if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
          }
        })
      }
    );
  }
);
CheckboxTrigger.displayName = TRIGGER_NAME4;
var Checkbox = React12.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeCheckbox,
      name: name2,
      checked,
      defaultChecked,
      required,
      disabled: disabled2,
      value,
      onCheckedChange,
      form,
      ...checkboxProps
    } = props;
    return /* @__PURE__ */ jsx21(
      CheckboxProvider,
      {
        __scopeCheckbox,
        checked,
        defaultChecked,
        disabled: disabled2,
        required,
        onCheckedChange,
        name: name2,
        form,
        value,
        internal_do_not_use_render: ({ isFormControl }) => /* @__PURE__ */ jsxs13(Fragment3, { children: [
          /* @__PURE__ */ jsx21(
            CheckboxTrigger,
            {
              ...checkboxProps,
              ref: forwardedRef,
              __scopeCheckbox
            }
          ),
          isFormControl && /* @__PURE__ */ jsx21(
            CheckboxBubbleInput,
            {
              __scopeCheckbox
            }
          )
        ] })
      }
    );
  }
);
Checkbox.displayName = CHECKBOX_NAME;
var INDICATOR_NAME = "CheckboxIndicator";
var CheckboxIndicator = React12.forwardRef(
  (props, forwardedRef) => {
    const { __scopeCheckbox, forceMount, ...indicatorProps } = props;
    const context = useCheckboxContext(INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ jsx21(
      Presence2,
      {
        present: forceMount || isIndeterminate(context.checked) || context.checked === true,
        children: /* @__PURE__ */ jsx21(
          Primitive3.span,
          {
            "data-state": getState3(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: { pointerEvents: "none", ...props.style }
          }
        )
      }
    );
  }
);
CheckboxIndicator.displayName = INDICATOR_NAME;
var BUBBLE_INPUT_NAME = "CheckboxBubbleInput";
var CheckboxBubbleInput = React12.forwardRef(
  ({ __scopeCheckbox, ...props }, forwardedRef) => {
    const {
      control,
      hasConsumerStoppedPropagationRef,
      checked,
      defaultChecked,
      required,
      disabled: disabled2,
      name: name2,
      value,
      form,
      bubbleInput,
      setBubbleInput
    } = useCheckboxContext(BUBBLE_INPUT_NAME, __scopeCheckbox);
    const composedRefs = useComposedRefs2(forwardedRef, setBubbleInput);
    const prevChecked = usePrevious2(checked);
    const controlSize = useSize2(control);
    React12.useEffect(() => {
      const input = bubbleInput;
      if (!input) return;
      const inputProto = window.HTMLInputElement.prototype;
      const descriptor = Object.getOwnPropertyDescriptor(
        inputProto,
        "checked"
      );
      const setChecked = descriptor.set;
      const bubbles = !hasConsumerStoppedPropagationRef.current;
      if (prevChecked !== checked && setChecked) {
        const event = new Event("click", { bubbles });
        input.indeterminate = isIndeterminate(checked);
        setChecked.call(input, isIndeterminate(checked) ? false : checked);
        input.dispatchEvent(event);
      }
    }, [bubbleInput, prevChecked, checked, hasConsumerStoppedPropagationRef]);
    const defaultCheckedRef = React12.useRef(isIndeterminate(checked) ? false : checked);
    return /* @__PURE__ */ jsx21(
      Primitive3.input,
      {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: defaultChecked ?? defaultCheckedRef.current,
        required,
        disabled: disabled2,
        name: name2,
        value,
        form,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
          ...props.style,
          ...controlSize,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
CheckboxBubbleInput.displayName = BUBBLE_INPUT_NAME;
function isFunction(value) {
  return typeof value === "function";
}
function isIndeterminate(checked) {
  return checked === "indeterminate";
}
function getState3(checked) {
  return isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}

// src/components/primitive/Checkbox/Checkbox.tsx
import { jsx as jsx22, jsxs as jsxs14 } from "react/jsx-runtime";
var checkboxVariants = cva("buyscout-checkbox", {
  variants: {
    size: {
      sm: "buyscout-checkbox--size-sm",
      md: "buyscout-checkbox--size-md",
      lg: "buyscout-checkbox--size-lg"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
function Checkbox2({
  ref,
  size: size5,
  className,
  ...rest
}) {
  return /* @__PURE__ */ jsx22(Checkbox, { ref, className: checkboxVariants({ size: size5, className }), ...rest, children: /* @__PURE__ */ jsxs14(CheckboxIndicator, { className: "buyscout-checkbox__indicator", children: [
    /* @__PURE__ */ jsx22("svg", { className: "buyscout-checkbox__check", viewBox: "0 0 12 12", "aria-hidden": true, focusable: false, children: /* @__PURE__ */ jsx22("path", { d: "M2.5 6.4 4.75 8.6 9.5 3.6", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round" }) }),
    /* @__PURE__ */ jsx22("svg", { className: "buyscout-checkbox__minus", viewBox: "0 0 12 12", "aria-hidden": true, focusable: false, children: /* @__PURE__ */ jsx22("path", { d: "M3 6 H9", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round" }) })
  ] }) });
}
Checkbox2.displayName = "Checkbox";

// src/components/primitive/Collapse/Collapse.tsx
import { useEffect as useEffect6, useRef as useRef11, useState as useState9 } from "react";
import { jsx as jsx23 } from "react/jsx-runtime";
var DEFAULT_DURATION_MS = 280;
var SETTLE_GRACE_MS = 50;
function Collapse({
  in: inProp,
  children,
  timeout,
  collapsedSize = 0,
  className,
  id,
  onSettled,
  ref
}) {
  const [restingOpen, setRestingOpen] = useState9(inProp);
  const restingRef = useRef11(inProp);
  const settleTimer = useRef11(void 0);
  const onSettledRef = useRef11(onSettled);
  useEffect6(() => {
    onSettledRef.current = onSettled;
  });
  const settle = (open2) => {
    clearTimeout(settleTimer.current);
    restingRef.current = open2;
    setRestingOpen(open2);
    onSettledRef.current?.(open2);
  };
  useEffect6(() => {
    clearTimeout(settleTimer.current);
    if (restingRef.current === inProp) return;
    settleTimer.current = setTimeout(settle, (timeout ?? DEFAULT_DURATION_MS) + SETTLE_GRACE_MS, inProp);
    return () => clearTimeout(settleTimer.current);
  }, [inProp, timeout]);
  const handleTransitionEnd = (event) => {
    if (event.target === event.currentTarget && restingRef.current !== inProp) settle(inProp);
  };
  const settled = restingOpen === inProp;
  const shutsFully = Number.parseFloat(String(collapsedSize)) === 0;
  const inert = !inProp && settled && shutsFully;
  const style = {
    ...timeout !== void 0 && { "--buyscout-collapse-duration": `${timeout}ms` },
    ...collapsedSize !== 0 && { "--buyscout-collapse-size": typeof collapsedSize === "number" ? `${collapsedSize}px` : collapsedSize }
  };
  return /* @__PURE__ */ jsx23(Root5, { open: inProp, asChild: true, children: /* @__PURE__ */ jsx23(
    "div",
    {
      ref,
      className: clsx_default("buyscout-collapse", className),
      style,
      "data-settled": settled || void 0,
      "data-reveal": timeout === void 0 && shutsFully || void 0,
      onTransitionEnd: handleTransitionEnd,
      children: /* @__PURE__ */ jsx23(Content3, { forceMount: true, asChild: true, ...id !== void 0 && { id }, children: /* @__PURE__ */ jsx23("div", { className: "buyscout-collapse-content", inert, children }) })
    }
  ) });
}
Collapse.displayName = "Collapse";

// src/components/primitive/Combobox/Combobox.tsx
import * as React97 from "react";
import { MdArrowDropDown as MdArrowDropDown2, MdCheck, MdClose as MdClose2 } from "react-icons/md";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/index.parts.mjs
var index_parts_exports = {};
__export(index_parts_exports, {
  Arrow: () => ComboboxArrow,
  Backdrop: () => ComboboxBackdrop,
  Chip: () => ComboboxChip,
  ChipRemove: () => ComboboxChipRemove,
  Chips: () => ComboboxChips,
  Clear: () => ComboboxClear,
  Collection: () => ComboboxCollection,
  Empty: () => ComboboxEmpty,
  Group: () => ComboboxGroup,
  GroupLabel: () => ComboboxGroupLabel,
  Icon: () => ComboboxIcon,
  Input: () => ComboboxInput,
  InputGroup: () => ComboboxInputGroup,
  Item: () => ComboboxItem,
  ItemIndicator: () => ComboboxItemIndicator,
  Label: () => ComboboxLabel,
  List: () => ComboboxList,
  Popup: () => ComboboxPopup,
  Portal: () => ComboboxPortal,
  Positioner: () => ComboboxPositioner,
  Root: () => ComboboxRoot,
  Row: () => ComboboxRow,
  Separator: () => ComboboxSeparator,
  Status: () => ComboboxStatus,
  Trigger: () => ComboboxTrigger,
  Value: () => ComboboxValue,
  createItems: () => createComboboxItems,
  useFilter: () => useComboboxFilter,
  useFilteredItems: () => useFilteredItems
});

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/ComboboxRoot.mjs
import * as React52 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/formatErrorMessage.mjs
function createFormatErrorMessage(baseUrl, prefix) {
  return function formatErrorMessage2(code3, ...args) {
    const url = new URL(baseUrl);
    url.searchParams.set("code", code3.toString());
    args.forEach((arg) => url.searchParams.append("args[]", arg));
    return `${prefix} error #${code3}; visit ${url} for the full message.`;
  };
}
var formatErrorMessage = createFormatErrorMessage("https://base-ui.com/production-error", "Base UI");
var formatErrorMessage_default = formatErrorMessage;

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/AriaCombobox.mjs
import * as React51 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useControlled.mjs
import * as React13 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/createLogOnce.mjs
var loggedMessages;
if (process.env.NODE_ENV !== "production") {
  loggedMessages = /* @__PURE__ */ new Set();
}
function createLogOnce(severity, prefix) {
  return function logOnce(...messages) {
    if (process.env.NODE_ENV !== "production") {
      const message = messages.join(" ");
      const output = prefix ? `${prefix}: ${message}` : message;
      const key = `${severity}:${output}`;
      if (!loggedMessages.has(key)) {
        loggedMessages.add(key);
        if (severity === "warn") {
          console.warn(output);
        } else {
          console.error(output);
        }
      }
    }
  };
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/error.mjs
var error = createLogOnce("error", "Base UI");

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useControlled.mjs
function useControlled({
  controlled,
  default: defaultProp,
  name: name2,
  state = "value"
}) {
  const {
    current: isControlled
  } = React13.useRef(controlled !== void 0);
  const [valueState, setValue] = React13.useState(defaultProp);
  const value = isControlled && controlled !== void 0 ? controlled : valueState;
  if (process.env.NODE_ENV !== "production") {
    React13.useEffect(() => {
      if (isControlled !== (controlled !== void 0)) {
        error([`A component is changing the ${isControlled ? "" : "un"}controlled ${state} state of ${name2} to be ${isControlled ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${name2} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join("\n"));
      }
    }, [state, name2, controlled]);
    const {
      current: defaultValue
    } = React13.useRef(defaultProp);
    React13.useEffect(() => {
      if (!isControlled && serializeToDevModeString(defaultValue) !== serializeToDevModeString(defaultProp)) {
        error([`A component is changing the default ${state} state of an uncontrolled ${name2} after being initialized. To suppress this warning opt to use a controlled ${name2}.`].join("\n"));
      }
    }, [defaultProp]);
  }
  const setValueIfUncontrolled = React13.useCallback((newValue) => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
function serializeToDevModeString(input) {
  let nextId2 = 0;
  const seen = /* @__PURE__ */ new WeakMap();
  try {
    const result = JSON.stringify(input, function replacer(key, value) {
      if (key === "_owner" && this != null && typeof this === "object" && "$$typeof" in this) {
        return void 0;
      }
      if (typeof value === "bigint") {
        return `__bigint__:${value}`;
      }
      if (value !== null && typeof value === "object") {
        const id = seen.get(value);
        if (id !== void 0) {
          return `__object__:${id}`;
        }
        seen.set(value, nextId2);
        nextId2 += 1;
      }
      return value;
    });
    return result ?? `__top__:${typeof input}`;
  } catch {
    return "__unserializable__";
  }
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useIsoLayoutEffect.mjs
import * as React14 from "react";
var noop = () => {
};
var useIsoLayoutEffect = typeof document !== "undefined" ? React14.useLayoutEffect : noop;

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useOnFirstRender.mjs
import * as React15 from "react";
function useOnFirstRender(fn) {
  const ref = React15.useRef(true);
  if (ref.current) {
    ref.current = false;
    fn();
  }
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/safeReact.mjs
import * as React16 from "react";
var SafeReact = {
  ...React16
};

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useRefWithInit.mjs
import * as React17 from "react";
var UNINITIALIZED = {};
function useRefWithInit(init, initArg) {
  const ref = React17.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg);
  }
  return ref;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useStableCallback.mjs
var useInsertionEffect = SafeReact.useInsertionEffect;
var useSafeInsertionEffect = (
  // React 17 doesn't have useInsertionEffect.
  useInsertionEffect && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  useInsertionEffect !== SafeReact.useLayoutEffect ? useInsertionEffect : (fn) => fn()
);
function useStableCallback(callback) {
  const stable = useRefWithInit(createStableCallback).current;
  stable.next = callback;
  useSafeInsertionEffect(stable.effect);
  return stable.trampoline;
}
function createStableCallback() {
  const stable = {
    next: void 0,
    callback: assertNotCalled,
    trampoline: (...args) => stable.callback?.(...args),
    effect: () => {
      stable.callback = stable.next;
    }
  };
  return stable;
}
function assertNotCalled() {
  if (process.env.NODE_ENV !== "production") {
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
  }
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useMergedRefs.mjs
function useMergedRefs(a, b, c, d) {
  const forkRef = useRefWithInit(createForkRef).current;
  if (didChange(forkRef, a, b, c, d)) {
    update(forkRef, [a, b, c, d]);
  }
  return forkRef.callback;
}
function useMergedRefsN(refs) {
  const forkRef = useRefWithInit(createForkRef).current;
  if (didChangeN(forkRef, refs)) {
    update(forkRef, refs);
  }
  return forkRef.callback;
}
function createForkRef() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function didChange(forkRef, a, b, c, d) {
  return forkRef.refs[0] !== a || forkRef.refs[1] !== b || forkRef.refs[2] !== c || forkRef.refs[3] !== d;
}
function didChangeN(forkRef, newRefs) {
  return forkRef.refs.length !== newRefs.length || forkRef.refs.some((ref, index2) => ref !== newRefs[index2]);
}
function update(forkRef, refs) {
  forkRef.refs = refs;
  if (refs.every((ref) => ref == null)) {
    forkRef.callback = null;
    return;
  }
  forkRef.callback = (instance) => {
    if (forkRef.cleanup) {
      forkRef.cleanup();
      forkRef.cleanup = null;
    }
    if (instance != null) {
      const cleanupCallbacks = Array(refs.length).fill(null);
      for (let i = 0; i < refs.length; i += 1) {
        const ref = refs[i];
        if (ref == null) {
          continue;
        }
        switch (typeof ref) {
          case "function": {
            const refCleanup = ref(instance);
            if (typeof refCleanup === "function") {
              cleanupCallbacks[i] = refCleanup;
            }
            break;
          }
          case "object": {
            ref.current = instance;
            break;
          }
          default:
        }
      }
      forkRef.cleanup = () => {
        for (let i = 0; i < refs.length; i += 1) {
          const ref = refs[i];
          if (ref == null) {
            continue;
          }
          switch (typeof ref) {
            case "function": {
              const cleanupCallback = cleanupCallbacks[i];
              if (typeof cleanupCallback === "function") {
                cleanupCallback();
              } else {
                void ref(null);
              }
              break;
            }
            case "object": {
              ref.current = null;
              break;
            }
            default:
          }
        }
      };
    }
  };
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useValueAsRef.mjs
function useValueAsRef(value) {
  const latest = useRefWithInit(createLatestRef, value).current;
  latest.next = value;
  useIsoLayoutEffect(latest.effect);
  return latest;
}
function createLatestRef(value) {
  const latest = {
    current: value,
    next: value,
    effect: () => {
      latest.current = latest.next;
    }
  };
  return latest;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/visuallyHidden.mjs
var visuallyHiddenBase = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
};
var visuallyHidden = {
  ...visuallyHiddenBase,
  position: "fixed",
  top: 0,
  left: 0
};
var visuallyHiddenInput = {
  ...visuallyHiddenBase,
  position: "absolute"
};

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/store/useStore.mjs
import * as React20 from "react";
import { useSyncExternalStore } from "use-sync-external-store/shim";
import { useSyncExternalStoreWithSelector } from "use-sync-external-store/shim/with-selector";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/reactVersion.mjs
import * as React18 from "react";
var majorVersion = parseInt(React18.version, 10);
function isReactVersionAtLeast(reactVersionToCheck) {
  return majorVersion >= reactVersionToCheck;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/fastHooks.mjs
import * as React19 from "react";
var hooks = [];
var currentInstance = void 0;
function getInstance() {
  return currentInstance;
}
function register(hook) {
  hooks.push(hook);
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/store/useStore.mjs
var canUseRawUseSyncExternalStore = isReactVersionAtLeast(19);
var useStoreImplementation = canUseRawUseSyncExternalStore ? useStoreFast : useStoreLegacy;
function useStore(store, selector, a1, a2, a3) {
  return useStoreImplementation(store, selector, a1, a2, a3);
}
function useStoreR19(store, selector, a1, a2, a3) {
  const getSelection = React20.useCallback(() => selector(store.getSnapshot(), a1, a2, a3), [store, selector, a1, a2, a3]);
  return useSyncExternalStore(store.subscribe, getSelection, getSelection);
}
register({
  before(instance) {
    instance.syncIndex = 0;
    if (!instance.didInitialize) {
      instance.syncTick = 1;
      instance.syncHooks = [];
      instance.didChangeStore = true;
      instance.getSnapshot = () => {
        let didChange2 = false;
        for (let i = 0; i < instance.syncHooks.length; i += 1) {
          const hook = instance.syncHooks[i];
          const value = hook.selector(hook.store.state, hook.a1, hook.a2, hook.a3);
          if (!Object.is(hook.value, value)) {
            didChange2 = true;
            hook.value = value;
          }
        }
        if (didChange2) {
          instance.syncTick += 1;
        }
        return instance.syncTick;
      };
    }
  },
  after(instance) {
    if (instance.syncHooks.length > 0) {
      if (instance.didChangeStore) {
        instance.didChangeStore = false;
        instance.subscribe = (onStoreChange) => {
          const stores = /* @__PURE__ */ new Set();
          for (const hook of instance.syncHooks) {
            stores.add(hook.store);
          }
          const unsubscribes = [];
          for (const store of stores) {
            unsubscribes.push(store.subscribe(onStoreChange));
          }
          return () => {
            for (const unsubscribe of unsubscribes) {
              unsubscribe();
            }
          };
        };
      }
      useSyncExternalStore(instance.subscribe, instance.getSnapshot, instance.getSnapshot);
    }
  }
});
function useStoreFast(store, selector, a1, a2, a3) {
  const instance = getInstance();
  if (!instance) {
    return useStoreR19(store, selector, a1, a2, a3);
  }
  const index2 = instance.syncIndex;
  instance.syncIndex += 1;
  let hook;
  if (!instance.didInitialize) {
    hook = {
      store,
      selector,
      a1,
      a2,
      a3,
      value: selector(store.getSnapshot(), a1, a2, a3)
    };
    instance.syncHooks.push(hook);
  } else {
    hook = instance.syncHooks[index2];
    if (hook.store !== store || hook.selector !== selector || !Object.is(hook.a1, a1) || !Object.is(hook.a2, a2) || !Object.is(hook.a3, a3)) {
      if (hook.store !== store) {
        instance.didChangeStore = true;
      }
      hook.store = store;
      hook.selector = selector;
      hook.a1 = a1;
      hook.a2 = a2;
      hook.a3 = a3;
      hook.value = selector(store.getSnapshot(), a1, a2, a3);
    }
  }
  return hook.value;
}
function useStoreLegacy(store, selector, a1, a2, a3) {
  return useSyncExternalStoreWithSelector(store.subscribe, store.getSnapshot, store.getSnapshot, (state) => selector(state, a1, a2, a3));
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/store/Store.mjs
var Store = class {
  /**
   * Creates a store with the given initial state, constructing the class it is called on.
   * Calling it on a generic base class (e.g. `ReactStore.create(...)`) constructs that
   * class but degrades the inferred instance type to `Store`; use `new` there instead.
   */
  static create(state) {
    return new this(state);
  }
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(state) {
    this.state = state;
    this.listeners = /* @__PURE__ */ new Set();
    this.updateTick = 0;
  }
  /**
   * Registers a listener that will be called whenever the store's state changes.
   *
   * @param fn The listener function to be called on state changes.
   * @returns A function to unsubscribe the listener.
   */
  subscribe = (fn) => {
    this.listeners.add(fn);
    return () => {
      this.listeners.delete(fn);
    };
  };
  /**
   * Returns the current state of the store.
   */
  getSnapshot = () => {
    return this.state;
  };
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(newState) {
    if (this.state === newState) {
      return;
    }
    this.state = newState;
    this.updateTick += 1;
    const currentTick = this.updateTick;
    for (const listener of this.listeners) {
      if (currentTick !== this.updateTick) {
        return;
      }
      listener(newState);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   * Each value must match its state key. Pass an exact known subset rather than a broad
   * `Partial<State>`, which may contain `undefined` for required state fields.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(changes) {
    for (const key in changes) {
      if (!Object.is(this.state[key], changes[key])) {
        this.setState({
          ...this.state,
          ...changes
        });
        return;
      }
    }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(key, value) {
    if (!Object.is(this.state[key], value)) {
      this.setState({
        ...this.state,
        [key]: value
      });
    }
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const newState = {
      ...this.state
    };
    this.setState(newState);
  }
  use(selector, a1, a2, a3) {
    return useStore(this, selector, a1, a2, a3);
  }
};

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/store/ReactStore.mjs
import * as React21 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/empty.mjs
function NOOP() {
}
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/store/ReactStore.mjs
var ReactStore = class extends Store {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(state, context = {}, selectors3) {
    super(state);
    this.context = context;
    this.selectors = selectors3;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(key, value) {
    React21.useDebugValue(key);
    const store = this;
    useIsoLayoutEffect(() => {
      if (store.state[key] !== value) {
        store.set(key, value);
      }
    }, [store, key, value]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(key, value) {
    const store = this;
    useIsoLayoutEffect(() => {
      if (store.state[key] !== value) {
        store.set(key, value);
      }
      return () => {
        store.set(key, void 0);
      };
    }, [store, key, value]);
  }
  /**
   * Synchronizes multiple external values into the store.
   * Each value must match its state key. Pass an exact known subset rather than a broad
   * `Partial<State>`, which may contain `undefined` for required state fields.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   *
   * @param statePart An exact subset of state fields to synchronize. Unknown keys are not accepted.
   */
  useSyncedValues(statePart) {
    const store = this;
    if (process.env.NODE_ENV !== "production") {
      React21.useDebugValue(statePart, (p) => Object.keys(p));
      const keys2 = React21.useRef(Object.keys(statePart)).current;
      const nextKeys = Object.keys(statePart);
      if (keys2.length !== nextKeys.length || keys2.some((key, index2) => key !== nextKeys[index2])) {
        console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
      }
    }
    const dependencies = Object.values(statePart);
    useIsoLayoutEffect(() => {
      store.update(statePart);
    }, [store, ...dependencies]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(key, controlled) {
    React21.useDebugValue(key);
    const store = this;
    const isControlled = controlled !== void 0;
    useIsoLayoutEffect(() => {
      if (isControlled && !Object.is(store.state[key], controlled)) {
        store.setState({
          ...store.state,
          [key]: controlled
        });
      }
    }, [store, key, controlled, isControlled]);
    if (process.env.NODE_ENV !== "production") {
      const cache2 = this.controlledValues ??= /* @__PURE__ */ new Map();
      if (!cache2.has(key)) {
        cache2.set(key, isControlled);
      }
      const previouslyControlled = cache2.get(key);
      if (previouslyControlled !== void 0 && previouslyControlled !== isControlled) {
        console.error(`A component is changing the ${isControlled ? "" : "un"}controlled state of ${key.toString()} to be ${isControlled ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
      }
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(key, a1, a2, a3) {
    const selector = this.selectors[key];
    return selector(this.state, a1, a2, a3);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(key, a1, a2, a3) {
    React21.useDebugValue(key);
    return useStore(this, this.selectors[key], a1, a2, a3);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(key, fn) {
    React21.useDebugValue(key);
    const stableFunction = useStableCallback(fn ?? NOOP);
    this.context[key] = stableFunction;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(key) {
    const ref = React21.useRef(void 0);
    if (ref.current === void 0) {
      ref.current = (value) => {
        this.set(key, value);
      };
    }
    return ref.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(selector, listener) {
    let selectFn;
    if (typeof selector === "function") {
      selectFn = selector;
    } else {
      selectFn = this.selectors[selector];
    }
    let prevValue = selectFn(this.state);
    listener(prevValue, prevValue, this);
    return this.subscribe((nextState) => {
      const nextValue = selectFn(nextState);
      if (!Object.is(prevValue, nextValue)) {
        const oldValue = prevValue;
        prevValue = nextValue;
        listener(nextValue, oldValue, this);
      }
    });
  }
};

// ../../node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element2) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle2(element2);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== "inline" && display !== "contents";
}
function isTableElement(element2) {
  return /^(table|td|th)$/.test(getNodeName(element2));
}
function isTopLayer(element2) {
  try {
    if (element2.matches(":popover-open")) {
      return true;
    }
  } catch (_e) {
  }
  try {
    return element2.matches(":modal");
  } catch (_e) {
    return false;
  }
}
var willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
var containRe = /paint|layout|strict|content/;
var isNotNone = (value) => !!value && value !== "none";
var isWebKitValue;
function isContainingBlock(elementOrCss) {
  const css = isElement(elementOrCss) ? getComputedStyle2(elementOrCss) : elementOrCss;
  return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || "") || containRe.test(css.contain || "");
}
function getContainingBlock(element2) {
  let currentNode = getParentNode(element2);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (isWebKitValue == null) {
    isWebKitValue = typeof CSS !== "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none");
  }
  return isWebKitValue;
}
function isLastTraversableNode(node) {
  return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle2(element2) {
  return getWindow(element2).getComputedStyle(element2);
}
function getNodeScroll(element2) {
  if (isElement(element2)) {
    return {
      scrollLeft: element2.scrollLeft,
      scrollTop: element2.scrollTop
    };
  }
  return {
    scrollLeft: element2.scrollX,
    scrollTop: element2.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return (node.ownerDocument || node).body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list2, traverseIframes) {
  var _node$ownerDocument2;
  if (list2 === void 0) {
    list2 = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  } else {
    return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
  }
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/mergeCleanups.mjs
function mergeCleanups(...cleanups) {
  return () => {
    for (let i = 0; i < cleanups.length; i += 1) {
      const cleanup = cleanups[i];
      if (cleanup) {
        cleanup();
      }
    }
  };
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/owner.mjs
function ownerDocument(node) {
  return node?.ownerDocument || document;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/addEventListener.mjs
function addEventListener(target, type, listener, options) {
  target.addEventListener(type, listener, options);
  return () => {
    target.removeEventListener(type, listener, options);
  };
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useForcedRerendering.mjs
import * as React22 from "react";
function useForcedRerendering() {
  const [, setState] = React22.useState({});
  return React22.useCallback(() => {
    setState({});
  }, []);
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useOnMount.mjs
import * as React23 from "react";
function useOnMount(fn) {
  React23.useEffect(fn, EMPTY_ARRAY);
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useAnimationFrame.mjs
var EMPTY = null;
var LAST_RAF = globalThis.requestAnimationFrame;
var Scheduler = class {
  /* This implementation uses an array as a backing data-structure for frame callbacks.
   * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
   * never calls the native `cancelAnimationFrame` if there are no frames left. This can
   * be much more efficient if there is a call pattern that alterns as
   * "request-cancel-request-cancel-…".
   * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
   * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
  callbacks = [];
  callbacksCount = 0;
  nextId = 1;
  startId = 1;
  isScheduled = false;
  tick = (timestamp) => {
    this.isScheduled = false;
    const currentCallbacks = this.callbacks;
    const currentCallbacksCount = this.callbacksCount;
    this.callbacks = [];
    this.callbacksCount = 0;
    this.startId = this.nextId;
    if (currentCallbacksCount > 0) {
      for (let i = 0; i < currentCallbacks.length; i += 1) {
        currentCallbacks[i]?.(timestamp);
      }
    }
  };
  request(fn) {
    const id = this.nextId;
    this.nextId += 1;
    this.callbacks.push(fn);
    this.callbacksCount += 1;
    const didRAFChange = process.env.NODE_ENV !== "production" && LAST_RAF !== requestAnimationFrame && (LAST_RAF = requestAnimationFrame, true);
    if (!this.isScheduled || didRAFChange) {
      requestAnimationFrame(this.tick);
      this.isScheduled = true;
    }
    return id;
  }
  cancel(id) {
    const index2 = id - this.startId;
    if (index2 < 0 || index2 >= this.callbacks.length) {
      return;
    }
    if (this.callbacks[index2] === null) {
      return;
    }
    this.callbacks[index2] = null;
    this.callbacksCount -= 1;
  }
};
var scheduler = new Scheduler();
var AnimationFrame = class _AnimationFrame {
  static create() {
    return new _AnimationFrame();
  }
  static request(fn) {
    return scheduler.request(fn);
  }
  static cancel(id) {
    return scheduler.cancel(id);
  }
  currentId = EMPTY;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(fn) {
    this.cancel();
    this.currentId = scheduler.request(() => {
      this.currentId = EMPTY;
      fn();
    });
  }
  cancel = () => {
    if (this.currentId !== EMPTY) {
      scheduler.cancel(this.currentId);
      this.currentId = EMPTY;
    }
  };
  disposeEffect = () => {
    return this.cancel;
  };
};
function useAnimationFrame() {
  const timeout = useRefWithInit(AnimationFrame.create).current;
  useOnMount(timeout.disposeEffect);
  return timeout;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useTimeout.mjs
var EMPTY2 = 0;
var Timeout = class _Timeout {
  static create() {
    return new _Timeout();
  }
  currentId = EMPTY2;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(delay, fn) {
    this.clear();
    this.currentId = setTimeout(() => {
      this.currentId = EMPTY2;
      fn();
    }, delay);
  }
  isStarted() {
    return this.currentId !== EMPTY2;
  }
  clear = () => {
    if (this.currentId !== EMPTY2) {
      clearTimeout(this.currentId);
      this.currentId = EMPTY2;
    }
  };
  disposeEffect = () => {
    return this.clear;
  };
};
function useTimeout() {
  const timeout = useRefWithInit(Timeout.create).current;
  useOnMount(timeout.disposeEffect);
  return timeout;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/platform/parts.mjs
var parts_exports = {};
__export(parts_exports, {
  engine: () => engine_exports,
  env: () => env_exports,
  mediaQuery: () => media_query_exports,
  os: () => os_exports,
  screenReader: () => screen_reader_exports
});

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/platform/os.mjs
var os_exports = {};
__export(os_exports, {
  android: () => android,
  apple: () => apple,
  ios: () => ios,
  linux: () => linux,
  mac: () => mac,
  windows: () => windows
});

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/platform/shared.mjs
function readRawData() {
  if (typeof navigator === "undefined") {
    return {
      userAgent: "",
      platform: "",
      maxTouchPoints: 0
    };
  }
  if (process.env.NODE_ENV !== "production") {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) {
      return {
        userAgent: uaData.brands.map(({
          brand,
          version: version2
        }) => `${brand}/${version2}`).join(" "),
        platform: uaData.platform ?? navigator.platform ?? "",
        maxTouchPoints: navigator.maxTouchPoints ?? 0
      };
    }
  }
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? 0
  };
}
var {
  userAgent,
  platform,
  maxTouchPoints
} = readRawData();
var lowerUserAgent = userAgent.toLowerCase();
var lowerPlatform = platform.toLowerCase();

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/platform/os.mjs
var ios = /^i(os$|p)/.test(lowerPlatform) || lowerPlatform === "macintel" && maxTouchPoints > 1;
var ANDROID_STRING = "android";
var android = lowerPlatform === ANDROID_STRING || lowerUserAgent.includes(ANDROID_STRING);
var mac = !ios && lowerPlatform.startsWith("mac");
var windows = lowerPlatform.startsWith("win");
var linux = !android && /^(linux|chrome os)/.test(lowerPlatform);
var apple = mac || ios;

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/platform/engine.mjs
var engine_exports = {};
__export(engine_exports, {
  blink: () => blink,
  gecko: () => gecko,
  webkit: () => webkit
});
var webkit = typeof CSS !== "undefined" && !!CSS.supports?.("-webkit-backdrop-filter:none");
var gecko = !webkit && lowerUserAgent.includes("firefox");
var blink = !webkit && lowerUserAgent.includes("chrom");

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/platform/screen-reader.mjs
var screen_reader_exports = {};
__export(screen_reader_exports, {
  voiceOver: () => voiceOver
});
var voiceOver = apple;

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/platform/env.mjs
var env_exports = {};
__export(env_exports, {
  jsdom: () => jsdom
});
var jsdom = /jsdom|happydom/.test(lowerUserAgent);

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/platform/media-query.mjs
var media_query_exports = {};
__export(media_query_exports, {
  iOS: () => iOS
});
var iOS = "@supports (-webkit-touch-callout: none)";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/event.mjs
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isReactEvent(event) {
  return "nativeEvent" in event;
}
function isVirtualClick(event) {
  if (event.pointerType === "" && event.isTrusted) {
    return true;
  }
  if (parts_exports.os.android && event.pointerType) {
    return event.type === "click" && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  if (parts_exports.env.jsdom) {
    return false;
  }
  return !parts_exports.os.android && event.width === 0 && event.height === 0 || parts_exports.os.android && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function isMouseLikePointerType(pointerType, strict) {
  const values = ["mouse", "pen"];
  if (!strict) {
    values.push("", void 0);
  }
  return values.includes(pointerType);
}
function isClickLikeEvent(event) {
  const type = event.type;
  return type === "click" || type === "mousedown" || type === "keydown" || type === "keyup";
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/shadowDom.mjs
function activeElement(doc) {
  let element2 = doc.activeElement;
  while (element2?.shadowRoot?.activeElement != null) {
    element2 = element2.shadowRoot.activeElement;
  }
  return element2;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode?.();
  if (parent.contains(child)) {
    return true;
  }
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      next = next.parentNode || next.host;
    }
  }
  return false;
}
function getTarget(event) {
  if ("composedPath" in event) {
    return event.composedPath()[0] ?? event.target;
  }
  return event.target;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/constants.mjs
var FOCUSABLE_ATTRIBUTE = "data-base-ui-focusable";
var TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";
var ARROW_UP = "ArrowUp";
var ARROW_DOWN = "ArrowDown";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/TransitionStatusDataAttributes.mjs
var startingStyle = "data-starting-style";
var endingStyle = "data-ending-style";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/stateAttributesMapping.mjs
var STARTING_HOOK = {
  [startingStyle]: ""
};
var ENDING_HOOK = {
  [endingStyle]: ""
};
var transitionStatusMapping = {
  transitionStatus(value) {
    if (value === "starting") {
      return STARTING_HOOK;
    }
    if (value === "ending") {
      return ENDING_HOOK;
    }
    return null;
  }
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/CommonPopupDataAttributes.mjs
var open = "data-open";
var closed = "data-closed";
var anchorHidden = "data-anchor-hidden";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/CommonTriggerDataAttributes.mjs
var CommonTriggerDataAttributes_exports = {};
__export(CommonTriggerDataAttributes_exports, {
  popupOpen: () => popupOpen,
  pressed: () => pressed
});
var popupOpen = "data-popup-open";
var pressed = "data-pressed";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/popupStateMapping.mjs
var TRIGGER_HOOK = {
  [popupOpen]: ""
};
var PRESSABLE_TRIGGER_HOOK = {
  [popupOpen]: "",
  [pressed]: ""
};
var POPUP_OPEN_HOOK = {
  [open]: ""
};
var POPUP_CLOSED_HOOK = {
  [closed]: ""
};
var ANCHOR_HIDDEN_HOOK = {
  [anchorHidden]: ""
};
var triggerOpenStateMapping = {
  open(value) {
    if (value) {
      return TRIGGER_HOOK;
    }
    return null;
  }
};
var pressableTriggerOpenStateMapping = {
  open(value) {
    if (value) {
      return PRESSABLE_TRIGGER_HOOK;
    }
    return null;
  }
};
var popupStateMapping = {
  open(value) {
    if (value) {
      return POPUP_OPEN_HOOK;
    }
    return POPUP_CLOSED_HOOK;
  },
  anchorHidden(value) {
    if (value) {
      return ANCHOR_HIDDEN_HOOK;
    }
    return null;
  }
};
var popupTransitionStateMapping = {
  ...popupStateMapping,
  ...transitionStatusMapping
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/element.mjs
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ("composedPath" in event) {
    return event.composedPath().includes(node);
  }
  const eventAgain = event;
  return eventAgain.target != null && node.contains(eventAgain.target);
}
function isRootElement(element2) {
  return element2.matches("html,body");
}
function isTypeableElement(element2) {
  return isHTMLElement(element2) && element2.matches(TYPEABLE_SELECTOR);
}
function isInteractiveElement(element2) {
  return element2?.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${TYPEABLE_SELECTOR}`) != null;
}
function isTypeableCombobox(element2) {
  if (!element2) {
    return false;
  }
  return element2.getAttribute("role") === "combobox" && isTypeableElement(element2);
}
function getFloatingFocusElement(floatingElement) {
  if (!floatingElement) {
    return null;
  }
  return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector(`[${FOCUSABLE_ATTRIBUTE}]`) || floatingElement;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/reason-parts.mjs
var reason_parts_exports = {};
__export(reason_parts_exports, {
  cancelOpen: () => cancelOpen,
  chipRemovePress: () => chipRemovePress,
  clearPress: () => clearPress,
  closePress: () => closePress,
  closeWatcher: () => closeWatcher,
  decrementPress: () => decrementPress,
  disabled: () => disabled,
  drag: () => drag,
  escapeKey: () => escapeKey,
  focusOut: () => focusOut,
  imperativeAction: () => imperativeAction,
  incrementPress: () => incrementPress,
  initial: () => initial,
  inputBlur: () => inputBlur,
  inputChange: () => inputChange,
  inputClear: () => inputClear,
  inputPaste: () => inputPaste,
  inputPress: () => inputPress,
  itemPress: () => itemPress,
  keyboard: () => keyboard,
  linkPress: () => linkPress,
  listNavigation: () => listNavigation,
  missing: () => missing,
  none: () => none,
  outsidePress: () => outsidePress,
  pointer: () => pointer,
  scrub: () => scrub,
  siblingOpen: () => siblingOpen,
  swipe: () => swipe,
  trackPress: () => trackPress,
  triggerFocus: () => triggerFocus,
  triggerHover: () => triggerHover,
  triggerPress: () => triggerPress,
  wheel: () => wheel,
  windowResize: () => windowResize
});
var none = "none";
var triggerPress = "trigger-press";
var triggerHover = "trigger-hover";
var triggerFocus = "trigger-focus";
var outsidePress = "outside-press";
var itemPress = "item-press";
var closePress = "close-press";
var linkPress = "link-press";
var clearPress = "clear-press";
var chipRemovePress = "chip-remove-press";
var trackPress = "track-press";
var incrementPress = "increment-press";
var decrementPress = "decrement-press";
var inputChange = "input-change";
var inputClear = "input-clear";
var inputBlur = "input-blur";
var inputPaste = "input-paste";
var inputPress = "input-press";
var focusOut = "focus-out";
var escapeKey = "escape-key";
var closeWatcher = "close-watcher";
var listNavigation = "list-navigation";
var keyboard = "keyboard";
var pointer = "pointer";
var drag = "drag";
var wheel = "wheel";
var scrub = "scrub";
var cancelOpen = "cancel-open";
var siblingOpen = "sibling-open";
var disabled = "disabled";
var missing = "missing";
var initial = "initial";
var imperativeAction = "imperative-action";
var swipe = "swipe";
var windowResize = "window-resize";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/createBaseUIEventDetails.mjs
function createChangeEventDetails(reason, event, trigger, customProperties) {
  let canceled = false;
  let allowPropagation = false;
  const custom = customProperties ?? EMPTY_OBJECT;
  const details = {
    reason,
    event: event ?? new Event("base-ui"),
    cancel() {
      canceled = true;
    },
    allowPropagation() {
      allowPropagation = true;
    },
    get isCanceled() {
      return canceled;
    },
    get isPropagationAllowed() {
      return allowPropagation;
    },
    trigger,
    ...custom
  };
  return details;
}
function createGenericEventDetails(reason, event, customProperties) {
  const custom = customProperties ?? EMPTY_OBJECT;
  const details = {
    reason,
    event: event ?? new Event("base-ui"),
    ...custom
  };
  return details;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/components/FloatingFocusManager.mjs
import * as React30 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/FocusGuard.mjs
import * as React24 from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var FocusGuard = /* @__PURE__ */ React24.forwardRef(function FocusGuard2(props, ref) {
  const [role, setRole] = React24.useState();
  useIsoLayoutEffect(() => {
    if (parts_exports.screenReader.voiceOver && parts_exports.engine.webkit) {
      setRole("button");
    }
  }, []);
  const restProps = {
    tabIndex: 0,
    // Role is only for VoiceOver
    role
  };
  return /* @__PURE__ */ _jsx("span", {
    ...props,
    ref,
    style: visuallyHidden,
    "aria-hidden": role ? void 0 : true,
    ...restProps,
    "data-base-ui-focus-guard": ""
  });
});
if (process.env.NODE_ENV !== "production") FocusGuard.displayName = "FocusGuard";

// ../../node_modules/.pnpm/@floating-ui+utils@0.2.12/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
  x: v,
  y: v
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function clamp2(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  const firstChar = placement[0];
  return firstChar === "t" || firstChar === "b" ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.includes("start") ? placement.replace("start", "end") : placement.replace("end", "start");
}
var lrPlacement = ["left", "right"];
var rlPlacement = ["right", "left"];
var tbPlacement = ["top", "bottom"];
var btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list2 = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list2 = list2.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list2 = list2.concat(list2.map(getOppositeAlignmentPlacement));
    }
  }
  return list2;
}
function getOppositePlacement(placement) {
  const side = getSide(placement);
  return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
  var _padding$top, _padding$right, _padding$bottom, _padding$left;
  return {
    top: (_padding$top = padding.top) != null ? _padding$top : 0,
    right: (_padding$right = padding.right) != null ? _padding$right : 0,
    bottom: (_padding$bottom = padding.bottom) != null ? _padding$bottom : 0,
    left: (_padding$left = padding.left) != null ? _padding$left : 0
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/composite.mjs
function isDifferentGridRow(index2, cols, prevRow) {
  return Math.floor(index2 / cols) !== prevRow;
}
function isIndexOutOfListBounds(list2, index2) {
  return index2 < 0 || index2 >= list2.length;
}
function getMinListIndex(listRef, disabledIndices) {
  return findNonDisabledListIndex(listRef.current, {
    disabledIndices
  });
}
function getMaxListIndex(listRef, disabledIndices) {
  return findNonDisabledListIndex(listRef.current, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function findNonDisabledListIndex(list2, {
  startingIndex = -1,
  decrement = false,
  disabledIndices,
  amount = 1
} = {}) {
  let index2 = startingIndex;
  do {
    index2 += decrement ? -amount : amount;
  } while (index2 >= 0 && index2 <= list2.length - 1 && isListIndexDisabled(list2, index2, disabledIndices));
  return index2;
}
function getGridNavigatedIndex(list2, {
  event,
  orientation,
  loopFocus,
  onLoop,
  rtl,
  cols,
  disabledIndices,
  minIndex,
  maxIndex,
  prevIndex,
  stopEvent: stop = false
}) {
  let nextIndex = prevIndex;
  let verticalDirection;
  if (event.key === ARROW_UP) {
    verticalDirection = "up";
  } else if (event.key === ARROW_DOWN) {
    verticalDirection = "down";
  }
  if (verticalDirection) {
    const rows = [];
    const rowIndexMap = [];
    let hasRoleRow = false;
    let visibleItemCount = 0;
    {
      let currentRowEl = null;
      let currentRowIndex = -1;
      list2.forEach((el, idx) => {
        if (el == null) {
          return;
        }
        visibleItemCount += 1;
        const rowEl = el.closest('[role="row"]');
        if (rowEl) {
          hasRoleRow = true;
        }
        if (rowEl !== currentRowEl || currentRowIndex === -1) {
          currentRowEl = rowEl;
          currentRowIndex += 1;
          rows[currentRowIndex] = [];
        }
        rows[currentRowIndex].push(idx);
        rowIndexMap[idx] = currentRowIndex;
      });
    }
    let hasDomRows = false;
    let inferredDomCols = 0;
    if (hasRoleRow) {
      for (const row of rows) {
        const rowLength = row.length;
        if (rowLength > inferredDomCols) {
          inferredDomCols = rowLength;
        }
        if (rowLength !== cols) {
          hasDomRows = true;
        }
      }
    }
    const hasVirtualizedGaps = hasDomRows && visibleItemCount < list2.length;
    const verticalCols = inferredDomCols || cols;
    const navigateVertically = (direction) => {
      if (!hasDomRows || prevIndex === -1) {
        return void 0;
      }
      const currentRow = rowIndexMap[prevIndex];
      if (currentRow == null) {
        return void 0;
      }
      const colInRow = rows[currentRow].indexOf(prevIndex);
      const step = direction === "up" ? -1 : 1;
      for (let nextRow = currentRow + step, i = 0; i < rows.length; i += 1, nextRow += step) {
        if (nextRow < 0 || nextRow >= rows.length) {
          if (!loopFocus || hasVirtualizedGaps) {
            return void 0;
          }
          nextRow = nextRow < 0 ? rows.length - 1 : 0;
          if (onLoop) {
            const clampedCol = Math.min(colInRow, rows[nextRow].length - 1);
            const targetItemIndex = rows[nextRow][clampedCol] ?? rows[nextRow][0];
            const returnedItemIndex = onLoop(event, prevIndex, targetItemIndex);
            nextRow = rowIndexMap[returnedItemIndex] ?? nextRow;
          }
        }
        const targetRow = rows[nextRow];
        for (let col = Math.min(colInRow, targetRow.length - 1); col >= 0; col -= 1) {
          const candidate = targetRow[col];
          if (!isListIndexDisabled(list2, candidate, disabledIndices)) {
            return candidate;
          }
        }
      }
      return void 0;
    };
    const navigateVerticallyWithInferredRows = (direction) => {
      if (!hasVirtualizedGaps || prevIndex === -1) {
        return void 0;
      }
      const colInRow = prevIndex % verticalCols;
      const rowStep = direction === "up" ? -verticalCols : verticalCols;
      const lastRowStart = maxIndex - maxIndex % verticalCols;
      const rowCount = floor(maxIndex / verticalCols) + 1;
      for (let rowStart = prevIndex - colInRow + rowStep, i = 0; i < rowCount; i += 1, rowStart += rowStep) {
        if (rowStart < 0 || rowStart > maxIndex) {
          if (!loopFocus) {
            return void 0;
          }
          rowStart = rowStart < 0 ? lastRowStart : 0;
        }
        const rowEnd = Math.min(rowStart + verticalCols - 1, maxIndex);
        for (let candidate = Math.min(rowStart + colInRow, rowEnd); candidate >= rowStart; candidate -= 1) {
          if (!isListIndexDisabled(list2, candidate, disabledIndices)) {
            return candidate;
          }
        }
      }
      return void 0;
    };
    if (stop) {
      stopEvent(event);
    }
    const verticalCandidate = navigateVertically(verticalDirection) ?? navigateVerticallyWithInferredRows(verticalDirection);
    if (verticalCandidate !== void 0) {
      nextIndex = verticalCandidate;
    } else if (prevIndex === -1) {
      nextIndex = verticalDirection === "up" ? maxIndex : minIndex;
    } else {
      nextIndex = findNonDisabledListIndex(list2, {
        startingIndex: prevIndex,
        amount: verticalCols,
        decrement: verticalDirection === "up",
        disabledIndices
      });
      if (loopFocus) {
        if (verticalDirection === "up" && (prevIndex - verticalCols < minIndex || nextIndex < 0)) {
          const col = prevIndex % verticalCols;
          const maxCol = maxIndex % verticalCols;
          const offset5 = maxIndex - (maxCol - col);
          if (maxCol === col) {
            nextIndex = maxIndex;
          } else {
            nextIndex = maxCol > col ? offset5 : offset5 - verticalCols;
          }
          if (onLoop) {
            nextIndex = onLoop(event, prevIndex, nextIndex);
          }
        }
        if (verticalDirection === "down" && prevIndex + verticalCols > maxIndex) {
          nextIndex = findNonDisabledListIndex(list2, {
            startingIndex: prevIndex % verticalCols - verticalCols,
            amount: verticalCols,
            disabledIndices
          });
          if (onLoop) {
            nextIndex = onLoop(event, prevIndex, nextIndex);
          }
        }
      }
    }
    if (isIndexOutOfListBounds(list2, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (orientation === "both") {
    const prevRow = floor(prevIndex / cols);
    if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
      if (stop) {
        stopEvent(event);
      }
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledListIndex(list2, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loopFocus && isDifferentGridRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledListIndex(list2, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
          if (onLoop) {
            nextIndex = onLoop(event, prevIndex, nextIndex);
          }
        }
      } else if (loopFocus) {
        nextIndex = findNonDisabledListIndex(list2, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
        if (onLoop) {
          nextIndex = onLoop(event, prevIndex, nextIndex);
        }
      }
      if (isDifferentGridRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
      if (stop) {
        stopEvent(event);
      }
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledListIndex(list2, {
          startingIndex: prevIndex,
          decrement: true,
          disabledIndices
        });
        if (loopFocus && isDifferentGridRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledListIndex(list2, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
          if (onLoop) {
            nextIndex = onLoop(event, prevIndex, nextIndex);
          }
        }
      } else if (loopFocus) {
        nextIndex = findNonDisabledListIndex(list2, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
        if (onLoop) {
          nextIndex = onLoop(event, prevIndex, nextIndex);
        }
      }
      if (isDifferentGridRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = floor(maxIndex / cols) === prevRow;
    if (isIndexOutOfListBounds(list2, nextIndex)) {
      if (loopFocus && lastRow) {
        nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledListIndex(list2, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
        if (onLoop) {
          nextIndex = onLoop(event, prevIndex, nextIndex);
        }
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}
function isListIndexDisabled(list2, index2, disabledIndices) {
  const isExplicitlyDisabled = typeof disabledIndices === "function" ? disabledIndices(index2) : disabledIndices?.includes(index2) ?? false;
  if (isExplicitlyDisabled) {
    return true;
  }
  const element2 = list2[index2];
  if (!element2) {
    return false;
  }
  if (!isElementVisible(element2)) {
    return true;
  }
  if (element2.matches(":disabled")) {
    return true;
  }
  return !disabledIndices && (element2.hasAttribute("disabled") || element2.getAttribute("aria-disabled") === "true");
}
function isHiddenByStyles(styles) {
  return styles.visibility === "hidden" || styles.visibility === "collapse";
}
function isElementVisible(element2, styles = element2 ? getComputedStyle2(element2) : null) {
  if (!element2 || !element2.isConnected || !styles || isHiddenByStyles(styles)) {
    return false;
  }
  if (typeof element2.checkVisibility === "function") {
    return element2.checkVisibility();
  }
  return styles.display !== "none" && styles.display !== "contents";
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/tabbable.mjs
var CANDIDATE_SELECTOR = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function getParentElement(element2) {
  const assignedSlot = element2.assignedSlot;
  if (assignedSlot) {
    return assignedSlot;
  }
  if (element2.parentElement) {
    return element2.parentElement;
  }
  const rootNode = element2.getRootNode();
  return isShadowRoot(rootNode) ? rootNode.host : null;
}
function getDetailsSummary(details) {
  for (const child of Array.from(details.children)) {
    if (getNodeName(child) === "summary") {
      return child;
    }
  }
  return null;
}
function isWithinOpenDetailsSummary(element2, details) {
  const summary = getDetailsSummary(details);
  return !!summary && (element2 === summary || contains(summary, element2));
}
function isFocusableCandidate(element2) {
  const nodeName = element2 ? getNodeName(element2) : "";
  return element2 != null && element2.matches(CANDIDATE_SELECTOR) && (nodeName !== "summary" || element2.parentElement != null && getNodeName(element2.parentElement) === "details" && getDetailsSummary(element2.parentElement) === element2) && (nodeName !== "details" || getDetailsSummary(element2) == null) && (nodeName !== "input" || element2.type !== "hidden");
}
function isFocusableElement(element2) {
  if (!isFocusableCandidate(element2) || !element2.isConnected || element2.matches(":disabled")) {
    return false;
  }
  for (let current = element2; current; current = getParentElement(current)) {
    const isAncestor = current !== element2;
    const isSlot = getNodeName(current) === "slot";
    if (current.hasAttribute("inert")) {
      return false;
    }
    if (isAncestor && getNodeName(current) === "details" && !current.open && !isWithinOpenDetailsSummary(element2, current) || current.hasAttribute("hidden") || !isSlot && !isVisibleInTabbableTree(current, isAncestor)) {
      return false;
    }
  }
  return true;
}
function isVisibleInTabbableTree(element2, isAncestor) {
  const styles = getComputedStyle2(element2);
  if (!isAncestor) {
    return isElementVisible(element2, styles);
  }
  return styles.display !== "none";
}
function getTabIndex(element2) {
  const tabIndex = element2.tabIndex;
  if (tabIndex < 0) {
    const nodeName = getNodeName(element2);
    if (nodeName === "details" || nodeName === "audio" || nodeName === "video" || isHTMLElement(element2) && element2.isContentEditable) {
      return 0;
    }
  }
  return tabIndex;
}
function getNamedRadioInput(element2) {
  if (getNodeName(element2) !== "input") {
    return null;
  }
  const input = element2;
  return input.type === "radio" && input.name !== "" ? input : null;
}
function isTabbableRadio(element2, candidates) {
  const input = getNamedRadioInput(element2);
  if (!input) {
    return true;
  }
  const checkedRadio = candidates.find((candidate) => {
    const radio = getNamedRadioInput(candidate);
    return radio?.name === input.name && radio.form === input.form && radio.checked;
  });
  if (checkedRadio) {
    return checkedRadio === input;
  }
  return candidates.find((candidate) => {
    const radio = getNamedRadioInput(candidate);
    return radio?.name === input.name && radio.form === input.form;
  }) === input;
}
function getComposedChildren(container) {
  if (isHTMLElement(container) && getNodeName(container) === "slot") {
    const assignedElements = container.assignedElements({
      flatten: true
    });
    if (assignedElements.length > 0) {
      return assignedElements;
    }
  }
  if (isHTMLElement(container) && container.shadowRoot) {
    return Array.from(container.shadowRoot.children);
  }
  return Array.from(container.children);
}
function appendCandidates(container, list2) {
  getComposedChildren(container).forEach((child) => {
    if (isFocusableCandidate(child)) {
      list2.push(child);
    }
    appendCandidates(child, list2);
  });
}
function appendMatchingElements(container, selector, list2) {
  getComposedChildren(container).forEach((child) => {
    if (isHTMLElement(child) && child.matches(selector)) {
      list2.push(child);
    }
    appendMatchingElements(child, selector, list2);
  });
}
function isTabbable(element2) {
  return isFocusableElement(element2) && getTabIndex(element2) >= 0;
}
function focusable(container) {
  const candidates = [];
  appendCandidates(container, candidates);
  return candidates.filter(isFocusableElement);
}
function tabbable(container) {
  const candidates = focusable(container);
  return candidates.filter((element2) => getTabIndex(element2) >= 0 && isTabbableRadio(element2, candidates));
}
function getTabbableIn(container, dir) {
  const list2 = tabbable(container);
  const len = list2.length;
  if (len === 0) {
    return void 0;
  }
  const active = activeElement(ownerDocument(container));
  const index2 = list2.indexOf(active);
  const nextIndex = index2 === -1 ? dir === 1 ? 0 : len - 1 : index2 + dir;
  return list2[nextIndex];
}
function getNextTabbable(referenceElement) {
  return getTabbableIn(ownerDocument(referenceElement).body, 1) || referenceElement;
}
function getPreviousTabbable(referenceElement) {
  return getTabbableIn(ownerDocument(referenceElement).body, -1) || referenceElement;
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container);
  tabbableElements.forEach((element2) => {
    element2.dataset.tabindex = element2.getAttribute("tabindex") || "";
    element2.setAttribute("tabindex", "-1");
  });
}
function enableFocusInside(container) {
  const elements = [];
  appendMatchingElements(container, "[data-tabindex]", elements);
  elements.forEach((element2) => {
    const tabindex = element2.dataset.tabindex;
    delete element2.dataset.tabindex;
    if (tabindex) {
      element2.setAttribute("tabindex", tabindex);
    } else {
      element2.removeAttribute("tabindex");
    }
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/nodes.mjs
function getNodeChildren(nodes, id, onlyOpenChildren = true) {
  const directChildren = nodes.filter((node) => node.parentId === id);
  return directChildren.flatMap((child) => [...!onlyOpenChildren || child.context?.open ? [child] : [], ...getNodeChildren(nodes, child.id, onlyOpenChildren)]);
}
function getNodeAncestors(nodes, id) {
  let allAncestors = [];
  let currentParentId = nodes.find((node) => node.id === id)?.parentId;
  while (currentParentId) {
    const currentNode = nodes.find((node) => node.id === currentParentId);
    currentParentId = currentNode?.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/createAttribute.mjs
function createAttribute(name2) {
  return `data-base-ui-${name2}`;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/enqueueFocus.mjs
var rafId = 0;
function enqueueFocus(el, options = {}) {
  const {
    preventScroll = false,
    sync = false,
    shouldFocus
  } = options;
  cancelAnimationFrame(rafId);
  function exec() {
    if (shouldFocus && !shouldFocus()) {
      return;
    }
    el?.focus({
      preventScroll
    });
  }
  if (sync) {
    exec();
    return NOOP;
  }
  const currentRafId = requestAnimationFrame(exec);
  rafId = currentRafId;
  return () => {
    if (rafId === currentRafId) {
      cancelAnimationFrame(currentRafId);
      rafId = 0;
    }
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/markOthers.mjs
var counters = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap()
};
var markerName = "data-base-ui-inert";
var uncontrolledElementsSets = {
  inert: /* @__PURE__ */ new WeakSet(),
  "aria-hidden": /* @__PURE__ */ new WeakSet()
};
var markerCounterMap = /* @__PURE__ */ new WeakMap();
var lockCount = 0;
function getUncontrolledElementsSet(controlAttribute) {
  return uncontrolledElementsSets[controlAttribute];
}
function unwrapHost(node) {
  if (!node) {
    return null;
  }
  return isShadowRoot(node) ? node.host : unwrapHost(node.parentNode);
}
var correctElements = (parent, targets) => targets.map((target) => {
  if (parent.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter((x) => x != null);
var buildKeepSet = (targets) => {
  const keep = /* @__PURE__ */ new Set();
  targets.forEach((target) => {
    let node = target;
    while (node && !keep.has(node)) {
      keep.add(node);
      node = node.parentNode;
    }
  });
  return keep;
};
var collectOutsideElements = (root3, keepElements, stopElements) => {
  const outside = [];
  const walk = (parent) => {
    if (!parent || stopElements.has(parent)) {
      return;
    }
    Array.from(parent.children).forEach((node) => {
      if (getNodeName(node) === "script") {
        return;
      }
      if (keepElements.has(node)) {
        walk(node);
      } else {
        outside.push(node);
      }
    });
  };
  walk(root3);
  return outside;
};
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert, {
  mark: mark2 = true
}) {
  let controlAttribute = null;
  if (inert) {
    controlAttribute = "inert";
  } else if (ariaHidden) {
    controlAttribute = "aria-hidden";
  }
  let counterMap = null;
  let uncontrolledElementsSet = null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const markerTargets = mark2 ? collectOutsideElements(body, buildKeepSet(avoidElements), new Set(avoidElements)) : [];
  const hiddenElements = [];
  const markedElements = [];
  if (controlAttribute) {
    const map = counters[controlAttribute];
    const currentUncontrolledElementsSet = getUncontrolledElementsSet(controlAttribute);
    uncontrolledElementsSet = currentUncontrolledElementsSet;
    counterMap = map;
    const ariaLiveElements = correctElements(body, Array.from(body.querySelectorAll("[aria-live]")));
    const controlElements = avoidElements.concat(ariaLiveElements);
    const controlTargets = collectOutsideElements(body, buildKeepSet(controlElements), new Set(controlElements));
    controlTargets.forEach((node) => {
      const attr2 = node.getAttribute(controlAttribute);
      const alreadyHidden = attr2 !== null && attr2 !== "false";
      const counterValue = (map.get(node) || 0) + 1;
      map.set(node, counterValue);
      hiddenElements.push(node);
      if (counterValue === 1 && alreadyHidden) {
        currentUncontrolledElementsSet.add(node);
      }
      if (!alreadyHidden) {
        node.setAttribute(controlAttribute, controlAttribute === "inert" ? "" : "true");
      }
    });
  }
  if (mark2) {
    markerTargets.forEach((node) => {
      const markerValue = (markerCounterMap.get(node) || 0) + 1;
      markerCounterMap.set(node, markerValue);
      markedElements.push(node);
      if (markerValue === 1) {
        node.setAttribute(markerName, "");
      }
    });
  }
  lockCount += 1;
  return () => {
    if (counterMap) {
      hiddenElements.forEach((element2) => {
        const currentCounterValue = counterMap.get(element2) || 0;
        const counterValue = currentCounterValue - 1;
        counterMap.set(element2, counterValue);
        if (!counterValue) {
          if (!uncontrolledElementsSet?.has(element2) && controlAttribute) {
            element2.removeAttribute(controlAttribute);
          }
          uncontrolledElementsSet?.delete(element2);
        }
      });
    }
    if (mark2) {
      markedElements.forEach((element2) => {
        const markerValue = (markerCounterMap.get(element2) || 0) - 1;
        markerCounterMap.set(element2, markerValue);
        if (!markerValue) {
          element2.removeAttribute(markerName);
        }
      });
    }
    lockCount -= 1;
    if (!lockCount) {
      counters.inert = /* @__PURE__ */ new WeakMap();
      counters["aria-hidden"] = /* @__PURE__ */ new WeakMap();
      uncontrolledElementsSets.inert = /* @__PURE__ */ new WeakSet();
      uncontrolledElementsSets["aria-hidden"] = /* @__PURE__ */ new WeakSet();
      markerCounterMap = /* @__PURE__ */ new WeakMap();
    }
  };
}
function markOthers(avoidElements, options = {}) {
  const {
    ariaHidden = false,
    inert = false,
    mark: mark2 = true
  } = options;
  const body = ownerDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements, body, ariaHidden, inert, {
    mark: mark2
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/components/FloatingPortal.mjs
import * as React28 from "react";
import * as ReactDOM from "react-dom";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useId.mjs
import * as React25 from "react";
var globalId = 0;
function useGlobalId(idOverride, prefix = "mui") {
  const [defaultId, setDefaultId] = React25.useState(idOverride);
  const id = idOverride || defaultId;
  React25.useEffect(() => {
    if (defaultId == null) {
      globalId += 1;
      setDefaultId(`${prefix}-${globalId}`);
    }
  }, [defaultId, prefix]);
  return id;
}
var maybeReactUseId = SafeReact.useId;
function useId4(idOverride, prefix) {
  if (maybeReactUseId !== void 0) {
    const reactId = maybeReactUseId();
    return idOverride ?? (prefix ? `${prefix}-${reactId}` : reactId);
  }
  return useGlobalId(idOverride, prefix);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useRenderElement.mjs
import * as React27 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/getReactElementRef.mjs
import * as React26 from "react";
function getReactElementRef(element2) {
  if (!/* @__PURE__ */ React26.isValidElement(element2)) {
    return null;
  }
  const reactElement = element2;
  const propsWithRef = reactElement.props;
  return (isReactVersionAtLeast(19) ? propsWithRef?.ref : reactElement.ref) ?? null;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/mergeObjects.mjs
function mergeObjects(a, b) {
  if (a && !b) {
    return a;
  }
  if (!a && b) {
    return b;
  }
  if (a || b) {
    return {
      ...a,
      ...b
    };
  }
  return void 0;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/warn.mjs
var warn = createLogOnce("warn", "Base UI");

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/getStateAttributesProps.mjs
function getStateAttributesProps(state, customMapping) {
  const props = {};
  for (const key in state) {
    const value = state[key];
    if (customMapping?.hasOwnProperty(key)) {
      const customProps = customMapping[key](value);
      if (customProps != null) {
        Object.assign(props, customProps);
      }
      continue;
    }
    if (value === true) {
      props[`data-${key.toLowerCase()}`] = "";
    } else if (value) {
      props[`data-${key.toLowerCase()}`] = value.toString();
    }
  }
  return props;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/resolveClassName.mjs
function resolveClassName(className, state) {
  return typeof className === "function" ? className(state) : className;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/resolveStyle.mjs
function resolveStyle(style, state) {
  return typeof style === "function" ? style(state) : style;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/merge-props/mergeProps.mjs
var EMPTY_PROPS = {};
function mergeProps(a, b, c, d, e) {
  if (!c && !d && !e && !a) {
    return createInitialMergedProps(b);
  }
  let merged = createInitialMergedProps(a);
  if (b) {
    merged = mergeInto(merged, b);
  }
  if (c) {
    merged = mergeInto(merged, c);
  }
  if (d) {
    merged = mergeInto(merged, d);
  }
  if (e) {
    merged = mergeInto(merged, e);
  }
  return merged;
}
function mergePropsN(props) {
  if (props.length === 0) {
    return EMPTY_PROPS;
  }
  if (props.length === 1) {
    return createInitialMergedProps(props[0]);
  }
  let merged = createInitialMergedProps(props[0]);
  for (let i = 1; i < props.length; i += 1) {
    merged = mergeInto(merged, props[i]);
  }
  return merged;
}
function createInitialMergedProps(inputProps) {
  if (isPropsGetter(inputProps)) {
    return {
      ...resolvePropsGetter(inputProps, EMPTY_PROPS)
    };
  }
  return copyInitialProps(inputProps);
}
function mergeInto(merged, inputProps) {
  if (isPropsGetter(inputProps)) {
    return resolvePropsGetter(inputProps, merged);
  }
  return mutablyMergeInto(merged, inputProps);
}
function copyInitialProps(inputProps) {
  const copiedProps = {
    ...inputProps
  };
  for (const propName in copiedProps) {
    const propValue = copiedProps[propName];
    if (isEventHandler(propName, propValue)) {
      copiedProps[propName] = wrapEventHandler(propValue);
    }
  }
  return copiedProps;
}
function mutablyMergeInto(mergedProps, externalProps) {
  if (!externalProps) {
    return mergedProps;
  }
  for (const propName in externalProps) {
    const externalPropValue = externalProps[propName];
    switch (propName) {
      case "style": {
        mergedProps[propName] = mergeObjects(mergedProps.style, externalPropValue);
        break;
      }
      case "className": {
        mergedProps[propName] = mergeClassNames(mergedProps.className, externalPropValue);
        break;
      }
      default: {
        if (isEventHandler(propName, externalPropValue)) {
          mergedProps[propName] = mergeEventHandlers(mergedProps[propName], externalPropValue);
        } else {
          mergedProps[propName] = externalPropValue;
        }
      }
    }
  }
  return mergedProps;
}
function isEventHandler(key, value) {
  const code0 = key.charCodeAt(0);
  const code1 = key.charCodeAt(1);
  const code22 = key.charCodeAt(2);
  return code0 === 111 && code1 === 110 && code22 >= 65 && code22 <= 90 && (typeof value === "function" || typeof value === "undefined");
}
function isPropsGetter(inputProps) {
  return typeof inputProps === "function";
}
function resolvePropsGetter(inputProps, previousProps) {
  if (isPropsGetter(inputProps)) {
    return inputProps(previousProps);
  }
  return inputProps ?? EMPTY_PROPS;
}
function mergeEventHandlers(ourHandler, theirHandler) {
  if (!theirHandler) {
    return ourHandler;
  }
  if (!ourHandler) {
    return wrapEventHandler(theirHandler);
  }
  return (...args) => {
    const event = args[0];
    if (isSyntheticEvent(event)) {
      const baseUIEvent = event;
      makeEventPreventable(baseUIEvent);
      const result2 = theirHandler(...args);
      if (!baseUIEvent.baseUIHandlerPrevented) {
        ourHandler?.(...args);
      }
      return result2;
    }
    const result = theirHandler(...args);
    ourHandler?.(...args);
    return result;
  };
}
function wrapEventHandler(handler) {
  if (!handler) {
    return handler;
  }
  return (...args) => {
    const event = args[0];
    if (isSyntheticEvent(event)) {
      makeEventPreventable(event);
    }
    return handler(...args);
  };
}
function makeEventPreventable(event) {
  event.preventBaseUIHandler = () => {
    event.baseUIHandlerPrevented = true;
  };
  return event;
}
function mergeClassNames(ourClassName, theirClassName) {
  if (theirClassName) {
    if (ourClassName) {
      return theirClassName + " " + ourClassName;
    }
    return theirClassName;
  }
  return ourClassName;
}
function isSyntheticEvent(event) {
  return event != null && typeof event === "object" && "nativeEvent" in event;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useRenderElement.mjs
import { createElement as _createElement } from "react";
function useRenderElement(element2, componentProps, params = {}) {
  let renderProp = componentProps.render;
  if (params.enabled !== false) {
    renderProp = unwrapLazyRenderProp(renderProp);
  }
  const outProps = useRenderElementProps(componentProps, params, renderProp);
  if (params.enabled === false) {
    return null;
  }
  const state = params.state ?? EMPTY_OBJECT;
  return evaluateRenderProp(element2, renderProp, outProps, state);
}
function useRenderElementProps(componentProps, params, renderProp) {
  const {
    className: classNameProp,
    style: styleProp
  } = componentProps;
  const {
    state = EMPTY_OBJECT,
    ref,
    props,
    stateAttributesMapping: stateAttributesMapping5,
    enabled = true
  } = params;
  const className = enabled ? resolveClassName(classNameProp, state) : void 0;
  const style = enabled ? resolveStyle(styleProp, state) : void 0;
  const stateProps = enabled ? getStateAttributesProps(state, stateAttributesMapping5) : EMPTY_OBJECT;
  const resolvedProps = enabled && props ? resolveRenderFunctionProps(props) : void 0;
  const outProps = enabled ? mergeObjects(stateProps, resolvedProps) ?? {} : EMPTY_OBJECT;
  if (typeof document !== "undefined") {
    if (!enabled) {
      void useMergedRefs(null, null);
    } else if (Array.isArray(ref)) {
      outProps.ref = useMergedRefsN([outProps.ref, getReactElementRef(renderProp), ...ref]);
    } else {
      outProps.ref = useMergedRefs(outProps.ref, getReactElementRef(renderProp), ref);
    }
  }
  if (!enabled) {
    return EMPTY_OBJECT;
  }
  if (className !== void 0) {
    outProps.className = mergeClassNames(outProps.className, className);
  }
  if (style !== void 0) {
    outProps.style = mergeObjects(outProps.style, style);
  }
  return outProps;
}
function resolveRenderFunctionProps(props) {
  if (Array.isArray(props)) {
    return mergePropsN(props);
  }
  return mergeProps(void 0, props);
}
var REACT_LAZY_TYPE = Symbol.for("react.lazy");
var COMPONENT_IDENTIFIER_PATTERN = /^[A-Z][A-Za-z0-9$]*$/;
var LOWERCASE_CHARACTER_PATTERN = /[a-z]/;
function unwrapLazyRenderProp(render) {
  if (render?.$$typeof !== REACT_LAZY_TYPE) {
    return render;
  }
  const unwrapped = React27.Children.toArray(render)[0];
  return /* @__PURE__ */ React27.isValidElement(unwrapped) ? unwrapped : render;
}
function evaluateRenderProp(element2, render, props, state) {
  if (render) {
    if (typeof render === "function") {
      if (process.env.NODE_ENV !== "production") {
        warnIfRenderPropLooksLikeComponent(render);
      }
      return render(props, state);
    }
    const mergedProps = mergeProps(props, render.props);
    mergedProps.ref = props.ref;
    if (process.env.NODE_ENV !== "production") {
      if (!/* @__PURE__ */ React27.isValidElement(render)) {
        throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join("\n"));
      }
    }
    return /* @__PURE__ */ React27.cloneElement(render, mergedProps);
  }
  if (element2) {
    if (typeof element2 === "string") {
      return renderTag(element2, props);
    }
  }
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : formatErrorMessage_default(8));
}
function warnIfRenderPropLooksLikeComponent(renderFn) {
  const functionName = renderFn.name;
  if (functionName.length === 0) {
    return;
  }
  if (!COMPONENT_IDENTIFIER_PATTERN.test(functionName)) {
    return;
  }
  if (!LOWERCASE_CHARACTER_PATTERN.test(functionName)) {
    return;
  }
  warn(`The \`render\` prop received a function named \`${functionName}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function renderTag(Tag, props) {
  if (Tag === "button") {
    return /* @__PURE__ */ _createElement("button", {
      type: "button",
      ...props,
      key: props.key
    });
  }
  if (Tag === "img") {
    return /* @__PURE__ */ _createElement("img", {
      alt: "",
      ...props,
      key: props.key
    });
  }
  return /* @__PURE__ */ React27.createElement(Tag, props);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/constants.mjs
var DISABLED_TRANSITIONS_STYLE = {
  style: {
    transition: "none"
  }
};
var CLICK_TRIGGER_IDENTIFIER = "data-base-ui-click-trigger";
var BASE_UI_SWIPE_IGNORE_ATTRIBUTE = "data-base-ui-swipe-ignore";
var LEGACY_SWIPE_IGNORE_ATTRIBUTE = "data-swipe-ignore";
var BASE_UI_SWIPE_IGNORE_SELECTOR = `[${BASE_UI_SWIPE_IGNORE_ATTRIBUTE}]`;
var LEGACY_SWIPE_IGNORE_SELECTOR = `[${LEGACY_SWIPE_IGNORE_ATTRIBUTE}]`;
var DROPDOWN_COLLISION_AVOIDANCE = {
  fallbackAxisSide: "none"
};
var ownerVisuallyHidden = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/components/FloatingPortal.mjs
import { jsx as _jsx2, jsxs as _jsxs } from "react/jsx-runtime";
var PortalContext = /* @__PURE__ */ React28.createContext(null);
if (process.env.NODE_ENV !== "production") PortalContext.displayName = "PortalContext";
var usePortalContext = () => React28.useContext(PortalContext);
var attr = createAttribute("portal");
function useFloatingPortalNode(props = {}) {
  const {
    ref,
    container: containerProp,
    componentProps = EMPTY_OBJECT,
    elementProps
  } = props;
  const uniqueId = useId4();
  const portalContext = usePortalContext();
  const parentPortalNode = portalContext?.portalNode;
  const [containerElement, setContainerElement] = React28.useState(null);
  const [portalNode, setPortalNode] = React28.useState(null);
  const setPortalNodeRef = useStableCallback((node) => {
    if (node !== null) {
      setPortalNode(node);
    }
  });
  const containerRef = React28.useRef(null);
  useIsoLayoutEffect(() => {
    if (containerProp === null) {
      if (containerRef.current) {
        containerRef.current = null;
        setPortalNode(null);
        setContainerElement(null);
      }
      return;
    }
    const resolvedContainer = (containerProp && (isNode(containerProp) ? containerProp : containerProp.current)) ?? parentPortalNode ?? document.body;
    if (resolvedContainer == null) {
      if (containerRef.current) {
        containerRef.current = null;
        setPortalNode(null);
        setContainerElement(null);
      }
      return;
    }
    if (containerRef.current !== resolvedContainer) {
      containerRef.current = resolvedContainer;
      setPortalNode(null);
      setContainerElement(resolvedContainer);
    }
  }, [containerProp, parentPortalNode]);
  const portalElement = useRenderElement("div", componentProps, {
    ref: [ref, setPortalNodeRef],
    props: [{
      id: uniqueId,
      [attr]: ""
    }, elementProps]
  });
  const portalSubtree = containerElement && portalElement ? /* @__PURE__ */ ReactDOM.createPortal(portalElement, containerElement) : null;
  return {
    node: portalNode,
    // `id` and `render` props can override or remove the generated ID. Use the exact
    // rendered value so `aria-owns` never points at an ID absent from the DOM.
    nodeId: /* @__PURE__ */ React28.isValidElement(portalElement) ? portalElement.props.id : void 0,
    subtree: portalSubtree
  };
}
var FloatingPortal = /* @__PURE__ */ React28.forwardRef(function FloatingPortal2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    children,
    container,
    portalOwnerRole,
    ...elementProps
  } = componentProps;
  const {
    node: portalNode,
    nodeId: portalNodeId,
    subtree: portalSubtree
  } = useFloatingPortalNode({
    container,
    ref: forwardedRef,
    componentProps,
    elementProps
  });
  const beforeOutsideRef = React28.useRef(null);
  const afterOutsideRef = React28.useRef(null);
  const beforeInsideRef = React28.useRef(null);
  const afterInsideRef = React28.useRef(null);
  const [focusManagerState, setFocusManagerState] = React28.useState(null);
  const focusInsideDisabledRef = React28.useRef(false);
  const modal = focusManagerState?.modal;
  const open2 = focusManagerState?.open;
  const shouldRenderGuards = !!focusManagerState && !focusManagerState.modal && focusManagerState.open && !!portalNode;
  React28.useEffect(() => {
    if (!portalNode || modal) {
      return void 0;
    }
    function onFocus(event) {
      if (portalNode && event.relatedTarget && isOutsideEvent(event)) {
        if (event.type === "focusin") {
          if (focusInsideDisabledRef.current) {
            enableFocusInside(portalNode);
            focusInsideDisabledRef.current = false;
          }
        } else {
          disableFocusInside(portalNode);
          focusInsideDisabledRef.current = true;
        }
      }
    }
    return mergeCleanups(addEventListener(portalNode, "focusin", onFocus, true), addEventListener(portalNode, "focusout", onFocus, true));
  }, [portalNode, modal]);
  useIsoLayoutEffect(() => {
    if (!portalNode || open2 !== true || !focusInsideDisabledRef.current) {
      return;
    }
    enableFocusInside(portalNode);
    focusInsideDisabledRef.current = false;
  }, [open2, portalNode]);
  const portalContextValue = React28.useMemo(() => ({
    beforeOutsideRef,
    afterOutsideRef,
    beforeInsideRef,
    afterInsideRef,
    portalNode,
    setFocusManagerState
  }), [portalNode]);
  return /* @__PURE__ */ _jsxs(React28.Fragment, {
    children: [portalSubtree, /* @__PURE__ */ _jsxs(PortalContext.Provider, {
      value: portalContextValue,
      children: [shouldRenderGuards && portalNode && /* @__PURE__ */ _jsx2(FocusGuard, {
        "data-type": "outside",
        ref: beforeOutsideRef,
        onFocus: (event) => {
          if (isOutsideEvent(event, portalNode)) {
            beforeInsideRef.current?.focus();
          } else {
            const domReference = focusManagerState ? focusManagerState.domReference : null;
            const prevTabbable = getPreviousTabbable(domReference);
            prevTabbable?.focus();
          }
        }
      }), shouldRenderGuards && portalNode && /* @__PURE__ */ _jsx2("span", {
        role: portalOwnerRole,
        "aria-owns": portalNodeId,
        style: ownerVisuallyHidden
      }), portalNode && /* @__PURE__ */ ReactDOM.createPortal(children, portalNode), shouldRenderGuards && portalNode && /* @__PURE__ */ _jsx2(FocusGuard, {
        "data-type": "outside",
        ref: afterOutsideRef,
        onFocus: (event) => {
          if (isOutsideEvent(event, portalNode)) {
            afterInsideRef.current?.focus();
          } else {
            const domReference = focusManagerState ? focusManagerState.domReference : null;
            const nextTabbable = getNextTabbable(domReference);
            nextTabbable?.focus();
            if (focusManagerState?.closeOnFocusOut) {
              focusManagerState?.onOpenChange(false, createChangeEventDetails(reason_parts_exports.focusOut, event.nativeEvent));
            }
          }
        }
      })]
    })]
  });
});
if (process.env.NODE_ENV !== "production") FloatingPortal.displayName = "FloatingPortal";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/components/FloatingTree.mjs
import * as React29 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/utils/createEventEmitter.mjs
function createEventEmitter() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      map.get(event)?.forEach((listener) => listener(data));
    },
    on(event, listener) {
      if (!map.has(event)) {
        map.set(event, /* @__PURE__ */ new Set());
      }
      map.get(event).add(listener);
    },
    off(event, listener) {
      map.get(event)?.delete(listener);
    }
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/components/FloatingTree.mjs
import { jsx as _jsx3 } from "react/jsx-runtime";
var FloatingNodeContext = /* @__PURE__ */ React29.createContext(null);
if (process.env.NODE_ENV !== "production") FloatingNodeContext.displayName = "FloatingNodeContext";
var FloatingTreeContext = /* @__PURE__ */ React29.createContext(null);
if (process.env.NODE_ENV !== "production") FloatingTreeContext.displayName = "FloatingTreeContext";
var useFloatingParentNodeId = () => React29.useContext(FloatingNodeContext)?.id || null;
var useFloatingTree = (externalTree) => {
  const contextTree = React29.useContext(FloatingTreeContext);
  return externalTree ?? contextTree;
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/resolveRef.mjs
function resolveRef(maybeRef) {
  if (maybeRef == null) {
    return maybeRef;
  }
  return "current" in maybeRef ? maybeRef.current : maybeRef;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/components/FloatingFocusManager.mjs
import { jsx as _jsx4, jsxs as _jsxs2 } from "react/jsx-runtime";
function getEventType(event, lastInteractionType) {
  const win = getWindow(getTarget(event));
  if (event instanceof win.KeyboardEvent) {
    return "keyboard";
  }
  if (event instanceof win.FocusEvent) {
    return lastInteractionType || "keyboard";
  }
  if ("pointerType" in event) {
    return event.pointerType || "keyboard";
  }
  if ("touches" in event) {
    return "touch";
  }
  if (event instanceof win.MouseEvent) {
    return lastInteractionType || (event.detail === 0 ? "keyboard" : "mouse");
  }
  return "";
}
var LIST_LIMIT = 20;
var previouslyFocusedElements = [];
function clearDisconnectedPreviouslyFocusedElements() {
  previouslyFocusedElements = previouslyFocusedElements.filter((entry) => {
    return entry.deref()?.isConnected;
  });
}
function addPreviouslyFocusedElement(element2) {
  clearDisconnectedPreviouslyFocusedElements();
  if (element2 && getNodeName(element2) !== "body") {
    previouslyFocusedElements.push(new WeakRef(element2));
    if (previouslyFocusedElements.length > LIST_LIMIT) {
      previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
    }
  }
}
function getPreviouslyFocusedElement() {
  clearDisconnectedPreviouslyFocusedElements();
  return previouslyFocusedElements[previouslyFocusedElements.length - 1]?.deref();
}
function getFirstTabbableElement(container) {
  if (!container) {
    return null;
  }
  if (isTabbable(container)) {
    return container;
  }
  return tabbable(container)[0] || container;
}
function handleTabIndex(floatingFocusElement) {
  if (floatingFocusElement.hasAttribute("tabindex") && !floatingFocusElement.hasAttribute("data-tabindex")) {
    return;
  }
  if (!floatingFocusElement.getAttribute("role")?.includes("dialog")) {
    return;
  }
  const focusableElements = focusable(floatingFocusElement);
  const tabbableContent = focusableElements.filter((element2) => {
    const dataTabIndex = element2.getAttribute("data-tabindex") || "";
    return isTabbable(element2) || element2.hasAttribute("data-tabindex") && !dataTabIndex.startsWith("-");
  });
  const tabIndex = floatingFocusElement.getAttribute("tabindex");
  if (tabbableContent.length === 0) {
    if (tabIndex !== "0") {
      floatingFocusElement.setAttribute("tabindex", "0");
      floatingFocusElement.setAttribute("data-tabindex", "0");
    }
  } else if (tabIndex !== "-1" || floatingFocusElement.hasAttribute("data-tabindex") && floatingFocusElement.getAttribute("data-tabindex") !== "-1") {
    floatingFocusElement.setAttribute("tabindex", "-1");
    floatingFocusElement.setAttribute("data-tabindex", "-1");
  }
}
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled: disabled2 = false,
    initialFocus = true,
    returnFocus = true,
    restoreFocus = false,
    modal = true,
    closeOnFocusOut = true,
    openInteractionType = "",
    nextFocusableElement,
    previousFocusableElement,
    beforeContentFocusGuardRef,
    externalTree,
    getInsideElements
  } = props;
  const store = "rootStore" in context ? context.rootStore : context;
  const open2 = store.useState("open");
  const domReference = store.useState("domReferenceElement");
  const floating = store.useState("floatingElement");
  const {
    events,
    dataRef
  } = store.context;
  const getNodeId = useStableCallback(() => dataRef.current.floatingContext?.nodeId);
  const ignoreInitialFocus = initialFocus === false;
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;
  const initialFocusRef = useValueAsRef(initialFocus);
  const returnFocusRef = useValueAsRef(returnFocus);
  const openInteractionTypeRef = useValueAsRef(openInteractionType);
  const openRef = useValueAsRef(open2);
  const tree = useFloatingTree(externalTree);
  const portalContext = usePortalContext();
  const preventReturnFocusRef = React30.useRef(false);
  const isPointerDownRef = React30.useRef(false);
  const pointerDownOutsideRef = React30.useRef(false);
  const lastFocusedTabbableRef = React30.useRef(null);
  const closeTypeRef = React30.useRef("");
  const lastInteractionTypeRef = React30.useRef("");
  const beforeGuardRef = React30.useRef(null);
  const afterGuardRef = React30.useRef(null);
  const mergedBeforeGuardRef = useMergedRefs(beforeGuardRef, beforeContentFocusGuardRef, portalContext?.beforeInsideRef);
  const mergedAfterGuardRef = useMergedRefs(afterGuardRef, portalContext?.afterInsideRef);
  const blurTimeout = useTimeout();
  const pointerDownTimeout = useTimeout();
  const restoreFocusFrame = useAnimationFrame();
  const isInsidePortal = portalContext != null;
  const floatingFocusElement = getFloatingFocusElement(floating);
  const getTabbableContent = useStableCallback((container = floatingFocusElement) => {
    return container ? tabbable(container) : [];
  });
  const getResolvedInsideElements = useStableCallback(() => getInsideElements?.().filter((element2) => element2 != null) ?? []);
  React30.useEffect(() => {
    if (disabled2 || !modal) {
      return void 0;
    }
    function onKeyDown(event) {
      if (event.key === "Tab") {
        if (contains(floatingFocusElement, activeElement(ownerDocument(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
      }
    }
    const doc = ownerDocument(floatingFocusElement);
    return addEventListener(doc, "keydown", onKeyDown);
  }, [disabled2, floatingFocusElement, modal, isUntrappedTypeableCombobox, getTabbableContent]);
  React30.useEffect(() => {
    if (disabled2 || !open2) {
      return void 0;
    }
    const doc = ownerDocument(floatingFocusElement);
    function clearPointerDownOutside() {
      pointerDownOutsideRef.current = false;
    }
    function onPointerDown(event) {
      const target = getTarget(event);
      const insideElements = getResolvedInsideElements();
      const pointerTargetInside = contains(floating, target) || contains(domReference, target) || contains(portalContext?.portalNode, target) || insideElements.some((element2) => element2 === target || contains(element2, target));
      pointerDownOutsideRef.current = !pointerTargetInside;
      lastInteractionTypeRef.current = event.pointerType || "keyboard";
      if (target?.closest(`[${CLICK_TRIGGER_IDENTIFIER}]`)) {
        isPointerDownRef.current = true;
        pointerDownTimeout.start(0, () => {
          isPointerDownRef.current = false;
        });
      }
    }
    function onKeyDown() {
      lastInteractionTypeRef.current = "keyboard";
    }
    return mergeCleanups(
      addEventListener(doc, "pointerdown", onPointerDown, true),
      addEventListener(doc, "pointerup", clearPointerDownOutside, true),
      addEventListener(doc, "pointercancel", clearPointerDownOutside, true),
      addEventListener(doc, "keydown", onKeyDown, true),
      // Avoid a stale `true` leaking into the next open (e.g. keep-mounted popups)
      // if the popup dismissed between pointerdown and pointerup.
      clearPointerDownOutside
    );
  }, [disabled2, floating, domReference, floatingFocusElement, open2, portalContext, pointerDownTimeout, getResolvedInsideElements]);
  React30.useEffect(() => {
    if (disabled2 || !closeOnFocusOut) {
      return void 0;
    }
    const doc = ownerDocument(floatingFocusElement);
    function handlePointerDown() {
      isPointerDownRef.current = true;
      pointerDownTimeout.start(0, () => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusIn(event) {
      const target = getTarget(event);
      if (isTabbable(target)) {
        lastFocusedTabbableRef.current = target;
      }
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      const currentTarget = event.currentTarget;
      const target = getTarget(event);
      if (modal && relatedTarget == null && target != null && contains(floating, target)) {
        addPreviouslyFocusedElement(target);
      }
      queueMicrotask(() => {
        const nodeId = getNodeId();
        const triggers = store.context.triggerElements;
        const insideElements = getResolvedInsideElements();
        const isRelatedFocusGuard = relatedTarget?.hasAttribute(createAttribute("focus-guard")) && [beforeGuardRef.current, afterGuardRef.current, portalContext?.beforeInsideRef.current, portalContext?.afterInsideRef.current, portalContext?.beforeOutsideRef.current, portalContext?.afterOutsideRef.current, resolveRef(previousFocusableElement), resolveRef(nextFocusableElement)].includes(relatedTarget);
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext?.portalNode, relatedTarget) || insideElements.some((element2) => element2 === relatedTarget || contains(element2, relatedTarget)) || triggers.hasMatchingElement((trigger) => contains(trigger, relatedTarget)) || isRelatedFocusGuard || tree && (getNodeChildren(tree.nodesRef.current, nodeId).find((node) => contains(node.context?.elements.floating, relatedTarget) || contains(node.context?.elements.domReference, relatedTarget)) || getNodeAncestors(tree.nodesRef.current, nodeId).find((node) => [node.context?.elements.floating, getFloatingFocusElement(node.context?.elements.floating)].includes(relatedTarget) || node.context?.elements.domReference === relatedTarget)));
        if (currentTarget === domReference && floatingFocusElement) {
          handleTabIndex(floatingFocusElement);
        }
        if (restoreFocus && currentTarget !== domReference && !isElementVisible(target) && activeElement(doc) === doc.body) {
          if (isHTMLElement(floatingFocusElement)) {
            floatingFocusElement.focus();
            if (restoreFocus === "popup") {
              restoreFocusFrame.request(() => {
                floatingFocusElement.focus();
              });
              return;
            }
          }
          const tabbableContent = getTabbableContent();
          const prevTabbable = lastFocusedTabbableRef.current;
          const nodeToFocus = (prevTabbable && tabbableContent.includes(prevTabbable) ? prevTabbable : null) || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
          if (isHTMLElement(nodeToFocus)) {
            nodeToFocus.focus();
          }
        }
        if (dataRef.current.insideReactTree) {
          dataRef.current.insideReactTree = false;
          return;
        }
        if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (isUntrappedTypeableCombobox || relatedTarget !== getPreviouslyFocusedElement())) {
          preventReturnFocusRef.current = true;
          store.setOpen(false, createChangeEventDetails(reason_parts_exports.focusOut, event));
        }
      });
    }
    function markInsideReactTree() {
      if (pointerDownOutsideRef.current) {
        return;
      }
      dataRef.current.insideReactTree = true;
      blurTimeout.start(0, () => {
        dataRef.current.insideReactTree = false;
      });
    }
    const domReferenceElement = isHTMLElement(domReference) ? domReference : null;
    if (!floating && !domReferenceElement) {
      return void 0;
    }
    return mergeCleanups(domReferenceElement && addEventListener(domReferenceElement, "focusout", handleFocusOutside), domReferenceElement && addEventListener(domReferenceElement, "pointerdown", handlePointerDown), floating && addEventListener(floating, "focusin", handleFocusIn), floating && addEventListener(floating, "focusout", handleFocusOutside), floating && portalContext && addEventListener(floating, "focusout", markInsideReactTree, true));
  }, [disabled2, domReference, floating, floatingFocusElement, modal, tree, portalContext, store, closeOnFocusOut, restoreFocus, getTabbableContent, isUntrappedTypeableCombobox, getNodeId, dataRef, blurTimeout, pointerDownTimeout, restoreFocusFrame, nextFocusableElement, previousFocusableElement, getResolvedInsideElements]);
  React30.useEffect(() => {
    if (disabled2 || !floating || !open2) {
      return void 0;
    }
    const portalNodes = Array.from(portalContext?.portalNode?.querySelectorAll(`[${createAttribute("portal")}]`) || []);
    const ancestors = tree ? getNodeAncestors(tree.nodesRef.current, getNodeId()) : [];
    const rootAncestorComboboxDomReference = ancestors.find((node) => isTypeableCombobox(node.context?.elements.domReference || null))?.context?.elements.domReference;
    const controlInsideElements = [floating, ...portalNodes, beforeGuardRef.current, afterGuardRef.current, portalContext?.beforeOutsideRef.current, portalContext?.afterOutsideRef.current, ...getResolvedInsideElements()];
    const insideElements = [...controlInsideElements, rootAncestorComboboxDomReference, resolveRef(previousFocusableElement), resolveRef(nextFocusableElement), isUntrappedTypeableCombobox ? domReference : null].filter((x) => x != null);
    const ariaHiddenCleanup = markOthers(insideElements, {
      ariaHidden: modal || isUntrappedTypeableCombobox,
      mark: false
    });
    const markerInsideElements = [floating, ...portalNodes].filter((x) => x != null);
    const markerCleanup = markOthers(markerInsideElements);
    return () => {
      markerCleanup();
      ariaHiddenCleanup();
    };
  }, [open2, disabled2, domReference, floating, modal, portalContext, isUntrappedTypeableCombobox, tree, getNodeId, nextFocusableElement, previousFocusableElement, getResolvedInsideElements]);
  useIsoLayoutEffect(() => {
    if (!open2 || disabled2 || !isHTMLElement(floatingFocusElement)) {
      return;
    }
    closeTypeRef.current = "";
    lastInteractionTypeRef.current = "";
    const doc = ownerDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    queueMicrotask(() => {
      const initialFocusValueOrFn = initialFocusRef.current;
      const resolvedInitialFocus = typeof initialFocusValueOrFn === "function" ? initialFocusValueOrFn(openInteractionTypeRef.current || "") : initialFocusValueOrFn;
      if (resolvedInitialFocus === void 0 || resolvedInitialFocus === false) {
        return;
      }
      const focusAlreadyInsideFloatingEl = contains(floatingFocusElement, previouslyFocusedElement);
      if (focusAlreadyInsideFloatingEl) {
        return;
      }
      let focusableElements = null;
      const getDefaultFocusElement = () => {
        if (focusableElements == null) {
          focusableElements = getTabbableContent(floatingFocusElement);
        }
        return focusableElements[0] || floatingFocusElement;
      };
      let elToFocus;
      if (resolvedInitialFocus === true || resolvedInitialFocus === null) {
        elToFocus = getDefaultFocusElement();
      } else {
        elToFocus = resolveRef(resolvedInitialFocus);
      }
      elToFocus = elToFocus || getDefaultFocusElement();
      const hadFocusInside = contains(floatingFocusElement, activeElement(doc));
      void enqueueFocus(elToFocus, {
        preventScroll: elToFocus === floatingFocusElement,
        shouldFocus() {
          if (!openRef.current) {
            return false;
          }
          if (hadFocusInside) {
            return true;
          }
          const currentActiveElement = activeElement(doc);
          const focusMovedInside = currentActiveElement !== elToFocus && contains(floatingFocusElement, currentActiveElement);
          return !focusMovedInside;
        }
      });
    });
  }, [disabled2, open2, floatingFocusElement, getTabbableContent, initialFocusRef, openInteractionTypeRef, openRef]);
  useIsoLayoutEffect(() => {
    if (disabled2 || !floatingFocusElement) {
      return void 0;
    }
    const doc = ownerDocument(floatingFocusElement);
    const elementFocusedBeforeOpen = activeElement(doc);
    const preferPreviousFocus = openInteractionTypeRef.current == null;
    addPreviouslyFocusedElement(elementFocusedBeforeOpen);
    function onOpenChangeLocal(details) {
      if (!details.open) {
        closeTypeRef.current = getEventType(details.nativeEvent, lastInteractionTypeRef.current);
      }
      if (details.reason === reason_parts_exports.triggerHover && details.nativeEvent.type === "mouseleave") {
        preventReturnFocusRef.current = true;
      }
      if (details.reason !== reason_parts_exports.outsidePress) {
        return;
      }
      if (details.nested) {
        preventReturnFocusRef.current = false;
      } else if (isVirtualClick(details.nativeEvent) || isVirtualPointerEvent(details.nativeEvent)) {
        preventReturnFocusRef.current = false;
      } else {
        let isPreventScrollSupported = false;
        ownerDocument(floatingFocusElement).createElement("div").focus({
          get preventScroll() {
            isPreventScrollSupported = true;
            return false;
          }
        });
        if (isPreventScrollSupported) {
          preventReturnFocusRef.current = false;
        } else {
          preventReturnFocusRef.current = true;
        }
      }
    }
    events.on("openchange", onOpenChangeLocal);
    function getReturnElement(closeType) {
      const returnFocusValueOrFn = returnFocusRef.current;
      let resolvedReturnFocusValue = typeof returnFocusValueOrFn === "function" ? returnFocusValueOrFn(closeType) : returnFocusValueOrFn;
      if (resolvedReturnFocusValue === void 0 || resolvedReturnFocusValue === false) {
        return null;
      }
      if (resolvedReturnFocusValue === null) {
        resolvedReturnFocusValue = true;
      }
      const referenceReturnElement = domReference?.isConnected ? domReference : null;
      const previousReturnElement = elementFocusedBeforeOpen?.isConnected && getNodeName(elementFocusedBeforeOpen) !== "body" ? elementFocusedBeforeOpen : null;
      let defaultReturnElement = preferPreviousFocus ? previousReturnElement || referenceReturnElement : referenceReturnElement || previousReturnElement;
      if (!defaultReturnElement) {
        defaultReturnElement = getPreviouslyFocusedElement() || null;
      }
      if (typeof resolvedReturnFocusValue === "boolean") {
        return defaultReturnElement;
      }
      return resolveRef(resolvedReturnFocusValue) || defaultReturnElement || null;
    }
    return () => {
      events.off("openchange", onOpenChangeLocal);
      const activeEl = activeElement(doc);
      const insideElements = getResolvedInsideElements();
      const isFocusInsideFloatingTree = contains(floating, activeEl) || insideElements.some((element2) => element2 === activeEl || contains(element2, activeEl)) || tree && getNodeChildren(tree.nodesRef.current, getNodeId(), false).some((node) => contains(node.context?.elements.floating, activeEl));
      const returnFocusValueOrFn = returnFocusRef.current;
      const closeType = closeTypeRef.current;
      const returnElement = getReturnElement(closeType);
      queueMicrotask(() => {
        const tabbableReturnElement = getFirstTabbableElement(returnElement);
        const hasExplicitReturnFocus = typeof returnFocusValueOrFn !== "boolean";
        if (returnFocusValueOrFn && !preventReturnFocusRef.current && isHTMLElement(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!hasExplicitReturnFocus && tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) {
          const focusOptions = {
            preventScroll: true
          };
          if (closeType === "keyboard") {
            focusOptions.focusVisible = true;
          }
          tabbableReturnElement.focus(focusOptions);
        }
        preventReturnFocusRef.current = false;
      });
    };
  }, [disabled2, floating, floatingFocusElement, returnFocusRef, openInteractionTypeRef, events, tree, domReference, getNodeId, getResolvedInsideElements]);
  useIsoLayoutEffect(() => {
    if (!parts_exports.engine.webkit || open2 || !floating) {
      return;
    }
    const activeEl = activeElement(ownerDocument(floating));
    if (!isHTMLElement(activeEl) || !isTypeableElement(activeEl)) {
      return;
    }
    if (contains(floating, activeEl)) {
      activeEl.blur();
    }
  }, [open2, floating]);
  useIsoLayoutEffect(() => {
    if (disabled2 || !portalContext) {
      return void 0;
    }
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open: open2,
      onOpenChange: store.setOpen,
      domReference
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled2, portalContext, modal, open2, store, closeOnFocusOut, domReference]);
  useIsoLayoutEffect(() => {
    if (disabled2 || !floatingFocusElement) {
      return void 0;
    }
    handleTabIndex(floatingFocusElement);
    return () => {
      queueMicrotask(clearDisconnectedPreviouslyFocusedElements);
    };
  }, [disabled2, floatingFocusElement]);
  const shouldRenderGuards = !disabled2 && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
  return /* @__PURE__ */ _jsxs2(React30.Fragment, {
    children: [shouldRenderGuards && /* @__PURE__ */ _jsx4(FocusGuard, {
      "data-type": "inside",
      ref: mergedBeforeGuardRef,
      onFocus: (event) => {
        if (modal) {
          const els = getTabbableContent();
          void enqueueFocus(els[els.length - 1]);
        } else if (portalContext?.portalNode) {
          preventReturnFocusRef.current = false;
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const nextTabbable = getNextTabbable(domReference);
            nextTabbable?.focus();
          } else {
            resolveRef(previousFocusableElement ?? portalContext.beforeOutsideRef)?.focus();
          }
        }
      }
    }), children, shouldRenderGuards && /* @__PURE__ */ _jsx4(FocusGuard, {
      "data-type": "inside",
      ref: mergedAfterGuardRef,
      onFocus: (event) => {
        if (modal) {
          void enqueueFocus(getTabbableContent()[0]);
        } else if (portalContext?.portalNode) {
          if (closeOnFocusOut) {
            preventReturnFocusRef.current = true;
          }
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const prevTabbable = getPreviousTabbable(domReference);
            prevTabbable?.focus();
          } else {
            resolveRef(nextFocusableElement ?? portalContext.afterOutsideRef)?.focus();
          }
        }
      }
    })]
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/hooks/useClick.mjs
import * as React31 from "react";
function useClick(context, props = {}) {
  const {
    enabled = true,
    event: eventOption = "click",
    toggle = true,
    ignoreMouse = false,
    stickIfOpen = true,
    touchOpenDelay = 0,
    reason = reason_parts_exports.triggerPress
  } = props;
  const store = "rootStore" in context ? context.rootStore : context;
  const dataRef = store.context.dataRef;
  const pointerTypeRef = React31.useRef(void 0);
  const frame = useAnimationFrame();
  const touchOpenTimeout = useTimeout();
  const reference = React31.useMemo(() => {
    function setOpenWithTouchDelay(nextOpen, nativeEvent, target, pointerType) {
      const details = createChangeEventDetails(reason, nativeEvent, target);
      if (nextOpen && pointerType === "touch" && touchOpenDelay > 0) {
        touchOpenTimeout.start(touchOpenDelay, () => {
          store.setOpen(true, details);
        });
      } else {
        store.setOpen(nextOpen, details);
      }
    }
    function getNextOpen(open2, currentTarget, isClickLikeOpenEvent) {
      const openEvent = dataRef.current.openEvent;
      const hasClickedOnInactiveTrigger = store.select("domReferenceElement") !== currentTarget;
      if (open2 && hasClickedOnInactiveTrigger) {
        return true;
      }
      if (!open2) {
        return true;
      }
      if (!toggle) {
        return true;
      }
      if (openEvent && stickIfOpen) {
        return !isClickLikeOpenEvent(openEvent.type);
      }
      return false;
    }
    return {
      onPointerDown(event) {
        pointerTypeRef.current = isMouseLikePointerType(event.pointerType, true) && isVirtualPointerEvent(event.nativeEvent) ? "virtual" : event.pointerType;
      },
      onMouseDown(event) {
        const pointerType = pointerTypeRef.current;
        const nativeEvent = event.nativeEvent;
        const open2 = store.select("open");
        if (event.button !== 0 || eventOption === "click" || isMouseLikePointerType(pointerType, true) && ignoreMouse) {
          return;
        }
        const nextOpen = getNextOpen(open2, event.currentTarget, (openEventType) => openEventType === "click" || openEventType === "mousedown");
        const target = getTarget(nativeEvent);
        if (isTypeableElement(target)) {
          setOpenWithTouchDelay(nextOpen, nativeEvent, target, pointerType);
          return;
        }
        const eventCurrentTarget = event.currentTarget;
        frame.request(() => {
          setOpenWithTouchDelay(nextOpen, nativeEvent, eventCurrentTarget, pointerType);
        });
      },
      onClick(event) {
        if (eventOption === "mousedown-only") {
          return;
        }
        const pointerType = pointerTypeRef.current;
        if (eventOption === "mousedown" && pointerType) {
          pointerTypeRef.current = void 0;
          return;
        }
        if (isMouseLikePointerType(pointerType, true) && ignoreMouse) {
          return;
        }
        const open2 = store.select("open");
        const nextOpen = getNextOpen(open2, event.currentTarget, (openEventType) => openEventType === "click" || openEventType === "mousedown" || openEventType === "keydown" || openEventType === "keyup");
        setOpenWithTouchDelay(nextOpen, event.nativeEvent, event.currentTarget, pointerType);
      },
      onKeyDown() {
        pointerTypeRef.current = void 0;
      }
    };
  }, [dataRef, eventOption, ignoreMouse, reason, store, stickIfOpen, toggle, frame, touchOpenTimeout, touchOpenDelay]);
  return React31.useMemo(() => enabled ? {
    reference
  } : EMPTY_OBJECT, [enabled, reference]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/hooks/useDismiss.mjs
import * as React32 from "react";
function alwaysFalse() {
  return false;
}
function normalizeProp(normalizable) {
  return {
    escapeKey: typeof normalizable === "boolean" ? normalizable : normalizable?.escapeKey ?? false,
    outsidePress: typeof normalizable === "boolean" ? normalizable : normalizable?.outsidePress ?? true
  };
}
function useDismiss(context, props = {}) {
  const {
    enabled = true,
    escapeKey: escapeKey2 = true,
    outsidePress: outsidePressProp = true,
    outsidePressEvent = "sloppy",
    referencePress = alwaysFalse,
    bubbles,
    externalTree
  } = props;
  const store = "rootStore" in context ? context.rootStore : context;
  const open2 = store.useState("open");
  const floatingElement = store.useState("floatingElement");
  const {
    dataRef,
    events
  } = store.context;
  const tree = useFloatingTree(externalTree);
  const outsidePressFn = useStableCallback(typeof outsidePressProp === "function" ? outsidePressProp : () => false);
  const outsidePress2 = typeof outsidePressProp === "function" ? outsidePressFn : outsidePressProp;
  const outsidePressEnabled = outsidePress2 !== false;
  const getOutsidePressEventProp = useStableCallback(() => outsidePressEvent);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const pressStartedInsideRef = React32.useRef(false);
  const pressStartPreventedRef = React32.useRef(false);
  const suppressNextOutsideClickRef = React32.useRef(false);
  const sawPressWhileOpenRef = React32.useRef(false);
  const isComposingRef = React32.useRef(false);
  const currentPointerTypeRef = React32.useRef("");
  const touchStateRef = React32.useRef(null);
  const cancelDismissOnEndTimeout = useTimeout();
  const clearInsideReactTreeTimeout = useTimeout();
  const clearInsideReactTree = useStableCallback(() => {
    clearInsideReactTreeTimeout.clear();
    dataRef.current.insideReactTree = false;
  });
  const hasBlockingChild = useStableCallback((bubbleKey) => {
    const nodeId = dataRef.current.floatingContext?.nodeId;
    const children = tree ? getNodeChildren(tree.nodesRef.current, nodeId) : [];
    return children.some((child) => child.context?.open && !child.context.dataRef.current[bubbleKey]);
  });
  const isEventWithinOwnElements = useStableCallback((event) => {
    return isEventTargetWithin(event, store.select("floatingElement")) || isEventTargetWithin(event, store.select("domReferenceElement"));
  });
  const closeOnReferencePress = useStableCallback((event) => {
    if (!referencePress()) {
      return;
    }
    store.setOpen(false, createChangeEventDetails(reason_parts_exports.triggerPress, event.nativeEvent));
  });
  const closeOnEscapeKeyDown = useStableCallback((event) => {
    if (!open2 || !enabled || !escapeKey2 || event.key !== "Escape") {
      return;
    }
    if (isComposingRef.current) {
      return;
    }
    if (!escapeKeyBubbles && hasBlockingChild("__escapeKeyBubbles")) {
      return;
    }
    const native = isReactEvent(event) ? event.nativeEvent : event;
    const eventDetails = createChangeEventDetails(reason_parts_exports.escapeKey, native);
    store.setOpen(false, eventDetails);
    if (!eventDetails.isCanceled) {
      event.preventDefault();
    }
    if (!escapeKeyBubbles && !eventDetails.isPropagationAllowed) {
      event.stopPropagation();
    }
  });
  const markInsideReactTree = useStableCallback(() => {
    dataRef.current.insideReactTree = true;
    clearInsideReactTreeTimeout.start(0, clearInsideReactTree);
  });
  const markPressStartedInsideReactTree = useStableCallback((event) => {
    if (!open2 || !enabled || event.button !== 0) {
      return;
    }
    const target = getTarget(event.nativeEvent);
    if (!contains(store.select("floatingElement"), target)) {
      return;
    }
    if (!pressStartedInsideRef.current) {
      pressStartedInsideRef.current = true;
      pressStartPreventedRef.current = false;
    }
  });
  const markInsidePressStartPrevented = useStableCallback((event) => {
    if (!open2 || !enabled) {
      return;
    }
    if (!(event.defaultPrevented || event.nativeEvent.defaultPrevented)) {
      return;
    }
    if (pressStartedInsideRef.current) {
      pressStartPreventedRef.current = true;
    }
  });
  React32.useEffect(() => {
    function handleOpenChange(details) {
      if (!details.open) {
        sawPressWhileOpenRef.current = false;
      }
    }
    events.on("openchange", handleOpenChange);
    return () => {
      events.off("openchange", handleOpenChange);
    };
  }, [events]);
  React32.useEffect(() => {
    if (!open2 || !enabled) {
      if (!open2) {
        sawPressWhileOpenRef.current = false;
      }
      return clearInsideReactTree;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    const compositionTimeout = new Timeout();
    const preventedPressSuppressionTimeout = new Timeout();
    const doc = ownerDocument(floatingElement);
    function handleCompositionStart() {
      compositionTimeout.clear();
      isComposingRef.current = true;
    }
    function handleCompositionEnd() {
      compositionTimeout.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        parts_exports.engine.webkit ? 5 : 0,
        () => {
          isComposingRef.current = false;
        }
      );
    }
    function suppressImmediateOutsideClickAfterPreventedStart() {
      suppressNextOutsideClickRef.current = true;
      preventedPressSuppressionTimeout.start(0, () => {
        suppressNextOutsideClickRef.current = false;
      });
    }
    function resetPressStartState() {
      pressStartedInsideRef.current = false;
      pressStartPreventedRef.current = false;
    }
    function getOutsidePressEvent() {
      const type = currentPointerTypeRef.current;
      const computedType = type === "pen" || !type ? "mouse" : type;
      const outsidePressEventValue = getOutsidePressEventProp();
      const resolved = typeof outsidePressEventValue === "function" ? outsidePressEventValue() : outsidePressEventValue;
      if (typeof resolved === "string") {
        return resolved;
      }
      return resolved[computedType];
    }
    function shouldIgnoreEvent(event) {
      const computedOutsidePressEvent = getOutsidePressEvent();
      return computedOutsidePressEvent === "intentional" && event.type !== "click" || computedOutsidePressEvent === "sloppy" && event.type === "click";
    }
    function isEventWithinFloatingTree(event) {
      const nodeId = dataRef.current.floatingContext?.nodeId;
      const targetIsInsideChildren = tree && getNodeChildren(tree.nodesRef.current, nodeId).some((node) => isEventTargetWithin(event, node.context?.elements.floating));
      return isEventWithinOwnElements(event) || targetIsInsideChildren;
    }
    function closeOnPressOutside(event) {
      if (shouldIgnoreEvent(event)) {
        if (event.type !== "click" && !isEventWithinOwnElements(event)) {
          preventedPressSuppressionTimeout.clear();
          suppressNextOutsideClickRef.current = false;
        }
        clearInsideReactTree();
        return;
      }
      if (dataRef.current.insideReactTree) {
        clearInsideReactTree();
        return;
      }
      const target = getTarget(event);
      const inertSelector = `[${createAttribute("inert")}]`;
      const targetRoot = isElement(target) ? target.getRootNode() : null;
      const markers = Array.from((isShadowRoot(targetRoot) ? targetRoot : ownerDocument(store.select("floatingElement"))).querySelectorAll(inertSelector));
      const triggers = store.context.triggerElements;
      if (target && (triggers.hasElement(target) || triggers.hasMatchingElement((trigger) => contains(trigger, target)))) {
        return;
      }
      let targetRootAncestor = isElement(target) ? target : null;
      while (targetRootAncestor && !isLastTraversableNode(targetRootAncestor)) {
        const nextParent = getParentNode(targetRootAncestor);
        if (isLastTraversableNode(nextParent) || !isElement(nextParent)) {
          break;
        }
        targetRootAncestor = nextParent;
      }
      if (markers.length && isElement(target) && !isRootElement(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !contains(target, store.select("floatingElement")) && // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      markers.every((marker) => !contains(targetRootAncestor, marker))) {
        return;
      }
      if (isHTMLElement(target) && !("touches" in event)) {
        const lastTraversableNode = isLastTraversableNode(target);
        const style = getComputedStyle2(target);
        const scrollRe = /auto|scroll/;
        const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
        const isScrollableY2 = lastTraversableNode || scrollRe.test(style.overflowY);
        const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
        const canScrollY = isScrollableY2 && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
        const isRTL2 = style.direction === "rtl";
        const pressedVerticalScrollbar = canScrollY && (isRTL2 ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
        const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
        if (pressedVerticalScrollbar || pressedHorizontalScrollbar) {
          return;
        }
      }
      if (isEventWithinFloatingTree(event)) {
        return;
      }
      if (getOutsidePressEvent() === "intentional") {
        if (event.detail !== 0 && !isVirtualClick(event) && !sawPressWhileOpenRef.current) {
          return;
        }
        if (suppressNextOutsideClickRef.current) {
          preventedPressSuppressionTimeout.clear();
          suppressNextOutsideClickRef.current = false;
          return;
        }
      }
      if (typeof outsidePress2 === "function" && !outsidePress2(event)) {
        return;
      }
      if (hasBlockingChild("__outsidePressBubbles")) {
        return;
      }
      store.setOpen(false, createChangeEventDetails(reason_parts_exports.outsidePress, event));
      clearInsideReactTree();
    }
    function handlePointerDown(event) {
      if (getOutsidePressEvent() !== "sloppy" || event.pointerType === "touch" || !store.select("open") || !enabled || isEventWithinOwnElements(event)) {
        return;
      }
      closeOnPressOutside(event);
    }
    function handleTouchStart(event) {
      if (getOutsidePressEvent() !== "sloppy" || !store.select("open") || !enabled || isEventWithinOwnElements(event)) {
        return;
      }
      const touch = event.touches[0];
      if (touch) {
        touchStateRef.current = {
          startTime: Date.now(),
          startX: touch.clientX,
          startY: touch.clientY,
          dismissOnTouchEnd: false,
          dismissOnMouseDown: true
        };
        cancelDismissOnEndTimeout.start(1e3, () => {
          if (touchStateRef.current) {
            touchStateRef.current.dismissOnTouchEnd = false;
            touchStateRef.current.dismissOnMouseDown = false;
          }
        });
      }
    }
    function addTargetEventListenerOnce(event, listener) {
      const target = getTarget(event);
      if (!target) {
        return;
      }
      const unsubscribe2 = addEventListener(target, event.type, () => {
        listener(event);
        unsubscribe2();
      });
    }
    function handleTouchStartCapture(event) {
      currentPointerTypeRef.current = "touch";
      addTargetEventListenerOnce(event, handleTouchStart);
    }
    function closeOnPressOutsideCapture(event) {
      cancelDismissOnEndTimeout.clear();
      if (event.type === "pointerdown") {
        if (event.button === 0) {
          sawPressWhileOpenRef.current = true;
        }
        currentPointerTypeRef.current = event.pointerType;
      }
      if (event.type === "mousedown" && touchStateRef.current && !touchStateRef.current.dismissOnMouseDown) {
        return;
      }
      addTargetEventListenerOnce(event, (targetEvent) => {
        if (targetEvent.type === "pointerdown") {
          handlePointerDown(targetEvent);
        } else {
          closeOnPressOutside(targetEvent);
        }
      });
    }
    function handlePressEndCapture(event) {
      if (event.type === "pointercancel") {
        sawPressWhileOpenRef.current = false;
      }
      if (!pressStartedInsideRef.current) {
        return;
      }
      const pressStartedInsideDefaultPrevented = pressStartPreventedRef.current;
      resetPressStartState();
      if (getOutsidePressEvent() !== "intentional") {
        return;
      }
      if (event.type === "pointercancel") {
        if (pressStartedInsideDefaultPrevented) {
          suppressImmediateOutsideClickAfterPreventedStart();
        }
        return;
      }
      if (isEventWithinFloatingTree(event)) {
        return;
      }
      if (pressStartedInsideDefaultPrevented) {
        suppressImmediateOutsideClickAfterPreventedStart();
        return;
      }
      if (typeof outsidePress2 === "function" && !outsidePress2(event)) {
        return;
      }
      preventedPressSuppressionTimeout.clear();
      suppressNextOutsideClickRef.current = true;
      clearInsideReactTree();
    }
    function handleTouchMove(event) {
      if (getOutsidePressEvent() !== "sloppy" || !touchStateRef.current || isEventWithinOwnElements(event)) {
        return;
      }
      const touch = event.touches[0];
      if (!touch) {
        return;
      }
      const deltaX = Math.abs(touch.clientX - touchStateRef.current.startX);
      const deltaY = Math.abs(touch.clientY - touchStateRef.current.startY);
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
      if (distance > 5) {
        touchStateRef.current.dismissOnTouchEnd = true;
      }
      if (distance > 10) {
        closeOnPressOutside(event);
        cancelDismissOnEndTimeout.clear();
        touchStateRef.current = null;
      }
    }
    function handleTouchMoveCapture(event) {
      addTargetEventListenerOnce(event, handleTouchMove);
    }
    function handleTouchEnd(event) {
      if (getOutsidePressEvent() !== "sloppy" || !touchStateRef.current || isEventWithinOwnElements(event)) {
        return;
      }
      if (touchStateRef.current.dismissOnTouchEnd) {
        closeOnPressOutside(event);
      }
      cancelDismissOnEndTimeout.clear();
      touchStateRef.current = null;
    }
    function handleTouchEndCapture(event) {
      addTargetEventListenerOnce(event, handleTouchEnd);
    }
    const unsubscribe = mergeCleanups(escapeKey2 && mergeCleanups(addEventListener(doc, "keydown", closeOnEscapeKeyDown), addEventListener(doc, "compositionstart", handleCompositionStart), addEventListener(doc, "compositionend", handleCompositionEnd)), outsidePressEnabled && mergeCleanups(addEventListener(doc, "click", closeOnPressOutsideCapture, true), addEventListener(doc, "pointerdown", closeOnPressOutsideCapture, true), addEventListener(doc, "pointerup", handlePressEndCapture, true), addEventListener(doc, "pointercancel", handlePressEndCapture, true), addEventListener(doc, "mousedown", closeOnPressOutsideCapture, true), addEventListener(doc, "mouseup", handlePressEndCapture, true), addEventListener(doc, "touchstart", handleTouchStartCapture, {
      capture: true,
      passive: true
    }), addEventListener(doc, "touchmove", handleTouchMoveCapture, {
      capture: true,
      passive: true
    }), addEventListener(doc, "touchend", handleTouchEndCapture, {
      capture: true,
      passive: true
    })));
    return () => {
      unsubscribe();
      compositionTimeout.clear();
      preventedPressSuppressionTimeout.clear();
      resetPressStartState();
      suppressNextOutsideClickRef.current = false;
      clearInsideReactTree();
    };
  }, [dataRef, floatingElement, escapeKey2, outsidePressEnabled, outsidePress2, open2, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, clearInsideReactTree, getOutsidePressEventProp, hasBlockingChild, isEventWithinOwnElements, tree, store, cancelDismissOnEndTimeout]);
  const reference = React32.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    onPointerDown: closeOnReferencePress,
    onClick: closeOnReferencePress
  }), [closeOnEscapeKeyDown, closeOnReferencePress]);
  const floating = React32.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: markInsidePressStartPrevented,
    onMouseDown: markInsidePressStartPrevented,
    onClickCapture: markInsideReactTree,
    onMouseDownCapture(event) {
      markInsideReactTree();
      markPressStartedInsideReactTree(event);
    },
    onPointerDownCapture(event) {
      markInsideReactTree();
      markPressStartedInsideReactTree(event);
    },
    onMouseUpCapture: markInsideReactTree,
    onTouchEndCapture: markInsideReactTree,
    onTouchMoveCapture: markInsideReactTree
  }), [closeOnEscapeKeyDown, markInsideReactTree, markPressStartedInsideReactTree, markInsidePressStartPrevented]);
  return React32.useMemo(() => enabled ? {
    reference,
    floating,
    trigger: reference
  } : {}, [enabled, reference, floating]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/hooks/useFloating.mjs
import * as React37 from "react";

// ../../node_modules/.pnpm/@floating-ui+core@1.8.0/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  const alignment = getAlignment(placement);
  if (alignment) {
    coords[alignmentAxis] += commonAlign * (alignment === "end" ? 1 : -1) * (rtl && isVertical ? -1 : 1);
  }
  return coords;
}
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform3,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element2 = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform3.getClippingRect({
    element: ((_await$platform$isEle = await (platform3.isElement == null ? void 0 : platform3.isElement(element2))) != null ? _await$platform$isEle : true) ? element2 : element2.contextElement || await (platform3.getDocumentElement == null ? void 0 : platform3.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform3.getOffsetParent == null ? void 0 : platform3.getOffsetParent(elements.floating));
  const offsetScale = await (platform3.isElement == null ? void 0 : platform3.isElement(offsetParent)) && await (platform3.getScale == null ? void 0 : platform3.getScale(offsetParent)) || {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform3.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform3.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
var MAX_RESET_COUNT = 50;
var computePosition = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform3
  } = config;
  const platformWithDetectOverflow = platform3.detectOverflow ? platform3 : {
    ...platform3,
    detectOverflow
  };
  const rtl = await (platform3.isRTL == null ? void 0 : platform3.isRTL(floating));
  let rects = await platform3.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let resetCount = 0;
  const middlewareData = {};
  for (let i = 0; i < middleware.length; i++) {
    const currentMiddleware = middleware[i];
    if (!currentMiddleware) {
      continue;
    }
    const {
      name: name2,
      fn
    } = currentMiddleware;
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platformWithDetectOverflow,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData[name2] = {
      ...middlewareData[name2],
      ...data
    };
    if (reset && resetCount < MAX_RESET_COUNT) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform3.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
var flip2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform3,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform3.isRTL == null ? void 0 : platform3.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await platform3.detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d) => getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
var originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform3,
    elements
  } = state;
  const rtl = await (platform3.isRTL == null ? void 0 : platform3.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
var offset2 = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
var shift2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x,
        y,
        placement,
        platform: platform3
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await platform3.detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const clampCoord = (axis, coord) => clamp2(coord + overflow[axis === "y" ? "top" : "left"], coord, coord - overflow[axis === "y" ? "bottom" : "right"]);
      if (checkMainAxis) {
        mainAxisCoord = clampCoord(mainAxis, mainAxisCoord);
      }
      if (checkCrossAxis) {
        crossAxisCoord = clampCoord(crossAxis, crossAxisCoord);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
var limitShift2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      var _rawOffset$mainAxis, _rawOffset$crossAxis;
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset5 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset5, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: (_rawOffset$mainAxis = rawOffset.mainAxis) != null ? _rawOffset$mainAxis : 0,
        crossAxis: (_rawOffset$crossAxis = rawOffset.crossAxis) != null ? _rawOffset$crossAxis : 0
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = originSides.has(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
var size2 = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      const {
        placement,
        rects,
        platform: platform3,
        elements
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await platform3.detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform3.isRTL == null ? void 0 : platform3.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const shiftData = state.middlewareData.shift;
      const noShift = !shiftData;
      let availableHeight2 = overflowAvailableHeight;
      let availableWidth2 = overflowAvailableWidth;
      if (shiftData != null && shiftData.enabled.x) {
        availableWidth2 = maximumClippingWidth;
      }
      if (shiftData != null && shiftData.enabled.y) {
        availableHeight2 = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        if (isYAxis) {
          availableWidth2 = width - 2 * max(overflow.left, overflow.right);
        } else {
          availableHeight2 = height - 2 * max(overflow.top, overflow.bottom);
        }
      }
      await apply({
        ...state,
        availableWidth: availableWidth2,
        availableHeight: availableHeight2
      });
      const nextDimensions = await platform3.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

// ../../node_modules/.pnpm/@floating-ui+dom@1.8.0/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element2) {
  const css = getComputedStyle2(element2);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element2);
  const offsetWidth = hasOffset ? element2.offsetWidth : width;
  const offsetHeight = hasOffset ? element2.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element2) {
  return !isElement(element2) ? element2.contextElement : element2;
}
function getScale(element2) {
  const domElement = unwrapElement(element2);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element2) {
  const win = getWindow(element2);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element2, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  return !!floatingOffsetParent && isFixed && floatingOffsetParent === getWindow(element2);
}
function getBoundingClientRect(element2, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element2.getBoundingClientRect();
  const domElement = unwrapElement(element2);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element2);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement && offsetParent) {
    const win = getWindow(domElement);
    const offsetWin = isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function getWindowScrollBarX(element2, rect) {
  const leftScroll = getNodeScroll(element2).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element2)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element2) {
  return element2.getClientRects ? Array.from(element2.getClientRects()) : [];
}
function getDocumentRect(html4) {
  const scroll = getNodeScroll(html4);
  const body = html4.ownerDocument.body;
  const width = max(html4.scrollWidth, html4.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html4.scrollHeight, html4.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(html4);
  const y = -scroll.scrollTop;
  if (getComputedStyle2(body).direction === "rtl") {
    x += max(html4.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
var SCROLLBAR_MAX = 25;
function getViewportRect(element2, strategy, rootBoundary) {
  if (rootBoundary === void 0) {
    rootBoundary = "viewport";
  }
  const isLayoutViewport = rootBoundary === "layoutViewport";
  const win = getWindow(element2);
  const html4 = getDocumentElement(element2);
  const visualViewport = win.visualViewport;
  let width = html4.clientWidth;
  let height = html4.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    const layoutRelativeClientCoords = !isWebKit() || strategy === "fixed";
    if (isLayoutViewport) {
      if (!layoutRelativeClientCoords) {
        x = -visualViewport.offsetLeft;
        y = -visualViewport.offsetTop;
      }
    } else {
      width = visualViewport.width;
      height = visualViewport.height;
      if (layoutRelativeClientCoords) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html4);
  if (windowScrollbarX <= 0) {
    const doc = html4.ownerDocument;
    const body = doc.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const reservedWidth = Math.abs(html4.clientWidth - body.clientWidth - bodyMarginInline);
    const gutter = getComputedStyle(html4).scrollbarGutter === "stable both-edges" ? reservedWidth / 2 : reservedWidth;
    if (gutter <= SCROLLBAR_MAX) {
      width -= gutter;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element2, strategy) {
  const clientRect = getBoundingClientRect(element2, true, strategy === "fixed");
  const top = clientRect.top + element2.clientTop;
  const left = clientRect.left + element2.clientLeft;
  const scale = getScale(element2);
  const width = element2.clientWidth * scale.x;
  const height = element2.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element2, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport" || clippingAncestor === "layoutViewport") {
    rect = getViewportRect(element2, strategy, clippingAncestor);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element2));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element2);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function getClippingElementAncestors(element2, cache2) {
  const cachedResult = cache2.get(element2);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element2, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let lastKeptComputedStyle = null;
  const elementIsFixed = getComputedStyle2(element2).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element2) : element2;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    const lastPosition = lastKeptComputedStyle ? lastKeptComputedStyle.position : elementIsFixed ? "fixed" : "";
    const shouldDropCurrentNode = !currentNodeIsContaining && (lastPosition === "fixed" || lastPosition === "absolute" && computedStyle.position === "static");
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      lastKeptComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache2.set(element2, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element: element2,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element2) ? [] : getClippingElementAncestors(element2, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstRect = getClientRectFromClippingAncestor(element2, clippingAncestors[0], strategy);
  let top = firstRect.top;
  let right = firstRect.right;
  let bottom = firstRect.bottom;
  let left = firstRect.left;
  for (let i = 1; i < clippingAncestors.length; i++) {
    const rect = getClientRectFromClippingAncestor(element2, clippingAncestors[i], strategy);
    top = max(rect.top, top);
    right = min(rect.right, right);
    bottom = min(rect.bottom, bottom);
    left = max(rect.left, left);
  }
  return {
    width: right - left,
    height: bottom - top,
    x: left,
    y: top
  };
}
function getDimensions(element2) {
  const {
    width,
    height
  } = getCssDimensions(element2);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element2, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element2, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  if (!isOffsetParentAnElement && documentElement) {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element2) {
  return getComputedStyle2(element2).position === "static";
}
function getTrueOffsetParent(element2, polyfill) {
  if (!isHTMLElement(element2) || getComputedStyle2(element2).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element2);
  }
  let rawOffsetParent = element2.offsetParent;
  if (getDocumentElement(element2) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element2, polyfill) {
  const win = getWindow(element2);
  if (isTopLayer(element2)) {
    return win;
  }
  if (!isHTMLElement(element2)) {
    let svgOffsetParent = getParentNode(element2);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element2, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element2) || win;
}
var getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element2) {
  return getComputedStyle2(element2).direction === "rtl";
}
var platform2 = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element2, onMove, ancestorResize) {
  let io = null;
  let timeoutId;
  const root3 = getDocumentElement(element2);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element2.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root3.clientWidth - (left + width));
    const insetBottom = floor(root3.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (!rectsAreEqual(elementRectForRootMargin, element2.getBoundingClientRect())) {
        return refresh();
      }
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root3.ownerDocument
      });
    } catch (_e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element2);
  }
  const win = getWindow(element2);
  const handleResize = () => refresh(ancestorResize);
  win.addEventListener("resize", handleResize);
  refresh(true);
  return () => {
    win.removeEventListener("resize", handleResize);
    cleanup();
  };
}
function autoUpdate2(reference, floating, update2, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...floating ? getOverflowAncestors(floating) : []] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update2);
    ancestorResize && ancestor.addEventListener("resize", update2);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update2, ancestorResize) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update2();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    if (floating) {
      resizeObserver.observe(floating);
    }
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update2();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update2();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update2);
      ancestorResize && ancestor.removeEventListener("resize", update2);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var offset3 = offset2;
var shift3 = shift2;
var flip3 = flip2;
var size3 = size2;
var limitShift3 = limitShift2;
var computePosition2 = (reference, floating, options) => {
  const cache2 = /* @__PURE__ */ new Map();
  const mergedOptions = options != null ? options : {};
  const platformWithCache = {
    ...platform2,
    ...mergedOptions.platform,
    _c: cache2
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

// ../../node_modules/.pnpm/@floating-ui+react-dom@2.1.9_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
import * as React33 from "react";
import { useLayoutEffect as useLayoutEffect4 } from "react";
import * as ReactDOM2 from "react-dom";
var isClient = typeof document !== "undefined";
var noop2 = function noop3() {
};
var index = isClient ? useLayoutEffect4 : noop2;
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys2;
  if (a && b && typeof a === "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys2 = Object.keys(a);
    length = keys2.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys2[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys2[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element2) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element2.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element2, value) {
  const dpr = getDPR(element2);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React33.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating2(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform3,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open: open2
  } = options;
  const [data, setData] = React33.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React33.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React33.useState(null);
  const [_floating, _setFloating] = React33.useState(null);
  const setReference = React33.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React33.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React33.useRef(null);
  const floatingRef = React33.useRef(null);
  const dataRef = React33.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform3);
  const openRef = useLatestRef(open2);
  const update2 = React33.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition2(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM2.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open2 === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open2]);
  const isMountedRef = React33.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update2);
      }
      update2();
    }
  }, [referenceEl, floatingEl, update2, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React33.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React33.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React33.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React33.useMemo(() => ({
    ...data,
    update: update2,
    refs,
    elements,
    floatingStyles
  }), [data, update2, refs, elements, floatingStyles]);
}
var offset4 = (options, deps) => {
  const result = offset3(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
var shift4 = (options, deps) => {
  const result = shift3(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
var limitShift4 = (options, deps) => {
  const result = limitShift3(options);
  return {
    fn: result.fn,
    options: [options, deps]
  };
};
var flip4 = (options, deps) => {
  const result = flip3(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};
var size4 = (options, deps) => {
  const result = size3(options);
  return {
    name: result.name,
    fn: result.fn,
    options: [options, deps]
  };
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/popups/popupStoreUtils.mjs
import * as React36 from "react";
import * as ReactDOM4 from "react-dom";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/components/FloatingRootStore.mjs
var selectors = {
  open: (state) => state.open,
  transitionStatus: (state) => state.transitionStatus,
  domReferenceElement: (state) => state.domReferenceElement,
  referenceElement: (state) => state.positionReference ?? state.referenceElement,
  floatingElement: (state) => state.floatingElement,
  floatingId: (state) => state.floatingId
};
var FloatingRootStore = class extends ReactStore {
  constructor(options) {
    const {
      syncOnly,
      nested,
      onOpenChange,
      triggerElements,
      ...initialState
    } = options;
    super({
      ...initialState,
      positionReference: initialState.referenceElement,
      domReferenceElement: initialState.referenceElement
    }, {
      onOpenChange,
      dataRef: {
        current: {}
      },
      events: createEventEmitter(),
      nested,
      triggerElements
    }, selectors);
    this.syncOnly = syncOnly;
  }
  /**
   * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
   */
  syncOpenEvent = (newOpen, event) => {
    if (!newOpen || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
    // click events to upgrade a hover-open.
    event != null && isClickLikeEvent(event)) {
      this.context.dataRef.current.openEvent = newOpen ? event : void 0;
    }
  };
  /**
   * Runs the root-owned side effects for an open state change.
   */
  dispatchOpenChange = (newOpen, eventDetails) => {
    this.syncOpenEvent(newOpen, eventDetails.event);
    const details = {
      open: newOpen,
      reason: eventDetails.reason,
      nativeEvent: eventDetails.event,
      nested: this.context.nested,
      triggerElement: eventDetails.trigger
    };
    this.context.events.emit("openchange", details);
  };
  /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */
  setOpen = (newOpen, eventDetails) => {
    if (this.syncOnly) {
      this.context.onOpenChange?.(newOpen, eventDetails);
      return;
    }
    this.dispatchOpenChange(newOpen, eventDetails);
    this.context.onOpenChange?.(newOpen, eventDetails);
  };
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useTransitionStatus.mjs
import * as React34 from "react";
function useTransitionStatus(open2, enableIdleState = false, deferEndingState = false, animateInitialOpen = false) {
  const [transitionStatus, setTransitionStatus] = React34.useState(open2 && enableIdleState ? "idle" : void 0);
  const [mounted, setMounted] = React34.useState(open2 && !animateInitialOpen);
  if (open2 && !mounted) {
    setMounted(true);
    setTransitionStatus("starting");
  }
  if (!open2 && mounted && transitionStatus !== "ending" && !deferEndingState) {
    setTransitionStatus("ending");
  }
  if (!open2 && !mounted && transitionStatus === "ending") {
    setTransitionStatus(void 0);
  }
  useIsoLayoutEffect(() => {
    if (!open2 && mounted && transitionStatus !== "ending" && deferEndingState) {
      const frame = AnimationFrame.request(() => {
        setTransitionStatus("ending");
      });
      return () => {
        AnimationFrame.cancel(frame);
      };
    }
    return void 0;
  }, [open2, mounted, transitionStatus, deferEndingState]);
  useIsoLayoutEffect(() => {
    if (!open2 || enableIdleState) {
      return void 0;
    }
    const frame = AnimationFrame.request(() => {
      setTransitionStatus(void 0);
    });
    return () => {
      AnimationFrame.cancel(frame);
    };
  }, [enableIdleState, open2]);
  useIsoLayoutEffect(() => {
    if (!open2 || !enableIdleState) {
      return void 0;
    }
    if (open2 && mounted && transitionStatus !== "idle") {
      setTransitionStatus("starting");
    }
    const frame = AnimationFrame.request(() => {
      setTransitionStatus("idle");
    });
    return () => {
      AnimationFrame.cancel(frame);
    };
  }, [enableIdleState, open2, mounted, transitionStatus]);
  return {
    mounted,
    setMounted,
    transitionStatus
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useOpenChangeComplete.mjs
import * as React35 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useAnimationsFinished.mjs
import * as ReactDOM3 from "react-dom";
var pendingCallbacks = null;
function flushBeforePaint(fn) {
  if (!pendingCallbacks) {
    const callbacks = [];
    pendingCallbacks = callbacks;
    queueMicrotask(() => {
      pendingCallbacks = null;
      ReactDOM3.flushSync(() => {
        for (const callback of callbacks) {
          callback();
        }
      });
    });
  }
  pendingCallbacks.push(fn);
}
function useAnimationsFinished(elementOrRef, waitForStartingStyleRemoved = false, batch = false) {
  const frame = useAnimationFrame();
  return useStableCallback((fnToExecute, signal = null) => {
    frame.cancel();
    const element2 = resolveRef(elementOrRef);
    if (element2 == null) {
      return;
    }
    const resolvedElement = element2;
    const done = () => {
      if (!batch) {
        ReactDOM3.flushSync(fnToExecute);
        return;
      }
      flushBeforePaint(() => {
        if (!signal?.aborted) {
          fnToExecute();
        }
      });
    };
    if (typeof resolvedElement.getAnimations !== "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      fnToExecute();
      return;
    }
    function exec() {
      Promise.all(resolvedElement.getAnimations().map((animation) => animation.finished)).then(() => {
        if (!signal?.aborted) {
          done();
        }
      }, () => {
        if (signal?.aborted) {
          return;
        }
        const currentAnimations = resolvedElement.getAnimations();
        if (currentAnimations.some((animation) => animation.pending || animation.playState !== "finished")) {
          exec();
          return;
        }
        done();
      });
    }
    if (waitForStartingStyleRemoved) {
      const startingStyleAttribute = startingStyle;
      if (!resolvedElement.hasAttribute(startingStyleAttribute)) {
        frame.request(exec);
        return;
      }
      const attributeObserver = new MutationObserver(() => {
        if (!resolvedElement.hasAttribute(startingStyleAttribute)) {
          attributeObserver.disconnect();
          exec();
        }
      });
      attributeObserver.observe(resolvedElement, {
        attributes: true,
        attributeFilter: [startingStyleAttribute]
      });
      signal?.addEventListener("abort", () => attributeObserver.disconnect(), {
        once: true
      });
      return;
    }
    frame.request(exec);
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useOpenChangeComplete.mjs
function useOpenChangeComplete(parameters) {
  const {
    enabled = true,
    open: open2,
    ref,
    batch = false,
    onComplete: onCompleteParam
  } = parameters;
  const onComplete = useStableCallback(onCompleteParam);
  const runOnceAnimationsFinish = useAnimationsFinished(ref, open2, batch);
  React35.useEffect(() => {
    if (!enabled) {
      return void 0;
    }
    const abortController = new AbortController();
    runOnceAnimationsFinish(onComplete, abortController.signal);
    return () => {
      abortController.abort();
    };
  }, [enabled, open2, onComplete, runOnceAnimationsFinish]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/popups/popupStoreUtils.mjs
var FOCUSABLE_POPUP_PROPS = {
  tabIndex: -1,
  [FOCUSABLE_ATTRIBUTE]: ""
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/popups/popupTriggerMap.mjs
var devElementIdsByMap;
function getDevElementIds(map) {
  devElementIdsByMap ??= /* @__PURE__ */ new WeakMap();
  let elementIds = devElementIdsByMap.get(map);
  if (!elementIds) {
    elementIds = /* @__PURE__ */ new WeakMap();
    devElementIdsByMap.set(map, elementIds);
  }
  return elementIds;
}
var PopupTriggerMap = class {
  constructor() {
    this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(id, element2) {
    if (process.env.NODE_ENV !== "production") {
      const elementIds = getDevElementIds(this);
      const existingId = elementIds.get(element2);
      if (existingId !== void 0 && existingId !== id) {
        throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
      }
      const previousElement = this.idMap.get(id);
      if (previousElement !== void 0 && previousElement !== element2) {
        elementIds.delete(previousElement);
      }
      elementIds.set(element2, id);
    }
    this.idMap.set(id, element2);
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(id) {
    if (process.env.NODE_ENV !== "production") {
      const element2 = this.idMap.get(id);
      if (element2 !== void 0) {
        devElementIdsByMap?.get(this)?.delete(element2);
      }
    }
    this.idMap.delete(id);
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(element2) {
    for (const registered of this.idMap.values()) {
      if (registered === element2) {
        return true;
      }
    }
    return false;
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(predicate) {
    for (const element2 of this.idMap.values()) {
      if (predicate(element2)) {
        return true;
      }
    }
    return false;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(id) {
    return this.idMap.get(id);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.idMap.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/hooks/useFloatingRootContext.mjs
function useFloatingRootContext(options) {
  const {
    open: open2 = false,
    onOpenChange,
    elements = {}
  } = options;
  const floatingId = useId4();
  const nested = useFloatingParentNodeId() != null;
  if (process.env.NODE_ENV !== "production") {
    const optionDomReference = elements.reference;
    if (optionDomReference && !isElement(optionDomReference)) {
      console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
    }
  }
  const store = useRefWithInit(() => new FloatingRootStore({
    open: open2,
    transitionStatus: void 0,
    onOpenChange,
    referenceElement: elements.reference ?? null,
    floatingElement: elements.floating ?? null,
    triggerElements: new PopupTriggerMap(),
    floatingId,
    syncOnly: false,
    nested
  })).current;
  useIsoLayoutEffect(() => {
    const valuesToSync = {
      open: open2,
      floatingId
    };
    if (elements.reference !== void 0) {
      valuesToSync.referenceElement = elements.reference;
      valuesToSync.domReferenceElement = isElement(elements.reference) ? elements.reference : null;
    }
    if (elements.floating !== void 0) {
      valuesToSync.floatingElement = elements.floating;
    }
    store.update(valuesToSync);
  }, [open2, floatingId, elements.reference, elements.floating, store]);
  store.context.onOpenChange = onOpenChange;
  store.context.nested = nested;
  return store;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/hooks/useFloating.mjs
function useBaseUIFloating(options) {
  return useFloatingWithStore(options, options.rootContext);
}
function useFloatingWithStore(options, store) {
  const {
    nodeId,
    externalTree
  } = options;
  const referenceElement = store.useState("referenceElement");
  const floatingElement = store.useState("floatingElement");
  const domReferenceElement = store.useState("domReferenceElement");
  const open2 = store.useState("open");
  const floatingId = store.useState("floatingId");
  const [positionReference, setPositionReferenceRaw] = React37.useState(null);
  const [localDomReference, setLocalDomReference] = React37.useState(void 0);
  const [localFloatingElement, setLocalFloatingElement] = React37.useState(void 0);
  const domReferenceRef = React37.useRef(null);
  const tree = useFloatingTree(externalTree);
  const storeElements = React37.useMemo(() => ({
    reference: referenceElement,
    floating: floatingElement,
    domReference: domReferenceElement
  }), [referenceElement, floatingElement, domReferenceElement]);
  const position2 = useFloating2({
    ...options,
    elements: {
      ...storeElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const localDomReferenceElement = isElement(localDomReference) ? localDomReference : null;
  const syncedFloatingElement = localFloatingElement === void 0 ? store.state.floatingElement : localFloatingElement;
  store.useSyncedValue("referenceElement", localDomReference ?? null);
  store.useSyncedValue("domReferenceElement", localDomReference === void 0 ? domReferenceElement : localDomReferenceElement);
  store.useSyncedValue("floatingElement", syncedFloatingElement);
  const setPositionReference = React37.useCallback((node) => {
    const computedPositionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      getClientRects: () => node.getClientRects(),
      contextElement: node
    } : node;
    setPositionReferenceRaw(computedPositionReference);
    position2.refs.setReference(computedPositionReference);
  }, [position2.refs]);
  const setReference = React37.useCallback((node) => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setLocalDomReference(node);
    }
    if (isElement(position2.refs.reference.current) || position2.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position2.refs.setReference(node);
    }
  }, [position2.refs, setLocalDomReference]);
  const setFloating = React37.useCallback((node) => {
    setLocalFloatingElement(node);
    position2.refs.setFloating(node);
  }, [position2.refs]);
  const refs = React37.useMemo(() => ({
    ...position2.refs,
    setReference,
    setFloating,
    setPositionReference,
    domReference: domReferenceRef
  }), [position2.refs, setReference, setFloating, setPositionReference]);
  const elements = React37.useMemo(() => ({
    ...position2.elements,
    domReference: domReferenceElement
  }), [position2.elements, domReferenceElement]);
  const context = React37.useMemo(() => ({
    ...position2,
    dataRef: store.context.dataRef,
    open: open2,
    onOpenChange: store.setOpen,
    events: store.context.events,
    floatingId,
    refs,
    elements,
    nodeId,
    rootStore: store
  }), [position2, refs, elements, nodeId, store, open2, floatingId]);
  useIsoLayoutEffect(() => {
    if (domReferenceElement) {
      domReferenceRef.current = domReferenceElement;
    }
  }, [domReferenceElement]);
  useIsoLayoutEffect(() => {
    store.context.dataRef.current.floatingContext = context;
    const node = tree?.nodesRef.current.find((n) => n.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React37.useMemo(() => ({
    ...position2,
    context,
    refs,
    elements,
    rootStore: store
  }), [position2, refs, elements, context, store]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/hooks/useListNavigation.mjs
import * as React38 from "react";
var ESCAPE = "Escape";
function isStationaryWebKitPointer(event) {
  return parts_exports.engine.webkit && event.movementX === 0 && event.movementY === 0;
}
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case "vertical":
      return vertical;
    case "horizontal":
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl, grid) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  if (orientation === "both" || orientation === "horizontal" && grid) {
    return key === ESCAPE;
  }
  return doSwitch(orientation, vertical, horizontal);
}
function useListNavigation(context, props) {
  const {
    listRef,
    activeIndex,
    onNavigate: onNavigateProp = () => {
    },
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loopFocus = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = "auto",
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = void 0,
    orientation = "vertical",
    parentOrientation,
    id,
    resetOnPointerLeave = true,
    externalTree,
    grid: navigateGrid
  } = props;
  const isGrid = navigateGrid != null;
  if (process.env.NODE_ENV !== "production") {
    if (allowEscape) {
      if (!loopFocus) {
        console.warn("`useListNavigation` looping must be enabled to allow escaping.");
      }
      if (!virtual) {
        console.warn("`useListNavigation` must be virtual to allow escaping.");
      }
    }
    if (orientation === "vertical" && isGrid) {
      console.warn("In grid list navigation mode, the `orientation` should", 'be either "horizontal" or "both".');
    }
  }
  const store = "rootStore" in context ? context.rootStore : context;
  const open2 = store.useState("open");
  const floatingElement = store.useState("floatingElement");
  const domReferenceElement = store.useState("domReferenceElement");
  const dataRef = store.context.dataRef;
  const floatingFocusElement = getFloatingFocusElement(floatingElement);
  const typeableComboboxReference = isTypeableCombobox(domReferenceElement);
  const floatingFocusElementRef = useValueAsRef(floatingFocusElement);
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree(externalTree);
  const focusItemOnOpenRef = React38.useRef(focusItemOnOpen);
  const indexRef = React38.useRef(selectedIndex ?? -1);
  const keyRef = React38.useRef(null);
  const isPointerModalityRef = React38.useRef(true);
  const onNavigate = useStableCallback((event) => {
    onNavigateProp(indexRef.current === -1 ? null : indexRef.current, event);
  });
  const previousMountedRef = React38.useRef(!!floatingElement);
  const previousOpenRef = React38.useRef(open2);
  const forceSyncFocusRef = React38.useRef(false);
  const forceScrollIntoViewRef = React38.useRef(false);
  const cancelQueuedFocusRef = React38.useRef(null);
  const disabledIndicesRef = useValueAsRef(disabledIndices);
  const latestOpenRef = useValueAsRef(open2);
  const selectedIndexRef = useValueAsRef(selectedIndex);
  const resetOnPointerLeaveRef = useValueAsRef(resetOnPointerLeave);
  const focusFrame = useAnimationFrame();
  const waitForListPopulatedFrame = useAnimationFrame();
  const focusItem = useStableCallback(() => {
    function runFocus(item2) {
      if (virtual) {
        tree?.events.emit("virtualfocus", item2);
      } else {
        cancelQueuedFocusRef.current = enqueueFocus(item2, {
          sync: forceSyncFocusRef.current,
          preventScroll: true
        });
      }
    }
    const initialItem = listRef.current[indexRef.current];
    const forceScrollIntoView = forceScrollIntoViewRef.current;
    if (initialItem) {
      runFocus(initialItem);
    }
    const scheduler2 = forceSyncFocusRef.current ? (callback) => callback() : (callback) => focusFrame.request(callback);
    scheduler2(() => {
      const waitedItem = listRef.current[indexRef.current] || initialItem;
      if (!waitedItem) {
        return;
      }
      if (!initialItem) {
        runFocus(waitedItem);
      }
      const shouldScrollIntoView = (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        item && (forceScrollIntoView || !isPointerModalityRef.current)
      );
      if (shouldScrollIntoView) {
        waitedItem.scrollIntoView?.({
          block: "nearest",
          inline: "nearest"
        });
      }
    });
  });
  useIsoLayoutEffect(() => {
    dataRef.current.orientation = orientation;
  }, [dataRef, orientation]);
  useIsoLayoutEffect(() => {
    if (!enabled) {
      return;
    }
    if (open2 && floatingElement) {
      indexRef.current = selectedIndex ?? -1;
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        forceScrollIntoViewRef.current = true;
        onNavigate();
      }
    } else if (previousMountedRef.current) {
      indexRef.current = -1;
      onNavigate();
    }
  }, [enabled, open2, floatingElement, selectedIndex, onNavigate]);
  useIsoLayoutEffect(() => {
    if (!enabled) {
      return;
    }
    if (!open2) {
      forceSyncFocusRef.current = false;
      return;
    }
    if (!floatingElement) {
      return;
    }
    if (activeIndex == null) {
      forceSyncFocusRef.current = false;
      if (selectedIndexRef.current != null) {
        return;
      }
      if (previousMountedRef.current) {
        indexRef.current = -1;
        focusItem();
      }
      if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
        let runs = 0;
        const waitForListPopulated = () => {
          if (listRef.current[0] == null) {
            if (runs < 2) {
              const scheduler2 = runs ? (callback) => waitForListPopulatedFrame.request(callback) : queueMicrotask;
              scheduler2(waitForListPopulated);
            }
            runs += 1;
          } else {
            indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinListIndex(listRef) : getMaxListIndex(listRef);
            keyRef.current = null;
            onNavigate();
          }
        };
        waitForListPopulated();
      }
    } else if (!isIndexOutOfListBounds(listRef.current, activeIndex)) {
      indexRef.current = activeIndex;
      focusItem();
      forceScrollIntoViewRef.current = false;
    }
  }, [enabled, open2, floatingElement, activeIndex, selectedIndexRef, nested, listRef, orientation, rtl, onNavigate, focusItem, waitForListPopulatedFrame]);
  useIsoLayoutEffect(() => {
    if (!enabled || floatingElement || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    const nodes = tree.nodesRef.current;
    const parent = nodes.find((node) => node.id === parentId)?.context?.elements.floating;
    const activeEl = activeElement(ownerDocument(domReferenceElement ?? parent ?? null));
    const treeContainsActiveEl = nodes.some((node) => node.context && contains(node.context.elements.floating, activeEl));
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, floatingElement, domReferenceElement, tree, parentId, virtual]);
  useIsoLayoutEffect(() => {
    previousOpenRef.current = open2;
    previousMountedRef.current = !!floatingElement;
  });
  useIsoLayoutEffect(() => {
    if (!open2) {
      keyRef.current = null;
      focusItemOnOpenRef.current = focusItemOnOpen;
    }
  }, [open2, focusItemOnOpen]);
  const hasActiveIndex = activeIndex != null;
  const syncCurrentTarget = useStableCallback((event) => {
    if (!latestOpenRef.current) {
      return;
    }
    const index2 = listRef.current.indexOf(event.currentTarget);
    if (index2 !== -1 && (indexRef.current !== index2 || activeIndex !== index2)) {
      indexRef.current = index2;
      onNavigate(event);
    }
  });
  const getParentOrientation = useStableCallback(() => {
    return parentOrientation ?? tree?.nodesRef.current.find((node) => node.id === parentId)?.context?.dataRef?.current.orientation;
  });
  const getMinEnabledIndex = useStableCallback(() => {
    return getMinListIndex(listRef, disabledIndicesRef.current);
  });
  const commonOnKeyDown = useStableCallback((event) => {
    isPointerModalityRef.current = false;
    forceSyncFocusRef.current = true;
    if (event.which === 229) {
      return;
    }
    if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) {
      return;
    }
    if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl, isGrid)) {
      if (!isMainOrientationKey(event.key, getParentOrientation())) {
        stopEvent(event);
      }
      store.setOpen(false, createChangeEventDetails(reason_parts_exports.listNavigation, event.nativeEvent));
      if (isHTMLElement(domReferenceElement)) {
        if (virtual) {
          tree?.events.emit("virtualfocus", domReferenceElement);
        } else {
          domReferenceElement.focus();
        }
      }
      return;
    }
    const currentIndex = indexRef.current;
    const minIndex = getMinListIndex(listRef, disabledIndices);
    const maxIndex = getMaxListIndex(listRef, disabledIndices);
    if (!typeableComboboxReference) {
      if (event.key === "Home") {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate(event);
      }
      if (event.key === "End") {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate(event);
      }
    }
    if (navigateGrid != null) {
      const index2 = navigateGrid(event, indexRef.current, listRef, orientation, loopFocus, rtl, disabledIndices, minIndex, maxIndex);
      if (index2 != null) {
        indexRef.current = index2;
        onNavigate(event);
      }
      if (orientation === "both") {
        return;
      }
    }
    if (isMainOrientationKey(event.key, orientation)) {
      stopEvent(event);
      if (open2 && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
        indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
        onNavigate(event);
        return;
      }
      if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
        if (loopFocus) {
          if (currentIndex >= maxIndex) {
            if (allowEscape && currentIndex !== listRef.current.length) {
              indexRef.current = -1;
            } else {
              forceSyncFocusRef.current = false;
              indexRef.current = minIndex;
            }
          } else {
            indexRef.current = findNonDisabledListIndex(listRef.current, {
              startingIndex: currentIndex,
              disabledIndices
            });
          }
        } else {
          indexRef.current = Math.min(maxIndex, findNonDisabledListIndex(listRef.current, {
            startingIndex: currentIndex,
            disabledIndices
          }));
        }
      } else if (loopFocus) {
        if (currentIndex <= minIndex) {
          if (allowEscape && currentIndex !== -1) {
            indexRef.current = listRef.current.length;
          } else {
            forceSyncFocusRef.current = false;
            indexRef.current = maxIndex;
          }
        } else {
          indexRef.current = findNonDisabledListIndex(listRef.current, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          });
        }
      } else {
        indexRef.current = Math.max(minIndex, findNonDisabledListIndex(listRef.current, {
          startingIndex: currentIndex,
          decrement: true,
          disabledIndices
        }));
      }
      if (isIndexOutOfListBounds(listRef.current, indexRef.current)) {
        indexRef.current = -1;
      }
      onNavigate(event);
    }
  });
  const item = React38.useMemo(() => {
    const itemProps = {
      onFocus(event) {
        forceSyncFocusRef.current = true;
        syncCurrentTarget(event);
      },
      onClick: ({
        currentTarget
      }) => currentTarget.focus({
        preventScroll: true
      }),
      // Safari
      onMouseMove(event) {
        if (isStationaryWebKitPointer(event)) {
          return;
        }
        forceSyncFocusRef.current = true;
        forceScrollIntoViewRef.current = false;
        if (focusItemOnHover) {
          syncCurrentTarget(event);
        }
      },
      onPointerLeave(event) {
        if (!latestOpenRef.current || !isPointerModalityRef.current || event.pointerType === "touch") {
          return;
        }
        forceSyncFocusRef.current = true;
        const relatedTarget = event.relatedTarget;
        if (!focusItemOnHover || listRef.current.includes(relatedTarget)) {
          return;
        }
        if (!resetOnPointerLeaveRef.current) {
          return;
        }
        cancelQueuedFocusRef.current?.();
        cancelQueuedFocusRef.current = null;
        indexRef.current = -1;
        onNavigate(event);
        if (!virtual) {
          const floatingFocusEl = floatingFocusElementRef.current;
          const activeEl = activeElement(ownerDocument(floatingFocusEl));
          if (floatingFocusEl && contains(floatingFocusEl, activeEl)) {
            floatingFocusEl.focus({
              preventScroll: true
            });
          }
        }
      }
    };
    return itemProps;
  }, [syncCurrentTarget, latestOpenRef, floatingFocusElementRef, focusItemOnHover, listRef, onNavigate, resetOnPointerLeaveRef, virtual]);
  const ariaActiveDescendantProp = React38.useMemo(() => {
    return virtual && open2 && hasActiveIndex && {
      "aria-activedescendant": `${id}-${activeIndex}`
    };
  }, [virtual, open2, hasActiveIndex, id, activeIndex]);
  const floating = React38.useMemo(() => {
    return {
      ...!typeableComboboxReference ? ariaActiveDescendantProp : {},
      onKeyDown(event) {
        if (event.key === "Tab" && event.shiftKey && open2 && !virtual) {
          const target = getTarget(event.nativeEvent);
          if (target && !contains(floatingFocusElementRef.current, target)) {
            return;
          }
          stopEvent(event);
          store.setOpen(false, createChangeEventDetails(reason_parts_exports.focusOut, event.nativeEvent));
          if (isHTMLElement(domReferenceElement)) {
            domReferenceElement.focus();
          }
          return;
        }
        commonOnKeyDown(event);
      },
      onPointerMove(event) {
        if (isStationaryWebKitPointer(event)) {
          return;
        }
        isPointerModalityRef.current = true;
      }
    };
  }, [ariaActiveDescendantProp, commonOnKeyDown, floatingFocusElementRef, typeableComboboxReference, store, open2, virtual, domReferenceElement]);
  const trigger = React38.useMemo(() => {
    function openOnNavigationKeyDown(event) {
      store.setOpen(true, createChangeEventDetails(reason_parts_exports.listNavigation, event.nativeEvent, event.currentTarget));
    }
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === "auto" && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = !virtual;
      }
    }
    function checkVirtualPointer(event) {
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === "auto" && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    return {
      onKeyDown(event) {
        const currentOpen = store.select("open");
        isPointerModalityRef.current = false;
        const isArrowKey = event.key.startsWith("Arrow");
        const isParentCrossOpenKey = isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
        const isMainKey = isMainOrientationKey(event.key, orientation);
        const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
        if (virtual && currentOpen) {
          return commonOnKeyDown(event);
        }
        if (!currentOpen && !openOnArrowKeyDown && isArrowKey) {
          return void 0;
        }
        if (isNavigationKey) {
          const isParentMainKey = isMainOrientationKey(event.key, getParentOrientation());
          keyRef.current = nested && isParentMainKey ? null : event.key;
        }
        if (nested) {
          if (isParentCrossOpenKey) {
            stopEvent(event);
            if (currentOpen) {
              indexRef.current = getMinEnabledIndex();
              onNavigate(event);
            } else {
              openOnNavigationKeyDown(event);
            }
          }
          return void 0;
        }
        if (isMainKey) {
          if (selectedIndexRef.current != null) {
            indexRef.current = selectedIndexRef.current;
          }
          stopEvent(event);
          if (!currentOpen && openOnArrowKeyDown) {
            openOnNavigationKeyDown(event);
          } else {
            commonOnKeyDown(event);
          }
          if (currentOpen) {
            onNavigate(event);
          }
        }
        return void 0;
      },
      onFocus(event) {
        if (store.select("open") && !virtual) {
          indexRef.current = -1;
          onNavigate(event);
        }
      },
      onPointerDown: checkVirtualPointer,
      onPointerEnter: checkVirtualPointer,
      onMouseDown: checkVirtualMouse,
      onClick: checkVirtualMouse
    };
  }, [commonOnKeyDown, focusItemOnOpen, getMinEnabledIndex, nested, onNavigate, store, openOnArrowKeyDown, orientation, getParentOrientation, rtl, selectedIndexRef, virtual]);
  const reference = React38.useMemo(() => {
    return {
      ...ariaActiveDescendantProp,
      ...trigger
    };
  }, [ariaActiveDescendantProp, trigger]);
  return React38.useMemo(() => enabled ? {
    reference,
    floating,
    item,
    trigger
  } : {}, [enabled, reference, floating, trigger, item]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/hooks/useTypeahead.mjs
import * as React39 from "react";
function useTypeahead(context, props) {
  const {
    listRef,
    elementsRef,
    activeIndex,
    onMatch: onMatchProp,
    disabledIndices,
    onTyping,
    enabled = true,
    resetMs = 750,
    selectedIndex = null
  } = props;
  const store = "rootStore" in context ? context.rootStore : context;
  const open2 = store.useState("open");
  const timeout = useTimeout();
  const stringRef = React39.useRef("");
  const prevIndexRef = React39.useRef(selectedIndex ?? activeIndex ?? -1);
  const matchIndexRef = React39.useRef(null);
  const onKeyDown = useStableCallback((event) => {
    function getElement(index3) {
      return elementsRef?.current[index3];
    }
    function isItemAvailable(index3) {
      const element2 = getElement(index3);
      if (element2 && !isElementVisible(element2) || element2?.matches(":disabled")) {
        return false;
      }
      return disabledIndices == null || !isListIndexDisabled(EMPTY_ARRAY, index3, disabledIndices);
    }
    function getMatchingIndex(list2, string, startIndex2 = 0) {
      if (list2.length === 0) {
        return -1;
      }
      const normalizedStartIndex = (startIndex2 % list2.length + list2.length) % list2.length;
      const lowerString = string.toLowerCase();
      for (let offset5 = 0; offset5 < list2.length; offset5 += 1) {
        const index3 = (normalizedStartIndex + offset5) % list2.length;
        const text4 = list2[index3];
        if (!text4?.toLowerCase().startsWith(lowerString) || !isItemAvailable(index3)) {
          continue;
        }
        return index3;
      }
      return -1;
    }
    const listContent = listRef.current;
    if (stringRef.current.length > 0 && event.key === " ") {
      stopEvent(event);
      onTyping?.(true);
    }
    if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
      if (getMatchingIndex(listContent, stringRef.current) === -1 && event.key !== " ") {
        onTyping?.(false);
      }
    }
    if (listContent == null || // Character key.
    event.key.length !== 1 || // Modifier key.
    event.ctrlKey || event.metaKey || event.altKey) {
      return;
    }
    if (open2 && event.key !== " ") {
      stopEvent(event);
      onTyping?.(true);
    }
    const isNewSession = stringRef.current === "";
    if (isNewSession) {
      prevIndexRef.current = selectedIndex ?? activeIndex ?? -1;
    }
    const allowRapidSuccessionOfFirstLetter = listContent.every((text4, index3) => text4 && isItemAvailable(index3) ? text4[0]?.toLowerCase() !== text4[1]?.toLowerCase() : true);
    if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
      stringRef.current = "";
      prevIndexRef.current = matchIndexRef.current;
    }
    stringRef.current += event.key;
    timeout.start(resetMs, () => {
      stringRef.current = "";
      prevIndexRef.current = matchIndexRef.current;
      onTyping?.(false);
    });
    const prevIndex = isNewSession ? selectedIndex ?? activeIndex ?? -1 : prevIndexRef.current;
    const startIndex = (prevIndex ?? 0) + 1;
    const index2 = getMatchingIndex(listContent, stringRef.current, startIndex);
    if (index2 !== -1) {
      onMatchProp?.(index2);
      matchIndexRef.current = index2;
    } else if (event.key !== " ") {
      stringRef.current = "";
      onTyping?.(false);
    }
  });
  const onBlur = useStableCallback((event) => {
    const next = event.relatedTarget;
    const currentDomReferenceElement = store.select("domReferenceElement");
    const currentFloatingElement = store.select("floatingElement");
    const withinComposite = contains(currentDomReferenceElement, next) || contains(currentFloatingElement, next);
    if (withinComposite) {
      return;
    }
    timeout.clear();
    stringRef.current = "";
    prevIndexRef.current = matchIndexRef.current;
    onTyping?.(false);
  });
  useIsoLayoutEffect(() => {
    if (!open2 && selectedIndex !== null) {
      return;
    }
    timeout.clear();
    matchIndexRef.current = null;
    if (stringRef.current !== "") {
      stringRef.current = "";
    }
  }, [open2, selectedIndex, timeout]);
  const sharedProps = React39.useMemo(() => ({
    onKeyDown,
    onBlur
  }), [onKeyDown, onBlur]);
  return React39.useMemo(() => enabled ? {
    reference: sharedProps,
    floating: sharedProps
  } : {}, [enabled, sharedProps]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/hooks/gridNavigation.mjs
function gridNavigation(event, prevIndex, listRef, orientation, loopFocus, rtl, disabledIndices, minIndex, maxIndex, cols = 2) {
  const nextIndex = getGridNavigatedIndex(listRef.current, {
    event,
    orientation,
    loopFocus,
    rtl,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    // An out-of-range previous index falls back to the first enabled item.
    prevIndex: prevIndex > maxIndex ? minIndex : prevIndex,
    stopEvent: true
  });
  return isIndexOutOfListBounds(listRef.current, nextIndex) ? void 0 : nextIndex;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/ComboboxRootContext.mjs
import * as React40 from "react";
var ComboboxRootContext = /* @__PURE__ */ React40.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxRootContext.displayName = "ComboboxRootContext";
var ComboboxFloatingContext = /* @__PURE__ */ React40.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxFloatingContext.displayName = "ComboboxFloatingContext";
var ComboboxDerivedItemsContext = /* @__PURE__ */ React40.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxDerivedItemsContext.displayName = "ComboboxDerivedItemsContext";
var ComboboxHasItemsContext = /* @__PURE__ */ React40.createContext(false);
if (process.env.NODE_ENV !== "production") ComboboxHasItemsContext.displayName = "ComboboxHasItemsContext";
var ComboboxInputValueContext = /* @__PURE__ */ React40.createContext("");
if (process.env.NODE_ENV !== "production") ComboboxInputValueContext.displayName = "ComboboxInputValueContext";
function useComboboxRootContext() {
  const context = React40.useContext(ComboboxRootContext);
  if (!context) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxRootContext is missing. Combobox parts must be placed within <Combobox.Root>." : formatErrorMessage_default(22));
  }
  return context;
}
function useComboboxFloatingContext() {
  const context = React40.useContext(ComboboxFloatingContext);
  if (!context) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxFloatingContext is missing. Combobox parts must be placed within <Combobox.Root>." : formatErrorMessage_default(23));
  }
  return context;
}
function useComboboxDerivedItemsContext() {
  const context = React40.useContext(ComboboxDerivedItemsContext);
  if (!context) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemsContext is missing. Combobox parts must be placed within <Combobox.Root>." : formatErrorMessage_default(24));
  }
  return context;
}
function useComboboxInputValueContext() {
  return React40.useContext(ComboboxInputValueContext);
}
function useComboboxHasItemsContext() {
  return React40.useContext(ComboboxHasItemsContext);
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/areArraysEqual.mjs
function areArraysEqual(array1, array2, itemComparer = Object.is) {
  const {
    length
  } = array1;
  if (length !== array2.length) {
    return false;
  }
  for (let i = 0; i < length; i += 1) {
    if (!itemComparer(array1[i], array2[i])) {
      return false;
    }
  }
  return true;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/itemEquality.mjs
var defaultItemEquality = (itemValue, selectedValue) => Object.is(itemValue, selectedValue);
function compareItemEquality(itemValue, selectedValue, comparer) {
  if (itemValue == null || selectedValue == null) {
    return Object.is(itemValue, selectedValue);
  }
  return comparer(itemValue, selectedValue);
}
function isSelectedValueDirty(currentValue, initialValue, comparer) {
  if (Array.isArray(currentValue) && Array.isArray(initialValue)) {
    return !areArraysEqual(currentValue, initialValue, (itemValue, initialItemValue) => compareItemEquality(itemValue, initialItemValue, comparer));
  }
  return currentValue !== initialValue;
}
function selectedValueIncludes(selectedValues, itemValue, comparer) {
  if (!selectedValues) {
    return false;
  }
  return selectedValues.some((selectedValue) => {
    if (selectedValue === void 0) {
      return false;
    }
    return compareItemEquality(itemValue, selectedValue, comparer);
  });
}
function findItemIndex(itemValues, selectedValue, comparer) {
  if (!itemValues) {
    return -1;
  }
  return itemValues.findIndex((itemValue) => {
    if (itemValue === void 0) {
      return false;
    }
    return compareItemEquality(itemValue, selectedValue, comparer);
  });
}
function createSelectionMatcher(selectedValues, comparer) {
  if (comparer !== defaultItemEquality) {
    return (itemValue) => selectedValueIncludes(selectedValues, itemValue, comparer);
  }
  const index2 = new Set(selectedValues);
  index2.delete(void 0);
  return (itemValue) => index2.has(itemValue) && (itemValue !== 0 || selectedValues.some((v) => Object.is(itemValue, v)));
}
function findSelectionIndex(itemValues, selectedValue, comparer, multiple) {
  const index2 = multiple && Array.isArray(selectedValue) ? (
    // Anchor to the first selected item in rendered order so the index does not depend
    // on the order in which the values were added to the array.
    itemValues.findIndex(createSelectionMatcher(selectedValue, comparer))
  ) : findItemIndex(itemValues, selectedValue, comparer);
  return index2 === -1 ? null : index2;
}
function resolveSelectedIndex(index2, itemValue, registry, selectedValues, comparer, currentIndex) {
  if (selectedValueIncludes(selectedValues, itemValue, comparer)) {
    return currentIndex != null && index2 > currentIndex && selectedValueIncludes(selectedValues, registry[currentIndex], comparer) ? currentIndex : index2;
  }
  return index2 === currentIndex ? findSelectionIndex(registry, selectedValues, comparer, true) : currentIndex;
}
function removeItem(selectedValues, itemValue, comparer) {
  return selectedValues.filter((selectedValue) => !compareItemEquality(itemValue, selectedValue, comparer));
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/resolveValueLabel.mjs
import * as React41 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/serializeValue.mjs
function serializeValue(value) {
  if (value == null) {
    return "";
  }
  if (typeof value === "string") {
    return value;
  }
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/resolveValueLabel.mjs
import { jsx as _jsx5 } from "react/jsx-runtime";
function isGroup(item) {
  return typeof item === "object" && item != null && Array.isArray(item.items);
}
function isGroupedItems(items) {
  return isGroup(items?.[0]);
}
function flattenLeafItems(items) {
  return isGroupedItems(items) ? items.flatMap((group) => group.items) : items;
}
function hasNullItemLabel(items) {
  if (!Array.isArray(items)) {
    return items != null && "null" in items;
  }
  const arrayItems = items;
  if (isGroupedItems(arrayItems)) {
    for (const group of arrayItems) {
      for (const item of group.items) {
        if (item && item.value == null && item.label != null) {
          return true;
        }
      }
    }
    return false;
  }
  for (const item of arrayItems) {
    if (item && item.value == null && item.label != null) {
      return true;
    }
  }
  return false;
}
function stringifyAsLabel(item, itemToStringLabel) {
  if (itemToStringLabel && item != null) {
    return itemToStringLabel(item) ?? "";
  }
  if (item && typeof item === "object") {
    if ("label" in item && item.label != null) {
      return String(item.label);
    }
    if ("value" in item) {
      return String(item.value);
    }
  }
  return serializeValue(item);
}
function stringifyAsValue(item, itemToStringValue) {
  if (itemToStringValue && item != null) {
    return itemToStringValue(item) ?? "";
  }
  if (item && typeof item === "object" && "value" in item && "label" in item) {
    return serializeValue(item.value);
  }
  return serializeValue(item);
}
function resolveSelectedLabel(value, items, itemToStringLabel) {
  function fallback() {
    return stringifyAsLabel(value, itemToStringLabel);
  }
  if (itemToStringLabel && value != null) {
    return itemToStringLabel(value);
  }
  if (value && typeof value === "object" && "label" in value && value.label != null) {
    return value.label;
  }
  if (items && !Array.isArray(items)) {
    const label = Object.hasOwn(items, value) ? items[value] : void 0;
    return label ?? fallback();
  }
  if (Array.isArray(items)) {
    const arrayItems = items;
    const flatItems = flattenLeafItems(arrayItems);
    if (value == null || typeof value !== "object") {
      const match = flatItems.find((item) => item.value === value);
      if (match && match.label != null) {
        return match.label;
      }
      return fallback();
    }
    if ("value" in value) {
      const match = flatItems.find((item) => item && item.value === value.value);
      if (match && match.label != null) {
        return match.label;
      }
    }
  }
  return fallback();
}
function resolveMultipleLabels(values, items, itemToStringLabel) {
  return values.reduce((acc, value, index2) => {
    if (index2 > 0) {
      acc.push(", ");
    }
    acc.push(/* @__PURE__ */ _jsx5(React41.Fragment, {
      children: resolveSelectedLabel(value, items, itemToStringLabel)
    }, index2));
    return acc;
  }, []);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/store.mjs
var selectors2 = {
  id: (state) => state.id,
  labelId: (state) => state.labelId,
  items: (state) => state.items,
  selectedValue: (state) => state.selectedValue,
  hasSelectionChips: (state) => {
    const selectedValue = state.selectedValue;
    return Array.isArray(selectedValue) && selectedValue.length > 0;
  },
  hasSelectedValue: (state) => {
    const {
      selectedValue,
      selectionMode
    } = state;
    if (selectedValue == null) {
      return false;
    }
    if (selectionMode === "multiple" && Array.isArray(selectedValue)) {
      return selectedValue.length > 0;
    }
    return true;
  },
  hasNullItemLabel: (state, enabled) => {
    return enabled ? hasNullItemLabel(state.items) : false;
  },
  open: (state) => state.open,
  mounted: (state) => state.mounted,
  forceMounted: (state) => state.forceMounted,
  inline: (state) => state.inline,
  activeIndex: (state) => state.activeIndex,
  selectedIndex: (state) => state.selectedIndex,
  isActive: (state, index2) => state.activeIndex === index2,
  isSelected: (state, itemValue) => {
    const comparer = state.isItemEqualToValue;
    const selectedValue = state.selectedValue;
    if (Array.isArray(selectedValue)) {
      return selectedValue.some((selectedItem) => compareItemEquality(itemValue, selectedItem, comparer));
    }
    return compareItemEquality(itemValue, selectedValue, comparer);
  },
  transitionStatus: (state) => state.transitionStatus,
  popupProps: (state) => state.popupProps,
  listProps: (state) => state.listProps,
  inputProps: (state) => state.inputProps,
  triggerProps: (state) => state.triggerProps,
  itemProps: (state) => state.itemProps,
  positionerElement: (state) => state.positionerElement,
  listElement: (state) => state.listElement,
  popupId: (state) => state.popupId,
  triggerElement: (state) => state.triggerElement,
  inputElement: (state) => state.inputElement,
  inputGroupElement: (state) => state.inputGroupElement,
  popupSide: (state) => state.popupSide,
  openMethod: (state) => state.openMethod,
  inputInsidePopup: (state) => state.inputInsidePopup,
  inputOwnsFormValue: (state) => state.inputOwnsFormValue,
  selectionMode: (state) => state.selectionMode,
  name: (state) => state.name,
  form: (state) => state.form,
  disabled: (state) => state.disabled,
  readOnly: (state) => state.readOnly,
  required: (state) => state.required,
  grid: (state) => state.grid,
  virtualized: (state) => state.virtualized,
  itemToStringLabel: (state) => state.itemToStringLabel,
  isItemEqualToValue: (state) => state.isItemEqualToValue,
  modal: (state) => state.modal,
  autoHighlight: (state) => state.autoHighlight
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/field-root-context/FieldRootContext.mjs
import * as React42 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/field/control/FieldControlDataAttributes.mjs
var valid = "data-valid";
var invalid = "data-invalid";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/field-constants/constants.mjs
var DEFAULT_VALIDITY_STATE = {
  badInput: false,
  customError: false,
  patternMismatch: false,
  rangeOverflow: false,
  rangeUnderflow: false,
  stepMismatch: false,
  tooLong: false,
  tooShort: false,
  typeMismatch: false,
  valid: null,
  valueMissing: false
};
var DEFAULT_FIELD_STATE_ATTRIBUTES = {
  valid: null,
  touched: false,
  dirty: false,
  filled: false,
  focused: false
};
var DEFAULT_FIELD_ROOT_STATE = {
  disabled: false,
  ...DEFAULT_FIELD_STATE_ATTRIBUTES
};
var fieldValidityMapping = {
  valid(value) {
    if (value === null) {
      return null;
    }
    if (value) {
      return {
        [valid]: ""
      };
    }
    return {
      [invalid]: ""
    };
  }
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/field-root-context/FieldRootContext.mjs
var DEFAULT_FIELD_ROOT_CONTEXT = {
  invalid: void 0,
  name: void 0,
  validityData: {
    state: DEFAULT_VALIDITY_STATE,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: NOOP,
  disabled: void 0,
  setTouched: NOOP,
  setDirty: NOOP,
  setFilled: NOOP,
  setFocused: NOOP,
  validationMode: "onSubmit",
  shouldValidateOnChange: () => false,
  state: DEFAULT_FIELD_ROOT_STATE,
  registerFieldControl: NOOP,
  validation: {
    getValidationProps: (_disabled, props = EMPTY_OBJECT) => props,
    inputRef: {
      current: null
    },
    registeredInputs: /* @__PURE__ */ new Map(),
    registerInput: NOOP,
    getInputControl: () => null,
    commit: async () => {
    },
    change: NOOP
  }
};
var FieldRootContext = /* @__PURE__ */ React42.createContext(DEFAULT_FIELD_ROOT_CONTEXT);
if (process.env.NODE_ENV !== "production") FieldRootContext.displayName = "FieldRootContext";
function useFieldRootContext(optional = true) {
  const context = React42.useContext(FieldRootContext);
  if (context.setValidityData === NOOP && !optional) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : formatErrorMessage_default(28));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/field-register-control/useRegisterFieldControl.mjs
function useRegisterFieldControl(controlRef, id, value, getFormValueOverride, enabled = true, name2) {
  const {
    registerFieldControl
  } = useFieldRootContext();
  const sourceRef = useRefWithInit(() => Symbol());
  useIsoLayoutEffect(() => {
    const source = sourceRef.current;
    if (!enabled) {
      registerFieldControl(source, void 0);
      return;
    }
    const registration = {
      controlRef,
      getValue: getFormValueOverride,
      id,
      name: name2,
      value
    };
    registerFieldControl(source, registration);
  }, [controlRef, enabled, getFormValueOverride, id, name2, registerFieldControl, sourceRef, value]);
  useIsoLayoutEffect(() => {
    const source = sourceRef.current;
    return () => {
      registerFieldControl(source, void 0);
    };
  }, [registerFieldControl, sourceRef]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/form-context/FormContext.mjs
import * as React43 from "react";
var FormContext = /* @__PURE__ */ React43.createContext({
  elementRef: {
    current: null
  },
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: NOOP,
  validationMode: "onSubmit",
  submitCountRef: {
    current: 0
  }
});
if (process.env.NODE_ENV !== "production") FormContext.displayName = "FormContext";
function useFormContext() {
  return React43.useContext(FormContext);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/labelable-provider/useLabelableId.mjs
import * as React45 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useBaseUiId.mjs
function useBaseUiId(idOverride) {
  return useId4(idOverride, "base-ui");
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/labelable-provider/LabelableContext.mjs
import * as React44 from "react";
var LabelableContext = /* @__PURE__ */ React44.createContext({
  controlId: void 0,
  registerControlId: NOOP,
  resetControlId: NOOP,
  labelId: void 0,
  setLabelId: NOOP,
  messageIds: [],
  setMessageIds: NOOP,
  getDescriptionProps: (externalProps) => externalProps
});
if (process.env.NODE_ENV !== "production") LabelableContext.displayName = "LabelableContext";
function useLabelableContext() {
  return React44.useContext(LabelableContext);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/labelable-provider/useLabelableId.mjs
function useLabelableId(params = {}) {
  const {
    id,
    enabled = true
  } = params;
  const {
    controlId,
    registerControlId,
    resetControlId
  } = useLabelableContext();
  const defaultId = useBaseUiId();
  const controlSourceRef = useRefWithInit(() => Symbol());
  const hasRegisteredRef = React45.useRef(false);
  const hadExplicitIdRef = React45.useRef(false);
  const unregisterControlId = useStableCallback(() => {
    if (!hasRegisteredRef.current || registerControlId === NOOP) {
      return;
    }
    hasRegisteredRef.current = false;
    registerControlId(controlSourceRef.current, void 0);
  });
  useIsoLayoutEffect(() => {
    if (!enabled || registerControlId === NOOP) {
      unregisterControlId();
      return void 0;
    }
    let nextId2;
    if (id !== void 0) {
      hadExplicitIdRef.current = true;
      nextId2 = id;
    } else if (hadExplicitIdRef.current) {
      nextId2 = defaultId;
    } else {
      resetControlId();
      return void 0;
    }
    if (nextId2 === void 0) {
      unregisterControlId();
      return void 0;
    }
    hasRegisteredRef.current = true;
    registerControlId(controlSourceRef.current, nextId2);
    return void 0;
  }, [id, enabled, registerControlId, resetControlId, defaultId, controlSourceRef, unregisterControlId]);
  useIsoLayoutEffect(() => {
    return unregisterControlId;
  }, [unregisterControlId]);
  return (enabled ? controlId : void 0) ?? id ?? defaultId;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/utils/index.mjs
function getComboboxPopupId(rootId) {
  return rootId == null ? void 0 : `${rootId}-popup`;
}
function createCollatorItemFilter(collatorFilter, itemToStringLabel) {
  return (item, query) => {
    if (item == null) {
      return false;
    }
    return collatorFilter.contains(item, query, itemToStringLabel);
  };
}
function createSingleSelectionCollatorFilter(collatorFilter, itemToStringLabel, selectedValue) {
  return (item, query) => {
    if (item == null) {
      return false;
    }
    if (!query) {
      return true;
    }
    const selectedValueToString = itemToStringLabel?.selected ?? itemToStringLabel;
    const selectedString = selectedValue != null ? stringifyAsLabel(selectedValue, selectedValueToString) : "";
    if (selectedString && collatorFilter.contains(selectedString, query) && selectedString.length === query.length) {
      return true;
    }
    return collatorFilter.contains(item, query, itemToStringLabel);
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/utils/useFilter.mjs
import * as React46 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/stringifyLocale.mjs
function stringifyLocale(locale) {
  if (Array.isArray(locale)) {
    return locale.map((value) => stringifyLocale(value)).join(",");
  }
  if (locale == null) {
    return "";
  }
  return String(locale);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/filter.mjs
var filterCache = /* @__PURE__ */ new Map();
function getFilter(options = {}) {
  const mergedOptions = {
    usage: "search",
    sensitivity: "base",
    ignorePunctuation: true,
    ...options
  };
  const cacheKey = `${stringifyLocale(options.locale)}|${JSON.stringify(mergedOptions)}`;
  const cachedFilter = filterCache.get(cacheKey);
  if (cachedFilter) {
    return cachedFilter;
  }
  const collator = new Intl.Collator(options.locale, mergedOptions);
  const filter = {
    contains(item, query, itemToString) {
      if (!query) {
        return true;
      }
      const itemString = stringifyAsLabel(item, itemToString);
      for (let i = 0; i <= itemString.length - query.length; i += 1) {
        if (collator.compare(itemString.slice(i, i + query.length), query) === 0) {
          return true;
        }
      }
      return false;
    },
    startsWith(item, query, itemToString) {
      if (!query) {
        return true;
      }
      const itemString = stringifyAsLabel(item, itemToString);
      return collator.compare(itemString.slice(0, query.length), query) === 0;
    },
    endsWith(item, query, itemToString) {
      if (!query) {
        return true;
      }
      const itemString = stringifyAsLabel(item, itemToString);
      const queryLength = query.length;
      return itemString.length >= queryLength && collator.compare(itemString.slice(itemString.length - queryLength), query) === 0;
    }
  };
  filterCache.set(cacheKey, filter);
  return filter;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/utils/useFilter.mjs
var useCoreFilter = getFilter;
function useComboboxFilter(options = {}) {
  const {
    multiple = false,
    value,
    ...collatorOptions
  } = options;
  const coreFilter = getFilter(collatorOptions);
  const contains2 = React46.useCallback((item, query, itemToString) => {
    if (multiple) {
      return createCollatorItemFilter(coreFilter, itemToString)(item, query);
    }
    return createSingleSelectionCollatorFilter(coreFilter, itemToString, value)(item, query);
  }, [coreFilter, value, multiple]);
  return React46.useMemo(() => ({
    ...coreFilter,
    contains: contains2
  }), [contains2, coreFilter]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/useOpenInteractionType.mjs
import * as React49 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useEnhancedClickHandler.mjs
import * as React47 from "react";
function useEnhancedClickHandler(handler) {
  const lastClickInteractionTypeRef = React47.useRef("");
  const handlePointerDown = React47.useCallback((event) => {
    if (event.defaultPrevented) {
      return;
    }
    lastClickInteractionTypeRef.current = event.pointerType;
    handler(event, event.pointerType);
  }, [handler]);
  const handleClick = React47.useCallback((event) => {
    if (event.detail === 0) {
      handler(event, "keyboard");
      return;
    }
    if ("pointerType" in event) {
      handler(event, event.pointerType);
    } else {
      handler(event, lastClickInteractionTypeRef.current);
    }
    lastClickInteractionTypeRef.current = "";
  }, [handler]);
  return {
    onClick: handleClick,
    onPointerDown: handlePointerDown
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useValueChanged.mjs
import * as React48 from "react";
function useValueChanged(value, onChange) {
  const valueRef = React48.useRef(value);
  const onChangeCallback = useStableCallback(onChange);
  useIsoLayoutEffect(() => {
    if (valueRef.current !== value) {
      onChangeCallback(valueRef.current);
    }
    valueRef.current = value;
  }, [value, onChangeCallback]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/useOpenInteractionType.mjs
function useOpenMethodTriggerProps(open2, setOpenMethod) {
  const handleTriggerClick = useStableCallback((_, interactionType) => {
    const isOpen = typeof open2 === "function" ? open2() : open2;
    if (!isOpen) {
      setOpenMethod(interactionType || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
      // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
      // will be "" in that case.
      (parts_exports.os.ios ? "touch" : ""));
    }
  });
  const {
    onClick,
    onPointerDown
  } = useEnhancedClickHandler(handleTriggerClick);
  return React49.useMemo(() => ({
    onClick,
    onPointerDown
  }), [onClick, onPointerDown]);
}
function useOpenInteractionType(open2) {
  const [openMethod, setOpenMethod] = React49.useState(null);
  const triggerProps = useOpenMethodTriggerProps(open2, setOpenMethod);
  useValueChanged(open2, (previousOpen) => {
    if (previousOpen && !open2) {
      setOpenMethod(null);
    }
  });
  return React49.useMemo(() => ({
    openMethod,
    triggerProps
  }), [openMethod, triggerProps]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/scrollable.mjs
function isScrollableY(element2, allowOverflowIntent = false) {
  const {
    overflowY
  } = getComputedStyle2(element2);
  if (overflowY !== "auto" && overflowY !== "scroll") {
    return false;
  }
  return allowOverflowIntent ? element2.clientHeight > 0 : element2.scrollHeight > element2.clientHeight;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/utils/constants.mjs
var NO_ACTIVE_VALUE = Symbol("none");
var INITIAL_LAST_HIGHLIGHT = {
  value: NO_ACTIVE_VALUE,
  index: -1
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/direction-context/DirectionContext.mjs
import * as React50 from "react";
var DirectionContext = /* @__PURE__ */ React50.createContext(void 0);
if (process.env.NODE_ENV !== "production") DirectionContext.displayName = "DirectionContext";
function useDirection3() {
  const context = React50.useContext(DirectionContext);
  return context?.direction ?? "ltr";
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/items/itemCollection.mjs
function findCollectionItem(valueToItem, itemValue, isEqual) {
  const exactItem = valueToItem.get(itemValue);
  if (exactItem !== void 0 || isEqual === defaultItemEquality) {
    return exactItem;
  }
  for (const [derivedValue, item] of valueToItem) {
    if (compareItemEquality(derivedValue, itemValue, isEqual)) {
      return item;
    }
  }
  return void 0;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/AriaCombobox.mjs
import { jsx as _jsx6, jsxs as _jsxs3 } from "react/jsx-runtime";
function AriaCombobox(props) {
  const {
    id: idProp,
    onOpenChangeComplete: onOpenChangeCompleteProp,
    defaultSelectedValue = null,
    selectedValue: selectedValueProp,
    onSelectedValueChange,
    defaultInputValue,
    inputValue: inputValueProp,
    open: openProp,
    defaultOpen = false,
    selectionMode,
    onItemHighlighted: onItemHighlightedProp,
    name: nameProp,
    form,
    disabled: disabledProp = false,
    readOnly = false,
    required = false,
    inputRef: inputRefProp,
    grid = false,
    items: itemsProp,
    filteredItems: filteredItemsProp,
    filter: filterProp,
    filterQuery: filterQueryProp,
    openOnInputClick = true,
    autoHighlight = false,
    keepHighlight = false,
    highlightItemOnHover = true,
    loopFocus = true,
    itemToStringLabel: itemToStringLabelProp,
    itemToStringValue,
    isItemEqualToValue = defaultItemEquality,
    virtualized = false,
    inline: inlineProp = false,
    fillInputOnItemPress = true,
    modal = false,
    limit = -1,
    autoComplete = "list",
    formAutoComplete,
    locale,
    submitOnItemClick = false
  } = props;
  const {
    clearErrors
  } = useFormContext();
  const {
    setDirty,
    validityData,
    setFilled,
    name: fieldName,
    disabled: fieldDisabled,
    setTouched,
    setFocused,
    validationMode,
    validation
  } = useFieldRootContext();
  const direction = useDirection3();
  const id = useLabelableId({
    id: idProp
  });
  const collatorFilter = useCoreFilter({
    locale
  });
  const collection = Array.isArray(itemsProp) ? null : itemsProp;
  if (collection && typeof collection.label !== "function") {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: the `items` prop received an object that is not a collection, so its items cannot be read. Pass an array of items, an array of groups with items, or the result of `createItems()`. See https://base-ui.com/react/components/combobox#createitems" : formatErrorMessage_default(100));
  }
  const items = collection ? collection.data : itemsProp;
  const itemToValue = collection?.value;
  const storeItems = itemToValue ? void 0 : items;
  const externalWindow = React51.useMemo(() => {
    if (!filteredItemsProp || !itemToValue) {
      return void 0;
    }
    const flat = flattenLeafItems(filteredItemsProp);
    const values = flat.map(itemToValue);
    let valueToItem;
    return {
      values,
      findItem(itemValue, isEqual) {
        if (!valueToItem) {
          valueToItem = /* @__PURE__ */ new Map();
          for (let i = 0; i < values.length; i += 1) {
            if (!valueToItem.has(values[i])) {
              valueToItem.set(values[i], flat[i]);
            }
          }
        }
        return findCollectionItem(valueToItem, itemValue, isEqual);
      }
    };
  }, [filteredItemsProp, itemToValue]);
  const itemToStringLabel = React51.useMemo(() => {
    if (!collection) {
      return itemToStringLabelProp;
    }
    return (itemValue) => {
      return collection.label(itemValue, isItemEqualToValue, (unresolvedValue) => {
        const externalItem = externalWindow?.findItem(unresolvedValue, isItemEqualToValue);
        if (externalItem != null) {
          return collection.itemLabel(externalItem);
        }
        return stringifyAsLabel(unresolvedValue, itemToStringLabelProp);
      });
    };
  }, [collection, itemToStringLabelProp, externalWindow, isItemEqualToValue]);
  const filterItemToString = React51.useMemo(() => {
    if (!collection) {
      return itemToStringLabelProp;
    }
    return Object.assign((item) => collection.itemLabel(item), {
      selected: (value) => stringifyAsLabel(value, itemToStringLabel)
    });
  }, [collection, itemToStringLabel, itemToStringLabelProp]);
  function stringifyValueLabel(item) {
    return stringifyAsLabel(item, itemToStringLabel);
  }
  const [queryChangedAfterOpen, setQueryChangedAfterOpen] = React51.useState(false);
  const [closeQuery, setCloseQuery] = React51.useState(null);
  const previousCloseQueryRef = React51.useRef(closeQuery);
  const listRef = React51.useRef([]);
  const labelsRef = React51.useRef([]);
  const popupRef = React51.useRef(null);
  const inputRef = React51.useRef(null);
  const startDismissRef = React51.useRef(null);
  const endDismissRef = React51.useRef(null);
  const emptyRef = React51.useRef(null);
  const keyboardActiveRef = React51.useRef(true);
  const hadInputClearRef = React51.useRef(false);
  const chipsContainerRef = React51.useRef(null);
  const clearRef = React51.useRef(null);
  const selectionEventRef = React51.useRef(null);
  const lastHighlightRef = React51.useRef(INITIAL_LAST_HIGHLIGHT);
  const pendingQueryHighlightRef = React51.useRef(null);
  const valuesRef = React51.useRef([]);
  const pointerDownItemRef = React51.useRef(null);
  const disabled2 = fieldDisabled || disabledProp;
  const name2 = fieldName ?? nameProp;
  const multiple = selectionMode === "multiple";
  const single = selectionMode === "single";
  const hasInputValue = inputValueProp !== void 0 || defaultInputValue !== void 0;
  const hasItems = items !== void 0;
  const hasFilteredItemsProp = filteredItemsProp !== void 0;
  let autoHighlightMode;
  if (autoHighlight === "always") {
    autoHighlightMode = "always";
  } else {
    autoHighlightMode = autoHighlight ? "input-change" : false;
  }
  const [selectedValue, setSelectedValueUnwrapped] = useControlled({
    controlled: selectedValueProp,
    default: multiple ? defaultSelectedValue ?? EMPTY_ARRAY : defaultSelectedValue,
    name: "Combobox",
    state: "selectedValue"
  });
  const filter = React51.useMemo(() => {
    if (filterProp === null) {
      return () => true;
    }
    if (filterProp !== void 0) {
      return filterProp;
    }
    return createCollatorItemFilter(collatorFilter, filterItemToString);
  }, [filterProp, collatorFilter, filterItemToString]);
  const initialDefaultInputValue = useRefWithInit(() => {
    if (hasInputValue) {
      return defaultInputValue ?? "";
    }
    if (single) {
      return stringifyValueLabel(selectedValue);
    }
    return "";
  }).current;
  const [inputValue, setInputValueUnwrapped] = useControlled({
    controlled: inputValueProp,
    default: initialDefaultInputValue,
    name: "Combobox",
    state: "inputValue"
  });
  const [open2, setOpenUnwrapped] = useControlled({
    controlled: openProp,
    default: defaultOpen,
    name: "Combobox",
    state: "open"
  });
  const isGrouped = isGroupedItems(items);
  const query = !open2 && closeQuery !== null ? closeQuery : String(inputValue).trim();
  const selectedLabelString = single ? stringifyValueLabel(selectedValue) : "";
  const shouldBypassFiltering = single && !queryChangedAfterOpen && query !== "" && selectedLabelString.length === query.length && collatorFilter.contains(selectedLabelString, query);
  const filterQuery = shouldBypassFiltering ? "" : filterQueryProp ?? query;
  const shouldIgnoreExternalFiltering = hasItems && hasFilteredItemsProp && shouldBypassFiltering && (!collection || collection.hasValue(selectedValue, isItemEqualToValue));
  const flatItems = React51.useMemo(() => items ? flattenLeafItems(items) : EMPTY_ARRAY, [items]);
  const filteredItems = React51.useMemo(() => {
    if (filteredItemsProp && !shouldIgnoreExternalFiltering) {
      return filteredItemsProp;
    }
    if (!items) {
      return EMPTY_ARRAY;
    }
    if (isGrouped) {
      const groupedItems = items;
      const resultingGroups = [];
      let currentCount = 0;
      for (const group of groupedItems) {
        if (limit > -1 && currentCount >= limit) {
          break;
        }
        const remainingLimit = limit > -1 ? limit - currentCount : Infinity;
        const itemsToTake = filterQuery === "" ? group.items.slice(0, remainingLimit) : [];
        if (filterQuery !== "") {
          for (const item of group.items) {
            if (itemsToTake.length >= remainingLimit) {
              break;
            }
            if (filter(item, filterQuery, filterItemToString)) {
              itemsToTake.push(item);
            }
          }
        }
        if (itemsToTake.length > 0) {
          const newGroup = {
            ...group,
            items: itemsToTake
          };
          resultingGroups.push(newGroup);
          currentCount += itemsToTake.length;
        }
      }
      return resultingGroups;
    }
    if (filterQuery === "") {
      return limit > -1 ? flatItems.slice(0, limit) : (
        // The cast here is done as `flatItems` is readonly.
        // valuesRef.current, a mutable ref, can be set to `flatFilteredValues`, which may
        // reference this exact readonly value, creating a mutation risk.
        // However, <Combobox.Item> can never mutate this value as the mutating effect
        // bails early when `items` is provided, and this is only ever returned
        // when `items` is provided due to the early return at the top of this hook.
        flatItems
      );
    }
    const limitedItems = [];
    for (const item of flatItems) {
      if (limit > -1 && limitedItems.length >= limit) {
        break;
      }
      if (filter(item, filterQuery, filterItemToString)) {
        limitedItems.push(item);
      }
    }
    return limitedItems;
  }, [filteredItemsProp, shouldIgnoreExternalFiltering, items, isGrouped, filterQuery, limit, filter, filterItemToString, flatItems]);
  const flatFilteredValues = React51.useMemo(() => {
    if (externalWindow && filteredItems === filteredItemsProp) {
      return externalWindow.values;
    }
    const flat = flattenLeafItems(filteredItems);
    return itemToValue ? flat.map((item) => itemToValue(item)) : flat;
  }, [filteredItems, filteredItemsProp, externalWindow, itemToValue]);
  const store = useRefWithInit(() => {
    let initialSelectedIndex = null;
    if (inlineProp && open2 && hasItems && selectionMode !== "none") {
      initialSelectedIndex = findSelectionIndex(flatFilteredValues, selectedValue, isItemEqualToValue, multiple);
    }
    return new ReactStore({
      id,
      labelId: void 0,
      selectedValue,
      open: open2,
      items: storeItems,
      selectionMode,
      name: name2,
      form,
      disabled: disabled2,
      readOnly,
      required,
      grid,
      virtualized,
      openOnInputClick,
      itemToStringLabel,
      isItemEqualToValue,
      modal,
      autoHighlight: autoHighlightMode,
      submitOnItemClick,
      hasInputValue,
      mounted: false,
      forceMounted: false,
      transitionStatus: "idle",
      inline: inlineProp,
      activeIndex: null,
      selectedIndex: initialSelectedIndex,
      popupProps: {},
      listProps: {},
      inputProps: {},
      triggerProps: {},
      itemProps: EMPTY_OBJECT,
      positionerElement: null,
      listElement: null,
      popupId: void 0,
      triggerElement: null,
      inputElement: null,
      inputGroupElement: null,
      popupSide: null,
      openMethod: null,
      inputInsidePopup: true,
      // Avoid duplicate names in the server HTML. Popup inputs aren't rendered
      // until after hydration, so the hidden input takes over then if needed.
      inputOwnsFormValue: selectionMode === "none"
    }, {
      // Placeholder callbacks replaced on first render
      onOpenChangeComplete: NOOP,
      setOpen: NOOP,
      setInputValue: NOOP,
      setSelectedValue: NOOP,
      setIndices: NOOP,
      handleSelection: NOOP,
      forceMount: NOOP,
      requestSubmit: NOOP,
      listRef,
      labelsRef,
      popupRef,
      emptyRef,
      inputRef,
      startDismissRef,
      endDismissRef,
      keyboardActiveRef,
      chipsContainerRef,
      clearRef,
      valuesRef,
      pointerDownItemRef,
      selectionEventRef
    }, selectors2);
  }).current;
  const fieldRawValue = selectionMode === "none" ? inputValue : selectedValue;
  const fieldStringValue = React51.useMemo(() => {
    if (selectionMode === "none") {
      return fieldRawValue;
    }
    if (Array.isArray(selectedValue)) {
      return selectedValue.map((value) => stringifyAsValue(value, itemToStringValue));
    }
    return stringifyAsValue(selectedValue, itemToStringValue);
  }, [fieldRawValue, itemToStringValue, selectionMode, selectedValue]);
  const onItemHighlighted = useStableCallback(onItemHighlightedProp);
  const onOpenChangeComplete = useStableCallback(onOpenChangeCompleteProp);
  const activeIndex = store.useState("activeIndex");
  const selectedIndex = store.useState("selectedIndex");
  const positionerElement = store.useState("positionerElement");
  const listElement = store.useState("listElement");
  const triggerElement = store.useState("triggerElement");
  const inputElement = store.useState("inputElement");
  const inputGroupElement = store.useState("inputGroupElement");
  const inline4 = store.useState("inline");
  const inputInsidePopup = store.useState("inputInsidePopup");
  const inputOwnsFormValue = store.useState("inputOwnsFormValue");
  const inputMatchesSelectedValue = single && !inputInsidePopup && inputValue === selectedLabelString;
  const triggerRef = useValueAsRef(triggerElement);
  const {
    mounted,
    setMounted,
    transitionStatus
  } = useTransitionStatus(open2);
  const {
    openMethod,
    triggerProps
  } = useOpenInteractionType(open2);
  const getStringifiedValueForForm = useStableCallback(() => fieldStringValue);
  useRegisterFieldControl(inputInsidePopup ? triggerRef : inputRef, id, fieldRawValue, getStringifiedValueForForm, !disabled2, nameProp);
  const forceMount = useStableCallback(() => {
    if (items) {
      labelsRef.current = flatFilteredValues.map(stringifyValueLabel);
    } else {
      store.set("forceMounted", true);
    }
  });
  const emitHighlight = useStableCallback((value, index2, type) => {
    if (index2 === -1) {
      if (lastHighlightRef.current === INITIAL_LAST_HIGHLIGHT) {
        return;
      }
      lastHighlightRef.current = INITIAL_LAST_HIGHLIGHT;
    } else {
      lastHighlightRef.current = {
        value,
        index: index2
      };
    }
    onItemHighlighted(value, createGenericEventDetails(type, void 0, {
      index: index2
    }));
  });
  const setIndices = useStableCallback((options) => {
    const update2 = {};
    if (options.activeIndex !== void 0) {
      update2.activeIndex = options.activeIndex;
    }
    if (options.selectedIndex !== void 0) {
      update2.selectedIndex = options.selectedIndex;
    }
    store.update(update2);
    const activeIndexOption = options.activeIndex;
    if (activeIndexOption === void 0) {
      return;
    }
    const type = options.type || reason_parts_exports.none;
    if (activeIndexOption === null) {
      emitHighlight(void 0, -1, type);
    } else {
      emitHighlight(valuesRef.current[activeIndexOption], activeIndexOption, type);
    }
  });
  const setInputValue = useStableCallback((next, eventDetails) => {
    props.onInputValueChange?.(next, eventDetails);
    if (eventDetails.isCanceled) {
      return;
    }
    hadInputClearRef.current = eventDetails.reason === reason_parts_exports.inputClear;
    if (eventDetails.reason === reason_parts_exports.inputChange) {
      if (open2 && closeQuery !== null) {
        setCloseQuery(null);
      }
      const event = eventDetails.event;
      const inputType = event.inputType;
      const isTypedInput = event.type === "compositionend" || inputType != null && inputType !== "" && inputType !== "insertReplacementText";
      if (isTypedInput) {
        const hasQuery = next.trim() !== "";
        if (hasQuery) {
          setQueryChangedAfterOpen(true);
        }
        pendingQueryHighlightRef.current = {
          hasQuery
        };
        const list2 = store.state.listElement;
        if (!store.state.virtualized && list2) {
          const popup = popupRef.current;
          for (const ancestor of getOverflowAncestors(list2.firstElementChild ?? list2)) {
            if (!isHTMLElement(ancestor) || (popup ? !contains(popup, ancestor) : ancestor.getAttribute("role") === "dialog")) {
              break;
            }
            if (isScrollableY(ancestor)) {
              ancestor.scrollTop = 0;
              break;
            }
          }
        }
        if (hasQuery && autoHighlightMode && store.state.activeIndex == null && (open2 || inline4)) {
          store.set("activeIndex", 0);
        }
      }
    } else if (eventDetails.reason === reason_parts_exports.inputClear && next === "" && store.state.inputInsidePopup) {
      pendingQueryHighlightRef.current = {
        hasQuery: false,
        selection: true
      };
    }
    setInputValueUnwrapped(next);
  });
  const handleInterruptedReopen = useStableCallback((isInputChange) => {
    const clearsPendingInput = !isInputChange && inputInsidePopup && !inline4 && inputValue !== "" && (String(inputValue).trim() === closeQuery || inputValue === selectedLabelString);
    if (!isInputChange && (clearsPendingInput || inputValue === "" || inputMatchesSelectedValue)) {
      setQueryChangedAfterOpen(false);
    }
    setCloseQuery(null);
    if (clearsPendingInput) {
      setInputValue("", createChangeEventDetails(reason_parts_exports.inputClear));
    }
  });
  const setOpen = useStableCallback((nextOpen, eventDetails) => {
    if (open2 === nextOpen) {
      return;
    }
    if (eventDetails.reason === reason_parts_exports.escapeKey && hasItems && flatFilteredValues.length === 0 && !emptyRef.current) {
      eventDetails.allowPropagation();
    }
    props.onOpenChange?.(nextOpen, eventDetails);
    if (eventDetails.isCanceled) {
      return;
    }
    if (nextOpen && closeQuery !== null) {
      handleInterruptedReopen(eventDetails.reason === reason_parts_exports.inputChange);
    }
    if (!nextOpen && queryChangedAfterOpen) {
      if (single) {
        if (!inline4) {
          setCloseQuery(query);
        }
        if (query === "") {
          setQueryChangedAfterOpen(false);
        }
      } else if (multiple) {
        if (!inline4) {
          setCloseQuery(query);
        }
        if (inputInsidePopup) {
          setIndices({
            activeIndex: null
          });
        }
        if (!inputInsidePopup || inline4) {
          setInputValue("", createChangeEventDetails(reason_parts_exports.inputClear, eventDetails.event, void 0, {
            isItemPress: eventDetails.reason === reason_parts_exports.itemPress
          }));
        }
      }
    }
    setOpenUnwrapped(nextOpen);
    if (!nextOpen && inputInsidePopup && (eventDetails.reason === reason_parts_exports.focusOut || eventDetails.reason === reason_parts_exports.outsidePress)) {
      setTouched(true);
      setFocused(false);
      if (validationMode === "onBlur") {
        const valueToValidate = selectionMode === "none" ? inputValue : selectedValue;
        validation.commit(valueToValidate);
      }
    }
  });
  const setSelectedValue = useStableCallback((nextValue, eventDetails) => {
    onSelectedValueChange?.(nextValue, eventDetails);
    if (eventDetails.isCanceled) {
      return;
    }
    setSelectedValueUnwrapped(nextValue);
    const shouldFillInput = selectionMode === "none" && popupRef.current && fillInputOnItemPress || single && !store.state.inputInsidePopup;
    if (shouldFillInput) {
      setInputValue(stringifyValueLabel(nextValue), createChangeEventDetails(eventDetails.reason, eventDetails.event));
    }
  });
  const handleSelection = useStableCallback((event, itemValue) => {
    const targetEl = getTarget(event);
    const overrideEvent = selectionEventRef.current ?? event;
    selectionEventRef.current = null;
    const eventDetails = createChangeEventDetails(reason_parts_exports.itemPress, overrideEvent);
    const href = targetEl?.closest("a")?.getAttribute("href");
    if (href) {
      if (href.startsWith("#")) {
        setOpen(false, eventDetails);
      }
      return;
    }
    if (multiple) {
      const currentSelectedValue = Array.isArray(selectedValue) ? selectedValue : [];
      const isCurrentlySelected = selectedValueIncludes(currentSelectedValue, itemValue, isItemEqualToValue);
      const nextValue = isCurrentlySelected ? removeItem(currentSelectedValue, itemValue, isItemEqualToValue) : [...currentSelectedValue, itemValue];
      setSelectedValue(nextValue, eventDetails);
      if (eventDetails.isCanceled) {
        return;
      }
      const wasFiltering = inputRef.current ? inputRef.current.value.trim() !== "" : false;
      if (!wasFiltering) {
        return;
      }
      if (store.state.inputInsidePopup) {
        setInputValue("", createChangeEventDetails(reason_parts_exports.inputClear, eventDetails.event, void 0, {
          isItemPress: true
        }));
        const pendingHighlight = pendingQueryHighlightRef.current;
        if (pendingHighlight && !isCurrentlySelected) {
          pendingHighlight.toggledValue = itemValue;
        }
      } else {
        setOpen(false, eventDetails);
      }
    } else {
      setSelectedValue(itemValue, eventDetails);
      if (eventDetails.isCanceled) {
        return;
      }
      setOpen(false, eventDetails);
    }
  });
  const requestSubmit = useStableCallback(() => {
    const formElement = validation.inputRef.current?.form ?? store.state.inputElement?.form;
    if (formElement && typeof formElement.requestSubmit === "function") {
      formElement.requestSubmit();
    }
  });
  const handleUnmount = useStableCallback(() => {
    setMounted(false);
    onOpenChangeComplete?.(false);
    setQueryChangedAfterOpen(false);
    setCloseQuery(null);
    if (selectionMode === "none") {
      setIndices({
        activeIndex: null,
        selectedIndex: null
      });
    } else {
      setIndices({
        activeIndex: null
      });
    }
    if (multiple && inputRef.current && inputRef.current.value !== "" && !hadInputClearRef.current) {
      setInputValue("", createChangeEventDetails(reason_parts_exports.inputClear));
    }
    if (single) {
      if (store.state.inputInsidePopup) {
        if (inputRef.current && inputRef.current.value !== "") {
          setInputValue("", createChangeEventDetails(reason_parts_exports.inputClear));
        }
      } else {
        const stringVal = stringifyValueLabel(selectedValue);
        if (inputRef.current && inputRef.current.value !== stringVal) {
          const reason = stringVal === "" ? reason_parts_exports.inputClear : reason_parts_exports.none;
          setInputValue(stringVal, createChangeEventDetails(reason));
        }
      }
    }
  });
  const resolvedPopupRef = React51.useMemo(() => {
    if (inline4 && positionerElement) {
      return {
        current: positionerElement.closest('[role="dialog"]')
      };
    }
    return popupRef;
  }, [inline4, positionerElement]);
  useOpenChangeComplete({
    enabled: !props.actionsRef,
    open: open2,
    ref: resolvedPopupRef,
    onComplete() {
      if (!open2) {
        handleUnmount();
      }
    }
  });
  React51.useImperativeHandle(props.actionsRef, () => ({
    unmount: handleUnmount
  }), [handleUnmount]);
  useIsoLayoutEffect(function syncSelectedIndex() {
    const closeQueryReleased = previousCloseQueryRef.current !== null && closeQuery === null;
    previousCloseQueryRef.current = closeQuery;
    if (open2 && (!closeQueryReleased || !hasItems)) {
      return;
    }
    if (!open2) {
      pointerDownItemRef.current = null;
    }
    if (selectionMode === "none") {
      return;
    }
    const registry = hasItems ? flatFilteredValues : valuesRef.current;
    setIndices({
      selectedIndex: findSelectionIndex(registry, selectedValue, isItemEqualToValue, multiple)
    });
  }, [open2, closeQuery, selectedValue, selectionMode, multiple, hasItems, flatFilteredValues, isItemEqualToValue, setIndices]);
  useIsoLayoutEffect(() => {
    if (items) {
      valuesRef.current = flatFilteredValues;
      listRef.current.length = flatFilteredValues.length;
    }
  }, [items, flatFilteredValues]);
  useIsoLayoutEffect(() => {
    const pendingHighlight = pendingQueryHighlightRef.current;
    if (pendingHighlight) {
      const listIsNavigable = open2 || inline4 || store.state.positionerElement?.hidden === false;
      if (pendingHighlight.hasQuery) {
        if (autoHighlightMode && listIsNavigable) {
          store.set("activeIndex", 0);
        }
        pendingQueryHighlightRef.current = null;
      } else if (String(inputValue).trim() === "") {
        pendingQueryHighlightRef.current = null;
        if (listIsNavigable) {
          const clearedBySelection = pendingHighlight.selection;
          if (autoHighlightMode === "always" && !clearedBySelection && store.state.selectionMode === "none") {
            store.set("activeIndex", 0);
          }
          queueMicrotask(() => {
            if (!store.state.open && !store.state.inline || inputRef.current && inputRef.current.value.trim() !== "") {
              return;
            }
            const currentSelectedValue = store.state.selectedValue;
            const isMultiple = store.state.selectionMode === "multiple";
            const hasSelection = isMultiple && Array.isArray(currentSelectedValue) ? currentSelectedValue.length > 0 : store.state.selectionMode !== "none" && currentSelectedValue != null;
            if (hasSelection) {
              const registry = hasItems || hasFilteredItemsProp ? flatFilteredValues : valuesRef.current;
              const toggledIndex = findItemIndex(registry, pendingHighlight.toggledValue, store.state.isItemEqualToValue);
              store.set("activeIndex", toggledIndex !== -1 ? toggledIndex : findSelectionIndex(registry, currentSelectedValue, store.state.isItemEqualToValue, isMultiple));
            } else if (clearedBySelection) {
              store.set("activeIndex", null);
            } else if (autoHighlightMode === "always") {
              store.set("activeIndex", 0);
            }
          });
        }
      }
    }
    if (!open2 && !inline4) {
      return;
    }
    const shouldUseFlatFilteredValues = hasItems || hasFilteredItemsProp;
    const candidateItems = shouldUseFlatFilteredValues ? flatFilteredValues : valuesRef.current;
    const storeActiveIndex = store.state.activeIndex;
    if (storeActiveIndex == null) {
      if (autoHighlightMode === "always" && candidateItems.length > 0) {
        store.set("activeIndex", 0);
        return;
      }
      emitHighlight(void 0, -1, reason_parts_exports.none);
      return;
    }
    if (storeActiveIndex >= candidateItems.length) {
      emitHighlight(void 0, -1, reason_parts_exports.none);
      store.set("activeIndex", null);
      return;
    }
    const itemValue = candidateItems[storeActiveIndex];
    const previouslyHighlightedItemValue = lastHighlightRef.current.value;
    const isSameItem = previouslyHighlightedItemValue !== NO_ACTIVE_VALUE && compareItemEquality(itemValue, previouslyHighlightedItemValue, store.state.isItemEqualToValue);
    if (lastHighlightRef.current.index !== storeActiveIndex || !isSameItem) {
      emitHighlight(itemValue, storeActiveIndex, reason_parts_exports.none);
    }
  }, [
    activeIndex,
    autoHighlightMode,
    emitHighlight,
    hasFilteredItemsProp,
    hasItems,
    flatFilteredValues,
    inline4,
    open2,
    store,
    // Reruns the effect when the query changes without affecting the deps above, such as
    // clearing the input when no items are filtered out (individually rendered items).
    inputValue
  ]);
  useIsoLayoutEffect(() => {
    if (selectionMode === "none") {
      setFilled(String(inputValue) !== "");
      return;
    }
    setFilled(multiple ? Array.isArray(selectedValue) && selectedValue.length > 0 : selectedValue != null);
  }, [setFilled, selectionMode, inputValue, selectedValue, multiple]);
  React51.useEffect(() => {
    if (hasItems && autoHighlightMode && flatFilteredValues.length === 0) {
      setIndices({
        activeIndex: null
      });
    }
  }, [hasItems, autoHighlightMode, flatFilteredValues.length, setIndices]);
  function handleQueryChanged() {
    if (open2 && query !== "" && query !== String(initialDefaultInputValue) && !inputMatchesSelectedValue) {
      setQueryChangedAfterOpen(true);
    }
  }
  function handleOpenChanged() {
    if (open2 && closeQuery !== null) {
      handleInterruptedReopen(false);
    }
  }
  let syncedSelectedLabel = false;
  function syncInputToSelectedLabel() {
    if (!syncedSelectedLabel && inputValue !== selectedLabelString) {
      syncedSelectedLabel = true;
      setInputValue(selectedLabelString, createChangeEventDetails(reason_parts_exports.none));
    }
  }
  function handleSelectedValueChanged() {
    if (selectionMode === "none") {
      return;
    }
    clearErrors(name2);
    setDirty(isSelectedValueDirty(selectedValue, validityData.initialValue, isItemEqualToValue));
    validation.change(selectedValue);
    if (single && !hasInputValue && !inputInsidePopup) {
      syncInputToSelectedLabel();
    }
  }
  function syncInputAfterItemsOrLabelChange() {
    if (single && !hasInputValue && !inputInsidePopup && !queryChangedAfterOpen) {
      syncInputToSelectedLabel();
    }
  }
  function handleInputValueChanged() {
    if (selectionMode !== "none") {
      return;
    }
    clearErrors(name2);
    setDirty(inputValue !== validityData.initialValue);
    validation.change(inputValue);
  }
  useValueChanged(query, handleQueryChanged);
  useValueChanged(open2, handleOpenChanged);
  useValueChanged(selectedValue, handleSelectedValueChanged);
  useValueChanged(selectedLabelString, syncInputAfterItemsOrLabelChange);
  useValueChanged(items, syncInputAfterItemsOrLabelChange);
  useValueChanged(inputValue, handleInputValueChanged);
  const floatingRootContext = useFloatingRootContext({
    open: inline4 ? true : open2,
    onOpenChange: setOpen,
    elements: {
      reference: inputInsidePopup ? triggerElement : inputElement,
      floating: positionerElement
    }
  });
  const ariaHasPopup = grid ? "grid" : "listbox";
  const expanded = open2 || inline4;
  const ariaExpanded = expanded ? "true" : "false";
  const role = React51.useMemo(() => {
    const isPlainInput = inputElement?.tagName === "INPUT";
    const shouldTreatAsInput = inputElement == null || isPlainInput;
    const shouldApplyAria = shouldTreatAsInput || expanded;
    const reference = shouldTreatAsInput ? {
      autoComplete: "off",
      spellCheck: "false",
      autoCorrect: "off",
      autoCapitalize: "none"
    } : {};
    if (shouldApplyAria) {
      reference.role = "combobox";
      reference["aria-expanded"] = ariaExpanded;
      reference["aria-haspopup"] = ariaHasPopup;
      reference["aria-controls"] = expanded ? listElement?.id : void 0;
      reference["aria-autocomplete"] = readOnly ? "none" : autoComplete;
    }
    return {
      reference,
      floating: {
        role: "presentation"
      }
    };
  }, [inputElement, expanded, ariaExpanded, ariaHasPopup, listElement?.id, autoComplete, readOnly]);
  const click = useClick(floatingRootContext, {
    enabled: !disabled2 && openOnInputClick,
    event: "mousedown-only",
    toggle: false,
    // Apply a small delay for touch to let mobile viewport/keyboard positioning settle.
    // This avoids top-bottom flip flickers if the preferred position is "top" when first tapping.
    touchOpenDelay: inputInsidePopup ? 0 : 100,
    reason: reason_parts_exports.inputPress
  });
  const dismiss2 = useDismiss(floatingRootContext, {
    enabled: !disabled2 && !inline4,
    outsidePressEvent: {
      mouse: "sloppy",
      // The visual viewport (affected by the mobile software keyboard) can be
      // somewhat small. The user may want to scroll the screen to see more of
      // the popup.
      touch: "intentional"
    },
    // Without a popup, let the Escape key bubble the event up to other popups' handlers.
    bubbles: inline4 ? true : void 0,
    outsidePress(event) {
      const target = getTarget(event);
      return !contains(triggerElement, target) && !contains(clearRef.current, target) && !contains(chipsContainerRef.current, target) && !contains(inputGroupElement, target);
    }
  });
  const listNavigation2 = useListNavigation(floatingRootContext, {
    enabled: !disabled2,
    id,
    listRef,
    activeIndex,
    selectedIndex,
    virtual: true,
    loopFocus,
    allowEscape: loopFocus && !autoHighlightMode,
    focusItemOnOpen: queryChangedAfterOpen || selectionMode === "none" && !autoHighlightMode ? false : "auto",
    focusItemOnHover: highlightItemOnHover,
    resetOnPointerLeave: !keepHighlight,
    orientation: grid ? "horizontal" : void 0,
    rtl: direction === "rtl",
    disabledIndices: EMPTY_ARRAY,
    grid: grid ? gridNavigation : void 0,
    onNavigate(nextActiveIndex, event) {
      if (!event && !open2 || transitionStatus === "ending") {
        return;
      }
      if (!event) {
        setIndices({
          activeIndex: nextActiveIndex
        });
      } else {
        setIndices({
          activeIndex: nextActiveIndex,
          type: keyboardActiveRef.current ? reason_parts_exports.keyboard : reason_parts_exports.pointer
        });
      }
    }
  });
  const inputProps = React51.useMemo(() => mergeProps(listNavigation2.reference, {
    onKeyDown(event) {
      if (grid && store.state.activeIndex == null && (event.key === "ArrowLeft" || event.key === "ArrowRight")) {
        event.preventBaseUIHandler();
      }
    }
  }, dismiss2.reference, click.reference, role.reference), [listNavigation2.reference, dismiss2.reference, click.reference, role.reference, grid, store]);
  const popupProps = React51.useMemo(() => mergeProps(FOCUSABLE_POPUP_PROPS, dismiss2.floating), [dismiss2.floating]);
  const listProps = React51.useMemo(() => mergeProps(listNavigation2.floating, role.floating), [listNavigation2.floating, role.floating]);
  const itemProps = React51.useMemo(() => {
    const listNavigationItemProps = listNavigation2.item;
    if (!listNavigationItemProps) {
      return EMPTY_OBJECT;
    }
    return {
      ...listNavigationItemProps,
      onFocus: void 0
    };
  }, [listNavigation2.item]);
  store.useContextCallback("setOpen", setOpen);
  store.useContextCallback("setInputValue", setInputValue);
  store.useContextCallback("setSelectedValue", setSelectedValue);
  store.useContextCallback("setIndices", setIndices);
  store.useContextCallback("handleSelection", handleSelection);
  store.useContextCallback("forceMount", forceMount);
  store.useContextCallback("requestSubmit", requestSubmit);
  store.useContextCallback("onOpenChangeComplete", onOpenChangeCompleteProp);
  useOnFirstRender(() => {
    store.update({
      inline: inlineProp,
      popupProps,
      listProps,
      inputProps,
      triggerProps,
      itemProps
    });
  });
  const syncedValues = {
    id,
    selectedValue,
    open: open2,
    mounted,
    transitionStatus,
    items: storeItems,
    inline: inlineProp,
    popupProps,
    listProps,
    inputProps,
    triggerProps,
    itemProps,
    openMethod,
    selectionMode,
    name: name2,
    form,
    disabled: disabled2,
    readOnly,
    required,
    grid,
    virtualized,
    openOnInputClick,
    itemToStringLabel,
    modal,
    autoHighlight: autoHighlightMode,
    isItemEqualToValue,
    submitOnItemClick,
    hasInputValue
  };
  useIsoLayoutEffect(() => {
    store.update({
      ...syncedValues,
      inputOwnsFormValue: selectionMode === "none" && (inlineProp || !store.state.inputInsidePopup)
    });
  }, [store, ...Object.values(syncedValues)]);
  const hiddenInputRef = useMergedRefs(inputRefProp, validation.inputRef);
  const itemsContextValue = React51.useMemo(() => ({
    query,
    hasItems,
    filteredItems,
    flatFilteredValues
  }), [query, hasItems, filteredItems, flatFilteredValues]);
  const serializedValue = React51.useMemo(() => {
    if (Array.isArray(fieldRawValue)) {
      return "";
    }
    return stringifyAsValue(fieldRawValue, itemToStringValue);
  }, [fieldRawValue, itemToStringValue]);
  const hasMultipleSelection = multiple && Array.isArray(selectedValue) && selectedValue.length > 0;
  const hiddenInputName = multiple || selectionMode === "none" && inputOwnsFormValue ? void 0 : name2;
  const hiddenInputs = React51.useMemo(() => {
    if (!multiple || !Array.isArray(selectedValue) || !name2) {
      return null;
    }
    return selectedValue.map((value) => {
      const currentSerializedValue = stringifyAsValue(value, itemToStringValue);
      return /* @__PURE__ */ _jsx6("input", {
        type: "hidden",
        form,
        name: name2,
        value: currentSerializedValue,
        disabled: disabled2
      }, currentSerializedValue);
    });
  }, [multiple, selectedValue, form, name2, itemToStringValue, disabled2]);
  const children = /* @__PURE__ */ _jsxs3(React51.Fragment, {
    children: [props.children, /* @__PURE__ */ _jsx6("input", {
      ...validation.getValidationProps(disabled2, {
        // Move focus when the hidden input is focused.
        onFocus() {
          if (inputInsidePopup) {
            triggerElement?.focus();
            return;
          }
          (inputRef.current || triggerElement)?.focus();
        },
        // Handle browser autofill.
        onChange(event) {
          if (event.nativeEvent.defaultPrevented || disabled2 || readOnly) {
            return;
          }
          const nextValue = event.currentTarget.value;
          const nextValueLower = nextValue.toLowerCase();
          const details = createChangeEventDetails(reason_parts_exports.none, event.nativeEvent);
          const findSerializedMatchIndex = () => valuesRef.current.findIndex((candidate) => stringifyAsValue(candidate, itemToStringValue).toLowerCase() === nextValueLower || stringifyValueLabel(candidate).toLowerCase() === nextValueLower);
          function handleChange() {
            if (multiple) {
              return;
            }
            if (selectionMode === "none") {
              setInputValue(nextValue, details);
              return;
            }
            let matchingIndex = findSerializedMatchIndex();
            if (matchingIndex === -1) {
              matchingIndex = valuesRef.current.findIndex((_, index2) => {
                const renderedLabel = labelsRef.current[index2];
                return renderedLabel != null && renderedLabel.toLowerCase() === nextValueLower;
              });
            }
            const matchingValue = matchingIndex === -1 ? void 0 : valuesRef.current[matchingIndex];
            if (matchingValue != null) {
              setSelectedValue?.(matchingValue, details);
            }
          }
          if (single) {
            forceMount();
            if (items && findSerializedMatchIndex() === -1) {
              store.set("forceMounted", true);
            }
          }
          queueMicrotask(handleChange);
        }
      }),
      id: id && hiddenInputName == null ? `${id}-hidden-input` : void 0,
      form,
      name: hiddenInputName,
      autoComplete: formAutoComplete,
      disabled: disabled2,
      required: required && !hasMultipleSelection,
      readOnly,
      value: serializedValue,
      ref: hiddenInputRef,
      style: hiddenInputName ? visuallyHiddenInput : visuallyHidden,
      tabIndex: -1,
      "aria-hidden": true,
      suppressHydrationWarning: true
    }), hiddenInputs]
  });
  return /* @__PURE__ */ _jsx6(ComboboxRootContext.Provider, {
    value: store,
    children: /* @__PURE__ */ _jsx6(ComboboxFloatingContext.Provider, {
      value: floatingRootContext,
      children: /* @__PURE__ */ _jsx6(ComboboxHasItemsContext.Provider, {
        value: hasItems,
        children: /* @__PURE__ */ _jsx6(ComboboxDerivedItemsContext.Provider, {
          value: itemsContextValue,
          children: /* @__PURE__ */ _jsx6(ComboboxInputValueContext.Provider, {
            value: inputValue,
            children
          })
        })
      })
    })
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/ComboboxRoot.mjs
import { jsx as _jsx7 } from "react/jsx-runtime";
function ComboboxRoot(props) {
  const {
    multiple = false,
    defaultValue,
    value,
    onValueChange,
    autoComplete,
    ...other
  } = props;
  return /* @__PURE__ */ _jsx7(AriaCombobox, {
    ...other,
    selectionMode: multiple ? "multiple" : "single",
    selectedValue: value,
    defaultSelectedValue: defaultValue,
    onSelectedValueChange: onValueChange,
    formAutoComplete: autoComplete
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/label/ComboboxLabel.mjs
import * as React53 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/useRegisteredLabelId.mjs
function useRegisteredLabelId(idProp, setLabelId) {
  const id = useBaseUiId(idProp);
  useIsoLayoutEffect(() => {
    setLabelId(id);
    return () => {
      setLabelId((currentId) => currentId === id ? void 0 : currentId);
    };
  }, [id, setLabelId]);
  return id;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/labelable-provider/useLabel.mjs
function useLabel(params = {}) {
  const {
    id: idProp,
    fallbackControlId,
    native = false,
    setLabelId: setLabelIdProp,
    focusControl: focusControlProp
  } = params;
  const {
    controlId: contextControlId,
    setLabelId: setContextLabelId
  } = useLabelableContext();
  const syncLabelId = useStableCallback((nextLabelId) => {
    setContextLabelId(nextLabelId);
    setLabelIdProp?.(nextLabelId);
  });
  const id = useRegisteredLabelId(idProp, syncLabelId);
  const resolvedControlId = contextControlId ?? fallbackControlId;
  function focusControl(event) {
    if (focusControlProp) {
      focusControlProp(event, resolvedControlId);
      return;
    }
    if (!resolvedControlId) {
      return;
    }
    const controlElement = ownerDocument(event.currentTarget).getElementById(resolvedControlId);
    if (isHTMLElement(controlElement)) {
      focusElementWithVisible(controlElement);
    }
  }
  function handleInteraction(event) {
    const target = getTarget(event.nativeEvent);
    if (target?.closest("button,input,select,textarea")) {
      return;
    }
    if (!event.defaultPrevented && event.detail > 1) {
      event.preventDefault();
    }
    if (native) {
      return;
    }
    focusControl(event);
  }
  return native ? {
    id,
    htmlFor: resolvedControlId,
    onMouseDown: handleInteraction
  } : {
    id,
    onClick: handleInteraction,
    onPointerDown(event) {
      event.preventDefault();
    }
  };
}
function focusElementWithVisible(element2) {
  element2.focus({
    // Available from Chrome 144+ (January 2026).
    // Safari and Firefox already support it.
    focusVisible: true
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/resolveAriaLabelledBy.mjs
function getDefaultLabelId(id) {
  return id == null ? void 0 : `${id}-label`;
}
function resolveAriaLabelledBy(fieldLabelId, localLabelId) {
  return fieldLabelId ?? localLabelId;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/label/ComboboxLabel.mjs
var ComboboxLabel = /* @__PURE__ */ React53.forwardRef(function ComboboxLabel2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const elementPropsWithoutId = elementProps;
  delete elementPropsWithoutId.id;
  const fieldRootContext = useFieldRootContext();
  const store = useComboboxRootContext();
  const inputInsidePopup = store.useState("inputInsidePopup");
  const triggerElement = store.useState("triggerElement");
  const inputElement = store.useState("inputElement");
  const rootId = store.useState("id");
  const defaultLabelId = getDefaultLabelId(rootId);
  const localControlId = triggerElement?.id ?? (inputInsidePopup ? rootId : void 0);
  if (process.env.NODE_ENV !== "production") {
    React53.useEffect(() => {
      if (!inputElement || inputInsidePopup) {
        return;
      }
      const ownerStackMessage = SafeReact.captureOwnerStack?.() || "";
      const message = "<Combobox.Label> labels <Combobox.Trigger> only. When <Combobox.Input> is the form control, use a native <label> or <Field.Label> instead.";
      error(`${message}${ownerStackMessage}`);
    }, [inputElement, inputInsidePopup]);
  }
  const labelProps = useLabel({
    id: defaultLabelId,
    fallbackControlId: localControlId,
    setLabelId(nextLabelId) {
      const resolvedLabelId = typeof nextLabelId === "function" ? nextLabelId(store.state.labelId) : nextLabelId;
      store.set("labelId", resolvedLabelId);
    }
  });
  return useRenderElement("div", componentProps, {
    ref: forwardedRef,
    state: fieldRootContext.state,
    props: [labelProps, elementProps],
    stateAttributesMapping: fieldValidityMapping
  });
});
if (process.env.NODE_ENV !== "production") ComboboxLabel.displayName = "ComboboxLabel";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/value/ComboboxValue.mjs
import * as React54 from "react";
import { jsx as _jsx8 } from "react/jsx-runtime";
function ComboboxValue(props) {
  const {
    children: childrenProp,
    placeholder
  } = props;
  const store = useComboboxRootContext();
  const itemToStringLabel = store.useState("itemToStringLabel");
  const selectedValue = store.useState("selectedValue");
  const items = store.useState("items");
  const multiple = store.useState("selectionMode") === "multiple";
  const hasSelectedValue = store.useState("hasSelectedValue");
  const shouldCheckNullItemLabel = !hasSelectedValue && placeholder != null && childrenProp == null;
  const hasNullLabel = store.useState("hasNullItemLabel", shouldCheckNullItemLabel);
  let children = null;
  if (typeof childrenProp === "function") {
    children = childrenProp(selectedValue);
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (!hasSelectedValue && placeholder != null && !hasNullLabel) {
    children = placeholder;
  } else if (multiple && Array.isArray(selectedValue)) {
    children = resolveMultipleLabels(selectedValue, items, itemToStringLabel);
  } else {
    children = resolveSelectedLabel(selectedValue, items, itemToStringLabel);
  }
  return /* @__PURE__ */ _jsx8(React54.Fragment, {
    children
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/input/ComboboxInput.mjs
import * as React61 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/input/ComboboxInputDataAttributes.mjs
var popupOpen2 = CommonTriggerDataAttributes_exports.popupOpen;
var pressed2 = CommonTriggerDataAttributes_exports.pressed;
var popupSide = "data-popup-side";
var listEmpty = "data-list-empty";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/utils/stateAttributesMapping.mjs
var triggerStateAttributesMapping = {
  ...pressableTriggerOpenStateMapping,
  ...fieldValidityMapping,
  popupSide: (side) => side ? {
    [popupSide]: side
  } : null,
  listEmpty: (empty2) => empty2 ? {
    [listEmpty]: ""
  } : null
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/chips/ComboboxChipsContext.mjs
import * as React55 from "react";
var ComboboxChipsContext = /* @__PURE__ */ React55.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxChipsContext.displayName = "ComboboxChipsContext";
function useComboboxChipsContext() {
  return React55.useContext(ComboboxChipsContext);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/positioner/ComboboxPositionerContext.mjs
import * as React56 from "react";
var ComboboxPositionerContext = /* @__PURE__ */ React56.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxPositionerContext.displayName = "ComboboxPositionerContext";
function useComboboxPositionerContext(optional) {
  const context = React56.useContext(ComboboxPositionerContext);
  if (context === void 0 && !optional) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Popup> and <Combobox.Arrow> must be used within the <Combobox.Positioner> component" : formatErrorMessage_default(21));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/utils/ComboboxInternalDismissButton.mjs
import * as React60 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/use-button/useButton.mjs
import * as React59 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/composite/root/CompositeRootContext.mjs
import * as React57 from "react";
var CompositeRootContext = /* @__PURE__ */ React57.createContext(void 0);
if (process.env.NODE_ENV !== "production") CompositeRootContext.displayName = "CompositeRootContext";
function useCompositeRootContext(optional = false) {
  const context = React57.useContext(CompositeRootContext);
  if (context === void 0 && !optional) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : formatErrorMessage_default(16));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/useFocusableWhenDisabled.mjs
import * as React58 from "react";
function useFocusableWhenDisabled(parameters) {
  const {
    focusableWhenDisabled,
    disabled: disabled2,
    composite = false,
    tabIndex: tabIndexProp = 0,
    isNativeButton
  } = parameters;
  const isFocusableComposite = composite && focusableWhenDisabled !== false;
  const isNonFocusableComposite = composite && focusableWhenDisabled === false;
  const props = React58.useMemo(() => {
    const additionalProps = {
      // allow Tabbing away from focusableWhenDisabled elements
      onKeyDown(event) {
        if (disabled2 && focusableWhenDisabled && event.key !== "Tab") {
          event.preventDefault();
        }
      }
    };
    if (!composite) {
      additionalProps.tabIndex = tabIndexProp;
      if (!isNativeButton && disabled2) {
        additionalProps.tabIndex = focusableWhenDisabled ? tabIndexProp : -1;
      }
    }
    if (isNativeButton && (focusableWhenDisabled || isFocusableComposite) || !isNativeButton && disabled2) {
      additionalProps["aria-disabled"] = disabled2;
    }
    if (isNativeButton && (!focusableWhenDisabled || isNonFocusableComposite)) {
      additionalProps.disabled = disabled2;
    }
    return additionalProps;
  }, [composite, disabled2, focusableWhenDisabled, isFocusableComposite, isNonFocusableComposite, isNativeButton, tabIndexProp]);
  return {
    props
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/dispatchClickWithModifiers.mjs
function dispatchClickWithModifiers(target, sourceEvent, {
  detail = 0
} = {}) {
  target.dispatchEvent(new (getWindow(target)).PointerEvent("click", {
    bubbles: true,
    cancelable: true,
    composed: true,
    detail,
    shiftKey: sourceEvent.shiftKey,
    ctrlKey: sourceEvent.ctrlKey,
    altKey: sourceEvent.altKey,
    metaKey: sourceEvent.metaKey
  }));
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/use-button/useButton.mjs
function useButton(parameters = {}) {
  const {
    disabled: disabled2 = false,
    focusableWhenDisabled,
    tabIndex = 0,
    native: isNativeButton = true,
    composite: compositeProp
  } = parameters;
  const elementRef = React59.useRef(null);
  const compositeRootContext = useCompositeRootContext(true);
  const isCompositeItem = compositeProp ?? compositeRootContext !== void 0;
  const {
    props: focusableWhenDisabledProps
  } = useFocusableWhenDisabled({
    focusableWhenDisabled,
    disabled: disabled2,
    composite: isCompositeItem,
    tabIndex,
    isNativeButton
  });
  if (process.env.NODE_ENV !== "production") {
    React59.useEffect(() => {
      if (!elementRef.current) {
        return;
      }
      const isButtonTag = isButtonElement(elementRef.current);
      if (isNativeButton) {
        if (!isButtonTag) {
          const ownerStackMessage = SafeReact.captureOwnerStack?.() || "";
          const message = "A component that acts as a button expected a native <button> because the `nativeButton` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the `render` prop, or set `nativeButton` to `false`.";
          error(`${message}${ownerStackMessage}`);
        }
      } else if (isButtonTag) {
        const ownerStackMessage = SafeReact.captureOwnerStack?.() || "";
        const message = "A component that acts as a button expected a non-<button> because the `nativeButton` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as `role` or `aria-disabled`). Use a non-<button> in the `render` prop, or set `nativeButton` to `true`.";
        error(`${message}${ownerStackMessage}`);
      }
    }, [isNativeButton]);
  }
  const updateDisabled = React59.useCallback(() => {
    const element2 = elementRef.current;
    if (!isButtonElement(element2)) {
      return;
    }
    if (isCompositeItem && disabled2 && focusableWhenDisabledProps.disabled === void 0 && element2.disabled) {
      element2.disabled = false;
    }
  }, [disabled2, focusableWhenDisabledProps.disabled, isCompositeItem]);
  useIsoLayoutEffect(updateDisabled, [updateDisabled]);
  const getButtonProps = React59.useCallback((externalProps = {}) => {
    const {
      onClick: externalOnClick,
      onMouseDown: externalOnMouseDown,
      onKeyUp: externalOnKeyUp,
      onKeyDown: externalOnKeyDown,
      onPointerDown: externalOnPointerDown,
      ...otherExternalProps
    } = externalProps;
    return mergeProps({
      onClick(event) {
        if (disabled2) {
          event.preventDefault();
          return;
        }
        externalOnClick?.(event);
      },
      onMouseDown(event) {
        if (!disabled2) {
          externalOnMouseDown?.(event);
        }
      },
      onKeyDown(event) {
        if (disabled2) {
          return;
        }
        makeEventPreventable(event);
        externalOnKeyDown?.(event);
        if (event.baseUIHandlerPrevented) {
          return;
        }
        const isCurrentTarget = event.target === event.currentTarget;
        const currentTarget = event.currentTarget;
        const isButton = isButtonElement(currentTarget);
        const isLink = !isNativeButton && isValidLinkElement(currentTarget);
        const shouldClick = isCurrentTarget && (isNativeButton ? isButton : !isLink);
        const isEnterKey = event.key === "Enter";
        const isSpaceKey = event.key === " ";
        const role = currentTarget.getAttribute("role");
        const isTextNavigationRole = role?.startsWith("menuitem") || role === "option" || role === "gridcell";
        if (isCurrentTarget && isCompositeItem && isSpaceKey) {
          if (event.defaultPrevented && isTextNavigationRole) {
            return;
          }
          event.preventDefault();
          if (!isNativeButton || isButton) {
            event.preventBaseUIHandler();
            dispatchClickWithModifiers(currentTarget, event);
          }
          return;
        }
        if (!shouldClick || isNativeButton || !isSpaceKey && !isEnterKey) {
          if (isCurrentTarget && isLink && isSpaceKey) {
            event.preventDefault();
          }
          return;
        }
        if (event.defaultPrevented) {
          return;
        }
        event.preventDefault();
        if (isEnterKey) {
          event.preventBaseUIHandler();
          dispatchClickWithModifiers(currentTarget, event);
        }
      },
      onKeyUp(event) {
        if (disabled2) {
          return;
        }
        makeEventPreventable(event);
        externalOnKeyUp?.(event);
        if (event.target === event.currentTarget && isNativeButton && isCompositeItem && isButtonElement(event.currentTarget) && event.key === " ") {
          event.preventDefault();
          return;
        }
        if (event.baseUIHandlerPrevented) {
          return;
        }
        if (event.target === event.currentTarget && !isNativeButton && !isCompositeItem && !event.defaultPrevented && event.key === " ") {
          event.preventBaseUIHandler();
          dispatchClickWithModifiers(event.currentTarget, event);
        }
      },
      onPointerDown(event) {
        if (disabled2) {
          event.preventDefault();
          return;
        }
        externalOnPointerDown?.(event);
      }
    }, isNativeButton ? {
      type: "button"
    } : {
      role: "button"
    }, focusableWhenDisabledProps, otherExternalProps);
  }, [disabled2, focusableWhenDisabledProps, isCompositeItem, isNativeButton]);
  const buttonRef = useStableCallback((element2) => {
    elementRef.current = element2;
    updateDisabled();
  });
  return {
    getButtonProps,
    buttonRef
  };
}
function isButtonElement(elem) {
  return isHTMLElement(elem) && elem.tagName === "BUTTON";
}
function isValidLinkElement(elem) {
  return isHTMLElement(elem) && elem.tagName === "A" && Boolean(elem.href);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/utils/ComboboxInternalDismissButton.mjs
import { jsx as _jsx9 } from "react/jsx-runtime";
var ComboboxInternalDismissButton = /* @__PURE__ */ React60.forwardRef(function ComboboxInternalDismissButton2(_, forwardedRef) {
  const store = useComboboxRootContext();
  const {
    buttonRef,
    getButtonProps
  } = useButton({
    native: false
  });
  const mergedRef = useMergedRefs(forwardedRef, buttonRef);
  function handleDismiss(event) {
    store.context.setOpen(false, createChangeEventDetails(reason_parts_exports.closePress, event.nativeEvent, event.currentTarget));
  }
  const dismissProps = getButtonProps({
    onClick: handleDismiss
  });
  return /* @__PURE__ */ _jsx9("span", {
    ref: mergedRef,
    ...dismissProps,
    "aria-label": "Dismiss",
    tabIndex: void 0,
    style: visuallyHiddenInput
  });
});
if (process.env.NODE_ENV !== "production") ComboboxInternalDismissButton.displayName = "ComboboxInternalDismissButton";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/utils/parts.mjs
function usePopupSide(store) {
  const mounted = store.useState("mounted");
  const popupSide2 = store.useState("popupSide");
  const positionerElement = store.useState("positionerElement");
  return mounted && positionerElement ? popupSide2 : null;
}
function useListEmpty() {
  return useComboboxDerivedItemsContext().filteredItems.length === 0;
}
function getChipNavigationKeys(direction) {
  return direction === "rtl" ? ["ArrowRight", "ArrowLeft"] : ["ArrowLeft", "ArrowRight"];
}
function getIndexAfterChipRemoval(index2, chipCount) {
  const nextIndex = index2 >= chipCount - 1 ? chipCount - 2 : index2;
  return nextIndex >= 0 ? nextIndex : void 0;
}
function clickHighlightedItem(store, activeIndex, nativeEvent) {
  const listItem2 = store.context.listRef.current[activeIndex];
  if (listItem2) {
    store.context.selectionEventRef.current = nativeEvent;
    listItem2.click();
    store.context.selectionEventRef.current = null;
  }
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/input/ComboboxInput.mjs
import { jsx as _jsx10, jsxs as _jsxs4 } from "react/jsx-runtime";
var ComboboxInput = /* @__PURE__ */ React61.forwardRef(function ComboboxInput2(componentProps, forwardedRef) {
  const {
    render,
    className,
    disabled: disabledProp = false,
    id: idProp,
    style,
    ...elementProps
  } = componentProps;
  const {
    state: fieldState,
    disabled: fieldDisabled,
    setTouched,
    setFocused,
    validationMode,
    validation
  } = useFieldRootContext();
  const {
    labelId: fieldLabelId
  } = useLabelableContext();
  const comboboxChipsContext = useComboboxChipsContext();
  const positioning = useComboboxPositionerContext(true);
  const hasPositionerParent = Boolean(positioning);
  const store = useComboboxRootContext();
  const inputValue = useComboboxInputValueContext();
  const direction = useDirection3();
  const required = store.useState("required");
  const comboboxDisabled = store.useState("disabled");
  const readOnly = store.useState("readOnly");
  const name2 = store.useState("name");
  const form = store.useState("form");
  const selectionMode = store.useState("selectionMode");
  const autoHighlightMode = store.useState("autoHighlight");
  const inputProps = store.useState("inputProps");
  const triggerProps = store.useState("triggerProps");
  const open2 = store.useState("open");
  const mounted = store.useState("mounted");
  const selectedValue = store.useState("selectedValue");
  const rootId = store.useState("id");
  const inline4 = store.useState("inline");
  const modal = store.useState("modal");
  const autoHighlightEnabled = Boolean(autoHighlightMode);
  const popupSide2 = usePopupSide(store);
  const disabled2 = fieldDisabled || comboboxDisabled || disabledProp;
  const listEmpty2 = useListEmpty();
  const isInsidePopup = hasPositionerParent || inline4;
  const focusManagerModal = !isInsidePopup || modal;
  const id = useBaseUiId(idProp ?? (!isInsidePopup ? rootId : void 0));
  const fieldStateForInput = hasPositionerParent ? DEFAULT_FIELD_STATE_ATTRIBUTES : fieldState;
  const [composingValue, setComposingValue] = React61.useState(null);
  const isComposingRef = React61.useRef(false);
  const lastActiveIndexRef = React61.useRef(null);
  const shouldRestoreActiveIndexRef = React61.useRef(false);
  const inputOwnsFormValue = selectionMode === "none" && !hasPositionerParent;
  const setInputElement = useStableCallback((element3) => {
    const nextIsInsidePopup = hasPositionerParent || store.state.inline;
    if (nextIsInsidePopup && !store.state.hasInputValue) {
      store.context.setInputValue("", createChangeEventDetails(reason_parts_exports.none));
    }
    store.update({
      inputElement: element3,
      inputInsidePopup: nextIsInsidePopup,
      inputOwnsFormValue
    });
  });
  const validationProps = hasPositionerParent ? elementProps : validation.getValidationProps(disabled2, elementProps);
  function clearHighlight() {
    store.context.setIndices({
      activeIndex: null,
      selectedIndex: null,
      type: store.context.keyboardActiveRef.current ? reason_parts_exports.keyboard : reason_parts_exports.pointer
    });
  }
  function markPointerActive() {
    store.context.keyboardActiveRef.current = false;
  }
  const state = {
    ...fieldStateForInput,
    open: open2,
    disabled: disabled2,
    readOnly,
    popupSide: popupSide2,
    listEmpty: listEmpty2
  };
  function handleKeyDown(event) {
    if (!comboboxChipsContext) {
      return void 0;
    }
    let nextIndex;
    const {
      highlightedChipIndex
    } = comboboxChipsContext;
    const renderedChipsCount = comboboxChipsContext.chipsRef.current.length;
    const [previousChipKey, nextChipKey] = getChipNavigationKeys(direction);
    if (highlightedChipIndex !== void 0) {
      if (event.key === previousChipKey) {
        event.preventDefault();
        if (highlightedChipIndex > 0) {
          nextIndex = highlightedChipIndex - 1;
        } else {
          nextIndex = void 0;
        }
      } else if (event.key === nextChipKey) {
        event.preventDefault();
        if (highlightedChipIndex < renderedChipsCount - 1) {
          nextIndex = highlightedChipIndex + 1;
        } else {
          nextIndex = void 0;
        }
      } else if (event.key === "Backspace" || event.key === "Delete") {
        event.preventDefault();
        nextIndex = getIndexAfterChipRemoval(highlightedChipIndex, selectedValue.length);
        clearHighlight();
      }
      return nextIndex;
    }
    if (event.key === previousChipKey && (event.currentTarget.selectionStart ?? 0) === 0 && selectedValue.length > 0) {
      event.preventDefault();
      nextIndex = renderedChipsCount > 0 ? renderedChipsCount - 1 : void 0;
    }
    return nextIndex;
  }
  const element2 = useRenderElement("input", componentProps, {
    state,
    ref: [forwardedRef, store.context.inputRef, setInputElement],
    props: [inputProps, triggerProps, {
      value: composingValue ?? inputValue,
      "aria-readonly": readOnly || void 0,
      "aria-required": required || void 0,
      "aria-labelledby": fieldLabelId,
      disabled: disabled2,
      readOnly,
      required: selectionMode === "none" ? required : void 0,
      form,
      ...inputOwnsFormValue && name2 && {
        name: name2
      },
      id,
      onFocus() {
        setFocused(true);
        if (!inline4 || !shouldRestoreActiveIndexRef.current) {
          return;
        }
        shouldRestoreActiveIndexRef.current = false;
        const nextActiveIndex = lastActiveIndexRef.current;
        if (nextActiveIndex == null || // `valuesRef` can be sparse, so guard against restoring a removed slot.
        !Object.hasOwn(store.context.valuesRef.current, nextActiveIndex)) {
          return;
        }
        store.context.setIndices({
          activeIndex: nextActiveIndex
        });
      },
      onBlur() {
        setTouched(true);
        setFocused(false);
        const activeIndex = store.state.activeIndex;
        if (inline4 && activeIndex !== null && autoHighlightMode !== "always") {
          lastActiveIndexRef.current = activeIndex;
          shouldRestoreActiveIndexRef.current = true;
          store.context.setIndices({
            activeIndex: null
          });
        }
        if (validationMode === "onBlur") {
          const valueToValidate = selectionMode === "none" ? inputValue : selectedValue;
          validation.commit(valueToValidate);
        }
      },
      onCompositionStart(event) {
        if (parts_exports.os.android) {
          return;
        }
        isComposingRef.current = true;
        setComposingValue(event.currentTarget.value);
      },
      onCompositionEnd(event) {
        isComposingRef.current = false;
        const next = event.currentTarget.value;
        setComposingValue(null);
        store.context.setInputValue(next, createChangeEventDetails(reason_parts_exports.inputChange, event.nativeEvent));
      },
      onChange(event) {
        const nativeEvent = event.nativeEvent;
        const inputType = nativeEvent.inputType;
        const autofillLikeInput = !inputType || inputType === "insertReplacementText";
        const shouldOpenOnInput = isComposingRef.current || !autofillLikeInput;
        function maybeOpenOnInput(trimmed) {
          if (readOnly || disabled2 || !trimmed || !shouldOpenOnInput) {
            return;
          }
          store.context.setOpen(true, createChangeEventDetails(reason_parts_exports.inputChange, nativeEvent));
          if (!autoHighlightEnabled) {
            clearHighlight();
          }
        }
        if (isComposingRef.current) {
          const nextVal = event.currentTarget.value;
          setComposingValue(nextVal);
          if (nextVal === "" && !store.state.openOnInputClick && !store.state.inputInsidePopup) {
            store.context.setOpen(false, createChangeEventDetails(reason_parts_exports.inputClear, nativeEvent));
          }
          const trimmed = nextVal.trim();
          const shouldMaintainHighlight = autoHighlightEnabled && trimmed !== "";
          maybeOpenOnInput(trimmed);
          if (open2 && store.state.activeIndex !== null && !shouldMaintainHighlight) {
            clearHighlight();
          }
          return;
        }
        const inputChangeDetails = createChangeEventDetails(reason_parts_exports.inputChange, nativeEvent);
        store.context.setInputValue(event.currentTarget.value, inputChangeDetails);
        if (inputChangeDetails.isCanceled) {
          return;
        }
        const empty2 = event.currentTarget.value === "";
        const clearDetails = createChangeEventDetails(reason_parts_exports.inputClear, nativeEvent);
        if (empty2 && !store.state.inputInsidePopup) {
          if (selectionMode === "single") {
            store.context.setSelectedValue(null, clearDetails);
          }
          if (!store.state.openOnInputClick) {
            store.context.setOpen(false, clearDetails);
          }
        }
        maybeOpenOnInput(event.currentTarget.value.trim());
        if (open2 && store.state.activeIndex !== null && !autoHighlightEnabled) {
          clearHighlight();
        }
      },
      onKeyDown(event) {
        if (event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) {
          return;
        }
        store.context.keyboardActiveRef.current = true;
        if (disabled2 || readOnly) {
          if (readOnly && event.key === "Enter" && open2 && store.state.activeIndex !== null) {
            stopEvent(event);
          }
          return;
        }
        const input = event.currentTarget;
        const scrollAmount = input.scrollWidth - input.clientWidth;
        const isRTL2 = direction === "rtl";
        if (event.key === "Home") {
          stopEvent(event);
          const cursor = parts_exports.engine.gecko && isRTL2 ? input.value.length : 0;
          input.setSelectionRange(cursor, cursor);
          input.scrollLeft = 0;
          return;
        }
        if (event.key === "End") {
          stopEvent(event);
          const cursor = parts_exports.engine.gecko && isRTL2 ? 0 : input.value.length;
          input.setSelectionRange(cursor, cursor);
          input.scrollLeft = isRTL2 ? -scrollAmount : scrollAmount;
          return;
        }
        if (!mounted && event.key === "Escape") {
          const isClear = selectionMode === "multiple" && Array.isArray(selectedValue) ? selectedValue.length === 0 : selectedValue === null;
          const details = createChangeEventDetails(reason_parts_exports.escapeKey, event.nativeEvent);
          const value = selectionMode === "multiple" ? [] : null;
          store.context.setInputValue("", details);
          store.context.setSelectedValue(value, details);
          if (!isClear && !store.state.inline && !details.isPropagationAllowed) {
            event.stopPropagation();
          }
          return;
        }
        if (comboboxChipsContext && event.key === "Backspace" && input.value === "" && comboboxChipsContext.highlightedChipIndex === void 0 && Array.isArray(selectedValue) && selectedValue.length > 0) {
          const renderedChipsCount = comboboxChipsContext.chipsRef.current.length;
          const removalIndex = renderedChipsCount > 0 ? renderedChipsCount - 1 : selectedValue.length - 1;
          const newValue = selectedValue.filter((_, index2) => index2 !== removalIndex);
          clearHighlight();
          store.context.setSelectedValue(newValue, createChangeEventDetails(reason_parts_exports.none, event.nativeEvent));
          return;
        }
        const hadHighlightedChip = comboboxChipsContext?.highlightedChipIndex !== void 0;
        const nextIndex = handleKeyDown(event);
        comboboxChipsContext?.setHighlightedChipIndex(nextIndex);
        if (nextIndex !== void 0) {
          comboboxChipsContext?.chipsRef.current[nextIndex]?.focus();
        } else if (hadHighlightedChip) {
          store.context.inputRef.current?.focus();
        }
        if (event.which === 229) {
          return;
        }
        if (event.key === "Enter" && open2) {
          const activeIndex = store.state.activeIndex;
          const nativeEvent = event.nativeEvent;
          if (activeIndex === null) {
            if (inline4) {
              return;
            }
            store.context.setOpen(false, createChangeEventDetails(reason_parts_exports.none, nativeEvent));
            return;
          }
          stopEvent(event);
          clickHighlightedItem(store, activeIndex, nativeEvent);
        }
      },
      onPointerMove: markPointerActive,
      onPointerDown: markPointerActive
    }, validationProps],
    stateAttributesMapping: triggerStateAttributesMapping
  });
  const renderedInput = hasPositionerParent ? /* @__PURE__ */ _jsx10(FieldRootContext.Provider, {
    value: DEFAULT_FIELD_ROOT_CONTEXT,
    children: element2
  }) : element2;
  return /* @__PURE__ */ _jsxs4(React61.Fragment, {
    children: [open2 && focusManagerModal && /* @__PURE__ */ _jsx10(ComboboxInternalDismissButton, {
      ref: store.context.startDismissRef
    }), renderedInput]
  });
});
if (process.env.NODE_ENV !== "production") ComboboxInput.displayName = "ComboboxInput";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/input-group/ComboboxInputGroup.mjs
import * as React62 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/utils/handleInputPress.mjs
function handleInputPress(event, store, disabled2, shouldIgnoreTarget) {
  if (event.baseUIHandlerPrevented) {
    return;
  }
  const target = getTarget(event.nativeEvent);
  const targetElement = isElement(target) ? target : null;
  if (targetElement !== event.currentTarget && (shouldIgnoreTarget?.(targetElement) || isInteractiveElement(targetElement))) {
    return;
  }
  event.preventDefault();
  if (disabled2) {
    return;
  }
  store.context.inputRef.current?.focus();
  if (store.state.openOnInputClick) {
    store.context.setOpen(true, createChangeEventDetails(reason_parts_exports.inputPress, event.nativeEvent));
  }
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/input-group/ComboboxInputGroup.mjs
var ComboboxInputGroup = /* @__PURE__ */ React62.forwardRef(function ComboboxInputGroup2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const {
    state: fieldState
  } = useFieldRootContext();
  const store = useComboboxRootContext();
  const open2 = store.useState("open");
  const comboboxDisabled = store.useState("disabled");
  const readOnly = store.useState("readOnly");
  const hasSelectedValue = store.useState("hasSelectedValue");
  const selectionMode = store.useState("selectionMode");
  const popupSide2 = usePopupSide(store);
  const disabled2 = comboboxDisabled;
  const listEmpty2 = useListEmpty();
  const placeholder = selectionMode === "none" ? false : !hasSelectedValue;
  const state = {
    ...fieldState,
    open: open2,
    disabled: disabled2,
    readOnly,
    popupSide: popupSide2,
    listEmpty: listEmpty2,
    placeholder
  };
  const setInputGroupElement = useStableCallback((element2) => {
    store.set("inputGroupElement", element2);
  });
  return useRenderElement("div", componentProps, {
    ref: [forwardedRef, setInputGroupElement],
    props: [{
      role: "group",
      onMouseDown(event) {
        handleInputPress(event, store, disabled2, (target) => {
          return contains(store.context.chipsContainerRef.current, target);
        });
      }
    }, elementProps],
    state,
    stateAttributesMapping: triggerStateAttributesMapping
  });
});
if (process.env.NODE_ENV !== "production") ComboboxInputGroup.displayName = "ComboboxInputGroup";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/trigger/ComboboxTrigger.mjs
import * as React63 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/getPseudoElementBounds.mjs
var BOUNDARY_OFFSET = 5;
function isMouseWithinBounds(event, element2) {
  const bounds = getPseudoElementBounds(element2);
  return event.clientX >= bounds.left - BOUNDARY_OFFSET && event.clientX <= bounds.right + BOUNDARY_OFFSET && event.clientY >= bounds.top - BOUNDARY_OFFSET && event.clientY <= bounds.bottom + BOUNDARY_OFFSET;
}
function getPseudoElementBounds(element2) {
  const elementRect = element2.getBoundingClientRect();
  const win = getWindow(element2);
  if (parts_exports.env.jsdom) {
    return elementRect;
  }
  const beforeStyles = win.getComputedStyle(element2, "::before");
  const afterStyles = win.getComputedStyle(element2, "::after");
  const hasPseudoElements = beforeStyles.content !== "none" || afterStyles.content !== "none";
  if (!hasPseudoElements) {
    return elementRect;
  }
  const beforeWidth = parseFloat(beforeStyles.width) || 0;
  const beforeHeight = parseFloat(beforeStyles.height) || 0;
  const afterWidth = parseFloat(afterStyles.width) || 0;
  const afterHeight = parseFloat(afterStyles.height) || 0;
  const totalWidth = Math.max(elementRect.width, beforeWidth, afterWidth);
  const totalHeight = Math.max(elementRect.height, beforeHeight, afterHeight);
  const widthDiff = totalWidth - elementRect.width;
  const heightDiff = totalHeight - elementRect.height;
  return {
    left: elementRect.left - widthDiff / 2,
    right: elementRect.right + widthDiff / 2,
    top: elementRect.top - heightDiff / 2,
    bottom: elementRect.bottom + heightDiff / 2
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/trigger/ComboboxTrigger.mjs
var ComboboxTrigger = /* @__PURE__ */ React63.forwardRef(function ComboboxTrigger2(componentProps, forwardedRef) {
  const {
    render,
    className,
    nativeButton = true,
    disabled: disabledProp = false,
    id: idProp,
    style,
    ...elementProps
  } = componentProps;
  const {
    state: fieldState,
    disabled: fieldDisabled,
    setTouched,
    setFocused,
    validationMode,
    validation
  } = useFieldRootContext();
  const {
    labelId: fieldLabelId
  } = useLabelableContext();
  const store = useComboboxRootContext();
  const selectionMode = store.useState("selectionMode");
  const comboboxDisabled = store.useState("disabled");
  const readOnly = store.useState("readOnly");
  const required = store.useState("required");
  const positionerElement = store.useState("positionerElement");
  const listElement = store.useState("listElement");
  const storedPopupId = store.useState("popupId");
  const triggerProps = store.useState("triggerProps");
  const inputInsidePopup = store.useState("inputInsidePopup");
  const rootId = store.useState("id");
  const comboboxLabelId = store.useState("labelId");
  const open2 = store.useState("open");
  const selectedValue = store.useState("selectedValue");
  const activeIndex = store.useState("activeIndex");
  const selectedIndex = store.useState("selectedIndex");
  const hasSelectedValue = store.useState("hasSelectedValue");
  const floatingRootContext = useComboboxFloatingContext();
  const inputValue = useComboboxInputValueContext();
  const focusTimeout = useTimeout();
  const disabled2 = fieldDisabled || comboboxDisabled || disabledProp;
  const listEmpty2 = useListEmpty();
  const popupSide2 = usePopupSide(store);
  useLabelableId({
    id: inputInsidePopup ? idProp : void 0
  });
  const id = inputInsidePopup ? idProp ?? rootId : idProp;
  const ariaLabelledBy = resolveAriaLabelledBy(fieldLabelId, comboboxLabelId);
  let ariaControls;
  if (open2 && inputInsidePopup) {
    ariaControls = storedPopupId ?? getComboboxPopupId(rootId);
  } else if (open2) {
    ariaControls = listElement?.id;
  }
  const currentPointerTypeRef = React63.useRef("");
  function trackPointerType(event) {
    currentPointerTypeRef.current = event.pointerType;
  }
  const {
    reference: triggerTypeaheadProps
  } = useTypeahead(floatingRootContext, {
    // Typeahead on a closed trigger commits a value rather than moving a highlight, so it stays
    // gated on `readOnly`.
    enabled: !open2 && !readOnly && !comboboxDisabled && selectionMode === "single",
    listRef: store.context.labelsRef,
    activeIndex,
    selectedIndex,
    onMatch(index2) {
      const nextSelectedValue = store.context.valuesRef.current[index2];
      if (nextSelectedValue !== void 0) {
        store.context.setSelectedValue(nextSelectedValue, createChangeEventDetails(reason_parts_exports.none));
      }
    }
  });
  const {
    reference: triggerClickProps
  } = useClick(floatingRootContext, {
    enabled: !comboboxDisabled,
    event: "mousedown"
  });
  const {
    buttonRef,
    getButtonProps
  } = useButton({
    native: nativeButton,
    disabled: disabled2
  });
  const state = {
    ...fieldState,
    readOnly,
    open: open2,
    disabled: disabled2,
    popupSide: popupSide2,
    listEmpty: listEmpty2,
    placeholder: selectionMode === "none" ? false : !hasSelectedValue
  };
  const setTriggerElement = useStableCallback((element3) => {
    store.set("triggerElement", element3);
  });
  const element2 = useRenderElement("button", componentProps, {
    ref: [forwardedRef, buttonRef, setTriggerElement],
    state,
    props: [triggerProps, triggerClickProps, triggerTypeaheadProps, {
      id,
      tabIndex: inputInsidePopup ? 0 : -1,
      role: inputInsidePopup ? "combobox" : void 0,
      "aria-expanded": open2,
      "aria-haspopup": inputInsidePopup ? "dialog" : "listbox",
      "aria-controls": ariaControls,
      "aria-required": inputInsidePopup ? required || void 0 : void 0,
      // Only valid alongside the `combobox` role; without it the trigger is a plain button, and
      // the `Combobox.Input` outside the popup already carries `aria-readonly`.
      "aria-readonly": inputInsidePopup ? readOnly || void 0 : void 0,
      "aria-labelledby": ariaLabelledBy,
      onPointerDown: trackPointerType,
      onPointerEnter: trackPointerType,
      onFocus() {
        setFocused(true);
        if (disabled2) {
          return;
        }
        focusTimeout.start(0, store.context.forceMount);
      },
      onBlur(event) {
        if (contains(positionerElement, event.relatedTarget)) {
          return;
        }
        setTouched(true);
        setFocused(false);
        if (validationMode === "onBlur") {
          const valueToValidate = selectionMode === "none" ? inputValue : selectedValue;
          validation.commit(valueToValidate);
        }
      },
      onMouseDown(event) {
        if (disabled2) {
          return;
        }
        if (!inputInsidePopup) {
          floatingRootContext.set("domReferenceElement", event.currentTarget);
        }
        store.context.forceMount();
        if (currentPointerTypeRef.current !== "touch") {
          store.context.inputRef.current?.focus();
          if (!inputInsidePopup) {
            event.preventDefault();
          }
        }
        if (open2) {
          return;
        }
        const doc = ownerDocument(event.currentTarget);
        function handleMouseUp(mouseEvent) {
          const currentTriggerElement = store.state.triggerElement;
          if (!currentTriggerElement) {
            return;
          }
          const mouseUpTarget = getTarget(mouseEvent);
          const positioner = store.state.positionerElement;
          const list2 = store.state.listElement;
          if (contains(currentTriggerElement, mouseUpTarget) || contains(positioner, mouseUpTarget) || contains(list2, mouseUpTarget)) {
            return;
          }
          if (isMouseWithinBounds(mouseEvent, currentTriggerElement)) {
            return;
          }
          store.context.setOpen(false, createChangeEventDetails(reason_parts_exports.cancelOpen, mouseEvent));
        }
        if (inputInsidePopup) {
          doc.addEventListener("mouseup", handleMouseUp, {
            once: true
          });
        }
      },
      onKeyDown(event) {
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
          stopEvent(event);
          store.context.setOpen(true, createChangeEventDetails(reason_parts_exports.listNavigation, event.nativeEvent));
          store.context.inputRef.current?.focus();
        }
      }
    }, validation.getValidationProps(disabled2, elementProps), getButtonProps],
    stateAttributesMapping: triggerStateAttributesMapping
  });
  return element2;
});
if (process.env.NODE_ENV !== "production") ComboboxTrigger.displayName = "ComboboxTrigger";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/list/ComboboxList.mjs
import * as React68 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/collection/ComboboxCollection.mjs
import * as React65 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/collection/GroupCollectionContext.mjs
import * as React64 from "react";
import { jsx as _jsx11 } from "react/jsx-runtime";
var GroupCollectionContext = /* @__PURE__ */ React64.createContext(null);
if (process.env.NODE_ENV !== "production") GroupCollectionContext.displayName = "GroupCollectionContext";
function useGroupCollectionContext() {
  return React64.useContext(GroupCollectionContext);
}
function GroupCollectionProvider(props) {
  const {
    children,
    items
  } = props;
  const contextValue = React64.useMemo(() => ({
    items
  }), [items]);
  return /* @__PURE__ */ _jsx11(GroupCollectionContext.Provider, {
    value: contextValue,
    children
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/collection/ComboboxCollection.mjs
import { jsx as _jsx12 } from "react/jsx-runtime";
function ComboboxCollection(props) {
  const {
    children
  } = props;
  const {
    filteredItems
  } = useComboboxDerivedItemsContext();
  const groupContext = useGroupCollectionContext();
  const itemsToRender = groupContext ? groupContext.items : filteredItems;
  return /* @__PURE__ */ _jsx12(React65.Fragment, {
    children: itemsToRender.map(children)
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/composite/list/CompositeList.mjs
import * as React67 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/composite/list/CompositeListContext.mjs
import * as React66 from "react";
var CompositeListContext = /* @__PURE__ */ React66.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  nextIndexRef: {
    current: 0
  }
});
if (process.env.NODE_ENV !== "production") CompositeListContext.displayName = "CompositeListContext";
function useCompositeListContext() {
  return React66.useContext(CompositeListContext);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/composite/list/CompositeList.mjs
import { jsx as _jsx13 } from "react/jsx-runtime";
function CompositeList(props) {
  const {
    children,
    elementsRef,
    labelsRef,
    onMapChange: onMapChangeProp
  } = props;
  const onMapChange = useStableCallback(onMapChangeProp);
  const [, setMapTick] = React67.useState(false);
  const listeners2 = useRefWithInit(createListeners).current;
  const map = useRefWithInit(createMap).current;
  const nextIndexRef = React67.useRef(0);
  const isDirtyRef = React67.useRef(true);
  const itemsRef = React67.useRef(null);
  const mutationObserverRef = React67.useRef(null);
  const scheduleMapUpdate = useStableCallback(() => {
    if (isDirtyRef.current) {
      return;
    }
    isDirtyRef.current = true;
    setMapTick((tick) => !tick);
  });
  const register2 = useStableCallback((node, registration) => {
    map.set(node, registration);
    scheduleMapUpdate();
  });
  const unregister = useStableCallback((node) => {
    map.delete(node);
    scheduleMapUpdate();
  });
  const syncRefs = useStableCallback((items) => {
    const nextMap = /* @__PURE__ */ new Map();
    elementsRef.current.length = 0;
    if (labelsRef) {
      labelsRef.current.length = 0;
    }
    items.forEach((item) => {
      nextMap.set(item.element, {
        ...item.registration.metadata ?? {},
        index: item.index
      });
      elementsRef.current[item.index] = item.element;
      if (labelsRef) {
        labelsRef.current[item.index] = item.registration.label !== void 0 ? item.registration.label : item.registration.textRef?.current?.textContent ?? item.element.textContent;
      }
    });
    nextIndexRef.current = elementsRef.current.length;
    return nextMap;
  });
  function observe(sortedNodes) {
    mutationObserverRef.current?.disconnect();
    mutationObserverRef.current = null;
    if (typeof MutationObserver !== "function" || sortedNodes.length < 2) {
      return;
    }
    const mutationObserver = new MutationObserver((entries) => {
      if (!hasMovedNode(entries)) {
        return;
      }
      let previousConnectedNode = null;
      for (const node of sortedNodes) {
        if (!node.isConnected) {
          continue;
        }
        if (previousConnectedNode && sortByDocumentPosition(previousConnectedNode, node) > 0) {
          mutationObserver.disconnect();
          scheduleMapUpdate();
          return;
        }
        previousConnectedNode = node;
      }
    });
    mutationObserverRef.current = mutationObserver;
    const roots = /* @__PURE__ */ new Set();
    for (let i = 1; i < sortedNodes.length; i += 1) {
      const root3 = getCommonAncestor(sortedNodes[i - 1], sortedNodes[i]);
      if (root3) {
        roots.add(root3);
      }
    }
    roots.forEach((root3) => mutationObserver.observe(root3, {
      childList: true
    }));
  }
  const flush = useStableCallback(() => {
    const [items, automaticNodes] = getCompositeListSnapshot(map);
    const nextMap = syncRefs(items);
    const previousItems = itemsRef.current;
    const changed = !previousItems || previousItems.length !== items.length || items.some((item, index2) => {
      const previousItem = previousItems[index2];
      return item.index !== previousItem.index || item.element !== previousItem.element || item.registration.index !== previousItem.registration.index || item.registration.metadata !== previousItem.registration.metadata;
    });
    observe(automaticNodes);
    itemsRef.current = items;
    isDirtyRef.current = false;
    if (!changed) {
      return;
    }
    listeners2.forEach((listener) => listener(nextMap));
    onMapChange(nextMap);
  });
  useIsoLayoutEffect(() => {
    if (!isDirtyRef.current && itemsRef.current) {
      syncRefs(itemsRef.current);
    }
    return () => {
      elementsRef.current = [];
      if (labelsRef) {
        labelsRef.current = [];
      }
    };
  }, [elementsRef, labelsRef, syncRefs]);
  useIsoLayoutEffect(() => {
    if (isDirtyRef.current) {
      flush();
    }
  });
  useIsoLayoutEffect(() => {
    return () => {
      mutationObserverRef.current?.disconnect();
      isDirtyRef.current = true;
    };
  }, []);
  const subscribeMapChange = useStableCallback((fn) => {
    listeners2.add(fn);
    return () => {
      listeners2.delete(fn);
    };
  });
  const contextValue = React67.useMemo(() => ({
    register: register2,
    unregister,
    subscribeMapChange,
    nextIndexRef
  }), [register2, unregister, subscribeMapChange, nextIndexRef]);
  return /* @__PURE__ */ _jsx13(CompositeListContext.Provider, {
    value: contextValue,
    children
  });
}
function createMap() {
  return /* @__PURE__ */ new Map();
}
function createListeners() {
  return /* @__PURE__ */ new Set();
}
function getCompositeListSnapshot(map) {
  const reservedIndices = /* @__PURE__ */ new Set();
  const items = [];
  const automaticItems = [];
  map.forEach((registration, node) => {
    if (!node.isConnected) {
      return;
    }
    const index2 = registration.index;
    const item = {
      index: index2 ?? -1,
      element: node,
      registration
    };
    if (index2 === null) {
      automaticItems.push(item);
    } else if (index2 >= 0) {
      reservedIndices.add(index2);
      items.push(item);
    }
  });
  let nextAutomaticIndex = 0;
  automaticItems.sort((a, b) => sortByDocumentPosition(a.element, b.element));
  automaticItems.forEach((item) => {
    while (reservedIndices.has(nextAutomaticIndex)) {
      nextAutomaticIndex += 1;
    }
    item.index = nextAutomaticIndex;
    items.push(item);
    nextAutomaticIndex += 1;
  });
  if (reservedIndices.size > 0) {
    items.sort((a, b) => a.index - b.index);
  }
  return [items, automaticItems.map((item) => item.element)];
}
function getCommonAncestor(firstNode, lastNode) {
  let ancestor = firstNode.parentElement;
  while (ancestor && !ancestor.contains(lastNode)) {
    ancestor = ancestor.parentElement;
  }
  return ancestor;
}
function hasMovedNode(entries) {
  for (const entry of entries) {
    for (let i = 0; i < entry.removedNodes.length; i += 1) {
      if (entry.removedNodes[i].isConnected) {
        return true;
      }
    }
  }
  return false;
}
function sortByDocumentPosition(a, b) {
  return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/list/ComboboxList.mjs
import { jsx as _jsx14 } from "react/jsx-runtime";
var ComboboxList = /* @__PURE__ */ React68.forwardRef(function ComboboxList2(componentProps, forwardedRef) {
  var _ComboboxCollection;
  const {
    render,
    className,
    style,
    children,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const floatingRootContext = useComboboxFloatingContext();
  const hasPositionerContext = Boolean(useComboboxPositionerContext(true));
  const {
    filteredItems,
    hasItems
  } = useComboboxDerivedItemsContext();
  const selectionMode = store.useState("selectionMode");
  const grid = store.useState("grid");
  const readOnly = store.useState("readOnly");
  const listProps = store.useState("listProps");
  const virtualized = store.useState("virtualized");
  const forceMounted = store.useState("forceMounted");
  const multiple = selectionMode === "multiple";
  const empty2 = filteredItems.length === 0;
  const setPositionerElement = useStableCallback((element3) => {
    store.set("positionerElement", element3);
  });
  const setListElement = useStableCallback((element3) => {
    store.set("listElement", element3);
  });
  const resolvedChildren = React68.useMemo(() => {
    if (typeof children === "function") {
      return _ComboboxCollection || (_ComboboxCollection = /* @__PURE__ */ _jsx14(ComboboxCollection, {
        children
      }));
    }
    return children;
  }, [children]);
  const state = {
    empty: empty2
  };
  const floatingId = floatingRootContext.useState("floatingId");
  const element2 = useRenderElement("div", componentProps, {
    state,
    ref: [forwardedRef, setListElement, hasPositionerContext ? null : setPositionerElement],
    props: [listProps, {
      children: resolvedChildren,
      tabIndex: -1,
      id: floatingId,
      role: grid ? "grid" : "listbox",
      "aria-multiselectable": multiple ? "true" : void 0,
      // On a grid the attribute describes cell editability, not selection, so it's left to the
      // combobox element in that mode.
      "aria-readonly": !grid && readOnly ? true : void 0,
      onKeyDown(event) {
        if (store.state.disabled || store.state.readOnly) {
          return;
        }
        if (event.key === "Enter") {
          const activeIndex = store.state.activeIndex;
          if (activeIndex == null) {
            return;
          }
          stopEvent(event);
          clickHighlightedItem(store, activeIndex, event.nativeEvent);
        }
      },
      onKeyDownCapture() {
        store.context.keyboardActiveRef.current = true;
      },
      onPointerMoveCapture() {
        store.context.keyboardActiveRef.current = false;
      }
    }, elementProps]
  });
  if (virtualized) {
    return element2;
  }
  const labelsRef = hasItems && !forceMounted ? void 0 : store.context.labelsRef;
  return /* @__PURE__ */ _jsx14(CompositeList, {
    elementsRef: store.context.listRef,
    labelsRef,
    children: element2
  });
});
if (process.env.NODE_ENV !== "production") ComboboxList.displayName = "ComboboxList";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/status/ComboboxStatus.mjs
import * as React70 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/utils/useInitialLiveRegionTextMutation.mjs
import * as React69 from "react";
var LIVE_REGION_MARKER = "\u2060";
var INITIAL_LIVE_REGION_TEXT_MUTATION_RESET_DELAY = 200;
function findLastTextNode(root3) {
  const walker = root3.ownerDocument.createTreeWalker(root3, NodeFilter.SHOW_TEXT);
  let lastTextNode = null;
  while (walker.nextNode()) {
    const textNode = walker.currentNode;
    if (textNode.nodeValue !== "") {
      lastTextNode = textNode;
    }
  }
  return lastTextNode;
}
function useInitialLiveRegionTextMutation() {
  const timeout = useTimeout();
  const rootRef = React69.useRef(null);
  React69.useEffect(() => {
    if (parts_exports.os.ios) {
      return void 0;
    }
    const root3 = rootRef.current;
    if (root3 == null) {
      return void 0;
    }
    const textNode = findLastTextNode(root3);
    if (textNode == null) {
      return void 0;
    }
    const originalValue = textNode.data;
    const markedValue = `${originalValue}${LIVE_REGION_MARKER}`;
    textNode.nodeValue = markedValue;
    timeout.start(INITIAL_LIVE_REGION_TEXT_MUTATION_RESET_DELAY, () => {
      if (textNode.nodeValue === markedValue) {
        textNode.nodeValue = originalValue;
      }
    });
    return () => {
      timeout.clear();
      if (textNode.nodeValue === markedValue) {
        textNode.nodeValue = originalValue;
      }
    };
  }, [rootRef, timeout]);
  return rootRef;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/status/ComboboxStatus.mjs
var ComboboxStatus = /* @__PURE__ */ React70.forwardRef(function ComboboxStatus2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    children: childrenProp,
    ...elementProps
  } = componentProps;
  const statusRef = useInitialLiveRegionTextMutation();
  return useRenderElement("div", componentProps, {
    ref: [forwardedRef, statusRef],
    props: [{
      children: childrenProp,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": true
    }, elementProps]
  });
});
if (process.env.NODE_ENV !== "production") ComboboxStatus.displayName = "ComboboxStatus";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/portal/ComboboxPortal.mjs
import * as React72 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/portal/ComboboxPortalContext.mjs
import * as React71 from "react";
var ComboboxPortalContext = /* @__PURE__ */ React71.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxPortalContext.displayName = "ComboboxPortalContext";
function useComboboxPortalContext() {
  const context = React71.useContext(ComboboxPortalContext);
  if (context === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Portal> is missing." : formatErrorMessage_default(20));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/portal/ComboboxPortal.mjs
import { jsx as _jsx15 } from "react/jsx-runtime";
var ComboboxPortal = /* @__PURE__ */ React72.forwardRef(function ComboboxPortal2(props, forwardedRef) {
  const {
    keepMounted = false,
    ...portalProps
  } = props;
  const store = useComboboxRootContext();
  const mounted = store.useState("mounted");
  const forceMounted = store.useState("forceMounted");
  const shouldRender = mounted || keepMounted || forceMounted;
  if (!shouldRender) {
    return null;
  }
  return /* @__PURE__ */ _jsx15(ComboboxPortalContext.Provider, {
    value: keepMounted,
    children: /* @__PURE__ */ _jsx15(FloatingPortal, {
      ref: forwardedRef,
      ...portalProps
    })
  });
});
if (process.env.NODE_ENV !== "production") ComboboxPortal.displayName = "ComboboxPortal";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/backdrop/ComboboxBackdrop.mjs
import * as React73 from "react";
var stateAttributesMapping = {
  ...popupStateMapping,
  ...transitionStatusMapping
};
var ComboboxBackdrop = /* @__PURE__ */ React73.forwardRef(function ComboboxBackdrop2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const open2 = store.useState("open");
  const mounted = store.useState("mounted");
  const transitionStatus = store.useState("transitionStatus");
  const state = {
    open: open2,
    transitionStatus
  };
  return useRenderElement("div", componentProps, {
    state,
    ref: forwardedRef,
    stateAttributesMapping,
    props: [{
      role: "presentation",
      hidden: !mounted,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, elementProps]
  });
});
if (process.env.NODE_ENV !== "production") ComboboxBackdrop.displayName = "ComboboxBackdrop";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/positioner/ComboboxPositioner.mjs
import * as React77 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/inertValue.mjs
function inertValue(value) {
  if (isReactVersionAtLeast(19)) {
    return value;
  }
  return value ? "true" : void 0;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useAnchorPositioning.mjs
import * as React74 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/floating-ui-react/middleware/arrow.mjs
var baseArrow = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform: platform3,
      elements,
      middlewareData
    } = state;
    const {
      element: element2,
      padding = 0,
      offsetParent = "real"
    } = evaluate(options, state) || {};
    if (element2 == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform3.getDimensions(element2);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = offsetParent === "real" ? await platform3.getOffsetParent?.(element2) : elements.floating;
    let clientSize = elements.floating[clientProp] || rects.floating[length];
    if (!clientSize || !await platform3.isElement?.(arrowOffsetParent)) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = Math.min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = Math.min(paddingObject[maxProp], largestPossiblePadding);
    const min2 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset5 = clamp2(min2, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset5 && rects.reference[length] / 2 - (center < min2 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min2 ? center - min2 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset5,
        centerOffset: center - offset5 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
var arrow5 = (options, deps) => {
  const {
    name: name2,
    fn
  } = baseArrow(options);
  return {
    name: name2,
    fn,
    options: [options, deps]
  };
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/hideMiddleware.mjs
var hide5 = {
  name: "hide",
  async fn(state) {
    const {
      width,
      height,
      x,
      y
    } = state.rects.reference;
    const anchorHidden2 = width === 0 && height === 0 && x === 0 && y === 0;
    const overflow = await state.platform.detectOverflow(state, {
      elementContext: "reference"
    });
    const referenceHidden = overflow.top - height >= 0 || overflow.right - width >= 0 || overflow.bottom - height >= 0 || overflow.left - width >= 0;
    return {
      data: {
        referenceHidden: referenceHidden || anchorHidden2
      }
    };
  }
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/adaptiveOriginConstants.mjs
var DEFAULT_SIDES = {
  sideX: "left",
  sideY: "top"
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/CommonPositionerCssVars.mjs
var availableWidth = "--available-width";
var availableHeight = "--available-height";
var anchorWidth = "--anchor-width";
var anchorHeight = "--anchor-height";
var transformOrigin = "--transform-origin";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/useAnchorPositioning.mjs
var AVAILABLE_WIDTH_VAR = availableWidth;
var AVAILABLE_HEIGHT_VAR = availableHeight;
function getLogicalSide(sideParam, renderedSide, isRtl) {
  const isLogicalSideParam = sideParam === "inline-start" || sideParam === "inline-end";
  const logicalRight = isRtl ? "inline-start" : "inline-end";
  const logicalLeft = isRtl ? "inline-end" : "inline-start";
  return {
    top: "top",
    right: isLogicalSideParam ? logicalRight : "right",
    bottom: "bottom",
    left: isLogicalSideParam ? logicalLeft : "left"
  }[renderedSide];
}
function getOffsetData(state, sideParam, isRtl) {
  const {
    rects,
    placement
  } = state;
  const data = {
    side: getLogicalSide(sideParam, getSide(placement), isRtl),
    align: getAlignment(placement) || "center",
    anchor: {
      width: rects.reference.width,
      height: rects.reference.height
    },
    positioner: {
      width: rects.floating.width,
      height: rects.floating.height
    }
  };
  return data;
}
function useAnchorPositioning(params) {
  return useAnchorPositioningWithHook(params, useBaseUIFloating);
}
function useAnchorPositioningWithHook(params, useFloatingHook) {
  const {
    // Public parameters
    anchor,
    positionMethod = "absolute",
    side: sideParam = "bottom",
    sideOffset = 0,
    align = "center",
    alignOffset = 0,
    collisionBoundary,
    collisionPadding: collisionPaddingParam = 5,
    sticky = false,
    arrowPadding = 5,
    disableAnchorTracking = false,
    inline: inlineMiddleware,
    // Private parameters
    keepMounted = false,
    floatingRootContext,
    mounted,
    collisionAvoidance,
    shift: shift5,
    nodeId,
    adaptiveOrigin,
    lazyFlip = false,
    externalTree
  } = params;
  const [mountSide, setMountSide] = React74.useState(null);
  if (!mounted && mountSide !== null) {
    setMountSide(null);
  }
  const collisionAvoidanceSide = collisionAvoidance.side || "flip";
  const collisionAvoidanceAlign = collisionAvoidance.align || "flip";
  const collisionAvoidanceFallbackAxisSide = collisionAvoidance.fallbackAxisSide || "end";
  const shiftCrossAxis = shift5?.crossAxis ?? false;
  const shiftRootBoundary = shift5?.rootBoundary;
  const anchorFn = typeof anchor === "function" ? anchor : void 0;
  const anchorFnCallback = useStableCallback(anchorFn);
  const anchorDep = anchorFn ? anchorFnCallback : anchor;
  const anchorValueRef = useValueAsRef(anchor);
  const mountedRef = useValueAsRef(mounted);
  const direction = useDirection3();
  const isRtl = direction === "rtl";
  const side = mountSide || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": isRtl ? "left" : "right",
    "inline-start": isRtl ? "right" : "left"
  }[sideParam];
  const placement = align === "center" ? side : `${side}-${align}`;
  let collisionPadding = collisionPaddingParam;
  if (typeof collisionPadding === "number") {
    collisionPadding = {
      top: collisionPadding,
      right: collisionPadding,
      bottom: collisionPadding,
      left: collisionPadding
    };
  } else if (collisionPadding) {
    collisionPadding = {
      top: collisionPadding.top || 0,
      right: collisionPadding.right || 0,
      bottom: collisionPadding.bottom || 0,
      left: collisionPadding.left || 0
    };
  }
  const bias = 1;
  const biasTop = sideParam === "bottom" ? bias : 0;
  const biasBottom = sideParam === "top" ? bias : 0;
  const biasLeft = sideParam === "right" ? bias : 0;
  const biasRight = sideParam === "left" ? bias : 0;
  const commonCollisionProps = {
    boundary: collisionBoundary === "clipping-ancestors" ? "clippingAncestors" : collisionBoundary,
    padding: collisionPadding
  };
  const arrowRef = React74.useRef(null);
  const sideOffsetRef = useValueAsRef(sideOffset);
  const alignOffsetRef = useValueAsRef(alignOffset);
  const sideOffsetDep = typeof sideOffset !== "function" ? sideOffset : 0;
  const alignOffsetDep = typeof alignOffset !== "function" ? alignOffset : 0;
  const middleware = [];
  if (inlineMiddleware) {
    middleware.push(inlineMiddleware);
  }
  middleware.push(offset4((state) => {
    const data = getOffsetData(state, sideParam, isRtl);
    const sideAxis = typeof sideOffsetRef.current === "function" ? sideOffsetRef.current(data) : sideOffsetRef.current;
    const alignAxis = typeof alignOffsetRef.current === "function" ? alignOffsetRef.current(data) : alignOffsetRef.current;
    return {
      mainAxis: sideAxis,
      crossAxis: alignAxis,
      alignmentAxis: alignAxis
    };
  }, [sideOffsetDep, alignOffsetDep, isRtl, sideParam]));
  const shiftDisabled = collisionAvoidanceAlign === "none" && collisionAvoidanceSide !== "shift";
  const crossAxisShiftEnabled = !shiftDisabled && (sticky || shiftCrossAxis || collisionAvoidanceSide === "shift");
  const flipMiddleware = collisionAvoidanceSide === "none" ? null : flip4({
    ...commonCollisionProps,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: collisionPadding.top + bias + biasTop,
      right: collisionPadding.right + bias + biasRight,
      bottom: collisionPadding.bottom + bias + biasBottom,
      left: collisionPadding.left + bias + biasLeft
    },
    mainAxis: !shiftCrossAxis && collisionAvoidanceSide === "flip",
    crossAxis: collisionAvoidanceAlign === "flip" ? "alignment" : false,
    fallbackAxisSideDirection: collisionAvoidanceFallbackAxisSide
  });
  const shiftMiddleware = shiftDisabled ? null : shift4({
    ...commonCollisionProps,
    // Use the Layout Viewport to avoid shifting around when pinch-zooming.
    rootBoundary: shiftRootBoundary,
    mainAxis: collisionAvoidanceAlign !== "none",
    crossAxis: crossAxisShiftEnabled,
    limiter: sticky || shiftCrossAxis ? void 0 : limitShift4((limitData) => {
      if (!arrowRef.current) {
        return {};
      }
      const {
        width,
        height
      } = arrowRef.current.getBoundingClientRect();
      const sideAxis = getSideAxis(getSide(limitData.placement));
      const arrowSize = sideAxis === "y" ? width : height;
      const offsetAmount = sideAxis === "y" ? collisionPadding.left + collisionPadding.right : collisionPadding.top + collisionPadding.bottom;
      return {
        offset: arrowSize / 2 + offsetAmount / 2
      };
    })
  }, [commonCollisionProps, sticky, shiftCrossAxis, shiftRootBoundary, collisionPadding, collisionAvoidanceAlign]);
  if (collisionAvoidanceSide === "shift" || collisionAvoidanceAlign === "shift" || align === "center") {
    middleware.push(shiftMiddleware, flipMiddleware);
  } else {
    middleware.push(flipMiddleware, shiftMiddleware);
  }
  middleware.push(size4({
    ...commonCollisionProps,
    apply({
      elements: {
        floating
      },
      availableWidth: availableWidth2,
      availableHeight: availableHeight2,
      rects
    }) {
      if (!mountedRef.current) {
        return;
      }
      const floatingStyle = floating.style;
      floatingStyle.setProperty(AVAILABLE_WIDTH_VAR, `${availableWidth2}px`);
      floatingStyle.setProperty(AVAILABLE_HEIGHT_VAR, `${availableHeight2}px`);
      const dpr = getWindow(floating).devicePixelRatio || 1;
      const {
        x: x2,
        y: y2,
        width,
        height
      } = rects.reference;
      const anchorWidth2 = (Math.round((x2 + width) * dpr) - Math.round(x2 * dpr)) / dpr;
      const anchorHeight2 = (Math.round((y2 + height) * dpr) - Math.round(y2 * dpr)) / dpr;
      floatingStyle.setProperty(anchorWidth, `${anchorWidth2}px`);
      floatingStyle.setProperty(anchorHeight, `${anchorHeight2}px`);
    }
  }), arrow5((state) => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: arrowRef.current || ownerDocument(state.elements.floating).createElement("div"),
    // No padding for the fake arrow: it would displace aligned popups on narrow anchors.
    padding: arrowRef.current ? arrowPadding : 0,
    offsetParent: "floating"
  }), [arrowPadding]), {
    name: "transformOrigin",
    fn(state) {
      const {
        elements: {
          floating
        },
        middlewareData: middlewareData2,
        placement: renderedPlacement2,
        platform: platform3,
        rects,
        y: y2
      } = state;
      const renderedSide2 = getSide(renderedPlacement2);
      const renderedAlign2 = getAlignment(renderedPlacement2);
      const isVertical = getSideAxis(renderedSide2) === "y";
      const arrowEl = arrowRef.current;
      const sideOffsetValue = typeof sideOffset === "function" ? sideOffset(getOffsetData(state, sideParam, isRtl)) : sideOffset;
      let crossOrigin;
      if (!arrowEl && renderedAlign2 && Math.abs(isVertical ? middlewareData2.shift?.x || 0 : middlewareData2.shift?.y || 0) <= 1) {
        crossOrigin = renderedAlign2 === "start" === (isVertical && platform3.isRTL?.(floating) === true) ? "100%" : "0%";
      } else {
        const arrowOffset = isVertical ? middlewareData2.arrow?.x || 0 : middlewareData2.arrow?.y || 0;
        const arrowSize = isVertical ? arrowEl?.clientWidth || 0 : arrowEl?.clientHeight || 0;
        crossOrigin = `${arrowOffset + arrowSize / 2}px`;
      }
      let sideOrigin = renderedSide2 === "top" || renderedSide2 === "left" ? `calc(100% + ${sideOffsetValue}px)` : `${-sideOffsetValue}px`;
      if (crossAxisShiftEnabled && isVertical && Math.abs(middlewareData2.shift?.y || 0) > sideOffsetValue) {
        sideOrigin = `${rects.reference.y + rects.reference.height / 2 - y2}px`;
      }
      floating.style.setProperty(transformOrigin, isVertical ? `${crossOrigin} ${sideOrigin}` : `${sideOrigin} ${crossOrigin}`);
      return {};
    }
  }, hide5, adaptiveOrigin);
  useIsoLayoutEffect(() => {
    if (!mounted && floatingRootContext) {
      floatingRootContext.update({
        referenceElement: null,
        floatingElement: null,
        domReferenceElement: null,
        positionReference: null
      });
    }
  }, [mounted, floatingRootContext]);
  const autoUpdateOptions = React74.useMemo(() => ({
    ancestorScroll: !disableAnchorTracking,
    elementResize: !disableAnchorTracking && typeof ResizeObserver !== "undefined",
    layoutShift: !disableAnchorTracking && typeof IntersectionObserver !== "undefined"
  }), [disableAnchorTracking]);
  const {
    refs,
    elements,
    x,
    y,
    middlewareData,
    update: update2,
    placement: renderedPlacement,
    context,
    isPositioned,
    floatingStyles: originalFloatingStyles
  } = useFloatingHook({
    rootContext: floatingRootContext,
    open: keepMounted ? mounted : void 0,
    placement,
    middleware,
    strategy: positionMethod,
    whileElementsMounted: keepMounted ? void 0 : (...args) => autoUpdate2(...args, autoUpdateOptions),
    nodeId,
    externalTree
  });
  const {
    sideX,
    sideY
  } = middlewareData.adaptiveOrigin || DEFAULT_SIDES;
  const resolvedPosition = isPositioned ? positionMethod : "fixed";
  const floatingStyles = React74.useMemo(() => {
    let base;
    if (!isPositioned) {
      base = {
        position: resolvedPosition,
        top: 0,
        left: 0
      };
    } else if (adaptiveOrigin) {
      base = {
        position: resolvedPosition,
        [sideX]: x,
        [sideY]: y
      };
    } else {
      base = {
        ...originalFloatingStyles,
        position: resolvedPosition
      };
    }
    base[AVAILABLE_WIDTH_VAR] = "100vw";
    base[AVAILABLE_HEIGHT_VAR] = "100vh";
    if (!isPositioned) {
      base.opacity = 0;
    }
    return base;
  }, [adaptiveOrigin, resolvedPosition, sideX, x, sideY, y, originalFloatingStyles, isPositioned]);
  const registeredPositionReferenceRef = React74.useRef(null);
  useIsoLayoutEffect(() => {
    if (!mounted) {
      return;
    }
    const anchorValue = anchorValueRef.current;
    const resolvedAnchor = typeof anchorValue === "function" ? anchorValue() : anchorValue;
    const unwrappedElement = (isRef(resolvedAnchor) ? resolvedAnchor.current : resolvedAnchor) || null;
    const finalAnchor = unwrappedElement || null;
    if (finalAnchor !== registeredPositionReferenceRef.current) {
      refs.setPositionReference(finalAnchor);
      registeredPositionReferenceRef.current = finalAnchor;
    }
  }, [mounted, refs, anchorDep, anchorValueRef]);
  React74.useEffect(() => {
    if (!mounted) {
      return;
    }
    const anchorValue = anchorValueRef.current;
    if (typeof anchorValue === "function") {
      return;
    }
    if (isRef(anchorValue) && anchorValue.current !== registeredPositionReferenceRef.current) {
      refs.setPositionReference(anchorValue.current);
      registeredPositionReferenceRef.current = anchorValue.current;
    }
  }, [mounted, refs, anchorDep, anchorValueRef]);
  React74.useEffect(() => {
    if (keepMounted && mounted && elements.reference && elements.floating) {
      return autoUpdate2(elements.reference, elements.floating, update2, autoUpdateOptions);
    }
    return void 0;
  }, [keepMounted, mounted, elements, update2, autoUpdateOptions]);
  const renderedSide = getSide(renderedPlacement);
  const logicalRenderedSide = getLogicalSide(sideParam, renderedSide, isRtl);
  const renderedAlign = getAlignment(renderedPlacement) || "center";
  const anchorHidden2 = Boolean(middlewareData.hide?.referenceHidden);
  useIsoLayoutEffect(() => {
    if (lazyFlip && mounted && isPositioned && renderedSide !== side) {
      setMountSide(renderedSide);
    }
  }, [lazyFlip, mounted, isPositioned, renderedSide, side]);
  const arrowStyles = React74.useMemo(() => ({
    position: "absolute",
    top: middlewareData.arrow?.y,
    left: middlewareData.arrow?.x
  }), [middlewareData.arrow]);
  const arrowUncentered = middlewareData.arrow?.centerOffset !== 0;
  return React74.useMemo(() => ({
    positionerStyles: floatingStyles,
    arrowStyles,
    arrowRef,
    arrowUncentered,
    side: logicalRenderedSide,
    align: renderedAlign,
    physicalSide: renderedSide,
    anchorHidden: anchorHidden2,
    refs,
    context,
    isPositioned,
    update: update2
  }), [floatingStyles, arrowStyles, arrowRef, arrowUncentered, logicalRenderedSide, renderedAlign, renderedSide, anchorHidden2, refs, context, isPositioned, update2]);
}
function isRef(param) {
  return param != null && "current" in param;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/InternalBackdrop.mjs
import * as React75 from "react";
import { jsx as _jsx16 } from "react/jsx-runtime";
var InternalBackdrop = /* @__PURE__ */ React75.forwardRef(function InternalBackdrop2(props, ref) {
  const {
    cutout,
    ...otherProps
  } = props;
  let clipPath;
  if (cutout) {
    const rect = cutout.getBoundingClientRect();
    clipPath = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${rect.left}px ${rect.top}px,${rect.left}px ${rect.bottom}px,${rect.right}px ${rect.bottom}px,${rect.right}px ${rect.top}px,${rect.left}px ${rect.top}px)`;
  }
  return /* @__PURE__ */ _jsx16("div", {
    ref,
    role: "presentation",
    "data-base-ui-inert": "",
    ...otherProps,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath
    }
  });
});
if (process.env.NODE_ENV !== "production") InternalBackdrop.displayName = "InternalBackdrop";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/getDisabledMountTransitionStyles.mjs
function getDisabledMountTransitionStyles(transitionStatus) {
  return transitionStatus === "starting" ? DISABLED_TRANSITIONS_STYLE : EMPTY_OBJECT;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/usePositioner.mjs
function usePositioner(componentProps, state, {
  styles,
  transitionStatus,
  props,
  refs,
  hidden,
  inert = false
}) {
  const style = {
    ...styles
  };
  if (inert) {
    style.pointerEvents = "none";
  }
  return useRenderElement("div", componentProps, {
    state,
    ref: refs,
    props: [{
      role: "presentation",
      hidden,
      style
    }, getDisabledMountTransitionStyles(transitionStatus), props],
    stateAttributesMapping: popupStateMapping
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/useAnchoredPopupScrollLock.mjs
import * as React76 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useScrollLock.mjs
var originalHtmlStyles = {};
var originalBodyStyles = {};
var originalHtmlScrollBehavior = "";
function getViewportScroller(html4, body) {
  return isOverflowElement(html4) ? html4 : body;
}
function isPageScrollLocked(win, html4, body) {
  return /hidden|clip/.test(win.getComputedStyle(getViewportScroller(html4, body)).overflowY);
}
function hasInsetScrollbars(referenceElement) {
  if (typeof document === "undefined") {
    return false;
  }
  const doc = ownerDocument(referenceElement);
  const win = getWindow(doc);
  return win.innerWidth - doc.documentElement.clientWidth > 0;
}
function supportsStableScrollbarGutter(referenceElement) {
  const supported = typeof CSS !== "undefined" && CSS.supports && CSS.supports("scrollbar-gutter", "stable");
  if (!supported || typeof document === "undefined") {
    return false;
  }
  const doc = ownerDocument(referenceElement);
  const html4 = doc.documentElement;
  const body = doc.body;
  const scrollContainer = getViewportScroller(html4, body);
  const originalScrollContainerOverflowY = scrollContainer.style.overflowY;
  const originalHtmlStyleGutter = html4.style.scrollbarGutter;
  html4.style.scrollbarGutter = "stable";
  scrollContainer.style.overflowY = "scroll";
  const before = scrollContainer.offsetWidth;
  scrollContainer.style.overflowY = "hidden";
  const after = scrollContainer.offsetWidth;
  scrollContainer.style.overflowY = originalScrollContainerOverflowY;
  html4.style.scrollbarGutter = originalHtmlStyleGutter;
  return before === after;
}
function preventScrollOverlayScrollbars(referenceElement) {
  const doc = ownerDocument(referenceElement);
  const html4 = doc.documentElement;
  const body = doc.body;
  const elementToLock = getViewportScroller(html4, body);
  const originalElementToLockStyles = {
    overflowY: elementToLock.style.overflowY,
    overflowX: elementToLock.style.overflowX
  };
  Object.assign(elementToLock.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  });
  return () => {
    Object.assign(elementToLock.style, originalElementToLockStyles);
  };
}
function preventScrollInsetScrollbars(referenceElement) {
  const doc = ownerDocument(referenceElement);
  const html4 = doc.documentElement;
  const body = doc.body;
  const win = getWindow(html4);
  let scrollTop = 0;
  let scrollLeft = 0;
  let updateGutterOnly = false;
  const resizeFrame = AnimationFrame.create();
  if (parts_exports.engine.webkit && (win.visualViewport?.scale ?? 1) !== 1) {
    return () => {
    };
  }
  function lockScroll() {
    const htmlStyles = win.getComputedStyle(html4);
    const bodyStyles = win.getComputedStyle(body);
    const htmlScrollbarGutterValue = htmlStyles.scrollbarGutter || "";
    const hasBothEdges = htmlScrollbarGutterValue.includes("both-edges");
    const scrollbarGutterValue = hasBothEdges ? "stable both-edges" : "stable";
    scrollTop = html4.scrollTop;
    scrollLeft = html4.scrollLeft;
    originalHtmlStyles = {
      scrollbarGutter: html4.style.scrollbarGutter,
      overflowY: html4.style.overflowY,
      overflowX: html4.style.overflowX
    };
    originalHtmlScrollBehavior = html4.style.scrollBehavior;
    originalBodyStyles = {
      position: body.style.position,
      height: body.style.height,
      width: body.style.width,
      boxSizing: body.style.boxSizing,
      overflowY: body.style.overflowY,
      overflowX: body.style.overflowX,
      scrollBehavior: body.style.scrollBehavior
    };
    const isScrollableY2 = html4.scrollHeight > html4.clientHeight;
    const isScrollableX = html4.scrollWidth > html4.clientWidth;
    const hasConstantOverflowY = htmlStyles.overflowY === "scroll" || bodyStyles.overflowY === "scroll";
    const hasConstantOverflowX = htmlStyles.overflowX === "scroll" || bodyStyles.overflowX === "scroll";
    const scrollbarWidth = Math.max(0, win.innerWidth - body.clientWidth);
    const scrollbarHeight = Math.max(0, win.innerHeight - body.clientHeight);
    const marginY = parseFloat(bodyStyles.marginTop) + parseFloat(bodyStyles.marginBottom);
    const marginX = parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight);
    const elementToLock = getViewportScroller(html4, body);
    updateGutterOnly = supportsStableScrollbarGutter(referenceElement);
    if (updateGutterOnly) {
      html4.style.scrollbarGutter = scrollbarGutterValue;
      elementToLock.style.overflowY = "hidden";
      elementToLock.style.overflowX = "hidden";
      return;
    }
    Object.assign(html4.style, {
      scrollbarGutter: scrollbarGutterValue,
      overflowY: "hidden",
      overflowX: "hidden"
    });
    if (isScrollableY2 || hasConstantOverflowY) {
      html4.style.overflowY = "scroll";
    }
    if (isScrollableX || hasConstantOverflowX) {
      html4.style.overflowX = "scroll";
    }
    Object.assign(body.style, {
      position: "relative",
      height: marginY || scrollbarHeight ? `calc(100dvh - ${marginY + scrollbarHeight}px)` : "100dvh",
      width: marginX || scrollbarWidth ? `calc(100vw - ${marginX + scrollbarWidth}px)` : "100vw",
      boxSizing: "border-box",
      // Assign the longhands that `cleanup` restores, so nothing is left behind.
      overflowY: "hidden",
      overflowX: "hidden",
      scrollBehavior: "unset"
    });
    body.scrollTop = scrollTop;
    body.scrollLeft = scrollLeft;
    html4.setAttribute("data-base-ui-scroll-locked", "");
    html4.style.scrollBehavior = "unset";
  }
  function cleanup() {
    Object.assign(html4.style, originalHtmlStyles);
    Object.assign(body.style, originalBodyStyles);
    if (!updateGutterOnly) {
      html4.scrollTop = scrollTop;
      html4.scrollLeft = scrollLeft;
      html4.removeAttribute("data-base-ui-scroll-locked");
      html4.style.scrollBehavior = originalHtmlScrollBehavior;
    }
  }
  function handleResize() {
    cleanup();
    resizeFrame.request(lockScroll);
  }
  lockScroll();
  const unsubscribeResize = addEventListener(win, "resize", handleResize);
  return () => {
    resizeFrame.cancel();
    cleanup();
    if (typeof win.removeEventListener === "function") {
      unsubscribeResize();
    }
  };
}
var ScrollLocker = class {
  lockCount = 0;
  restore = null;
  timeoutLock = Timeout.create();
  timeoutUnlock = Timeout.create();
  acquire(referenceElement) {
    this.lockCount += 1;
    if (this.lockCount === 1 && this.restore === null) {
      this.timeoutLock.start(0, () => this.lock(referenceElement));
    }
    return this.release;
  }
  release = () => {
    this.lockCount -= 1;
    if (this.lockCount === 0 && this.restore) {
      this.timeoutUnlock.start(0, this.unlock);
    }
  };
  unlock = () => {
    if (this.lockCount === 0 && this.restore) {
      this.restore?.();
      this.restore = null;
    }
  };
  lock(referenceElement) {
    if (this.lockCount === 0 || this.restore !== null) {
      return;
    }
    const doc = ownerDocument(referenceElement);
    const html4 = doc.documentElement;
    const body = doc.body;
    const win = getWindow(html4);
    if (isPageScrollLocked(win, html4, body)) {
      const observer = new win.MutationObserver(() => {
        if (isPageScrollLocked(win, html4, body)) {
          return;
        }
        observer.disconnect();
        this.restore = null;
        this.lock(referenceElement);
      });
      const options = {
        attributes: true
      };
      observer.observe(html4, options);
      observer.observe(body, options);
      this.restore = () => observer.disconnect();
      return;
    }
    const hasOverlayScrollbars = parts_exports.os.ios || !hasInsetScrollbars(referenceElement);
    this.restore = hasOverlayScrollbars ? preventScrollOverlayScrollbars(referenceElement) : preventScrollInsetScrollbars(referenceElement);
  }
};
var SCROLL_LOCKER = new ScrollLocker();
function useScrollLock(enabled = true, referenceElement = null) {
  useIsoLayoutEffect(() => {
    if (!enabled) {
      return void 0;
    }
    return SCROLL_LOCKER.acquire(referenceElement);
  }, [enabled, referenceElement]);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/useAnchoredPopupScrollLock.mjs
var VIEWPORT_WIDTH_TOLERANCE_PX = 20;
function useAnchoredPopupScrollLock(enabled, touchOpen, positionerElement, referenceElement) {
  const [touchOpenShouldLockScroll, setTouchOpenShouldLockScroll] = React76.useState(false);
  useIsoLayoutEffect(() => {
    if (!enabled || !touchOpen || positionerElement == null) {
      setTouchOpenShouldLockScroll(false);
      return;
    }
    const viewportWidth = ownerDocument(positionerElement).documentElement.clientWidth;
    const popupWidth = positionerElement.offsetWidth;
    setTouchOpenShouldLockScroll(viewportWidth > 0 && popupWidth > 0 && popupWidth >= viewportWidth - VIEWPORT_WIDTH_TOLERANCE_PX);
  }, [enabled, touchOpen, positionerElement]);
  useScrollLock(enabled && (!touchOpen || touchOpenShouldLockScroll), referenceElement);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/positioner/ComboboxPositioner.mjs
import { jsx as _jsx17, jsxs as _jsxs5 } from "react/jsx-runtime";
var ComboboxPositioner = /* @__PURE__ */ React77.forwardRef(function ComboboxPositioner2(componentProps, forwardedRef) {
  const {
    render,
    className,
    anchor,
    // `useAnchorPositioning` applies the same defaults to the undefined values; the names
    // remain destructured to exclude the props from `elementProps`.
    positionMethod,
    side,
    align,
    sideOffset,
    alignOffset,
    collisionBoundary = "clipping-ancestors",
    collisionPadding,
    arrowPadding,
    sticky,
    disableAnchorTracking = false,
    collisionAvoidance = DROPDOWN_COLLISION_AVOIDANCE,
    style: styleProp,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const floatingRootContext = useComboboxFloatingContext();
  const keepMounted = useComboboxPortalContext();
  const modal = store.useState("modal");
  const open2 = store.useState("open");
  const mounted = store.useState("mounted");
  const openMethod = store.useState("openMethod");
  const positionerElement = store.useState("positionerElement");
  const triggerElement = store.useState("triggerElement");
  const inputElement = store.useState("inputElement");
  const inputGroupElement = store.useState("inputGroupElement");
  const inputInsidePopup = store.useState("inputInsidePopup");
  const transitionStatus = store.useState("transitionStatus");
  const empty2 = useListEmpty();
  const resolvedAnchor = anchor ?? (inputInsidePopup ? triggerElement : inputGroupElement ?? inputElement);
  const positioning = useAnchorPositioning({
    anchor: resolvedAnchor,
    floatingRootContext,
    positionMethod,
    mounted,
    side,
    sideOffset,
    align,
    alignOffset,
    arrowPadding,
    collisionBoundary,
    collisionPadding,
    sticky,
    disableAnchorTracking,
    keepMounted,
    collisionAvoidance,
    lazyFlip: true
  });
  useAnchoredPopupScrollLock(open2 && modal, openMethod === "touch", positionerElement, triggerElement);
  const state = {
    open: open2,
    side: positioning.side,
    align: positioning.align,
    anchorHidden: positioning.anchorHidden,
    empty: empty2
  };
  useIsoLayoutEffect(() => {
    store.set("popupSide", positioning.side);
  }, [store, positioning.side]);
  const setPositionerElement = useStableCallback((element3) => {
    store.set("positionerElement", element3);
  });
  const element2 = usePositioner(componentProps, state, {
    styles: positioning.positionerStyles,
    transitionStatus,
    props: elementProps,
    refs: [forwardedRef, setPositionerElement],
    hidden: !mounted,
    inert: !open2
  });
  return /* @__PURE__ */ _jsxs5(ComboboxPositionerContext.Provider, {
    value: positioning,
    children: [mounted && modal && /* @__PURE__ */ _jsx17(InternalBackdrop, {
      inert: inertValue(!open2),
      cutout: inputGroupElement ?? inputElement ?? triggerElement
    }), element2]
  });
});
if (process.env.NODE_ENV !== "production") ComboboxPositioner.displayName = "ComboboxPositioner";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/popup/ComboboxPopup.mjs
import * as React78 from "react";
import { jsx as _jsx18, jsxs as _jsxs6 } from "react/jsx-runtime";
var stateAttributesMapping2 = {
  ...popupStateMapping,
  ...transitionStatusMapping
};
var ComboboxPopup = /* @__PURE__ */ React78.forwardRef(function ComboboxPopup2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    initialFocus,
    finalFocus,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const positioning = useComboboxPositionerContext();
  const floatingRootContext = useComboboxFloatingContext();
  const mounted = store.useState("mounted");
  const open2 = store.useState("open");
  const openMethod = store.useState("openMethod");
  const popupProps = store.useState("popupProps");
  const transitionStatus = store.useState("transitionStatus");
  const inputInsidePopup = store.useState("inputInsidePopup");
  const inputElement = store.useState("inputElement");
  const modal = store.useState("modal");
  const rootId = store.useState("id");
  const empty2 = useListEmpty();
  const popupId = elementProps.id ?? (inputInsidePopup ? getComboboxPopupId(rootId) : void 0);
  useIsoLayoutEffect(() => {
    store.set("popupId", store.context.popupRef.current?.id || popupId);
    return () => {
      store.set("popupId", void 0);
    };
  }, [store, popupId]);
  useOpenChangeComplete({
    open: open2,
    ref: store.context.popupRef,
    onComplete() {
      if (open2) {
        store.context.onOpenChangeComplete(true);
      }
    }
  });
  const state = {
    open: open2,
    side: positioning.side,
    align: positioning.align,
    anchorHidden: positioning.anchorHidden,
    transitionStatus,
    empty: empty2
  };
  const element2 = useRenderElement("div", componentProps, {
    state,
    ref: [forwardedRef, store.context.popupRef],
    props: [popupProps, {
      id: popupId,
      role: inputInsidePopup ? "dialog" : "presentation",
      onFocus(event) {
        const target = getTarget(event.nativeEvent);
        if (openMethod !== "touch" && (contains(store.state.listElement, target) || target === event.currentTarget)) {
          store.context.inputRef.current?.focus();
        }
      }
    }, getDisabledMountTransitionStyles(transitionStatus), elementProps],
    stateAttributesMapping: stateAttributesMapping2
  });
  const computedDefaultInitialFocus = inputInsidePopup ? (interactionType) => interactionType === "touch" ? store.context.popupRef.current : inputElement : false;
  const resolvedInitialFocus = initialFocus === void 0 ? computedDefaultInitialFocus : initialFocus;
  let resolvedFinalFocus;
  if (finalFocus != null) {
    resolvedFinalFocus = finalFocus;
  } else {
    resolvedFinalFocus = inputInsidePopup ? void 0 : false;
  }
  const focusManagerModal = !inputInsidePopup || modal;
  return /* @__PURE__ */ _jsx18(FloatingFocusManager, {
    context: floatingRootContext,
    disabled: !mounted,
    modal: focusManagerModal,
    openInteractionType: openMethod,
    initialFocus: resolvedInitialFocus,
    returnFocus: resolvedFinalFocus,
    getInsideElements: () => [store.context.startDismissRef.current, store.context.endDismissRef.current],
    children: /* @__PURE__ */ _jsxs6(React78.Fragment, {
      children: [element2, focusManagerModal && /* @__PURE__ */ _jsx18(ComboboxInternalDismissButton, {
        ref: store.context.endDismissRef
      })]
    })
  });
});
if (process.env.NODE_ENV !== "production") ComboboxPopup.displayName = "ComboboxPopup";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/arrow/ComboboxArrow.mjs
import * as React79 from "react";
var ComboboxArrow = /* @__PURE__ */ React79.forwardRef(function ComboboxArrow2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const {
    arrowRef,
    side,
    align,
    arrowUncentered,
    arrowStyles
  } = useComboboxPositionerContext();
  const open2 = store.useState("open");
  const state = {
    open: open2,
    side,
    align,
    uncentered: arrowUncentered
  };
  return useRenderElement("div", componentProps, {
    ref: [arrowRef, forwardedRef],
    stateAttributesMapping: popupStateMapping,
    state,
    props: {
      style: arrowStyles,
      "aria-hidden": true,
      ...elementProps
    }
  });
});
if (process.env.NODE_ENV !== "production") ComboboxArrow.displayName = "ComboboxArrow";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/icon/ComboboxIcon.mjs
import * as React80 from "react";
var ComboboxIcon = /* @__PURE__ */ React80.forwardRef(function ComboboxIcon2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const element2 = useRenderElement("span", componentProps, {
    ref: forwardedRef,
    props: [{
      "aria-hidden": true,
      children: "\u25BC"
    }, elementProps]
  });
  return element2;
});
if (process.env.NODE_ENV !== "production") ComboboxIcon.displayName = "ComboboxIcon";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/group/ComboboxGroup.mjs
import * as React82 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/group/ComboboxGroupContext.mjs
import * as React81 from "react";
var ComboboxGroupContext = /* @__PURE__ */ React81.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxGroupContext.displayName = "ComboboxGroupContext";
function useComboboxGroupContext() {
  const context = React81.useContext(ComboboxGroupContext);
  if (context === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxGroupContext is missing. ComboboxGroup parts must be placed within <Combobox.Group>." : formatErrorMessage_default(18));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/group/ComboboxGroup.mjs
import { jsx as _jsx19 } from "react/jsx-runtime";
var ComboboxGroup = /* @__PURE__ */ React82.forwardRef(function ComboboxGroup2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    items,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const grid = store.useState("grid");
  const [labelId, setLabelId] = React82.useState();
  const contextValue = React82.useMemo(() => ({
    labelId,
    setLabelId,
    items
  }), [labelId, setLabelId, items]);
  const element2 = useRenderElement("div", componentProps, {
    ref: forwardedRef,
    props: [{
      // `group` is not a valid owned element of `grid`, and `row` must be owned
      // by `grid`, `rowgroup`, or `treegrid`.
      role: grid ? "rowgroup" : "group",
      "aria-labelledby": labelId
    }, elementProps]
  });
  const wrappedElement = /* @__PURE__ */ _jsx19(ComboboxGroupContext.Provider, {
    value: contextValue,
    children: element2
  });
  if (items) {
    return /* @__PURE__ */ _jsx19(GroupCollectionProvider, {
      items,
      children: wrappedElement
    });
  }
  return wrappedElement;
});
if (process.env.NODE_ENV !== "production") ComboboxGroup.displayName = "ComboboxGroup";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/group-label/ComboboxGroupLabel.mjs
import * as React83 from "react";
var ComboboxGroupLabel = /* @__PURE__ */ React83.forwardRef(function ComboboxGroupLabel2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    id: idProp,
    ...elementProps
  } = componentProps;
  const {
    setLabelId
  } = useComboboxGroupContext();
  const id = useBaseUiId(idProp);
  useIsoLayoutEffect(() => {
    setLabelId(id);
    return () => {
      setLabelId((currentId) => currentId === id ? void 0 : currentId);
    };
  }, [id, setLabelId]);
  const element2 = useRenderElement("div", componentProps, {
    ref: forwardedRef,
    props: [{
      id,
      "aria-hidden": true
    }, elementProps]
  });
  return element2;
});
if (process.env.NODE_ENV !== "production") ComboboxGroupLabel.displayName = "ComboboxGroupLabel";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/item/ComboboxItem.mjs
import * as React87 from "react";
import * as ReactDOM5 from "react-dom";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/composite/list/useCompositeListItem.mjs
import * as React84 from "react";
function useCompositeListItem(params = {}) {
  const {
    guess,
    label,
    metadata,
    textRef,
    index: externalIndex
  } = params;
  const {
    register: register2,
    unregister,
    subscribeMapChange,
    nextIndexRef
  } = useCompositeListContext();
  const indexRef = React84.useRef(-1);
  const [internalIndex, setInternalIndex] = React84.useState(externalIndex == null && guess ? () => {
    if (indexRef.current === -1) {
      const newIndex = nextIndexRef.current;
      nextIndexRef.current += 1;
      indexRef.current = newIndex;
    }
    return indexRef.current;
  } : -1);
  const index2 = externalIndex ?? internalIndex;
  const componentRef = React84.useRef(null);
  const ref = React84.useCallback((node) => {
    const previousNode = componentRef.current;
    if (previousNode) {
      unregister(previousNode);
    }
    componentRef.current = node;
    if (node) {
      register2(node, {
        metadata: metadata ?? null,
        index: externalIndex ?? null,
        label,
        textRef
      });
    }
  }, [externalIndex, register2, unregister, metadata, label, textRef]);
  useIsoLayoutEffect(() => {
    if (externalIndex != null) {
      return void 0;
    }
    return subscribeMapChange((map) => {
      const i = componentRef.current ? map.get(componentRef.current)?.index : null;
      if (i != null) {
        setInternalIndex(i);
      }
    });
  }, [externalIndex, subscribeMapChange]);
  return {
    ref,
    index: index2
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/item/ComboboxItemContext.mjs
import * as React85 from "react";
var ComboboxItemContext = /* @__PURE__ */ React85.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxItemContext.displayName = "ComboboxItemContext";
function useComboboxItemContext() {
  const context = React85.useContext(ComboboxItemContext);
  if (!context) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemContext is missing. ComboboxItem parts must be placed within <Combobox.Item>." : formatErrorMessage_default(19));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/row/ComboboxRowContext.mjs
import * as React86 from "react";
var ComboboxRowContext = /* @__PURE__ */ React86.createContext(false);
if (process.env.NODE_ENV !== "production") ComboboxRowContext.displayName = "ComboboxRowContext";
function useComboboxRowContext() {
  return React86.useContext(ComboboxRowContext);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/item/ComboboxItem.mjs
import { jsx as _jsx20 } from "react/jsx-runtime";
function ComboboxItemInner(props) {
  const {
    componentProps,
    forwardedRef,
    virtualized,
    indexFromFilter
  } = props;
  const {
    render,
    className,
    style,
    value: itemValue = null,
    index: indexProp,
    disabled: disabledProp = false,
    nativeButton = false,
    ...elementProps
  } = componentProps;
  const textRef = React87.useRef(null);
  const listItem2 = useCompositeListItem({
    guess: true,
    index: indexProp,
    textRef
  });
  const store = useComboboxRootContext();
  const isRow = useComboboxRowContext();
  const hasItems = useComboboxHasItemsContext();
  const selectionMode = store.useState("selectionMode");
  const rootDisabled = store.useState("disabled");
  const readOnly = store.useState("readOnly");
  const isItemEqualToValue = store.useState("isItemEqualToValue");
  const disabled2 = rootDisabled || disabledProp;
  const selectable = selectionMode !== "none";
  const index2 = indexProp ?? indexFromFilter ?? listItem2.index;
  const hasRegistered = index2 !== -1;
  const rootId = store.useState("id");
  const highlighted = store.useState("isActive", index2);
  const matchesSelectedValue = store.useState("isSelected", itemValue);
  const itemProps = store.useState("itemProps");
  const itemRef = React87.useRef(null);
  const id = rootId != null && hasRegistered ? `${rootId}-${index2}` : void 0;
  const selected = matchesSelectedValue && selectable;
  useIsoLayoutEffect(() => {
    const shouldRun = hasRegistered && (virtualized || indexProp != null);
    if (!shouldRun) {
      return void 0;
    }
    const list2 = store.context.listRef.current;
    list2[index2] = itemRef.current;
    return () => {
      delete list2[index2];
    };
  }, [hasRegistered, virtualized, index2, indexProp, store]);
  useIsoLayoutEffect(() => {
    if (!hasRegistered || hasItems) {
      return void 0;
    }
    const visibleValues = store.context.valuesRef.current;
    visibleValues[index2] = itemValue;
    return () => {
      delete visibleValues[index2];
    };
  }, [hasRegistered, hasItems, index2, itemValue, store]);
  useIsoLayoutEffect(() => {
    if (!hasRegistered || hasItems) {
      return;
    }
    const selectedValue = store.state.selectedValue;
    let nextIndex = store.state.selectedIndex;
    if (store.state.selectionMode === "multiple" && Array.isArray(selectedValue)) {
      nextIndex = resolveSelectedIndex(index2, itemValue, store.context.valuesRef.current, selectedValue, isItemEqualToValue, nextIndex);
    } else if (compareItemEquality(itemValue, selectedValue, isItemEqualToValue)) {
      nextIndex = index2;
    }
    store.set("selectedIndex", nextIndex);
  }, [hasRegistered, hasItems, store, index2, itemValue, isItemEqualToValue]);
  const {
    getButtonProps,
    buttonRef
  } = useButton({
    disabled: disabled2,
    focusableWhenDisabled: true,
    native: nativeButton,
    composite: true
  });
  const state = {
    disabled: disabled2,
    selected,
    highlighted
  };
  function commitSelection(nativeEvent) {
    function selectItem() {
      store.context.handleSelection(nativeEvent, itemValue);
    }
    if (store.state.submitOnItemClick) {
      ReactDOM5.flushSync(selectItem);
      store.context.requestSubmit();
    } else {
      selectItem();
    }
  }
  const defaultProps = {
    id,
    role: isRow ? "gridcell" : "option",
    "aria-selected": selectable ? selected : void 0,
    // Focusable items steal focus from the input upon mouseup.
    // Warn if the user renders a natively focusable element like `<button>`,
    // as it should be a `<div>` instead.
    tabIndex: void 0,
    onPointerDownCapture(event) {
      if (event.isPrimary) {
        store.context.pointerDownItemRef.current = event.currentTarget;
      }
      event.preventDefault();
    },
    onMouseDown(event) {
      event.preventDefault();
    },
    onClick(event) {
      if (disabled2 || readOnly) {
        return;
      }
      commitSelection(event.nativeEvent);
    },
    onMouseUp(event) {
      const pointerStartedOnItem = store.context.pointerDownItemRef.current === event.currentTarget;
      store.context.pointerDownItemRef.current = null;
      if (disabled2 || readOnly || event.button !== 0 || pointerStartedOnItem || !highlighted) {
        return;
      }
      commitSelection(event.nativeEvent);
    }
  };
  const element2 = useRenderElement("div", componentProps, {
    ref: [buttonRef, forwardedRef, listItem2.ref, itemRef],
    state,
    props: [itemProps, defaultProps, elementProps, getButtonProps]
  });
  const contextValue = React87.useMemo(() => ({
    selected,
    textRef
  }), [selected, textRef]);
  return /* @__PURE__ */ _jsx20(ComboboxItemContext.Provider, {
    value: contextValue,
    children: element2
  });
}
function ComboboxItemVirtualizedIndex(props) {
  const {
    componentProps,
    forwardedRef
  } = props;
  const store = useComboboxRootContext();
  const isItemEqualToValue = store.useState("isItemEqualToValue");
  const {
    flatFilteredValues
  } = useComboboxDerivedItemsContext();
  const lookupValue = componentProps.value ?? null;
  const indexFromFilter = findItemIndex(flatFilteredValues, lookupValue, isItemEqualToValue);
  return /* @__PURE__ */ _jsx20(ComboboxItemInner, {
    componentProps,
    forwardedRef,
    virtualized: true,
    indexFromFilter
  });
}
var ComboboxItem = /* @__PURE__ */ React87.memo(/* @__PURE__ */ React87.forwardRef(function ComboboxItem2(componentProps, forwardedRef) {
  const store = useComboboxRootContext();
  const virtualized = store.useState("virtualized");
  if (virtualized && componentProps.index == null) {
    return /* @__PURE__ */ _jsx20(ComboboxItemVirtualizedIndex, {
      componentProps,
      forwardedRef
    });
  }
  return /* @__PURE__ */ _jsx20(ComboboxItemInner, {
    componentProps,
    forwardedRef,
    virtualized,
    indexFromFilter: void 0
  });
}));
if (process.env.NODE_ENV !== "production") ComboboxItem.displayName = "ComboboxItem";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/item-indicator/ComboboxItemIndicator.mjs
import * as React88 from "react";
import { jsx as _jsx21 } from "react/jsx-runtime";
var ComboboxItemIndicator = /* @__PURE__ */ React88.forwardRef(function ComboboxItemIndicator2(componentProps, forwardedRef) {
  const {
    selected
  } = useComboboxItemContext();
  const shouldRender = componentProps.keepMounted || selected;
  if (!shouldRender) {
    return null;
  }
  return /* @__PURE__ */ _jsx21(Inner, {
    ...componentProps,
    ref: forwardedRef
  });
});
if (process.env.NODE_ENV !== "production") ComboboxItemIndicator.displayName = "ComboboxItemIndicator";
var Inner = /* @__PURE__ */ React88.memo(/* @__PURE__ */ React88.forwardRef((componentProps, forwardedRef) => {
  const {
    render,
    className,
    style,
    keepMounted,
    ...elementProps
  } = componentProps;
  const {
    selected
  } = useComboboxItemContext();
  const indicatorRef = React88.useRef(null);
  const {
    transitionStatus,
    setMounted
  } = useTransitionStatus(selected);
  const state = {
    selected,
    transitionStatus
  };
  const element2 = useRenderElement("span", componentProps, {
    ref: [forwardedRef, indicatorRef],
    state,
    props: [{
      "aria-hidden": true,
      children: "\u2714\uFE0F"
    }, elementProps],
    stateAttributesMapping: transitionStatusMapping
  });
  useOpenChangeComplete({
    batch: true,
    enabled: !selected,
    open: selected,
    ref: indicatorRef,
    onComplete() {
      if (!selected) {
        setMounted(false);
      }
    }
  });
  return element2;
}));
if (process.env.NODE_ENV !== "production") Inner.displayName = "Inner";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/chips/ComboboxChips.mjs
import * as React89 from "react";
import { jsx as _jsx22 } from "react/jsx-runtime";
var ComboboxChips = /* @__PURE__ */ React89.forwardRef(function ComboboxChips2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const open2 = store.useState("open");
  const hasSelectionChips = store.useState("hasSelectionChips");
  const [highlightedChipIndex, setHighlightedChipIndex] = React89.useState(void 0);
  if (open2 && highlightedChipIndex !== void 0) {
    setHighlightedChipIndex(void 0);
  }
  const chipsRef = React89.useRef([]);
  const element2 = useRenderElement("div", componentProps, {
    ref: [forwardedRef, store.context.chipsContainerRef],
    // NVDA enters browse mode instead of staying in focus mode when navigating with
    // arrow keys inside a container unless it has a toolbar role.
    props: [hasSelectionChips ? {
      role: "toolbar"
    } : EMPTY_OBJECT, {
      onMouseDown(event) {
        handleInputPress(event, store, store.state.disabled);
      }
    }, elementProps]
  });
  const contextValue = React89.useMemo(() => ({
    highlightedChipIndex,
    setHighlightedChipIndex,
    chipsRef
  }), [highlightedChipIndex, setHighlightedChipIndex, chipsRef]);
  return /* @__PURE__ */ _jsx22(ComboboxChipsContext.Provider, {
    value: contextValue,
    children: /* @__PURE__ */ _jsx22(CompositeList, {
      elementsRef: chipsRef,
      children: element2
    })
  });
});
if (process.env.NODE_ENV !== "production") ComboboxChips.displayName = "ComboboxChips";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/chip/ComboboxChip.mjs
import * as React91 from "react";
import * as ReactDOM6 from "react-dom";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/chip/ComboboxChipContext.mjs
import * as React90 from "react";
var ComboboxChipContext = /* @__PURE__ */ React90.createContext(void 0);
if (process.env.NODE_ENV !== "production") ComboboxChipContext.displayName = "ComboboxChipContext";
function useComboboxChipContext() {
  const context = React90.useContext(ComboboxChipContext);
  if (!context) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxChipContext is missing. ComboboxChip parts must be placed within <Combobox.Chip>." : formatErrorMessage_default(17));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/chip/ComboboxChip.mjs
import { jsx as _jsx23 } from "react/jsx-runtime";
var ComboboxChip = /* @__PURE__ */ React91.forwardRef(function ComboboxChip2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const {
    setHighlightedChipIndex,
    chipsRef
  } = useComboboxChipsContext();
  const direction = useDirection3();
  const disabled2 = store.useState("disabled");
  const readOnly = store.useState("readOnly");
  const selectedValue = store.useState("selectedValue");
  const {
    ref,
    index: index2
  } = useCompositeListItem();
  function handleKeyDown(event) {
    let nextIndex = index2;
    const [previousChipKey, nextChipKey] = getChipNavigationKeys(direction);
    if (event.key === previousChipKey) {
      event.preventDefault();
      if (index2 > 0) {
        nextIndex = index2 - 1;
      } else {
        nextIndex = void 0;
      }
    } else if (event.key === nextChipKey) {
      event.preventDefault();
      if (index2 < chipsRef.current.length - 1) {
        nextIndex = index2 + 1;
      } else {
        nextIndex = void 0;
      }
    } else if (event.key === "Backspace" || event.key === "Delete") {
      nextIndex = getIndexAfterChipRemoval(index2, selectedValue.length);
      stopEvent(event);
      store.context.setIndices({
        activeIndex: null,
        selectedIndex: null,
        type: reason_parts_exports.keyboard
      });
      store.context.setSelectedValue(selectedValue.filter((_, i) => i !== index2), createChangeEventDetails(reason_parts_exports.none, event.nativeEvent));
    } else if (event.key === "Enter" || event.key === " ") {
      stopEvent(event);
      nextIndex = void 0;
    } else if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      stopEvent(event);
      store.context.setOpen(true, createChangeEventDetails(reason_parts_exports.listNavigation, event.nativeEvent));
      nextIndex = void 0;
    } else if (
      // Check for printable characters (letters, numbers, symbols)
      event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey
    ) {
      nextIndex = void 0;
    }
    return nextIndex;
  }
  const state = {
    disabled: disabled2
  };
  const element2 = useRenderElement("div", componentProps, {
    ref: [forwardedRef, ref],
    state,
    props: [{
      tabIndex: -1,
      "aria-disabled": disabled2 || void 0,
      "aria-readonly": readOnly || void 0,
      onKeyDown(event) {
        if (disabled2 || readOnly) {
          return;
        }
        const nextIndex = handleKeyDown(event);
        ReactDOM6.flushSync(() => {
          setHighlightedChipIndex(nextIndex);
        });
        if (nextIndex === void 0) {
          store.context.inputRef.current?.focus();
        } else {
          chipsRef.current[nextIndex]?.focus();
        }
      }
    }, elementProps]
  });
  const contextValue = React91.useMemo(() => ({
    index: index2
  }), [index2]);
  return /* @__PURE__ */ _jsx23(ComboboxChipContext.Provider, {
    value: contextValue,
    children: element2
  });
});
if (process.env.NODE_ENV !== "production") ComboboxChip.displayName = "ComboboxChip";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/chip-remove/ComboboxChipRemove.mjs
import * as React92 from "react";
var ComboboxChipRemove = /* @__PURE__ */ React92.forwardRef(function ComboboxChipRemove2(componentProps, forwardedRef) {
  const {
    render,
    className,
    disabled: disabledProp = false,
    nativeButton = true,
    style,
    ...elementProps
  } = componentProps;
  const store = useComboboxRootContext();
  const {
    index: index2
  } = useComboboxChipContext();
  const comboboxDisabled = store.useState("disabled");
  const readOnly = store.useState("readOnly");
  const selectedValue = store.useState("selectedValue");
  const isItemEqualToValue = store.useState("isItemEqualToValue");
  const disabled2 = comboboxDisabled || disabledProp;
  const {
    buttonRef,
    getButtonProps
  } = useButton({
    native: nativeButton,
    disabled: disabled2 || readOnly,
    focusableWhenDisabled: true
  });
  const state = {
    disabled: disabled2
  };
  function clearActiveIndexForRemovedItem(removedItem) {
    const activeIndex = store.state.activeIndex;
    if (activeIndex == null) {
      return;
    }
    const removedIndex = findItemIndex(store.context.valuesRef.current, removedItem, isItemEqualToValue);
    if (removedIndex !== -1 && activeIndex === removedIndex) {
      store.context.setIndices({
        activeIndex: null,
        type: store.context.keyboardActiveRef.current ? reason_parts_exports.keyboard : reason_parts_exports.pointer
      });
    }
  }
  function removeChip(event) {
    const eventDetails = createChangeEventDetails(reason_parts_exports.chipRemovePress, event.nativeEvent);
    const removedItem = selectedValue[index2];
    clearActiveIndexForRemovedItem(removedItem);
    store.context.setSelectedValue(selectedValue.filter((_, i) => i !== index2), eventDetails);
    store.context.inputRef.current?.focus();
    return eventDetails;
  }
  const element2 = useRenderElement("button", componentProps, {
    ref: [forwardedRef, buttonRef],
    state,
    props: [{
      tabIndex: -1,
      onMouseDown(event) {
        event.preventDefault();
      },
      onClick(event) {
        const eventDetails = removeChip(event);
        if (!eventDetails.isPropagationAllowed) {
          event.stopPropagation();
        }
      },
      onKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
          const eventDetails = removeChip(event);
          if (!eventDetails.isPropagationAllowed) {
            stopEvent(event);
          }
        }
      }
    }, elementProps, getButtonProps]
  });
  return element2;
});
if (process.env.NODE_ENV !== "production") ComboboxChipRemove.displayName = "ComboboxChipRemove";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/row/ComboboxRow.mjs
import * as React93 from "react";
import { jsx as _jsx24 } from "react/jsx-runtime";
var ComboboxRow = /* @__PURE__ */ React93.forwardRef(function ComboboxRow2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const element2 = useRenderElement("div", componentProps, {
    ref: forwardedRef,
    props: [{
      role: "row"
    }, elementProps]
  });
  return /* @__PURE__ */ _jsx24(ComboboxRowContext.Provider, {
    value: true,
    children: element2
  });
});
if (process.env.NODE_ENV !== "production") ComboboxRow.displayName = "ComboboxRow";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/empty/ComboboxEmpty.mjs
import * as React94 from "react";
var ComboboxEmpty = /* @__PURE__ */ React94.forwardRef(function ComboboxEmpty2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    children: childrenProp,
    ...elementProps
  } = componentProps;
  const {
    filteredItems
  } = useComboboxDerivedItemsContext();
  const store = useComboboxRootContext();
  const emptyRef = useInitialLiveRegionTextMutation();
  const children = filteredItems.length === 0 ? childrenProp : null;
  return useRenderElement("div", componentProps, {
    ref: [forwardedRef, store.context.emptyRef, emptyRef],
    props: [{
      children,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": true
    }, elementProps]
  });
});
if (process.env.NODE_ENV !== "production") ComboboxEmpty.displayName = "ComboboxEmpty";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/clear/ComboboxClear.mjs
import * as React95 from "react";
var stateAttributesMapping3 = {
  ...transitionStatusMapping,
  ...triggerOpenStateMapping
};
var ComboboxClear = /* @__PURE__ */ React95.forwardRef(function ComboboxClear2(componentProps, forwardedRef) {
  const {
    render,
    className,
    disabled: disabledProp = false,
    nativeButton = true,
    keepMounted = false,
    style,
    ...elementProps
  } = componentProps;
  const {
    disabled: fieldDisabled
  } = useFieldRootContext();
  const store = useComboboxRootContext();
  const selectionMode = store.useState("selectionMode");
  const comboboxDisabled = store.useState("disabled");
  const readOnly = store.useState("readOnly");
  const open2 = store.useState("open");
  const selectedValue = store.useState("selectedValue");
  const hasSelectionChips = store.useState("hasSelectionChips");
  const inputValue = useComboboxInputValueContext();
  let visible = false;
  if (selectionMode === "none") {
    visible = inputValue !== "";
  } else if (selectionMode === "single") {
    visible = selectedValue != null;
  } else {
    visible = hasSelectionChips;
  }
  const disabled2 = fieldDisabled || comboboxDisabled || disabledProp;
  const {
    buttonRef,
    getButtonProps
  } = useButton({
    native: nativeButton,
    disabled: disabled2
  });
  const {
    mounted,
    transitionStatus,
    setMounted
  } = useTransitionStatus(visible);
  const state = {
    disabled: disabled2,
    visible,
    open: open2,
    transitionStatus
  };
  useOpenChangeComplete({
    open: visible,
    ref: store.context.clearRef,
    onComplete() {
      if (!visible) {
        setMounted(false);
      }
    }
  });
  const element2 = useRenderElement("button", componentProps, {
    state,
    ref: [forwardedRef, buttonRef, store.context.clearRef],
    props: [{
      tabIndex: -1,
      children: "x",
      // Avoid stealing focus from the input.
      onMouseDown(event) {
        event.preventDefault();
      },
      onClick(event) {
        if (disabled2 || readOnly) {
          return;
        }
        const type = store.context.keyboardActiveRef.current ? reason_parts_exports.keyboard : reason_parts_exports.pointer;
        store.context.setInputValue("", createChangeEventDetails(reason_parts_exports.clearPress, event.nativeEvent));
        if (selectionMode !== "none") {
          store.context.setSelectedValue(Array.isArray(selectedValue) ? [] : null, createChangeEventDetails(reason_parts_exports.clearPress, event.nativeEvent));
          store.context.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type
          });
        } else {
          store.context.setIndices({
            activeIndex: null,
            type
          });
        }
        store.context.inputRef.current?.focus();
      }
    }, elementProps, getButtonProps],
    stateAttributesMapping: stateAttributesMapping3
  });
  const shouldRender = keepMounted || mounted;
  if (!shouldRender) {
    return null;
  }
  return element2;
});
if (process.env.NODE_ENV !== "production") ComboboxClear.displayName = "ComboboxClear";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/utils/listbox-separator/ListboxSeparator.mjs
import * as React96 from "react";
var ListboxSeparator = /* @__PURE__ */ React96.forwardRef(function ListboxSeparator2(componentProps, forwardedRef) {
  const {
    className,
    render,
    orientation = "horizontal",
    style,
    ...elementProps
  } = componentProps;
  const state = {
    orientation
  };
  return useRenderElement("div", componentProps, {
    state,
    ref: forwardedRef,
    props: [{
      role: "presentation"
    }, elementProps]
  });
});
if (process.env.NODE_ENV !== "production") ListboxSeparator.displayName = "ListboxSeparator";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/separator/ComboboxSeparator.mjs
var ComboboxSeparator = ListboxSeparator;

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/root/utils/useFilteredItems.mjs
function useFilteredItems() {
  const items = useComboboxDerivedItemsContext();
  return items.filteredItems;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/combobox/items/createItems.mjs
function createComboboxItems(data, options) {
  const {
    getValue,
    getLabel: getLabel2
  } = options;
  let valueToItem = null;
  function ensureDerived() {
    if (valueToItem === null) {
      const derived = /* @__PURE__ */ new Map();
      const leafItems = data ? flattenLeafItems(data) : EMPTY_ARRAY;
      for (const item of leafItems) {
        if (item == null) {
          continue;
        }
        const derivedValue = getValue(item);
        if (!derived.has(derivedValue)) {
          derived.set(derivedValue, item);
        } else if (process.env.NODE_ENV !== "production") {
          error(`Two items passed to createItems() derived the value ${String(derivedValue)}, so selection and label resolution cannot tell them apart: the first item wins the label and every item carrying the value renders as selected. Return a unique value from \`getValue\`.`);
        }
      }
      valueToItem = derived;
    }
    return valueToItem;
  }
  function value(item) {
    if (item == null) {
      return item;
    }
    return getValue(item);
  }
  return {
    // Passed through rather than defaulted: data that has not loaded must stay the absence of
    // items rather than an empty list that filters everything away.
    data,
    value,
    hasValue(itemValue, isEqual) {
      return findCollectionItem(ensureDerived(), itemValue, isEqual) !== void 0;
    },
    itemLabel: getLabel2,
    label(itemValue, isEqual, fallback) {
      const item = findCollectionItem(ensureDerived(), itemValue, isEqual);
      if (item !== void 0) {
        return getLabel2(item);
      }
      return stringifyAsLabel(itemValue, fallback);
    }
  };
}

// src/components/primitive/Combobox/Combobox.tsx
import { jsx as jsx24, jsxs as jsxs15 } from "react/jsx-runtime";
function classes(base, className) {
  return typeof className === "function" ? (state) => clsx(base, className(state)) : clsx(base, className);
}
function Combobox(props) {
  return /* @__PURE__ */ jsx24(index_parts_exports.Root, { ...props });
}
Combobox.displayName = "Combobox";
function ComboboxValue2(props) {
  return /* @__PURE__ */ jsx24(index_parts_exports.Value, { ...props });
}
ComboboxValue2.displayName = "ComboboxValue";
var ComboboxChipsInput = React97.forwardRef(
  ({ className, onKeyDown, ...props }, ref) => /* @__PURE__ */ jsx24(
    index_parts_exports.Input,
    {
      ref,
      className: classes("buyscout-combobox__input", className),
      onKeyDown: (event) => {
        onKeyDown?.(event);
        const input = event.currentTarget;
        if (event.key !== "Backspace" || input.value !== "" || input.readOnly || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
        event.preventBaseUIHandler();
        if (event.repeat) return;
        const chips = input.closest(".buyscout-combobox__chips")?.querySelectorAll(".buyscout-combobox__chip");
        chips?.[chips.length - 1]?.focus();
      },
      ...props
    }
  )
);
ComboboxChipsInput.displayName = "ComboboxChipsInput";
var ComboboxChips3 = React97.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ jsx24(index_parts_exports.Chips, { ref, className: classes("buyscout-combobox__chips", className), ...props })
);
ComboboxChips3.displayName = "ComboboxChips";
var ComboboxChip3 = React97.forwardRef(
  ({ className, children, removeLabel, showRemove = true, onKeyDown, ...props }, ref) => /* @__PURE__ */ jsxs15(
    index_parts_exports.Chip,
    {
      ref,
      className: classes("buyscout-combobox__chip", className),
      onKeyDown: (event) => {
        onKeyDown?.(event);
        if (event.repeat && (event.key === "Backspace" || event.key === "Delete")) {
          event.preventDefault();
          event.preventBaseUIHandler();
        }
      },
      ...props,
      children: [
        /* @__PURE__ */ jsx24("span", { className: "buyscout-combobox__chip-text", children }),
        showRemove && /* @__PURE__ */ jsx24(index_parts_exports.ChipRemove, { className: "buyscout-combobox__remove", "aria-label": removeLabel, children: /* @__PURE__ */ jsx24(MdClose2, { "aria-hidden": "true" }) })
      ]
    }
  )
);
ComboboxChip3.displayName = "ComboboxChip";
var ComboboxTrigger3 = React97.forwardRef(
  ({ className, children, asChild, ...props }, ref) => /* @__PURE__ */ jsx24(index_parts_exports.Trigger, { ref, render: asChild ? /* @__PURE__ */ jsx24(Slot, {}) : void 0, className: classes("buyscout-combobox__trigger", className), ...props, children: children ?? /* @__PURE__ */ jsx24(MdArrowDropDown2, { "aria-hidden": "true" }) })
);
ComboboxTrigger3.displayName = "ComboboxTrigger";
var ComboboxContent = React97.forwardRef(
  ({ className, anchor, side = "bottom", sideOffset = 6, align = "start", alignOffset = 0, ...props }, ref) => {
    const [container, setContainer] = React97.useState();
    React97.useLayoutEffect(() => {
      setContainer(anchor.current?.closest('[role="dialog"]') ?? void 0);
    }, [anchor]);
    return (
      // Radix dialogs need nested popups in their focus boundary and layer stack.
      /* @__PURE__ */ jsx24(index_parts_exports.Portal, { container, children: /* @__PURE__ */ jsx24(index_parts_exports.Positioner, { anchor, side, sideOffset, align, alignOffset, className: "buyscout-combobox__positioner", children: /* @__PURE__ */ jsx24(DismissableLayer, { asChild: true, onEscapeKeyDown: (event) => event.preventDefault(), children: /* @__PURE__ */ jsx24(index_parts_exports.Popup, { ref, className: classes("buyscout-combobox__content", className), ...props }) }) }) })
    );
  }
);
ComboboxContent.displayName = "ComboboxContent";
var ComboboxList3 = React97.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ jsx24(index_parts_exports.List, { ref, className: classes("buyscout-combobox__list", className), ...props })
);
ComboboxList3.displayName = "ComboboxList";
var ComboboxItem3 = React97.forwardRef(
  ({ className, children, ...props }, ref) => /* @__PURE__ */ jsxs15(index_parts_exports.Item, { ref, className: classes("buyscout-combobox__item", className), ...props, children: [
    /* @__PURE__ */ jsx24(index_parts_exports.ItemIndicator, { className: "buyscout-combobox__indicator", children: /* @__PURE__ */ jsx24(MdCheck, { "aria-hidden": "true" }) }),
    children
  ] })
);
ComboboxItem3.displayName = "ComboboxItem";
var ComboboxEmpty3 = React97.forwardRef(
  ({ className, ...props }, ref) => /* @__PURE__ */ jsx24(index_parts_exports.Empty, { ref, className: classes("buyscout-combobox__empty", className), ...props })
);
ComboboxEmpty3.displayName = "ComboboxEmpty";
function ComboboxCount({ ref, className, count: count2, max: max2, limitMessage, ...props }) {
  const { t } = useComponentsTranslation();
  const full = count2 >= max2;
  return /* @__PURE__ */ jsxs15("span", { ref, className: clsx("buyscout-combobox__count", className), "data-full": full ? "" : void 0, ...props, children: [
    t("combobox.count", { current: count2, max: max2 }),
    /* @__PURE__ */ jsx24("span", { role: "status", className: "buyscout-combobox__count-status", children: full ? limitMessage : "" })
  ] });
}
ComboboxCount.displayName = "ComboboxCount";

// src/components/primitive/Combobox/useComboboxAnchor.ts
import { useRef as useRef39 } from "react";
function useComboboxAnchor() {
  return useRef39(null);
}

// src/components/primitive/DropdownMenu/DropdownMenu.tsx
import * as React108 from "react";
import { MdCheck as MdCheck2, MdChevronRight, MdRemove } from "react-icons/md";

// ../../node_modules/.pnpm/@radix-ui+react-dropdown-menu@2.1.18_@types+react-dom@19.2.3_@types+react@19.2.14__@typ_e132fcc7fd7b3b054096338a0581fd04/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs
import * as React107 from "react";

// ../../node_modules/.pnpm/@radix-ui+react-menu@2.1.18_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react@_2d2bf0087e8cc830b92ad0450e3a3635/node_modules/@radix-ui/react-menu/dist/index.mjs
import * as React106 from "react";

// ../../node_modules/.pnpm/@radix-ui+react-collection@1.1.10_@types+react-dom@19.2.3_@types+react@19.2.14__@types+_65c396047026fe85ecbd1fde002c71b9/node_modules/@radix-ui/react-collection/dist/index.mjs
import * as React98 from "react";
import { jsx as jsx25 } from "react/jsx-runtime";
import * as React210 from "react";
import { jsx as jsx26 } from "react/jsx-runtime";
function createCollection2(name2) {
  const PROVIDER_NAME2 = name2 + "CollectionProvider";
  const [createCollectionContext, createCollectionScope6] = createContextScope3(PROVIDER_NAME2);
  const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(
    PROVIDER_NAME2,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  );
  const CollectionProvider = (props) => {
    const { scope, children } = props;
    const ref = React98.useRef(null);
    const itemMap = React98.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ jsx25(CollectionProviderImpl, { scope, itemMap, collectionRef: ref, children });
  };
  CollectionProvider.displayName = PROVIDER_NAME2;
  const COLLECTION_SLOT_NAME = name2 + "CollectionSlot";
  const CollectionSlotImpl = createSlot(COLLECTION_SLOT_NAME);
  const CollectionSlot = React98.forwardRef(
    (props, forwardedRef) => {
      const { scope, children } = props;
      const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
      const composedRefs = useComposedRefs2(forwardedRef, context.collectionRef);
      return /* @__PURE__ */ jsx25(CollectionSlotImpl, { ref: composedRefs, children });
    }
  );
  CollectionSlot.displayName = COLLECTION_SLOT_NAME;
  const ITEM_SLOT_NAME = name2 + "CollectionItemSlot";
  const ITEM_DATA_ATTR = "data-radix-collection-item";
  const CollectionItemSlotImpl = createSlot(ITEM_SLOT_NAME);
  const CollectionItemSlot = React98.forwardRef(
    (props, forwardedRef) => {
      const { scope, children, ...itemData } = props;
      const ref = React98.useRef(null);
      const composedRefs = useComposedRefs2(forwardedRef, ref);
      const context = useCollectionContext(ITEM_SLOT_NAME, scope);
      React98.useEffect(() => {
        context.itemMap.set(ref, { ref, ...itemData });
        return () => void context.itemMap.delete(ref);
      });
      return /* @__PURE__ */ jsx25(CollectionItemSlotImpl, { ...{ [ITEM_DATA_ATTR]: "" }, ref: composedRefs, children });
    }
  );
  CollectionItemSlot.displayName = ITEM_SLOT_NAME;
  function useCollection6(scope) {
    const context = useCollectionContext(name2 + "CollectionConsumer", scope);
    const getItems = React98.useCallback(() => {
      const collectionNode = context.collectionRef.current;
      if (!collectionNode) return [];
      const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
      const items = Array.from(context.itemMap.values());
      const orderedItems = items.sort(
        (a, b) => orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current)
      );
      return orderedItems;
    }, [context.collectionRef, context.itemMap]);
    return getItems;
  }
  return [
    { Provider: CollectionProvider, Slot: CollectionSlot, ItemSlot: CollectionItemSlot },
    useCollection6,
    createCollectionScope6
  ];
}

// ../../node_modules/.pnpm/@radix-ui+react-focus-guards@1.1.4_@types+react@19.2.14_react@19.2.5/node_modules/@radix-ui/react-focus-guards/dist/index.mjs
import * as React99 from "react";
var count = 0;
var guards = null;
function useFocusGuards() {
  React99.useEffect(() => {
    if (!guards) {
      guards = { start: createFocusGuard(), end: createFocusGuard() };
    }
    const { start, end } = guards;
    if (document.body.firstElementChild !== start) {
      document.body.insertAdjacentElement("afterbegin", start);
    }
    if (document.body.lastElementChild !== end) {
      document.body.insertAdjacentElement("beforeend", end);
    }
    count++;
    return () => {
      if (count === 1) {
        guards?.start.remove();
        guards?.end.remove();
        guards = null;
      }
      count = Math.max(0, count - 1);
    };
  }, []);
}
function createFocusGuard() {
  const element2 = document.createElement("span");
  element2.setAttribute("data-radix-focus-guard", "");
  element2.tabIndex = 0;
  element2.style.outline = "none";
  element2.style.opacity = "0";
  element2.style.position = "fixed";
  element2.style.pointerEvents = "none";
  return element2;
}

// ../../node_modules/.pnpm/@radix-ui+react-focus-scope@1.1.10_@types+react-dom@19.2.3_@types+react@19.2.14__@types_e60b43ba8965db89e83f29772a75dac0/node_modules/@radix-ui/react-focus-scope/dist/index.mjs
import * as React100 from "react";
import { jsx as jsx27 } from "react/jsx-runtime";
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = React100.forwardRef((props, forwardedRef) => {
  const {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp,
    ...scopeProps
  } = props;
  const [container, setContainer] = React100.useState(null);
  const onMountAutoFocus = useCallbackRef(onMountAutoFocusProp);
  const onUnmountAutoFocus = useCallbackRef(onUnmountAutoFocusProp);
  const lastFocusedElementRef = React100.useRef(null);
  const composedRefs = useComposedRefs2(forwardedRef, (node) => setContainer(node));
  const focusScope = React100.useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  React100.useEffect(() => {
    if (trapped) {
      let handleFocusIn2 = function(event) {
        if (focusScope.paused || !container) return;
        const target = event.target;
        if (container.contains(target)) {
          lastFocusedElementRef.current = target;
        } else {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleFocusOut2 = function(event) {
        if (focusScope.paused || !container) return;
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null) return;
        if (!container.contains(relatedTarget)) {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleMutations2 = function(mutations) {
        const focusedElement = document.activeElement;
        if (focusedElement !== document.body) return;
        for (const mutation of mutations) {
          if (mutation.removedNodes.length > 0) focus(container);
        }
      };
      var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      const mutationObserver = new MutationObserver(handleMutations2);
      if (container) mutationObserver.observe(container, { childList: true, subtree: true });
      return () => {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container, focusScope.paused]);
  React100.useEffect(() => {
    if (container) {
      focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
        container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst(removeLinks(getTabbableCandidates(container)), { select: true });
          if (document.activeElement === previouslyFocusedElement) {
            focus(container);
          }
        }
      }
      return () => {
        container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
          container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            focus(previouslyFocusedElement ?? document.body, { select: true });
          }
          container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = React100.useCallback(
    (event) => {
      if (!loop && !trapped) return;
      if (focusScope.paused) return;
      const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
      const focusedElement = document.activeElement;
      if (isTabKey && focusedElement) {
        const container2 = event.currentTarget;
        const [first, last] = getTabbableEdges(container2);
        const hasTabbableElementsInside = first && last;
        if (!hasTabbableElementsInside) {
          if (focusedElement === container2) event.preventDefault();
        } else {
          if (!event.shiftKey && focusedElement === last) {
            event.preventDefault();
            if (loop) focus(first, { select: true });
          } else if (event.shiftKey && focusedElement === first) {
            event.preventDefault();
            if (loop) focus(last, { select: true });
          }
        }
      }
    },
    [loop, trapped, focusScope.paused]
  );
  return /* @__PURE__ */ jsx27(Primitive.div, { tabIndex: -1, ...scopeProps, ref: composedRefs, onKeyDown: handleKeyDown });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    focus(candidate, { select });
    if (document.activeElement !== previouslyFocusedElement) return;
  }
}
function getTabbableEdges(container) {
  const candidates = getTabbableCandidates(container);
  const first = findVisible(candidates, container);
  const last = findVisible(candidates.reverse(), container);
  return [first, last];
}
function getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container) {
  for (const element2 of elements) {
    if (!isHidden(element2, { upTo: container })) return element2;
  }
}
function isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === "hidden") return true;
  while (node) {
    if (upTo !== void 0 && node === upTo) return false;
    if (getComputedStyle(node).display === "none") return true;
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element2) {
  return element2 instanceof HTMLInputElement && "select" in element2;
}
function focus(element2, { select = false } = {}) {
  if (element2 && element2.focus) {
    const previouslyFocusedElement = document.activeElement;
    element2.focus({ preventScroll: true });
    if (element2 !== previouslyFocusedElement && isSelectableInput(element2) && select)
      element2.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope?.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      stack = arrayRemove(stack, focusScope);
      stack[0]?.resume();
    }
  };
}
function arrayRemove(array, item) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) {
    updatedArray.splice(index2, 1);
  }
  return updatedArray;
}
function removeLinks(items) {
  return items.filter((item) => item.tagName !== "A");
}

// ../../node_modules/.pnpm/@radix-ui+react-popper@1.3.1_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_b8775c33ed027d826589d032467a112e/node_modules/@radix-ui/react-popper/dist/index.mjs
import * as React102 from "react";

// ../../node_modules/.pnpm/@radix-ui+react-arrow@1.1.10_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_6c01b894d93396d8227ca8bf721dd865/node_modules/@radix-ui/react-arrow/dist/index.mjs
import * as React101 from "react";
import { jsx as jsx28 } from "react/jsx-runtime";
var NAME = "Arrow";
var Arrow = React101.forwardRef((props, forwardedRef) => {
  const { children, width = 10, height = 5, ...arrowProps } = props;
  return /* @__PURE__ */ jsx28(
    Primitive.svg,
    {
      ...arrowProps,
      ref: forwardedRef,
      width,
      height,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: props.asChild ? children : /* @__PURE__ */ jsx28("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Arrow.displayName = NAME;
var Root6 = Arrow;

// ../../node_modules/.pnpm/@radix-ui+react-popper@1.3.1_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_b8775c33ed027d826589d032467a112e/node_modules/@radix-ui/react-popper/dist/index.mjs
import { jsx as jsx29 } from "react/jsx-runtime";
var POPPER_NAME = "Popper";
var [createPopperContext, createPopperScope] = createContextScope3(POPPER_NAME);
var [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
var Popper = (props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = React102.useState(null);
  const [placementState, setPlacementState] = React102.useState(void 0);
  return /* @__PURE__ */ jsx29(
    PopperProvider,
    {
      scope: __scopePopper,
      anchor,
      onAnchorChange: setAnchor,
      placementState,
      setPlacementState,
      children
    }
  );
};
Popper.displayName = POPPER_NAME;
var ANCHOR_NAME = "PopperAnchor";
var PopperAnchor = React102.forwardRef(
  (props, forwardedRef) => {
    const { __scopePopper, virtualRef, ...anchorProps } = props;
    const context = usePopperContext(ANCHOR_NAME, __scopePopper);
    const ref = React102.useRef(null);
    const onAnchorChange = context.onAnchorChange;
    const callbackRef = React102.useCallback(
      (node) => {
        ref.current = node;
        if (node) {
          onAnchorChange(node);
        }
      },
      [onAnchorChange]
    );
    const composedRefs = useComposedRefs2(forwardedRef, callbackRef);
    const anchorRef = React102.useRef(null);
    React102.useEffect(() => {
      if (!virtualRef) {
        return;
      }
      const previousAnchor = anchorRef.current;
      anchorRef.current = virtualRef.current;
      if (previousAnchor !== anchorRef.current) {
        onAnchorChange(anchorRef.current);
      }
    });
    const sideAndAlign = context.placementState && getSideAndAlignFromPlacement(context.placementState);
    const placedSide = sideAndAlign?.[0];
    const placedAlign = sideAndAlign?.[1];
    return virtualRef ? null : /* @__PURE__ */ jsx29(
      Primitive.div,
      {
        "data-radix-popper-side": placedSide,
        "data-radix-popper-align": placedAlign,
        ...anchorProps,
        ref: composedRefs
      }
    );
  }
);
PopperAnchor.displayName = ANCHOR_NAME;
var CONTENT_NAME4 = "PopperContent";
var [PopperContentProvider, useContentContext] = createPopperContext(CONTENT_NAME4);
var PopperContent = React102.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopePopper,
      side = "bottom",
      sideOffset = 0,
      align = "center",
      alignOffset = 0,
      arrowPadding = 0,
      avoidCollisions = true,
      collisionBoundary = [],
      collisionPadding: collisionPaddingProp = 0,
      sticky = "partial",
      hideWhenDetached = false,
      updatePositionStrategy = "optimized",
      onPlaced,
      ...contentProps
    } = props;
    const context = usePopperContext(CONTENT_NAME4, __scopePopper);
    const [content, setContent] = React102.useState(null);
    const composedRefs = useComposedRefs2(forwardedRef, (node) => setContent(node));
    const [arrow6, setArrow] = React102.useState(null);
    const arrowSize = useSize2(arrow6);
    const arrowWidth = arrowSize?.width ?? 0;
    const arrowHeight = arrowSize?.height ?? 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : { top: 0, right: 0, bottom: 0, left: 0, ...collisionPaddingProp };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
      padding: collisionPadding,
      boundary: boundary.filter(isNotNull),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: hasExplicitBoundaries
    };
    const { refs, floatingStyles, placement, isPositioned, middlewareData } = useFloating({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: desiredPlacement,
      whileElementsMounted: (...args) => {
        const cleanup = autoUpdate(...args, {
          animationFrame: updatePositionStrategy === "always"
        });
        return cleanup;
      },
      elements: {
        reference: context.anchor
      },
      middleware: [
        offset({ mainAxis: sideOffset + arrowHeight, alignmentAxis: alignOffset }),
        avoidCollisions && shift({
          mainAxis: true,
          crossAxis: false,
          limiter: sticky === "partial" ? limitShift() : void 0,
          ...detectOverflowOptions
        }),
        avoidCollisions && flip({ ...detectOverflowOptions }),
        size({
          ...detectOverflowOptions,
          apply: ({ elements, rects, availableWidth: availableWidth2, availableHeight: availableHeight2 }) => {
            const { width: anchorWidth2, height: anchorHeight2 } = rects.reference;
            const contentStyle = elements.floating.style;
            contentStyle.setProperty("--radix-popper-available-width", `${availableWidth2}px`);
            contentStyle.setProperty("--radix-popper-available-height", `${availableHeight2}px`);
            contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth2}px`);
            contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight2}px`);
          }
        }),
        arrow6 && arrow({ element: arrow6, padding: arrowPadding }),
        transformOrigin2({ arrowWidth, arrowHeight }),
        hideWhenDetached && hide({
          strategy: "referenceHidden",
          ...detectOverflowOptions,
          // `hide` detects whether the anchor (reference) is clipped, so when
          // no explicit `collisionBoundary` is set we fall back to Floating
          // UI's default clipping ancestors (e.g. a scrollable menu). This
          // lets an occluded submenu hide once its anchor scrolls out of view
          // (#3237). The collision/size middlewares deliberately keep the
          // viewport-based default to avoid clamping content rendered inside
          // transformed or overflow-clipping portal containers.
          boundary: hasExplicitBoundaries ? detectOverflowOptions.boundary : void 0
        })
      ]
    });
    const setPlacementState = context.setPlacementState;
    useLayoutEffect22(() => {
      setPlacementState(placement);
      return () => {
        setPlacementState(void 0);
      };
    }, [placement, setPlacementState]);
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const handlePlaced = useCallbackRef(onPlaced);
    useLayoutEffect22(() => {
      if (isPositioned) {
        handlePlaced?.();
      }
    }, [isPositioned, handlePlaced]);
    const arrowX = middlewareData.arrow?.x;
    const arrowY = middlewareData.arrow?.y;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const [contentZIndex, setContentZIndex] = React102.useState();
    useLayoutEffect22(() => {
      if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [content]);
    return /* @__PURE__ */ jsx29(
      "div",
      {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...floatingStyles,
          transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: contentZIndex,
          "--radix-popper-transform-origin": [
            middlewareData.transformOrigin?.x,
            middlewareData.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...middlewareData.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: props.dir,
        children: /* @__PURE__ */ jsx29(
          PopperContentProvider,
          {
            scope: __scopePopper,
            placedSide,
            placedAlign,
            onArrowChange: setArrow,
            arrowX,
            arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ jsx29(
              Primitive.div,
              {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                  ...contentProps.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: !isPositioned ? "none" : void 0
                }
              }
            )
          }
        )
      }
    );
  }
);
PopperContent.displayName = CONTENT_NAME4;
var ARROW_NAME = "PopperArrow";
var OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
var PopperArrow = React102.forwardRef(function PopperArrow2(props, forwardedRef) {
  const { __scopePopper, ...arrowProps } = props;
  const contentContext = useContentContext(ARROW_NAME, __scopePopper);
  const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ jsx29(
      "span",
      {
        ref: contentContext.onArrowChange,
        style: {
          position: "absolute",
          left: contentContext.arrowX,
          top: contentContext.arrowY,
          [baseSide]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[contentContext.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: `rotate(180deg)`,
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[contentContext.placedSide],
          visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ jsx29(
          Root6,
          {
            ...arrowProps,
            ref: forwardedRef,
            style: {
              ...arrowProps.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
PopperArrow.displayName = ARROW_NAME;
function isNotNull(value) {
  return value !== null;
}
var transformOrigin2 = (options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = middlewareData.arrow?.centerOffset !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const noArrowAlign = { start: "0%", center: "50%", end: "100%" }[placedAlign];
    const arrowXCenter = (middlewareData.arrow?.x ?? 0) + arrowWidth / 2;
    const arrowYCenter = (middlewareData.arrow?.y ?? 0) + arrowHeight / 2;
    let x = "";
    let y = "";
    if (placedSide === "bottom") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x = `${-arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x = `${rects.floating.width + arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return { data: { x, y } };
  }
});
function getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
var Root24 = Popper;
var Anchor = PopperAnchor;
var Content4 = PopperContent;
var Arrow2 = PopperArrow;

// ../../node_modules/.pnpm/@radix-ui+react-portal@1.1.12_@types+react-dom@19.2.3_@types+react@19.2.14__@types+reac_b7177a060acbfa11f637f0ba1a6db3ee/node_modules/@radix-ui/react-portal/dist/index.mjs
import * as React103 from "react";
import * as ReactDOM7 from "react-dom";
import { jsx as jsx30 } from "react/jsx-runtime";
var PORTAL_NAME2 = "Portal";
var Portal3 = React103.forwardRef((props, forwardedRef) => {
  const { container: containerProp, ...portalProps } = props;
  const [mounted, setMounted] = React103.useState(false);
  useLayoutEffect22(() => setMounted(true), []);
  const container = containerProp || mounted && globalThis?.document?.body;
  return container ? ReactDOM7.createPortal(/* @__PURE__ */ jsx30(Primitive.div, { ...portalProps, ref: forwardedRef }), container) : null;
});
Portal3.displayName = PORTAL_NAME2;

// ../../node_modules/.pnpm/@radix-ui+react-presence@1.1.6_@types+react-dom@19.2.3_@types+react@19.2.14__@types+rea_385b3110950623b51c55043bffa79fe3/node_modules/@radix-ui/react-presence/dist/index.mjs
import * as React211 from "react";
import * as React104 from "react";
function useStateMachine(initialState, machine) {
  return React104.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState ?? state;
  }, initialState);
}
var Presence3 = (props) => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : React211.Children.only(children);
  const ref = useStableComposedRefs(presence.ref, getElementRef(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? React211.cloneElement(child, { ref }) : null;
};
Presence3.displayName = "Presence";
function usePresence(present) {
  const [node, setNode] = React211.useState();
  const stylesRef = React211.useRef(null);
  const prevPresentRef = React211.useRef(present);
  const prevAnimationNameRef = React211.useRef("none");
  const initialState = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  React211.useEffect(() => {
    const currentAnimationName = getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  useLayoutEffect22(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        send("MOUNT");
      } else if (currentAnimationName === "none" || styles?.display === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect22(() => {
    if (node) {
      let timeoutId;
      const ownerWindow = node.ownerDocument.defaultView ?? window;
      const handleAnimationEnd = (event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
        if (event.target === node && isCurrentAnimation) {
          send("ANIMATION_END");
          if (!prevPresentRef.current) {
            const currentFillMode = node.style.animationFillMode;
            node.style.animationFillMode = "forwards";
            timeoutId = ownerWindow.setTimeout(() => {
              if (node.style.animationFillMode === "forwards") {
                node.style.animationFillMode = currentFillMode;
              }
            });
          }
        }
      };
      const handleAnimationStart = (event) => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node.addEventListener("animationstart", handleAnimationStart);
      node.addEventListener("animationcancel", handleAnimationEnd);
      node.addEventListener("animationend", handleAnimationEnd);
      return () => {
        ownerWindow.clearTimeout(timeoutId);
        node.removeEventListener("animationstart", handleAnimationStart);
        node.removeEventListener("animationcancel", handleAnimationEnd);
        node.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: React211.useCallback((node2) => {
      stylesRef.current = node2 ? getComputedStyle(node2) : null;
      setNode(node2);
    }, [])
  };
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    return ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function useStableComposedRefs(...refs) {
  const refsRef = React211.useRef(refs);
  refsRef.current = refs;
  return React211.useCallback((node) => {
    const currentRefs = refsRef.current;
    let hasCleanup = false;
    const cleanups = currentRefs.map((ref) => {
      const cleanup = setRef(ref, node);
      if (!hasCleanup && typeof cleanup === "function") {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        for (let i = 0; i < cleanups.length; i++) {
          const cleanup = cleanups[i];
          if (typeof cleanup === "function") {
            cleanup();
          } else {
            setRef(currentRefs[i], null);
          }
        }
      };
    }
  }, []);
}
function getAnimationName(styles) {
  return styles?.animationName || "none";
}
function getElementRef(element2) {
  let getter = Object.getOwnPropertyDescriptor(element2.props, "ref")?.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element2.ref;
  }
  getter = Object.getOwnPropertyDescriptor(element2, "ref")?.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element2.props.ref;
  }
  return element2.props.ref || element2.ref;
}

// ../../node_modules/.pnpm/@radix-ui+react-roving-focus@1.1.13_@types+react-dom@19.2.3_@types+react@19.2.14__@type_20930acab9fa792fed522777cca2461a/node_modules/@radix-ui/react-roving-focus/dist/index.mjs
import * as React105 from "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var EVENT_OPTIONS2 = { bubbles: false, cancelable: true };
var GROUP_NAME = "RovingFocusGroup";
var [Collection2, useCollection2, createCollectionScope2] = createCollection2(GROUP_NAME);
var [createRovingFocusGroupContext, createRovingFocusGroupScope2] = createContextScope3(
  GROUP_NAME,
  [createCollectionScope2]
);
var [RovingFocusProvider, useRovingFocusContext] = createRovingFocusGroupContext(GROUP_NAME);
var RovingFocusGroup = React105.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ jsx31(Collection2.Provider, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ jsx31(Collection2.Slot, { scope: props.__scopeRovingFocusGroup, children: /* @__PURE__ */ jsx31(RovingFocusGroupImpl, { ...props, ref: forwardedRef }) }) });
  }
);
RovingFocusGroup.displayName = GROUP_NAME;
var RovingFocusGroupImpl = React105.forwardRef((props, forwardedRef) => {
  const {
    __scopeRovingFocusGroup,
    orientation,
    loop = false,
    dir,
    currentTabStopId: currentTabStopIdProp,
    defaultCurrentTabStopId,
    onCurrentTabStopIdChange,
    onEntryFocus,
    preventScrollOnEntryFocus = false,
    ...groupProps
  } = props;
  const ref = React105.useRef(null);
  const composedRefs = useComposedRefs2(forwardedRef, ref);
  const direction = useDirection2(dir);
  const [currentTabStopId, setCurrentTabStopId] = useControllableState2({
    prop: currentTabStopIdProp,
    defaultProp: defaultCurrentTabStopId ?? null,
    onChange: onCurrentTabStopIdChange,
    caller: GROUP_NAME
  });
  const [isTabbingBackOut, setIsTabbingBackOut] = React105.useState(false);
  const handleEntryFocus = useCallbackRef(onEntryFocus);
  const getItems = useCollection2(__scopeRovingFocusGroup);
  const isClickFocusRef = React105.useRef(false);
  const [focusableItemsCount, setFocusableItemsCount] = React105.useState(0);
  React105.useEffect(() => {
    const node = ref.current;
    if (node) {
      node.addEventListener(ENTRY_FOCUS, handleEntryFocus);
      return () => node.removeEventListener(ENTRY_FOCUS, handleEntryFocus);
    }
  }, [handleEntryFocus]);
  return /* @__PURE__ */ jsx31(
    RovingFocusProvider,
    {
      scope: __scopeRovingFocusGroup,
      orientation,
      dir: direction,
      loop,
      currentTabStopId,
      onItemFocus: React105.useCallback(
        (tabStopId) => setCurrentTabStopId(tabStopId),
        [setCurrentTabStopId]
      ),
      onItemShiftTab: React105.useCallback(() => setIsTabbingBackOut(true), []),
      onFocusableItemAdd: React105.useCallback(
        () => setFocusableItemsCount((prevCount) => prevCount + 1),
        []
      ),
      onFocusableItemRemove: React105.useCallback(
        () => setFocusableItemsCount((prevCount) => prevCount - 1),
        []
      ),
      children: /* @__PURE__ */ jsx31(
        Primitive.div,
        {
          tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
          "data-orientation": orientation,
          ...groupProps,
          ref: composedRefs,
          style: { outline: "none", ...props.style },
          onMouseDown: composeEventHandlers2(props.onMouseDown, () => {
            isClickFocusRef.current = true;
          }),
          onFocus: composeEventHandlers2(props.onFocus, (event) => {
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
              const entryFocusEvent = new CustomEvent(ENTRY_FOCUS, EVENT_OPTIONS2);
              event.currentTarget.dispatchEvent(entryFocusEvent);
              if (!entryFocusEvent.defaultPrevented) {
                const items = getItems().filter((item) => item.focusable);
                const activeItem = items.find((item) => item.active);
                const currentItem = items.find((item) => item.id === currentTabStopId);
                const candidateItems = [activeItem, currentItem, ...items].filter(
                  Boolean
                );
                const candidateNodes = candidateItems.map((item) => item.ref.current);
                focusFirst2(candidateNodes, preventScrollOnEntryFocus);
              }
            }
            isClickFocusRef.current = false;
          }),
          onBlur: composeEventHandlers2(props.onBlur, () => setIsTabbingBackOut(false))
        }
      )
    }
  );
});
var ITEM_NAME2 = "RovingFocusGroupItem";
var RovingFocusGroupItem = React105.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeRovingFocusGroup,
      focusable: focusable2 = true,
      active = false,
      tabStopId,
      children,
      ...itemProps
    } = props;
    const autoId = useId2();
    const id = tabStopId || autoId;
    const context = useRovingFocusContext(ITEM_NAME2, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = useCollection2(__scopeRovingFocusGroup);
    const { onFocusableItemAdd, onFocusableItemRemove, currentTabStopId } = context;
    React105.useEffect(() => {
      if (focusable2) {
        onFocusableItemAdd();
        return () => onFocusableItemRemove();
      }
    }, [focusable2, onFocusableItemAdd, onFocusableItemRemove]);
    return /* @__PURE__ */ jsx31(
      Collection2.ItemSlot,
      {
        scope: __scopeRovingFocusGroup,
        id,
        focusable: focusable2,
        active,
        children: /* @__PURE__ */ jsx31(
          Primitive.span,
          {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: composeEventHandlers2(props.onMouseDown, (event) => {
              if (!focusable2) event.preventDefault();
              else context.onItemFocus(id);
            }),
            onFocus: composeEventHandlers2(props.onFocus, () => context.onItemFocus(id)),
            onKeyDown: composeEventHandlers2(props.onKeyDown, (event) => {
              if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
              }
              if (event.target !== event.currentTarget) return;
              const focusIntent = getFocusIntent(event, context.orientation, context.dir);
              if (focusIntent !== void 0) {
                if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                event.preventDefault();
                const items = getItems().filter((item) => item.focusable);
                let candidateNodes = items.map((item) => item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                  if (focusIntent === "prev") candidateNodes.reverse();
                  const currentIndex = candidateNodes.indexOf(event.currentTarget);
                  candidateNodes = context.loop ? wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                setTimeout(() => focusFirst2(candidateNodes));
              }
            }),
            children: typeof children === "function" ? children({ isCurrentTabStop, hasTabStop: currentTabStopId != null }) : children
          }
        )
      }
    );
  }
);
RovingFocusGroupItem.displayName = ITEM_NAME2;
var MAP_KEY_TO_FOCUS_INTENT = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function getDirectionAwareKey(key, dir) {
  if (dir !== "rtl") return key;
  return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function getFocusIntent(event, orientation, dir) {
  const key = getDirectionAwareKey(event.key, dir);
  if (orientation === "vertical" && ["ArrowLeft", "ArrowRight"].includes(key)) return void 0;
  if (orientation === "horizontal" && ["ArrowUp", "ArrowDown"].includes(key)) return void 0;
  return MAP_KEY_TO_FOCUS_INTENT[key];
}
function focusFirst2(candidates, preventScroll = false) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus({ preventScroll });
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function wrapArray(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
var Root7 = RovingFocusGroup;
var Item3 = RovingFocusGroupItem;

// ../../node_modules/.pnpm/@radix-ui+react-menu@2.1.18_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react@_2d2bf0087e8cc830b92ad0450e3a3635/node_modules/@radix-ui/react-menu/dist/index.mjs
import { jsx as jsx32 } from "react/jsx-runtime";
var SELECTION_KEYS = ["Enter", " "];
var FIRST_KEYS = ["ArrowDown", "PageUp", "Home"];
var LAST_KEYS = ["ArrowUp", "PageDown", "End"];
var FIRST_LAST_KEYS = [...FIRST_KEYS, ...LAST_KEYS];
var SUB_OPEN_KEYS = {
  ltr: [...SELECTION_KEYS, "ArrowRight"],
  rtl: [...SELECTION_KEYS, "ArrowLeft"]
};
var SUB_CLOSE_KEYS = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
};
var MENU_NAME = "Menu";
var [Collection3, useCollection3, createCollectionScope3] = createCollection2(MENU_NAME);
var [createMenuContext, createMenuScope] = createContextScope3(MENU_NAME, [
  createCollectionScope3,
  createPopperScope,
  createRovingFocusGroupScope2
]);
var usePopperScope = createPopperScope();
var useRovingFocusGroupScope = createRovingFocusGroupScope2();
var [MenuProvider, useMenuContext] = createMenuContext(MENU_NAME);
var [MenuRootProvider, useMenuRootContext] = createMenuContext(MENU_NAME);
var Menu = (props) => {
  const { __scopeMenu, open: open2 = false, children, dir, onOpenChange, modal = true } = props;
  const popperScope = usePopperScope(__scopeMenu);
  const [content, setContent] = React106.useState(null);
  const isUsingKeyboardRef = React106.useRef(false);
  const handleOpenChange = useCallbackRef(onOpenChange);
  const direction = useDirection2(dir);
  React106.useEffect(() => {
    const handleKeyDown = () => {
      isUsingKeyboardRef.current = true;
      document.addEventListener("pointerdown", handlePointer, { capture: true, once: true });
      document.addEventListener("pointermove", handlePointer, { capture: true, once: true });
    };
    const handlePointer = () => isUsingKeyboardRef.current = false;
    document.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => {
      document.removeEventListener("keydown", handleKeyDown, { capture: true });
      document.removeEventListener("pointerdown", handlePointer, { capture: true });
      document.removeEventListener("pointermove", handlePointer, { capture: true });
    };
  }, []);
  React106.useEffect(() => {
    if (!open2) {
      return;
    }
    const handleBlur = () => handleOpenChange(false);
    window.addEventListener("blur", handleBlur);
    return () => window.removeEventListener("blur", handleBlur);
  }, [open2, handleOpenChange]);
  return /* @__PURE__ */ jsx32(Root24, { ...popperScope, children: /* @__PURE__ */ jsx32(
    MenuProvider,
    {
      scope: __scopeMenu,
      open: open2,
      onOpenChange: handleOpenChange,
      content,
      onContentChange: setContent,
      children: /* @__PURE__ */ jsx32(
        MenuRootProvider,
        {
          scope: __scopeMenu,
          onClose: React106.useCallback(() => handleOpenChange(false), [handleOpenChange]),
          isUsingKeyboardRef,
          dir: direction,
          modal,
          children
        }
      )
    }
  ) });
};
Menu.displayName = MENU_NAME;
var ANCHOR_NAME2 = "MenuAnchor";
var MenuAnchor = React106.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...anchorProps } = props;
    const popperScope = usePopperScope(__scopeMenu);
    return /* @__PURE__ */ jsx32(Anchor, { ...popperScope, ...anchorProps, ref: forwardedRef });
  }
);
MenuAnchor.displayName = ANCHOR_NAME2;
var PORTAL_NAME3 = "MenuPortal";
var [PortalProvider, usePortalContext2] = createMenuContext(PORTAL_NAME3, {
  forceMount: void 0
});
var MenuPortal = (props) => {
  const { __scopeMenu, forceMount, children, container } = props;
  const context = useMenuContext(PORTAL_NAME3, __scopeMenu);
  return /* @__PURE__ */ jsx32(PortalProvider, { scope: __scopeMenu, forceMount, children: /* @__PURE__ */ jsx32(Presence3, { present: forceMount || context.open, children: /* @__PURE__ */ jsx32(Portal3, { asChild: true, container, children }) }) });
};
MenuPortal.displayName = PORTAL_NAME3;
var CONTENT_NAME5 = "MenuContent";
var [MenuContentProvider, useMenuContentContext] = createMenuContext(CONTENT_NAME5);
var MenuContent = React106.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext2(CONTENT_NAME5, props.__scopeMenu);
    const { forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = useMenuContext(CONTENT_NAME5, props.__scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME5, props.__scopeMenu);
    return /* @__PURE__ */ jsx32(Collection3.Provider, { scope: props.__scopeMenu, children: /* @__PURE__ */ jsx32(Presence3, { present: forceMount || context.open, children: /* @__PURE__ */ jsx32(Collection3.Slot, { scope: props.__scopeMenu, children: rootContext.modal ? /* @__PURE__ */ jsx32(MenuRootContentModal, { ...contentProps, ref: forwardedRef }) : /* @__PURE__ */ jsx32(MenuRootContentNonModal, { ...contentProps, ref: forwardedRef }) }) }) });
  }
);
var MenuRootContentModal = React106.forwardRef(
  (props, forwardedRef) => {
    const context = useMenuContext(CONTENT_NAME5, props.__scopeMenu);
    const ref = React106.useRef(null);
    const composedRefs = useComposedRefs2(forwardedRef, ref);
    React106.useEffect(() => {
      const content = ref.current;
      if (content) return hideOthers(content);
    }, []);
    return /* @__PURE__ */ jsx32(
      MenuContentImpl,
      {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: composeEventHandlers2(
          props.onFocusOutside,
          (event) => event.preventDefault(),
          { checkForDefaultPrevented: false }
        ),
        onDismiss: () => context.onOpenChange(false)
      }
    );
  }
);
var MenuRootContentNonModal = React106.forwardRef((props, forwardedRef) => {
  const context = useMenuContext(CONTENT_NAME5, props.__scopeMenu);
  return /* @__PURE__ */ jsx32(
    MenuContentImpl,
    {
      ...props,
      ref: forwardedRef,
      trapFocus: false,
      disableOutsidePointerEvents: false,
      disableOutsideScroll: false,
      onDismiss: () => context.onOpenChange(false)
    }
  );
});
var Slot2 = createSlot("MenuContent.ScrollLock");
var MenuContentImpl = React106.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeMenu,
      loop = false,
      trapFocus,
      onOpenAutoFocus,
      onCloseAutoFocus,
      disableOutsidePointerEvents,
      onEntryFocus,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss,
      disableOutsideScroll,
      ...contentProps
    } = props;
    const context = useMenuContext(CONTENT_NAME5, __scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME5, __scopeMenu);
    const popperScope = usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeMenu);
    const getItems = useCollection3(__scopeMenu);
    const [currentItemId, setCurrentItemId] = React106.useState(null);
    const contentRef = React106.useRef(null);
    const composedRefs = useComposedRefs2(forwardedRef, contentRef, context.onContentChange);
    const timerRef = React106.useRef(0);
    const searchRef = React106.useRef("");
    const pointerGraceTimerRef = React106.useRef(0);
    const pointerGraceIntentRef = React106.useRef(null);
    const pointerDirRef = React106.useRef("right");
    const lastPointerXRef = React106.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? Combination_default : React106.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? { as: Slot2, allowPinchZoom: true } : void 0;
    const handleTypeaheadSearch = (key) => {
      const search = searchRef.current + key;
      const items = getItems().filter((item) => !item.disabled);
      const currentItem = document.activeElement;
      const currentMatch = items.find((item) => item.ref.current === currentItem)?.textValue;
      const values = items.map((item) => item.textValue);
      const nextMatch = getNextMatch(values, search, currentMatch);
      const newItem = items.find((item) => item.textValue === nextMatch)?.ref.current;
      (function updateSearch(value) {
        searchRef.current = value;
        window.clearTimeout(timerRef.current);
        if (value !== "") timerRef.current = window.setTimeout(() => updateSearch(""), 1e3);
      })(search);
      if (newItem) {
        setTimeout(() => newItem.focus());
      }
    };
    React106.useEffect(() => {
      return () => window.clearTimeout(timerRef.current);
    }, []);
    useFocusGuards();
    const isPointerMovingToSubmenu = React106.useCallback((event) => {
      const isMovingTowards = pointerDirRef.current === pointerGraceIntentRef.current?.side;
      return isMovingTowards && isPointerInGraceArea(event, pointerGraceIntentRef.current?.area);
    }, []);
    return /* @__PURE__ */ jsx32(
      MenuContentProvider,
      {
        scope: __scopeMenu,
        searchRef,
        onItemEnter: React106.useCallback(
          (event) => {
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
          },
          [isPointerMovingToSubmenu]
        ),
        onItemLeave: React106.useCallback(
          (event) => {
            if (isPointerMovingToSubmenu(event)) return;
            contentRef.current?.focus();
            setCurrentItemId(null);
          },
          [isPointerMovingToSubmenu]
        ),
        onTriggerLeave: React106.useCallback(
          (event) => {
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
          },
          [isPointerMovingToSubmenu]
        ),
        pointerGraceTimerRef,
        onPointerGraceIntentChange: React106.useCallback((intent) => {
          pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ jsx32(ScrollLockWrapper, { ...scrollLockWrapperProps, children: /* @__PURE__ */ jsx32(
          FocusScope,
          {
            asChild: true,
            trapped: trapFocus,
            onMountAutoFocus: composeEventHandlers2(onOpenAutoFocus, (event) => {
              event.preventDefault();
              contentRef.current?.focus({ preventScroll: true });
            }),
            onUnmountAutoFocus: onCloseAutoFocus,
            children: /* @__PURE__ */ jsx32(
              DismissableLayer,
              {
                asChild: true,
                disableOutsidePointerEvents,
                onEscapeKeyDown,
                onPointerDownOutside,
                onFocusOutside,
                onInteractOutside,
                onDismiss,
                children: /* @__PURE__ */ jsx32(
                  Root7,
                  {
                    asChild: true,
                    ...rovingFocusGroupScope,
                    dir: rootContext.dir,
                    orientation: "vertical",
                    loop,
                    currentTabStopId: currentItemId,
                    onCurrentTabStopIdChange: setCurrentItemId,
                    onEntryFocus: composeEventHandlers2(onEntryFocus, (event) => {
                      if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                    }),
                    preventScrollOnEntryFocus: true,
                    children: /* @__PURE__ */ jsx32(
                      Content4,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": getOpenState(context.open),
                        "data-radix-menu-content": "",
                        dir: rootContext.dir,
                        ...popperScope,
                        ...contentProps,
                        ref: composedRefs,
                        style: { outline: "none", ...contentProps.style },
                        onKeyDown: composeEventHandlers2(contentProps.onKeyDown, (event) => {
                          const target = event.target;
                          const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                          const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                          const isCharacterKey = event.key.length === 1;
                          if (isKeyDownInside) {
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                          }
                          const content = contentRef.current;
                          if (event.target !== content) return;
                          if (!FIRST_LAST_KEYS.includes(event.key)) return;
                          event.preventDefault();
                          const items = getItems().filter((item) => !item.disabled);
                          const candidateNodes = items.map((item) => item.ref.current);
                          if (LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                          focusFirst3(candidateNodes);
                        }),
                        onBlur: composeEventHandlers2(props.onBlur, (event) => {
                          if (!event.currentTarget.contains(event.target)) {
                            window.clearTimeout(timerRef.current);
                            searchRef.current = "";
                          }
                        }),
                        onPointerMove: composeEventHandlers2(
                          props.onPointerMove,
                          whenMouse((event) => {
                            const target = event.target;
                            const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                            if (event.currentTarget.contains(target) && pointerXHasChanged) {
                              const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                              pointerDirRef.current = newDir;
                              lastPointerXRef.current = event.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
MenuContent.displayName = CONTENT_NAME5;
var GROUP_NAME2 = "MenuGroup";
var MenuGroup = React106.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ jsx32(Primitive.div, { role: "group", ...groupProps, ref: forwardedRef });
  }
);
MenuGroup.displayName = GROUP_NAME2;
var LABEL_NAME = "MenuLabel";
var MenuLabel = React106.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ jsx32(Primitive.div, { ...labelProps, ref: forwardedRef });
  }
);
MenuLabel.displayName = LABEL_NAME;
var ITEM_NAME3 = "MenuItem";
var ITEM_SELECT = "menu.itemSelect";
var MenuItem = React106.forwardRef(
  (props, forwardedRef) => {
    const { disabled: disabled2 = false, onSelect, ...itemProps } = props;
    const ref = React106.useRef(null);
    const rootContext = useMenuRootContext(ITEM_NAME3, props.__scopeMenu);
    const contentContext = useMenuContentContext(ITEM_NAME3, props.__scopeMenu);
    const composedRefs = useComposedRefs2(forwardedRef, ref);
    const isPointerDownRef = React106.useRef(false);
    const handleSelect = () => {
      const menuItem = ref.current;
      if (!disabled2 && menuItem) {
        const itemSelectEvent = new CustomEvent(ITEM_SELECT, { bubbles: true, cancelable: true });
        menuItem.addEventListener(ITEM_SELECT, (event) => onSelect?.(event), { once: true });
        dispatchDiscreteCustomEvent(menuItem, itemSelectEvent);
        if (itemSelectEvent.defaultPrevented) {
          isPointerDownRef.current = false;
        } else {
          rootContext.onClose();
        }
      }
    };
    return /* @__PURE__ */ jsx32(
      MenuItemImpl,
      {
        ...itemProps,
        ref: composedRefs,
        disabled: disabled2,
        onClick: composeEventHandlers2(props.onClick, handleSelect),
        onPointerDown: (event) => {
          props.onPointerDown?.(event);
          isPointerDownRef.current = true;
        },
        onPointerUp: composeEventHandlers2(props.onPointerUp, (event) => {
          if (!isPointerDownRef.current) event.currentTarget?.click();
        }),
        onKeyDown: composeEventHandlers2(props.onKeyDown, (event) => {
          const isTypingAhead = contentContext.searchRef.current !== "";
          if (disabled2 || isTypingAhead && event.key === " ") return;
          if (SELECTION_KEYS.includes(event.key)) {
            event.currentTarget.click();
            event.preventDefault();
          }
        })
      }
    );
  }
);
MenuItem.displayName = ITEM_NAME3;
var MenuItemImpl = React106.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, disabled: disabled2 = false, textValue, ...itemProps } = props;
    const contentContext = useMenuContentContext(ITEM_NAME3, __scopeMenu);
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeMenu);
    const ref = React106.useRef(null);
    const composedRefs = useComposedRefs2(forwardedRef, ref);
    const [isFocused, setIsFocused] = React106.useState(false);
    const [textContent, setTextContent] = React106.useState("");
    React106.useEffect(() => {
      const menuItem = ref.current;
      if (menuItem) {
        setTextContent((menuItem.textContent ?? "").trim());
      }
    }, [itemProps.children]);
    return /* @__PURE__ */ jsx32(
      Collection3.ItemSlot,
      {
        scope: __scopeMenu,
        disabled: disabled2,
        textValue: textValue ?? textContent,
        children: /* @__PURE__ */ jsx32(Item3, { asChild: true, ...rovingFocusGroupScope, focusable: !disabled2, children: /* @__PURE__ */ jsx32(
          Primitive.div,
          {
            role: "menuitem",
            "data-highlighted": isFocused ? "" : void 0,
            "aria-disabled": disabled2 || void 0,
            "data-disabled": disabled2 ? "" : void 0,
            ...itemProps,
            ref: composedRefs,
            onPointerMove: composeEventHandlers2(
              props.onPointerMove,
              whenMouse((event) => {
                if (disabled2) {
                  contentContext.onItemLeave(event);
                } else {
                  contentContext.onItemEnter(event);
                  if (!event.defaultPrevented) {
                    const item = event.currentTarget;
                    item.focus({ preventScroll: true });
                  }
                }
              })
            ),
            onPointerLeave: composeEventHandlers2(
              props.onPointerLeave,
              whenMouse((event) => contentContext.onItemLeave(event))
            ),
            onFocus: composeEventHandlers2(props.onFocus, () => setIsFocused(true)),
            onBlur: composeEventHandlers2(props.onBlur, () => setIsFocused(false))
          }
        ) })
      }
    );
  }
);
var CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var MenuCheckboxItem = React106.forwardRef(
  (props, forwardedRef) => {
    const { checked = false, onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ jsx32(ItemIndicatorProvider, { scope: props.__scopeMenu, checked, children: /* @__PURE__ */ jsx32(
      MenuItem,
      {
        role: "menuitemcheckbox",
        "aria-checked": isIndeterminate2(checked) ? "mixed" : checked,
        ...checkboxItemProps,
        ref: forwardedRef,
        "data-state": getCheckedState(checked),
        onSelect: composeEventHandlers2(
          checkboxItemProps.onSelect,
          () => onCheckedChange?.(isIndeterminate2(checked) ? true : !checked),
          { checkForDefaultPrevented: false }
        )
      }
    ) });
  }
);
MenuCheckboxItem.displayName = CHECKBOX_ITEM_NAME;
var RADIO_GROUP_NAME = "MenuRadioGroup";
var [RadioGroupProvider, useRadioGroupContext] = createMenuContext(
  RADIO_GROUP_NAME,
  { value: void 0, onValueChange: () => {
  } }
);
var MenuRadioGroup = React106.forwardRef(
  (props, forwardedRef) => {
    const { value, onValueChange, ...groupProps } = props;
    const handleValueChange = useCallbackRef(onValueChange);
    return /* @__PURE__ */ jsx32(RadioGroupProvider, { scope: props.__scopeMenu, value, onValueChange: handleValueChange, children: /* @__PURE__ */ jsx32(MenuGroup, { ...groupProps, ref: forwardedRef }) });
  }
);
MenuRadioGroup.displayName = RADIO_GROUP_NAME;
var RADIO_ITEM_NAME = "MenuRadioItem";
var MenuRadioItem = React106.forwardRef(
  (props, forwardedRef) => {
    const { value, ...radioItemProps } = props;
    const context = useRadioGroupContext(RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ jsx32(ItemIndicatorProvider, { scope: props.__scopeMenu, checked, children: /* @__PURE__ */ jsx32(
      MenuItem,
      {
        role: "menuitemradio",
        "aria-checked": checked,
        ...radioItemProps,
        ref: forwardedRef,
        "data-state": getCheckedState(checked),
        onSelect: composeEventHandlers2(
          radioItemProps.onSelect,
          () => context.onValueChange?.(value),
          { checkForDefaultPrevented: false }
        )
      }
    ) });
  }
);
MenuRadioItem.displayName = RADIO_ITEM_NAME;
var ITEM_INDICATOR_NAME = "MenuItemIndicator";
var [ItemIndicatorProvider, useItemIndicatorContext] = createMenuContext(
  ITEM_INDICATOR_NAME,
  { checked: false }
);
var MenuItemIndicator = React106.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = useItemIndicatorContext(ITEM_INDICATOR_NAME, __scopeMenu);
    return /* @__PURE__ */ jsx32(
      Presence3,
      {
        present: forceMount || isIndeterminate2(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ jsx32(
          Primitive.span,
          {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": getCheckedState(indicatorContext.checked)
          }
        )
      }
    );
  }
);
MenuItemIndicator.displayName = ITEM_INDICATOR_NAME;
var SEPARATOR_NAME = "MenuSeparator";
var MenuSeparator = React106.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ jsx32(
      Primitive.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
      }
    );
  }
);
MenuSeparator.displayName = SEPARATOR_NAME;
var ARROW_NAME2 = "MenuArrow";
var MenuArrow = React106.forwardRef(
  (props, forwardedRef) => {
    const { __scopeMenu, ...arrowProps } = props;
    const popperScope = usePopperScope(__scopeMenu);
    return /* @__PURE__ */ jsx32(Arrow2, { ...popperScope, ...arrowProps, ref: forwardedRef });
  }
);
MenuArrow.displayName = ARROW_NAME2;
var SUB_NAME = "MenuSub";
var [MenuSubProvider, useMenuSubContext] = createMenuContext(SUB_NAME);
var MenuSub = (props) => {
  const { __scopeMenu, children, open: open2 = false, onOpenChange } = props;
  const parentMenuContext = useMenuContext(SUB_NAME, __scopeMenu);
  const popperScope = usePopperScope(__scopeMenu);
  const [trigger, setTrigger] = React106.useState(null);
  const [content, setContent] = React106.useState(null);
  const handleOpenChange = useCallbackRef(onOpenChange);
  React106.useEffect(() => {
    if (parentMenuContext.open === false) handleOpenChange(false);
    return () => handleOpenChange(false);
  }, [parentMenuContext.open, handleOpenChange]);
  return /* @__PURE__ */ jsx32(Root24, { ...popperScope, children: /* @__PURE__ */ jsx32(
    MenuProvider,
    {
      scope: __scopeMenu,
      open: open2,
      onOpenChange: handleOpenChange,
      content,
      onContentChange: setContent,
      children: /* @__PURE__ */ jsx32(
        MenuSubProvider,
        {
          scope: __scopeMenu,
          contentId: useId2(),
          triggerId: useId2(),
          trigger,
          onTriggerChange: setTrigger,
          children
        }
      )
    }
  ) });
};
MenuSub.displayName = SUB_NAME;
var SUB_TRIGGER_NAME = "MenuSubTrigger";
var MenuSubTrigger = React106.forwardRef(
  (props, forwardedRef) => {
    const context = useMenuContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = useMenuRootContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = useMenuSubContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = useMenuContentContext(SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = React106.useRef(null);
    const { pointerGraceTimerRef, onPointerGraceIntentChange } = contentContext;
    const scope = { __scopeMenu: props.__scopeMenu };
    const clearOpenTimer = React106.useCallback(() => {
      if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
      openTimerRef.current = null;
    }, []);
    React106.useEffect(() => clearOpenTimer, [clearOpenTimer]);
    React106.useEffect(() => {
      const pointerGraceTimer = pointerGraceTimerRef.current;
      return () => {
        window.clearTimeout(pointerGraceTimer);
        onPointerGraceIntentChange(null);
      };
    }, [pointerGraceTimerRef, onPointerGraceIntentChange]);
    return /* @__PURE__ */ jsx32(MenuAnchor, { asChild: true, ...scope, children: /* @__PURE__ */ jsx32(
      MenuItemImpl,
      {
        id: subContext.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? subContext.contentId : void 0,
        "data-state": getOpenState(context.open),
        ...props,
        ref: composeRefs(forwardedRef, subContext.onTriggerChange),
        onClick: (event) => {
          props.onClick?.(event);
          if (props.disabled || event.defaultPrevented) return;
          event.currentTarget.focus();
          if (!context.open) context.onOpenChange(true);
        },
        onPointerMove: composeEventHandlers2(
          props.onPointerMove,
          whenMouse((event) => {
            contentContext.onItemEnter(event);
            if (event.defaultPrevented) return;
            if (!props.disabled && !context.open && !openTimerRef.current) {
              contentContext.onPointerGraceIntentChange(null);
              openTimerRef.current = window.setTimeout(() => {
                context.onOpenChange(true);
                clearOpenTimer();
              }, 100);
            }
          })
        ),
        onPointerLeave: composeEventHandlers2(
          props.onPointerLeave,
          whenMouse((event) => {
            clearOpenTimer();
            const contentRect = context.content?.getBoundingClientRect();
            if (contentRect) {
              const side = context.content?.dataset.side;
              const rightSide = side === "right";
              const bleed = rightSide ? -5 : 5;
              const contentNearEdge = contentRect[rightSide ? "left" : "right"];
              const contentFarEdge = contentRect[rightSide ? "right" : "left"];
              contentContext.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: event.clientX + bleed, y: event.clientY },
                  { x: contentNearEdge, y: contentRect.top },
                  { x: contentFarEdge, y: contentRect.top },
                  { x: contentFarEdge, y: contentRect.bottom },
                  { x: contentNearEdge, y: contentRect.bottom }
                ],
                side
              });
              window.clearTimeout(pointerGraceTimerRef.current);
              pointerGraceTimerRef.current = window.setTimeout(
                () => contentContext.onPointerGraceIntentChange(null),
                300
              );
            } else {
              contentContext.onTriggerLeave(event);
              if (event.defaultPrevented) return;
              contentContext.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: composeEventHandlers2(props.onKeyDown, (event) => {
          const isTypingAhead = contentContext.searchRef.current !== "";
          if (props.disabled || isTypingAhead && event.key === " ") return;
          if (SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
            context.onOpenChange(true);
            context.content?.focus();
            event.preventDefault();
          }
        })
      }
    ) });
  }
);
MenuSubTrigger.displayName = SUB_TRIGGER_NAME;
var SUB_CONTENT_NAME = "MenuSubContent";
var MenuSubContent = React106.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext2(CONTENT_NAME5, props.__scopeMenu);
    const { forceMount = portalContext.forceMount, align = "start", ...subContentProps } = props;
    const context = useMenuContext(CONTENT_NAME5, props.__scopeMenu);
    const rootContext = useMenuRootContext(CONTENT_NAME5, props.__scopeMenu);
    const subContext = useMenuSubContext(SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = React106.useRef(null);
    const composedRefs = useComposedRefs2(forwardedRef, ref);
    return /* @__PURE__ */ jsx32(Collection3.Provider, { scope: props.__scopeMenu, children: /* @__PURE__ */ jsx32(Presence3, { present: forceMount || context.open, children: /* @__PURE__ */ jsx32(Collection3.Slot, { scope: props.__scopeMenu, children: /* @__PURE__ */ jsx32(
      MenuContentImpl,
      {
        id: subContext.contentId,
        "aria-labelledby": subContext.triggerId,
        ...subContentProps,
        ref: composedRefs,
        align,
        side: rootContext.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        trapFocus: false,
        onOpenAutoFocus: (event) => {
          if (rootContext.isUsingKeyboardRef.current) ref.current?.focus();
          event.preventDefault();
        },
        onCloseAutoFocus: (event) => event.preventDefault(),
        onFocusOutside: composeEventHandlers2(props.onFocusOutside, (event) => {
          if (event.target !== subContext.trigger) context.onOpenChange(false);
        }),
        onEscapeKeyDown: composeEventHandlers2(props.onEscapeKeyDown, (event) => {
          rootContext.onClose();
          event.preventDefault();
        }),
        onKeyDown: composeEventHandlers2(props.onKeyDown, (event) => {
          const isKeyDownInside = event.currentTarget.contains(event.target);
          const isCloseKey = SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
          if (isKeyDownInside && isCloseKey) {
            context.onOpenChange(false);
            subContext.trigger?.focus();
            event.preventDefault();
          }
        })
      }
    ) }) }) });
  }
);
MenuSubContent.displayName = SUB_CONTENT_NAME;
function getOpenState(open2) {
  return open2 ? "open" : "closed";
}
function isIndeterminate2(checked) {
  return checked === "indeterminate";
}
function getCheckedState(checked) {
  return isIndeterminate2(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function focusFirst3(candidates) {
  const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
  for (const candidate of candidates) {
    if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
    candidate.focus();
    if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
  }
}
function wrapArray2(array, startIndex) {
  return array.map((_, index2) => array[(startIndex + index2) % array.length]);
}
function getNextMatch(values, search, currentMatch) {
  const isRepeated = search.length > 1 && Array.from(search).every((char) => char === search[0]);
  const normalizedSearch = isRepeated ? search[0] : search;
  const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
  let wrappedValues = wrapArray2(values, Math.max(currentMatchIndex, 0));
  const excludeCurrentMatch = normalizedSearch.length === 1;
  if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v) => v !== currentMatch);
  const nextMatch = wrappedValues.find(
    (value) => value.toLowerCase().startsWith(normalizedSearch.toLowerCase())
  );
  return nextMatch !== currentMatch ? nextMatch : void 0;
}
function isPointInPolygon(point2, polygon) {
  const { x, y } = point2;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const ii = polygon[i];
    const jj = polygon[j];
    const xi = ii.x;
    const yi = ii.y;
    const xj = jj.x;
    const yj = jj.y;
    const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}
function isPointerInGraceArea(event, area) {
  if (!area) return false;
  const cursorPos = { x: event.clientX, y: event.clientY };
  return isPointInPolygon(cursorPos, area);
}
function whenMouse(handler) {
  return (event) => event.pointerType === "mouse" ? handler(event) : void 0;
}
var Root32 = Menu;
var Anchor22 = MenuAnchor;
var Portal4 = MenuPortal;
var Content24 = MenuContent;
var Group = MenuGroup;
var Label = MenuLabel;
var Item22 = MenuItem;
var CheckboxItem = MenuCheckboxItem;
var RadioGroup = MenuRadioGroup;
var RadioItem = MenuRadioItem;
var ItemIndicator = MenuItemIndicator;
var Separator = MenuSeparator;
var Arrow22 = MenuArrow;
var Sub = MenuSub;
var SubTrigger = MenuSubTrigger;
var SubContent = MenuSubContent;

// ../../node_modules/.pnpm/@radix-ui+react-dropdown-menu@2.1.18_@types+react-dom@19.2.3_@types+react@19.2.14__@typ_e132fcc7fd7b3b054096338a0581fd04/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs
import { jsx as jsx33 } from "react/jsx-runtime";
var DROPDOWN_MENU_NAME = "DropdownMenu";
var [createDropdownMenuContext, createDropdownMenuScope] = createContextScope3(
  DROPDOWN_MENU_NAME,
  [createMenuScope]
);
var useMenuScope = createMenuScope();
var [DropdownMenuProvider, useDropdownMenuContext] = createDropdownMenuContext(DROPDOWN_MENU_NAME);
var DropdownMenu = (props) => {
  const {
    __scopeDropdownMenu,
    children,
    dir,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = true
  } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  const triggerRef = React107.useRef(null);
  const [open2, setOpen] = useControllableState2({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: DROPDOWN_MENU_NAME
  });
  return /* @__PURE__ */ jsx33(
    DropdownMenuProvider,
    {
      scope: __scopeDropdownMenu,
      triggerId: useId2(),
      triggerRef,
      contentId: useId2(),
      open: open2,
      onOpenChange: setOpen,
      onOpenToggle: React107.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
      modal,
      children: /* @__PURE__ */ jsx33(Root32, { ...menuScope, open: open2, onOpenChange: setOpen, dir, modal, children })
    }
  );
};
DropdownMenu.displayName = DROPDOWN_MENU_NAME;
var TRIGGER_NAME5 = "DropdownMenuTrigger";
var DropdownMenuTrigger = React107.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, disabled: disabled2 = false, ...triggerProps } = props;
    const context = useDropdownMenuContext(TRIGGER_NAME5, __scopeDropdownMenu);
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx33(Anchor22, { asChild: true, ...menuScope, children: /* @__PURE__ */ jsx33(
      Primitive.button,
      {
        type: "button",
        id: context.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": context.open ? "open" : "closed",
        "data-disabled": disabled2 ? "" : void 0,
        disabled: disabled2,
        ...triggerProps,
        ref: composeRefs(forwardedRef, context.triggerRef),
        onPointerDown: composeEventHandlers2(props.onPointerDown, (event) => {
          if (!disabled2 && event.button === 0 && event.ctrlKey === false) {
            context.onOpenToggle();
            if (!context.open) event.preventDefault();
          }
        }),
        onKeyDown: composeEventHandlers2(props.onKeyDown, (event) => {
          if (disabled2) return;
          if (["Enter", " "].includes(event.key)) context.onOpenToggle();
          if (event.key === "ArrowDown") context.onOpenChange(true);
          if (["Enter", " ", "ArrowDown"].includes(event.key)) event.preventDefault();
        })
      }
    ) });
  }
);
DropdownMenuTrigger.displayName = TRIGGER_NAME5;
var PORTAL_NAME4 = "DropdownMenuPortal";
var DropdownMenuPortal = (props) => {
  const { __scopeDropdownMenu, ...portalProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx33(Portal4, { ...menuScope, ...portalProps });
};
DropdownMenuPortal.displayName = PORTAL_NAME4;
var CONTENT_NAME6 = "DropdownMenuContent";
var DropdownMenuContent = React107.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...contentProps } = props;
    const context = useDropdownMenuContext(CONTENT_NAME6, __scopeDropdownMenu);
    const menuScope = useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = React107.useRef(false);
    return /* @__PURE__ */ jsx33(
      Content24,
      {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: composeEventHandlers2(props.onCloseAutoFocus, (event) => {
          if (!hasInteractedOutsideRef.current) context.triggerRef.current?.focus();
          hasInteractedOutsideRef.current = false;
          event.preventDefault();
        }),
        onInteractOutside: composeEventHandlers2(props.onInteractOutside, (event) => {
          const originalEvent = event.detail.originalEvent;
          const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
          const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
          if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
          ...props.style,
          // re-namespace exposed content custom properties
          ...{
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      }
    );
  }
);
DropdownMenuContent.displayName = CONTENT_NAME6;
var GROUP_NAME3 = "DropdownMenuGroup";
var DropdownMenuGroup = React107.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx33(Group, { ...menuScope, ...groupProps, ref: forwardedRef });
  }
);
DropdownMenuGroup.displayName = GROUP_NAME3;
var LABEL_NAME2 = "DropdownMenuLabel";
var DropdownMenuLabel = React107.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx33(Label, { ...menuScope, ...labelProps, ref: forwardedRef });
  }
);
DropdownMenuLabel.displayName = LABEL_NAME2;
var ITEM_NAME4 = "DropdownMenuItem";
var DropdownMenuItem = React107.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx33(Item22, { ...menuScope, ...itemProps, ref: forwardedRef });
  }
);
DropdownMenuItem.displayName = ITEM_NAME4;
var CHECKBOX_ITEM_NAME2 = "DropdownMenuCheckboxItem";
var DropdownMenuCheckboxItem = React107.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...checkboxItemProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx33(CheckboxItem, { ...menuScope, ...checkboxItemProps, ref: forwardedRef });
});
DropdownMenuCheckboxItem.displayName = CHECKBOX_ITEM_NAME2;
var RADIO_GROUP_NAME2 = "DropdownMenuRadioGroup";
var DropdownMenuRadioGroup = React107.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...radioGroupProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx33(RadioGroup, { ...menuScope, ...radioGroupProps, ref: forwardedRef });
});
DropdownMenuRadioGroup.displayName = RADIO_GROUP_NAME2;
var RADIO_ITEM_NAME2 = "DropdownMenuRadioItem";
var DropdownMenuRadioItem = React107.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...radioItemProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx33(RadioItem, { ...menuScope, ...radioItemProps, ref: forwardedRef });
});
DropdownMenuRadioItem.displayName = RADIO_ITEM_NAME2;
var INDICATOR_NAME2 = "DropdownMenuItemIndicator";
var DropdownMenuItemIndicator = React107.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...itemIndicatorProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx33(ItemIndicator, { ...menuScope, ...itemIndicatorProps, ref: forwardedRef });
});
DropdownMenuItemIndicator.displayName = INDICATOR_NAME2;
var SEPARATOR_NAME2 = "DropdownMenuSeparator";
var DropdownMenuSeparator = React107.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...separatorProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx33(Separator, { ...menuScope, ...separatorProps, ref: forwardedRef });
});
DropdownMenuSeparator.displayName = SEPARATOR_NAME2;
var ARROW_NAME3 = "DropdownMenuArrow";
var DropdownMenuArrow = React107.forwardRef(
  (props, forwardedRef) => {
    const { __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ jsx33(Arrow22, { ...menuScope, ...arrowProps, ref: forwardedRef });
  }
);
DropdownMenuArrow.displayName = ARROW_NAME3;
var DropdownMenuSub = (props) => {
  const { __scopeDropdownMenu, children, open: openProp, onOpenChange, defaultOpen } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  const [open2, setOpen] = useControllableState2({
    prop: openProp,
    defaultProp: defaultOpen ?? false,
    onChange: onOpenChange,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ jsx33(Sub, { ...menuScope, open: open2, onOpenChange: setOpen, children });
};
var SUB_TRIGGER_NAME2 = "DropdownMenuSubTrigger";
var DropdownMenuSubTrigger = React107.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...subTriggerProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx33(SubTrigger, { ...menuScope, ...subTriggerProps, ref: forwardedRef });
});
DropdownMenuSubTrigger.displayName = SUB_TRIGGER_NAME2;
var SUB_CONTENT_NAME2 = "DropdownMenuSubContent";
var DropdownMenuSubContent = React107.forwardRef((props, forwardedRef) => {
  const { __scopeDropdownMenu, ...subContentProps } = props;
  const menuScope = useMenuScope(__scopeDropdownMenu);
  return /* @__PURE__ */ jsx33(
    SubContent,
    {
      ...menuScope,
      ...subContentProps,
      ref: forwardedRef,
      style: {
        ...props.style,
        // re-namespace exposed content custom properties
        ...{
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    }
  );
});
DropdownMenuSubContent.displayName = SUB_CONTENT_NAME2;
var Root25 = DropdownMenu;
var Trigger4 = DropdownMenuTrigger;
var Portal23 = DropdownMenuPortal;
var Content25 = DropdownMenuContent;
var Group2 = DropdownMenuGroup;
var Label2 = DropdownMenuLabel;
var Item23 = DropdownMenuItem;
var CheckboxItem2 = DropdownMenuCheckboxItem;
var RadioGroup2 = DropdownMenuRadioGroup;
var RadioItem2 = DropdownMenuRadioItem;
var ItemIndicator2 = DropdownMenuItemIndicator;
var Separator2 = DropdownMenuSeparator;
var Sub2 = DropdownMenuSub;
var SubTrigger2 = DropdownMenuSubTrigger;
var SubContent2 = DropdownMenuSubContent;

// src/components/primitive/DropdownMenu/DropdownMenu.tsx
import { jsx as jsx34, jsxs as jsxs16 } from "react/jsx-runtime";
var cx2 = (...parts) => parts.filter(Boolean).join(" ");
function usePointerModality({ onPointerMove, onKeyDown }) {
  const [pointer2, setPointer] = React108.useState(false);
  return {
    "data-pointer": pointer2 ? "" : void 0,
    "onPointerMove": (event) => {
      onPointerMove?.(event);
      if (event.pointerType !== "touch") setPointer(true);
    },
    "onKeyDown": (event) => {
      onKeyDown?.(event);
      setPointer(false);
    }
  };
}
function DropdownMenu2(props) {
  return /* @__PURE__ */ jsx34(Root25, { ...props });
}
DropdownMenu2.displayName = "DropdownMenu";
function DropdownMenuTrigger2({ ref, ...props }) {
  return /* @__PURE__ */ jsx34(Trigger4, { ref, ...props });
}
DropdownMenuTrigger2.displayName = "DropdownMenuTrigger";
function DropdownMenuGroup2(props) {
  return /* @__PURE__ */ jsx34(Group2, { ...props });
}
DropdownMenuGroup2.displayName = "DropdownMenuGroup";
function DropdownMenuContent2({
  ref,
  className,
  align = "start",
  sideOffset = 6,
  collisionPadding = 8,
  children,
  onPointerMove,
  onKeyDown,
  ...props
}) {
  const modality = usePointerModality({ onPointerMove, onKeyDown });
  return /* @__PURE__ */ jsx34(Portal23, { children: /* @__PURE__ */ jsx34(
    Content25,
    {
      ref,
      align,
      sideOffset,
      collisionPadding,
      className: cx2("buyscout-dropdown-menu__content", className),
      ...props,
      ...modality,
      children
    }
  ) });
}
DropdownMenuContent2.displayName = "DropdownMenuContent";
function DropdownMenuItem2({ ref, className, intent = "default", ...props }) {
  return /* @__PURE__ */ jsx34(Item23, { ref, className: cx2("buyscout-dropdown-menu__item", intent === "destructive" && "buyscout-dropdown-menu__item--destructive", className), ...props });
}
DropdownMenuItem2.displayName = "DropdownMenuItem";
function DropdownMenuItemCaption({ children }) {
  return /* @__PURE__ */ jsx34("span", { className: "buyscout-dropdown-menu__caption", children });
}
DropdownMenuItemCaption.displayName = "DropdownMenuItemCaption";
function DropdownMenuLabel2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx34(Label2, { ref, className: cx2("buyscout-dropdown-menu__label", className), ...props });
}
DropdownMenuLabel2.displayName = "DropdownMenuLabel";
function DropdownMenuSeparator2({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx34(Separator2, { ref, className: cx2("buyscout-dropdown-menu__separator", className), ...props });
}
DropdownMenuSeparator2.displayName = "DropdownMenuSeparator";
function DropdownMenuCheckboxItem2({ ref, className, children, ...props }) {
  return /* @__PURE__ */ jsxs16(CheckboxItem2, { ref, className: cx2("buyscout-dropdown-menu__item", "buyscout-dropdown-menu__item--indented", className), ...props, children: [
    /* @__PURE__ */ jsx34(ItemIndicator2, { className: "buyscout-dropdown-menu__indicator", children: props.checked === "indeterminate" ? /* @__PURE__ */ jsx34(MdRemove, { "aria-hidden": true }) : /* @__PURE__ */ jsx34(MdCheck2, { "aria-hidden": true }) }),
    children
  ] });
}
DropdownMenuCheckboxItem2.displayName = "DropdownMenuCheckboxItem";
function DropdownMenuRadioGroup2(props) {
  return /* @__PURE__ */ jsx34(RadioGroup2, { ...props });
}
DropdownMenuRadioGroup2.displayName = "DropdownMenuRadioGroup";
function DropdownMenuRadioItem2({ ref, className, children, ...props }) {
  return /* @__PURE__ */ jsxs16(RadioItem2, { ref, className: cx2("buyscout-dropdown-menu__item", "buyscout-dropdown-menu__item--indented", className), ...props, children: [
    /* @__PURE__ */ jsx34(ItemIndicator2, { className: "buyscout-dropdown-menu__indicator", children: /* @__PURE__ */ jsx34(MdCheck2, { "aria-hidden": true }) }),
    children
  ] });
}
DropdownMenuRadioItem2.displayName = "DropdownMenuRadioItem";
function DropdownMenuSub2(props) {
  return /* @__PURE__ */ jsx34(Sub2, { ...props });
}
DropdownMenuSub2.displayName = "DropdownMenuSub";
function DropdownMenuSubTrigger2({ ref, className, children, value, ...props }) {
  return /* @__PURE__ */ jsxs16(SubTrigger2, { ref, className: cx2("buyscout-dropdown-menu__item", "buyscout-dropdown-menu__sub-trigger", className), ...props, children: [
    children,
    /* @__PURE__ */ jsxs16("span", { className: "buyscout-dropdown-menu__trail", children: [
      value,
      /* @__PURE__ */ jsx34(MdChevronRight, { "aria-hidden": true })
    ] })
  ] });
}
DropdownMenuSubTrigger2.displayName = "DropdownMenuSubTrigger";
function DropdownMenuSubContent2({ ref, className, sideOffset = 4, collisionPadding = 8, onPointerMove, onKeyDown, ...props }) {
  const modality = usePointerModality({ onPointerMove, onKeyDown });
  return /* @__PURE__ */ jsx34(Portal23, { children: /* @__PURE__ */ jsx34(
    SubContent2,
    {
      ref,
      sideOffset,
      collisionPadding,
      className: cx2("buyscout-dropdown-menu__content", "buyscout-dropdown-menu__sub-content", className),
      ...props,
      ...modality
    }
  ) });
}
DropdownMenuSubContent2.displayName = "DropdownMenuSubContent";

// src/components/primitive/EmptyState/EmptyState.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var cls4 = (...parts) => parts.filter(Boolean).join(" ");
var emptyStateVariants = cva("buyscout-empty-state", {
  variants: {
    variant: {
      panel: "buyscout-empty-state--panel",
      plain: "buyscout-empty-state--plain"
    }
  },
  defaultVariants: {
    variant: "panel"
  }
});
function EmptyState({ ref, variant, className, ...props }) {
  return /* @__PURE__ */ jsx35("div", { ref, className: emptyStateVariants({ variant, className }), ...props });
}
EmptyState.displayName = "EmptyState";
function EmptyStateMedia({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx35("div", { "aria-hidden": true, ref, className: cls4("buyscout-empty-state__media", className), ...props });
}
EmptyStateMedia.displayName = "EmptyStateMedia";
function EmptyStateTitle({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx35("p", { ref, className: cls4("buyscout-empty-state__title", className), ...props });
}
EmptyStateTitle.displayName = "EmptyStateTitle";
function EmptyStateDescription({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx35("p", { ref, className: cls4("buyscout-empty-state__description", className), ...props });
}
EmptyStateDescription.displayName = "EmptyStateDescription";
function EmptyStateActions({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx35("div", { ref, className: cls4("buyscout-empty-state__actions", className), ...props });
}
EmptyStateActions.displayName = "EmptyStateActions";

// src/components/primitive/Field/Field.tsx
import { jsx as jsx36, jsxs as jsxs17 } from "react/jsx-runtime";
function cls5(...parts) {
  return parts.filter(Boolean).join(" ");
}
var fieldVariants = cva("buyscout-field", {
  variants: {
    layout: {
      inline: "",
      stacked: "buyscout-field--stacked"
    },
    labelWidth: {
      sm: "buyscout-field--label-width-sm",
      md: "buyscout-field--label-width-md"
    },
    align: {
      center: "buyscout-field--align-center",
      start: "buyscout-field--align-start"
    }
  },
  defaultVariants: {
    layout: "inline",
    labelWidth: "md",
    align: "center"
  }
});
function Field({
  ref,
  label,
  layout,
  labelWidth,
  align,
  className,
  labelClassName,
  htmlFor,
  labelId,
  children,
  ...props
}) {
  const LabelTag = htmlFor ? "label" : "span";
  return /* @__PURE__ */ jsxs17("div", { ref, className: fieldVariants({ layout, labelWidth, align, className }), ...props, children: [
    /* @__PURE__ */ jsx36(LabelTag, { id: labelId, htmlFor, className: cls5("buyscout-field__label", labelClassName), children: label }),
    /* @__PURE__ */ jsx36("div", { className: "buyscout-field__value", children })
  ] });
}
Field.displayName = "Field";

// src/components/primitive/GoogleButton/GoogleButton.tsx
import { jsx as jsx37, jsxs as jsxs18 } from "react/jsx-runtime";
function GoogleButton({ ref, className = "", children, ...rest }) {
  const { t } = useComponentsTranslation();
  const classes2 = ["buyscout-google-btn", className].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs18(
    Button,
    {
      ref,
      variant: "outlined",
      color: "neutral",
      className: classes2,
      ...rest,
      children: [
        /* @__PURE__ */ jsx37(GoogleGLogo, {}),
        children ?? t("googleButton.signIn")
      ]
    }
  );
}
GoogleButton.displayName = "GoogleButton";
function GoogleGLogo() {
  return /* @__PURE__ */ jsx37("span", { className: "buyscout-btn__icon-start", children: /* @__PURE__ */ jsxs18("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", "aria-hidden": "true", children: [
    /* @__PURE__ */ jsx37("path", { fill: "#FFC107", d: "M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" }),
    /* @__PURE__ */ jsx37("path", { fill: "#FF3D00", d: "M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" }),
    /* @__PURE__ */ jsx37("path", { fill: "#4CAF50", d: "M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" }),
    /* @__PURE__ */ jsx37("path", { fill: "#1976D2", d: "M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" })
  ] }) });
}

// src/components/primitive/IconTile/IconTile.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
var iconTileVariants = cva("buyscout-icon-tile", {
  variants: {
    size: {
      sm: "buyscout-icon-tile--size-sm",
      md: "buyscout-icon-tile--size-md"
    },
    tone: {
      neutral: "buyscout-icon-tile--tone-neutral",
      gold: "buyscout-icon-tile--tone-gold",
      info: "buyscout-icon-tile--tone-info",
      success: "buyscout-icon-tile--tone-success",
      warning: "buyscout-icon-tile--tone-warning"
    },
    shape: {
      rounded: "buyscout-icon-tile--shape-rounded",
      circle: "buyscout-icon-tile--shape-circle"
    }
  },
  defaultVariants: {
    size: "md",
    tone: "neutral",
    shape: "rounded"
  }
});
function IconTile({
  ref,
  ...props
}) {
  const { size: size5, tone, shape, asChild = false, className, children, ...rest } = props;
  const Comp = asChild ? Slot : "span";
  const classes2 = iconTileVariants({ size: size5, tone, shape, className });
  return /* @__PURE__ */ jsx38(Comp, { ref, className: classes2, ...rest, children });
}
IconTile.displayName = "IconTile";

// src/hooks/useLoadingActivity.ts
import { createContext as createContext21, use as use3, useEffect as useEffect27 } from "react";
var LoadingActivityContext = createContext21(null);
function useReportLoading(active = true) {
  const report = use3(LoadingActivityContext);
  useEffect27(() => active && report ? report() : void 0, [active, report]);
}

// src/components/primitive/Spinner/Spinner.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var spinnerVariants = cva("buyscout-spinner", {
  variants: {
    size: {
      sm: "buyscout-spinner--sm",
      md: "buyscout-spinner--md",
      lg: "buyscout-spinner--lg"
    },
    tone: {
      ink: "",
      current: "buyscout-spinner--tone-current"
    }
  },
  defaultVariants: {
    size: "md",
    tone: "ink"
  }
});
function Spinner({
  ref,
  ...props
}) {
  const {
    size: size5,
    tone,
    className,
    ariaLabel,
    "aria-label": ariaLabelProp,
    ...rest
  } = props;
  const { t } = useComponentsTranslation();
  return /* @__PURE__ */ jsx39(
    "div",
    {
      ref,
      className: spinnerVariants({ size: size5, tone, className }),
      role: "progressbar",
      "aria-label": ariaLabelProp ?? ariaLabel ?? t("spinner.loading"),
      ...rest
    }
  );
}
Spinner.displayName = "Spinner";

// src/components/primitive/LoadingState/LoadingState.tsx
import { jsx as jsx40, jsxs as jsxs19 } from "react/jsx-runtime";
function LoadingState({
  ref,
  className,
  ...rest
}) {
  const { t } = useComponentsTranslation();
  useReportLoading();
  return /* @__PURE__ */ jsxs19("div", { ref, className: className ? `buyscout-loading-state ${className}` : "buyscout-loading-state", role: "status", ...rest, children: [
    /* @__PURE__ */ jsx40(Spinner, { size: "lg", "aria-hidden": true }),
    /* @__PURE__ */ jsx40("p", { className: "buyscout-loading-state__label", children: t("loadingState.loading") })
  ] });
}
LoadingState.displayName = "LoadingState";

// src/components/primitive/MultiSelect/MultiSelect.tsx
import * as React109 from "react";
import { MdArrowDropDown as MdArrowDropDown3, MdCheck as MdCheck3, MdUnfoldMore } from "react-icons/md";
import { jsx as jsx41, jsxs as jsxs20 } from "react/jsx-runtime";
var cx3 = (...parts) => parts.filter(Boolean).join(" ");
var triggerVariants = cva("buyscout-select__trigger buyscout-multi-select__trigger", {
  variants: {
    variant: { outlined: "", subtle: "buyscout-select__trigger--subtle" },
    size: { md: "", sm: "buyscout-select__trigger--sm" }
  },
  defaultVariants: { variant: "outlined", size: "md" }
});
function MultiSelect({
  value,
  onValueChange,
  options,
  placeholder = "Select\u2026",
  disabled: disabled2 = false,
  id,
  className,
  size: size5,
  variant,
  ref,
  maxSelected,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  "aria-invalid": ariaInvalid
}) {
  const [activeValue, setActiveValue] = React109.useState(null);
  const toggle = (v) => {
    if (value.includes(v)) {
      onValueChange(value.filter((x) => x !== v));
    } else if (maxSelected === void 0 || value.length < maxSelected) {
      onValueChange([...value, v]);
    }
  };
  const isAtLimit = (v) => !value.includes(v) && maxSelected !== void 0 && value.length >= maxSelected;
  const enabledValues = options.map((o) => o.value).filter((v) => !isAtLimit(v));
  const tabStop = (activeValue !== null && enabledValues.includes(activeValue) ? activeValue : void 0) ?? enabledValues.find((v) => value.includes(v)) ?? enabledValues[0];
  const moveFocus = (event) => {
    const items = Array.from(event.currentTarget.querySelectorAll('[role="option"]:not(:disabled)'));
    if (items.length === 0) return;
    const current = items.indexOf(event.target);
    let next;
    switch (event.key) {
      case "ArrowDown":
        next = Math.min(current + 1, items.length - 1);
        break;
      case "ArrowUp":
        next = Math.max(current - 1, 0);
        break;
      case "Home":
        next = 0;
        break;
      case "End":
        next = items.length - 1;
        break;
      default:
        return;
    }
    event.preventDefault();
    items[next].focus();
  };
  const selectedLabels = options.filter((o) => value.includes(o.value)).map((o) => o.label);
  const hasSelection = selectedLabels.length > 0;
  return /* @__PURE__ */ jsxs20(Popover, { onOpenChange: (open2) => {
    if (!open2) setActiveValue(null);
  }, children: [
    /* @__PURE__ */ jsxs20(
      PopoverTrigger,
      {
        ref,
        id,
        disabled: disabled2,
        "aria-haspopup": "listbox",
        "aria-controls": void 0,
        "aria-label": ariaLabelledBy ? void 0 : ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-invalid": ariaInvalid || void 0,
        className: triggerVariants({ variant, size: size5, className }),
        children: [
          /* @__PURE__ */ jsx41("span", { className: cx3("buyscout-multi-select__value", !hasSelection && "buyscout-multi-select__value--placeholder"), children: hasSelection ? selectedLabels.join(", ") : placeholder }),
          /* @__PURE__ */ jsx41(MdArrowDropDown3, { "aria-hidden": true, className: "buyscout-select__caret buyscout-select__caret--down" }),
          /* @__PURE__ */ jsx41(MdUnfoldMore, { "aria-hidden": true, className: "buyscout-select__caret buyscout-select__caret--up-down" })
        ]
      }
    ),
    /* @__PURE__ */ jsx41(
      PopoverContent,
      {
        align: "start",
        sideOffset: 6,
        role: void 0,
        className: cx3("buyscout-select__content", "buyscout-multi-select__content"),
        children: /* @__PURE__ */ jsx41(
          "div",
          {
            role: "listbox",
            "aria-multiselectable": true,
            "aria-label": ariaLabelledBy ? void 0 : ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            className: "buyscout-multi-select__list",
            tabIndex: -1,
            onKeyDown: moveFocus,
            children: options.map((o) => {
              const checked = value.includes(o.value);
              return /* @__PURE__ */ jsxs20(
                "button",
                {
                  type: "button",
                  role: "option",
                  "aria-selected": checked,
                  disabled: isAtLimit(o.value),
                  tabIndex: o.value === tabStop ? 0 : -1,
                  "data-highlighted": o.value === activeValue ? "" : void 0,
                  onFocus: () => setActiveValue(o.value),
                  onPointerMove: (event) => {
                    if (event.pointerType === "mouse" && document.activeElement !== event.currentTarget) event.currentTarget.focus({ preventScroll: true });
                  },
                  onPointerLeave: (event) => {
                    if (event.pointerType !== "mouse" || document.activeElement !== event.currentTarget) return;
                    event.currentTarget.closest('[role="listbox"]')?.focus();
                    setActiveValue(null);
                  },
                  onClick: () => toggle(o.value),
                  className: cx3("buyscout-select__item", "buyscout-multi-select__item"),
                  children: [
                    /* @__PURE__ */ jsx41("span", { className: "buyscout-select__item-indicator", children: checked && /* @__PURE__ */ jsx41(MdCheck3, { "aria-hidden": true }) }),
                    o.label
                  ]
                },
                o.value
              );
            })
          }
        )
      }
    )
  ] });
}
MultiSelect.displayName = "MultiSelect";

// src/components/primitive/NumberField/NumberField.tsx
import * as React120 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/index.parts.mjs
var index_parts_exports2 = {};
__export(index_parts_exports2, {
  Decrement: () => NumberFieldDecrement,
  Group: () => NumberFieldGroup,
  Increment: () => NumberFieldIncrement,
  Input: () => NumberFieldInput,
  Root: () => NumberFieldRoot,
  ScrubArea: () => NumberFieldScrubArea,
  ScrubAreaCursor: () => NumberFieldScrubAreaCursor
});

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/root/NumberFieldRoot.mjs
import * as React111 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/formatNumber.mjs
var cache = /* @__PURE__ */ new Map();
function getFormatter(locale, options) {
  const optionsString = JSON.stringify({
    locale: stringifyLocale(locale),
    options
  });
  const cachedFormatter = cache.get(optionsString);
  if (cachedFormatter) {
    return cachedFormatter;
  }
  const formatter = new Intl.NumberFormat(locale, options);
  cache.set(optionsString, formatter);
  return formatter;
}
function formatNumber(value, locale, options) {
  if (value == null) {
    return "";
  }
  return getFormatter(locale, options).format(value);
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/root/NumberFieldRootContext.mjs
import * as React110 from "react";
var NumberFieldRootContext = /* @__PURE__ */ React110.createContext(void 0);
if (process.env.NODE_ENV !== "production") NumberFieldRootContext.displayName = "NumberFieldRootContext";
function useNumberFieldRootContext() {
  const context = React110.useContext(NumberFieldRootContext);
  if (context === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: NumberFieldRootContext is missing. NumberField parts must be placed within <NumberField.Root>." : formatErrorMessage_default(43));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/utils/stateAttributesMapping.mjs
var stateAttributesMapping4 = {
  inputValue: () => null,
  value: () => null,
  ...fieldValidityMapping
};

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/utils/parse.mjs
var HAN_NUMERALS = "\u96F6\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D";
var NON_ASCII_DIGIT_RE = /[٠-٩۰-۹０-９]/g;
var HAN_RE = /[零〇一二三四五六七八九]/g;
var PERCENTAGES = ["%", "\u066A", "\uFF05", "\uFE6A"];
var PERMILLE = ["\u2030", "\u0609"];
var FULLWIDTH_DECIMAL = "\uFF0E";
var FULLWIDTH_GROUP = "\uFF0C";
var PERCENT_RE = /[%٪％﹪]/;
var PERMILLE_RE = /[‰؉]/;
var PERCENT_GLOBAL_RE = /[%٪％﹪]/g;
var PERMILLE_GLOBAL_RE = /[‰؉]/g;
var ARABIC_PERSIAN_DETECT_RE = /[٠-٩۰-۹]/;
var HAN_DETECT_RE = /[零〇一二三四五六七八九]/;
var ANY_NUMERAL_DETECT_RE = /[0-9٠-٩۰-۹０-９零〇一二三四五六七八九]/;
function isNumeralChar(char) {
  return ANY_NUMERAL_DETECT_RE.test(char);
}
var BASE_NON_NUMERIC_SYMBOLS = [".", ",", FULLWIDTH_DECIMAL, FULLWIDTH_GROUP, "\u066B", "\u066C"];
var SPACE_SEPARATOR_RE = /\p{Zs}/u;
var FORMAT_CONTROL_DETECT_RE = /\p{Cf}/u;
var FORMAT_CONTROL_GLOBAL_RE = /\p{Cf}/gu;
var PLUS_SIGNS_WITH_ASCII = ["+", "\uFF0B", "\uFE62"];
var MINUS_SIGNS_WITH_ASCII = ["-", "\u2212", "\uFF0D", "\u2012", "\u2013", "\u2014", "\uFE63"];
var escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
function shiftDecimal(value, exponentDelta) {
  const [coefficient, exponent = "0"] = String(value).split("e");
  return Number(`${coefficient}e${Number(exponent) + exponentDelta}`);
}
var ANY_MINUS_RE = /[-−－‒–—﹣]/gu;
var ANY_PLUS_RE = /[+＋﹢]/gu;
var ANY_MINUS_DETECT_RE = /[-−－‒–—﹣]/;
var ANY_PLUS_DETECT_RE = /[+＋﹢]/;
var SAMPLE_FORMAT_NUMBER = 11111.1;
function getFormatParts(locale, options) {
  return getFormatter(locale, options).formatToParts(SAMPLE_FORMAT_NUMBER);
}
function getNumberLocaleDetails(locale, options) {
  const parts = getFormatParts(locale, options);
  const result = {};
  parts.forEach((part) => {
    result[part.type] = part.value;
  });
  let decimal = ".";
  getFormatter(locale).formatToParts(0.1).forEach((part) => {
    if (part.type === "decimal") {
      decimal = part.value;
    }
  });
  return {
    ...result,
    decimal
  };
}
function parseNumber(formattedNumber, locale, options) {
  let input = formattedNumber.replace(FORMAT_CONTROL_GLOBAL_RE, "").trim();
  input = input.replace(ANY_MINUS_RE, "-").replace(ANY_PLUS_RE, "+");
  let isNegative = false;
  const takeSign = (match, sign) => {
    if (sign === "-") {
      isNegative = true;
    }
    return "";
  };
  input = input.replace(/([+-])\s*$/, takeSign).replace(/^\s*([+-])/, takeSign);
  let computedLocale = locale;
  if (computedLocale === void 0) {
    if (ARABIC_PERSIAN_DETECT_RE.test(input)) {
      computedLocale = "ar";
    } else if (HAN_DETECT_RE.test(input)) {
      computedLocale = "zh";
    }
  }
  const {
    group,
    decimal,
    currency,
    exponentSeparator
  } = getNumberLocaleDetails(computedLocale, options);
  const unitParts = getFormatter(computedLocale, options).formatToParts(1).filter((p) => p.type === "unit").map((p) => escapeRegExp(p.value));
  const unitRegex = unitParts.length ? new RegExp(unitParts.join("|"), "g") : null;
  let groupRegex = null;
  if (group) {
    const isSpaceGroup = /\p{Zs}/u.test(group);
    const isApostropheGroup = group === "'" || group === "\u2019";
    if (isSpaceGroup) {
      groupRegex = /\p{Zs}/gu;
    } else if (isApostropheGroup) {
      groupRegex = /['’]/g;
    } else {
      groupRegex = new RegExp(escapeRegExp(group), "g");
    }
  }
  const replacements = [
    [groupRegex, ""],
    [new RegExp(escapeRegExp(decimal), "g"), "."],
    // Fullwidth/Arabic punctuation
    [/[．٫]/g, "."],
    // FULLWIDTH_DECIMAL, ARABIC DECIMAL SEPARATOR (U+066B)
    [/[，٬]/g, ""],
    // FULLWIDTH_GROUP, ARABIC THOUSANDS SEPARATOR (U+066C)
    // Currency & unit labels
    [currency ? new RegExp(escapeRegExp(currency), "g") : null, ""],
    [unitRegex, ""],
    [PERCENT_GLOBAL_RE, ""],
    [PERMILLE_GLOBAL_RE, ""],
    [exponentSeparator ? new RegExp(escapeRegExp(exponentSeparator), "g") : null, "e"],
    // Numeral systems to ASCII digits
    [NON_ASCII_DIGIT_RE, (ch) => String(ch.charCodeAt(0) % 16)],
    [HAN_RE, (ch) => String(Math.max(HAN_NUMERALS.indexOf(ch) - 1, 0))]
  ];
  let unformatted = replacements.reduce((acc, [regex, replacement]) => {
    return regex ? acc.replace(regex, replacement) : acc;
  }, input);
  const lastDot = unformatted.lastIndexOf(".");
  if (lastDot !== -1) {
    unformatted = `${unformatted.slice(0, lastDot).replace(/\./g, "")}.${unformatted.slice(lastDot + 1).replace(/\./g, "")}`;
  }
  if (/^[-+]?Infinity$/i.test(input) || input.includes("\u221E")) {
    return null;
  }
  const parseTarget = (isNegative ? "-" : "") + unformatted;
  let num = parseFloat(parseTarget);
  const style = options?.style;
  const isUnitPercent = style === "unit" && options?.unit === "percent";
  const hasPercentSymbol = PERCENT_RE.test(formattedNumber) || style === "percent";
  const hasPermilleSymbol = PERMILLE_RE.test(formattedNumber);
  if (hasPermilleSymbol) {
    num = shiftDecimal(num, -3);
  } else if (!isUnitPercent && hasPercentSymbol) {
    num = shiftDecimal(num, -2);
  }
  if (!Number.isFinite(num)) {
    return null;
  }
  return num;
}

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/clamp.mjs
function clamp3(val, min2 = Number.MIN_SAFE_INTEGER, max2 = Number.MAX_SAFE_INTEGER) {
  return Math.max(min2, Math.min(val, max2));
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/utils/validate.mjs
var STEP_EPSILON_FACTOR = 1e-10;
var MAX_FLOATING_POINT_CLEANUP_DELTA = 1e-10;
function hasNumberFormatRoundingOptions(format) {
  return format?.maximumFractionDigits != null || format?.minimumFractionDigits != null || format?.maximumSignificantDigits != null || format?.minimumSignificantDigits != null || format?.roundingIncrement != null || format?.roundingMode != null || format?.roundingPriority != null;
}
function removeFloatingPointErrors(value, format) {
  if (!Number.isFinite(value)) {
    return value;
  }
  if (!hasNumberFormatRoundingOptions(format)) {
    const roundedValue2 = parseFloat(value.toPrecision(15));
    const cleanupDelta = Math.abs(roundedValue2 - value);
    const cleanupTolerance = Math.min(Number.EPSILON * Math.max(1, Math.abs(value)), MAX_FLOATING_POINT_CLEANUP_DELTA);
    return cleanupDelta <= cleanupTolerance ? roundedValue2 : value;
  }
  const formatter = getFormatter("en-US", {
    ...format,
    // These options alter only display decoration, not numeric rounding.
    signDisplay: "auto",
    currencySign: "standard",
    notation: format.notation === "compact" ? "standard" : format.notation,
    useGrouping: false
  });
  const roundedText = formatter.format(value);
  const roundedValue = parseNumber(roundedText, "en-US", format);
  if (roundedValue === null) {
    return value;
  }
  return formatter.format(roundedValue) === roundedText ? roundedValue : value;
}
function snapToStep(value, base, step, nearest) {
  const stepSize = Math.abs(step);
  const direction = Math.sign(step);
  const tolerance = stepSize * STEP_EPSILON_FACTOR * direction;
  const rawSteps = value - base + tolerance;
  if (nearest) {
    return base + Math.round(rawSteps / step) * step;
  }
  const snappedSteps = direction > 0 ? Math.floor(rawSteps / stepSize) : Math.ceil(rawSteps / stepSize);
  return base + snappedSteps * stepSize;
}
function toValidatedNumber(value, step, minWithDefault, maxWithDefault, minWithZeroDefault, format, snapOnStep, small, shouldClamp) {
  if (value === null) {
    return value;
  }
  let nextValue = value;
  if (step != null && snapOnStep && step !== 0) {
    const base = small || minWithDefault === Number.MIN_SAFE_INTEGER ? minWithZeroDefault : minWithDefault;
    nextValue = snapToStep(nextValue, base, step, small);
  }
  if (shouldClamp) {
    nextValue = clamp3(nextValue, minWithDefault, maxWithDefault);
  }
  if (step == null && !hasNumberFormatRoundingOptions(format)) {
    return nextValue;
  }
  const roundedValue = removeFloatingPointErrors(nextValue, format);
  return shouldClamp ? clamp3(roundedValue, minWithDefault, maxWithDefault) : roundedValue;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/root/NumberFieldRoot.mjs
import { jsx as _jsx25, jsxs as _jsxs7 } from "react/jsx-runtime";
var NumberFieldRoot = /* @__PURE__ */ React111.forwardRef(function NumberFieldRoot2(componentProps, forwardedRef) {
  const {
    id: idProp,
    min: min2,
    max: max2,
    smallStep = 0.1,
    step: stepProp = 1,
    largeStep = 10,
    required = false,
    disabled: disabledProp = false,
    readOnly = false,
    form,
    name: nameProp,
    defaultValue = null,
    value: valueProp,
    onValueChange: onValueChangeProp,
    onValueCommitted: onValueCommittedProp,
    allowWheelScrub = false,
    snapOnStep = false,
    allowOutOfRange = false,
    format,
    locale,
    render,
    className,
    inputRef: inputRefProp,
    style,
    ...elementProps
  } = componentProps;
  const {
    setDirty,
    validityData,
    disabled: fieldDisabled,
    setFilled,
    name: fieldName,
    state: fieldState,
    validation
  } = useFieldRootContext();
  const {
    clearErrors
  } = useFormContext();
  const disabled2 = fieldDisabled || disabledProp;
  const name2 = fieldName ?? nameProp;
  const step = stepProp === "any" ? 1 : stepProp;
  const [isScrubbing, setIsScrubbing] = React111.useState(false);
  const minWithDefault = min2 ?? Number.MIN_SAFE_INTEGER;
  const maxWithDefault = max2 ?? Number.MAX_SAFE_INTEGER;
  const minWithZeroDefault = min2 ?? 0;
  const formatStyle = format?.style;
  const inputRef = React111.useRef(null);
  const hiddenInputRef = useMergedRefs(inputRefProp, validation.inputRef);
  const id = useLabelableId({
    id: idProp
  });
  const [value, setValueUnwrapped] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: "NumberField",
    state: "value"
  });
  const valueRef = useValueAsRef(value);
  useIsoLayoutEffect(() => {
    setFilled(value !== null);
  }, [setFilled, value]);
  const forceRender = useForcedRerendering();
  const formatOptionsRef = useValueAsRef(format);
  const hasPendingCommitRef = React111.useRef(false);
  const onValueCommitted = useStableCallback((nextValue, eventDetails) => {
    hasPendingCommitRef.current = false;
    onValueCommittedProp?.(nextValue, eventDetails);
  });
  const allowInputSyncRef = React111.useRef(true);
  const lastChangedValueRef = React111.useRef(null);
  const [inputValue, setInputValue] = React111.useState(() => formatNumber(value, locale, format));
  const [inputMode, setInputMode] = React111.useState("numeric");
  const getAllowedNonNumericKeys = useStableCallback(() => {
    const parts = getFormatParts(locale, format);
    const keys2 = new Set(BASE_NON_NUMERIC_SYMBOLS);
    const addAll = (chars) => chars.forEach((char) => keys2.add(char));
    const decimal = parts.find((part) => part.type === "decimal")?.value ?? getNumberLocaleDetails(locale, format).decimal;
    keys2.add(decimal);
    parts.forEach((part) => {
      if (part.type === "integer" || part.type === "fraction" || part.type === "exponentInteger" || part.type === "compact") {
        return;
      }
      addAll(Array.from(part.value));
      if (SPACE_SEPARATOR_RE.test(part.value)) {
        keys2.add(" ");
      }
    });
    const allowPercentSymbols = formatStyle === "percent" || formatStyle === "unit" && format?.unit === "percent";
    const allowPermilleSymbols = formatStyle === "percent" || formatStyle === "unit" && format?.unit === "permille";
    if (allowPercentSymbols) {
      addAll(PERCENTAGES);
    }
    if (allowPermilleSymbols) {
      addAll(PERMILLE);
    }
    addAll(PLUS_SIGNS_WITH_ASCII);
    if (minWithDefault < 0 || allowOutOfRange) {
      addAll(MINUS_SIGNS_WITH_ASCII);
    }
    return keys2;
  });
  const getStepAmount = useStableCallback((event) => {
    if (event?.altKey) {
      return smallStep;
    }
    if (event?.shiftKey) {
      return largeStep;
    }
    return step;
  });
  const setValue = useStableCallback((unvalidatedValue, details) => {
    const eventWithOptionalKeyState = details.event;
    const dir = details.direction;
    const isInputReason = details.reason.startsWith("input-") || details.reason === reason_parts_exports.none;
    const shouldClampValue = !allowOutOfRange || !isInputReason;
    const validatedValue = toValidatedNumber(unvalidatedValue, dir ? getStepAmount(eventWithOptionalKeyState) * dir : void 0, minWithDefault, maxWithDefault, minWithZeroDefault, formatOptionsRef.current, snapOnStep, eventWithOptionalKeyState?.altKey ?? false, shouldClampValue);
    const shouldFireChange = validatedValue !== value || isInputReason && (unvalidatedValue !== value || allowInputSyncRef.current === false);
    if (shouldFireChange) {
      onValueChangeProp?.(validatedValue, details);
      if (details.isCanceled) {
        return false;
      }
      setValueUnwrapped(validatedValue);
      setDirty(validatedValue !== validityData.initialValue);
      hasPendingCommitRef.current = true;
    }
    lastChangedValueRef.current = validatedValue;
    if (allowInputSyncRef.current) {
      setInputValue(formatNumber(validatedValue, locale, format));
    }
    forceRender();
    return shouldFireChange;
  });
  const incrementValue = useStableCallback((amount, {
    direction,
    currentValue,
    event,
    reason
  }) => {
    const prevValue = currentValue == null ? valueRef.current : currentValue;
    const nativeEvent = event;
    if (typeof prevValue !== "number") {
      return setValue(0, createChangeEventDetails(reason, nativeEvent));
    }
    return setValue(prevValue + amount * direction, createChangeEventDetails(reason, nativeEvent, void 0, {
      direction
    }));
  });
  useIsoLayoutEffect(function syncFormattedInputValueOnValueChange() {
    if (!allowInputSyncRef.current) {
      return;
    }
    const nextInputValue = formatNumber(value, locale, format);
    if (nextInputValue !== inputValue) {
      setInputValue(nextInputValue);
    }
  });
  useIsoLayoutEffect(function setDynamicInputModeForIOS() {
    if (!parts_exports.os.ios) {
      return;
    }
    let computedInputMode = "text";
    if (minWithDefault >= 0) {
      computedInputMode = "decimal";
    }
    setInputMode(computedInputMode);
  }, [minWithDefault]);
  const focusInput = useStableCallback(() => {
    const input = inputRef.current;
    if (!input) {
      return;
    }
    const length = input.value.length;
    input.setSelectionRange(length, length);
    input.focus();
  });
  React111.useEffect(function registerElementWheelListener() {
    const element3 = inputRef.current;
    if (disabled2 || readOnly || !allowWheelScrub || !element3) {
      return void 0;
    }
    function handleWheel(event) {
      if (
        // Allow pinch-zooming.
        event.ctrlKey || activeElement(ownerDocument(inputRef.current)) !== inputRef.current
      ) {
        return;
      }
      const isHorizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
      const delta = event.shiftKey && isHorizontal ? event.deltaX : event.deltaY;
      if (delta === 0 || !event.shiftKey && isHorizontal) {
        return;
      }
      event.preventDefault();
      allowInputSyncRef.current = true;
      const amount = getStepAmount(event);
      const changed = incrementValue(amount, {
        direction: delta > 0 ? -1 : 1,
        event,
        reason: reason_parts_exports.wheel
      });
      if (changed) {
        onValueCommitted(lastChangedValueRef.current, createGenericEventDetails(reason_parts_exports.wheel, event));
      }
    }
    return addEventListener(element3, "wheel", handleWheel);
  }, [allowWheelScrub, incrementValue, disabled2, readOnly, getStepAmount, onValueCommitted, lastChangedValueRef, valueRef]);
  const state = React111.useMemo(() => ({
    ...fieldState,
    disabled: disabled2,
    readOnly,
    required,
    value,
    inputValue,
    scrubbing: isScrubbing
  }), [fieldState, disabled2, readOnly, required, value, inputValue, isScrubbing]);
  const contextValue = React111.useMemo(() => ({
    inputRef,
    focusInput,
    minWithDefault,
    maxWithDefault,
    id,
    setValue,
    incrementValue,
    getStepAmount,
    allowInputSyncRef,
    formatOptionsRef,
    valueRef,
    lastChangedValueRef,
    hasPendingCommitRef,
    name: name2,
    nameProp,
    inputMode,
    getAllowedNonNumericKeys,
    min: min2,
    max: max2,
    setInputValue,
    locale,
    setIsScrubbing,
    state,
    onValueCommitted
  }), [inputRef, focusInput, minWithDefault, maxWithDefault, id, setValue, incrementValue, getStepAmount, formatOptionsRef, valueRef, name2, nameProp, inputMode, getAllowedNonNumericKeys, min2, max2, setInputValue, locale, state, onValueCommitted]);
  const element2 = useRenderElement("div", componentProps, {
    ref: forwardedRef,
    state,
    props: elementProps,
    stateAttributesMapping: stateAttributesMapping4
  });
  return /* @__PURE__ */ _jsxs7(NumberFieldRootContext.Provider, {
    value: contextValue,
    children: [element2, /* @__PURE__ */ _jsx25("input", {
      ...validation.getValidationProps(disabled2, {
        onFocus() {
          focusInput();
        },
        onChange(event) {
          if (event.nativeEvent.defaultPrevented || disabled2 || readOnly) {
            return;
          }
          const nextValue = event.currentTarget.valueAsNumber;
          const parsedValue = Number.isNaN(nextValue) ? null : nextValue;
          const details = createChangeEventDetails(reason_parts_exports.none, event.nativeEvent);
          setValue(parsedValue, details);
          clearErrors(name2);
          validation.change(lastChangedValueRef.current ?? parsedValue);
        }
      }),
      ref: hiddenInputRef,
      type: "number",
      form,
      name: name2,
      value: value ?? "",
      min: min2,
      max: max2,
      step: stepProp,
      disabled: disabled2,
      readOnly,
      required,
      "aria-hidden": true,
      tabIndex: -1,
      style: name2 ? visuallyHiddenInput : visuallyHidden,
      suppressHydrationWarning: true
    })]
  });
});
if (process.env.NODE_ENV !== "production") NumberFieldRoot.displayName = "NumberFieldRoot";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/group/NumberFieldGroup.mjs
import * as React112 from "react";
var NumberFieldGroup = /* @__PURE__ */ React112.forwardRef(function NumberFieldGroup2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const {
    state
  } = useNumberFieldRootContext();
  const element2 = useRenderElement("div", componentProps, {
    ref: forwardedRef,
    state,
    props: [{
      role: "group"
    }, elementProps],
    stateAttributesMapping: stateAttributesMapping4
  });
  return element2;
});
if (process.env.NODE_ENV !== "production") NumberFieldGroup.displayName = "NumberFieldGroup";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/increment/NumberFieldIncrement.mjs
import * as React114 from "react";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/usePressAndHold.mjs
import * as React113 from "react";

// ../../node_modules/.pnpm/@base-ui+utils@0.4.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/utils/useInterval.mjs
var EMPTY3 = 0;
var Interval = class _Interval extends Timeout {
  static create() {
    return new _Interval();
  }
  /**
   * Executes `fn` at `delay` interval, clearing any previously scheduled call.
   */
  start(delay, fn) {
    this.clear();
    this.currentId = setInterval(() => {
      fn();
    }, delay);
  }
  clear = () => {
    if (this.currentId !== EMPTY3) {
      clearInterval(this.currentId);
      this.currentId = EMPTY3;
    }
  };
};
function useInterval() {
  const timeout = useRefWithInit(Interval.create).current;
  useOnMount(timeout.disposeEffect);
  return timeout;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/internals/usePressAndHold.mjs
var DEFAULT_TICK_DELAY = 60;
var DEFAULT_START_DELAY = 400;
var DEFAULT_SCROLL_DISTANCE = 8;
var TOUCH_TIMEOUT = 50;
var MAX_POINTER_MOVES_AFTER_TOUCH = 3;
function isTouchLikePointerType(pointerType) {
  return pointerType === "touch" || pointerType === "pen";
}
function usePressAndHold(params) {
  const {
    disabled: disabled2,
    tick,
    onStop,
    tickDelay = DEFAULT_TICK_DELAY,
    startDelay = DEFAULT_START_DELAY,
    scrollDistance = DEFAULT_SCROLL_DISTANCE,
    elementRef
  } = params;
  const startTickTimeout = useTimeout();
  const tickInterval = useInterval();
  const intentionalTouchCheckTimeout = useTimeout();
  const isPressedRef = React113.useRef(false);
  const movesAfterTouchRef = React113.useRef(0);
  const downCoordsRef = React113.useRef({
    x: 0,
    y: 0
  });
  const isTouchingButtonRef = React113.useRef(false);
  const ignoreClickRef = React113.useRef(false);
  const pointerTypeRef = React113.useRef("");
  const unsubscribeFromGlobalContextMenuRef = React113.useRef(NOOP);
  const unsubscribeFromGlobalPointerUpRef = React113.useRef(NOOP);
  const stopAutoChange = useStableCallback(() => {
    intentionalTouchCheckTimeout.clear();
    startTickTimeout.clear();
    tickInterval.clear();
    unsubscribeFromGlobalContextMenuRef.current();
    movesAfterTouchRef.current = 0;
  });
  function startAutoChange(triggerNativeEvent) {
    stopAutoChange();
    const element2 = elementRef.current;
    if (!element2) {
      return;
    }
    const win = getWindow(element2);
    function handleContextMenu(event) {
      event.preventDefault();
    }
    unsubscribeFromGlobalContextMenuRef.current = addEventListener(win, "contextmenu", handleContextMenu);
    unsubscribeFromGlobalPointerUpRef.current();
    unsubscribeFromGlobalPointerUpRef.current = addEventListener(win, "pointerup", (event) => {
      isPressedRef.current = false;
      stopAutoChange();
      onStop?.(event);
    }, {
      once: true
    });
    if (!tick(triggerNativeEvent)) {
      stopAutoChange();
      return;
    }
    startTickTimeout.start(startDelay, () => {
      tickInterval.start(tickDelay, () => {
        if (!tick(triggerNativeEvent)) {
          stopAutoChange();
        }
      });
    });
  }
  React113.useEffect(() => () => {
    stopAutoChange();
    unsubscribeFromGlobalPointerUpRef.current();
  }, [stopAutoChange]);
  React113.useEffect(() => {
    if (disabled2) {
      isPressedRef.current = false;
      isTouchingButtonRef.current = false;
      pointerTypeRef.current = "";
      stopAutoChange();
    }
  }, [disabled2, stopAutoChange]);
  const pointerHandlers = {
    onTouchStart() {
      isTouchingButtonRef.current = true;
    },
    onTouchEnd() {
      isTouchingButtonRef.current = false;
    },
    onPointerDown(event) {
      if (event.defaultPrevented || event.button || disabled2) {
        return;
      }
      pointerTypeRef.current = event.pointerType;
      ignoreClickRef.current = false;
      isPressedRef.current = true;
      downCoordsRef.current = {
        x: event.clientX,
        y: event.clientY
      };
      const isTouchPointer = isTouchLikePointerType(event.pointerType);
      if (!isTouchPointer) {
        event.preventDefault();
        startAutoChange(event.nativeEvent);
      } else {
        intentionalTouchCheckTimeout.start(TOUCH_TIMEOUT, () => {
          const moves = movesAfterTouchRef.current;
          movesAfterTouchRef.current = 0;
          const stillPressed = isPressedRef.current;
          if (stillPressed && moves < MAX_POINTER_MOVES_AFTER_TOUCH) {
            startAutoChange(event.nativeEvent);
            ignoreClickRef.current = true;
          } else {
            ignoreClickRef.current = false;
            stopAutoChange();
          }
        });
      }
    },
    onPointerUp(event) {
      if (isTouchLikePointerType(event.pointerType)) {
        isPressedRef.current = false;
      }
    },
    onPointerMove(event) {
      if (disabled2 || !isTouchLikePointerType(event.pointerType) || !isPressedRef.current) {
        return;
      }
      movesAfterTouchRef.current += 1;
      const {
        x,
        y
      } = downCoordsRef.current;
      const dx = x - event.clientX;
      const dy = y - event.clientY;
      if (dx ** 2 + dy ** 2 > scrollDistance ** 2) {
        stopAutoChange();
      }
    },
    onMouseEnter(event) {
      if (event.defaultPrevented || disabled2 || !isPressedRef.current || isTouchingButtonRef.current || isTouchLikePointerType(pointerTypeRef.current)) {
        return;
      }
      startAutoChange(event.nativeEvent);
    },
    onMouseLeave() {
      if (isTouchingButtonRef.current) {
        return;
      }
      stopAutoChange();
    },
    onMouseUp() {
      if (isTouchingButtonRef.current) {
        return;
      }
      stopAutoChange();
    }
  };
  const shouldSkipClick = useStableCallback((event) => {
    if (event.defaultPrevented) {
      return true;
    }
    if (isTouchLikePointerType(pointerTypeRef.current)) {
      return ignoreClickRef.current;
    }
    return event.detail !== 0;
  });
  return {
    pointerHandlers,
    shouldSkipClick
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/root/useNumberFieldStepperButton.mjs
var SELECT_NONE_STYLE = {
  WebkitUserSelect: "none",
  userSelect: "none"
};
function useNumberFieldStepperButton(componentProps, forwardedRef, isIncrement) {
  const {
    render,
    className,
    disabled: disabledProp = false,
    nativeButton = true,
    style,
    ...elementProps
  } = componentProps;
  const {
    allowInputSyncRef,
    formatOptionsRef,
    getStepAmount,
    id,
    incrementValue,
    inputRef,
    focusInput,
    maxWithDefault,
    minWithDefault,
    setValue,
    state,
    valueRef,
    locale,
    lastChangedValueRef,
    onValueCommitted
  } = useNumberFieldRootContext();
  const {
    disabled: contextDisabled,
    readOnly,
    value,
    inputValue
  } = state;
  const isAtBoundary = value != null && (isIncrement ? value >= maxWithDefault : value <= minWithDefault);
  const disabled2 = disabledProp || contextDisabled || isAtBoundary;
  const pressReason = isIncrement ? reason_parts_exports.incrementPress : reason_parts_exports.decrementPress;
  function commitValue(nativeEvent) {
    const shouldCommitInputValue = !allowInputSyncRef.current;
    allowInputSyncRef.current = true;
    if (!shouldCommitInputValue) {
      lastChangedValueRef.current = valueRef.current;
      return;
    }
    const parsedValue = parseNumber(inputValue, locale, formatOptionsRef.current);
    if (parsedValue !== null) {
      const details = createChangeEventDetails(pressReason, nativeEvent);
      setValue(parsedValue, details);
      if (!details.isCanceled) {
        valueRef.current = parsedValue;
      }
    }
  }
  const {
    pointerHandlers,
    shouldSkipClick
  } = usePressAndHold({
    disabled: disabled2 || readOnly,
    elementRef: inputRef,
    tick(triggerEvent) {
      const amount = getStepAmount(triggerEvent);
      return incrementValue(amount, {
        direction: isIncrement ? 1 : -1,
        event: triggerEvent,
        reason: pressReason
      });
    },
    onStop(nativeEvent) {
      const committed = lastChangedValueRef.current ?? valueRef.current;
      onValueCommitted(committed, createGenericEventDetails(pressReason, nativeEvent));
    }
  });
  const props = {
    disabled: disabled2,
    "aria-label": isIncrement ? "Increase" : "Decrease",
    "aria-controls": id,
    // Keyboard users shouldn't have access to the buttons, since they can use the input element
    // to change the value. On the other hand, `aria-hidden` is not applied because touch screen
    // readers should be able to use the buttons.
    tabIndex: -1,
    style: SELECT_NONE_STYLE,
    ...pointerHandlers,
    onClick(event) {
      const isDisabled = disabled2 || readOnly;
      if (event.defaultPrevented || isDisabled || shouldSkipClick(event)) {
        return;
      }
      commitValue(event.nativeEvent);
      const amount = getStepAmount(event);
      const prev = valueRef.current;
      incrementValue(amount, {
        direction: isIncrement ? 1 : -1,
        event: event.nativeEvent,
        reason: pressReason
      });
      const committed = lastChangedValueRef.current ?? valueRef.current;
      if (committed !== prev) {
        onValueCommitted(committed, createGenericEventDetails(pressReason, event.nativeEvent));
      }
    },
    onPointerDown(event) {
      if (event.defaultPrevented || readOnly || event.button || disabled2) {
        return;
      }
      commitValue(event.nativeEvent);
      lastChangedValueRef.current = null;
      if (!isTouchLikePointerType(event.pointerType)) {
        focusInput();
      }
      pointerHandlers.onPointerDown(event);
    }
  };
  const {
    getButtonProps,
    buttonRef
  } = useButton({
    // Read-only steppers are exposed as unavailable through button disabled semantics, while
    // `data-readonly` (from `state`) is preserved for styling. `aria-readonly` isn't valid on the
    // `button` role, so it's intentionally not set.
    disabled: disabled2 || readOnly,
    native: nativeButton,
    focusableWhenDisabled: true
  });
  const buttonState = {
    ...state,
    disabled: disabled2
  };
  return useRenderElement("button", componentProps, {
    ref: [forwardedRef, buttonRef],
    state: buttonState,
    props: [props, elementProps, getButtonProps],
    stateAttributesMapping: stateAttributesMapping4
  });
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/increment/NumberFieldIncrement.mjs
var NumberFieldIncrement = /* @__PURE__ */ React114.forwardRef(function NumberFieldIncrement2(componentProps, forwardedRef) {
  return useNumberFieldStepperButton(componentProps, forwardedRef, true);
});
if (process.env.NODE_ENV !== "production") NumberFieldIncrement.displayName = "NumberFieldIncrement";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/decrement/NumberFieldDecrement.mjs
import * as React115 from "react";
var NumberFieldDecrement = /* @__PURE__ */ React115.forwardRef(function NumberFieldDecrement2(componentProps, forwardedRef) {
  return useNumberFieldStepperButton(componentProps, forwardedRef, false);
});
if (process.env.NODE_ENV !== "production") NumberFieldDecrement.displayName = "NumberFieldDecrement";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/input/NumberFieldInput.mjs
import * as React116 from "react";
var NAVIGATE_KEYS = /* @__PURE__ */ new Set(["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter", "Escape"]);
var NumberFieldInput = /* @__PURE__ */ React116.forwardRef(function NumberFieldInput2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const {
    allowInputSyncRef,
    formatOptionsRef,
    getAllowedNonNumericKeys,
    getStepAmount,
    id,
    incrementValue,
    inputMode,
    max: max2,
    min: min2,
    name: name2,
    nameProp,
    setValue,
    state,
    setInputValue,
    locale,
    inputRef,
    onValueCommitted,
    lastChangedValueRef,
    hasPendingCommitRef,
    valueRef
  } = useNumberFieldRootContext();
  const {
    disabled: disabled2,
    readOnly,
    required,
    value,
    inputValue
  } = state;
  const {
    clearErrors
  } = useFormContext();
  const {
    validationMode,
    setTouched,
    setFocused,
    invalid: invalid2,
    shouldValidateOnChange,
    validation
  } = useFieldRootContext();
  const {
    labelId
  } = useLabelableContext();
  const blockRevalidationRef = React116.useRef(false);
  const pendingCaretRef = React116.useRef(null);
  useRegisterFieldControl(inputRef, id, value, void 0, !disabled2, nameProp);
  useIsoLayoutEffect(() => {
    if (pendingCaretRef.current != null) {
      const caret = pendingCaretRef.current;
      pendingCaretRef.current = null;
      inputRef.current?.setSelectionRange(caret, caret);
    }
  });
  useValueChanged(value, () => {
    clearErrors(name2);
    if (blockRevalidationRef.current && !shouldValidateOnChange()) {
      blockRevalidationRef.current = false;
      return;
    }
    validation.change(value);
  });
  const inputProps = {
    id,
    required,
    disabled: disabled2,
    readOnly,
    inputMode,
    value: inputValue,
    type: "text",
    autoComplete: "off",
    autoCorrect: "off",
    spellCheck: "false",
    "aria-roledescription": "Number field",
    "aria-invalid": !disabled2 && invalid2 ? true : void 0,
    "aria-labelledby": labelId,
    // If the server's locale does not match the client's locale, the formatting may not match,
    // causing a hydration mismatch.
    suppressHydrationWarning: true,
    onFocus(event) {
      if (event.defaultPrevented || disabled2) {
        return;
      }
      setFocused(true);
    },
    onBlur(event) {
      if (event.defaultPrevented || disabled2) {
        return;
      }
      setTouched(true);
      setFocused(false);
      if (readOnly) {
        return;
      }
      const hadManualInput = !allowInputSyncRef.current;
      const hadPendingProgrammaticChange = hasPendingCommitRef.current;
      allowInputSyncRef.current = true;
      if (inputValue.trim() === "") {
        const clearDetails = createChangeEventDetails(reason_parts_exports.inputClear, event.nativeEvent);
        setValue(null, clearDetails);
        if (clearDetails.isCanceled) {
          return;
        }
        if (validationMode === "onBlur") {
          validation.commit(null);
        }
        if (hadManualInput || hadPendingProgrammaticChange || value !== null) {
          onValueCommitted(null, createGenericEventDetails(reason_parts_exports.inputClear, event.nativeEvent));
        }
        return;
      }
      const formatOptions = formatOptionsRef.current;
      const parsedValue = parseNumber(inputValue, locale, formatOptions);
      if (parsedValue === null) {
        return;
      }
      const hasRoundingOptions = hasNumberFormatRoundingOptions(formatOptions);
      let committed;
      if (!hadManualInput && !hasRoundingOptions) {
        committed = value;
      } else if (hasRoundingOptions) {
        committed = removeFloatingPointErrors(parsedValue, formatOptions);
      } else {
        committed = parsedValue;
      }
      const nextEventDetails = createGenericEventDetails(reason_parts_exports.inputBlur, event.nativeEvent);
      const shouldUpdateValue = value !== committed;
      const shouldCommit = hadManualInput || shouldUpdateValue || hadPendingProgrammaticChange;
      let committedValue = committed;
      if (shouldUpdateValue) {
        const changeDetails = createChangeEventDetails(reason_parts_exports.inputBlur, event.nativeEvent);
        blockRevalidationRef.current = true;
        setValue(committed, changeDetails);
        if (changeDetails.isCanceled) {
          blockRevalidationRef.current = false;
          return;
        }
        committedValue = lastChangedValueRef.current;
        if (committedValue === value) {
          blockRevalidationRef.current = false;
        }
      }
      if (validationMode === "onBlur") {
        validation.commit(committedValue);
      }
      if (shouldCommit) {
        onValueCommitted(committedValue, nextEventDetails);
      }
      const canonicalText = formatNumber(committedValue, locale, formatOptions);
      if (inputValue !== canonicalText) {
        setInputValue(canonicalText);
      }
    },
    onChange(event) {
      if (event.nativeEvent.defaultPrevented) {
        return;
      }
      allowInputSyncRef.current = false;
      const targetValue = event.currentTarget.value;
      if (targetValue.trim() === "") {
        setInputValue(targetValue);
        setValue(null, createChangeEventDetails(reason_parts_exports.inputClear, event.nativeEvent));
        return;
      }
      const allowedNonNumericKeys = getAllowedNonNumericKeys();
      const isValidCharacterString = Array.from(targetValue).every((ch) => isNumeralChar(ch) || ANY_MINUS_DETECT_RE.test(ch) || allowedNonNumericKeys.has(ch) || // Bidi/format controls are stripped by `parseNumber`; don't let them reject the string
      // (RTL locales insert them around exponent/currency signs, e.g. scientific notation).
      FORMAT_CONTROL_DETECT_RE.test(ch));
      if (!isValidCharacterString) {
        return;
      }
      const parsedValue = parseNumber(targetValue, locale, formatOptionsRef.current);
      setInputValue(targetValue);
      if (parsedValue !== null) {
        setValue(parsedValue, createChangeEventDetails(reason_parts_exports.inputChange, event.nativeEvent));
      }
    },
    onKeyDown(event) {
      if (event.defaultPrevented || readOnly || disabled2) {
        return;
      }
      const nativeEvent = event.nativeEvent;
      const hadManualInput = !allowInputSyncRef.current;
      const allowedNonNumericKeys = getAllowedNonNumericKeys();
      let isAllowedNonNumericKey = allowedNonNumericKeys.has(event.key);
      const {
        decimal,
        currency,
        percentSign
      } = getNumberLocaleDetails(locale, formatOptionsRef.current);
      const selectionStart = event.currentTarget.selectionStart;
      const selectionEnd = event.currentTarget.selectionEnd;
      const isAllSelected = selectionStart === 0 && selectionEnd === inputValue.length;
      const selectionContainsIndex = (index2) => selectionStart != null && selectionEnd != null && index2 >= selectionStart && index2 < selectionEnd;
      const signGroups = [[ANY_MINUS_DETECT_RE, ANY_MINUS_RE], [ANY_PLUS_DETECT_RE, ANY_PLUS_RE]];
      signGroups.forEach(([detectRe, globalRe]) => {
        if (detectRe.test(event.key) && Array.from(allowedNonNumericKeys).some((k) => detectRe.test(k))) {
          const existingIndex = inputValue.search(globalRe);
          const isReplacingExisting = existingIndex !== -1 && selectionContainsIndex(existingIndex);
          isAllowedNonNumericKey = !(ANY_MINUS_DETECT_RE.test(inputValue) || ANY_PLUS_DETECT_RE.test(inputValue)) || isAllSelected || isReplacingExisting;
        }
      });
      [decimal, currency, percentSign].forEach((symbol) => {
        if (event.key === symbol) {
          const symbolIndex = inputValue.indexOf(symbol);
          const isSymbolHighlighted = selectionContainsIndex(symbolIndex);
          isAllowedNonNumericKey = symbolIndex === -1 || isAllSelected || isSymbolHighlighted;
        }
      });
      const isNavigateKey = NAVIGATE_KEYS.has(event.key);
      const isStepKey = event.key === "ArrowUp" || event.key === "ArrowDown";
      if (
        // Allow composition events (e.g., pinyin)
        // event.nativeEvent.isComposing does not work in Safari:
        // https://bugs.webkit.org/show_bug.cgi?id=165004
        event.which === 229 || event.altKey && !isStepKey || event.ctrlKey || event.metaKey || isAllowedNonNumericKey || isNumeralChar(event.key) || isNavigateKey
      ) {
        return;
      }
      let boundaryValue = null;
      if (event.key === "Home" && min2 != null) {
        boundaryValue = min2;
      } else if (event.key === "End" && max2 != null) {
        boundaryValue = max2;
      }
      if (event.key.length > 1 && !isStepKey && boundaryValue === null) {
        return;
      }
      const currentValue = hadManualInput ? parseNumber(inputValue, locale, formatOptionsRef.current) : null;
      const amount = getStepAmount(event);
      event.preventDefault();
      event.stopPropagation();
      const commitDetails = createGenericEventDetails(reason_parts_exports.keyboard, nativeEvent);
      let changed = false;
      if (isStepKey || boundaryValue !== null) {
        allowInputSyncRef.current = true;
      }
      if (isStepKey) {
        if (!hadManualInput) {
          lastChangedValueRef.current = valueRef.current;
        }
        changed = incrementValue(amount, {
          direction: event.key === "ArrowUp" ? 1 : -1,
          currentValue,
          event: nativeEvent,
          reason: reason_parts_exports.keyboard
        });
      } else if (boundaryValue !== null) {
        changed = setValue(boundaryValue, createChangeEventDetails(reason_parts_exports.keyboard, nativeEvent));
      }
      if (changed) {
        onValueCommitted(lastChangedValueRef.current, commitDetails);
      }
    },
    onPaste(event) {
      if (event.defaultPrevented || readOnly || disabled2) {
        return;
      }
      let pastedData = "";
      try {
        pastedData = event.clipboardData?.getData("text/plain") ?? "";
      } catch {
        if (process.env.NODE_ENV !== "production") {
          const ownerStackMessage = SafeReact.captureOwnerStack?.() || "";
          warn("<NumberField.Input> could not read clipboard text during paste handling.", ownerStackMessage);
        }
        return;
      }
      event.preventDefault();
      const input = event.currentTarget;
      const selectionStart = input.selectionStart;
      const selectionEnd = input.selectionEnd;
      const nextText = inputValue.slice(0, selectionStart) + pastedData + inputValue.slice(selectionEnd);
      const parsedValue = parseNumber(nextText, locale, formatOptionsRef.current);
      if (parsedValue !== null) {
        allowInputSyncRef.current = false;
        pendingCaretRef.current = selectionStart + pastedData.length;
        setValue(parsedValue, createChangeEventDetails(reason_parts_exports.inputPaste, event.nativeEvent));
        setInputValue(nextText);
      }
    }
  };
  const element2 = useRenderElement("input", componentProps, {
    ref: [forwardedRef, inputRef],
    state,
    props: [inputProps, elementProps, (props) => validation.getValidationProps(disabled2, props)],
    stateAttributesMapping: stateAttributesMapping4
  });
  return element2;
});
if (process.env.NODE_ENV !== "production") NumberFieldInput.displayName = "NumberFieldInput";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/scrub-area/NumberFieldScrubArea.mjs
import * as React118 from "react";
import * as ReactDOM8 from "react-dom";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/scrub-area/NumberFieldScrubAreaContext.mjs
import * as React117 from "react";
var NumberFieldScrubAreaContext = /* @__PURE__ */ React117.createContext(void 0);
if (process.env.NODE_ENV !== "production") NumberFieldScrubAreaContext.displayName = "NumberFieldScrubAreaContext";
function useNumberFieldScrubAreaContext() {
  const context = React117.useContext(NumberFieldScrubAreaContext);
  if (context === void 0) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: NumberFieldScrubAreaContext is missing. NumberFieldScrubArea parts must be placed within <NumberField.ScrubArea>." : formatErrorMessage_default(44));
  }
  return context;
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/utils/getViewportRect.mjs
function getViewportRect2(teleportDistance, scrubAreaEl) {
  const win = getWindow(scrubAreaEl);
  if (teleportDistance != null) {
    const rect = scrubAreaEl.getBoundingClientRect();
    return {
      left: rect.left - teleportDistance / 2,
      top: rect.top - teleportDistance / 2,
      right: rect.right + teleportDistance / 2,
      bottom: rect.bottom + teleportDistance / 2
    };
  }
  const vV = win.visualViewport;
  if (vV) {
    return {
      left: vV.offsetLeft,
      top: vV.offsetTop,
      right: vV.offsetLeft + vV.width,
      bottom: vV.offsetTop + vV.height
    };
  }
  return {
    left: 0,
    top: 0,
    right: win.document.documentElement.clientWidth,
    bottom: win.document.documentElement.clientHeight
  };
}

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/scrub-area/NumberFieldScrubArea.mjs
import { jsx as _jsx26 } from "react/jsx-runtime";
var SCRUB_AREA_STYLE = {
  touchAction: "none",
  WebkitUserSelect: "none",
  userSelect: "none"
};
var NumberFieldScrubArea = /* @__PURE__ */ React118.forwardRef(function NumberFieldScrubArea2(componentProps, forwardedRef) {
  const {
    render,
    className,
    direction = "horizontal",
    pixelSensitivity = 2,
    teleportDistance,
    style,
    ...elementProps
  } = componentProps;
  const {
    state,
    setIsScrubbing: setRootScrubbing,
    inputRef,
    focusInput,
    incrementValue,
    allowInputSyncRef,
    getStepAmount,
    onValueCommitted,
    lastChangedValueRef,
    valueRef
  } = useNumberFieldRootContext();
  const {
    disabled: disabled2,
    readOnly
  } = state;
  const scrubAreaRef = React118.useRef(null);
  const isScrubbingRef = React118.useRef(false);
  const didMoveRef = React118.useRef(false);
  const pointerDownTargetRef = React118.useRef(null);
  const scrubAreaCursorRef = React118.useRef(null);
  const virtualCursorCoords = React118.useRef({
    x: 0,
    y: 0
  });
  const exitPointerLockTimeout = useTimeout();
  const [isTouchInput, setIsTouchInput] = React118.useState(false);
  const [isPointerLockDenied, setIsPointerLockDenied] = React118.useState(false);
  const [isScrubbing, setIsScrubbing] = React118.useState(false);
  function updateCursorTransform(virtualCursor, x, y) {
    const scale = getWindow(virtualCursor).visualViewport?.scale ?? 1;
    virtualCursor.style.transform = `translate3d(${x}px,${y}px,0) scale(${1 / scale})`;
  }
  const onScrub = useStableCallback(({
    movementX,
    movementY
  }) => {
    const virtualCursor = scrubAreaCursorRef.current;
    const scrubAreaEl = scrubAreaRef.current;
    if (!virtualCursor || !scrubAreaEl) {
      return;
    }
    const rect = getViewportRect2(teleportDistance, scrubAreaEl);
    const coords = virtualCursorCoords.current;
    const wrap3 = (coord, halfSize, low, high) => {
      if (coord + halfSize < low) {
        return high - halfSize;
      }
      if (coord + halfSize > high) {
        return low - halfSize;
      }
      return coord;
    };
    const newCoords = {
      x: wrap3(Math.round(coords.x + movementX), virtualCursor.offsetWidth / 2, rect.left, rect.right),
      y: wrap3(Math.round(coords.y + movementY), virtualCursor.offsetHeight / 2, rect.top, rect.bottom)
    };
    virtualCursorCoords.current = newCoords;
    updateCursorTransform(virtualCursor, newCoords.x, newCoords.y);
  });
  const onScrubbingChange = useStableCallback((scrubbingValue, {
    clientX,
    clientY
  }) => {
    ReactDOM8.flushSync(() => {
      setIsScrubbing(scrubbingValue);
      setRootScrubbing(scrubbingValue);
    });
    const virtualCursor = scrubAreaCursorRef.current;
    if (!virtualCursor || !scrubbingValue) {
      return;
    }
    const initialCoords = {
      x: clientX - virtualCursor.offsetWidth / 2,
      y: clientY - virtualCursor.offsetHeight / 2
    };
    virtualCursorCoords.current = initialCoords;
    updateCursorTransform(virtualCursor, initialCoords.x, initialCoords.y);
  });
  React118.useEffect(function registerGlobalScrubbingEventListeners() {
    if (!inputRef.current || disabled2 || readOnly || !isScrubbing) {
      return void 0;
    }
    let cumulativeDelta = 0;
    function handleScrubPointerUp(event) {
      function handler() {
        try {
          ownerDocument(scrubAreaRef.current).exitPointerLock();
        } catch {
        } finally {
          isScrubbingRef.current = false;
          onScrubbingChange(false, event);
          onValueCommitted(lastChangedValueRef.current ?? valueRef.current, createGenericEventDetails(reason_parts_exports.scrub, event));
          const pointerDownTarget = pointerDownTargetRef.current;
          const input = inputRef.current;
          if (!didMoveRef.current && pointerDownTarget != null && input) {
            pointerDownTarget.dispatchEvent(new (getWindow(input)).MouseEvent("click", {
              bubbles: true,
              cancelable: true
            }));
          }
          didMoveRef.current = false;
          pointerDownTargetRef.current = null;
        }
      }
      if (parts_exports.engine.gecko) {
        exitPointerLockTimeout.start(20, handler);
      } else {
        handler();
      }
    }
    function handleScrubPointerMove(event) {
      if (!isScrubbingRef.current) {
        return;
      }
      event.preventDefault();
      onScrub(event);
      const {
        movementX,
        movementY
      } = event;
      cumulativeDelta += direction === "vertical" ? movementY : movementX;
      if (Math.abs(cumulativeDelta) >= pixelSensitivity) {
        cumulativeDelta = 0;
        didMoveRef.current = true;
        const dValue = direction === "vertical" ? -movementY : movementX;
        const stepAmount = getStepAmount(event);
        const rawAmount = dValue * stepAmount;
        if (rawAmount !== 0) {
          allowInputSyncRef.current = true;
          incrementValue(Math.abs(rawAmount), {
            direction: rawAmount >= 0 ? 1 : -1,
            event,
            reason: reason_parts_exports.scrub
          });
        }
      }
    }
    const win = getWindow(inputRef.current);
    const unsubscribe = mergeCleanups(addEventListener(win, "pointerup", handleScrubPointerUp, true), addEventListener(win, "pointermove", handleScrubPointerMove, true));
    return () => {
      exitPointerLockTimeout.clear();
      unsubscribe();
    };
  }, [disabled2, readOnly, allowInputSyncRef, incrementValue, isScrubbing, getStepAmount, inputRef, onScrubbingChange, onScrub, direction, pixelSensitivity, lastChangedValueRef, onValueCommitted, valueRef, exitPointerLockTimeout]);
  React118.useEffect(() => () => {
    if (isScrubbingRef.current) {
      isScrubbingRef.current = false;
      setRootScrubbing(false);
      try {
        ownerDocument(scrubAreaRef.current).exitPointerLock();
      } catch {
      }
    }
  }, [setRootScrubbing]);
  React118.useEffect(function registerScrubberTouchPreventListener() {
    const element3 = scrubAreaRef.current;
    if (!element3 || disabled2 || readOnly) {
      return void 0;
    }
    function handleTouchStart(event) {
      if (event.touches.length === 1) {
        event.preventDefault();
      }
    }
    return addEventListener(element3, "touchstart", handleTouchStart);
  }, [disabled2, readOnly]);
  const defaultProps = {
    role: "presentation",
    style: SCRUB_AREA_STYLE,
    async onPointerDown(event) {
      if (event.defaultPrevented || readOnly || event.button || disabled2) {
        return;
      }
      const isTouch = event.pointerType === "touch";
      setIsTouchInput(isTouch);
      if (event.pointerType === "mouse") {
        event.preventDefault();
        focusInput();
      }
      isScrubbingRef.current = true;
      didMoveRef.current = false;
      pointerDownTargetRef.current = getTarget(event.nativeEvent);
      onScrubbingChange(true, event.nativeEvent);
      if (!isTouch && !parts_exports.engine.webkit) {
        try {
          await ownerDocument(scrubAreaRef.current).body.requestPointerLock();
          setIsPointerLockDenied(false);
        } catch (error2) {
          setIsPointerLockDenied(true);
        } finally {
          if (isScrubbingRef.current) {
            onScrubbingChange(true, event.nativeEvent);
          }
        }
      }
    }
  };
  const element2 = useRenderElement("span", componentProps, {
    ref: [forwardedRef, scrubAreaRef],
    state,
    props: [defaultProps, elementProps],
    stateAttributesMapping: stateAttributesMapping4
  });
  const contextValue = React118.useMemo(() => ({
    isScrubbing,
    isTouchInput,
    isPointerLockDenied,
    scrubAreaCursorRef
  }), [isScrubbing, isTouchInput, isPointerLockDenied]);
  return /* @__PURE__ */ _jsx26(NumberFieldScrubAreaContext.Provider, {
    value: contextValue,
    children: element2
  });
});
if (process.env.NODE_ENV !== "production") NumberFieldScrubArea.displayName = "NumberFieldScrubArea";

// ../../node_modules/.pnpm/@base-ui+react@1.8.0_@types+react@19.2.14_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/@base-ui/react/number-field/scrub-area-cursor/NumberFieldScrubAreaCursor.mjs
import * as React119 from "react";
import * as ReactDOM9 from "react-dom";
var CURSOR_STYLE = {
  position: "fixed",
  top: 0,
  left: 0,
  pointerEvents: "none"
};
var NumberFieldScrubAreaCursor = /* @__PURE__ */ React119.forwardRef(function NumberFieldScrubAreaCursor2(componentProps, forwardedRef) {
  const {
    render,
    className,
    style,
    ...elementProps
  } = componentProps;
  const {
    state
  } = useNumberFieldRootContext();
  const {
    isScrubbing,
    isTouchInput,
    isPointerLockDenied,
    scrubAreaCursorRef
  } = useNumberFieldScrubAreaContext();
  const [domElement, setDomElement] = React119.useState(null);
  const shouldRender = isScrubbing && !parts_exports.engine.webkit && !isTouchInput && !isPointerLockDenied;
  const element2 = useRenderElement("span", componentProps, {
    enabled: shouldRender,
    ref: [forwardedRef, scrubAreaCursorRef, setDomElement],
    state,
    props: [{
      role: "presentation",
      style: CURSOR_STYLE
    }, elementProps],
    stateAttributesMapping: stateAttributesMapping4
  });
  return element2 && /* @__PURE__ */ ReactDOM9.createPortal(element2, ownerDocument(domElement).body);
});
if (process.env.NODE_ENV !== "production") NumberFieldScrubAreaCursor.displayName = "NumberFieldScrubAreaCursor";

// src/components/primitive/NumberField/NumberField.tsx
import { jsx as jsx42, jsxs as jsxs21 } from "react/jsx-runtime";
function NumberField({
  ref,
  value: valueProp,
  defaultValue,
  onValueChange,
  onValueCommitted,
  min: min2,
  max: max2,
  step = 1,
  largeStep = 10,
  format,
  locale: localeProp,
  label,
  placeholder,
  helperText: helperTextProp,
  errorText: errorTextProp,
  size: size5 = "md",
  fullWidth = false,
  disabled: disabled2,
  readOnly,
  required,
  name: name2,
  id: idProp,
  className,
  "aria-label": ariaLabel,
  "aria-labelledby": ariaLabelledBy,
  "aria-describedby": ariaDescribedBy
}) {
  const { t, i18n } = useComponentsTranslation();
  const locale = localeProp ?? i18n.language;
  const reactId = React120.useId();
  const id = idProp ?? `buyscout-number-field-${reactId}`;
  const helperId = `${id}-helper`;
  const errorId = `${id}-error`;
  const [uncontrolled, setUncontrolled] = React120.useState(defaultValue ?? null);
  const controlled = valueProp !== void 0;
  const value = controlled ? valueProp : uncontrolled;
  const change = (next) => {
    if (!controlled) setUncontrolled(next);
    onValueChange?.(next);
  };
  const formatter = React120.useMemo(() => new Intl.NumberFormat(locale, format), [locale, format]);
  const bounds = min2 !== void 0 && max2 !== void 0 ? t("numberField.between", { min: formatter.format(min2), max: formatter.format(max2) }) : min2 !== void 0 ? t("numberField.atLeast", { min: formatter.format(min2) }) : max2 !== void 0 ? t("numberField.atMost", { max: formatter.format(max2) }) : void 0;
  const helperText = helperTextProp === void 0 ? bounds : helperTextProp ?? void 0;
  const rangeError = value === null ? void 0 : min2 !== void 0 && value < min2 ? t("numberField.tooLow", { min: formatter.format(min2) }) : max2 !== void 0 && value > max2 ? t("numberField.tooHigh", { max: formatter.format(max2) }) : void 0;
  const errorText = errorTextProp ?? rangeError;
  const invalid2 = Boolean(errorText);
  const describedBy = [helperText ? helperId : "", errorText ? errorId : "", ariaDescribedBy ?? ""].filter(Boolean).join(" ") || void 0;
  const handleKeyDown = (event) => {
    if (event.key !== "PageUp" && event.key !== "PageDown" || disabled2 || readOnly) return;
    event.preventDefault();
    const base = value ?? min2 ?? 0;
    let next = base + (event.key === "PageUp" ? largeStep : -largeStep);
    if (min2 !== void 0) next = Math.max(min2, next);
    if (max2 !== void 0) next = Math.min(max2, next);
    change(next);
    onValueCommitted?.(next);
  };
  return /* @__PURE__ */ jsxs21(
    "div",
    {
      className: clsx(
        textFieldVariants({ variant: "outlined", size: size5 }),
        "buyscout-number-field",
        invalid2 && "buyscout-tf--error",
        disabled2 && "buyscout-tf--disabled",
        fullWidth && "buyscout-tf--full-width",
        className
      ),
      children: [
        label && /* @__PURE__ */ jsx42("label", { htmlFor: id, className: "buyscout-tf__label", children: label }),
        /* @__PURE__ */ jsx42(
          index_parts_exports2.Root,
          {
            id,
            value,
            onValueChange: (next) => change(next),
            onValueCommitted: (next) => onValueCommitted?.(next),
            min: min2,
            max: max2,
            step,
            largeStep,
            format,
            locale,
            allowOutOfRange: true,
            allowWheelScrub: false,
            disabled: disabled2,
            readOnly,
            required,
            name: name2,
            className: "buyscout-tf__chrome",
            children: /* @__PURE__ */ jsx42(index_parts_exports2.Group, { className: "buyscout-tf__field", children: /* @__PURE__ */ jsx42(
              index_parts_exports2.Input,
              {
                ref,
                className: "buyscout-tf__input buyscout-number-field__input",
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                "aria-describedby": describedBy,
                "aria-invalid": invalid2 || void 0,
                placeholder,
                onKeyDown: handleKeyDown
              }
            ) })
          }
        ),
        helperText && /* @__PURE__ */ jsx42("span", { id: helperId, className: "buyscout-tf__helper", children: helperText }),
        errorText && /* @__PURE__ */ jsx42("span", { id: errorId, className: "buyscout-tf__helper buyscout-tf__helper--error", children: errorText })
      ]
    }
  );
}
NumberField.displayName = "NumberField";

// src/components/primitive/PageGrid/PageGrid.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var cls6 = (...parts) => parts.filter(Boolean).join(" ");
function PageGrid({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx43("div", { ref, className: cls6("buyscout-page-grid", className), ...props });
}
PageGrid.displayName = "PageGrid";
var pageGridItemVariants = cva("buyscout-page-grid__item", {
  variants: {
    align: {
      stretch: "",
      start: "buyscout-page-grid__item--align-start"
    }
  },
  defaultVariants: {
    align: "stretch"
  }
});
function PageGridItem({ ref, span = 12, spanSm, spanMd, spanLg, sticky, align, className, ...props }) {
  return /* @__PURE__ */ jsx43(
    "div",
    {
      ref,
      className: pageGridItemVariants({ align, className }),
      "data-span": span,
      "data-span-sm": spanSm,
      "data-span-md": spanMd,
      "data-span-lg": spanLg,
      "data-sticky": sticky === true ? "always" : sticky || void 0,
      ...props
    }
  );
}
PageGridItem.displayName = "PageGridItem";

// src/components/primitive/Progress/Progress.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var progressVariants = cva("buyscout-progress", {
  variants: {
    variant: {
      bar: null,
      segmented: "buyscout-progress--variant-segmented"
    },
    color: {
      primary: "buyscout-progress--color-primary",
      ink: "buyscout-progress--color-ink",
      error: "buyscout-progress--color-error"
    },
    size: {
      sm: "buyscout-progress--size-sm",
      md: "buyscout-progress--size-md",
      lg: "buyscout-progress--size-lg"
    }
  },
  defaultVariants: {
    variant: "bar",
    color: "primary",
    size: "md"
  }
});
function Progress({
  ref,
  ...props
}) {
  const { value = 0, max: max2 = 100, variant, color, size: size5, indeterminate: indeterminateProp = false, pending = false, className, ...rest } = props;
  const segmented = variant === "segmented";
  const indeterminate = indeterminateProp && !pending && !segmented;
  const safeMax = max2 > 0 ? segmented ? Math.max(1, Math.round(max2)) : max2 : 0;
  const clamped = Math.min(Math.max(value, 0), safeMax);
  const pct = safeMax > 0 ? clamped / safeMax * 100 : 0;
  const classes2 = progressVariants({
    variant,
    color,
    size: size5,
    className: indeterminate ? `buyscout-progress--indeterminate ${className ?? ""}`.trim() : className
  });
  return /* @__PURE__ */ jsx44(
    "div",
    {
      ref,
      className: classes2,
      role: "progressbar",
      "aria-valuenow": indeterminate || pending ? void 0 : clamped,
      "aria-valuemin": 0,
      "aria-valuemax": indeterminate ? void 0 : safeMax,
      "aria-busy": pending || void 0,
      "data-empty": !indeterminate && !pending && clamped === 0 ? "" : void 0,
      ...rest,
      children: segmented ? Array.from({ length: safeMax }, (_, index2) => /* @__PURE__ */ jsx44("span", { className: "buyscout-progress__segment", "data-filled": !pending && index2 < clamped ? "" : void 0 }, index2)) : pending ? null : /* @__PURE__ */ jsx44(
        "div",
        {
          className: "buyscout-progress__fill",
          style: indeterminate ? void 0 : { width: `${pct}%` }
        }
      )
    }
  );
}
Progress.displayName = "Progress";

// src/components/primitive/PropertyList/PropertyList.tsx
import { createContext as createContext24, use as use4 } from "react";
import { jsx as jsx45, jsxs as jsxs22 } from "react/jsx-runtime";
var cls7 = (...parts) => parts.filter(Boolean).join(" ");
var propertyListVariants = cva("buyscout-property-list", {
  variants: {
    layout: {
      inline: "",
      stacked: "buyscout-property-list--stacked"
    }
  },
  defaultVariants: {
    layout: "inline"
  }
});
var PropertyListContext = createContext24({ layout: "inline", labelWidth: "md" });
function PropertyList({ ref, layout, labelWidth = "md", className, children, ...props }) {
  return /* @__PURE__ */ jsx45("dl", { ref, className: propertyListVariants({ layout, className }), ...props, children: /* @__PURE__ */ jsx45(PropertyListContext, { value: { layout: layout ?? "inline", labelWidth }, children }) });
}
PropertyList.displayName = "PropertyList";
function PropertyListItem({ ref, label, className, children, ...props }) {
  const { layout, labelWidth } = use4(PropertyListContext);
  return /* @__PURE__ */ jsxs22(
    "div",
    {
      ref,
      className: cls7(
        "buyscout-field buyscout-field--align-start",
        layout === "stacked" && "buyscout-field--stacked",
        `buyscout-field--label-width-${labelWidth}`,
        "buyscout-property-list__item",
        className
      ),
      ...props,
      children: [
        /* @__PURE__ */ jsx45("dt", { className: "buyscout-field__label buyscout-property-list__label", children: label }),
        /* @__PURE__ */ jsx45("dd", { className: "buyscout-field__value buyscout-property-list__value", children })
      ]
    }
  );
}
PropertyListItem.displayName = "PropertyListItem";

// src/components/primitive/RadioGroup/RadioGroup.tsx
import { MdCheck as MdCheck4 } from "react-icons/md";

// ../../node_modules/.pnpm/@radix-ui+react-radio-group@1.3.8_@types+react-dom@19.2.3_@types+react@19.2.14__@types+_cd32cc5d3acab82c80f5f32482bb55d0/node_modules/@radix-ui/react-radio-group/dist/index.mjs
import * as React212 from "react";
import * as React121 from "react";
import { jsx as jsx46, jsxs as jsxs23 } from "react/jsx-runtime";
import { jsx as jsx210 } from "react/jsx-runtime";
var RADIO_NAME = "Radio";
var [createRadioContext, createRadioScope] = createContextScope(RADIO_NAME);
var [RadioProvider, useRadioContext] = createRadioContext(RADIO_NAME);
var Radio = React121.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeRadio,
      name: name2,
      checked = false,
      required,
      disabled: disabled2,
      value = "on",
      onCheck,
      form,
      ...radioProps
    } = props;
    const [button, setButton] = React121.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setButton(node));
    const hasConsumerStoppedPropagationRef = React121.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    return /* @__PURE__ */ jsxs23(RadioProvider, { scope: __scopeRadio, checked, disabled: disabled2, children: [
      /* @__PURE__ */ jsx46(
        Primitive2.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": checked,
          "data-state": getState4(checked),
          "data-disabled": disabled2 ? "" : void 0,
          disabled: disabled2,
          value,
          ...radioProps,
          ref: composedRefs,
          onClick: composeEventHandlers(props.onClick, (event) => {
            if (!checked) onCheck?.();
            if (isFormControl) {
              hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
              if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
          })
        }
      ),
      isFormControl && /* @__PURE__ */ jsx46(
        RadioBubbleInput,
        {
          control: button,
          bubbles: !hasConsumerStoppedPropagationRef.current,
          name: name2,
          value,
          checked,
          required,
          disabled: disabled2,
          form,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Radio.displayName = RADIO_NAME;
var INDICATOR_NAME3 = "RadioIndicator";
var RadioIndicator = React121.forwardRef(
  (props, forwardedRef) => {
    const { __scopeRadio, forceMount, ...indicatorProps } = props;
    const context = useRadioContext(INDICATOR_NAME3, __scopeRadio);
    return /* @__PURE__ */ jsx46(Presence, { present: forceMount || context.checked, children: /* @__PURE__ */ jsx46(
      Primitive2.span,
      {
        "data-state": getState4(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...indicatorProps,
        ref: forwardedRef
      }
    ) });
  }
);
RadioIndicator.displayName = INDICATOR_NAME3;
var BUBBLE_INPUT_NAME2 = "RadioBubbleInput";
var RadioBubbleInput = React121.forwardRef(
  ({
    __scopeRadio,
    control,
    checked,
    bubbles = true,
    ...props
  }, forwardedRef) => {
    const ref = React121.useRef(null);
    const composedRefs = useComposedRefs(ref, forwardedRef);
    const prevChecked = usePrevious(checked);
    const controlSize = useSize(control);
    React121.useEffect(() => {
      const input = ref.current;
      if (!input) return;
      const inputProto = window.HTMLInputElement.prototype;
      const descriptor = Object.getOwnPropertyDescriptor(
        inputProto,
        "checked"
      );
      const setChecked = descriptor.set;
      if (prevChecked !== checked && setChecked) {
        const event = new Event("click", { bubbles });
        setChecked.call(input, checked);
        input.dispatchEvent(event);
      }
    }, [prevChecked, checked, bubbles]);
    return /* @__PURE__ */ jsx46(
      Primitive2.input,
      {
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
          ...props.style,
          ...controlSize,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
RadioBubbleInput.displayName = BUBBLE_INPUT_NAME2;
function getState4(checked) {
  return checked ? "checked" : "unchecked";
}
var ARROW_KEYS = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
var RADIO_GROUP_NAME3 = "RadioGroup";
var [createRadioGroupContext, createRadioGroupScope] = createContextScope(RADIO_GROUP_NAME3, [
  createRovingFocusGroupScope,
  createRadioScope
]);
var useRovingFocusGroupScope2 = createRovingFocusGroupScope();
var useRadioScope = createRadioScope();
var [RadioGroupProvider2, useRadioGroupContext2] = createRadioGroupContext(RADIO_GROUP_NAME3);
var RadioGroup3 = React212.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeRadioGroup,
      name: name2,
      defaultValue,
      value: valueProp,
      required = false,
      disabled: disabled2 = false,
      orientation,
      dir,
      loop = true,
      onValueChange,
      ...groupProps
    } = props;
    const rovingFocusGroupScope = useRovingFocusGroupScope2(__scopeRadioGroup);
    const direction = useDirection(dir);
    const [value, setValue] = useControllableState({
      prop: valueProp,
      defaultProp: defaultValue ?? null,
      onChange: onValueChange,
      caller: RADIO_GROUP_NAME3
    });
    return /* @__PURE__ */ jsx210(
      RadioGroupProvider2,
      {
        scope: __scopeRadioGroup,
        name: name2,
        required,
        disabled: disabled2,
        value,
        onValueChange: setValue,
        children: /* @__PURE__ */ jsx210(
          Root3,
          {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation,
            dir: direction,
            loop,
            children: /* @__PURE__ */ jsx210(
              Primitive2.div,
              {
                role: "radiogroup",
                "aria-required": required,
                "aria-orientation": orientation,
                "data-disabled": disabled2 ? "" : void 0,
                dir: direction,
                ...groupProps,
                ref: forwardedRef
              }
            )
          }
        )
      }
    );
  }
);
RadioGroup3.displayName = RADIO_GROUP_NAME3;
var ITEM_NAME5 = "RadioGroupItem";
var RadioGroupItem = React212.forwardRef(
  (props, forwardedRef) => {
    const { __scopeRadioGroup, disabled: disabled2, ...itemProps } = props;
    const context = useRadioGroupContext2(ITEM_NAME5, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled2;
    const rovingFocusGroupScope = useRovingFocusGroupScope2(__scopeRadioGroup);
    const radioScope = useRadioScope(__scopeRadioGroup);
    const ref = React212.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = React212.useRef(false);
    React212.useEffect(() => {
      const handleKeyDown = (event) => {
        if (ARROW_KEYS.includes(event.key)) {
          isArrowKeyPressedRef.current = true;
        }
      };
      const handleKeyUp = () => isArrowKeyPressedRef.current = false;
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("keyup", handleKeyUp);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
        document.removeEventListener("keyup", handleKeyUp);
      };
    }, []);
    return /* @__PURE__ */ jsx210(
      Item,
      {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !isDisabled,
        active: checked,
        children: /* @__PURE__ */ jsx210(
          Radio,
          {
            disabled: isDisabled,
            required: context.required,
            checked,
            ...radioScope,
            ...itemProps,
            name: context.name,
            ref: composedRefs,
            onCheck: () => context.onValueChange(itemProps.value),
            onKeyDown: composeEventHandlers((event) => {
              if (event.key === "Enter") event.preventDefault();
            }),
            onFocus: composeEventHandlers(itemProps.onFocus, () => {
              if (isArrowKeyPressedRef.current) ref.current?.click();
            })
          }
        )
      }
    );
  }
);
RadioGroupItem.displayName = ITEM_NAME5;
var INDICATOR_NAME22 = "RadioGroupIndicator";
var RadioGroupIndicator = React212.forwardRef(
  (props, forwardedRef) => {
    const { __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = useRadioScope(__scopeRadioGroup);
    return /* @__PURE__ */ jsx210(RadioIndicator, { ...radioScope, ...indicatorProps, ref: forwardedRef });
  }
);
RadioGroupIndicator.displayName = INDICATOR_NAME22;
var Root26 = RadioGroup3;
var Item24 = RadioGroupItem;
var Indicator = RadioGroupIndicator;

// src/components/primitive/RadioGroup/RadioGroup.tsx
import { jsx as jsx47, jsxs as jsxs24 } from "react/jsx-runtime";
function RadioGroup4({
  ref,
  className = "",
  ...rest
}) {
  const classes2 = ["buyscout-radio-group", className].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx47(Root26, { ref, className: classes2, ...rest });
}
RadioGroup4.displayName = "RadioGroup";
function RadioGroupItem2({
  ref,
  ...props
}) {
  const {
    size: size5 = "md",
    disabled: disabled2 = false,
    className = "",
    ...rest
  } = props;
  const classes2 = [
    "buyscout-radio-item",
    `buyscout-radio-item--size-${size5}`,
    disabled2 ? "buyscout-radio-item--disabled" : "",
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx47(Item24, { ref, className: classes2, disabled: disabled2, ...rest, children: /* @__PURE__ */ jsx47(Indicator, { className: "buyscout-radio-item__indicator" }) });
}
RadioGroupItem2.displayName = "RadioGroupItem";
function RadioCard(props) {
  const variant = props.variant ?? "card";
  const classes2 = ["buyscout-radio-card", `buyscout-radio-card--${variant}`, props.className].filter(Boolean).join(" ");
  if (props.variant === "swatch") {
    const { ref: ref2, variant: _variant2, swatch, className: _className2, style, ...rest2 } = props;
    return /* @__PURE__ */ jsx47(Item24, { ref: ref2, className: classes2, style: { ...style, backgroundColor: swatch }, ...rest2, children: /* @__PURE__ */ jsx47(MdCheck4, { "aria-hidden": true, className: "buyscout-radio-card__check" }) });
  }
  if (props.variant === "thumbnail") {
    const { ref: ref2, variant: _variant2, media, label, className: _className2, ...rest2 } = props;
    return /* @__PURE__ */ jsxs24(Item24, { ref: ref2, className: classes2, ...rest2, children: [
      /* @__PURE__ */ jsx47("span", { "aria-hidden": true, className: "buyscout-radio-card__media", children: media }),
      /* @__PURE__ */ jsx47("span", { className: "buyscout-radio-card__label", children: label })
    ] });
  }
  const { ref, variant: _variant, title, description, className: _className, ...rest } = props;
  return /* @__PURE__ */ jsxs24(Item24, { ref, className: classes2, ...rest, children: [
    /* @__PURE__ */ jsx47("span", { "aria-hidden": true, className: "buyscout-radio-card__control", children: /* @__PURE__ */ jsx47(Indicator, { className: "buyscout-radio-card__dot" }) }),
    /* @__PURE__ */ jsxs24("span", { className: "buyscout-radio-card__content", children: [
      /* @__PURE__ */ jsx47("span", { className: "buyscout-radio-card__title", children: title }),
      description && /* @__PURE__ */ jsx47("span", { className: "buyscout-radio-card__description", children: description })
    ] })
  ] });
}
RadioCard.displayName = "RadioCard";

// src/components/primitive/SegmentedControl/SegmentedControl.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
var segmentedControlVariants = cva("buyscout-segmented-control", {
  variants: {
    variant: {
      default: "",
      tinted: "buyscout-segmented-control--variant-tinted",
      glass: "buyscout-segmented-control--variant-glass",
      quiet: "buyscout-segmented-control--variant-quiet"
    },
    size: {
      sm: "buyscout-segmented-control--size-sm",
      md: "buyscout-segmented-control--size-md",
      lg: "buyscout-segmented-control--size-lg"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "md"
  }
});
var segmentedControlItemVariants = cva("buyscout-segmented-control__item");
function SegmentedControl({
  ref,
  variant,
  size: size5,
  className,
  ...rest
}) {
  return /* @__PURE__ */ jsx48(
    Root26,
    {
      ref,
      orientation: "horizontal",
      className: segmentedControlVariants({ variant, size: size5, className }),
      ...rest
    }
  );
}
SegmentedControl.displayName = "SegmentedControl";
function SegmentedControlItem({
  ref,
  className,
  children,
  ...rest
}) {
  return /* @__PURE__ */ jsx48(Item24, { ref, className: segmentedControlItemVariants({ className }), ...rest, children });
}
SegmentedControlItem.displayName = "SegmentedControlItem";

// src/components/primitive/SettingsGroup/SettingsGroup.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var cls8 = (...parts) => parts.filter(Boolean).join(" ");
var settingsGroupVariants = cva("buyscout-settings-group", {
  variants: {
    tone: {
      default: "",
      danger: "buyscout-settings-group--tone-danger"
    }
  },
  defaultVariants: {
    tone: "default"
  }
});
function SettingsGroup({ ref, tone, className, ...props }) {
  return /* @__PURE__ */ jsx49("section", { ref, className: settingsGroupVariants({ tone, className }), ...props });
}
SettingsGroup.displayName = "SettingsGroup";
function SettingsGroupHeader({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx49("div", { ref, className: cls8("buyscout-settings-group__header", className), ...props });
}
SettingsGroupHeader.displayName = "SettingsGroupHeader";
function SettingsGroupTitle({ ref, className, children, ...props }) {
  return /* @__PURE__ */ jsx49("h3", { ref, className: cls8("buyscout-settings-group__title", className), ...props, children });
}
SettingsGroupTitle.displayName = "SettingsGroupTitle";
function SettingsGroupDescription({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx49("p", { ref, className: cls8("buyscout-settings-group__description", className), ...props });
}
SettingsGroupDescription.displayName = "SettingsGroupDescription";
function SettingsGroupAction({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx49("div", { ref, className: cls8("buyscout-settings-group__action", className), ...props });
}
SettingsGroupAction.displayName = "SettingsGroupAction";
function SettingsList({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx49("div", { ref, className: cls8("buyscout-settings-list", className), ...props });
}
SettingsList.displayName = "SettingsList";
function SettingsRow({ ref, asChild = false, separator = true, className, ...props }) {
  const Comp = asChild ? Slot : "div";
  return /* @__PURE__ */ jsx49(Comp, { ref, className: cls8("buyscout-settings-row", className), "data-separator": separator, ...props });
}
SettingsRow.displayName = "SettingsRow";
function SettingsRowLeading({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx49("div", { ref, className: cls8("buyscout-settings-row__leading", className), ...props });
}
SettingsRowLeading.displayName = "SettingsRowLeading";
function SettingsRowContent({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx49("div", { ref, className: cls8("buyscout-settings-row__content", className), ...props });
}
SettingsRowContent.displayName = "SettingsRowContent";
function SettingsRowTitle({ className, ...props }) {
  return /* @__PURE__ */ jsx49(Text, { variant: "body", as: "div", className: cls8("buyscout-settings-row__title", className), ...props });
}
SettingsRowTitle.displayName = "SettingsRowTitle";
function SettingsRowDescription({ className, ...props }) {
  return /* @__PURE__ */ jsx49(Text, { variant: "caption", as: "div", className: cls8("buyscout-settings-row__description", className), ...props });
}
SettingsRowDescription.displayName = "SettingsRowDescription";
function SettingsRowTrailing({ ref, width = "default", className, ...props }) {
  return /* @__PURE__ */ jsx49("div", { ref, className: cls8("buyscout-settings-row__trailing", className), "data-width": width, ...props });
}
SettingsRowTrailing.displayName = "SettingsRowTrailing";

// src/components/primitive/Sheet/Sheet.tsx
import { jsx as jsx50, jsxs as jsxs25 } from "react/jsx-runtime";
var cx4 = (...parts) => parts.filter(Boolean).join(" ");
function Sheet(props) {
  return /* @__PURE__ */ jsx50(Root4, { ...props });
}
Sheet.displayName = "Sheet";
function SheetTrigger({ ref, ...props }) {
  return /* @__PURE__ */ jsx50(Trigger, { ref, ...props });
}
SheetTrigger.displayName = "SheetTrigger";
function SheetClose({ ref, ...props }) {
  return /* @__PURE__ */ jsx50(Close, { ref, ...props });
}
SheetClose.displayName = "SheetClose";
function SheetOverlay({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx50(Overlay, { ref, className: cx4("buyscout-sheet__overlay", className), ...props });
}
SheetOverlay.displayName = "SheetOverlay";
function SheetContent({
  ref,
  className,
  side = "end",
  container,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsxs25(Portal2, { container: container ?? void 0, children: [
    /* @__PURE__ */ jsx50(SheetOverlay, {}),
    /* @__PURE__ */ jsx50(
      Content,
      {
        ref,
        className: cx4("buyscout-sheet__content", `buyscout-sheet__content--${side}`, className),
        ...props,
        children
      }
    )
  ] });
}
SheetContent.displayName = "SheetContent";
function SheetTitle({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx50(Title, { ref, className: cx4("buyscout-sheet__title", className), ...props });
}
SheetTitle.displayName = "SheetTitle";
function SheetDescription({ ref, className, ...props }) {
  return /* @__PURE__ */ jsx50(Description, { ref, className: cx4("buyscout-sheet__description", className), ...props });
}
SheetDescription.displayName = "SheetDescription";

// src/components/primitive/Skeleton/Skeleton.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
var skeletonVariants = cva("buyscout-skeleton", {
  variants: {
    variant: {
      text: "buyscout-skeleton--text",
      rect: "buyscout-skeleton--rect",
      circle: "buyscout-skeleton--circle"
    },
    inline: {
      true: "buyscout-skeleton--inline",
      false: ""
    }
  },
  defaultVariants: {
    variant: "text",
    inline: false
  }
});
function Skeleton({
  ref,
  ...props
}) {
  const { variant, inline: inline4, width, height, className, style, ...rest } = props;
  useReportLoading();
  const sizeStyle = {
    ...width !== void 0 && { width },
    ...height !== void 0 && { height },
    ...style
  };
  return /* @__PURE__ */ jsx51(
    "span",
    {
      ref,
      className: skeletonVariants({ variant, inline: inline4, className }),
      style: sizeStyle,
      "aria-hidden": "true",
      ...rest
    }
  );
}
Skeleton.displayName = "Skeleton";

// src/components/primitive/Slider/Slider.tsx
import * as React123 from "react";

// ../../node_modules/.pnpm/@radix-ui+react-slider@1.3.6_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_bc6705c94abdae56af6b7d4e76cb8620/node_modules/@radix-ui/react-slider/dist/index.mjs
import * as React122 from "react";
import { jsx as jsx52, jsxs as jsxs26 } from "react/jsx-runtime";
var PAGE_KEYS = ["PageUp", "PageDown"];
var ARROW_KEYS2 = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
var BACK_KEYS = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
};
var SLIDER_NAME = "Slider";
var [Collection4, useCollection4, createCollectionScope4] = createCollection(SLIDER_NAME);
var [createSliderContext, createSliderScope] = createContextScope(SLIDER_NAME, [
  createCollectionScope4
]);
var [SliderProvider, useSliderContext] = createSliderContext(SLIDER_NAME);
var Slider = React122.forwardRef(
  (props, forwardedRef) => {
    const {
      name: name2,
      min: min2 = 0,
      max: max2 = 100,
      step = 1,
      orientation = "horizontal",
      disabled: disabled2 = false,
      minStepsBetweenThumbs = 0,
      defaultValue = [min2],
      value,
      onValueChange = () => {
      },
      onValueCommit = () => {
      },
      inverted = false,
      form,
      ...sliderProps
    } = props;
    const thumbRefs = React122.useRef(/* @__PURE__ */ new Set());
    const valueIndexToChangeRef = React122.useRef(0);
    const isHorizontal = orientation === "horizontal";
    const SliderOrientation = isHorizontal ? SliderHorizontal : SliderVertical;
    const [values = [], setValues] = useControllableState({
      prop: value,
      defaultProp: defaultValue,
      onChange: (value2) => {
        const thumbs = [...thumbRefs.current];
        thumbs[valueIndexToChangeRef.current]?.focus();
        onValueChange(value2);
      }
    });
    const valuesBeforeSlideStartRef = React122.useRef(values);
    function handleSlideStart(value2) {
      const closestIndex = getClosestValueIndex(values, value2);
      updateValues(value2, closestIndex);
    }
    function handleSlideMove(value2) {
      updateValues(value2, valueIndexToChangeRef.current);
    }
    function handleSlideEnd() {
      const prevValue = valuesBeforeSlideStartRef.current[valueIndexToChangeRef.current];
      const nextValue = values[valueIndexToChangeRef.current];
      const hasChanged = nextValue !== prevValue;
      if (hasChanged) onValueCommit(values);
    }
    function updateValues(value2, atIndex, { commit } = { commit: false }) {
      const decimalCount = getDecimalCount(step);
      const snapToStep2 = roundValue(Math.round((value2 - min2) / step) * step + min2, decimalCount);
      const nextValue = clamp(snapToStep2, [min2, max2]);
      setValues((prevValues = []) => {
        const nextValues = getNextSortedValues(prevValues, nextValue, atIndex);
        if (hasMinStepsBetweenValues(nextValues, minStepsBetweenThumbs * step)) {
          valueIndexToChangeRef.current = nextValues.indexOf(nextValue);
          const hasChanged = String(nextValues) !== String(prevValues);
          if (hasChanged && commit) onValueCommit(nextValues);
          return hasChanged ? nextValues : prevValues;
        } else {
          return prevValues;
        }
      });
    }
    return /* @__PURE__ */ jsx52(
      SliderProvider,
      {
        scope: props.__scopeSlider,
        name: name2,
        disabled: disabled2,
        min: min2,
        max: max2,
        valueIndexToChangeRef,
        thumbs: thumbRefs.current,
        values,
        orientation,
        form,
        children: /* @__PURE__ */ jsx52(Collection4.Provider, { scope: props.__scopeSlider, children: /* @__PURE__ */ jsx52(Collection4.Slot, { scope: props.__scopeSlider, children: /* @__PURE__ */ jsx52(
          SliderOrientation,
          {
            "aria-disabled": disabled2,
            "data-disabled": disabled2 ? "" : void 0,
            ...sliderProps,
            ref: forwardedRef,
            onPointerDown: composeEventHandlers(sliderProps.onPointerDown, () => {
              if (!disabled2) valuesBeforeSlideStartRef.current = values;
            }),
            min: min2,
            max: max2,
            inverted,
            onSlideStart: disabled2 ? void 0 : handleSlideStart,
            onSlideMove: disabled2 ? void 0 : handleSlideMove,
            onSlideEnd: disabled2 ? void 0 : handleSlideEnd,
            onHomeKeyDown: () => !disabled2 && updateValues(min2, 0, { commit: true }),
            onEndKeyDown: () => !disabled2 && updateValues(max2, values.length - 1, { commit: true }),
            onStepKeyDown: ({ event, direction: stepDirection }) => {
              if (!disabled2) {
                const isPageKey = PAGE_KEYS.includes(event.key);
                const isSkipKey = isPageKey || event.shiftKey && ARROW_KEYS2.includes(event.key);
                const multiplier = isSkipKey ? 10 : 1;
                const atIndex = valueIndexToChangeRef.current;
                const value2 = values[atIndex];
                const stepInDirection = step * multiplier * stepDirection;
                updateValues(value2 + stepInDirection, atIndex, { commit: true });
              }
            }
          }
        ) }) })
      }
    );
  }
);
Slider.displayName = SLIDER_NAME;
var [SliderOrientationProvider, useSliderOrientationContext] = createSliderContext(SLIDER_NAME, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
});
var SliderHorizontal = React122.forwardRef(
  (props, forwardedRef) => {
    const {
      min: min2,
      max: max2,
      dir,
      inverted,
      onSlideStart,
      onSlideMove,
      onSlideEnd,
      onStepKeyDown,
      ...sliderProps
    } = props;
    const [slider, setSlider] = React122.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setSlider(node));
    const rectRef = React122.useRef(void 0);
    const direction = useDirection(dir);
    const isDirectionLTR = direction === "ltr";
    const isSlidingFromLeft = isDirectionLTR && !inverted || !isDirectionLTR && inverted;
    function getValueFromPointer(pointerPosition) {
      const rect = rectRef.current || slider.getBoundingClientRect();
      const input = [0, rect.width];
      const output = isSlidingFromLeft ? [min2, max2] : [max2, min2];
      const value = linearScale(input, output);
      rectRef.current = rect;
      return value(pointerPosition - rect.left);
    }
    return /* @__PURE__ */ jsx52(
      SliderOrientationProvider,
      {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromLeft ? "left" : "right",
        endEdge: isSlidingFromLeft ? "right" : "left",
        direction: isSlidingFromLeft ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ jsx52(
          SliderImpl,
          {
            dir: direction,
            "data-orientation": "horizontal",
            ...sliderProps,
            ref: composedRefs,
            style: {
              ...sliderProps.style,
              ["--radix-slider-thumb-transform"]: "translateX(-50%)"
            },
            onSlideStart: (event) => {
              const value = getValueFromPointer(event.clientX);
              onSlideStart?.(value);
            },
            onSlideMove: (event) => {
              const value = getValueFromPointer(event.clientX);
              onSlideMove?.(value);
            },
            onSlideEnd: () => {
              rectRef.current = void 0;
              onSlideEnd?.();
            },
            onStepKeyDown: (event) => {
              const slideDirection = isSlidingFromLeft ? "from-left" : "from-right";
              const isBackKey = BACK_KEYS[slideDirection].includes(event.key);
              onStepKeyDown?.({ event, direction: isBackKey ? -1 : 1 });
            }
          }
        )
      }
    );
  }
);
var SliderVertical = React122.forwardRef(
  (props, forwardedRef) => {
    const {
      min: min2,
      max: max2,
      inverted,
      onSlideStart,
      onSlideMove,
      onSlideEnd,
      onStepKeyDown,
      ...sliderProps
    } = props;
    const sliderRef = React122.useRef(null);
    const ref = useComposedRefs(forwardedRef, sliderRef);
    const rectRef = React122.useRef(void 0);
    const isSlidingFromBottom = !inverted;
    function getValueFromPointer(pointerPosition) {
      const rect = rectRef.current || sliderRef.current.getBoundingClientRect();
      const input = [0, rect.height];
      const output = isSlidingFromBottom ? [max2, min2] : [min2, max2];
      const value = linearScale(input, output);
      rectRef.current = rect;
      return value(pointerPosition - rect.top);
    }
    return /* @__PURE__ */ jsx52(
      SliderOrientationProvider,
      {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromBottom ? "bottom" : "top",
        endEdge: isSlidingFromBottom ? "top" : "bottom",
        size: "height",
        direction: isSlidingFromBottom ? 1 : -1,
        children: /* @__PURE__ */ jsx52(
          SliderImpl,
          {
            "data-orientation": "vertical",
            ...sliderProps,
            ref,
            style: {
              ...sliderProps.style,
              ["--radix-slider-thumb-transform"]: "translateY(50%)"
            },
            onSlideStart: (event) => {
              const value = getValueFromPointer(event.clientY);
              onSlideStart?.(value);
            },
            onSlideMove: (event) => {
              const value = getValueFromPointer(event.clientY);
              onSlideMove?.(value);
            },
            onSlideEnd: () => {
              rectRef.current = void 0;
              onSlideEnd?.();
            },
            onStepKeyDown: (event) => {
              const slideDirection = isSlidingFromBottom ? "from-bottom" : "from-top";
              const isBackKey = BACK_KEYS[slideDirection].includes(event.key);
              onStepKeyDown?.({ event, direction: isBackKey ? -1 : 1 });
            }
          }
        )
      }
    );
  }
);
var SliderImpl = React122.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeSlider,
      onSlideStart,
      onSlideMove,
      onSlideEnd,
      onHomeKeyDown,
      onEndKeyDown,
      onStepKeyDown,
      ...sliderProps
    } = props;
    const context = useSliderContext(SLIDER_NAME, __scopeSlider);
    return /* @__PURE__ */ jsx52(
      Primitive2.span,
      {
        ...sliderProps,
        ref: forwardedRef,
        onKeyDown: composeEventHandlers(props.onKeyDown, (event) => {
          if (event.key === "Home") {
            onHomeKeyDown(event);
            event.preventDefault();
          } else if (event.key === "End") {
            onEndKeyDown(event);
            event.preventDefault();
          } else if (PAGE_KEYS.concat(ARROW_KEYS2).includes(event.key)) {
            onStepKeyDown(event);
            event.preventDefault();
          }
        }),
        onPointerDown: composeEventHandlers(props.onPointerDown, (event) => {
          const target = event.target;
          target.setPointerCapture(event.pointerId);
          event.preventDefault();
          if (context.thumbs.has(target)) {
            target.focus();
          } else {
            onSlideStart(event);
          }
        }),
        onPointerMove: composeEventHandlers(props.onPointerMove, (event) => {
          const target = event.target;
          if (target.hasPointerCapture(event.pointerId)) onSlideMove(event);
        }),
        onPointerUp: composeEventHandlers(props.onPointerUp, (event) => {
          const target = event.target;
          if (target.hasPointerCapture(event.pointerId)) {
            target.releasePointerCapture(event.pointerId);
            onSlideEnd(event);
          }
        })
      }
    );
  }
);
var TRACK_NAME = "SliderTrack";
var SliderTrack = React122.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSlider, ...trackProps } = props;
    const context = useSliderContext(TRACK_NAME, __scopeSlider);
    return /* @__PURE__ */ jsx52(
      Primitive2.span,
      {
        "data-disabled": context.disabled ? "" : void 0,
        "data-orientation": context.orientation,
        ...trackProps,
        ref: forwardedRef
      }
    );
  }
);
SliderTrack.displayName = TRACK_NAME;
var RANGE_NAME = "SliderRange";
var SliderRange = React122.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSlider, ...rangeProps } = props;
    const context = useSliderContext(RANGE_NAME, __scopeSlider);
    const orientation = useSliderOrientationContext(RANGE_NAME, __scopeSlider);
    const ref = React122.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    const valuesCount = context.values.length;
    const percentages = context.values.map(
      (value) => convertValueToPercentage(value, context.min, context.max)
    );
    const offsetStart = valuesCount > 1 ? Math.min(...percentages) : 0;
    const offsetEnd = 100 - Math.max(...percentages);
    return /* @__PURE__ */ jsx52(
      Primitive2.span,
      {
        "data-orientation": context.orientation,
        "data-disabled": context.disabled ? "" : void 0,
        ...rangeProps,
        ref: composedRefs,
        style: {
          ...props.style,
          [orientation.startEdge]: offsetStart + "%",
          [orientation.endEdge]: offsetEnd + "%"
        }
      }
    );
  }
);
SliderRange.displayName = RANGE_NAME;
var THUMB_NAME = "SliderThumb";
var SliderThumb = React122.forwardRef(
  (props, forwardedRef) => {
    const getItems = useCollection4(props.__scopeSlider);
    const [thumb, setThumb] = React122.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setThumb(node));
    const index2 = React122.useMemo(
      () => thumb ? getItems().findIndex((item) => item.ref.current === thumb) : -1,
      [getItems, thumb]
    );
    return /* @__PURE__ */ jsx52(SliderThumbImpl, { ...props, ref: composedRefs, index: index2 });
  }
);
var SliderThumbImpl = React122.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSlider, index: index2, name: name2, ...thumbProps } = props;
    const context = useSliderContext(THUMB_NAME, __scopeSlider);
    const orientation = useSliderOrientationContext(THUMB_NAME, __scopeSlider);
    const [thumb, setThumb] = React122.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setThumb(node));
    const isFormControl = thumb ? context.form || !!thumb.closest("form") : true;
    const size5 = useSize(thumb);
    const value = context.values[index2];
    const percent2 = value === void 0 ? 0 : convertValueToPercentage(value, context.min, context.max);
    const label = getLabel(index2, context.values.length);
    const orientationSize = size5?.[orientation.size];
    const thumbInBoundsOffset = orientationSize ? getThumbInBoundsOffset(orientationSize, percent2, orientation.direction) : 0;
    React122.useEffect(() => {
      if (thumb) {
        context.thumbs.add(thumb);
        return () => {
          context.thumbs.delete(thumb);
        };
      }
    }, [thumb, context.thumbs]);
    return /* @__PURE__ */ jsxs26(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [orientation.startEdge]: `calc(${percent2}% + ${thumbInBoundsOffset}px)`
        },
        children: [
          /* @__PURE__ */ jsx52(Collection4.ItemSlot, { scope: props.__scopeSlider, children: /* @__PURE__ */ jsx52(
            Primitive2.span,
            {
              role: "slider",
              "aria-label": props["aria-label"] || label,
              "aria-valuemin": context.min,
              "aria-valuenow": value,
              "aria-valuemax": context.max,
              "aria-orientation": context.orientation,
              "data-orientation": context.orientation,
              "data-disabled": context.disabled ? "" : void 0,
              tabIndex: context.disabled ? void 0 : 0,
              ...thumbProps,
              ref: composedRefs,
              style: value === void 0 ? { display: "none" } : props.style,
              onFocus: composeEventHandlers(props.onFocus, () => {
                context.valueIndexToChangeRef.current = index2;
              })
            }
          ) }),
          isFormControl && /* @__PURE__ */ jsx52(
            SliderBubbleInput,
            {
              name: name2 ?? (context.name ? context.name + (context.values.length > 1 ? "[]" : "") : void 0),
              form: context.form,
              value
            },
            index2
          )
        ]
      }
    );
  }
);
SliderThumb.displayName = THUMB_NAME;
var BUBBLE_INPUT_NAME3 = "RadioBubbleInput";
var SliderBubbleInput = React122.forwardRef(
  ({ __scopeSlider, value, ...props }, forwardedRef) => {
    const ref = React122.useRef(null);
    const composedRefs = useComposedRefs(ref, forwardedRef);
    const prevValue = usePrevious(value);
    React122.useEffect(() => {
      const input = ref.current;
      if (!input) return;
      const inputProto = window.HTMLInputElement.prototype;
      const descriptor = Object.getOwnPropertyDescriptor(inputProto, "value");
      const setValue = descriptor.set;
      if (prevValue !== value && setValue) {
        const event = new Event("input", { bubbles: true });
        setValue.call(input, value);
        input.dispatchEvent(event);
      }
    }, [prevValue, value]);
    return /* @__PURE__ */ jsx52(
      Primitive2.input,
      {
        style: { display: "none" },
        ...props,
        ref: composedRefs,
        defaultValue: value
      }
    );
  }
);
SliderBubbleInput.displayName = BUBBLE_INPUT_NAME3;
function getNextSortedValues(prevValues = [], nextValue, atIndex) {
  const nextValues = [...prevValues];
  nextValues[atIndex] = nextValue;
  return nextValues.sort((a, b) => a - b);
}
function convertValueToPercentage(value, min2, max2) {
  const maxSteps = max2 - min2;
  const percentPerStep = 100 / maxSteps;
  const percentage = percentPerStep * (value - min2);
  return clamp(percentage, [0, 100]);
}
function getLabel(index2, totalValues) {
  if (totalValues > 2) {
    return `Value ${index2 + 1} of ${totalValues}`;
  } else if (totalValues === 2) {
    return ["Minimum", "Maximum"][index2];
  } else {
    return void 0;
  }
}
function getClosestValueIndex(values, nextValue) {
  if (values.length === 1) return 0;
  const distances = values.map((value) => Math.abs(value - nextValue));
  const closestDistance = Math.min(...distances);
  return distances.indexOf(closestDistance);
}
function getThumbInBoundsOffset(width, left, direction) {
  const halfWidth = width / 2;
  const halfPercent = 50;
  const offset5 = linearScale([0, halfPercent], [0, halfWidth]);
  return (halfWidth - offset5(left) * direction) * direction;
}
function getStepsBetweenValues(values) {
  return values.slice(0, -1).map((value, index2) => values[index2 + 1] - value);
}
function hasMinStepsBetweenValues(values, minStepsBetweenValues) {
  if (minStepsBetweenValues > 0) {
    const stepsBetweenValues = getStepsBetweenValues(values);
    const actualMinStepsBetweenValues = Math.min(...stepsBetweenValues);
    return actualMinStepsBetweenValues >= minStepsBetweenValues;
  }
  return true;
}
function linearScale(input, output) {
  return (value) => {
    if (input[0] === input[1] || output[0] === output[1]) return output[0];
    const ratio = (output[1] - output[0]) / (input[1] - input[0]);
    return output[0] + ratio * (value - input[0]);
  };
}
function getDecimalCount(value) {
  return (String(value).split(".")[1] || "").length;
}
function roundValue(value, decimalCount) {
  const rounder = Math.pow(10, decimalCount);
  return Math.round(value * rounder) / rounder;
}
var Root8 = Slider;
var Track = SliderTrack;
var Range = SliderRange;
var Thumb = SliderThumb;

// src/components/primitive/Slider/Slider.tsx
import { jsx as jsx53, jsxs as jsxs27 } from "react/jsx-runtime";
var sameValues = (a, b) => a.length === b.length && a.every((value, index2) => value === b[index2]);
function Slider2({
  ref,
  ...props
}) {
  const {
    size: size5 = "md",
    disabled: disabled2 = false,
    className = "",
    value,
    defaultValue,
    min: min2 = 0,
    thumbAriaLabels,
    getAriaValueText,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    onValueChange,
    onValueCommit,
    onPointerDown,
    onPointerCancel,
    onKeyDown,
    onBlur,
    ...rest
  } = props;
  const { t } = useComponentsTranslation();
  const [pointerModality, setPointerModality] = React123.useState(false);
  const [uncontrolled, setUncontrolled] = React123.useState(defaultValue ?? [min2]);
  const values = value ?? uncontrolled;
  const valuesRef = React123.useRef(values);
  valuesRef.current = values;
  const dragRef = React123.useRef(null);
  const thumbCount = values.length;
  const rangeLabels = thumbCount === 2 ? [t("slider.minimum"), t("slider.maximum")] : void 0;
  const classes2 = [
    "buyscout-slider",
    `buyscout-slider--size-${size5}`,
    disabled2 ? "buyscout-slider--disabled" : "",
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs27(
    Root8,
    {
      ref,
      className: classes2,
      role: "group",
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      disabled: disabled2,
      value,
      defaultValue,
      min: min2,
      "data-pointer": pointerModality ? "" : void 0,
      onValueChange: (next) => {
        if (value === void 0) setUncontrolled(next);
        onValueChange?.(next);
      },
      onValueCommit: (next) => {
        if (dragRef.current) dragRef.current.committed = true;
        onValueCommit?.(next);
      },
      onPointerDown: (event) => {
        onPointerDown?.(event);
        dragRef.current = { start: valuesRef.current, committed: false };
        if (!event.defaultPrevented) setPointerModality(true);
      },
      onPointerCancel: (event) => {
        onPointerCancel?.(event);
        const drag2 = dragRef.current;
        dragRef.current = null;
        if (drag2 && !drag2.committed && !sameValues(drag2.start, valuesRef.current)) onValueCommit?.(valuesRef.current);
      },
      onKeyDown: (event) => {
        onKeyDown?.(event);
        setPointerModality(false);
      },
      onBlur: (event) => {
        onBlur?.(event);
        if (!event.currentTarget.contains(event.relatedTarget)) setPointerModality(false);
      },
      ...rest,
      children: [
        /* @__PURE__ */ jsx53(Track, { className: "buyscout-slider__track", children: /* @__PURE__ */ jsx53(Range, { className: "buyscout-slider__range" }) }),
        Array.from({ length: thumbCount }, (_, i) => {
          const explicit = thumbAriaLabels?.[i] ?? rangeLabels?.[i];
          return /* @__PURE__ */ jsx53(
            Thumb,
            {
              className: "buyscout-slider__thumb",
              "aria-label": explicit ?? ariaLabel,
              "aria-labelledby": explicit === void 0 ? ariaLabelledBy : void 0,
              "aria-valuetext": getAriaValueText && values[i] !== void 0 ? getAriaValueText(values[i], i) : void 0
            },
            i
          );
        })
      ]
    }
  );
}
Slider2.displayName = "Slider";

// src/components/primitive/StatusDot/StatusDot.tsx
import { jsx as jsx54, jsxs as jsxs28 } from "react/jsx-runtime";
var statusDotVariants = cva("buyscout-status-dot", {
  variants: {
    status: {
      live: "buyscout-status-dot--live",
      syncing: "buyscout-status-dot--syncing",
      off: "buyscout-status-dot--off",
      error: "buyscout-status-dot--error"
    }
  },
  defaultVariants: {
    status: "off"
  }
});
function StatusDot({ ref, status, className, children, ...props }) {
  return /* @__PURE__ */ jsxs28("span", { ref, className: statusDotVariants({ status, className }), ...props, children: [
    /* @__PURE__ */ jsx54("span", { "aria-hidden": true, className: "buyscout-status-dot__dot" }),
    children
  ] });
}
StatusDot.displayName = "StatusDot";

// ../../node_modules/.pnpm/@radix-ui+react-switch@1.2.6_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_7ca460f1f67ff8c5b086b59b47ac08b0/node_modules/@radix-ui/react-switch/dist/index.mjs
import * as React124 from "react";
import { jsx as jsx55, jsxs as jsxs29 } from "react/jsx-runtime";
var SWITCH_NAME = "Switch";
var [createSwitchContext, createSwitchScope] = createContextScope(SWITCH_NAME);
var [SwitchProvider, useSwitchContext] = createSwitchContext(SWITCH_NAME);
var Switch = React124.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeSwitch,
      name: name2,
      checked: checkedProp,
      defaultChecked,
      required,
      disabled: disabled2,
      value = "on",
      onCheckedChange,
      form,
      ...switchProps
    } = props;
    const [button, setButton] = React124.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setButton(node));
    const hasConsumerStoppedPropagationRef = React124.useRef(false);
    const isFormControl = button ? form || !!button.closest("form") : true;
    const [checked, setChecked] = useControllableState({
      prop: checkedProp,
      defaultProp: defaultChecked ?? false,
      onChange: onCheckedChange,
      caller: SWITCH_NAME
    });
    return /* @__PURE__ */ jsxs29(SwitchProvider, { scope: __scopeSwitch, checked, disabled: disabled2, children: [
      /* @__PURE__ */ jsx55(
        Primitive2.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": checked,
          "aria-required": required,
          "data-state": getState5(checked),
          "data-disabled": disabled2 ? "" : void 0,
          disabled: disabled2,
          value,
          ...switchProps,
          ref: composedRefs,
          onClick: composeEventHandlers(props.onClick, (event) => {
            setChecked((prevChecked) => !prevChecked);
            if (isFormControl) {
              hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
              if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
          })
        }
      ),
      isFormControl && /* @__PURE__ */ jsx55(
        SwitchBubbleInput,
        {
          control: button,
          bubbles: !hasConsumerStoppedPropagationRef.current,
          name: name2,
          value,
          checked,
          required,
          disabled: disabled2,
          form,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Switch.displayName = SWITCH_NAME;
var THUMB_NAME2 = "SwitchThumb";
var SwitchThumb = React124.forwardRef(
  (props, forwardedRef) => {
    const { __scopeSwitch, ...thumbProps } = props;
    const context = useSwitchContext(THUMB_NAME2, __scopeSwitch);
    return /* @__PURE__ */ jsx55(
      Primitive2.span,
      {
        "data-state": getState5(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
      }
    );
  }
);
SwitchThumb.displayName = THUMB_NAME2;
var BUBBLE_INPUT_NAME4 = "SwitchBubbleInput";
var SwitchBubbleInput = React124.forwardRef(
  ({
    __scopeSwitch,
    control,
    checked,
    bubbles = true,
    ...props
  }, forwardedRef) => {
    const ref = React124.useRef(null);
    const composedRefs = useComposedRefs(ref, forwardedRef);
    const prevChecked = usePrevious(checked);
    const controlSize = useSize(control);
    React124.useEffect(() => {
      const input = ref.current;
      if (!input) return;
      const inputProto = window.HTMLInputElement.prototype;
      const descriptor = Object.getOwnPropertyDescriptor(
        inputProto,
        "checked"
      );
      const setChecked = descriptor.set;
      if (prevChecked !== checked && setChecked) {
        const event = new Event("click", { bubbles });
        setChecked.call(input, checked);
        input.dispatchEvent(event);
      }
    }, [prevChecked, checked, bubbles]);
    return /* @__PURE__ */ jsx55(
      "input",
      {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked,
        ...props,
        tabIndex: -1,
        ref: composedRefs,
        style: {
          ...props.style,
          ...controlSize,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
SwitchBubbleInput.displayName = BUBBLE_INPUT_NAME4;
function getState5(checked) {
  return checked ? "checked" : "unchecked";
}
var Root9 = Switch;
var Thumb2 = SwitchThumb;

// src/components/primitive/Switch/Switch.tsx
import { jsx as jsx56 } from "react/jsx-runtime";
var switchVariants = cva("buyscout-switch", {
  variants: {
    size: { sm: "buyscout-switch--size-sm", md: "buyscout-switch--size-md", lg: "buyscout-switch--size-lg" },
    disabled: { true: "buyscout-switch--disabled" }
  }
});
function Switch2({
  ref,
  ...props
}) {
  const {
    size: size5 = "md",
    disabled: disabled2 = false,
    className = "",
    ...rest
  } = props;
  const classes2 = switchVariants({ size: size5, disabled: disabled2, className });
  return /* @__PURE__ */ jsx56(Root9, { ref, className: classes2, disabled: disabled2, ...rest, children: /* @__PURE__ */ jsx56(Thumb2, { className: "buyscout-switch__thumb" }) });
}
Switch2.displayName = "Switch";

// src/components/primitive/Toast/Toast.tsx
import * as React127 from "react";
import { useSyncExternalStore as useSyncExternalStore2 } from "react";
import { MdCheckCircle, MdClose as MdClose3, MdError, MdInfo, MdWarning } from "react-icons/md";

// ../../node_modules/.pnpm/@radix-ui+react-toast@1.2.17_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_e2c89a8b2101bf34d851118001d0f315/node_modules/@radix-ui/react-toast/dist/index.mjs
import * as React126 from "react";
import * as ReactDOM10 from "react-dom";

// ../../node_modules/.pnpm/@radix-ui+react-visually-hidden@1.2.6_@types+react-dom@19.2.3_@types+react@19.2.14__@ty_665fa0a3cb3246aed343ea5f7039280f/node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
import * as React125 from "react";
import { jsx as jsx57 } from "react/jsx-runtime";
var VISUALLY_HIDDEN_STYLES = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
});
var NAME2 = "VisuallyHidden";
var VisuallyHidden = React125.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ jsx57(
      Primitive.span,
      {
        ...props,
        ref: forwardedRef,
        style: { ...VISUALLY_HIDDEN_STYLES, ...props.style }
      }
    );
  }
);
VisuallyHidden.displayName = NAME2;

// ../../node_modules/.pnpm/@radix-ui+react-toast@1.2.17_@types+react-dom@19.2.3_@types+react@19.2.14__@types+react_e2c89a8b2101bf34d851118001d0f315/node_modules/@radix-ui/react-toast/dist/index.mjs
import { Fragment as Fragment13, jsx as jsx58, jsxs as jsxs30 } from "react/jsx-runtime";
var PROVIDER_NAME = "ToastProvider";
var [Collection5, useCollection5, createCollectionScope5] = createCollection2("Toast");
var [createToastContext, createToastScope] = createContextScope3("Toast", [createCollectionScope5]);
var [ToastProviderProvider, useToastProviderContext] = createToastContext(PROVIDER_NAME);
var ToastProvider = (props) => {
  const {
    __scopeToast,
    label = "Notification",
    duration = 5e3,
    swipeDirection = "right",
    swipeThreshold = 50,
    announcerContainer,
    children
  } = props;
  const [viewport, setViewport] = React126.useState(null);
  const [toastCount, setToastCount] = React126.useState(0);
  const isFocusedToastEscapeKeyDownRef = React126.useRef(false);
  const isClosePausedRef = React126.useRef(false);
  if (!label.trim()) {
    console.error(
      `Invalid prop \`label\` supplied to \`${PROVIDER_NAME}\`. Expected non-empty \`string\`.`
    );
  }
  return /* @__PURE__ */ jsx58(Collection5.Provider, { scope: __scopeToast, children: /* @__PURE__ */ jsx58(
    ToastProviderProvider,
    {
      scope: __scopeToast,
      label,
      duration,
      swipeDirection,
      swipeThreshold,
      toastCount,
      viewport,
      onViewportChange: setViewport,
      onToastAdd: React126.useCallback(() => setToastCount((prevCount) => prevCount + 1), []),
      onToastRemove: React126.useCallback(() => setToastCount((prevCount) => prevCount - 1), []),
      isFocusedToastEscapeKeyDownRef,
      isClosePausedRef,
      announcerContainer,
      children
    }
  ) });
};
ToastProvider.displayName = PROVIDER_NAME;
var VIEWPORT_NAME = "ToastViewport";
var VIEWPORT_DEFAULT_HOTKEY = ["F8"];
var VIEWPORT_PAUSE = "toast.viewportPause";
var VIEWPORT_RESUME = "toast.viewportResume";
var ToastViewport = React126.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeToast,
      hotkey = VIEWPORT_DEFAULT_HOTKEY,
      label = "Notifications ({hotkey})",
      ...viewportProps
    } = props;
    const context = useToastProviderContext(VIEWPORT_NAME, __scopeToast);
    const getItems = useCollection5(__scopeToast);
    const wrapperRef = React126.useRef(null);
    const headFocusProxyRef = React126.useRef(null);
    const tailFocusProxyRef = React126.useRef(null);
    const ref = React126.useRef(null);
    const composedRefs = useComposedRefs2(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    const hasToasts = context.toastCount > 0;
    React126.useEffect(() => {
      const handleKeyDown = (event) => {
        const isHotkeyPressed = hotkey.length !== 0 && hotkey.every((key) => event[key] || event.code === key);
        if (isHotkeyPressed) ref.current?.focus();
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    }, [hotkey]);
    React126.useEffect(() => {
      const wrapper = wrapperRef.current;
      const viewport = ref.current;
      if (hasToasts && wrapper && viewport) {
        const handlePause = () => {
          if (!context.isClosePausedRef.current) {
            const pauseEvent = new CustomEvent(VIEWPORT_PAUSE);
            viewport.dispatchEvent(pauseEvent);
            context.isClosePausedRef.current = true;
          }
        };
        const handleResume = () => {
          if (context.isClosePausedRef.current) {
            const resumeEvent = new CustomEvent(VIEWPORT_RESUME);
            viewport.dispatchEvent(resumeEvent);
            context.isClosePausedRef.current = false;
          }
        };
        const handleFocusOutResume = (event) => {
          const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
          if (isFocusMovingOutside) handleResume();
        };
        const handlePointerLeaveResume = () => {
          const isFocusInside = wrapper.contains(document.activeElement);
          if (!isFocusInside) handleResume();
        };
        wrapper.addEventListener("focusin", handlePause);
        wrapper.addEventListener("focusout", handleFocusOutResume);
        wrapper.addEventListener("pointermove", handlePause);
        wrapper.addEventListener("pointerleave", handlePointerLeaveResume);
        window.addEventListener("blur", handlePause);
        window.addEventListener("focus", handleResume);
        return () => {
          wrapper.removeEventListener("focusin", handlePause);
          wrapper.removeEventListener("focusout", handleFocusOutResume);
          wrapper.removeEventListener("pointermove", handlePause);
          wrapper.removeEventListener("pointerleave", handlePointerLeaveResume);
          window.removeEventListener("blur", handlePause);
          window.removeEventListener("focus", handleResume);
        };
      }
    }, [hasToasts, context.isClosePausedRef]);
    const getSortedTabbableCandidates = React126.useCallback(
      ({ tabbingDirection }) => {
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem) => {
          const toastNode = toastItem.ref.current;
          const toastTabbableCandidates = [toastNode, ...getTabbableCandidates2(toastNode)];
          return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
      },
      [getItems]
    );
    React126.useEffect(() => {
      const viewport = ref.current;
      if (viewport) {
        const handleKeyDown = (event) => {
          const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
          const isTabKey = event.key === "Tab" && !isMetaKey;
          if (isTabKey) {
            const focusedElement = document.activeElement;
            const isTabbingBackwards = event.shiftKey;
            const targetIsViewport = event.target === viewport;
            if (targetIsViewport && isTabbingBackwards) {
              headFocusProxyRef.current?.focus();
              return;
            }
            const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
            const sortedCandidates = getSortedTabbableCandidates({ tabbingDirection });
            const index2 = sortedCandidates.findIndex((candidate) => candidate === focusedElement);
            if (focusFirst4(sortedCandidates.slice(index2 + 1))) {
              event.preventDefault();
            } else {
              isTabbingBackwards ? headFocusProxyRef.current?.focus() : tailFocusProxyRef.current?.focus();
            }
          }
        };
        viewport.addEventListener("keydown", handleKeyDown);
        return () => viewport.removeEventListener("keydown", handleKeyDown);
      }
    }, [getItems, getSortedTabbableCandidates]);
    return /* @__PURE__ */ jsxs30(
      Branch,
      {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace("{hotkey}", hotkeyLabel),
        tabIndex: -1,
        style: { pointerEvents: hasToasts ? void 0 : "none" },
        children: [
          hasToasts && /* @__PURE__ */ jsx58(
            FocusProxy,
            {
              ref: headFocusProxyRef,
              onFocusFromOutsideViewport: () => {
                const tabbableCandidates = getSortedTabbableCandidates({
                  tabbingDirection: "forwards"
                });
                focusFirst4(tabbableCandidates);
              }
            }
          ),
          /* @__PURE__ */ jsx58(Collection5.Slot, { scope: __scopeToast, children: /* @__PURE__ */ jsx58(Primitive.ol, { tabIndex: -1, ...viewportProps, ref: composedRefs }) }),
          hasToasts && /* @__PURE__ */ jsx58(
            FocusProxy,
            {
              ref: tailFocusProxyRef,
              onFocusFromOutsideViewport: () => {
                const tabbableCandidates = getSortedTabbableCandidates({
                  tabbingDirection: "backwards"
                });
                focusFirst4(tabbableCandidates);
              }
            }
          )
        ]
      }
    );
  }
);
ToastViewport.displayName = VIEWPORT_NAME;
var FOCUS_PROXY_NAME = "ToastFocusProxy";
var FocusProxy = React126.forwardRef(
  (props, forwardedRef) => {
    const { __scopeToast, onFocusFromOutsideViewport, ...proxyProps } = props;
    const context = useToastProviderContext(FOCUS_PROXY_NAME, __scopeToast);
    return /* @__PURE__ */ jsx58(
      VisuallyHidden,
      {
        tabIndex: 0,
        ...proxyProps,
        ref: forwardedRef,
        style: { position: "fixed" },
        onFocus: (event) => {
          const prevFocusedElement = event.relatedTarget;
          const isFocusFromOutsideViewport = !context.viewport?.contains(prevFocusedElement);
          if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
      }
    );
  }
);
FocusProxy.displayName = FOCUS_PROXY_NAME;
var TOAST_NAME = "Toast";
var TOAST_SWIPE_START = "toast.swipeStart";
var TOAST_SWIPE_MOVE = "toast.swipeMove";
var TOAST_SWIPE_CANCEL = "toast.swipeCancel";
var TOAST_SWIPE_END = "toast.swipeEnd";
var Toast = React126.forwardRef(
  (props, forwardedRef) => {
    const { forceMount, open: openProp, defaultOpen, onOpenChange, ...toastProps } = props;
    const [open2, setOpen] = useControllableState2({
      prop: openProp,
      defaultProp: defaultOpen ?? true,
      onChange: onOpenChange,
      caller: TOAST_NAME
    });
    return /* @__PURE__ */ jsx58(Presence3, { present: forceMount || open2, children: /* @__PURE__ */ jsx58(
      ToastImpl,
      {
        open: open2,
        ...toastProps,
        ref: forwardedRef,
        onClose: () => setOpen(false),
        onPause: useCallbackRef(props.onPause),
        onResume: useCallbackRef(props.onResume),
        onSwipeStart: composeEventHandlers2(props.onSwipeStart, (event) => {
          event.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: composeEventHandlers2(props.onSwipeMove, (event) => {
          const { x, y } = event.detail.delta;
          event.currentTarget.setAttribute("data-swipe", "move");
          event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x}px`);
          event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y}px`);
        }),
        onSwipeCancel: composeEventHandlers2(props.onSwipeCancel, (event) => {
          event.currentTarget.setAttribute("data-swipe", "cancel");
          event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
          event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
          event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
          event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: composeEventHandlers2(props.onSwipeEnd, (event) => {
          const { x, y } = event.detail.delta;
          event.currentTarget.setAttribute("data-swipe", "end");
          event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
          event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
          event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x}px`);
          event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y}px`);
          setOpen(false);
        })
      }
    ) });
  }
);
Toast.displayName = TOAST_NAME;
var [ToastInteractiveProvider, useToastInteractiveContext] = createToastContext(TOAST_NAME, {
  onClose() {
  }
});
var ToastImpl = React126.forwardRef(
  (props, forwardedRef) => {
    const {
      __scopeToast,
      type = "foreground",
      duration: durationProp,
      open: open2,
      onClose,
      onEscapeKeyDown,
      onPause,
      onResume,
      onSwipeStart,
      onSwipeMove,
      onSwipeCancel,
      onSwipeEnd,
      ...toastProps
    } = props;
    const context = useToastProviderContext(TOAST_NAME, __scopeToast);
    const [node, setNode] = React126.useState(null);
    const composedRefs = useComposedRefs2(forwardedRef, (node2) => setNode(node2));
    const pointerStartRef = React126.useRef(null);
    const swipeDeltaRef = React126.useRef(null);
    const duration = durationProp || context.duration;
    const closeTimerStartTimeRef = React126.useRef(0);
    const closeTimerRemainingTimeRef = React126.useRef(duration);
    const closeTimerRef = React126.useRef(0);
    const { onToastAdd, onToastRemove } = context;
    const handleClose = useCallbackRef(() => {
      const isFocusInToast = node?.contains(document.activeElement);
      if (isFocusInToast) context.viewport?.focus();
      onClose();
    });
    const startTimer = React126.useCallback(
      (duration2) => {
        if (!duration2 || duration2 === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = (/* @__PURE__ */ new Date()).getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration2);
      },
      [handleClose]
    );
    React126.useEffect(() => {
      const viewport = context.viewport;
      if (viewport) {
        const handleResume = () => {
          startTimer(closeTimerRemainingTimeRef.current);
          onResume?.();
        };
        const handlePause = () => {
          const elapsedTime = (/* @__PURE__ */ new Date()).getTime() - closeTimerStartTimeRef.current;
          closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
          window.clearTimeout(closeTimerRef.current);
          onPause?.();
        };
        viewport.addEventListener(VIEWPORT_PAUSE, handlePause);
        viewport.addEventListener(VIEWPORT_RESUME, handleResume);
        return () => {
          viewport.removeEventListener(VIEWPORT_PAUSE, handlePause);
          viewport.removeEventListener(VIEWPORT_RESUME, handleResume);
        };
      }
    }, [context.viewport, duration, onPause, onResume, startTimer]);
    React126.useEffect(() => {
      if (open2 && !context.isClosePausedRef.current) startTimer(duration);
    }, [open2, duration, context.isClosePausedRef, startTimer]);
    React126.useEffect(() => {
      onToastAdd();
      return () => onToastRemove();
    }, [onToastAdd, onToastRemove]);
    const announceTextContent = React126.useMemo(() => {
      return node ? getAnnounceTextContent(node) : null;
    }, [node]);
    if (!context.viewport) return null;
    return /* @__PURE__ */ jsxs30(Fragment13, { children: [
      announceTextContent && /* @__PURE__ */ jsx58(
        ToastAnnounce,
        {
          __scopeToast,
          role: "status",
          "aria-live": type === "foreground" ? "assertive" : "polite",
          children: announceTextContent
        }
      ),
      /* @__PURE__ */ jsx58(ToastInteractiveProvider, { scope: __scopeToast, onClose: handleClose, children: ReactDOM10.createPortal(
        /* @__PURE__ */ jsx58(Collection5.ItemSlot, { scope: __scopeToast, children: /* @__PURE__ */ jsx58(
          Root,
          {
            asChild: true,
            onEscapeKeyDown: composeEventHandlers2(onEscapeKeyDown, () => {
              if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
              context.isFocusedToastEscapeKeyDownRef.current = false;
            }),
            children: /* @__PURE__ */ jsx58(
              Primitive.li,
              {
                tabIndex: 0,
                "data-state": open2 ? "open" : "closed",
                "data-swipe-direction": context.swipeDirection,
                ...toastProps,
                ref: composedRefs,
                style: { userSelect: "none", touchAction: "none", ...props.style },
                onKeyDown: composeEventHandlers2(props.onKeyDown, (event) => {
                  if (event.key !== "Escape") return;
                  onEscapeKeyDown?.(event.nativeEvent);
                  if (!event.nativeEvent.defaultPrevented) {
                    context.isFocusedToastEscapeKeyDownRef.current = true;
                    handleClose();
                  }
                }),
                onPointerDown: composeEventHandlers2(props.onPointerDown, (event) => {
                  if (event.button !== 0) return;
                  pointerStartRef.current = { x: event.clientX, y: event.clientY };
                }),
                onPointerMove: composeEventHandlers2(props.onPointerMove, (event) => {
                  if (!pointerStartRef.current) return;
                  const x = event.clientX - pointerStartRef.current.x;
                  const y = event.clientY - pointerStartRef.current.y;
                  const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
                  const isHorizontalSwipe = ["left", "right"].includes(context.swipeDirection);
                  const clamp4 = ["left", "up"].includes(context.swipeDirection) ? Math.min : Math.max;
                  const clampedX = isHorizontalSwipe ? clamp4(0, x) : 0;
                  const clampedY = !isHorizontalSwipe ? clamp4(0, y) : 0;
                  const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
                  const delta = { x: clampedX, y: clampedY };
                  const eventDetail = { originalEvent: event, delta };
                  if (hasSwipeMoveStarted) {
                    swipeDeltaRef.current = delta;
                    handleAndDispatchCustomEvent(TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                      discrete: false
                    });
                  } else if (isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                    swipeDeltaRef.current = delta;
                    handleAndDispatchCustomEvent(TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                      discrete: false
                    });
                    event.target.setPointerCapture(event.pointerId);
                  } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) {
                    pointerStartRef.current = null;
                  }
                }),
                onPointerUp: composeEventHandlers2(props.onPointerUp, (event) => {
                  const delta = swipeDeltaRef.current;
                  const target = event.target;
                  if (target.hasPointerCapture(event.pointerId)) {
                    target.releasePointerCapture(event.pointerId);
                  }
                  swipeDeltaRef.current = null;
                  pointerStartRef.current = null;
                  if (delta) {
                    const toast2 = event.currentTarget;
                    const eventDetail = { originalEvent: event, delta };
                    if (isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) {
                      handleAndDispatchCustomEvent(TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                        discrete: true
                      });
                    } else {
                      handleAndDispatchCustomEvent(
                        TOAST_SWIPE_CANCEL,
                        onSwipeCancel,
                        eventDetail,
                        {
                          discrete: true
                        }
                      );
                    }
                    toast2.addEventListener("click", (event2) => event2.preventDefault(), {
                      once: true
                    });
                  }
                })
              }
            )
          }
        ) }),
        context.viewport
      ) })
    ] });
  }
);
var ToastAnnounce = (props) => {
  const { __scopeToast, children, ...announceProps } = props;
  const context = useToastProviderContext(TOAST_NAME, __scopeToast);
  const [renderAnnounceText, setRenderAnnounceText] = React126.useState(false);
  const [isAnnounced, setIsAnnounced] = React126.useState(false);
  useNextFrame(() => setRenderAnnounceText(true));
  React126.useEffect(() => {
    const timer = window.setTimeout(() => setIsAnnounced(true), 1e3);
    return () => window.clearTimeout(timer);
  }, []);
  return isAnnounced ? null : /* @__PURE__ */ jsx58(Portal3, { asChild: true, container: context.announcerContainer || void 0, children: /* @__PURE__ */ jsx58(VisuallyHidden, { ...announceProps, children: renderAnnounceText && /* @__PURE__ */ jsxs30(Fragment13, { children: [
    context.label,
    " ",
    children
  ] }) }) });
};
var TITLE_NAME2 = "ToastTitle";
var ToastTitle = React126.forwardRef(
  (props, forwardedRef) => {
    const { __scopeToast, ...titleProps } = props;
    return /* @__PURE__ */ jsx58(Primitive.div, { ...titleProps, ref: forwardedRef });
  }
);
ToastTitle.displayName = TITLE_NAME2;
var DESCRIPTION_NAME2 = "ToastDescription";
var ToastDescription = React126.forwardRef(
  (props, forwardedRef) => {
    const { __scopeToast, ...descriptionProps } = props;
    return /* @__PURE__ */ jsx58(Primitive.div, { ...descriptionProps, ref: forwardedRef });
  }
);
ToastDescription.displayName = DESCRIPTION_NAME2;
var ACTION_NAME2 = "ToastAction";
var ToastAction = React126.forwardRef(
  (props, forwardedRef) => {
    const { altText, ...actionProps } = props;
    if (!altText.trim()) {
      console.error(
        `Invalid prop \`altText\` supplied to \`${ACTION_NAME2}\`. Expected non-empty \`string\`.`
      );
      return null;
    }
    return /* @__PURE__ */ jsx58(ToastAnnounceExclude, { altText, asChild: true, children: /* @__PURE__ */ jsx58(ToastClose, { ...actionProps, ref: forwardedRef }) });
  }
);
ToastAction.displayName = ACTION_NAME2;
var CLOSE_NAME = "ToastClose";
var ToastClose = React126.forwardRef(
  (props, forwardedRef) => {
    const { __scopeToast, ...closeProps } = props;
    const interactiveContext = useToastInteractiveContext(CLOSE_NAME, __scopeToast);
    return /* @__PURE__ */ jsx58(ToastAnnounceExclude, { asChild: true, children: /* @__PURE__ */ jsx58(
      Primitive.button,
      {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: composeEventHandlers2(props.onClick, interactiveContext.onClose)
      }
    ) });
  }
);
ToastClose.displayName = CLOSE_NAME;
var ToastAnnounceExclude = React126.forwardRef((props, forwardedRef) => {
  const { __scopeToast, altText, ...announceExcludeProps } = props;
  return /* @__PURE__ */ jsx58(
    Primitive.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": altText || void 0,
      ...announceExcludeProps,
      ref: forwardedRef
    }
  );
});
function getAnnounceTextContent(container) {
  const textContent = [];
  const childNodes = Array.from(container.childNodes);
  childNodes.forEach((node) => {
    if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
    if (isHTMLElement2(node)) {
      const isHidden2 = node.ariaHidden || node.hidden || node.style.display === "none";
      const isExcluded = node.dataset.radixToastAnnounceExclude === "";
      if (!isHidden2) {
        if (isExcluded) {
          const altText = node.dataset.radixToastAnnounceAlt;
          if (altText) textContent.push(altText);
        } else {
          textContent.push(...getAnnounceTextContent(node));
        }
      }
    }
  });
  return textContent;
}
function handleAndDispatchCustomEvent(name2, handler, detail, { discrete }) {
  const currentTarget = detail.originalEvent.currentTarget;
  const event = new CustomEvent(name2, { bubbles: true, cancelable: true, detail });
  if (handler) currentTarget.addEventListener(name2, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(currentTarget, event);
  } else {
    currentTarget.dispatchEvent(event);
  }
}
var isDeltaInDirection = (delta, direction, threshold = 0) => {
  const deltaX = Math.abs(delta.x);
  const deltaY = Math.abs(delta.y);
  const isDeltaX = deltaX > deltaY;
  if (direction === "left" || direction === "right") {
    return isDeltaX && deltaX > threshold;
  } else {
    return !isDeltaX && deltaY > threshold;
  }
};
function useNextFrame(callback = () => {
}) {
  const fn = useCallbackRef(callback);
  useLayoutEffect22(() => {
    let raf1 = 0;
    let raf2 = 0;
    raf1 = window.requestAnimationFrame(() => raf2 = window.requestAnimationFrame(fn));
    return () => {
      window.cancelAnimationFrame(raf1);
      window.cancelAnimationFrame(raf2);
    };
  }, [fn]);
}
function isHTMLElement2(node) {
  return node.nodeType === node.ELEMENT_NODE;
}
function getTabbableCandidates2(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode()) nodes.push(walker.currentNode);
  return nodes;
}
function focusFirst4(candidates) {
  const previouslyFocusedElement = document.activeElement;
  return candidates.some((candidate) => {
    if (candidate === previouslyFocusedElement) return true;
    candidate.focus();
    return document.activeElement !== previouslyFocusedElement;
  });
}
var Provider = ToastProvider;
var Viewport = ToastViewport;
var Root27 = Toast;
var Title3 = ToastTitle;
var Description3 = ToastDescription;
var Action2 = ToastAction;
var Close2 = ToastClose;

// src/utils/announce.ts
var ANNOUNCE_DELAY_MS = 100;
function createAnnouncerStore() {
  let message = "";
  let timer;
  const listeners2 = /* @__PURE__ */ new Set();
  const set = (next) => {
    message = next;
    for (const listener of listeners2) listener();
  };
  return {
    subscribe: (listener) => {
      listeners2.add(listener);
      return () => listeners2.delete(listener);
    },
    getMessage: () => message,
    announce: (next) => {
      clearTimeout(timer);
      set("");
      if (next) timer = setTimeout(set, ANNOUNCE_DELAY_MS, next);
    },
    clear: () => {
      clearTimeout(timer);
      set("");
    }
  };
}
var appAnnouncer = createAnnouncerStore();
var subscribeAnnouncement = appAnnouncer.subscribe;
var getAnnouncement = appAnnouncer.getMessage;
var announce = appAnnouncer.announce;

// src/components/primitive/Toast/toastStore.ts
var records = [];
var listeners = /* @__PURE__ */ new Set();
var nextId = 0;
function emit() {
  for (const listener of listeners) listener();
}
function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
function getToasts() {
  return records;
}
var MAX_OPEN = 5;
function show(type, message, options = {}) {
  const id = options.id ?? `toast-${++nextId}`;
  const existing = records.find((r) => r.id === id);
  const revision = !existing ? 0 : existing.type === "loading" && type !== "loading" ? existing.revision : existing.revision + 1;
  const record = { ...options, id, type, message, open: true, revision };
  records = existing ? records.map((r) => r.id === id ? record : r) : [...records, record];
  emit();
  if (existing?.type === "loading" && type !== "loading") announce([message, options.description].filter(Boolean).join(". "));
  const open2 = records.filter((r) => r.open);
  if (open2.length > MAX_OPEN) {
    const oldest = open2.find((r) => r.type !== "loading" && r.id !== id);
    if (oldest) dismiss(oldest.id);
  }
  return id;
}
var EXIT_MS = 400;
var pendingPromises = /* @__PURE__ */ new Map();
function dismiss(id) {
  const closing = records.filter((r) => id === void 0 || r.id === id).map((r) => r.id);
  for (const closingId of closing) {
    const pending = pendingPromises.get(closingId);
    if (pending) pending.dismissed = true;
  }
  records = records.map((r) => closing.includes(r.id) ? { ...r, open: false } : r);
  emit();
  setTimeout(() => {
    records = records.filter((r) => !(closing.includes(r.id) && !r.open));
    emit();
  }, EXIT_MS);
}
function promise(work, messages, options = {}) {
  const id = show("loading", messages.loading, options);
  const pending = { dismissed: false };
  pendingPromises.set(id, pending);
  const settle = (type, message) => {
    if (pendingPromises.get(id) === pending) pendingPromises.delete(id);
    if (!pending.dismissed) show(type, message, { ...options, id });
  };
  work.then(
    (value) => settle("success", typeof messages.success === "function" ? messages.success(value) : messages.success),
    (error2) => settle("error", typeof messages.error === "function" ? messages.error(error2) : messages.error)
  );
  return work;
}
var toast = Object.assign(
  (message, options) => show("info", message, options),
  {
    success: (message, options) => show("success", message, options),
    warning: (message, options) => show("warning", message, options),
    error: (message, options) => show("error", message, options),
    loading: (message, options) => show("loading", message, options),
    promise,
    dismiss
  }
);

// src/components/primitive/Toast/Toast.tsx
import { jsx as jsx59, jsxs as jsxs31 } from "react/jsx-runtime";
var DEFAULT_DURATION = 4e3;
var URGENT_DURATION_FACTOR = 1.5;
var VISIBLE_TOASTS = 3;
var ICONS = { info: MdInfo, success: MdCheckCircle, warning: MdWarning, error: MdError };
function ToastIcon({ type }) {
  if (type === "loading") return /* @__PURE__ */ jsx59(Spinner, { size: "sm", "aria-hidden": true, className: "buyscout-toast__icon buyscout-toast__icon--loading" });
  const Icon3 = ICONS[type];
  return /* @__PURE__ */ jsx59(Icon3, { "aria-hidden": true, className: `buyscout-toast__icon buyscout-toast__icon--${type}` });
}
function stackIndexes(records2) {
  const indexes = /* @__PURE__ */ new Map();
  let newer = 0;
  for (const record of [...records2].reverse()) {
    indexes.set(record.id, newer);
    if (record.open) newer++;
  }
  return indexes;
}
function naturalHeight(toast2) {
  const style = getComputedStyle(toast2);
  let tallest = 0;
  for (const child of Array.from(toast2.children)) {
    const childStyle = getComputedStyle(child);
    const height = child instanceof HTMLElement ? child.offsetHeight : Number.parseFloat(childStyle.height);
    tallest = Math.max(tallest, height + Number.parseFloat(childStyle.marginTop) + Number.parseFloat(childStyle.marginBottom));
  }
  return tallest + Number.parseFloat(style.paddingTop) + Number.parseFloat(style.paddingBottom) + Number.parseFloat(style.borderTopWidth) + Number.parseFloat(style.borderBottomWidth);
}
function layoutStack(viewport) {
  const gap = Number.parseFloat(getComputedStyle(viewport).rowGap) || 0;
  const open2 = Array.from(viewport.querySelectorAll(':scope > .buyscout-toast[data-state="open"]')).reverse();
  let offset5 = 0;
  let stackHeight = 0;
  open2.forEach((toast2, index2) => {
    const height = naturalHeight(toast2);
    toast2.style.setProperty("--buyscout-toast-height", `${height}px`);
    toast2.style.setProperty("--buyscout-toast-offset", `${offset5}px`);
    if (index2 === 0) viewport.style.setProperty("--buyscout-toast-front-height", `${height}px`);
    if (index2 < VISIBLE_TOASTS) stackHeight = offset5 + height;
    offset5 += height + gap;
  });
  viewport.style.setProperty("--buyscout-toast-stack-height", `${stackHeight}px`);
}
function useStackLayout(viewportRef) {
  React127.useLayoutEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport || typeof ResizeObserver === "undefined") return;
    const layout = () => layoutStack(viewport);
    const resizeObserver = new ResizeObserver(layout);
    const observeToasts = () => {
      resizeObserver.disconnect();
      for (const content of viewport.querySelectorAll(":scope > .buyscout-toast > .buyscout-toast__content")) resizeObserver.observe(content);
      layout();
    };
    const mutationObserver = new MutationObserver(observeToasts);
    mutationObserver.observe(viewport, { childList: true, subtree: true, attributes: true, attributeFilter: ["data-state"] });
    observeToasts();
    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, [viewportRef]);
}
var SWIPE_DIRECTIONS = {
  "bottom-right": "right",
  "top-right": "right",
  "bottom-center": "down",
  "top-center": "up"
};
function closeIfCurrent(record) {
  if (getToasts().some((r) => r.id === record.id && r.revision === record.revision)) dismiss(record.id);
}
function isUrgent(type) {
  return type === "error" || type === "warning";
}
var VIEWPORT_PAUSE2 = "toast.viewportPause";
var VIEWPORT_RESUME2 = "toast.viewportResume";
function useViewportPause(viewportRef) {
  React127.useEffect(() => {
    const viewport = viewportRef.current;
    if (!viewport) return;
    const pause = () => viewport.setAttribute("data-paused", "");
    const resume = () => viewport.removeAttribute("data-paused");
    viewport.addEventListener(VIEWPORT_PAUSE2, pause);
    viewport.addEventListener(VIEWPORT_RESUME2, resume);
    return () => {
      viewport.removeEventListener(VIEWPORT_PAUSE2, pause);
      viewport.removeEventListener(VIEWPORT_RESUME2, resume);
    };
  }, [viewportRef]);
}
function Toaster({ duration = DEFAULT_DURATION, position: position2 = "top-center", className }) {
  const { t } = useComponentsTranslation();
  const toasts = useSyncExternalStore2(subscribe, getToasts, getToasts);
  const viewportRef = React127.useRef(null);
  useStackLayout(viewportRef);
  useViewportPause(viewportRef);
  const indexes = stackIndexes(toasts);
  const lifetimeOf = (record) => record.type === "loading" ? Infinity : record.duration ?? (isUrgent(record.type) ? duration * URGENT_DURATION_FACTOR : duration);
  return /* @__PURE__ */ jsxs31(Provider, { swipeDirection: SWIPE_DIRECTIONS[position2], duration, label: t("toast.region"), children: [
    toasts.map((record) => {
      const lifetime = lifetimeOf(record);
      const countsDown = !!record.action && Number.isFinite(lifetime);
      return /* @__PURE__ */ jsxs31(
        Root27,
        {
          open: record.open,
          onOpenChange: (open2) => {
            if (!open2) closeIfCurrent(record);
          },
          duration: lifetime,
          type: isUrgent(record.type) ? "foreground" : "background",
          className: `buyscout-toast buyscout-toast--${record.type}`,
          "data-index": indexes.get(record.id),
          style: countsDown ? { "--buyscout-toast-lifetime": `${lifetime}ms` } : void 0,
          children: [
            /* @__PURE__ */ jsx59(ToastIcon, { type: record.type }),
            /* @__PURE__ */ jsxs31("div", { className: "buyscout-toast__content", children: [
              /* @__PURE__ */ jsx59(Title3, { className: "buyscout-toast__title", children: record.message }),
              record.description && /* @__PURE__ */ jsx59(Description3, { className: "buyscout-toast__description", children: record.description }),
              record.action && /* @__PURE__ */ jsx59("div", { className: "buyscout-toast__actions", children: /* @__PURE__ */ jsx59(Action2, { asChild: true, altText: record.action.label, children: /* @__PURE__ */ jsx59(Button, { variant: "bordered", color: "neutral", size: "xs", onClick: record.action.onClick, children: record.action.label }) }) })
            ] }),
            /* @__PURE__ */ jsx59(Close2, { className: "buyscout-toast__close", "aria-label": t("toast.dismiss"), children: /* @__PURE__ */ jsx59(MdClose3, { "aria-hidden": true }) }),
            countsDown && /* @__PURE__ */ jsx59("span", { className: "buyscout-toast__countdown", "aria-hidden": true })
          ]
        },
        `${record.id}:${record.revision}`
      );
    }),
    /* @__PURE__ */ jsx59(
      Viewport,
      {
        ref: viewportRef,
        className: ["buyscout-toast-viewport", `buyscout-toast-viewport--${position2}`, className].filter(Boolean).join(" "),
        label: t("toast.viewportLabel", { hotkey: "{hotkey}" })
      }
    )
  ] });
}
Toaster.displayName = "Toaster";

// src/components/composite/ChatControls/ChatInput/ChatInput.tsx
import { useEffect as useEffect37, useImperativeHandle as useImperativeHandle2, useRef as useRef59 } from "react";

// src/utils/shopifyImageSource.ts
var SHOPIFY_CDN_HOST = "cdn.shopify.com";
var STOREFRONT_CDN_PATH = "/cdn/shop/";
var PLACEHOLDER_ORIGIN = "https://placeholder.invalid";
var DENSITIES = [1, 2, 3];
function urlForm(url) {
  if (url.startsWith("//")) return "protocol-relative";
  return /^[a-z][a-z\d+.-]*:/i.test(url) ? "absolute" : "path";
}
function serialize(url, form) {
  if (form === "absolute") return url.href;
  if (form === "protocol-relative") return url.href.slice(url.protocol.length);
  return `${url.pathname}${url.search}${url.hash}`;
}
function shopifyImageSource(url, cssPx) {
  const form = urlForm(url);
  let parsed;
  try {
    parsed = new URL(url, PLACEHOLDER_ORIGIN);
  } catch {
    return { src: url };
  }
  const onShopifyCdn = form !== "path" && parsed.hostname === SHOPIFY_CDN_HOST;
  const onStorefrontCdn = (form !== "path" || url.startsWith("/")) && parsed.pathname.startsWith(STOREFRONT_CDN_PATH);
  const webScheme = parsed.protocol === "https:" || parsed.protocol === "http:";
  if (!webScheme || !(onShopifyCdn || onStorefrontCdn)) return { src: url };
  const atDensity = (density) => {
    const sized = new URL(parsed);
    sized.searchParams.set("width", String(Math.ceil(cssPx * density)));
    return serialize(sized, form);
  };
  return {
    src: atDensity(1),
    srcSet: DENSITIES.map((density) => `${atDensity(density)} ${density}x`).join(", ")
  };
}

// src/components/primitive/ImageFrame/imageFallback.ts
var SVG_NS = "http://www.w3.org/2000/svg";
function createImageFallbackElement(doc, className) {
  const wrap3 = doc.createElement("span");
  wrap3.className = className;
  wrap3.setAttribute("aria-hidden", "true");
  const svg3 = doc.createElementNS(SVG_NS, "svg");
  svg3.setAttribute("width", "20");
  svg3.setAttribute("height", "20");
  svg3.setAttribute("viewBox", "0 0 24 24");
  svg3.setAttribute("fill", "currentColor");
  const path2 = doc.createElementNS(SVG_NS, "path");
  path2.setAttribute("d", PRODUCT_BAG_FILLED_PATH);
  svg3.appendChild(path2);
  wrap3.appendChild(svg3);
  return wrap3;
}
function applyImageFallback(img, fallbackClassName) {
  img.draggable = false;
  img.addEventListener("error", () => {
    img.replaceWith(createImageFallbackElement(img.ownerDocument, fallbackClassName));
  }, { once: true });
}

// src/components/composite/Timeline/shared/mentionChipImage.ts
var MENTION_CHIP_IMAGE_PX = 20;

// src/components/composite/ChatControls/ChatInput/ChatInput.tsx
import { jsx as jsx60 } from "react/jsx-runtime";
var EMPTY_PRODUCTS = [];
function idMatches(cachedId, pastedId) {
  const c = String(cachedId);
  const p = String(pastedId);
  if (c === p) return true;
  const last = c.split("/").pop();
  return last === p;
}
function ChatInput({ ref, onEnterPress, onAtTrigger, placeholder, ariaLabel, disabled: disabled2 = false, products = EMPTY_PRODUCTS, knownProducts = EMPTY_PRODUCTS, className = "", autoFocus = false, onChange, value, maxLength, style, onFocus: onFocusCallback, onBlur: onBlurCallback, onProductNotFoundChange, onWordMatchTrigger, onWordMatchClose, onAtClose, ariaControls, ariaActiveDescendant, ariaDescribedBy }) {
  const { t } = useComponentsTranslation();
  const effectivePlaceholder = placeholder ?? t("chatInput.placeholder");
  const inputRef = useRef59(null);
  const mentionedProductsRef = useRef59([]);
  const savedRangeRef = useRef59(null);
  const savedCursorOffsetRef = useRef59(null);
  const skipNextSelectionSaveRef = useRef59(false);
  const isProgrammaticUpdateRef = useRef59(false);
  const persistedProductsRef = useRef59(/* @__PURE__ */ new Map());
  const isFocusedRef = useRef59(false);
  const saveLoopRafRef = useRef59(null);
  const savedTextLengthAtAtRef = useRef59(null);
  const isComposingRef = useRef59(false);
  const savedWordRangeRef = useRef59(null);
  const lastTriggeredWordRef = useRef59(null);
  const atTriggerTimeoutRef = useRef59(null);
  useEffect37(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);
  const getSelection = (el) => {
    const root3 = el.getRootNode();
    if (root3 instanceof ShadowRoot && typeof root3.getSelection === "function") {
      return root3.getSelection();
    }
    return el.ownerDocument.defaultView?.getSelection() || null;
  };
  useEffect37(() => {
    const onSelectionChange = () => {
      if (skipNextSelectionSaveRef.current) {
        skipNextSelectionSaveRef.current = false;
        return;
      }
      const el = inputRef.current;
      if (!el) return;
      const chips = Array.from(el.querySelectorAll(".product-mention-chip"));
      const sel = getSelection(el);
      if (!sel || sel.rangeCount === 0) {
        chips.forEach((c) => c.classList.remove("product-mention-chip--selected"));
        return;
      }
      const range = sel.getRangeAt(0);
      const anchorIn = sel.anchorNode != null && el.contains(sel.anchorNode);
      if (anchorIn) {
        savedRangeRef.current = range.cloneRange();
        savedCursorOffsetRef.current = getRangeCharIndex(el, range);
      }
      chips.forEach((chip) => {
        if (anchorIn && range.intersectsNode(chip)) {
          chip.classList.add("product-mention-chip--selected");
        } else {
          chip.classList.remove("product-mention-chip--selected");
        }
      });
    };
    document.addEventListener("selectionchange", onSelectionChange);
    return () => document.removeEventListener("selectionchange", onSelectionChange);
  }, []);
  const getMessageTextFromDom = () => {
    if (!inputRef.current) return "";
    let s = "";
    Array.from(inputRef.current.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        s += node.textContent || "";
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node;
        if (el.classList.contains("product-mention-chip")) {
          const title = el.getAttribute("data-product-title") ?? el.getAttribute("data-product-id") ?? "";
          if (title) s += `@[${title}]`;
        }
      }
    });
    return s;
  };
  const notifyProductNotFound = () => {
    if (!onProductNotFoundChange) return;
    const el = inputRef.current;
    if (!el) return;
    const has = el.querySelectorAll(".product-mention-chip--not-found").length > 0;
    onProductNotFoundChange(has);
  };
  const findRangeAtLastStandaloneAt = (el) => {
    const text4 = getMessageTextFromDom();
    let lastAtIndex = -1;
    for (let i = 0; i < text4.length; i++) {
      if (text4[i] === "@" && (i + 1 >= text4.length || text4[i + 1] !== "[")) lastAtIndex = i;
    }
    if (lastAtIndex < 0) return null;
    let charIndex = 0;
    for (const node of Array.from(el.childNodes)) {
      if (node.nodeType === Node.TEXT_NODE) {
        const len = (node.textContent || "").length;
        if (lastAtIndex >= charIndex && lastAtIndex < charIndex + len) {
          const range = document.createRange();
          const offsetInNode = lastAtIndex - charIndex;
          range.setStart(node, offsetInNode);
          range.setEnd(node, offsetInNode + 1);
          return range;
        }
        charIndex += len;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const sub = node;
        if (sub.classList.contains("product-mention-chip")) {
          charIndex += getChipSerializedLength(sub);
        }
      }
    }
    return null;
  };
  const expandRangeToMentionQuery = (el, range) => {
    const endNode = range.endContainer;
    if (endNode.nodeType !== Node.TEXT_NODE || !el.contains(endNode)) return;
    const textNode = endNode;
    const text4 = textNode.textContent || "";
    let endOffset = range.endOffset;
    while (endOffset < text4.length && text4[endOffset] !== " " && text4[endOffset] !== "\xA0") {
      endOffset += 1;
    }
    if (endOffset > range.endOffset) {
      range.setEnd(textNode, endOffset);
    }
  };
  const getRangeCharIndex = (el, range) => {
    let charIndex = 0;
    const startContainer = range.startContainer;
    for (const node of Array.from(el.childNodes)) {
      if (node === startContainer || node.nodeType === Node.ELEMENT_NODE && node.contains(startContainer)) {
        if (node.nodeType === Node.TEXT_NODE) return charIndex + range.startOffset;
        return charIndex + getChipSerializedLength(node);
      }
      if (node.nodeType === Node.TEXT_NODE) {
        charIndex += (node.textContent || "").length;
      } else if (node.classList?.contains("product-mention-chip")) {
        charIndex += getChipSerializedLength(node);
      }
    }
    return charIndex;
  };
  const getProductById = (id) => {
    const idStr = String(id);
    const fromProductsExact = products.find((p) => String(p.id) === idStr);
    if (fromProductsExact) return fromProductsExact;
    const fromProductsMatch = products.find((p) => idMatches(p.id, idStr));
    if (fromProductsMatch) return { ...fromProductsMatch, id: idStr };
    return persistedProductsRef.current.get(id);
  };
  const getProductByTitle = (title) => {
    const t2 = title.trim();
    if (!t2) return void 0;
    const all = [...products, ...knownProducts, ...persistedProductsRef.current.values()];
    return all.find((p) => p.title === t2) ?? all.find((p) => p.title.trim() === t2);
  };
  const getChipSerializedLength = (chipEl) => {
    const title = chipEl.getAttribute("data-product-title") ?? chipEl.getAttribute("data-product-id") ?? "";
    return title ? `@[${title}]`.length : 0;
  };
  const createRangeAtCharOffset = (el, targetCharIndex) => {
    const doc = el.ownerDocument;
    const range = doc.createRange();
    let charIndex = 0;
    for (const node of Array.from(el.childNodes)) {
      if (node.nodeType === Node.TEXT_NODE) {
        const len = (node.textContent || "").length;
        if (targetCharIndex >= charIndex && targetCharIndex <= charIndex + len) {
          const offsetInNode = targetCharIndex - charIndex;
          range.setStart(node, offsetInNode);
          range.setEnd(node, offsetInNode);
          return range;
        }
        charIndex += len;
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const sub = node;
        if (sub.classList.contains("product-mention-chip")) {
          const chipLen = getChipSerializedLength(sub);
          if (targetCharIndex >= charIndex && targetCharIndex <= charIndex + chipLen) {
            range.setStart(sub, 0);
            range.setEnd(sub, 0);
            return range;
          }
          charIndex += chipLen;
        }
      }
    }
    return null;
  };
  const applyValueToDom = (val) => {
    if (!inputRef.current) return;
    isProgrammaticUpdateRef.current = true;
    const regex = /@\[([^\]]+)\]/g;
    const parts = [];
    let lastIndex = 0;
    let m;
    while ((m = regex.exec(val)) !== null) {
      if (m.index > lastIndex) parts.push(val.slice(lastIndex, m.index));
      parts.push({ type: "chip", name: m[1] });
      lastIndex = m.index + m[0].length;
    }
    if (lastIndex < val.length) parts.push(val.slice(lastIndex));
    inputRef.current.innerHTML = "";
    parts.forEach((part) => {
      if (typeof part === "string") {
        inputRef.current.appendChild(document.createTextNode(part));
      } else {
        const product = getProductByTitle(part.name);
        if (product) {
          const chip = createChipElement(product, mentionedProductsRef.current.length);
          mentionedProductsRef.current.push(product);
          persistedProductsRef.current.set(product.id, product);
          inputRef.current.appendChild(chip);
        } else {
          inputRef.current.appendChild(document.createTextNode(`@[${part.name}]`));
        }
      }
    });
    isProgrammaticUpdateRef.current = false;
  };
  useEffect37(() => {
    if (value === void 0 || !inputRef.current) return;
    const currentText = getMessageTextFromDom();
    const willApply = currentText !== value;
    if (willApply) {
      if (/@\[[^\]]+\]/.test(value)) {
        mentionedProductsRef.current = [];
        applyValueToDom(value);
      } else {
        isProgrammaticUpdateRef.current = true;
        inputRef.current.textContent = value;
        isProgrammaticUpdateRef.current = false;
      }
    }
  }, [value, products, knownProducts]);
  const createChipElement = (product, index2) => {
    const chip = document.createElement("span");
    chip.className = "product-mention-chip size-input";
    chip.contentEditable = "false";
    chip.setAttribute("data-product-id", product.id);
    chip.setAttribute("data-product-title", product.title);
    chip.setAttribute("data-mention-index", String(index2));
    if (product.imageUrl) {
      const img = document.createElement("img");
      const { src, srcSet } = shopifyImageSource(product.imageUrl, MENTION_CHIP_IMAGE_PX);
      img.src = src;
      if (srcSet) img.srcset = srcSet;
      img.alt = product.title;
      img.className = "product-mention-chip-image";
      applyImageFallback(img, "product-mention-chip-icon");
      chip.appendChild(img);
    } else {
      chip.appendChild(createImageFallbackElement(document, "product-mention-chip-icon"));
    }
    const titleSpan = document.createElement("span");
    titleSpan.className = "product-mention-chip-title";
    titleSpan.textContent = product.title.length > 20 ? `${product.title.slice(0, 20)}\u2026` : product.title;
    titleSpan.setAttribute("title", product.title);
    chip.setAttribute("title", product.title);
    chip.appendChild(titleSpan);
    const deleteBtn = document.createElement("button");
    deleteBtn.type = "button";
    deleteBtn.className = "product-mention-chip-delete";
    deleteBtn.setAttribute("data-mention-index", String(index2));
    deleteBtn.setAttribute("aria-label", t("productMention.removeAria"));
    const svg3 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg3.setAttribute("viewBox", "0 0 24 24");
    svg3.setAttribute("fill", "currentColor");
    const path2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path2.setAttribute("d", "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z");
    svg3.appendChild(path2);
    deleteBtn.appendChild(svg3);
    chip.appendChild(deleteBtn);
    return chip;
  };
  const createNotFoundChipElement = (nameOrId, index2) => {
    const chip = document.createElement("span");
    chip.className = "product-mention-chip size-input product-mention-chip--not-found";
    chip.contentEditable = "false";
    chip.setAttribute("data-product-id", nameOrId);
    chip.setAttribute("data-product-title", t("chatInput.productNotFound"));
    chip.setAttribute("data-mention-index", String(index2));
    chip.setAttribute("title", t("chatInput.productNotFound"));
    chip.appendChild(createImageFallbackElement(document, "product-mention-chip-icon product-mention-chip-icon--not-found"));
    const titleSpan = document.createElement("span");
    titleSpan.className = "product-mention-chip-title";
    titleSpan.textContent = t("chatInput.productNotFound");
    titleSpan.setAttribute("title", t("chatInput.productNotFound"));
    chip.appendChild(titleSpan);
    const deleteBtn = document.createElement("button");
    deleteBtn.type = "button";
    deleteBtn.className = "product-mention-chip-delete";
    deleteBtn.setAttribute("data-mention-index", String(index2));
    deleteBtn.setAttribute("aria-label", t("productMention.removeAria"));
    const delSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    delSvg.setAttribute("viewBox", "0 0 24 24");
    delSvg.setAttribute("fill", "currentColor");
    const delPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    delPath.setAttribute("d", "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z");
    delSvg.appendChild(delPath);
    deleteBtn.appendChild(delSvg);
    chip.appendChild(deleteBtn);
    return chip;
  };
  const resolveTitleForCopy = (id) => getProductById(id)?.title;
  const serializeSelectionToPlainText = (fragment, resolveTitleFromId) => {
    const parts = [];
    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        parts.push(node.textContent || "");
        return;
      }
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node;
        if (el.classList.contains("product-mention-chip")) {
          let title = el.getAttribute("data-product-title")?.trim();
          if (!title) {
            const id = el.getAttribute("data-product-id");
            if (id && resolveTitleFromId) title = resolveTitleFromId(id) ?? "";
            if (!title && id) title = id;
            if (!title) {
              const titleEl = el.querySelector(".product-mention-chip-title");
              title = (titleEl?.textContent ?? "").trim() || (el.getAttribute("title") ?? "");
            }
          }
          parts.push(title ? `@[${title}]` : "");
          return;
        }
        el.childNodes.forEach(walk);
      }
    };
    fragment.childNodes.forEach(walk);
    return parts.join("");
  };
  const serializeSelectionToHtml = (fragment, resolveTitleFromId) => {
    const escape = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    const parts = [];
    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        parts.push(escape(node.textContent || ""));
        return;
      }
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node;
        if (el.classList.contains("product-mention-chip")) {
          const id = el.getAttribute("data-product-id") ?? "";
          let title = el.getAttribute("data-product-title")?.trim();
          if (!title && id && resolveTitleFromId) title = resolveTitleFromId(id) ?? "";
          if (!title) title = id;
          const titleEl = el.querySelector(".product-mention-chip-title");
          if (!title) title = (titleEl?.textContent ?? "").trim() || (el.getAttribute("title") ?? "");
          parts.push(id ? `<span data-product-id="${escape(id)}" data-product-title="${escape(title)}" data-copy-chip="1">@[${escape(title)}]</span>` : "");
          return;
        }
        el.childNodes.forEach(walk);
      }
    };
    fragment.childNodes.forEach(walk);
    return parts.join("");
  };
  const handleCopy = (e) => {
    const el = inputRef.current;
    if (!el) return;
    const sel2 = getSelection(el);
    if (!sel2 || sel2.rangeCount === 0) return;
    const range2 = sel2.getRangeAt(0);
    if (!el.contains(range2.commonAncestorContainer)) return;
    const fragment = range2.cloneContents();
    const plainText = serializeSelectionToPlainText(fragment, resolveTitleForCopy);
    const html4 = serializeSelectionToHtml(fragment, resolveTitleForCopy);
    e.clipboardData.setData("text/plain", plainText);
    e.clipboardData.setData("text/html", html4 ? `<div>${html4}</div>` : "");
    e.preventDefault();
    e.stopPropagation();
  };
  const handleCut = (e) => {
    const el = inputRef.current;
    if (!el) return;
    const sel = getSelection(el);
    if (!sel || sel.rangeCount === 0) return;
    const range = sel.getRangeAt(0);
    if (!el.contains(range.commonAncestorContainer)) return;
    const fragment = range.cloneContents();
    const plainText = serializeSelectionToPlainText(fragment, resolveTitleForCopy);
    const html4 = serializeSelectionToHtml(fragment, resolveTitleForCopy);
    e.clipboardData.setData("text/plain", plainText);
    e.clipboardData.setData("text/html", html4 ? `<div>${html4}</div>` : "");
    e.preventDefault();
    e.stopPropagation();
    isProgrammaticUpdateRef.current = true;
    range.deleteContents();
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
    isProgrammaticUpdateRef.current = false;
    normalizeIfVisuallyEmpty();
    const currentProducts = [];
    Array.from(el.querySelectorAll(".product-mention-chip")).forEach((chip) => {
      const productId = chip.getAttribute("data-product-id");
      if (productId) {
        const product = getProductById(productId);
        if (product) currentProducts.push(product);
      }
    });
    mentionedProductsRef.current = currentProducts;
    if (onChange) onChange(getMessageTextFromDom());
  };
  const parsePastedHtml = (html4) => {
    const doc = inputRef.current?.ownerDocument;
    if (!doc) return [];
    const div = doc.createElement("div");
    div.innerHTML = html4;
    const result = [];
    const walk = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const v = node.textContent || "";
        if (v) result.push({ type: "text", value: v });
        return;
      }
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node;
        const id = el.getAttribute("data-product-id");
        if (id != null && (el.hasAttribute("data-copy-chip") || el.classList.contains("product-mention-chip"))) {
          const title = el.getAttribute("data-product-title") || el.getAttribute("title") || el.textContent?.trim() || "";
          result.push({ type: "chip", id, title });
          return;
        }
        el.childNodes.forEach(walk);
      }
    };
    div.childNodes.forEach(walk);
    return result;
  };
  const parsePastedPlainText = (text4) => {
    const result = [];
    let pos = 0;
    while (pos < text4.length) {
      const atIdx = text4.indexOf("@", pos);
      if (atIdx < 0) {
        result.push({ type: "text", value: text4.slice(pos) });
        break;
      }
      if (atIdx > pos) result.push({ type: "text", value: text4.slice(pos, atIdx) });
      const afterAt = text4.slice(atIdx + 1);
      const bracketMatch = /^\[([^\]]+)\]/.exec(afterAt);
      if (bracketMatch) {
        const name2 = bracketMatch[1];
        const product2 = getProductByTitle(name2);
        if (product2) result.push({ type: "chip", product: product2 });
        else result.push({ type: "chip", title: name2 });
        pos = atIdx + 1 + bracketMatch[0].length;
        continue;
      }
      const titleEnd = afterAt.search(/@|\n|$/);
      const title = (titleEnd < 0 ? afterAt : afterAt.slice(0, titleEnd)).trim();
      const consumed = titleEnd < 0 ? afterAt.length : titleEnd;
      const product = title ? getProductByTitle(title) : void 0;
      if (product) result.push({ type: "chip", product });
      else result.push({ type: "text", value: text4.slice(atIdx, atIdx + 1 + consumed) });
      pos = atIdx + 1 + consumed;
    }
    return result;
  };
  const insertPastedContent = (items) => {
    const el = inputRef.current;
    if (!el) return;
    const sel = getSelection(el);
    if (!sel || sel.rangeCount === 0) return;
    const range = sel.getRangeAt(0);
    if (!el.contains(range.startContainer)) return;
    isProgrammaticUpdateRef.current = true;
    range.deleteContents();
    items.forEach((item) => {
      if (item.type === "text") {
        const node = el.ownerDocument.createTextNode(item.value);
        range.insertNode(node);
        range.setStartAfter(node);
        range.setEndAfter(node);
      } else {
        const product = "product" in item && item.product ? item.product : "title" in item && item.title ? getProductByTitle(item.title) : "id" in item && item.id ? getProductById(item.id) : void 0;
        if (product) {
          const chip = createChipElement(product, mentionedProductsRef.current.length);
          mentionedProductsRef.current.push(product);
          persistedProductsRef.current.set(product.id, product);
          range.insertNode(chip);
          range.setStartAfter(chip);
          range.setEndAfter(chip);
        } else if ("title" in item && item.title) {
          const node = el.ownerDocument.createTextNode(`@[${item.title}]`);
          range.insertNode(node);
          range.setStartAfter(node);
          range.setEndAfter(node);
        } else if ("id" in item && item.id) {
          const notFoundIndex = el.querySelectorAll(".product-mention-chip").length;
          const chip = createNotFoundChipElement(item.id, notFoundIndex);
          range.insertNode(chip);
          range.setStartAfter(chip);
          range.setEndAfter(chip);
        } else {
          const fallback = "title" in item && item.title ? `@[${item.title}]` : "";
          const node = el.ownerDocument.createTextNode(fallback);
          range.insertNode(node);
          range.setStartAfter(node);
          range.setEndAfter(node);
        }
      }
    });
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
    isProgrammaticUpdateRef.current = false;
    if (onChange) onChange(getMessageTextFromDom());
    notifyProductNotFound();
  };
  const handlePaste = (e) => {
    const html4 = e.clipboardData.getData("text/html");
    const text4 = e.clipboardData.getData("text/plain");
    e.preventDefault();
    if (html4 && (html4.includes("data-product-id") || html4.includes("data-copy-chip"))) {
      const items = parsePastedHtml(html4);
      if (items.length) {
        insertPastedContent(items);
        return;
      }
    }
    if (text4) {
      const items = parsePastedPlainText(text4);
      if (items.length) {
        insertPastedContent(items);
        return;
      }
    }
    if (text4) {
      insertPastedContent([{ type: "text", value: text4 }]);
    }
  };
  const getPlainTextContent = () => {
    if (!inputRef.current) return "";
    let text4 = "";
    Array.from(inputRef.current.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        text4 += node.textContent || "";
      }
    });
    return text4;
  };
  const getCurrentWordAtCursor = () => {
    const el = inputRef.current;
    if (!el) return null;
    const sel = getSelection(el);
    if (!sel || sel.rangeCount === 0) return null;
    const range = sel.getRangeAt(0);
    if (!range.collapsed || !el.contains(range.startContainer)) return null;
    const node = range.startContainer;
    if (node.nodeType !== Node.TEXT_NODE) return null;
    if (el.querySelector(".product-mention-chip")?.contains(node)) return null;
    const text4 = node.textContent || "";
    const offset5 = range.startOffset;
    let start = offset5;
    while (start > 0 && text4[start - 1] !== " " && text4[start - 1] !== "\xA0") start -= 1;
    let end = offset5;
    while (end < text4.length && text4[end] !== " " && text4[end] !== "\xA0") end += 1;
    const word = text4.slice(start, end);
    if (!word) return null;
    const wordRange = el.ownerDocument.createRange();
    wordRange.setStart(node, start);
    wordRange.setEnd(node, end);
    return { word, range: wordRange };
  };
  const normalizeIfVisuallyEmpty = () => {
    const el = inputRef.current;
    if (!el) return;
    if (el.childNodes.length === 0) return;
    if (getMessageTextFromDom().trim() !== "") return;
    isProgrammaticUpdateRef.current = true;
    el.innerHTML = "";
    isProgrammaticUpdateRef.current = false;
  };
  const isAtBeforeCaret = (el) => {
    const sel = getSelection(el);
    if (!sel || sel.rangeCount === 0) return false;
    const range = sel.getRangeAt(0);
    if (!range.collapsed || range.startContainer.nodeType !== Node.TEXT_NODE || !el.contains(range.startContainer)) return false;
    return (range.startContainer.textContent ?? "")[range.startOffset - 1] === "@";
  };
  const triggerAtMention = () => {
    if (atTriggerTimeoutRef.current != null) clearTimeout(atTriggerTimeoutRef.current);
    atTriggerTimeoutRef.current = setTimeout(() => {
      atTriggerTimeoutRef.current = null;
      const el = inputRef.current;
      if (!el || !isAtBeforeCaret(el)) return;
      savedTextLengthAtAtRef.current = getMessageTextFromDom().length;
      const selection = getSelection(el);
      if (selection && selection.rangeCount > 0) {
        savedRangeRef.current = selection.getRangeAt(0).cloneRange();
      }
      onAtTrigger?.();
    }, 0);
  };
  const handleCompositionEnd = (e) => {
    isComposingRef.current = false;
    const el = inputRef.current;
    if (el && e.data.endsWith("@") && isAtBeforeCaret(el)) {
      triggerAtMention();
    }
  };
  const handleInput = (e) => {
    if (!inputRef.current) return;
    if (isProgrammaticUpdateRef.current) return;
    normalizeIfVisuallyEmpty();
    const currentProducts = [];
    Array.from(inputRef.current.querySelectorAll(".product-mention-chip")).forEach((chip) => {
      const productId = chip.getAttribute("data-product-id");
      if (productId) {
        let product = products.find((p) => String(p.id) === String(productId));
        if (!product) {
          product = persistedProductsRef.current.get(productId);
        }
        if (product) {
          currentProducts.push(product);
        }
      }
    });
    mentionedProductsRef.current = currentProducts;
    if (maxLength) {
      const plainText = getPlainTextContent();
      if (plainText.length > maxLength) {
        const text4 = plainText.substring(0, maxLength);
        inputRef.current.textContent = text4;
        const el = inputRef.current;
        const range = el.ownerDocument.createRange();
        const selection = getSelection(el);
        range.selectNodeContents(el);
        range.collapse(false);
        selection?.removeAllRanges();
        selection?.addRange(range);
      }
    }
    if (onChange) {
      const messageText = getMessageTextFromDom();
      onChange(messageText);
    }
    notifyProductNotFound();
    saveCursorPosition();
    if (!isComposingRef.current && (onWordMatchTrigger || onWordMatchClose)) {
      const el = inputRef.current;
      const hasStandaloneAt = el ? findRangeAtLastStandaloneAt(el) != null : false;
      const current = getCurrentWordAtCursor();
      const word = current?.word ?? "";
      const isEnglishWord = word.length >= 3 && /^[a-z]+$/i.test(word);
      const matchesProduct = isEnglishWord && products.some(
        (p) => p.title.toLowerCase().includes(word.toLowerCase())
      );
      if (hasStandaloneAt) {
        if (lastTriggeredWordRef.current) {
          lastTriggeredWordRef.current = null;
          savedWordRangeRef.current = null;
          onWordMatchClose?.();
        }
      } else if (matchesProduct && current) {
        savedWordRangeRef.current = current.range.cloneRange();
        lastTriggeredWordRef.current = word;
        onWordMatchTrigger?.(word);
      } else if (lastTriggeredWordRef.current) {
        if (!current || current.word.length < 3 || current.word !== lastTriggeredWordRef.current || !products.some((p) => p.title.toLowerCase().includes(current.word.toLowerCase()))) {
          lastTriggeredWordRef.current = null;
          savedWordRangeRef.current = null;
          onWordMatchClose?.();
        } else {
          savedWordRangeRef.current = current.range.cloneRange();
        }
      }
    }
    if (onAtClose) {
      const text4 = getMessageTextFromDom();
      let lastAt = -1;
      for (let i = 0; i < text4.length; i++) {
        if (text4[i] === "@" && (i + 1 >= text4.length || text4[i + 1] !== "[")) lastAt = i;
      }
      if (lastAt < 0 || lastAt < text4.length - 1) {
        onAtClose();
      }
    }
    const { inputType } = e.nativeEvent;
    if (!isComposingRef.current && inputType === "insertText" && isAtBeforeCaret(inputRef.current)) {
      skipNextSelectionSaveRef.current = true;
      triggerAtMention();
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      if (isComposingRef.current || isImeComposing(e.nativeEvent)) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      if (onEnterPress) {
        const { message, mentionedProducts } = buildMessageData();
        if (message.trim()) {
          onEnterPress(message, mentionedProducts);
        }
      }
    }
  };
  const buildMessageData = () => {
    if (!inputRef.current) return { message: "", mentionedProducts: [] };
    let messageText = "";
    const mentionedProducts = [];
    Array.from(inputRef.current.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        messageText += node.textContent || "";
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const element2 = node;
        if (element2.classList.contains("product-mention-chip")) {
          const productId = element2.getAttribute("data-product-id");
          let product = products.find((p) => String(p.id) === String(productId));
          if (!product && productId) {
            product = persistedProductsRef.current.get(productId);
          }
          if (product) {
            messageText += `@[${product.title}]`;
            mentionedProducts.push(product);
          }
        }
      }
    });
    return { message: messageText, mentionedProducts };
  };
  const clearInput = () => {
    if (inputRef.current) {
      inputRef.current.innerHTML = "";
      mentionedProductsRef.current = [];
      persistedProductsRef.current.clear();
      onChange?.("");
      onProductNotFoundChange?.(false);
    }
  };
  const setCursorToEnd = () => {
    const el = inputRef.current;
    if (!el) return;
    const sel = getSelection(el);
    if (!sel) return;
    const range = el.ownerDocument.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
  };
  const focusAndSaveCursorAtEnd = () => {
    const el = inputRef.current;
    if (!el) return;
    const sel = getSelection(el);
    if (!sel) return;
    const textLen = getMessageTextFromDom().length;
    const savedOffset = savedCursorOffsetRef.current;
    if (savedOffset != null && savedOffset >= 0) {
      const offset5 = Math.min(savedOffset, textLen);
      const range2 = createRangeAtCharOffset(el, offset5);
      if (range2) {
        savedCursorOffsetRef.current = null;
        el.focus();
        sel.removeAllRanges();
        sel.addRange(range2);
        savedRangeRef.current = range2.cloneRange();
        return;
      }
    }
    const existing = savedRangeRef.current;
    if (existing) {
      const startIn = el.contains(existing.startContainer);
      const endIn = el.contains(existing.endContainer);
      if (startIn && endIn) {
        el.focus();
        sel.removeAllRanges();
        sel.addRange(existing);
        return;
      }
    }
    el.focus();
    const range = el.ownerDocument.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
    savedRangeRef.current = range.cloneRange();
  };
  const insertProduct = (product) => {
    if (!inputRef.current) return;
    isProgrammaticUpdateRef.current = true;
    const el = inputRef.current;
    let range = savedRangeRef.current;
    if (!range) {
      range = findRangeAtLastStandaloneAt(el);
    } else {
      const text4 = getMessageTextFromDom();
      const cursorCharIndex = getRangeCharIndex(el, range);
      if (cursorCharIndex === text4.length && text4.length > 0) {
        const atRange = findRangeAtLastStandaloneAt(el);
        if (atRange) range = atRange;
      }
    }
    if (range && range.collapsed && range.startContainer.nodeType === Node.TEXT_NODE) {
      const textNode = range.startContainer;
      const text4 = textNode.textContent || "";
      if (range.startOffset > 0 && text4[range.startOffset - 1] === "@") {
        range.setStart(textNode, range.startOffset - 1);
        range.setEnd(textNode, range.startOffset);
      } else if (text4[range.startOffset] === "@") {
        range.setEnd(textNode, range.startOffset + 1);
      }
    }
    const currentText = getMessageTextFromDom();
    if (range && el.contains(range.startContainer)) {
      expandRangeToMentionQuery(el, range);
    }
    const rangeStartCharAfter = range ? getRangeCharIndex(el, range) : null;
    let rangeEndCharAfter = null;
    if (range && !range.collapsed) {
      const r = range.cloneRange();
      r.collapse(false);
      rangeEndCharAfter = getRangeCharIndex(el, r);
    }
    const savedLen = savedTextLengthAtAtRef.current;
    if (range && rangeStartCharAfter != null && rangeEndCharAfter != null && savedLen != null) {
      const maxReplaceLen = currentText.length - savedLen + 1;
      const maxEndCharIndex = rangeStartCharAfter + maxReplaceLen;
      if (rangeEndCharAfter > maxEndCharIndex) {
        const capRange = createRangeAtCharOffset(el, maxEndCharIndex);
        if (capRange) {
          range.setEnd(capRange.startContainer, capRange.startOffset);
          rangeEndCharAfter = maxEndCharIndex;
        }
      }
    }
    const chip = createChipElement(product, mentionedProductsRef.current.length);
    if (range) {
      range.deleteContents();
      range.insertNode(chip);
      const spaceNode = document.createTextNode(" ");
      range.setStartAfter(chip);
      range.insertNode(spaceNode);
      range.setStartAfter(spaceNode);
      range.collapse(true);
      const selection = getSelection(el);
      selection?.removeAllRanges();
      selection?.addRange(range);
    } else {
      inputRef.current.appendChild(chip);
      inputRef.current.appendChild(document.createTextNode(" "));
    }
    mentionedProductsRef.current.push(product);
    persistedProductsRef.current.set(product.id, product);
    savedRangeRef.current = null;
    savedCursorOffsetRef.current = null;
    savedTextLengthAtAtRef.current = null;
    let serialized = getMessageTextFromDom();
    const mention = `@[${product.title}]`;
    const didApply = !serialized.includes(mention);
    if (didApply) {
      serialized = `${serialized.replace(/@\s*$/, "")}${mention} `;
      mentionedProductsRef.current = [];
      applyValueToDom(serialized);
      setCursorToEnd();
    }
    if (onChange) onChange(serialized);
    isProgrammaticUpdateRef.current = false;
    const didApplyDom = didApply;
    setTimeout(() => {
      inputRef.current?.focus();
      if (didApplyDom) setCursorToEnd();
      if (didApplyDom) {
        setTimeout(() => {
          inputRef.current?.focus();
          setCursorToEnd();
        }, 0);
      }
    }, 0);
  };
  const insertProductReplacingWord = (product) => {
    const el = inputRef.current;
    const range = savedWordRangeRef.current;
    if (!el || !range || !el.contains(range.startContainer)) return;
    isProgrammaticUpdateRef.current = true;
    const chip = createChipElement(product, mentionedProductsRef.current.length);
    range.deleteContents();
    range.insertNode(chip);
    const spaceNode = document.createTextNode(" ");
    range.setStartAfter(chip);
    range.insertNode(spaceNode);
    range.setStartAfter(spaceNode);
    range.collapse(true);
    const sel = getSelection(el);
    sel?.removeAllRanges();
    sel?.addRange(range);
    mentionedProductsRef.current.push(product);
    persistedProductsRef.current.set(product.id, product);
    savedWordRangeRef.current = null;
    lastTriggeredWordRef.current = null;
    if (onChange) onChange(getMessageTextFromDom());
    isProgrammaticUpdateRef.current = false;
    el.focus();
    setTimeout(() => {
      if (!el || !spaceNode.parentNode) return;
      const r = el.ownerDocument.createRange();
      r.setStartAfter(spaceNode);
      r.collapse(true);
      const s = getSelection(el);
      s?.removeAllRanges();
      s?.addRange(r);
      el.focus();
    }, 0);
  };
  useEffect37(() => {
    const handleDelete = (e) => {
      const target = e.target;
      const deleteBtn = target.closest(".product-mention-chip-delete");
      if (deleteBtn) {
        const chip = deleteBtn.closest(".product-mention-chip");
        if (chip) {
          chip.remove();
          const productId = chip.getAttribute("data-product-id");
          if (productId) {
            mentionedProductsRef.current = mentionedProductsRef.current.filter(
              (p) => p.id !== productId
            );
          }
          normalizeIfVisuallyEmpty();
          if (onChange && inputRef.current) {
            onChange(getMessageTextFromDom());
          }
          inputRef.current?.focus();
        }
      }
    };
    const currentInput = inputRef.current;
    currentInput?.addEventListener("click", handleDelete);
    return () => currentInput?.removeEventListener("click", handleDelete);
  }, [onChange]);
  const isSelectionInInput = (el, sel) => {
    if (sel.rangeCount === 0) return false;
    const range = sel.getRangeAt(0);
    const anchorIn = sel.anchorNode != null && el.contains(sel.anchorNode);
    const focusIn = sel.focusNode != null && el.contains(sel.focusNode);
    const startIn = el.contains(range.startContainer);
    const endIn = el.contains(range.endContainer);
    return anchorIn || focusIn || startIn || endIn;
  };
  const saveCursorPosition = () => {
    const el = inputRef.current;
    if (!el) return;
    const sel = getSelection(el);
    if (!sel || sel.rangeCount === 0) return;
    if (isSelectionInInput(el, sel)) {
      const range = sel.getRangeAt(0);
      savedRangeRef.current = range.cloneRange();
      savedCursorOffsetRef.current = getRangeCharIndex(el, range);
    }
  };
  const startSaveLoop = () => {
    const loop = () => {
      saveCursorPosition();
      if (isFocusedRef.current && inputRef.current === document.activeElement) {
        saveLoopRafRef.current = requestAnimationFrame(loop);
      }
    };
    saveLoopRafRef.current = requestAnimationFrame(loop);
  };
  const handleFocus = () => {
    isFocusedRef.current = true;
    saveCursorPosition();
    startSaveLoop();
    onFocusCallback?.();
  };
  const handleBlur = () => {
    isFocusedRef.current = false;
    normalizeIfVisuallyEmpty();
    onBlurCallback?.();
  };
  useEffect37(() => {
    return () => {
      if (saveLoopRafRef.current != null) {
        cancelAnimationFrame(saveLoopRafRef.current);
        saveLoopRafRef.current = null;
      }
      if (atTriggerTimeoutRef.current != null) {
        clearTimeout(atTriggerTimeoutRef.current);
        atTriggerTimeoutRef.current = null;
      }
    };
  }, []);
  useEffect37(() => {
    const onDocMouseDown = (e) => {
      const el = inputRef.current;
      if (!el) return;
      const clickedInsideEl = el.contains(e.target);
      const root3 = el.getRootNode();
      const targetIsOurShadowHost = root3 instanceof ShadowRoot && root3.host === e.target;
      const targetInside = clickedInsideEl || targetIsOurShadowHost;
      if (targetInside) {
        requestAnimationFrame(() => saveCursorPosition());
      } else {
        const sel = getSelection(el);
        const rangeCount = sel?.rangeCount ?? 0;
        let rangeInInput = false;
        if (sel && rangeCount > 0) {
          rangeInInput = sel.anchorNode != null && el.contains(sel.anchorNode);
          if (rangeInInput) {
            savedRangeRef.current = sel.getRangeAt(0).cloneRange();
          }
        }
      }
    };
    document.addEventListener("mousedown", onDocMouseDown, true);
    return () => document.removeEventListener("mousedown", onDocMouseDown, true);
  }, []);
  const getCaretRect = (charOffset = 0) => {
    const el = inputRef.current;
    if (!el) return null;
    const sel = getSelection(el);
    const range = sel && isSelectionInInput(el, sel) ? sel.getRangeAt(0).cloneRange() : savedRangeRef.current?.cloneRange();
    if (!range || !el.contains(range.startContainer)) return null;
    range.collapse(true);
    if (charOffset < 0 && range.startContainer.nodeType === Node.TEXT_NODE) {
      range.setStart(range.startContainer, Math.max(0, range.startOffset + charOffset));
      range.collapse(true);
    }
    const rect = range.getBoundingClientRect();
    if (rect.top === 0 && rect.left === 0 && rect.height === 0) {
      return el.getBoundingClientRect();
    }
    return rect;
  };
  useImperativeHandle2(ref, () => ({
    insertProduct,
    insertProductReplacingWord,
    saveCursorPosition,
    focusAndSaveCursorAtEnd,
    clear: clearInput,
    focus: () => {
      const el = inputRef.current;
      if (!el) return;
      el.focus();
      setCursorToEnd();
    },
    getText: () => buildMessageData().message,
    getMentionedProducts: () => buildMessageData().mentionedProducts,
    getCaretRect
  }));
  return /* @__PURE__ */ jsx60(
    "div",
    {
      ref: inputRef,
      role: "textbox",
      "aria-multiline": "true",
      dir: "auto",
      "aria-label": ariaLabel || effectivePlaceholder || t("chatInput.placeholder"),
      "aria-controls": ariaControls,
      "aria-activedescendant": ariaActiveDescendant,
      "aria-describedby": ariaDescribedBy,
      "aria-disabled": disabled2 || void 0,
      tabIndex: disabled2 ? -1 : 0,
      className: `chat-input-bare ${disabled2 ? "disabled" : ""} ${className}`,
      contentEditable: !disabled2,
      onInput: handleInput,
      onKeyDown: handleKeyDown,
      onCopy: handleCopy,
      onCut: handleCut,
      onPaste: handlePaste,
      onCompositionStart: () => {
        isComposingRef.current = true;
      },
      onCompositionEnd: handleCompositionEnd,
      onClick: () => saveCursorPosition(),
      onFocus: handleFocus,
      onBlur: handleBlur,
      "data-placeholder": effectivePlaceholder,
      style,
      suppressContentEditableWarning: true
    }
  );
}
ChatInput.displayName = "ChatInput";

// src/components/composite/ChatControls/EditBanner/EditBanner.tsx
import { MdClose as MdClose4, MdEdit } from "react-icons/md";
import { jsx as jsx61, jsxs as jsxs32 } from "react/jsx-runtime";
function EditBanner(props) {
  const { t } = useComponentsTranslation();
  const { onClose, className = "", labelId } = props;
  return /* @__PURE__ */ jsxs32("div", { className: `buyscout-edit-banner ${className}`, children: [
    /* @__PURE__ */ jsxs32(Text, { variant: "body-bold", as: "span", id: labelId, className: "buyscout-edit-banner__label", children: [
      /* @__PURE__ */ jsx61(MdEdit, { className: "buyscout-edit-banner__icon", "aria-hidden": true }),
      t("editBanner.label")
    ] }),
    /* @__PURE__ */ jsx61(
      Button,
      {
        variant: "borderless",
        color: "neutral",
        type: "button",
        size: "sm",
        iconOnly: true,
        onClick: onClose,
        className: "buyscout-edit-banner__close",
        "aria-label": t("editBanner.exitAria"),
        children: /* @__PURE__ */ jsx61(MdClose4, { "aria-hidden": true })
      }
    )
  ] });
}
EditBanner.displayName = "EditBanner";

// src/components/composite/ChatControls/PopupMessage/PopupMessage.tsx
import { useCallback as useCallback24, useEffect as useEffect43, useRef as useRef65, useState as useState52 } from "react";

// src/components/composite/ChatMarkdown/ChatMarkdown.tsx
import * as React132 from "react";

// ../../node_modules/.pnpm/comma-separated-tokens@2.0.3/node_modules/comma-separated-tokens/index.js
function stringify(values, options) {
  const settings = options || {};
  const input = values[values.length - 1] === "" ? [...values, ""] : values;
  return input.join(
    (settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")
  ).trim();
}

// ../../node_modules/.pnpm/hast-util-whitespace@3.0.0/node_modules/hast-util-whitespace/lib/index.js
var re = /[ \t\n\f\r]/g;
function whitespace(thing) {
  return typeof thing === "object" ? thing.type === "text" ? empty(thing.value) : false : empty(thing);
}
function empty(value) {
  return value.replace(re, "") === "";
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/util/schema.js
var Schema = class {
  /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */
  constructor(property, normal, space2) {
    this.normal = normal;
    this.property = property;
    if (space2) {
      this.space = space2;
    }
  }
};
Schema.prototype.normal = {};
Schema.prototype.property = {};
Schema.prototype.space = void 0;

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/util/merge.js
function merge(definitions, space2) {
  const property = {};
  const normal = {};
  for (const definition of definitions) {
    Object.assign(property, definition.property);
    Object.assign(normal, definition.normal);
  }
  return new Schema(property, normal, space2);
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/normalize.js
function normalize(value) {
  return value.toLowerCase();
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/util/info.js
var Info = class {
  /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */
  constructor(property, attribute) {
    this.attribute = attribute;
    this.property = property;
  }
};
Info.prototype.attribute = "";
Info.prototype.booleanish = false;
Info.prototype.boolean = false;
Info.prototype.commaOrSpaceSeparated = false;
Info.prototype.commaSeparated = false;
Info.prototype.defined = false;
Info.prototype.mustUseProperty = false;
Info.prototype.number = false;
Info.prototype.overloadedBoolean = false;
Info.prototype.property = "";
Info.prototype.spaceSeparated = false;
Info.prototype.space = void 0;

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/util/types.js
var types_exports = {};
__export(types_exports, {
  boolean: () => boolean,
  booleanish: () => booleanish,
  commaOrSpaceSeparated: () => commaOrSpaceSeparated,
  commaSeparated: () => commaSeparated,
  number: () => number,
  overloadedBoolean: () => overloadedBoolean,
  spaceSeparated: () => spaceSeparated
});
var powers = 0;
var boolean = increment();
var booleanish = increment();
var overloadedBoolean = increment();
var number = increment();
var spaceSeparated = increment();
var commaSeparated = increment();
var commaOrSpaceSeparated = increment();
function increment() {
  return 2 ** ++powers;
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/util/defined-info.js
var checks = (
  /** @type {ReadonlyArray<keyof typeof types>} */
  Object.keys(types_exports)
);
var DefinedInfo = class extends Info {
  /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */
  constructor(property, attribute, mask, space2) {
    let index2 = -1;
    super(property, attribute);
    mark(this, "space", space2);
    if (typeof mask === "number") {
      while (++index2 < checks.length) {
        const check = checks[index2];
        mark(this, checks[index2], (mask & types_exports[check]) === types_exports[check]);
      }
    }
  }
};
DefinedInfo.prototype.defined = true;
function mark(values, key, value) {
  if (value) {
    values[key] = value;
  }
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/util/create.js
function create(definition) {
  const properties = {};
  const normals = {};
  for (const [property, value] of Object.entries(definition.properties)) {
    const info = new DefinedInfo(
      property,
      definition.transform(definition.attributes || {}, property),
      value,
      definition.space
    );
    if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) {
      info.mustUseProperty = true;
    }
    properties[property] = info;
    normals[normalize(property)] = property;
    normals[normalize(info.attribute)] = property;
  }
  return new Schema(properties, normals, definition.space);
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/aria.js
var aria = create({
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  },
  transform(_, property) {
    return property === "role" ? property : "aria-" + property.slice(4).toLowerCase();
  }
});

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/util/case-sensitive-transform.js
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/util/case-insensitive-transform.js
function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase());
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/html.js
var html = create({
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    blocking: spaceSeparated,
    capture: null,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: overloadedBoolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: boolean,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shadowRootClonable: boolean,
    shadowRootDelegatesFocus: boolean,
    shadowRootMode: null,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: number,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: boolean,
    // Lists. Use CSS to reduce space between items instead
    declare: boolean,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: number,
    // `<img>` and `<object>`
    leftMargin: number,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: number,
    // `<body>`
    marginWidth: number,
    // `<body>`
    noResize: boolean,
    // `<frame>`
    noHref: boolean,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: number,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: booleanish,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: number,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  },
  space: "html",
  transform: caseInsensitiveTransform
});

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/svg.js
var svg = create({
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  },
  space: "svg",
  transform: caseSensitiveTransform
});

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/xlink.js
var xlink = create({
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  },
  space: "xlink",
  transform(_, property) {
    return "xlink:" + property.slice(5).toLowerCase();
  }
});

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/xmlns.js
var xmlns = create({
  attributes: { xmlnsxlink: "xmlns:xlink" },
  properties: { xmlnsXLink: null, xmlns: null },
  space: "xmlns",
  transform: caseInsensitiveTransform
});

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/xml.js
var xml = create({
  properties: { xmlBase: null, xmlLang: null, xmlSpace: null },
  space: "xml",
  transform(_, property) {
    return "xml:" + property.slice(3).toLowerCase();
  }
});

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/hast-to-react.js
var hastToReact = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
};

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/lib/find.js
var cap = /[A-Z]/g;
var dash = /-[a-z]/g;
var valid2 = /^data[-\w.:]+$/i;
function find(schema, value) {
  const normal = normalize(value);
  let property = value;
  let Type = Info;
  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]];
  }
  if (normal.length > 4 && normal.slice(0, 4) === "data" && valid2.test(value)) {
    if (value.charAt(4) === "-") {
      const rest = value.slice(5).replace(dash, camelcase);
      property = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
    } else {
      const rest = value.slice(4);
      if (!dash.test(rest)) {
        let dashes = rest.replace(cap, kebab);
        if (dashes.charAt(0) !== "-") {
          dashes = "-" + dashes;
        }
        value = "data" + dashes;
      }
    }
    Type = DefinedInfo;
  }
  return new Type(property, value);
}
function kebab($0) {
  return "-" + $0.toLowerCase();
}
function camelcase($0) {
  return $0.charAt(1).toUpperCase();
}

// ../../node_modules/.pnpm/property-information@7.1.0/node_modules/property-information/index.js
var html2 = merge([aria, html, xlink, xmlns, xml], "html");
var svg2 = merge([aria, svg, xlink, xmlns, xml], "svg");

// ../../node_modules/.pnpm/space-separated-tokens@2.0.2/node_modules/space-separated-tokens/index.js
function stringify2(values) {
  return values.join(" ").trim();
}

// ../../node_modules/.pnpm/hast-util-to-jsx-runtime@2.3.6/node_modules/hast-util-to-jsx-runtime/lib/index.js
var import_style_to_js = __toESM(require_cjs3(), 1);

// ../../node_modules/.pnpm/unist-util-position@5.0.0/node_modules/unist-util-position/lib/index.js
var pointEnd = point("end");
var pointStart = point("start");
function point(type) {
  return point2;
  function point2(node) {
    const point3 = node && node.position && node.position[type] || {};
    if (typeof point3.line === "number" && point3.line > 0 && typeof point3.column === "number" && point3.column > 0) {
      return {
        line: point3.line,
        column: point3.column,
        offset: typeof point3.offset === "number" && point3.offset > -1 ? point3.offset : void 0
      };
    }
  }
}
function position(node) {
  const start = pointStart(node);
  const end = pointEnd(node);
  if (start && end) {
    return { start, end };
  }
}

// ../../node_modules/.pnpm/hast-util-to-jsx-runtime@2.3.6/node_modules/hast-util-to-jsx-runtime/lib/index.js
var own = {}.hasOwnProperty;
var emptyMap = /* @__PURE__ */ new Map();
var cap2 = /[A-Z]/g;
var tableElements = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]);
var tableCellElement = /* @__PURE__ */ new Set(["td", "th"]);
var docs = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function toJsxRuntime(tree, options) {
  if (!options || options.Fragment === void 0) {
    throw new TypeError("Expected `Fragment` in options");
  }
  const filePath = options.filePath || void 0;
  let create2;
  if (options.development) {
    if (typeof options.jsxDEV !== "function") {
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    }
    create2 = developmentCreate(filePath, options.jsxDEV);
  } else {
    if (typeof options.jsx !== "function") {
      throw new TypeError("Expected `jsx` in production options");
    }
    if (typeof options.jsxs !== "function") {
      throw new TypeError("Expected `jsxs` in production options");
    }
    create2 = productionCreate(filePath, options.jsx, options.jsxs);
  }
  const state = {
    Fragment: options.Fragment,
    ancestors: [],
    components: options.components || {},
    create: create2,
    elementAttributeNameCase: options.elementAttributeNameCase || "react",
    evaluater: options.createEvaluater ? options.createEvaluater() : void 0,
    filePath,
    ignoreInvalidStyle: options.ignoreInvalidStyle || false,
    passKeys: options.passKeys !== false,
    passNode: options.passNode || false,
    schema: options.space === "svg" ? svg2 : html2,
    stylePropertyNameCase: options.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: options.tableCellAlignToStyle !== false
  };
  const result = one(state, tree, void 0);
  if (result && typeof result !== "string") {
    return result;
  }
  return state.create(
    tree,
    state.Fragment,
    { children: result || void 0 },
    void 0
  );
}
function one(state, node, key) {
  if (node.type === "element") {
    return element(state, node, key);
  }
  if (node.type === "mdxFlowExpression" || node.type === "mdxTextExpression") {
    return mdxExpression(state, node);
  }
  if (node.type === "mdxJsxFlowElement" || node.type === "mdxJsxTextElement") {
    return mdxJsxElement(state, node, key);
  }
  if (node.type === "mdxjsEsm") {
    return mdxEsm(state, node);
  }
  if (node.type === "root") {
    return root(state, node, key);
  }
  if (node.type === "text") {
    return text(state, node);
  }
}
function element(state, node, key) {
  const parentSchema = state.schema;
  let schema = parentSchema;
  if (node.tagName.toLowerCase() === "svg" && parentSchema.space === "html") {
    schema = svg2;
    state.schema = schema;
  }
  state.ancestors.push(node);
  const type = findComponentFromName(state, node.tagName, false);
  const props = createElementProps(state, node);
  let children = createChildren(state, node);
  if (tableElements.has(node.tagName)) {
    children = children.filter(function(child) {
      return typeof child === "string" ? !whitespace(child) : true;
    });
  }
  addNode(state, props, type, node);
  addChildren(props, children);
  state.ancestors.pop();
  state.schema = parentSchema;
  return state.create(node, type, props, key);
}
function mdxExpression(state, node) {
  if (node.data && node.data.estree && state.evaluater) {
    const program = node.data.estree;
    const expression = program.body[0];
    ok(expression.type === "ExpressionStatement");
    return (
      /** @type {Child | undefined} */
      state.evaluater.evaluateExpression(expression.expression)
    );
  }
  crashEstree(state, node.position);
}
function mdxEsm(state, node) {
  if (node.data && node.data.estree && state.evaluater) {
    return (
      /** @type {Child | undefined} */
      state.evaluater.evaluateProgram(node.data.estree)
    );
  }
  crashEstree(state, node.position);
}
function mdxJsxElement(state, node, key) {
  const parentSchema = state.schema;
  let schema = parentSchema;
  if (node.name === "svg" && parentSchema.space === "html") {
    schema = svg2;
    state.schema = schema;
  }
  state.ancestors.push(node);
  const type = node.name === null ? state.Fragment : findComponentFromName(state, node.name, true);
  const props = createJsxElementProps(state, node);
  const children = createChildren(state, node);
  addNode(state, props, type, node);
  addChildren(props, children);
  state.ancestors.pop();
  state.schema = parentSchema;
  return state.create(node, type, props, key);
}
function root(state, node, key) {
  const props = {};
  addChildren(props, createChildren(state, node));
  return state.create(node, state.Fragment, props, key);
}
function text(_, node) {
  return node.value;
}
function addNode(state, props, type, node) {
  if (typeof type !== "string" && type !== state.Fragment && state.passNode) {
    props.node = node;
  }
}
function addChildren(props, children) {
  if (children.length > 0) {
    const value = children.length > 1 ? children : children[0];
    if (value) {
      props.children = value;
    }
  }
}
function productionCreate(_, jsx126, jsxs77) {
  return create2;
  function create2(_2, type, props, key) {
    const isStaticChildren = Array.isArray(props.children);
    const fn = isStaticChildren ? jsxs77 : jsx126;
    return key ? fn(type, props, key) : fn(type, props);
  }
}
function developmentCreate(filePath, jsxDEV) {
  return create2;
  function create2(node, type, props, key) {
    const isStaticChildren = Array.isArray(props.children);
    const point2 = pointStart(node);
    return jsxDEV(
      type,
      props,
      key,
      isStaticChildren,
      {
        columnNumber: point2 ? point2.column - 1 : void 0,
        fileName: filePath,
        lineNumber: point2 ? point2.line : void 0
      },
      void 0
    );
  }
}
function createElementProps(state, node) {
  const props = {};
  let alignValue;
  let prop;
  for (prop in node.properties) {
    if (prop !== "children" && own.call(node.properties, prop)) {
      const result = createProperty(state, prop, node.properties[prop]);
      if (result) {
        const [key, value] = result;
        if (state.tableCellAlignToStyle && key === "align" && typeof value === "string" && tableCellElement.has(node.tagName)) {
          alignValue = value;
        } else {
          props[key] = value;
        }
      }
    }
  }
  if (alignValue) {
    const style = (
      /** @type {Style} */
      props.style || (props.style = {})
    );
    style[state.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = alignValue;
  }
  return props;
}
function createJsxElementProps(state, node) {
  const props = {};
  for (const attribute of node.attributes) {
    if (attribute.type === "mdxJsxExpressionAttribute") {
      if (attribute.data && attribute.data.estree && state.evaluater) {
        const program = attribute.data.estree;
        const expression = program.body[0];
        ok(expression.type === "ExpressionStatement");
        const objectExpression = expression.expression;
        ok(objectExpression.type === "ObjectExpression");
        const property = objectExpression.properties[0];
        ok(property.type === "SpreadElement");
        Object.assign(
          props,
          state.evaluater.evaluateExpression(property.argument)
        );
      } else {
        crashEstree(state, node.position);
      }
    } else {
      const name2 = attribute.name;
      let value;
      if (attribute.value && typeof attribute.value === "object") {
        if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
          const program = attribute.value.data.estree;
          const expression = program.body[0];
          ok(expression.type === "ExpressionStatement");
          value = state.evaluater.evaluateExpression(expression.expression);
        } else {
          crashEstree(state, node.position);
        }
      } else {
        value = attribute.value === null ? true : attribute.value;
      }
      props[name2] = /** @type {Props[keyof Props]} */
      value;
    }
  }
  return props;
}
function createChildren(state, node) {
  const children = [];
  let index2 = -1;
  const countsByName = state.passKeys ? /* @__PURE__ */ new Map() : emptyMap;
  while (++index2 < node.children.length) {
    const child = node.children[index2];
    let key;
    if (state.passKeys) {
      const name2 = child.type === "element" ? child.tagName : child.type === "mdxJsxFlowElement" || child.type === "mdxJsxTextElement" ? child.name : void 0;
      if (name2) {
        const count2 = countsByName.get(name2) || 0;
        key = name2 + "-" + count2;
        countsByName.set(name2, count2 + 1);
      }
    }
    const result = one(state, child, key);
    if (result !== void 0) children.push(result);
  }
  return children;
}
function createProperty(state, prop, value) {
  const info = find(state.schema, prop);
  if (value === null || value === void 0 || typeof value === "number" && Number.isNaN(value)) {
    return;
  }
  if (Array.isArray(value)) {
    value = info.commaSeparated ? stringify(value) : stringify2(value);
  }
  if (info.property === "style") {
    let styleObject = typeof value === "object" ? value : parseStyle(state, String(value));
    if (state.stylePropertyNameCase === "css") {
      styleObject = transformStylesToCssCasing(styleObject);
    }
    return ["style", styleObject];
  }
  return [
    state.elementAttributeNameCase === "react" && info.space ? hastToReact[info.property] || info.property : info.attribute,
    value
  ];
}
function parseStyle(state, value) {
  try {
    return (0, import_style_to_js.default)(value, { reactCompat: true });
  } catch (error2) {
    if (state.ignoreInvalidStyle) {
      return {};
    }
    const cause = (
      /** @type {Error} */
      error2
    );
    const message = new VFileMessage("Cannot parse `style` attribute", {
      ancestors: state.ancestors,
      cause,
      ruleId: "style",
      source: "hast-util-to-jsx-runtime"
    });
    message.file = state.filePath || void 0;
    message.url = docs + "#cannot-parse-style-attribute";
    throw message;
  }
}
function findComponentFromName(state, name2, allowExpression) {
  let result;
  if (!allowExpression) {
    result = { type: "Literal", value: name2 };
  } else if (name2.includes(".")) {
    const identifiers = name2.split(".");
    let index2 = -1;
    let node;
    while (++index2 < identifiers.length) {
      const prop = name(identifiers[index2]) ? { type: "Identifier", name: identifiers[index2] } : { type: "Literal", value: identifiers[index2] };
      node = node ? {
        type: "MemberExpression",
        object: node,
        property: prop,
        computed: Boolean(index2 && prop.type === "Literal"),
        optional: false
      } : prop;
    }
    ok(node, "always a result");
    result = node;
  } else {
    result = name(name2) && !/^[a-z]/.test(name2) ? { type: "Identifier", name: name2 } : { type: "Literal", value: name2 };
  }
  if (result.type === "Literal") {
    const name3 = (
      /** @type {string | number} */
      result.value
    );
    return own.call(state.components, name3) ? state.components[name3] : name3;
  }
  if (state.evaluater) {
    return state.evaluater.evaluateExpression(result);
  }
  crashEstree(state);
}
function crashEstree(state, place) {
  const message = new VFileMessage(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: state.ancestors,
      place,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  message.file = state.filePath || void 0;
  message.url = docs + "#cannot-handle-mdx-estrees-without-createevaluater";
  throw message;
}
function transformStylesToCssCasing(domCasing) {
  const cssCasing = {};
  let from;
  for (from in domCasing) {
    if (own.call(domCasing, from)) {
      cssCasing[transformStyleToCssCasing(from)] = domCasing[from];
    }
  }
  return cssCasing;
}
function transformStyleToCssCasing(from) {
  let to = from.replace(cap2, toDash);
  if (to.slice(0, 3) === "ms-") to = "-" + to;
  return to;
}
function toDash($0) {
  return "-" + $0.toLowerCase();
}

// ../../node_modules/.pnpm/html-url-attributes@3.0.1/node_modules/html-url-attributes/lib/index.js
var urlAttributes = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
};

// ../../node_modules/.pnpm/react-markdown@10.1.0_@types+react@19.2.14_react@19.2.5/node_modules/react-markdown/lib/index.js
import { Fragment as Fragment14, jsx as jsx62, jsxs as jsxs33 } from "react/jsx-runtime";
import { useEffect as useEffect38, useState as useState46 } from "react";

// ../../node_modules/.pnpm/micromark-util-sanitize-uri@2.0.1/node_modules/micromark-util-sanitize-uri/index.js
function normalizeUri(value) {
  const result = [];
  let index2 = -1;
  let start = 0;
  let skip = 0;
  while (++index2 < value.length) {
    const code3 = value.charCodeAt(index2);
    let replace2 = "";
    if (code3 === 37 && asciiAlphanumeric(value.charCodeAt(index2 + 1)) && asciiAlphanumeric(value.charCodeAt(index2 + 2))) {
      skip = 2;
    } else if (code3 < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code3))) {
        replace2 = String.fromCharCode(code3);
      }
    } else if (code3 > 55295 && code3 < 57344) {
      const next = value.charCodeAt(index2 + 1);
      if (code3 < 56320 && next > 56319 && next < 57344) {
        replace2 = String.fromCharCode(code3, next);
        skip = 1;
      } else {
        replace2 = "\uFFFD";
      }
    } else {
      replace2 = String.fromCharCode(code3);
    }
    if (replace2) {
      result.push(value.slice(start, index2), encodeURIComponent(replace2));
      start = index2 + skip + 1;
      replace2 = "";
    }
    if (skip) {
      index2 += skip;
      skip = 0;
    }
  }
  return result.join("") + value.slice(start);
}

// ../../node_modules/.pnpm/remark-parse@11.0.0/node_modules/remark-parse/lib/index.js
function remarkParse(options) {
  const self2 = this;
  self2.parser = parser;
  function parser(doc) {
    return fromMarkdown(doc, {
      ...self2.data("settings"),
      ...options,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: self2.data("micromarkExtensions") || [],
      mdastExtensions: self2.data("fromMarkdownExtensions") || []
    });
  }
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/blockquote.js
function blockquote(state, node) {
  const result = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: state.wrap(state.all(node), true)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/break.js
function hardBreak(state, node) {
  const result = { type: "element", tagName: "br", properties: {}, children: [] };
  state.patch(node, result);
  return [state.applyData(node, result), { type: "text", value: "\n" }];
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/code.js
function code(state, node) {
  const value = node.value ? node.value + "\n" : "";
  const properties = {};
  const language = node.lang ? node.lang.split(/\s+/) : [];
  if (language.length > 0) {
    properties.className = ["language-" + language[0]];
  }
  let result = {
    type: "element",
    tagName: "code",
    properties,
    children: [{ type: "text", value }]
  };
  if (node.meta) {
    result.data = { meta: node.meta };
  }
  state.patch(node, result);
  result = state.applyData(node, result);
  result = { type: "element", tagName: "pre", properties: {}, children: [result] };
  state.patch(node, result);
  return result;
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/delete.js
function strikethrough(state, node) {
  const result = {
    type: "element",
    tagName: "del",
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/emphasis.js
function emphasis(state, node) {
  const result = {
    type: "element",
    tagName: "em",
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
function footnoteReference(state, node) {
  const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
  const id = String(node.identifier).toUpperCase();
  const safeId = normalizeUri(id.toLowerCase());
  const index2 = state.footnoteOrder.indexOf(id);
  let counter;
  let reuseCounter = state.footnoteCounts.get(id);
  if (reuseCounter === void 0) {
    reuseCounter = 0;
    state.footnoteOrder.push(id);
    counter = state.footnoteOrder.length;
  } else {
    counter = index2 + 1;
  }
  reuseCounter += 1;
  state.footnoteCounts.set(id, reuseCounter);
  const link2 = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + clobberPrefix + "fn-" + safeId,
      id: clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
      dataFootnoteRef: true,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(counter) }]
  };
  state.patch(node, link2);
  const sup = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [link2]
  };
  state.patch(node, sup);
  return state.applyData(node, sup);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/heading.js
function heading(state, node) {
  const result = {
    type: "element",
    tagName: "h" + node.depth,
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/html.js
function html3(state, node) {
  if (state.options.allowDangerousHtml) {
    const result = { type: "raw", value: node.value };
    state.patch(node, result);
    return state.applyData(node, result);
  }
  return void 0;
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/revert.js
function revert(state, node) {
  const subtype = node.referenceType;
  let suffix = "]";
  if (subtype === "collapsed") {
    suffix += "[]";
  } else if (subtype === "full") {
    suffix += "[" + (node.label || node.identifier) + "]";
  }
  if (node.type === "imageReference") {
    return [{ type: "text", value: "![" + node.alt + suffix }];
  }
  const contents = state.all(node);
  const head = contents[0];
  if (head && head.type === "text") {
    head.value = "[" + head.value;
  } else {
    contents.unshift({ type: "text", value: "[" });
  }
  const tail = contents[contents.length - 1];
  if (tail && tail.type === "text") {
    tail.value += suffix;
  } else {
    contents.push({ type: "text", value: suffix });
  }
  return contents;
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/image-reference.js
function imageReference(state, node) {
  const id = String(node.identifier).toUpperCase();
  const definition = state.definitionById.get(id);
  if (!definition) {
    return revert(state, node);
  }
  const properties = { src: normalizeUri(definition.url || ""), alt: node.alt };
  if (definition.title !== null && definition.title !== void 0) {
    properties.title = definition.title;
  }
  const result = { type: "element", tagName: "img", properties, children: [] };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/image.js
function image(state, node) {
  const properties = { src: normalizeUri(node.url) };
  if (node.alt !== null && node.alt !== void 0) {
    properties.alt = node.alt;
  }
  if (node.title !== null && node.title !== void 0) {
    properties.title = node.title;
  }
  const result = { type: "element", tagName: "img", properties, children: [] };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
function inlineCode(state, node) {
  const text4 = { type: "text", value: node.value.replace(/\r?\n|\r/g, " ") };
  state.patch(node, text4);
  const result = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [text4]
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/link-reference.js
function linkReference(state, node) {
  const id = String(node.identifier).toUpperCase();
  const definition = state.definitionById.get(id);
  if (!definition) {
    return revert(state, node);
  }
  const properties = { href: normalizeUri(definition.url || "") };
  if (definition.title !== null && definition.title !== void 0) {
    properties.title = definition.title;
  }
  const result = {
    type: "element",
    tagName: "a",
    properties,
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/link.js
function link(state, node) {
  const properties = { href: normalizeUri(node.url) };
  if (node.title !== null && node.title !== void 0) {
    properties.title = node.title;
  }
  const result = {
    type: "element",
    tagName: "a",
    properties,
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/list-item.js
function listItem(state, node, parent) {
  const results = state.all(node);
  const loose = parent ? listLoose(parent) : listItemLoose(node);
  const properties = {};
  const children = [];
  if (typeof node.checked === "boolean") {
    const head = results[0];
    let paragraph2;
    if (head && head.type === "element" && head.tagName === "p") {
      paragraph2 = head;
    } else {
      paragraph2 = { type: "element", tagName: "p", properties: {}, children: [] };
      results.unshift(paragraph2);
    }
    if (paragraph2.children.length > 0) {
      paragraph2.children.unshift({ type: "text", value: " " });
    }
    paragraph2.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: node.checked, disabled: true },
      children: []
    });
    properties.className = ["task-list-item"];
  }
  let index2 = -1;
  while (++index2 < results.length) {
    const child = results[index2];
    if (loose || index2 !== 0 || child.type !== "element" || child.tagName !== "p") {
      children.push({ type: "text", value: "\n" });
    }
    if (child.type === "element" && child.tagName === "p" && !loose) {
      children.push(...child.children);
    } else {
      children.push(child);
    }
  }
  const tail = results[results.length - 1];
  if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) {
    children.push({ type: "text", value: "\n" });
  }
  const result = { type: "element", tagName: "li", properties, children };
  state.patch(node, result);
  return state.applyData(node, result);
}
function listLoose(node) {
  let loose = false;
  if (node.type === "list") {
    loose = node.spread || false;
    const children = node.children;
    let index2 = -1;
    while (!loose && ++index2 < children.length) {
      loose = listItemLoose(children[index2]);
    }
  }
  return loose;
}
function listItemLoose(node) {
  const spread = node.spread;
  return spread === null || spread === void 0 ? node.children.length > 1 : spread;
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/list.js
function list(state, node) {
  const properties = {};
  const results = state.all(node);
  let index2 = -1;
  if (typeof node.start === "number" && node.start !== 1) {
    properties.start = node.start;
  }
  while (++index2 < results.length) {
    const child = results[index2];
    if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
      properties.className = ["contains-task-list"];
      break;
    }
  }
  const result = {
    type: "element",
    tagName: node.ordered ? "ol" : "ul",
    properties,
    children: state.wrap(results, true)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/paragraph.js
function paragraph(state, node) {
  const result = {
    type: "element",
    tagName: "p",
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/root.js
function root2(state, node) {
  const result = { type: "root", children: state.wrap(state.all(node)) };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/strong.js
function strong(state, node) {
  const result = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/table.js
function table(state, node) {
  const rows = state.all(node);
  const firstRow = rows.shift();
  const tableContent = [];
  if (firstRow) {
    const head = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: state.wrap([firstRow], true)
    };
    state.patch(node.children[0], head);
    tableContent.push(head);
  }
  if (rows.length > 0) {
    const body = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: state.wrap(rows, true)
    };
    const start = pointStart(node.children[1]);
    const end = pointEnd(node.children[node.children.length - 1]);
    if (start && end) body.position = { start, end };
    tableContent.push(body);
  }
  const result = {
    type: "element",
    tagName: "table",
    properties: {},
    children: state.wrap(tableContent, true)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/table-row.js
function tableRow(state, node, parent) {
  const siblings = parent ? parent.children : void 0;
  const rowIndex = siblings ? siblings.indexOf(node) : 1;
  const tagName = rowIndex === 0 ? "th" : "td";
  const align = parent && parent.type === "table" ? parent.align : void 0;
  const length = align ? align.length : node.children.length;
  let cellIndex = -1;
  const cells = [];
  while (++cellIndex < length) {
    const cell = node.children[cellIndex];
    const properties = {};
    const alignValue = align ? align[cellIndex] : void 0;
    if (alignValue) {
      properties.align = alignValue;
    }
    let result2 = { type: "element", tagName, properties, children: [] };
    if (cell) {
      result2.children = state.all(cell);
      state.patch(cell, result2);
      result2 = state.applyData(cell, result2);
    }
    cells.push(result2);
  }
  const result = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: state.wrap(cells, true)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/table-cell.js
function tableCell(state, node) {
  const result = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/trim-lines@3.0.1/node_modules/trim-lines/index.js
var tab = 9;
var space = 32;
function trimLines(value) {
  const source = String(value);
  const search = /\r?\n|\r/g;
  let match = search.exec(source);
  let last = 0;
  const lines = [];
  while (match) {
    lines.push(
      trimLine(source.slice(last, match.index), last > 0, true),
      match[0]
    );
    last = match.index + match[0].length;
    match = search.exec(source);
  }
  lines.push(trimLine(source.slice(last), last > 0, false));
  return lines.join("");
}
function trimLine(value, start, end) {
  let startIndex = 0;
  let endIndex = value.length;
  if (start) {
    let code3 = value.codePointAt(startIndex);
    while (code3 === tab || code3 === space) {
      startIndex++;
      code3 = value.codePointAt(startIndex);
    }
  }
  if (end) {
    let code3 = value.codePointAt(endIndex - 1);
    while (code3 === tab || code3 === space) {
      endIndex--;
      code3 = value.codePointAt(endIndex - 1);
    }
  }
  return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/text.js
function text2(state, node) {
  const result = { type: "text", value: trimLines(String(node.value)) };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/thematic-break.js
function thematicBreak(state, node) {
  const result = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  state.patch(node, result);
  return state.applyData(node, result);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/handlers/index.js
var handlers = {
  blockquote,
  break: hardBreak,
  code,
  delete: strikethrough,
  emphasis,
  footnoteReference,
  heading,
  html: html3,
  imageReference,
  image,
  inlineCode,
  linkReference,
  link,
  listItem,
  list,
  paragraph,
  // @ts-expect-error: root is different, but hard to type.
  root: root2,
  strong,
  table,
  tableCell,
  tableRow,
  text: text2,
  thematicBreak,
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
};
function ignore() {
  return void 0;
}

// ../../node_modules/.pnpm/@ungap+structured-clone@1.3.0/node_modules/@ungap/structured-clone/esm/types.js
var VOID = -1;
var PRIMITIVE = 0;
var ARRAY = 1;
var OBJECT = 2;
var DATE = 3;
var REGEXP = 4;
var MAP = 5;
var SET = 6;
var ERROR = 7;
var BIGINT = 8;

// ../../node_modules/.pnpm/@ungap+structured-clone@1.3.0/node_modules/@ungap/structured-clone/esm/deserialize.js
var env = typeof self === "object" ? self : globalThis;
var deserializer = ($, _) => {
  const as = (out, index2) => {
    $.set(index2, out);
    return out;
  };
  const unpair = (index2) => {
    if ($.has(index2))
      return $.get(index2);
    const [type, value] = _[index2];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index2);
      case ARRAY: {
        const arr = as([], index2);
        for (const index3 of value)
          arr.push(unpair(index3));
        return arr;
      }
      case OBJECT: {
        const object = as({}, index2);
        for (const [key, index3] of value)
          object[unpair(key)] = unpair(index3);
        return object;
      }
      case DATE:
        return as(new Date(value), index2);
      case REGEXP: {
        const { source, flags } = value;
        return as(new RegExp(source, flags), index2);
      }
      case MAP: {
        const map = as(/* @__PURE__ */ new Map(), index2);
        for (const [key, index3] of value)
          map.set(unpair(key), unpair(index3));
        return map;
      }
      case SET: {
        const set = as(/* @__PURE__ */ new Set(), index2);
        for (const index3 of value)
          set.add(unpair(index3));
        return set;
      }
      case ERROR: {
        const { name: name2, message } = value;
        return as(new env[name2](message), index2);
      }
      case BIGINT:
        return as(BigInt(value), index2);
      case "BigInt":
        return as(Object(BigInt(value)), index2);
      case "ArrayBuffer":
        return as(new Uint8Array(value).buffer, value);
      case "DataView": {
        const { buffer } = new Uint8Array(value);
        return as(new DataView(buffer), value);
      }
    }
    return as(new env[type](value), index2);
  };
  return unpair;
};
var deserialize = (serialized) => deserializer(/* @__PURE__ */ new Map(), serialized)(0);

// ../../node_modules/.pnpm/@ungap+structured-clone@1.3.0/node_modules/@ungap/structured-clone/esm/serialize.js
var EMPTY4 = "";
var { toString } = {};
var { keys } = Object;
var typeOf = (value) => {
  const type = typeof value;
  if (type !== "object" || !value)
    return [PRIMITIVE, type];
  const asString = toString.call(value).slice(8, -1);
  switch (asString) {
    case "Array":
      return [ARRAY, EMPTY4];
    case "Object":
      return [OBJECT, EMPTY4];
    case "Date":
      return [DATE, EMPTY4];
    case "RegExp":
      return [REGEXP, EMPTY4];
    case "Map":
      return [MAP, EMPTY4];
    case "Set":
      return [SET, EMPTY4];
    case "DataView":
      return [ARRAY, asString];
  }
  if (asString.includes("Array"))
    return [ARRAY, asString];
  if (asString.includes("Error"))
    return [ERROR, asString];
  return [OBJECT, asString];
};
var shouldSkip = ([TYPE, type]) => TYPE === PRIMITIVE && (type === "function" || type === "symbol");
var serializer = (strict, json, $, _) => {
  const as = (out, value) => {
    const index2 = _.push(out) - 1;
    $.set(value, index2);
    return index2;
  };
  const pair = (value) => {
    if ($.has(value))
      return $.get(value);
    let [TYPE, type] = typeOf(value);
    switch (TYPE) {
      case PRIMITIVE: {
        let entry = value;
        switch (type) {
          case "bigint":
            TYPE = BIGINT;
            entry = value.toString();
            break;
          case "function":
          case "symbol":
            if (strict)
              throw new TypeError("unable to serialize " + type);
            entry = null;
            break;
          case "undefined":
            return as([VOID], value);
        }
        return as([TYPE, entry], value);
      }
      case ARRAY: {
        if (type) {
          let spread = value;
          if (type === "DataView") {
            spread = new Uint8Array(value.buffer);
          } else if (type === "ArrayBuffer") {
            spread = new Uint8Array(value);
          }
          return as([type, [...spread]], value);
        }
        const arr = [];
        const index2 = as([TYPE, arr], value);
        for (const entry of value)
          arr.push(pair(entry));
        return index2;
      }
      case OBJECT: {
        if (type) {
          switch (type) {
            case "BigInt":
              return as([type, value.toString()], value);
            case "Boolean":
            case "Number":
            case "String":
              return as([type, value.valueOf()], value);
          }
        }
        if (json && "toJSON" in value)
          return pair(value.toJSON());
        const entries = [];
        const index2 = as([TYPE, entries], value);
        for (const key of keys(value)) {
          if (strict || !shouldSkip(typeOf(value[key])))
            entries.push([pair(key), pair(value[key])]);
        }
        return index2;
      }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP: {
        const { source, flags } = value;
        return as([TYPE, { source, flags }], value);
      }
      case MAP: {
        const entries = [];
        const index2 = as([TYPE, entries], value);
        for (const [key, entry] of value) {
          if (strict || !(shouldSkip(typeOf(key)) || shouldSkip(typeOf(entry))))
            entries.push([pair(key), pair(entry)]);
        }
        return index2;
      }
      case SET: {
        const entries = [];
        const index2 = as([TYPE, entries], value);
        for (const entry of value) {
          if (strict || !shouldSkip(typeOf(entry)))
            entries.push(pair(entry));
        }
        return index2;
      }
    }
    const { message } = value;
    return as([TYPE, { name: type, message }], value);
  };
  return pair;
};
var serialize2 = (value, { json, lossy } = {}) => {
  const _ = [];
  return serializer(!(json || lossy), !!json, /* @__PURE__ */ new Map(), _)(value), _;
};

// ../../node_modules/.pnpm/@ungap+structured-clone@1.3.0/node_modules/@ungap/structured-clone/esm/index.js
var esm_default = typeof structuredClone === "function" ? (
  /* c8 ignore start */
  (any, options) => options && ("json" in options || "lossy" in options) ? deserialize(serialize2(any, options)) : structuredClone(any)
) : (any, options) => deserialize(serialize2(any, options));

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/footer.js
function defaultFootnoteBackContent(_, rereferenceIndex) {
  const result = [{ type: "text", value: "\u21A9" }];
  if (rereferenceIndex > 1) {
    result.push({
      type: "element",
      tagName: "sup",
      properties: {},
      children: [{ type: "text", value: String(rereferenceIndex) }]
    });
  }
  return result;
}
function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
  return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function footer(state) {
  const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
  const footnoteBackContent = state.options.footnoteBackContent || defaultFootnoteBackContent;
  const footnoteBackLabel = state.options.footnoteBackLabel || defaultFootnoteBackLabel;
  const footnoteLabel = state.options.footnoteLabel || "Footnotes";
  const footnoteLabelTagName = state.options.footnoteLabelTagName || "h2";
  const footnoteLabelProperties = state.options.footnoteLabelProperties || {
    className: ["sr-only"]
  };
  const listItems = [];
  let referenceIndex = -1;
  while (++referenceIndex < state.footnoteOrder.length) {
    const definition = state.footnoteById.get(
      state.footnoteOrder[referenceIndex]
    );
    if (!definition) {
      continue;
    }
    const content = state.all(definition);
    const id = String(definition.identifier).toUpperCase();
    const safeId = normalizeUri(id.toLowerCase());
    let rereferenceIndex = 0;
    const backReferences = [];
    const counts = state.footnoteCounts.get(id);
    while (counts !== void 0 && ++rereferenceIndex <= counts) {
      if (backReferences.length > 0) {
        backReferences.push({ type: "text", value: " " });
      }
      let children = typeof footnoteBackContent === "string" ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
      if (typeof children === "string") {
        children = { type: "text", value: children };
      }
      backReferences.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + clobberPrefix + "fnref-" + safeId + (rereferenceIndex > 1 ? "-" + rereferenceIndex : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof footnoteBackLabel === "string" ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(children) ? children : [children]
      });
    }
    const tail = content[content.length - 1];
    if (tail && tail.type === "element" && tail.tagName === "p") {
      const tailTail = tail.children[tail.children.length - 1];
      if (tailTail && tailTail.type === "text") {
        tailTail.value += " ";
      } else {
        tail.children.push({ type: "text", value: " " });
      }
      tail.children.push(...backReferences);
    } else {
      content.push(...backReferences);
    }
    const listItem2 = {
      type: "element",
      tagName: "li",
      properties: { id: clobberPrefix + "fn-" + safeId },
      children: state.wrap(content, true)
    };
    state.patch(definition, listItem2);
    listItems.push(listItem2);
  }
  if (listItems.length === 0) {
    return;
  }
  return {
    type: "element",
    tagName: "section",
    properties: { dataFootnotes: true, className: ["footnotes"] },
    children: [
      {
        type: "element",
        tagName: footnoteLabelTagName,
        properties: {
          ...esm_default(footnoteLabelProperties),
          id: "footnote-label"
        },
        children: [{ type: "text", value: footnoteLabel }]
      },
      { type: "text", value: "\n" },
      {
        type: "element",
        tagName: "ol",
        properties: {},
        children: state.wrap(listItems, true)
      },
      { type: "text", value: "\n" }
    ]
  };
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/state.js
var own2 = {}.hasOwnProperty;
var emptyOptions = {};
function createState(tree, options) {
  const settings = options || emptyOptions;
  const definitionById = /* @__PURE__ */ new Map();
  const footnoteById = /* @__PURE__ */ new Map();
  const footnoteCounts = /* @__PURE__ */ new Map();
  const handlers2 = { ...handlers, ...settings.handlers };
  const state = {
    all,
    applyData,
    definitionById,
    footnoteById,
    footnoteCounts,
    footnoteOrder: [],
    handlers: handlers2,
    one: one2,
    options: settings,
    patch,
    wrap
  };
  visit(tree, function(node) {
    if (node.type === "definition" || node.type === "footnoteDefinition") {
      const map = node.type === "definition" ? definitionById : footnoteById;
      const id = String(node.identifier).toUpperCase();
      if (!map.has(id)) {
        map.set(id, node);
      }
    }
  });
  return state;
  function one2(node, parent) {
    const type = node.type;
    const handle = state.handlers[type];
    if (own2.call(state.handlers, type) && handle) {
      return handle(state, node, parent);
    }
    if (state.options.passThrough && state.options.passThrough.includes(type)) {
      if ("children" in node) {
        const { children, ...shallow } = node;
        const result = esm_default(shallow);
        result.children = state.all(node);
        return result;
      }
      return esm_default(node);
    }
    const unknown = state.options.unknownHandler || defaultUnknownHandler;
    return unknown(state, node, parent);
  }
  function all(parent) {
    const values = [];
    if ("children" in parent) {
      const nodes = parent.children;
      let index2 = -1;
      while (++index2 < nodes.length) {
        const result = state.one(nodes[index2], parent);
        if (result) {
          if (index2 && nodes[index2 - 1].type === "break") {
            if (!Array.isArray(result) && result.type === "text") {
              result.value = trimMarkdownSpaceStart(result.value);
            }
            if (!Array.isArray(result) && result.type === "element") {
              const head = result.children[0];
              if (head && head.type === "text") {
                head.value = trimMarkdownSpaceStart(head.value);
              }
            }
          }
          if (Array.isArray(result)) {
            values.push(...result);
          } else {
            values.push(result);
          }
        }
      }
    }
    return values;
  }
}
function patch(from, to) {
  if (from.position) to.position = position(from);
}
function applyData(from, to) {
  let result = to;
  if (from && from.data) {
    const hName = from.data.hName;
    const hChildren = from.data.hChildren;
    const hProperties = from.data.hProperties;
    if (typeof hName === "string") {
      if (result.type === "element") {
        result.tagName = hName;
      } else {
        const children = "children" in result ? result.children : [result];
        result = { type: "element", tagName: hName, properties: {}, children };
      }
    }
    if (result.type === "element" && hProperties) {
      Object.assign(result.properties, esm_default(hProperties));
    }
    if ("children" in result && result.children && hChildren !== null && hChildren !== void 0) {
      result.children = hChildren;
    }
  }
  return result;
}
function defaultUnknownHandler(state, node) {
  const data = node.data || {};
  const result = "value" in node && !(own2.call(data, "hProperties") || own2.call(data, "hChildren")) ? { type: "text", value: node.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: state.all(node)
  };
  state.patch(node, result);
  return state.applyData(node, result);
}
function wrap(nodes, loose) {
  const result = [];
  let index2 = -1;
  if (loose) {
    result.push({ type: "text", value: "\n" });
  }
  while (++index2 < nodes.length) {
    if (index2) result.push({ type: "text", value: "\n" });
    result.push(nodes[index2]);
  }
  if (loose && nodes.length > 0) {
    result.push({ type: "text", value: "\n" });
  }
  return result;
}
function trimMarkdownSpaceStart(value) {
  let index2 = 0;
  let code3 = value.charCodeAt(index2);
  while (code3 === 9 || code3 === 32) {
    index2++;
    code3 = value.charCodeAt(index2);
  }
  return value.slice(index2);
}

// ../../node_modules/.pnpm/mdast-util-to-hast@13.2.1/node_modules/mdast-util-to-hast/lib/index.js
function toHast(tree, options) {
  const state = createState(tree, options);
  const node = state.one(tree, void 0);
  const foot = footer(state);
  const result = Array.isArray(node) ? { type: "root", children: node } : node || { type: "root", children: [] };
  if (foot) {
    ok("children" in result);
    result.children.push({ type: "text", value: "\n" }, foot);
  }
  return result;
}

// ../../node_modules/.pnpm/remark-rehype@11.1.2/node_modules/remark-rehype/lib/index.js
function remarkRehype(destination, options) {
  if (destination && "run" in destination) {
    return async function(tree, file) {
      const hastTree = (
        /** @type {HastRoot} */
        toHast(tree, { file, ...options })
      );
      await destination.run(hastTree, file);
    };
  }
  return function(tree, file) {
    return (
      /** @type {HastRoot} */
      toHast(tree, { file, ...destination || options })
    );
  };
}

// ../../node_modules/.pnpm/bail@2.0.2/node_modules/bail/index.js
function bail(error2) {
  if (error2) {
    throw error2;
  }
}

// ../../node_modules/.pnpm/unified@11.0.5/node_modules/unified/lib/index.js
var import_extend = __toESM(require_extend(), 1);

// ../../node_modules/.pnpm/is-plain-obj@4.1.0/node_modules/is-plain-obj/index.js
function isPlainObject(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}

// ../../node_modules/.pnpm/trough@2.2.0/node_modules/trough/lib/index.js
function trough() {
  const fns = [];
  const pipeline = { run, use: use9 };
  return pipeline;
  function run(...values) {
    let middlewareIndex = -1;
    const callback = values.pop();
    if (typeof callback !== "function") {
      throw new TypeError("Expected function as last argument, not " + callback);
    }
    next(null, ...values);
    function next(error2, ...output) {
      const fn = fns[++middlewareIndex];
      let index2 = -1;
      if (error2) {
        callback(error2);
        return;
      }
      while (++index2 < values.length) {
        if (output[index2] === null || output[index2] === void 0) {
          output[index2] = values[index2];
        }
      }
      values = output;
      if (fn) {
        wrap2(fn, next)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }
  function use9(middelware) {
    if (typeof middelware !== "function") {
      throw new TypeError(
        "Expected `middelware` to be a function, not " + middelware
      );
    }
    fns.push(middelware);
    return pipeline;
  }
}
function wrap2(middleware, callback) {
  let called;
  return wrapped;
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    let result;
    if (fnExpectsCallback) {
      parameters.push(done);
    }
    try {
      result = middleware.apply(this, parameters);
    } catch (error2) {
      const exception = (
        /** @type {Error} */
        error2
      );
      if (fnExpectsCallback && called) {
        throw exception;
      }
      return done(exception);
    }
    if (!fnExpectsCallback) {
      if (result && result.then && typeof result.then === "function") {
        result.then(then, done);
      } else if (result instanceof Error) {
        done(result);
      } else {
        then(result);
      }
    }
  }
  function done(error2, ...output) {
    if (!called) {
      called = true;
      callback(error2, ...output);
    }
  }
  function then(value) {
    done(null, value);
  }
}

// ../../node_modules/.pnpm/vfile@6.0.3/node_modules/vfile/lib/minpath.browser.js
var minpath = { basename, dirname, extname, join, sep: "/" };
function basename(path2, extname2) {
  if (extname2 !== void 0 && typeof extname2 !== "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  assertPath(path2);
  let start = 0;
  let end = -1;
  let index2 = path2.length;
  let seenNonSlash;
  if (extname2 === void 0 || extname2.length === 0 || extname2.length > path2.length) {
    while (index2--) {
      if (path2.codePointAt(index2) === 47) {
        if (seenNonSlash) {
          start = index2 + 1;
          break;
        }
      } else if (end < 0) {
        seenNonSlash = true;
        end = index2 + 1;
      }
    }
    return end < 0 ? "" : path2.slice(start, end);
  }
  if (extname2 === path2) {
    return "";
  }
  let firstNonSlashEnd = -1;
  let extnameIndex = extname2.length - 1;
  while (index2--) {
    if (path2.codePointAt(index2) === 47) {
      if (seenNonSlash) {
        start = index2 + 1;
        break;
      }
    } else {
      if (firstNonSlashEnd < 0) {
        seenNonSlash = true;
        firstNonSlashEnd = index2 + 1;
      }
      if (extnameIndex > -1) {
        if (path2.codePointAt(index2) === extname2.codePointAt(extnameIndex--)) {
          if (extnameIndex < 0) {
            end = index2;
          }
        } else {
          extnameIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }
  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path2.length;
  }
  return path2.slice(start, end);
}
function dirname(path2) {
  assertPath(path2);
  if (path2.length === 0) {
    return ".";
  }
  let end = -1;
  let index2 = path2.length;
  let unmatchedSlash;
  while (--index2) {
    if (path2.codePointAt(index2) === 47) {
      if (unmatchedSlash) {
        end = index2;
        break;
      }
    } else if (!unmatchedSlash) {
      unmatchedSlash = true;
    }
  }
  return end < 0 ? path2.codePointAt(0) === 47 ? "/" : "." : end === 1 && path2.codePointAt(0) === 47 ? "//" : path2.slice(0, end);
}
function extname(path2) {
  assertPath(path2);
  let index2 = path2.length;
  let end = -1;
  let startPart = 0;
  let startDot = -1;
  let preDotState = 0;
  let unmatchedSlash;
  while (index2--) {
    const code3 = path2.codePointAt(index2);
    if (code3 === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    if (end < 0) {
      unmatchedSlash = true;
      end = index2 + 1;
    }
    if (code3 === 46) {
      if (startDot < 0) {
        startDot = index2;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      preDotState = -1;
    }
  }
  if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return "";
  }
  return path2.slice(startDot, end);
}
function join(...segments) {
  let index2 = -1;
  let joined;
  while (++index2 < segments.length) {
    assertPath(segments[index2]);
    if (segments[index2]) {
      joined = joined === void 0 ? segments[index2] : joined + "/" + segments[index2];
    }
  }
  return joined === void 0 ? "." : normalize2(joined);
}
function normalize2(path2) {
  assertPath(path2);
  const absolute = path2.codePointAt(0) === 47;
  let value = normalizeString(path2, !absolute);
  if (value.length === 0 && !absolute) {
    value = ".";
  }
  if (value.length > 0 && path2.codePointAt(path2.length - 1) === 47) {
    value += "/";
  }
  return absolute ? "/" + value : value;
}
function normalizeString(path2, allowAboveRoot) {
  let result = "";
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index2 = -1;
  let code3;
  let lastSlashIndex;
  while (++index2 <= path2.length) {
    if (index2 < path2.length) {
      code3 = path2.codePointAt(index2);
    } else if (code3 === 47) {
      break;
    } else {
      code3 = 47;
    }
    if (code3 === 47) {
      if (lastSlash === index2 - 1 || dots === 1) {
      } else if (lastSlash !== index2 - 1 && dots === 2) {
        if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 || result.codePointAt(result.length - 2) !== 46) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf("/");
            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = "";
                lastSegmentLength = 0;
              } else {
                result = result.slice(0, lastSlashIndex);
                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
              }
              lastSlash = index2;
              dots = 0;
              continue;
            }
          } else if (result.length > 0) {
            result = "";
            lastSegmentLength = 0;
            lastSlash = index2;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          result = result.length > 0 ? result + "/.." : "..";
          lastSegmentLength = 2;
        }
      } else {
        if (result.length > 0) {
          result += "/" + path2.slice(lastSlash + 1, index2);
        } else {
          result = path2.slice(lastSlash + 1, index2);
        }
        lastSegmentLength = index2 - lastSlash - 1;
      }
      lastSlash = index2;
      dots = 0;
    } else if (code3 === 46 && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }
  return result;
}
function assertPath(path2) {
  if (typeof path2 !== "string") {
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path2)
    );
  }
}

// ../../node_modules/.pnpm/vfile@6.0.3/node_modules/vfile/lib/minproc.browser.js
var minproc = { cwd };
function cwd() {
  return "/";
}

// ../../node_modules/.pnpm/vfile@6.0.3/node_modules/vfile/lib/minurl.shared.js
function isUrl(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === void 0
  );
}

// ../../node_modules/.pnpm/vfile@6.0.3/node_modules/vfile/lib/minurl.browser.js
function urlToPath(path2) {
  if (typeof path2 === "string") {
    path2 = new URL(path2);
  } else if (!isUrl(path2)) {
    const error2 = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + path2 + "`"
    );
    error2.code = "ERR_INVALID_ARG_TYPE";
    throw error2;
  }
  if (path2.protocol !== "file:") {
    const error2 = new TypeError("The URL must be of scheme file");
    error2.code = "ERR_INVALID_URL_SCHEME";
    throw error2;
  }
  return getPathFromURLPosix(path2);
}
function getPathFromURLPosix(url) {
  if (url.hostname !== "") {
    const error2 = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error2.code = "ERR_INVALID_FILE_URL_HOST";
    throw error2;
  }
  const pathname = url.pathname;
  let index2 = -1;
  while (++index2 < pathname.length) {
    if (pathname.codePointAt(index2) === 37 && pathname.codePointAt(index2 + 1) === 50) {
      const third = pathname.codePointAt(index2 + 2);
      if (third === 70 || third === 102) {
        const error2 = new TypeError(
          "File URL path must not include encoded / characters"
        );
        error2.code = "ERR_INVALID_FILE_URL_PATH";
        throw error2;
      }
    }
  }
  return decodeURIComponent(pathname);
}

// ../../node_modules/.pnpm/vfile@6.0.3/node_modules/vfile/lib/index.js
var order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
var VFile = class {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    let options;
    if (!value) {
      options = {};
    } else if (isUrl(value)) {
      options = { path: value };
    } else if (typeof value === "string" || isUint8Array(value)) {
      options = { value };
    } else {
      options = value;
    }
    this.cwd = "cwd" in options ? "" : minproc.cwd();
    this.data = {};
    this.history = [];
    this.messages = [];
    this.value;
    this.map;
    this.result;
    this.stored;
    let index2 = -1;
    while (++index2 < order.length) {
      const field2 = order[index2];
      if (field2 in options && options[field2] !== void 0 && options[field2] !== null) {
        this[field2] = field2 === "history" ? [...options[field2]] : options[field2];
      }
    }
    let field;
    for (field in options) {
      if (!order.includes(field)) {
        this[field] = options[field];
      }
    }
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename2) {
    assertNonEmpty(basename2, "basename");
    assertPart(basename2, "basename");
    this.path = minpath.join(this.dirname || "", basename2);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname2) {
    assertPath2(this.basename, "dirname");
    this.path = minpath.join(dirname2 || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname2) {
    assertPart(extname2, "extname");
    assertPath2(this.dirname, "extname");
    if (extname2) {
      if (extname2.codePointAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (extname2.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = minpath.join(this.dirname, this.stem + (extname2 || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path2) {
    if (isUrl(path2)) {
      path2 = urlToPath(path2);
    }
    assertNonEmpty(path2, "path");
    if (this.path !== path2) {
      this.history.push(path2);
    }
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty(stem, "stem");
    assertPart(stem, "stem");
    this.path = minpath.join(this.dirname || "", stem + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = true;
    throw message;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = void 0;
    return message;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    );
    if (this.path) {
      message.name = this.path + ":" + message.name;
      message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === void 0) {
      return "";
    }
    if (typeof this.value === "string") {
      return this.value;
    }
    const decoder = new TextDecoder(encoding || void 0);
    return decoder.decode(this.value);
  }
};
function assertPart(part, name2) {
  if (part && part.includes(minpath.sep)) {
    throw new Error(
      "`" + name2 + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
  }
}
function assertNonEmpty(part, name2) {
  if (!part) {
    throw new Error("`" + name2 + "` cannot be empty");
  }
}
function assertPath2(path2, name2) {
  if (!path2) {
    throw new Error("Setting `" + name2 + "` requires `path` to be set too");
  }
}
function isUint8Array(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}

// ../../node_modules/.pnpm/unified@11.0.5/node_modules/unified/lib/callable-instance.js
var CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(property) {
    const self2 = this;
    const constr = self2.constructor;
    const proto = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      constr.prototype
    );
    const value = proto[property];
    const apply = function() {
      return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    return apply;
  }
);

// ../../node_modules/.pnpm/unified@11.0.5/node_modules/unified/lib/index.js
var own3 = {}.hasOwnProperty;
var Processor = class _Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy");
    this.Compiler = void 0;
    this.Parser = void 0;
    this.attachers = [];
    this.compiler = void 0;
    this.freezeIndex = -1;
    this.frozen = void 0;
    this.namespace = {};
    this.parser = void 0;
    this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const destination = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new _Processor()
    );
    let index2 = -1;
    while (++index2 < this.attachers.length) {
      const attacher = this.attachers[index2];
      destination.use(...attacher);
    }
    destination.data((0, import_extend.default)(true, {}, this.namespace));
    return destination;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    if (typeof key === "string") {
      if (arguments.length === 2) {
        assertUnfrozen("data", this.frozen);
        this.namespace[key] = value;
        return this;
      }
      return own3.call(this.namespace, key) && this.namespace[key] || void 0;
    }
    if (key) {
      assertUnfrozen("data", this.frozen);
      this.namespace = key;
      return this;
    }
    return this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this;
    }
    const self2 = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options] = this.attachers[this.freezeIndex];
      if (options[0] === false) {
        continue;
      }
      if (options[0] === true) {
        options[0] = void 0;
      }
      const transformer = attacher.call(self2, ...options);
      if (typeof transformer === "function") {
        this.transformers.use(transformer);
      }
    }
    this.frozen = true;
    this.freezeIndex = Number.POSITIVE_INFINITY;
    return this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile(file);
    const parser = this.parser || this.Parser;
    assertParser("parse", parser);
    return parser(String(realFile), realFile);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self2 = this;
    this.freeze();
    assertParser("process", this.parser || this.Parser);
    assertCompiler("process", this.compiler || this.Compiler);
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject) {
      const realFile = vfile(file);
      const parseTree = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        self2.parse(realFile)
      );
      self2.run(parseTree, realFile, function(error2, tree, file2) {
        if (error2 || !tree || !file2) {
          return realDone(error2);
        }
        const compileTree = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          tree
        );
        const compileResult = self2.stringify(compileTree, file2);
        if (looksLikeAValue(compileResult)) {
          file2.value = compileResult;
        } else {
          file2.result = compileResult;
        }
        realDone(
          error2,
          /** @type {VFileWithOutput<CompileResult>} */
          file2
        );
      });
      function realDone(error2, file2) {
        if (error2 || !file2) {
          reject(error2);
        } else if (resolve) {
          resolve(file2);
        } else {
          ok(done, "`done` is defined if `resolve` is not");
          done(void 0, file2);
        }
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    let complete = false;
    let result;
    this.freeze();
    assertParser("processSync", this.parser || this.Parser);
    assertCompiler("processSync", this.compiler || this.Compiler);
    this.process(file, realDone);
    assertDone("processSync", "process", complete);
    ok(result, "we either bailed on an error or have a tree");
    return result;
    function realDone(error2, file2) {
      complete = true;
      bail(error2);
      result = file2;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode(tree);
    this.freeze();
    const transformers = this.transformers;
    if (!done && typeof file === "function") {
      done = file;
      file = void 0;
    }
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject) {
      ok(
        typeof file !== "function",
        "`file` can\u2019t be a `done` anymore, we checked"
      );
      const realFile = vfile(file);
      transformers.run(tree, realFile, realDone);
      function realDone(error2, outputTree, file2) {
        const resultingTree = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          outputTree || tree
        );
        if (error2) {
          reject(error2);
        } else if (resolve) {
          resolve(resultingTree);
        } else {
          ok(done, "`done` is defined if `resolve` is not");
          done(void 0, resultingTree, file2);
        }
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    let complete = false;
    let result;
    this.run(tree, file, realDone);
    assertDone("runSync", "run", complete);
    ok(result, "we either bailed on an error or have a tree");
    return result;
    function realDone(error2, tree2) {
      bail(error2);
      result = tree2;
      complete = true;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile(file);
    const compiler = this.compiler || this.Compiler;
    assertCompiler("stringify", compiler);
    assertNode(tree);
    return compiler(tree, realFile);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers;
    const namespace = this.namespace;
    assertUnfrozen("use", this.frozen);
    if (value === null || value === void 0) {
    } else if (typeof value === "function") {
      addPlugin(value, parameters);
    } else if (typeof value === "object") {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError("Expected usable value, not `" + value + "`");
    }
    return this;
    function add(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2, []);
      } else if (typeof value2 === "object") {
        if (Array.isArray(value2)) {
          const [plugin, ...parameters2] = (
            /** @type {PluginTuple<Array<unknown>>} */
            value2
          );
          addPlugin(plugin, parameters2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + value2 + "`");
      }
    }
    function addPreset(result) {
      if (!("plugins" in result) && !("settings" in result)) {
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      }
      addList(result.plugins);
      if (result.settings) {
        namespace.settings = (0, import_extend.default)(true, namespace.settings, result.settings);
      }
    }
    function addList(plugins) {
      let index2 = -1;
      if (plugins === null || plugins === void 0) {
      } else if (Array.isArray(plugins)) {
        while (++index2 < plugins.length) {
          const thing = plugins[index2];
          add(thing);
        }
      } else {
        throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
      }
    }
    function addPlugin(plugin, parameters2) {
      let index2 = -1;
      let entryIndex = -1;
      while (++index2 < attachers.length) {
        if (attachers[index2][0] === plugin) {
          entryIndex = index2;
          break;
        }
      }
      if (entryIndex === -1) {
        attachers.push([plugin, ...parameters2]);
      } else if (parameters2.length > 0) {
        let [primary, ...rest] = parameters2;
        const currentPrimary = attachers[entryIndex][1];
        if (isPlainObject(currentPrimary) && isPlainObject(primary)) {
          primary = (0, import_extend.default)(true, currentPrimary, primary);
        }
        attachers[entryIndex] = [plugin, primary, ...rest];
      }
    }
  }
};
var unified = new Processor().freeze();
function assertParser(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `parser`");
  }
}
function assertCompiler(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `compiler`");
  }
}
function assertUnfrozen(name2, frozen) {
  if (frozen) {
    throw new Error(
      "Cannot call `" + name2 + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
  }
}
function assertNode(node) {
  if (!isPlainObject(node) || typeof node.type !== "string") {
    throw new TypeError("Expected node, got `" + node + "`");
  }
}
function assertDone(name2, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name2 + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value);
}
function looksLikeAVFile(value) {
  return Boolean(
    value && typeof value === "object" && "message" in value && "messages" in value
  );
}
function looksLikeAValue(value) {
  return typeof value === "string" || isUint8Array2(value);
}
function isUint8Array2(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}

// ../../node_modules/.pnpm/react-markdown@10.1.0_@types+react@19.2.14_react@19.2.5/node_modules/react-markdown/lib/index.js
var changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
var emptyPlugins = [];
var emptyRemarkRehypeOptions = { allowDangerousHtml: true };
var safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
var deprecations = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  { from: "className", id: "remove-classname" },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Markdown(options) {
  const processor = createProcessor(options);
  const file = createFile(options);
  return post(processor.runSync(processor.parse(file), file), options);
}
function createProcessor(options) {
  const rehypePlugins = options.rehypePlugins || emptyPlugins;
  const remarkPlugins = options.remarkPlugins || emptyPlugins;
  const remarkRehypeOptions = options.remarkRehypeOptions ? { ...options.remarkRehypeOptions, ...emptyRemarkRehypeOptions } : emptyRemarkRehypeOptions;
  const processor = unified().use(remarkParse).use(remarkPlugins).use(remarkRehype, remarkRehypeOptions).use(rehypePlugins);
  return processor;
}
function createFile(options) {
  const children = options.children || "";
  const file = new VFile();
  if (typeof children === "string") {
    file.value = children;
  } else {
    unreachable(
      "Unexpected value `" + children + "` for `children` prop, expected `string`"
    );
  }
  return file;
}
function post(tree, options) {
  const allowedElements = options.allowedElements;
  const allowElement = options.allowElement;
  const components = options.components;
  const disallowedElements = options.disallowedElements;
  const skipHtml = options.skipHtml;
  const unwrapDisallowed = options.unwrapDisallowed;
  const urlTransform = options.urlTransform || defaultUrlTransform;
  for (const deprecation of deprecations) {
    if (Object.hasOwn(options, deprecation.from)) {
      unreachable(
        "Unexpected `" + deprecation.from + "` prop, " + (deprecation.to ? "use `" + deprecation.to + "` instead" : "remove it") + " (see <" + changelog + "#" + deprecation.id + "> for more info)"
      );
    }
  }
  if (allowedElements && disallowedElements) {
    unreachable(
      "Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other"
    );
  }
  visit(tree, transform);
  return toJsxRuntime(tree, {
    Fragment: Fragment14,
    components,
    ignoreInvalidStyle: true,
    jsx: jsx62,
    jsxs: jsxs33,
    passKeys: true,
    passNode: true
  });
  function transform(node, index2, parent) {
    if (node.type === "raw" && parent && typeof index2 === "number") {
      if (skipHtml) {
        parent.children.splice(index2, 1);
      } else {
        parent.children[index2] = { type: "text", value: node.value };
      }
      return index2;
    }
    if (node.type === "element") {
      let key;
      for (key in urlAttributes) {
        if (Object.hasOwn(urlAttributes, key) && Object.hasOwn(node.properties, key)) {
          const value = node.properties[key];
          const test = urlAttributes[key];
          if (test === null || test.includes(node.tagName)) {
            node.properties[key] = urlTransform(String(value || ""), key, node);
          }
        }
      }
    }
    if (node.type === "element") {
      let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
      if (!remove && allowElement && typeof index2 === "number") {
        remove = !allowElement(node, index2, parent);
      }
      if (remove && parent && typeof index2 === "number") {
        if (unwrapDisallowed && node.children) {
          parent.children.splice(index2, 1, ...node.children);
        } else {
          parent.children.splice(index2, 1);
        }
        return index2;
      }
    }
  }
}
function defaultUrlTransform(value) {
  const colon = value.indexOf(":");
  const questionMark = value.indexOf("?");
  const numberSign = value.indexOf("#");
  const slash = value.indexOf("/");
  if (
    // If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    safeProtocol.test(value.slice(0, colon))
  ) {
    return value;
  }
  return "";
}

// ../../node_modules/.pnpm/mdast-util-find-and-replace@3.0.2/node_modules/mdast-util-find-and-replace/lib/index.js
function findAndReplace(tree, list2, options) {
  const settings = options || {};
  const ignored = convert(settings.ignore || []);
  const pairs = toPairs(list2);
  let pairIndex = -1;
  while (++pairIndex < pairs.length) {
    visitParents(tree, "text", visitor);
  }
  function visitor(node, parents) {
    let index2 = -1;
    let grandparent;
    while (++index2 < parents.length) {
      const parent = parents[index2];
      const siblings = grandparent ? grandparent.children : void 0;
      if (ignored(
        parent,
        siblings ? siblings.indexOf(parent) : void 0,
        grandparent
      )) {
        return;
      }
      grandparent = parent;
    }
    if (grandparent) {
      return handler(node, parents);
    }
  }
  function handler(node, parents) {
    const parent = parents[parents.length - 1];
    const find2 = pairs[pairIndex][0];
    const replace2 = pairs[pairIndex][1];
    let start = 0;
    const siblings = parent.children;
    const index2 = siblings.indexOf(node);
    let change = false;
    let nodes = [];
    find2.lastIndex = 0;
    let match = find2.exec(node.value);
    while (match) {
      const position2 = match.index;
      const matchObject = {
        index: match.index,
        input: match.input,
        stack: [...parents, node]
      };
      let value = replace2(...match, matchObject);
      if (typeof value === "string") {
        value = value.length > 0 ? { type: "text", value } : void 0;
      }
      if (value === false) {
        find2.lastIndex = position2 + 1;
      } else {
        if (start !== position2) {
          nodes.push({
            type: "text",
            value: node.value.slice(start, position2)
          });
        }
        if (Array.isArray(value)) {
          nodes.push(...value);
        } else if (value) {
          nodes.push(value);
        }
        start = position2 + match[0].length;
        change = true;
      }
      if (!find2.global) {
        break;
      }
      match = find2.exec(node.value);
    }
    if (change) {
      if (start < node.value.length) {
        nodes.push({ type: "text", value: node.value.slice(start) });
      }
      parent.children.splice(index2, 1, ...nodes);
    } else {
      nodes = [node];
    }
    return index2 + nodes.length;
  }
}
function toPairs(tupleOrList) {
  const result = [];
  if (!Array.isArray(tupleOrList)) {
    throw new TypeError("Expected find and replace tuple or list of tuples");
  }
  const list2 = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [tupleOrList];
  let index2 = -1;
  while (++index2 < list2.length) {
    const tuple = list2[index2];
    result.push([toExpression(tuple[0]), toFunction(tuple[1])]);
  }
  return result;
}
function toExpression(find2) {
  return typeof find2 === "string" ? new RegExp(escapeStringRegexp(find2), "g") : find2;
}
function toFunction(replace2) {
  return typeof replace2 === "function" ? replace2 : function() {
    return replace2;
  };
}

// ../../node_modules/.pnpm/mdast-util-newline-to-break@2.0.0/node_modules/mdast-util-newline-to-break/lib/index.js
function newlineToBreak(tree) {
  findAndReplace(tree, [/\r?\n|\r/g, replace]);
}
function replace() {
  return { type: "break" };
}

// ../../node_modules/.pnpm/remark-breaks@4.0.0/node_modules/remark-breaks/lib/index.js
function remarkBreaks() {
  return function(tree) {
    newlineToBreak(tree);
  };
}

// ../../node_modules/.pnpm/mdast-util-gfm-autolink-literal@2.0.1/node_modules/mdast-util-gfm-autolink-literal/lib/index.js
var inConstruct = "phrasing";
var notInConstruct = ["autolink", "link", "image", "label"];
function gfmAutolinkLiteralFromMarkdown() {
  return {
    transforms: [transformGfmAutolinkLiterals],
    enter: {
      literalAutolink: enterLiteralAutolink,
      literalAutolinkEmail: enterLiteralAutolinkValue,
      literalAutolinkHttp: enterLiteralAutolinkValue,
      literalAutolinkWww: enterLiteralAutolinkValue
    },
    exit: {
      literalAutolink: exitLiteralAutolink,
      literalAutolinkEmail: exitLiteralAutolinkEmail,
      literalAutolinkHttp: exitLiteralAutolinkHttp,
      literalAutolinkWww: exitLiteralAutolinkWww
    }
  };
}
function gfmAutolinkLiteralToMarkdown() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct,
        notInConstruct
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct,
        notInConstruct
      }
    ]
  };
}
function enterLiteralAutolink(token) {
  this.enter({ type: "link", title: null, url: "", children: [] }, token);
}
function enterLiteralAutolinkValue(token) {
  this.config.enter.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkHttp(token) {
  this.config.exit.autolinkProtocol.call(this, token);
}
function exitLiteralAutolinkWww(token) {
  this.config.exit.data.call(this, token);
  const node = this.stack[this.stack.length - 1];
  ok(node.type === "link");
  node.url = "http://" + this.sliceSerialize(token);
}
function exitLiteralAutolinkEmail(token) {
  this.config.exit.autolinkEmail.call(this, token);
}
function exitLiteralAutolink(token) {
  this.exit(token);
}
function transformGfmAutolinkLiterals(tree) {
  findAndReplace(
    tree,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, findUrl],
      [/(?<=^|\s|\p{P}|\p{S})([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/gu, findEmail]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function findUrl(_, protocol, domain2, path2, match) {
  let prefix = "";
  if (!previous(match)) {
    return false;
  }
  if (/^w/i.test(protocol)) {
    domain2 = protocol + domain2;
    protocol = "";
    prefix = "http://";
  }
  if (!isCorrectDomain(domain2)) {
    return false;
  }
  const parts = splitUrl(domain2 + path2);
  if (!parts[0]) return false;
  const result = {
    type: "link",
    title: null,
    url: prefix + protocol + parts[0],
    children: [{ type: "text", value: protocol + parts[0] }]
  };
  if (parts[1]) {
    return [result, { type: "text", value: parts[1] }];
  }
  return result;
}
function findEmail(_, atext, label, match) {
  if (
    // Not an expected previous character.
    !previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)
  ) {
    return false;
  }
  return {
    type: "link",
    title: null,
    url: "mailto:" + atext + "@" + label,
    children: [{ type: "text", value: atext + "@" + label }]
  };
}
function isCorrectDomain(domain2) {
  const parts = domain2.split(".");
  if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) {
    return false;
  }
  return true;
}
function splitUrl(url) {
  const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
  if (!trailExec) {
    return [url, void 0];
  }
  url = url.slice(0, trailExec.index);
  let trail2 = trailExec[0];
  let closingParenIndex = trail2.indexOf(")");
  const openingParens = ccount(url, "(");
  let closingParens = ccount(url, ")");
  while (closingParenIndex !== -1 && openingParens > closingParens) {
    url += trail2.slice(0, closingParenIndex + 1);
    trail2 = trail2.slice(closingParenIndex + 1);
    closingParenIndex = trail2.indexOf(")");
    closingParens++;
  }
  return [url, trail2];
}
function previous(match, email) {
  const code3 = match.input.charCodeAt(match.index - 1);
  return (match.index === 0 || unicodeWhitespace(code3) || unicodePunctuation(code3)) && // If it’s an email, the previous character should not be a slash.
  (!email || code3 !== 47);
}

// ../../node_modules/.pnpm/mdast-util-gfm-footnote@2.1.0/node_modules/mdast-util-gfm-footnote/lib/index.js
footnoteReference2.peek = footnoteReferencePeek;
function enterFootnoteCallString() {
  this.buffer();
}
function enterFootnoteCall(token) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, token);
}
function enterFootnoteDefinitionLabelString() {
  this.buffer();
}
function enterFootnoteDefinition(token) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    token
  );
}
function exitFootnoteCallString(token) {
  const label = this.resume();
  const node = this.stack[this.stack.length - 1];
  ok(node.type === "footnoteReference");
  node.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase();
  node.label = label;
}
function exitFootnoteCall(token) {
  this.exit(token);
}
function exitFootnoteDefinitionLabelString(token) {
  const label = this.resume();
  const node = this.stack[this.stack.length - 1];
  ok(node.type === "footnoteDefinition");
  node.identifier = normalizeIdentifier(
    this.sliceSerialize(token)
  ).toLowerCase();
  node.label = label;
}
function exitFootnoteDefinition(token) {
  this.exit(token);
}
function footnoteReferencePeek() {
  return "[";
}
function footnoteReference2(node, _, state, info) {
  const tracker = state.createTracker(info);
  let value = tracker.move("[^");
  const exit = state.enter("footnoteReference");
  const subexit = state.enter("reference");
  value += tracker.move(
    state.safe(state.associationId(node), { after: "]", before: value })
  );
  subexit();
  exit();
  value += tracker.move("]");
  return value;
}
function gfmFootnoteFromMarkdown() {
  return {
    enter: {
      gfmFootnoteCallString: enterFootnoteCallString,
      gfmFootnoteCall: enterFootnoteCall,
      gfmFootnoteDefinitionLabelString: enterFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: enterFootnoteDefinition
    },
    exit: {
      gfmFootnoteCallString: exitFootnoteCallString,
      gfmFootnoteCall: exitFootnoteCall,
      gfmFootnoteDefinitionLabelString: exitFootnoteDefinitionLabelString,
      gfmFootnoteDefinition: exitFootnoteDefinition
    }
  };
}
function gfmFootnoteToMarkdown(options) {
  let firstLineBlank = false;
  if (options && options.firstLineBlank) {
    firstLineBlank = true;
  }
  return {
    handlers: { footnoteDefinition, footnoteReference: footnoteReference2 },
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["label", "phrasing", "reference"] }]
  };
  function footnoteDefinition(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move("[^");
    const exit = state.enter("footnoteDefinition");
    const subexit = state.enter("label");
    value += tracker.move(
      state.safe(state.associationId(node), { before: value, after: "]" })
    );
    subexit();
    value += tracker.move("]:");
    if (node.children && node.children.length > 0) {
      tracker.shift(4);
      value += tracker.move(
        (firstLineBlank ? "\n" : " ") + state.indentLines(
          state.containerFlow(node, tracker.current()),
          firstLineBlank ? mapAll : mapExceptFirst
        )
      );
    }
    exit();
    return value;
  }
}
function mapExceptFirst(line, index2, blank) {
  return index2 === 0 ? line : mapAll(line, index2, blank);
}
function mapAll(line, index2, blank) {
  return (blank ? "" : "    ") + line;
}

// ../../node_modules/.pnpm/mdast-util-gfm@3.1.0/node_modules/mdast-util-gfm/lib/index.js
function gfmFromMarkdown() {
  return [
    gfmAutolinkLiteralFromMarkdown(),
    gfmFootnoteFromMarkdown(),
    gfmStrikethroughFromMarkdown(),
    gfmTableFromMarkdown(),
    gfmTaskListItemFromMarkdown()
  ];
}
function gfmToMarkdown(options) {
  return {
    extensions: [
      gfmAutolinkLiteralToMarkdown(),
      gfmFootnoteToMarkdown(options),
      gfmStrikethroughToMarkdown(),
      gfmTableToMarkdown(options),
      gfmTaskListItemToMarkdown()
    ]
  };
}

// ../../node_modules/.pnpm/micromark-extension-gfm-autolink-literal@2.1.0/node_modules/micromark-extension-gfm-autolink-literal/lib/syntax.js
var wwwPrefix = {
  tokenize: tokenizeWwwPrefix,
  partial: true
};
var domain = {
  tokenize: tokenizeDomain,
  partial: true
};
var path = {
  tokenize: tokenizePath,
  partial: true
};
var trail = {
  tokenize: tokenizeTrail,
  partial: true
};
var emailDomainDotTrail = {
  tokenize: tokenizeEmailDomainDotTrail,
  partial: true
};
var wwwAutolink = {
  name: "wwwAutolink",
  tokenize: tokenizeWwwAutolink,
  previous: previousWww
};
var protocolAutolink = {
  name: "protocolAutolink",
  tokenize: tokenizeProtocolAutolink,
  previous: previousProtocol
};
var emailAutolink = {
  name: "emailAutolink",
  tokenize: tokenizeEmailAutolink,
  previous: previousEmail
};
var text3 = {};
function gfmAutolinkLiteral() {
  return {
    text: text3
  };
}
var code2 = 48;
while (code2 < 123) {
  text3[code2] = emailAutolink;
  code2++;
  if (code2 === 58) code2 = 65;
  else if (code2 === 91) code2 = 97;
}
text3[43] = emailAutolink;
text3[45] = emailAutolink;
text3[46] = emailAutolink;
text3[95] = emailAutolink;
text3[72] = [emailAutolink, protocolAutolink];
text3[104] = [emailAutolink, protocolAutolink];
text3[87] = [emailAutolink, wwwAutolink];
text3[119] = [emailAutolink, wwwAutolink];
function tokenizeEmailAutolink(effects, ok2, nok) {
  const self2 = this;
  let dot;
  let data;
  return start;
  function start(code3) {
    if (!gfmAtext(code3) || !previousEmail.call(self2, self2.previous) || previousUnbalanced(self2.events)) {
      return nok(code3);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkEmail");
    return atext(code3);
  }
  function atext(code3) {
    if (gfmAtext(code3)) {
      effects.consume(code3);
      return atext;
    }
    if (code3 === 64) {
      effects.consume(code3);
      return emailDomain;
    }
    return nok(code3);
  }
  function emailDomain(code3) {
    if (code3 === 46) {
      return effects.check(emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code3);
    }
    if (code3 === 45 || code3 === 95 || asciiAlphanumeric(code3)) {
      data = true;
      effects.consume(code3);
      return emailDomain;
    }
    return emailDomainAfter(code3);
  }
  function emailDomainDot(code3) {
    effects.consume(code3);
    dot = true;
    return emailDomain;
  }
  function emailDomainAfter(code3) {
    if (data && dot && asciiAlpha(self2.previous)) {
      effects.exit("literalAutolinkEmail");
      effects.exit("literalAutolink");
      return ok2(code3);
    }
    return nok(code3);
  }
}
function tokenizeWwwAutolink(effects, ok2, nok) {
  const self2 = this;
  return wwwStart;
  function wwwStart(code3) {
    if (code3 !== 87 && code3 !== 119 || !previousWww.call(self2, self2.previous) || previousUnbalanced(self2.events)) {
      return nok(code3);
    }
    effects.enter("literalAutolink");
    effects.enter("literalAutolinkWww");
    return effects.check(wwwPrefix, effects.attempt(domain, effects.attempt(path, wwwAfter), nok), nok)(code3);
  }
  function wwwAfter(code3) {
    effects.exit("literalAutolinkWww");
    effects.exit("literalAutolink");
    return ok2(code3);
  }
}
function tokenizeProtocolAutolink(effects, ok2, nok) {
  const self2 = this;
  let buffer = "";
  let seen = false;
  return protocolStart;
  function protocolStart(code3) {
    if ((code3 === 72 || code3 === 104) && previousProtocol.call(self2, self2.previous) && !previousUnbalanced(self2.events)) {
      effects.enter("literalAutolink");
      effects.enter("literalAutolinkHttp");
      buffer += String.fromCodePoint(code3);
      effects.consume(code3);
      return protocolPrefixInside;
    }
    return nok(code3);
  }
  function protocolPrefixInside(code3) {
    if (asciiAlpha(code3) && buffer.length < 5) {
      buffer += String.fromCodePoint(code3);
      effects.consume(code3);
      return protocolPrefixInside;
    }
    if (code3 === 58) {
      const protocol = buffer.toLowerCase();
      if (protocol === "http" || protocol === "https") {
        effects.consume(code3);
        return protocolSlashesInside;
      }
    }
    return nok(code3);
  }
  function protocolSlashesInside(code3) {
    if (code3 === 47) {
      effects.consume(code3);
      if (seen) {
        return afterProtocol;
      }
      seen = true;
      return protocolSlashesInside;
    }
    return nok(code3);
  }
  function afterProtocol(code3) {
    return code3 === null || asciiControl(code3) || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3) || unicodePunctuation(code3) ? nok(code3) : effects.attempt(domain, effects.attempt(path, protocolAfter), nok)(code3);
  }
  function protocolAfter(code3) {
    effects.exit("literalAutolinkHttp");
    effects.exit("literalAutolink");
    return ok2(code3);
  }
}
function tokenizeWwwPrefix(effects, ok2, nok) {
  let size5 = 0;
  return wwwPrefixInside;
  function wwwPrefixInside(code3) {
    if ((code3 === 87 || code3 === 119) && size5 < 3) {
      size5++;
      effects.consume(code3);
      return wwwPrefixInside;
    }
    if (code3 === 46 && size5 === 3) {
      effects.consume(code3);
      return wwwPrefixAfter;
    }
    return nok(code3);
  }
  function wwwPrefixAfter(code3) {
    return code3 === null ? nok(code3) : ok2(code3);
  }
}
function tokenizeDomain(effects, ok2, nok) {
  let underscoreInLastSegment;
  let underscoreInLastLastSegment;
  let seen;
  return domainInside;
  function domainInside(code3) {
    if (code3 === 46 || code3 === 95) {
      return effects.check(trail, domainAfter, domainAtPunctuation)(code3);
    }
    if (code3 === null || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3) || code3 !== 45 && unicodePunctuation(code3)) {
      return domainAfter(code3);
    }
    seen = true;
    effects.consume(code3);
    return domainInside;
  }
  function domainAtPunctuation(code3) {
    if (code3 === 95) {
      underscoreInLastSegment = true;
    } else {
      underscoreInLastLastSegment = underscoreInLastSegment;
      underscoreInLastSegment = void 0;
    }
    effects.consume(code3);
    return domainInside;
  }
  function domainAfter(code3) {
    if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) {
      return nok(code3);
    }
    return ok2(code3);
  }
}
function tokenizePath(effects, ok2) {
  let sizeOpen = 0;
  let sizeClose = 0;
  return pathInside;
  function pathInside(code3) {
    if (code3 === 40) {
      sizeOpen++;
      effects.consume(code3);
      return pathInside;
    }
    if (code3 === 41 && sizeClose < sizeOpen) {
      return pathAtPunctuation(code3);
    }
    if (code3 === 33 || code3 === 34 || code3 === 38 || code3 === 39 || code3 === 41 || code3 === 42 || code3 === 44 || code3 === 46 || code3 === 58 || code3 === 59 || code3 === 60 || code3 === 63 || code3 === 93 || code3 === 95 || code3 === 126) {
      return effects.check(trail, ok2, pathAtPunctuation)(code3);
    }
    if (code3 === null || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3)) {
      return ok2(code3);
    }
    effects.consume(code3);
    return pathInside;
  }
  function pathAtPunctuation(code3) {
    if (code3 === 41) {
      sizeClose++;
    }
    effects.consume(code3);
    return pathInside;
  }
}
function tokenizeTrail(effects, ok2, nok) {
  return trail2;
  function trail2(code3) {
    if (code3 === 33 || code3 === 34 || code3 === 39 || code3 === 41 || code3 === 42 || code3 === 44 || code3 === 46 || code3 === 58 || code3 === 59 || code3 === 63 || code3 === 95 || code3 === 126) {
      effects.consume(code3);
      return trail2;
    }
    if (code3 === 38) {
      effects.consume(code3);
      return trailCharacterReferenceStart;
    }
    if (code3 === 93) {
      effects.consume(code3);
      return trailBracketAfter;
    }
    if (
      // `<` is an end.
      code3 === 60 || // So is whitespace.
      code3 === null || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3)
    ) {
      return ok2(code3);
    }
    return nok(code3);
  }
  function trailBracketAfter(code3) {
    if (code3 === null || code3 === 40 || code3 === 91 || markdownLineEndingOrSpace(code3) || unicodeWhitespace(code3)) {
      return ok2(code3);
    }
    return trail2(code3);
  }
  function trailCharacterReferenceStart(code3) {
    return asciiAlpha(code3) ? trailCharacterReferenceInside(code3) : nok(code3);
  }
  function trailCharacterReferenceInside(code3) {
    if (code3 === 59) {
      effects.consume(code3);
      return trail2;
    }
    if (asciiAlpha(code3)) {
      effects.consume(code3);
      return trailCharacterReferenceInside;
    }
    return nok(code3);
  }
}
function tokenizeEmailDomainDotTrail(effects, ok2, nok) {
  return start;
  function start(code3) {
    effects.consume(code3);
    return after;
  }
  function after(code3) {
    return asciiAlphanumeric(code3) ? nok(code3) : ok2(code3);
  }
}
function previousWww(code3) {
  return code3 === null || code3 === 40 || code3 === 42 || code3 === 95 || code3 === 91 || code3 === 93 || code3 === 126 || markdownLineEndingOrSpace(code3);
}
function previousProtocol(code3) {
  return !asciiAlpha(code3);
}
function previousEmail(code3) {
  return !(code3 === 47 || gfmAtext(code3));
}
function gfmAtext(code3) {
  return code3 === 43 || code3 === 45 || code3 === 46 || code3 === 95 || asciiAlphanumeric(code3);
}
function previousUnbalanced(events) {
  let index2 = events.length;
  let result = false;
  while (index2--) {
    const token = events[index2][1];
    if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
      result = true;
      break;
    }
    if (token._gfmAutolinkLiteralWalkedInto) {
      result = false;
      break;
    }
  }
  if (events.length > 0 && !result) {
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
  }
  return result;
}

// ../../node_modules/.pnpm/micromark-core-commonmark@2.0.2/node_modules/micromark-core-commonmark/lib/blank-line.js
var blankLine = {
  partial: true,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(effects, ok2, nok) {
  return start;
  function start(code3) {
    return markdownSpace(code3) ? factorySpace(effects, after, "linePrefix")(code3) : after(code3);
  }
  function after(code3) {
    return code3 === null || markdownLineEnding(code3) ? ok2(code3) : nok(code3);
  }
}

// ../../node_modules/.pnpm/micromark-extension-gfm-footnote@2.1.0/node_modules/micromark-extension-gfm-footnote/lib/syntax.js
var indent = {
  tokenize: tokenizeIndent,
  partial: true
};
function gfmFootnote() {
  return {
    document: {
      [91]: {
        name: "gfmFootnoteDefinition",
        tokenize: tokenizeDefinitionStart,
        continuation: {
          tokenize: tokenizeDefinitionContinuation
        },
        exit: gfmFootnoteDefinitionEnd
      }
    },
    text: {
      [91]: {
        name: "gfmFootnoteCall",
        tokenize: tokenizeGfmFootnoteCall
      },
      [93]: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: tokenizePotentialGfmFootnoteCall,
        resolveTo: resolveToPotentialGfmFootnoteCall
      }
    }
  };
}
function tokenizePotentialGfmFootnoteCall(effects, ok2, nok) {
  const self2 = this;
  let index2 = self2.events.length;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let labelStart;
  while (index2--) {
    const token = self2.events[index2][1];
    if (token.type === "labelImage") {
      labelStart = token;
      break;
    }
    if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") {
      break;
    }
  }
  return start;
  function start(code3) {
    if (!labelStart || !labelStart._balanced) {
      return nok(code3);
    }
    const id = normalizeIdentifier(self2.sliceSerialize({
      start: labelStart.end,
      end: self2.now()
    }));
    if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) {
      return nok(code3);
    }
    effects.enter("gfmFootnoteCallLabelMarker");
    effects.consume(code3);
    effects.exit("gfmFootnoteCallLabelMarker");
    return ok2(code3);
  }
}
function resolveToPotentialGfmFootnoteCall(events, context) {
  let index2 = events.length;
  let labelStart;
  while (index2--) {
    if (events[index2][1].type === "labelImage" && events[index2][0] === "enter") {
      labelStart = events[index2][1];
      break;
    }
  }
  events[index2 + 1][1].type = "data";
  events[index2 + 3][1].type = "gfmFootnoteCallLabelMarker";
  const call = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, events[index2 + 3][1].start),
    end: Object.assign({}, events[events.length - 1][1].end)
  };
  const marker = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, events[index2 + 3][1].end),
    end: Object.assign({}, events[index2 + 3][1].end)
  };
  marker.end.column++;
  marker.end.offset++;
  marker.end._bufferIndex++;
  const string = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, marker.end),
    end: Object.assign({}, events[events.length - 1][1].start)
  };
  const chunk = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, string.start),
    end: Object.assign({}, string.end)
  };
  const replacement = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    events[index2 + 1],
    events[index2 + 2],
    ["enter", call, context],
    // The `[`
    events[index2 + 3],
    events[index2 + 4],
    // The `^`.
    ["enter", marker, context],
    ["exit", marker, context],
    // Everything in between.
    ["enter", string, context],
    ["enter", chunk, context],
    ["exit", chunk, context],
    ["exit", string, context],
    // The ending (`]`, properly parsed and labelled).
    events[events.length - 2],
    events[events.length - 1],
    ["exit", call, context]
  ];
  events.splice(index2, events.length - index2 + 1, ...replacement);
  return events;
}
function tokenizeGfmFootnoteCall(effects, ok2, nok) {
  const self2 = this;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let size5 = 0;
  let data;
  return start;
  function start(code3) {
    effects.enter("gfmFootnoteCall");
    effects.enter("gfmFootnoteCallLabelMarker");
    effects.consume(code3);
    effects.exit("gfmFootnoteCallLabelMarker");
    return callStart;
  }
  function callStart(code3) {
    if (code3 !== 94) return nok(code3);
    effects.enter("gfmFootnoteCallMarker");
    effects.consume(code3);
    effects.exit("gfmFootnoteCallMarker");
    effects.enter("gfmFootnoteCallString");
    effects.enter("chunkString").contentType = "string";
    return callData;
  }
  function callData(code3) {
    if (
      // Too long.
      size5 > 999 || // Closing brace with nothing.
      code3 === 93 && !data || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code3 === null || code3 === 91 || markdownLineEndingOrSpace(code3)
    ) {
      return nok(code3);
    }
    if (code3 === 93) {
      effects.exit("chunkString");
      const token = effects.exit("gfmFootnoteCallString");
      if (!defined.includes(normalizeIdentifier(self2.sliceSerialize(token)))) {
        return nok(code3);
      }
      effects.enter("gfmFootnoteCallLabelMarker");
      effects.consume(code3);
      effects.exit("gfmFootnoteCallLabelMarker");
      effects.exit("gfmFootnoteCall");
      return ok2;
    }
    if (!markdownLineEndingOrSpace(code3)) {
      data = true;
    }
    size5++;
    effects.consume(code3);
    return code3 === 92 ? callEscape : callData;
  }
  function callEscape(code3) {
    if (code3 === 91 || code3 === 92 || code3 === 93) {
      effects.consume(code3);
      size5++;
      return callData;
    }
    return callData(code3);
  }
}
function tokenizeDefinitionStart(effects, ok2, nok) {
  const self2 = this;
  const defined = self2.parser.gfmFootnotes || (self2.parser.gfmFootnotes = []);
  let identifier;
  let size5 = 0;
  let data;
  return start;
  function start(code3) {
    effects.enter("gfmFootnoteDefinition")._container = true;
    effects.enter("gfmFootnoteDefinitionLabel");
    effects.enter("gfmFootnoteDefinitionLabelMarker");
    effects.consume(code3);
    effects.exit("gfmFootnoteDefinitionLabelMarker");
    return labelAtMarker;
  }
  function labelAtMarker(code3) {
    if (code3 === 94) {
      effects.enter("gfmFootnoteDefinitionMarker");
      effects.consume(code3);
      effects.exit("gfmFootnoteDefinitionMarker");
      effects.enter("gfmFootnoteDefinitionLabelString");
      effects.enter("chunkString").contentType = "string";
      return labelInside;
    }
    return nok(code3);
  }
  function labelInside(code3) {
    if (
      // Too long.
      size5 > 999 || // Closing brace with nothing.
      code3 === 93 && !data || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      code3 === null || code3 === 91 || markdownLineEndingOrSpace(code3)
    ) {
      return nok(code3);
    }
    if (code3 === 93) {
      effects.exit("chunkString");
      const token = effects.exit("gfmFootnoteDefinitionLabelString");
      identifier = normalizeIdentifier(self2.sliceSerialize(token));
      effects.enter("gfmFootnoteDefinitionLabelMarker");
      effects.consume(code3);
      effects.exit("gfmFootnoteDefinitionLabelMarker");
      effects.exit("gfmFootnoteDefinitionLabel");
      return labelAfter;
    }
    if (!markdownLineEndingOrSpace(code3)) {
      data = true;
    }
    size5++;
    effects.consume(code3);
    return code3 === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code3) {
    if (code3 === 91 || code3 === 92 || code3 === 93) {
      effects.consume(code3);
      size5++;
      return labelInside;
    }
    return labelInside(code3);
  }
  function labelAfter(code3) {
    if (code3 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code3);
      effects.exit("definitionMarker");
      if (!defined.includes(identifier)) {
        defined.push(identifier);
      }
      return factorySpace(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
    }
    return nok(code3);
  }
  function whitespaceAfter(code3) {
    return ok2(code3);
  }
}
function tokenizeDefinitionContinuation(effects, ok2, nok) {
  return effects.check(blankLine, ok2, effects.attempt(indent, ok2, nok));
}
function gfmFootnoteDefinitionEnd(effects) {
  effects.exit("gfmFootnoteDefinition");
}
function tokenizeIndent(effects, ok2, nok) {
  const self2 = this;
  return factorySpace(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 4 + 1);
  function afterPrefix(code3) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok2(code3) : nok(code3);
  }
}

// ../../node_modules/.pnpm/micromark-extension-gfm@3.0.0/node_modules/micromark-extension-gfm/index.js
function gfm(options) {
  return combineExtensions([
    gfmAutolinkLiteral(),
    gfmFootnote(),
    gfmStrikethrough(options),
    gfmTable(),
    gfmTaskListItem()
  ]);
}

// ../../node_modules/.pnpm/remark-gfm@4.0.1/node_modules/remark-gfm/lib/index.js
var emptyOptions2 = {};
function remarkGfm(options) {
  const self2 = (
    /** @type {Processor<Root>} */
    this
  );
  const settings = options || emptyOptions2;
  const data = self2.data();
  const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
  const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
  const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
  micromarkExtensions.push(gfm(settings));
  fromMarkdownExtensions.push(gfmFromMarkdown());
  toMarkdownExtensions.push(gfmToMarkdown(settings));
}

// src/components/composite/Timeline/ContentChips/productMentions.ts
var PRODUCT_MENTION_REGEX = /@\[([^\]]+)\](?:\([^)]*\))?/g;
function resolveProductMention(productMap, productKey) {
  if (!productMap || typeof productKey !== "string") return void 0;
  if (Object.hasOwn(productMap, productKey)) return productMap[productKey];
  const trimmed = productKey.trim();
  return Object.hasOwn(productMap, trimmed) ? productMap[trimmed] : void 0;
}
function unresolvedMentionText(productKey) {
  return `@[${productKey.trim()}]`;
}
function resolveProductUrl(url, storeDomain) {
  if (!url) return void 0;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (!storeDomain) return url;
  const base = storeDomain.endsWith("/") ? storeDomain.slice(0, -1) : storeDomain;
  return `${base}${url.startsWith("/") ? url : `/${url}`}`;
}

// src/components/composite/Timeline/ContentChips/ProductMentionChip.tsx
import { Fragment as Fragment15, jsx as jsx63, jsxs as jsxs34 } from "react/jsx-runtime";
function urlWithoutQuery(url) {
  try {
    const u = new URL(url);
    const path2 = u.pathname.replace(/\/$/, "") || "/";
    return `${u.origin}${path2}`;
  } catch {
    return url;
  }
}
function isProductCurrentPage(productUrl) {
  if (typeof window === "undefined" || !productUrl) return false;
  const current = urlWithoutQuery(window.location.href);
  const product = urlWithoutQuery(productUrl);
  return current === product;
}
function ProductMentionChip({
  product,
  size: size5 = "message",
  className = "",
  style,
  storeDomain
}) {
  const { t } = useComponentsTranslation();
  const fullProductUrl = resolveProductUrl(product.url, storeDomain);
  const isCurrentPage = fullProductUrl ? isProductCurrentPage(fullProductUrl) : false;
  const isClickable = !!fullProductUrl && !isCurrentPage;
  const displayTitle = product.title.length > 20 ? `${product.title.slice(0, 20)}\u2026` : product.title;
  const chipTitle = isCurrentPage ? t("productMention.currentProductChip") : product.title;
  const content = /* @__PURE__ */ jsxs34(Fragment15, { children: [
    /* @__PURE__ */ jsx63(
      ImageFrame,
      {
        ...product.imageUrl ? shopifyImageSource(product.imageUrl, MENTION_CHIP_IMAGE_PX) : void 0,
        alt: "",
        fallback: "bag-filled",
        className: product.imageUrl ? "product-mention-chip-image" : "product-mention-chip-icon"
      }
    ),
    /* @__PURE__ */ jsx63(Text, { variant: size5 === "message" ? "body-xs" : "body-sm", as: "span", className: "product-mention-chip-title", title: chipTitle, children: displayTitle })
  ] });
  const chipClassName = clsx_default(
    "product-mention-chip",
    `size-${size5}`,
    isClickable && "clickable",
    isCurrentPage && "current-page",
    className
  );
  return isClickable ? /* @__PURE__ */ jsx63(
    "a",
    {
      href: fullProductUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: chipClassName,
      style,
      contentEditable: false,
      "data-product-id": product.id,
      title: chipTitle,
      onClick: (e) => e.stopPropagation(),
      children: content
    }
  ) : /* @__PURE__ */ jsx63(
    "span",
    {
      className: chipClassName,
      style,
      contentEditable: false,
      "data-product-id": product.id,
      title: chipTitle,
      children: content
    }
  );
}

// src/components/composite/ChatMarkdown/context.ts
import * as React128 from "react";
var ChatMarkdownContext = React128.createContext({});

// src/components/composite/ChatMarkdown/copyableCode.ts
import { createContext as createContext26 } from "react";
var CopyableCodesContext = createContext26(false);
var CODE_PATTERN = /^(?=[\dA-Z_-]*[A-Z])[\dA-Z][\dA-Z_-]{3,31}$/;
function isCopyableCode(text4) {
  return CODE_PATTERN.test(text4);
}

// src/components/composite/ChatMarkdown/StreamChar.tsx
import * as React130 from "react";

// src/components/composite/ChatMarkdown/streamingAnimation.ts
import * as React129 from "react";
var STREAM_REVEAL_MS = 420;
var STREAM_STAGGER_MS = 10;
var STREAM_MAX_STAGGER_MS = 240;
var STREAM_REVEAL_HOLD_MS = 280;
var STREAM_SETTLE_MS = STREAM_REVEAL_MS + STREAM_MAX_STAGGER_MS + STREAM_REVEAL_HOLD_MS;
var NOT_STREAMED = { age: Number.POSITIVE_INFINITY, start: Number.NEGATIVE_INFINITY };
function useStreamingAge(animateState, indexKey) {
  const [initial2] = React129.useState(() => {
    if (!animateState) return NOT_STREAMED;
    const now = Date.now();
    let st = animateState.charStartTimes.get(indexKey);
    if (!st) {
      st = Math.min(Math.max(now, (animateState.lastStartTime ?? 0) + STREAM_STAGGER_MS), now + STREAM_MAX_STAGGER_MS);
      animateState.lastStartTime = st;
      animateState.charStartTimes.set(indexKey, st);
    }
    return { age: now - st, start: st };
  });
  return initial2;
}
function streamRevealProps(age) {
  if (age >= STREAM_REVEAL_MS) return {};
  return { className: "buyscout-char-fade-in", style: age !== 0 ? { animationDelay: `${-age}ms` } : void 0 };
}
function rehypeCharacterStream() {
  return (tree) => {
    let fallbackIndex = 0;
    visit(tree, "text", (node, index2, parent) => {
      if (!parent || parent.tagName === "code") return;
      const textValue = node.value || "";
      if (/^\s*$/.test(textValue) && textValue.includes("\n")) return;
      const chars = Array.from(textValue);
      let currentOffset = node.position?.start?.offset;
      const newNodes = chars.map((char) => {
        const charIndex = typeof currentOffset === "number" ? currentOffset : fallbackIndex++;
        if (typeof currentOffset === "number") currentOffset += char.length;
        return {
          type: "element",
          tagName: "stream-char",
          properties: { charIndex },
          children: [{ type: "text", value: char }]
        };
      });
      if (typeof index2 !== "number") return;
      parent.children?.splice(index2, 1, ...newNodes);
      return [SKIP, index2 + newNodes.length];
    });
  };
}
function closeOpenMarker(text4, marker) {
  const trailingMatch = text4.match(/(\s+)$/);
  if (trailingMatch) {
    const ws = trailingMatch[1];
    let base = text4.slice(0, -ws.length);
    if (base.endsWith(marker)) base += "\u200B";
    return `${base}${marker}${ws}`;
  }
  if (text4.endsWith(marker)) return `${text4}\u200B${marker}`;
  return `${text4}${marker}`;
}
function preprocessStreamingContent(content) {
  let processed = content;
  processed = processed.replace(/@\[[^\]]*$/, "");
  processed = processed.replace(/@\[([^\]]+)\]\([^)]*$/, "@[$1]");
  processed = processed.replace(/(?<!@)!?\[[^\]]*\]\([^)]*$/, "");
  processed = processed.replace(/(?<!@)!?\[[^\]]*\]$/, "");
  processed = processed.replace(/(?<!@)!?\[[^\]\n]*$/, "");
  const codeBlockMatches = processed.match(/```/g) || [];
  if (codeBlockMatches.length % 2 !== 0) {
    processed += "\n```";
  } else {
    const doubleAsterisks = (processed.match(/\*\*/g) || []).length;
    if (doubleAsterisks % 2 !== 0) processed = closeOpenMarker(processed, "**");
    const singleAsterisks = (processed.replace(/\*\*/g, "").match(/\*/g) || []).length;
    if (singleAsterisks % 2 !== 0) processed = closeOpenMarker(processed, "*");
    const inlineBackticks = (processed.replace(/```/g, "").match(/`/g) || []).length;
    if (inlineBackticks % 2 !== 0) processed += "`";
  }
  return processed;
}

// src/components/composite/ChatMarkdown/StreamChar.tsx
import { Fragment as Fragment16, jsx as jsx64 } from "react/jsx-runtime";
var CharSpan = React130.memo(({ char, globalIndex }) => {
  const { animateState, settledAt = Number.NEGATIVE_INFINITY } = React130.use(ChatMarkdownContext);
  const { age, start } = useStreamingAge(animateState, globalIndex);
  const reveal = streamRevealProps(age);
  if (!reveal.className || start + STREAM_REVEAL_MS + STREAM_REVEAL_HOLD_MS <= settledAt) return /* @__PURE__ */ jsx64(Fragment16, { children: char });
  return /* @__PURE__ */ jsx64("span", { ...reveal, children: char });
});
CharSpan.displayName = "CharSpan";
var StreamChar = React130.memo(({ charIndex, children }) => /* @__PURE__ */ jsx64(CharSpan, { globalIndex: Number(charIndex), char: children }));
StreamChar.displayName = "StreamChar";

// src/components/composite/ChatMarkdown/TableWrapper.tsx
import * as React131 from "react";
import { jsx as jsx65, jsxs as jsxs35 } from "react/jsx-runtime";
function TableWrapper({ children }) {
  const wrapperRef = React131.useRef(null);
  const containerRef = React131.useRef(null);
  useScrollEdges(containerRef, wrapperRef);
  return /* @__PURE__ */ jsxs35("div", { className: "buyscout-table-wrapper", ref: wrapperRef, children: [
    /* @__PURE__ */ jsx65("div", { className: "buyscout-table-container", ref: containerRef, children: /* @__PURE__ */ jsx65("table", { children }) }),
    /* @__PURE__ */ jsx65("div", { className: "buyscout-table-shadow-left", "aria-hidden": "true" }),
    /* @__PURE__ */ jsx65("div", { className: "buyscout-table-shadow-right", "aria-hidden": "true" })
  ] });
}

// src/components/composite/ChatMarkdown/urlTransform.ts
function chatUrlTransform(url, key) {
  return key === "href" && url.startsWith("mention:") ? url : defaultUrlTransform(url);
}

// src/components/composite/ChatMarkdown/ChatMarkdown.tsx
import { Fragment as Fragment17, jsx as jsx66, jsxs as jsxs36 } from "react/jsx-runtime";
function encodeMentionUrlSegment(productKey) {
  return encodeURIComponent(productKey.trim()).replace(/\(/g, "%28").replace(/\)/g, "%29");
}
function decodeMentionProductKey(segment) {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}
var CustomAnchor = React132.memo(({ node, href, children, ...props }) => {
  const { animateState, isStreaming, productMap, storeDomain } = React132.use(ChatMarkdownContext);
  const offset5 = node?.position?.start?.offset ?? href;
  const { age } = useStreamingAge(animateState, `a-${offset5}`);
  const { className = "", style } = isStreaming ? streamRevealProps(age) : {};
  if (href?.startsWith("mention:")) {
    const productKey = decodeMentionProductKey(href.slice(8));
    const product = resolveProductMention(productMap, productKey);
    return product ? /* @__PURE__ */ jsx66(Text, { variant: "body", as: "span", style, className, children: /* @__PURE__ */ jsx66(
      ProductMentionChip,
      {
        product,
        storeDomain
      }
    ) }) : /* @__PURE__ */ jsx66(Text, { variant: "body", as: "span", style, className, children: unresolvedMentionText(productKey) });
  }
  return /* @__PURE__ */ jsx66(
    Link,
    {
      variant: "accent",
      href,
      target: "_blank",
      rel: "noopener noreferrer",
      className: `buyscout-chat-markdown-link ${className}`.trim(),
      style,
      ...props,
      onClick: (e) => {
        e.stopPropagation();
        props.onClick?.(e);
      },
      children
    }
  );
});
CustomAnchor.displayName = "CustomAnchor";
var CustomImage = React132.memo(({ node, src, alt }) => {
  const { animateState, isStreaming } = React132.use(ChatMarkdownContext);
  const offset5 = node?.position?.start?.offset ?? src;
  const { age } = useStreamingAge(animateState, `img-${offset5}`);
  const [failedSrc, setFailedSrc] = React132.useState(null);
  const [lightboxOpen, setLightboxOpen] = React132.useState(false);
  const [container, handleThumbnailRef] = useShadowPortalContainer();
  const triggerProps = useLightboxTriggerProps(alt, () => setLightboxOpen(true));
  const failed = !src || failedSrc === src;
  const reveal = isStreaming ? streamRevealProps(age) : {};
  return /* @__PURE__ */ jsxs36(Fragment17, { children: [
    /* @__PURE__ */ jsx66(
      ImageFrame,
      {
        ref: handleThumbnailRef,
        src: src || void 0,
        alt: alt ?? "",
        fallback: "alt",
        loading: "lazy",
        className: failed ? alt ? void 0 : "buyscout-image-unavailable" : clsx_default("buyscout-image-container", reveal.className),
        imgClassName: "buyscout-image-thumbnail",
        style: failed ? void 0 : reveal.style,
        onError: () => setFailedSrc(src),
        ...!failed && {
          ...triggerProps,
          onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
            setLightboxOpen(true);
          }
        }
      }
    ),
    !failed && /* @__PURE__ */ jsx66(ChatImageLightbox, { open: lightboxOpen, onOpenChange: setLightboxOpen, url: src, alt, container })
  ] });
});
CustomImage.displayName = "CustomImage";
var CustomCode = React132.memo(({ node: _node, children, ...props }) => {
  const { t } = useComponentsTranslation();
  const copyable = React132.use(CopyableCodesContext);
  const { isStreaming } = React132.use(ChatMarkdownContext);
  if (copyable && !isStreaming && typeof children === "string" && isCopyableCode(children)) {
    return /* @__PURE__ */ jsx66(CopyButton, { value: children, label: children, "aria-label": t("copyButton.copyValue", { value: children }), className: "buyscout-chat-markdown-code" });
  }
  return /* @__PURE__ */ jsx66("code", { ...props, children });
});
CustomCode.displayName = "CustomCode";
var MARKDOWN_COMPONENTS = {
  "stream-char": StreamChar,
  "a": CustomAnchor,
  "img": CustomImage,
  "code": CustomCode,
  "table": TableWrapper
};
var REMARK_PLUGINS = [remarkGfm, remarkBreaks];
var STREAMING_REHYPE_PLUGINS = [rehypeCharacterStream];
function parseMarkdown(content, revealing) {
  return Markdown({
    remarkPlugins: REMARK_PLUGINS,
    rehypePlugins: revealing ? STREAMING_REHYPE_PLUGINS : [],
    components: MARKDOWN_COMPONENTS,
    urlTransform: chatUrlTransform,
    children: content
  });
}
var SETTLED_CACHE_LIMIT = 200;
var settledMarkdown = /* @__PURE__ */ new Map();
function settledMarkdownFor(content) {
  const cached = settledMarkdown.get(content);
  if (cached) {
    settledMarkdown.delete(content);
    settledMarkdown.set(content, cached);
    return cached;
  }
  const parsed = parseMarkdown(content, false);
  settledMarkdown.set(content, parsed);
  if (settledMarkdown.size > SETTLED_CACHE_LIMIT) settledMarkdown.delete(settledMarkdown.keys().next().value);
  return parsed;
}
function ChatMarkdownImpl({
  content,
  productMap,
  storeDomain,
  isStreaming,
  animateState
}) {
  const [wasStreaming, setWasStreaming] = React132.useState(isStreaming);
  const [settling, setSettling] = React132.useState(false);
  if (isStreaming !== wasStreaming) {
    setWasStreaming(isStreaming);
    setSettling(Boolean(wasStreaming && !isStreaming));
  }
  React132.useEffect(() => {
    if (!settling) return;
    const timer = setTimeout(setSettling, STREAM_SETTLE_MS, false);
    return () => clearTimeout(timer);
  }, [settling]);
  const revealing = Boolean(isStreaming || settling);
  const [settledAt, setSettledAt] = React132.useState(Number.NEGATIVE_INFINITY);
  React132.useEffect(() => {
    const newest = animateState?.lastStartTime;
    if (!revealing || newest === void 0 || newest + STREAM_REVEAL_MS <= settledAt) return;
    const delay = Number.isFinite(settledAt) ? settledAt + STREAM_REVEAL_MS - Date.now() : 0;
    const timer = setTimeout(() => setSettledAt(Date.now()), Math.max(0, delay));
    return () => clearTimeout(timer);
  });
  const contextValue = React132.useMemo(
    () => ({ animateState, isStreaming: revealing, settledAt, productMap, storeDomain }),
    [animateState, revealing, settledAt, productMap, storeDomain]
  );
  let processedContent = isStreaming ? preprocessStreamingContent(content) : content;
  if (productMap) {
    processedContent = processedContent.replace(PRODUCT_MENTION_REGEX, (_match, productKey) => `[mention_chip](mention:${encodeMentionUrlSegment(productKey)})`);
  }
  processedContent = processedContent.replace(
    /\[mention_chip\]\(mention:([^)]+)\)/g,
    (_match, rawKey) => `[mention_chip](mention:${encodeMentionUrlSegment(decodeMentionProductKey(rawKey))})`
  );
  const markdown = React132.useMemo(
    () => revealing ? parseMarkdown(processedContent, true) : settledMarkdownFor(processedContent),
    [processedContent, revealing]
  );
  return /* @__PURE__ */ jsx66(ChatMarkdownContext, { value: contextValue, children: markdown });
}
var ChatMarkdown = React132.memo(ChatMarkdownImpl);
ChatMarkdown.displayName = "ChatMarkdown";

// src/components/primitive/Button/StableLabel.tsx
import { jsx as jsx67, jsxs as jsxs37 } from "react/jsx-runtime";
function StableLabel({ labels, children }) {
  const shown = labels.indexOf(children);
  if (shown === -1) {
    return /* @__PURE__ */ jsxs37("span", { className: "buyscout-stable-label", children: [
      labels.map((label, index2) => /* @__PURE__ */ jsx67("span", { className: "buyscout-stable-label__layer", "aria-hidden": "true", children: label }, index2)),
      /* @__PURE__ */ jsx67("span", { className: "buyscout-stable-label__layer", "data-shown": true, children })
    ] });
  }
  return /* @__PURE__ */ jsx67("span", { className: "buyscout-stable-label", children: labels.map((label, index2) => /* @__PURE__ */ jsx67("span", { className: "buyscout-stable-label__layer", "data-shown": index2 === shown || void 0, "aria-hidden": index2 !== shown || void 0, children: label }, index2)) });
}
StableLabel.displayName = "StableLabel";

// src/components/composite/Timeline/shared/useAddToCartState.ts
import { useEffect as useEffect40, useRef as useRef61, useState as useState49 } from "react";
var SETTLED_MS = 2e3;
function addToCartAriaLabel(t, state, title) {
  if (state === "added") return t("product.addedAria", { title });
  if (state === "error") return t("product.failedAria", { title });
  return t("product.addToCartAria", { title });
}
function useAddToCartState(onAddToCart) {
  const [states, setStates] = useState49({});
  const [outcome, setOutcome] = useState49(null);
  const timersRef = useRef61(/* @__PURE__ */ new Set());
  useEffect40(() => {
    const timers = timersRef.current;
    return () => timers.forEach(clearTimeout);
  }, []);
  const cartStateOf = (productId) => states[productId] ?? "idle";
  const settle = (product, state) => {
    const settled = { product, state };
    setStates((prev) => ({ ...prev, [product.id]: state }));
    setOutcome(settled);
    const timer = setTimeout(() => {
      timersRef.current.delete(timer);
      setStates((prev) => ({ ...prev, [product.id]: "idle" }));
      setOutcome((prev) => prev === settled ? null : prev);
    }, SETTLED_MS);
    timersRef.current.add(timer);
  };
  const addToCart = async (product) => {
    if (!onAddToCart) return;
    const state = cartStateOf(product.id);
    if (state === "loading" || state === "added") return;
    setStates((prev) => ({ ...prev, [product.id]: "loading" }));
    try {
      await onAddToCart(product);
      settle(product, "added");
    } catch {
      settle(product, "error");
    }
  };
  return { cartStateOf, addToCart, outcome };
}

// src/components/composite/Timeline/shared/AddToCartStatus.tsx
import { jsx as jsx68 } from "react/jsx-runtime";
function AddToCartStatus({ outcome, t }) {
  return /* @__PURE__ */ jsx68("span", { role: "status", className: "buyscout-add-to-cart-status", children: outcome ? addToCartAriaLabel(t, outcome.state, outcome.product.title) : "" });
}
AddToCartStatus.displayName = "AddToCartStatus";

// src/components/composite/Timeline/ProductCard/ProductCard.tsx
import { Fragment as Fragment18, jsx as jsx69, jsxs as jsxs38 } from "react/jsx-runtime";
var SINGLE_IMAGE_PX = 160;
function ProductCard({ product, storeDomain, onAddToCart }) {
  const { t } = useTranslation();
  const { cartStateOf, addToCart, outcome } = useAddToCartState(onAddToCart);
  const cartState = cartStateOf(product.id);
  const productUrl = resolveProductUrl(product.url, storeDomain);
  const isLoading = cartState === "loading";
  const isAdded = cartState === "added";
  const addedLabel = /* @__PURE__ */ jsxs38(Fragment18, { children: [
    /* @__PURE__ */ jsx69(DrawnCheck, { drawn: isAdded }),
    t("product.added")
  ] });
  const isError = cartState === "error";
  return /* @__PURE__ */ jsxs38(Fragment18, { children: [
    /* @__PURE__ */ jsxs38("div", { className: "buyscout-product-card-single", children: [
      /* @__PURE__ */ jsx69(
        ImageFrame,
        {
          ...product.imageUrl ? shopifyImageSource(product.imageUrl, SINGLE_IMAGE_PX) : void 0,
          alt: "",
          fallback: "bag",
          loading: "lazy",
          className: "buyscout-product-card-single-image",
          imgClassName: "buyscout-product-card-single-image-img"
        }
      ),
      /* @__PURE__ */ jsxs38("div", { className: "buyscout-product-card-single-info", children: [
        /* @__PURE__ */ jsx69(Text, { variant: "body-bold", as: "h3", className: "buyscout-product-card-single-title", children: productUrl ? /* @__PURE__ */ jsx69("a", { href: productUrl, target: "_blank", rel: "noopener noreferrer", className: "buyscout-product-card-single-link", children: product.title }) : product.title }),
        /* @__PURE__ */ jsx69(Text, { variant: "body-bold", as: "span", className: "buyscout-product-card-single-price", children: product.price }),
        onAddToCart && /* @__PURE__ */ jsx69(
          Button,
          {
            type: "button",
            variant: "prominent",
            size: "sm",
            color: isAdded ? "success" : isError ? "error" : "primary",
            className: `buyscout-product-card-single-add-to-cart buyscout-add-to-cart ${cartState}`,
            "data-cart-state": cartState,
            onClick: () => {
              void addToCart(product);
            },
            loading: isLoading,
            "aria-disabled": isAdded || void 0,
            "aria-label": addToCartAriaLabel(t, cartState, product.title),
            children: /* @__PURE__ */ jsx69(StableLabel, { labels: [t("product.addToCart"), addedLabel, t("product.failed")], children: isAdded ? addedLabel : isError ? t("product.failed") : t("product.addToCart") })
          }
        )
      ] })
    ] }),
    onAddToCart && /* @__PURE__ */ jsx69(AddToCartStatus, { outcome, t })
  ] });
}

// src/components/composite/Timeline/ProductCard/ProductCardTimelineItem.tsx
import { jsx as jsx70, jsxs as jsxs39 } from "react/jsx-runtime";
function ProductCardSkeleton({ hasAddToCart }) {
  return /* @__PURE__ */ jsxs39("div", { className: "buyscout-product-card-single-skeleton", children: [
    /* @__PURE__ */ jsx70(Skeleton, { variant: "rect", className: "buyscout-product-card-single-skeleton-image" }),
    /* @__PURE__ */ jsxs39("div", { className: "buyscout-product-card-single-skeleton-info", children: [
      /* @__PURE__ */ jsxs39("div", { className: "buyscout-product-card-single-skeleton-title", children: [
        /* @__PURE__ */ jsx70(Skeleton, { width: "85%" }),
        /* @__PURE__ */ jsx70(Skeleton, { width: "60%" })
      ] }),
      /* @__PURE__ */ jsx70(Skeleton, { width: "45%", className: "buyscout-product-card-single-skeleton-price" }),
      hasAddToCart && /* @__PURE__ */ jsx70(Skeleton, { variant: "rect", width: 100, className: "buyscout-product-card-single-skeleton-cart" })
    ] })
  ] });
}
function ProductCardTimelineItem({ product, loading = false, storeDomain, onAddToCart }) {
  if (!loading && !product) {
    return null;
  }
  return /* @__PURE__ */ jsx70("div", { className: "buyscout-timeline-product-card", "aria-busy": loading || void 0, children: loading ? /* @__PURE__ */ jsx70(ProductCardSkeleton, { hasAddToCart: !!onAddToCart }) : /* @__PURE__ */ jsx70(ProductCard, { product, storeDomain, onAddToCart }) });
}

// src/components/composite/ChatControls/PresetReplyButton/PresetReplyButton.tsx
import { useCallback as useCallback22, useEffect as useEffect41, useRef as useRef62, useState as useState51 } from "react";

// src/hooks/useEntranceStagger.ts
import { useState as useState50 } from "react";
var STAGGER_CAP = "240ms";
function staggerDelay(index2, offsetMs = 0) {
  const step = `min(${index2} * var(--bs-motion-surface-stagger, 40ms), ${STAGGER_CAP})`;
  return offsetMs > 0 ? `calc(${offsetMs}ms + ${step})` : `calc(${step})`;
}
function useEntranceStagger(keys2, skip) {
  const [placed] = useState50(() => /* @__PURE__ */ new Map());
  let next = 0;
  for (const key of keys2) {
    if (placed.has(key) || skip?.has(key)) continue;
    placed.set(key, next++);
  }
  return (key) => placed.get(key) ?? 0;
}

// src/components/composite/ChatControls/PresetReplyButton/PresetReplyButton.tsx
import { jsx as jsx71 } from "react/jsx-runtime";
var BASE_CLASS = "buyscout-preset-reply-button";
var EXIT_STAGGER_DELAY_MS = 50;
var EXIT_CLICKED_EXTRA_DELAY_MS = 80;
var EXIT_DURATION_MS = 150;
function getExitDelay(index2, itemCount, reverseStagger, clickedIndex) {
  if (clickedIndex == null) {
    return (reverseStagger ? index2 : itemCount - 1 - index2) * EXIT_STAGGER_DELAY_MS;
  }
  if (index2 === clickedIndex) {
    return (itemCount - 1) * EXIT_STAGGER_DELAY_MS + EXIT_CLICKED_EXTRA_DELAY_MS;
  }
  let rank;
  if (reverseStagger) {
    rank = index2 < clickedIndex ? index2 : index2 - 1;
  } else {
    const naturalRank = itemCount - 1 - index2;
    const clickedNaturalRank = itemCount - 1 - clickedIndex;
    rank = naturalRank < clickedNaturalRank ? naturalRank : naturalRank - 1;
  }
  return rank * EXIT_STAGGER_DELAY_MS;
}
function getTotalExitDuration(itemCount, hasClickedIndex) {
  const extraDelay = hasClickedIndex ? EXIT_CLICKED_EXTRA_DELAY_MS : 0;
  return (itemCount - 1) * EXIT_STAGGER_DELAY_MS + extraDelay + EXIT_DURATION_MS;
}
function PresetReplyButton(props) {
  const {
    items,
    onItemClick,
    reverseStagger = false,
    exiting = false,
    onExitComplete,
    className = "",
    variant = "chat",
    initialDelay = 50,
    baselineItems
  } = props;
  const [clickedIndex, setClickedIndex] = useState51(null);
  const entranceIndex = useEntranceStagger(reverseStagger ? [...items].reverse() : items, baselineItems);
  const [selfExiting, setSelfExiting] = useState51(false);
  const pendingClickRef = useRef62(null);
  const isExiting = exiting || selfExiting;
  useEffect41(() => {
    if (!exiting) {
      setClickedIndex(null);
    }
  }, [exiting]);
  useEffect41(() => {
    setSelfExiting(false);
    setClickedIndex(null);
    pendingClickRef.current = null;
  }, [items]);
  const handleExitComplete = useCallback22(() => {
    const pendingValue = pendingClickRef.current;
    pendingClickRef.current = null;
    if (pendingValue != null) {
      onItemClick?.(pendingValue);
    }
    onExitComplete?.();
  }, [onItemClick, onExitComplete]);
  useEffect41(() => {
    if (!isExiting || items.length === 0) {
      return;
    }
    const totalDuration = getTotalExitDuration(items.length, clickedIndex != null);
    const timer = setTimeout(handleExitComplete, totalDuration);
    return () => clearTimeout(timer);
  }, [isExiting, items.length, clickedIndex, handleExitComplete]);
  const rootClass = [
    BASE_CLASS,
    `${BASE_CLASS}--${variant}`,
    variant === "chat" && `${BASE_CLASS}--chat-auto`,
    className
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx71("div", { className: rootClass, children: items.map((item, index2) => {
    const delay = isExiting ? `${getExitDelay(index2, items.length, reverseStagger, clickedIndex)}ms` : staggerDelay(entranceIndex(item), initialDelay);
    const isAnimated = !baselineItems?.has(item);
    const baseBubbleClass = `${BASE_CLASS}__bubble ${BASE_CLASS}__bubble--${variant}`;
    const bubbleClass = `${baseBubbleClass}${isAnimated ? ` ${BASE_CLASS}__bubble--animated` : ""}${isExiting ? ` ${BASE_CLASS}__bubble--exiting` : ""}`;
    return /* @__PURE__ */ jsx71(
      "button",
      {
        type: "button",
        className: bubbleClass,
        style: { animationDelay: delay },
        disabled: selfExiting,
        onClick: () => {
          if (isExiting) return;
          setClickedIndex(index2);
          pendingClickRef.current = item;
          setSelfExiting(true);
        },
        children: /* @__PURE__ */ jsx71("span", { className: `${BASE_CLASS}__bubble-label ${BASE_CLASS}__bubble-label--${variant}`, children: item })
      },
      item
    );
  }) });
}
PresetReplyButton.displayName = "PresetReplyButton";

// src/components/composite/ChatControls/PopupMessage/useAutoDismiss.ts
import { useCallback as useCallback23, useEffect as useEffect42, useRef as useRef63 } from "react";
function holdsFocus(surface) {
  if (!surface?.isConnected) return false;
  const active = surface.getRootNode().activeElement;
  return !!active && surface.contains(active);
}
function useAutoDismiss({ ms, enabled, onElapsed }) {
  const active = enabled && ms != null && ms > 0;
  const hoveringRef = useRef63(false);
  const surfaceRef = useRef63(null);
  const timerRef = useRef63(void 0);
  const latestRef = useRef63({ active, ms, onElapsed });
  latestRef.current = { active, ms, onElapsed };
  const resume = useCallback23((focusLeaving = false) => {
    clearTimeout(timerRef.current);
    if (!latestRef.current.active || hoveringRef.current || document.hidden) return;
    if (!focusLeaving && holdsFocus(surfaceRef.current)) return;
    timerRef.current = setTimeout(() => latestRef.current.onElapsed(), latestRef.current.ms);
  }, []);
  useEffect42(() => {
    if (!active) return;
    resume();
    const handleVisibility = () => resume();
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      clearTimeout(timerRef.current);
    };
  }, [active, ms, onElapsed, resume]);
  useEffect42(() => () => clearTimeout(timerRef.current), []);
  const onPointerEnter = useCallback23(() => {
    hoveringRef.current = true;
    clearTimeout(timerRef.current);
  }, []);
  const onPointerLeave = useCallback23(() => {
    hoveringRef.current = false;
    resume();
  }, [resume]);
  const onFocus = useCallback23((event) => {
    surfaceRef.current = event.currentTarget;
    clearTimeout(timerRef.current);
  }, []);
  const onBlur = useCallback23((event) => {
    if (event.relatedTarget instanceof Node && event.currentTarget.contains(event.relatedTarget)) return;
    resume(true);
  }, [resume]);
  return { onPointerEnter, onPointerLeave, onFocus, onBlur };
}

// src/components/composite/ChatControls/PopupMessage/usePopupContentResize.ts
import { useLayoutEffect as useLayoutEffect7, useRef as useRef64 } from "react";
var RESIZE_DURATION_MS = 200;
var RESIZE_EASING = "cubic-bezier(0.23, 1, 0.32, 1)";
function usePopupContentResize(rootRef, bodyRef, dismissing) {
  const dismissingRef = useRef64(dismissing);
  dismissingRef.current = dismissing;
  useLayoutEffect7(() => {
    const root3 = rootRef.current;
    const body = bodyRef.current;
    const clip = body?.parentElement;
    if (!root3 || !body || !clip || dismissing || root3.closest(".buyscout-chat-bar-island")) return;
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let animation = null;
    const computedSize = () => {
      const style = getComputedStyle(root3);
      return { width: Number.parseFloat(style.width), height: Number.parseFloat(style.height) };
    };
    const release2 = () => {
      root3.style.removeProperty("width");
      root3.style.removeProperty("height");
      body.style.removeProperty("width");
      clip.style.removeProperty("overflow");
    };
    let lastSize = computedSize();
    const resize = () => {
      const from = animation ? computedSize() : lastSize;
      animation?.cancel();
      animation = null;
      release2();
      const to = computedSize();
      lastSize = to;
      if (motion.matches || from.width === to.width && from.height === to.height) return;
      body.style.width = getComputedStyle(body).width;
      root3.style.width = `${to.width}px`;
      root3.style.height = `${to.height}px`;
      clip.style.overflow = "hidden";
      const next = root3.animate(
        [{ width: `${from.width}px`, height: `${from.height}px` }, { width: `${to.width}px`, height: `${to.height}px` }],
        { duration: RESIZE_DURATION_MS, easing: RESIZE_EASING }
      );
      animation = next;
      next.onfinish = () => {
        if (animation !== next) return;
        animation = null;
        release2();
      };
    };
    const observer = new MutationObserver(resize);
    observer.observe(body, { childList: true, subtree: true, characterData: true });
    observer.observe(root3, { attributes: true, attributeFilter: ["class"] });
    const onLoad = () => resize();
    body.addEventListener("load", onLoad, true);
    const sizeObserver = new ResizeObserver(() => {
      if (!animation) lastSize = computedSize();
    });
    sizeObserver.observe(root3);
    const stop = () => {
      const running = animation;
      animation = null;
      running?.cancel();
      release2();
      lastSize = computedSize();
    };
    motion.addEventListener("change", stop);
    return () => {
      observer.disconnect();
      sizeObserver.disconnect();
      body.removeEventListener("load", onLoad, true);
      motion.removeEventListener("change", stop);
      if (dismissingRef.current && animation && root3.isConnected && root3.getClientRects().length) {
        animation.commitStyles();
        animation.cancel();
        animation = null;
        return;
      }
      stop();
    };
  }, [rootRef, bodyRef, dismissing]);
}

// src/components/composite/ChatControls/PopupMessage/PopupMessage.tsx
import { jsx as jsx72, jsxs as jsxs40 } from "react/jsx-runtime";
function isInteractiveDescendant(node, stopAt) {
  let el = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
  while (el && el !== stopAt) {
    const tag = el.tagName;
    if (tag === "A" || tag === "BUTTON") return true;
    const role = el.getAttribute("role");
    if (role === "button" || role === "link") return true;
    el = el.parentElement;
  }
  return false;
}
function PopupMessage(props) {
  const { t } = useTranslation();
  const { message, productMap, replies, product, productLoading, onClick, onReplyClick, onAddToCart, onDismiss, autoDismissMs, storeDomain, isStreaming } = props;
  const [dismissing, setDismissing] = useState52(false);
  const [cartAdded, setCartAdded] = useState52(false);
  const rootRef = useRef65(null);
  const bodyRef = useRef65(null);
  usePopupContentResize(rootRef, bodyRef, dismissing);
  const callbackRef = useRef65(void 0);
  const isManualDismissRef = useRef65(false);
  const hasProduct = product != null || productLoading;
  const animateStateRef = useRef65({ charStartTimes: /* @__PURE__ */ new Map() });
  if (!isStreaming) {
    animateStateRef.current.charStartTimes.clear();
  }
  const triggerDismiss = useCallback24((afterAnimation, manual = false) => {
    if (dismissing) return;
    isManualDismissRef.current = manual;
    callbackRef.current = afterAnimation;
    setDismissing(true);
  }, [dismissing]);
  const handleAddToCart = useCallback24(async (item) => {
    await onAddToCart?.(item);
    setCartAdded(true);
  }, [onAddToCart]);
  useEffect43(() => {
    if (!cartAdded || dismissing) return;
    const timer = setTimeout(triggerDismiss, 1e3);
    return () => clearTimeout(timer);
  }, [cartAdded, dismissing, triggerDismiss]);
  const handleAutoDismissElapsed = useCallback24(() => {
    if (onDismiss) triggerDismiss();
  }, [onDismiss, triggerDismiss]);
  const autoDismiss = useAutoDismiss({
    ms: autoDismissMs,
    enabled: !!autoDismissMs && !!onDismiss && !dismissing && !isStreaming && !productLoading && !cartAdded,
    onElapsed: handleAutoDismissElapsed
  });
  const handleAnimationEnd = useCallback24((e) => {
    if (e.target === e.currentTarget && dismissing) {
      callbackRef.current?.();
      onDismiss?.(isManualDismissRef.current);
    }
  }, [dismissing, onDismiss]);
  const handleMessageTextClick = useCallback24((e) => {
    if (!onClick) return;
    if (isInteractiveDescendant(e.target, e.currentTarget)) return;
    onClick();
  }, [onClick]);
  const handleMessageTextKeyDown = useCallback24((e) => {
    if (!onClick) return;
    if (e.target !== e.currentTarget) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick();
    }
  }, [onClick]);
  const rootClass = [
    "buyscout-popup-message",
    hasProduct && "buyscout-popup-message--with-product",
    dismissing && "buyscout-popup-message--exit"
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsxs40(
    "div",
    {
      ref: rootRef,
      className: rootClass,
      onAnimationEnd: handleAnimationEnd,
      onPointerEnter: autoDismiss.onPointerEnter,
      onPointerLeave: autoDismiss.onPointerLeave,
      onFocus: autoDismiss.onFocus,
      onBlur: autoDismiss.onBlur,
      children: [
        onDismiss && /* @__PURE__ */ jsx72(
          ChromeDismissButton,
          {
            variant: "glass",
            size: "xs",
            className: "buyscout-popup-message__close",
            label: t("popupMessage.dismissAria"),
            onClick: () => triggerDismiss(void 0, true)
          }
        ),
        /* @__PURE__ */ jsx72("div", { className: "buyscout-popup-message__body-clip", children: /* @__PURE__ */ jsxs40("div", { ref: bodyRef, className: "buyscout-popup-message__body", children: [
          /* @__PURE__ */ jsx72(
            "div",
            {
              className: "buyscout-popup-message__text buyscout-message-content assistant",
              style: { cursor: onClick ? "pointer" : void 0 },
              role: onClick ? "button" : void 0,
              tabIndex: onClick ? 0 : void 0,
              onClick: handleMessageTextClick,
              onKeyDown: handleMessageTextKeyDown,
              children: /* @__PURE__ */ jsx72(CopyableCodesContext, { value: true, children: /* @__PURE__ */ jsx72(
                ChatMarkdown,
                {
                  content: message,
                  productMap,
                  storeDomain,
                  isStreaming,
                  animateState: animateStateRef.current
                }
              ) })
            }
          ),
          hasProduct && /* @__PURE__ */ jsx72(
            "div",
            {
              className: "buyscout-chat-message-timeline buyscout-popup-message__timeline",
              role: "presentation",
              onClick: (e) => e.stopPropagation(),
              children: /* @__PURE__ */ jsx72(ProductCardTimelineItem, { product, loading: productLoading, storeDomain, onAddToCart: onAddToCart ? handleAddToCart : void 0 })
            }
          ),
          replies && replies.length > 0 && /* @__PURE__ */ jsx72(
            "div",
            {
              className: "buyscout-popup-message__replies",
              role: "presentation",
              onClick: (e) => e.stopPropagation(),
              children: /* @__PURE__ */ jsx72(
                PresetReplyButton,
                {
                  items: replies,
                  onItemClick: (value) => triggerDismiss(() => onReplyClick?.(value)),
                  exiting: dismissing,
                  initialDelay: 50,
                  variant: "popup"
                }
              )
            }
          )
        ] }) }),
        /* @__PURE__ */ jsxs40("svg", { className: "buyscout-popup-message__tail", width: "18", height: "11", viewBox: "0 0 18 11", "aria-hidden": "true", children: [
          /* @__PURE__ */ jsx72("path", { d: "M0 0.5C5 0.5 8 5.5 9 10.5C10 5.5 13 0.5 18 0.5V0H0Z", fill: "currentColor" }),
          /* @__PURE__ */ jsx72("path", { d: "M0 0.5C5 0.5 8 5.5 9 10.5C10 5.5 13 0.5 18 0.5", fill: "none", stroke: "currentColor", strokeWidth: "1" }),
          /* @__PURE__ */ jsx72("path", { d: "M0 0.5C5 0.5 8 5.5 9 10.5C10 5.5 13 0.5 18 0.5", fill: "none", className: "buyscout-popup-message__tail-border" })
        ] })
      ]
    }
  );
}
PopupMessage.displayName = "PopupMessage";

// src/components/composite/ChatControls/ProductSelector/ProductSelector.tsx
import { useEffect as useEffect45, useId as useId6, useImperativeHandle as useImperativeHandle3, useLayoutEffect as useLayoutEffect9, useMemo as useMemo30, useRef as useRef66, useState as useState55 } from "react";
import { createPortal as createPortal5 } from "react-dom";
import { MdSearch } from "react-icons/md";

// src/hooks/useExitPresence.ts
import { useEffect as useEffect44, useState as useState53 } from "react";
function useExitPresence(value, ref) {
  const [retained, setRetained] = useState53(value);
  if (value !== void 0 && value !== retained) setRetained(value);
  const closing = value === void 0 && retained !== void 0;
  useEffect44(() => {
    if (!closing) return;
    let cancelled = false;
    const release2 = () => {
      if (!cancelled) setRetained(void 0);
    };
    const running = ref.current?.getAnimations?.() ?? [];
    Promise.all(running.map((animation) => animation.finished)).then(release2, release2);
    return () => {
      cancelled = true;
    };
  }, [closing, ref]);
  return { rendered: value ?? retained, closing };
}

// src/hooks/useVisualViewport.ts
import { useLayoutEffect as useLayoutEffect8, useState as useState54 } from "react";
function readVisualViewport() {
  const viewport = window.visualViewport;
  return {
    top: viewport?.offsetTop ?? 0,
    left: viewport?.offsetLeft ?? 0,
    width: viewport?.width ?? window.innerWidth,
    height: viewport?.height ?? window.innerHeight
  };
}
function useVisualViewport() {
  const [bounds, setBounds] = useState54();
  useLayoutEffect8(() => {
    const update2 = () => {
      const next = readVisualViewport();
      setBounds((previous2) => previous2 && Object.keys(next).every((key) => next[key] === previous2[key]) ? previous2 : next);
    };
    const viewport = window.visualViewport;
    update2();
    viewport?.addEventListener("resize", update2);
    viewport?.addEventListener("scroll", update2);
    window.addEventListener("resize", update2);
    return () => {
      viewport?.removeEventListener("resize", update2);
      viewport?.removeEventListener("scroll", update2);
      window.removeEventListener("resize", update2);
    };
  }, []);
  return bounds;
}

// src/components/composite/ChatControls/ProductSelector/ProductSelector.tsx
import { jsx as jsx73, jsxs as jsxs41 } from "react/jsx-runtime";
var ROW_IMAGE_PX = 32;
function ProductSelector({ ref, products, onSelect, onClose, anchorEl, anchorRect, getAnchorRect, open: open2, className = "", onSearch, showSearchBox = true, listboxId, onActiveOptionChange }) {
  const { t } = useComponentsTranslation();
  const generatedListboxId = useId6();
  const listId = listboxId ?? generatedListboxId;
  const optionId = (index2) => `${listId}-option-${index2}`;
  const [searchQuery, setSearchQuery] = useState55("");
  const [selectedIndex, setSelectedIndex] = useState55(0);
  const searchInputRef = useRef66(null);
  const listRef = useRef66(null);
  const selectorRef = useRef66(null);
  const portalContainer = useMemo30(() => {
    if (typeof document === "undefined") return null;
    return shadowPortalContainer(anchorEl) ?? (anchorEl?.ownerDocument ?? document).body;
  }, [anchorEl]);
  const filteredProducts = useMemo30(() => showSearchBox ? products.filter(
    (product) => product.title.toLowerCase().includes(searchQuery.toLowerCase())
  ) : products, [products, searchQuery, showSearchBox]);
  const activeIndex = filteredProducts.length > 0 ? Math.min(selectedIndex, filteredProducts.length - 1) : 0;
  const visible = useMemo30(
    () => open2 ? { filteredProducts, selectedIndex: activeIndex, searchQuery, showSearchBox } : void 0,
    [open2, filteredProducts, activeIndex, searchQuery, showSearchBox]
  );
  const { rendered: displayed } = useExitPresence(visible, selectorRef);
  useEffect45(() => {
    if (onSearch && searchQuery) {
      onSearch(searchQuery);
    }
  }, [searchQuery, onSearch]);
  useEffect45(() => {
    if (open2) {
      setSearchQuery("");
      setSelectedIndex(0);
    }
  }, [open2, showSearchBox]);
  const handleKeyDownImpl = (e) => {
    if (!open2 || isImeComposing(e)) return false;
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setSelectedIndex(activeIndex < filteredProducts.length - 1 ? activeIndex + 1 : activeIndex);
        return true;
      case "ArrowUp":
        e.preventDefault();
        setSelectedIndex(activeIndex > 0 ? activeIndex - 1 : 0);
        return true;
      case "Enter":
        e.preventDefault();
        if (filteredProducts[activeIndex]) {
          onSelect(filteredProducts[activeIndex]);
        }
        return true;
      case "Escape":
        e.preventDefault();
        onClose();
        return true;
      case "Backspace":
        if (showSearchBox && searchQuery === "") {
          e.preventDefault();
          onClose();
          return true;
        }
        return false;
      default:
        return false;
    }
  };
  useImperativeHandle3(ref, () => ({
    handleKeyDown: handleKeyDownImpl
  }), [open2, activeIndex, filteredProducts, onSelect, onClose, searchQuery, showSearchBox]);
  useEffect45(() => {
    const handleKeyDown = (e) => {
      if (document.activeElement === searchInputRef.current) {
        handleKeyDownImpl(e);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open2, activeIndex, filteredProducts, onSelect, onClose, searchQuery, showSearchBox]);
  const hasActiveOption = open2 && filteredProducts.length > 0;
  const activeOptionId = hasActiveOption ? optionId(activeIndex) : null;
  useEffect45(() => {
    onActiveOptionChange?.(activeOptionId);
  }, [activeOptionId, onActiveOptionChange]);
  useEffect45(() => {
    if (listRef.current) {
      const selectedElement = listRef.current.children[activeIndex];
      if (selectedElement) {
        selectedElement.scrollIntoView({ block: "nearest", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth" });
      }
    }
  }, [activeIndex]);
  useLayoutEffect9(() => {
    const readAnchor = () => {
      const caret = getAnchorRect?.() ?? anchorRect;
      return { rect: caret ?? anchorEl?.getBoundingClientRect(), offset: caret ? 0 : 8 };
    };
    if (!open2 || !readAnchor().rect || !selectorRef.current) return;
    const viewportPadding = 8;
    const updatePosition = () => {
      const sel = selectorRef.current;
      if (!sel) return;
      const { rect: aRect, offset: anchorOffset } = readAnchor();
      if (!aRect) return;
      const viewport = readVisualViewport();
      sel.style.setProperty("--product-selector-available-height", `${Math.max(0, viewport.height - viewportPadding * 2)}px`);
      const rect = sel.getBoundingClientRect();
      const viewportW = viewport.left + viewport.width;
      const viewportH = viewport.top + viewport.height;
      const spaceAbove = aRect.top - viewport.top;
      const spaceBelow = viewportH - aRect.bottom;
      const preferAbove = spaceAbove >= spaceBelow;
      let top;
      if (preferAbove) {
        const topCandidate = aRect.top - rect.height - anchorOffset;
        top = Math.max(viewport.top + viewportPadding, topCandidate);
      } else {
        const topCandidate = aRect.bottom + anchorOffset;
        top = Math.min(viewportH - rect.height - viewportPadding, topCandidate);
      }
      top = Math.max(viewport.top + viewportPadding, Math.min(viewportH - rect.height - viewportPadding, top));
      let left = aRect.left;
      if (left + rect.width > viewportW - viewportPadding) left = viewportW - rect.width - viewportPadding;
      if (left < viewport.left + viewportPadding) left = viewport.left + viewportPadding;
      sel.style.top = "0px";
      sel.style.left = "0px";
      const cbOrigin = sel.getBoundingClientRect();
      sel.style.top = `${top - cbOrigin.top}px`;
      sel.style.left = `${left - cbOrigin.left}px`;
      sel.style.bottom = "auto";
    };
    updatePosition();
    let raf = requestAnimationFrame(() => {
      raf = requestAnimationFrame(updatePosition);
    });
    window.visualViewport?.addEventListener("resize", updatePosition);
    window.visualViewport?.addEventListener("scroll", updatePosition);
    return () => {
      cancelAnimationFrame(raf);
      window.visualViewport?.removeEventListener("resize", updatePosition);
      window.visualViewport?.removeEventListener("scroll", updatePosition);
    };
  }, [open2, anchorEl, anchorRect, getAnchorRect, filteredProducts.length, portalContainer]);
  const onCloseRef = useRef66(onClose);
  useEffect45(() => {
    onCloseRef.current = onClose;
  }, [onClose]);
  useEffect45(() => {
    if (!open2) return;
    const doc = anchorEl?.ownerDocument ?? document;
    const handleClickOutside = (e) => {
      if (selectorRef.current && !e.composedPath().includes(selectorRef.current)) {
        onCloseRef.current();
      }
    };
    doc.addEventListener("mousedown", handleClickOutside);
    return () => doc.removeEventListener("mousedown", handleClickOutside);
  }, [open2, anchorEl]);
  if (!displayed || !portalContainer) return null;
  return createPortal5(
    /* @__PURE__ */ jsxs41(
      "div",
      {
        ref: selectorRef,
        className: `product-selector ${className}`,
        "data-state": open2 ? "open" : "closed",
        inert: !open2,
        "aria-hidden": !open2,
        children: [
          displayed.showSearchBox && /* @__PURE__ */ jsxs41("div", { className: "product-selector-search", children: [
            /* @__PURE__ */ jsx73(MdSearch, { size: 16, className: "product-selector-search-icon" }),
            /* @__PURE__ */ jsx73(
              "input",
              {
                ref: searchInputRef,
                type: "text",
                value: displayed.searchQuery,
                onChange: (e) => {
                  if (open2) setSearchQuery(e.target.value);
                },
                placeholder: t("productMention.searchPlaceholder"),
                "aria-label": t("productMention.searchAria"),
                "aria-controls": open2 ? listId : void 0,
                "aria-activedescendant": open2 ? activeOptionId ?? void 0 : void 0,
                className: "product-selector-search-input"
              }
            )
          ] }),
          /* @__PURE__ */ jsx73("div", { ref: listRef, id: listId, className: "product-selector-list", role: "listbox", "aria-label": t("productMention.listAria"), children: displayed.filteredProducts.map((product, index2) => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events -- an option never takes focus here, so it can never receive a key event: Arrow and Enter are bound to the composer, which moves aria-selected and activates the highlighted row
            /* @__PURE__ */ jsxs41(
              "div",
              {
                id: optionId(index2),
                className: `product-selector-item ${index2 === displayed.selectedIndex ? "selected" : ""}`,
                role: "option",
                "aria-selected": index2 === displayed.selectedIndex,
                tabIndex: -1,
                onMouseDown: (e) => e.preventDefault(),
                onClick: () => {
                  if (open2) onSelect(product);
                },
                onMouseEnter: () => {
                  if (open2) setSelectedIndex(index2);
                },
                children: [
                  /* @__PURE__ */ jsx73(
                    ImageFrame,
                    {
                      ...product.imageUrl ? shopifyImageSource(product.imageUrl, ROW_IMAGE_PX) : void 0,
                      alt: "",
                      fallback: "bag-filled",
                      className: product.imageUrl ? "product-selector-item-image" : "product-selector-item-icon",
                      imgClassName: "product-selector-item-img"
                    }
                  ),
                  /* @__PURE__ */ jsx73(Text, { variant: "body", as: "div", className: "product-selector-item-title", children: product.title })
                ]
              },
              product.id
            )
          )) }),
          /* @__PURE__ */ jsx73("div", { role: "status", children: displayed.filteredProducts.length === 0 && /* @__PURE__ */ jsx73(Text, { variant: "body-secondary", as: "div", className: "product-selector-empty", children: t("productMention.empty") }) })
        ]
      }
    ),
    portalContainer
  );
}
ProductSelector.displayName = "ProductSelector";

// src/components/composite/ChatControls/ProductSelector/useProductSelector.ts
import { useCallback as useCallback25, useId as useId7, useRef as useRef67, useState as useState56 } from "react";
function useProductSelector(options) {
  const { inputRef, products, onProductSearch, onProductSearchClear, onAtTrigger } = options;
  const containerRef = useRef67(null);
  const productSelectorRef = useRef67(null);
  const [selectorOpen, setSelectorOpen] = useState56(false);
  const [wordMatchQuery, setWordMatchQuery] = useState56(null);
  const [caretRect, setCaretRect] = useState56(null);
  const caretOffsetRef = useRef67(0);
  const listboxId = useId7();
  const [activeOptionId, setActiveOptionId] = useState56(null);
  const handleActiveOptionChange = useCallback25((optionId) => {
    setActiveOptionId(optionId);
  }, []);
  const getCaretRect = useCallback25(() => inputRef.current?.getCaretRect?.(caretOffsetRef.current) ?? null, [inputRef]);
  const captureCaretRect = (charOffset = 0) => {
    caretOffsetRef.current = charOffset;
    const rect = getCaretRect();
    if (rect) {
      setCaretRect({ top: rect.top, left: rect.left, bottom: rect.bottom, right: rect.right, width: rect.width, height: rect.height });
    }
  };
  const handleAtTrigger = () => {
    inputRef.current?.focusAndSaveCursorAtEnd?.();
    captureCaretRect(-1);
    setSelectorOpen(true);
    setWordMatchQuery(null);
    onAtTrigger?.();
    onProductSearch?.("");
  };
  const handleAtClose = () => {
    if (selectorOpen && wordMatchQuery == null) {
      setSelectorOpen(false);
      setCaretRect(null);
      onProductSearchClear?.();
    }
  };
  const handleWordMatchTrigger = (word) => {
    captureCaretRect();
    setSelectorOpen(true);
    setWordMatchQuery(word);
  };
  const handleWordMatchClose = () => {
    if (wordMatchQuery != null) {
      setSelectorOpen(false);
      setWordMatchQuery(null);
    }
    onProductSearchClear?.();
    inputRef.current?.focusAndSaveCursorAtEnd?.();
  };
  const handleProductSelect = (product) => {
    if (wordMatchQuery != null) {
      inputRef.current?.insertProductReplacingWord?.(product);
      setWordMatchQuery(null);
    } else {
      inputRef.current?.insertProduct(product);
    }
    setSelectorOpen(false);
    setCaretRect(null);
    onProductSearchClear?.();
    inputRef.current?.focusAndSaveCursorAtEnd?.();
  };
  const handleSelectorClose = (restoreFocus = true) => {
    setSelectorOpen(false);
    setWordMatchQuery(null);
    setCaretRect(null);
    onProductSearchClear?.();
    if (restoreFocus) inputRef.current?.focusAndSaveCursorAtEnd?.();
  };
  const handleContainerKeyDown = (e) => {
    if (selectorOpen && !isImeComposing(e.nativeEvent) && ["ArrowDown", "ArrowUp", "Enter", "Escape"].includes(e.key)) {
      const handled = productSelectorRef.current?.handleKeyDown(e.nativeEvent);
      if (handled) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  };
  const selectorProducts = selectorOpen ? wordMatchQuery != null ? products.filter((p) => p.title.toLowerCase().includes(wordMatchQuery.toLowerCase())) : products : [];
  const showSearchBox = wordMatchQuery == null;
  return {
    containerRef,
    productSelectorRef,
    selectorOpen,
    caretRect,
    getCaretRect,
    handleAtTrigger,
    handleAtClose,
    handleWordMatchTrigger,
    handleWordMatchClose,
    handleProductSelect,
    handleSelectorClose,
    handleContainerKeyDown,
    selectorProducts,
    showSearchBox,
    listboxId,
    activeOptionId,
    handleActiveOptionChange
  };
}

// src/components/composite/ChatControls/TryOnStage/TryOnStage.tsx
import { useCallback as useCallback27, useEffect as useEffect49, useState as useState60 } from "react";
import { MdAutoAwesome, MdChevronLeft } from "react-icons/md";

// src/components/composite/ChatControls/TryOnStage/TryOnPreviewStep.tsx
import { useEffect as useEffect47, useId as useId8, useState as useState58 } from "react";
import { MdKeyboardArrowDown, MdOpenInFull, MdShoppingCartCheckout } from "react-icons/md";

// src/components/composite/ChatControls/TryOnStage/TryOnPreviewImage.tsx
import { useCallback as useCallback26, useEffect as useEffect46, useRef as useRef68, useState as useState57 } from "react";
import { jsx as jsx74 } from "react/jsx-runtime";
var SWAP_TIMEOUT_MS = 4e3;
var SETTLE_GRACE_MS2 = 400;
function decoded(event) {
  return event.currentTarget.decode().catch(() => {
  });
}
function TryOnPreviewImage({ image: image2, onReady }) {
  const [shown, setShown] = useState57({ current: image2 });
  const readyRef = useRef68(false);
  const onReadyRef = useRef68(onReady);
  onReadyRef.current = onReady;
  if (!shown.current && image2) setShown({ current: image2 });
  const pending = image2 && shown.current && image2.url !== shown.current.url ? image2 : void 0;
  const ready = useCallback26(() => {
    if (readyRef.current) return;
    readyRef.current = true;
    onReadyRef.current?.();
  }, []);
  useEffect46(() => {
    if (!image2) ready();
  }, [image2, ready]);
  const promote = useCallback26((next) => {
    setShown((prev) => prev.current?.url === next.url ? prev : { current: next, previous: prev.current });
  }, []);
  useEffect46(() => {
    if (!pending) return;
    const timer = setTimeout(promote, SWAP_TIMEOUT_MS, pending);
    return () => clearTimeout(timer);
  }, [pending, promote]);
  const dropPrevious = useCallback26(() => {
    setShown((prev) => prev.previous ? { current: prev.current } : prev);
  }, []);
  useEffect46(() => {
    if (!shown.previous) return;
    const timer = setTimeout(dropPrevious, SETTLE_GRACE_MS2);
    return () => clearTimeout(timer);
  }, [shown.previous, dropPrevious]);
  if (!image2 || !shown.current) return null;
  const current = shown.current;
  const layers = [
    ...shown.previous ? [{ image: shown.previous, role: "previous" }] : [],
    { image: current, role: "current" },
    ...pending ? [{ image: pending, role: "pending" }] : []
  ];
  return layers.map((layer) => /* @__PURE__ */ jsx74(
    "span",
    {
      className: clsx_default("buyscout-tryon-stage__layer", `is-${layer.role}`),
      inert: layer.role !== "current" || void 0,
      "aria-hidden": layer.role !== "current" || void 0,
      onTransitionEnd: (event) => {
        if (layer.role === "current" && event.target === event.currentTarget) dropPrevious();
      },
      children: /* @__PURE__ */ jsx74(
        ChatImageView,
        {
          image: layer.image,
          enlargeable: true,
          className: "buyscout-tryon-stage__image",
          onLoad: (event) => {
            if (layer.role === "pending") void decoded(event).then(() => promote(layer.image));
            else if (layer.role === "current") void decoded(event).then(ready);
          },
          onError: () => {
            if (layer.role === "pending") promote(layer.image);
            else if (layer.role === "current") ready();
          }
        }
      )
    },
    layer.image.url
  ));
}
TryOnPreviewImage.displayName = "TryOnPreviewImage";

// src/components/composite/ChatControls/TryOnStage/TryOnPreviewStep.tsx
import { Fragment as Fragment19, jsx as jsx75, jsxs as jsxs42 } from "react/jsx-runtime";
function TryOnPreviewStep({
  product,
  axes,
  previewImage,
  defaultExpanded = false,
  fill = false,
  onAddToCart,
  onExit,
  held = false,
  onImageReady
}) {
  const { t } = useComponentsTranslation();
  const controlsId = useId8();
  const [expanded, setExpanded] = useState58(defaultExpanded);
  const { cartStateOf, addToCart, outcome } = useAddToCartState(onAddToCart);
  useEffect47(() => {
    setExpanded(defaultExpanded);
  }, [defaultExpanded]);
  const allAxes = axes ?? [];
  const visualAxis = allAxes.find((a) => a.values.some((v) => v.image));
  const axisStates = allAxes.map((axis) => {
    const name2 = axis.selected ?? axis.recommended;
    const active = axis.values.find((v) => v.name === name2) ?? (axis === visualAxis ? axis.values[0] : void 0);
    const isSwatch = axis.values.every((v) => v.swatch);
    return { axis, active, isSwatch };
  });
  const visualActive = axisStates.find((s) => s.axis === visualAxis)?.active;
  const image2 = visualActive?.image ?? previewImage;
  const hasControls = allAxes.some((a) => a.values.length > 0);
  const summaryParts = axisStates.map(({ axis, active, isSwatch }) => active ? isSwatch ? active.name : `${axis.label} ${active.name}` : void 0).filter(Boolean);
  const summaryText = summaryParts.length > 0 ? summaryParts.join(" \xB7 ") : void 0;
  const controlsOpen = expanded || !summaryText;
  const cartValues = [
    ...axisStates.filter((s) => s.axis !== visualAxis).map((s) => s.active?.name),
    visualActive?.name
  ].filter(Boolean);
  const cartState = product ? cartStateOf(product.id) : "idle";
  const imageEl = /* @__PURE__ */ jsx75(TryOnPreviewImage, { image: image2, onReady: onImageReady });
  const enlargeHint = image2 && /* @__PURE__ */ jsxs42("span", { className: "buyscout-tryon-stage__enlarge-hint", "aria-hidden": "true", children: [
    /* @__PURE__ */ jsx75(MdOpenInFull, { size: 12 }),
    t("tryOn.enlargeHint")
  ] });
  const summaryToggle = hasControls && summaryText && /* @__PURE__ */ jsxs42(
    "button",
    {
      type: "button",
      className: "buyscout-tryon-stage__summary",
      "aria-expanded": expanded,
      "aria-controls": controlsId,
      onClick: () => setExpanded((prev) => !prev),
      children: [
        /* @__PURE__ */ jsxs42("span", { className: "buyscout-tryon-stage__summary-left", children: [
          visualActive?.swatch && /* @__PURE__ */ jsx75("span", { className: "buyscout-tryon-stage__summary-swatch", style: { backgroundColor: visualActive.swatch } }),
          /* @__PURE__ */ jsx75("span", { className: "buyscout-tryon-stage__summary-text", children: summaryText })
        ] }),
        /* @__PURE__ */ jsxs42("span", { className: "buyscout-tryon-stage__summary-right", children: [
          t(expanded ? "tryOn.done" : "tryOn.change"),
          /* @__PURE__ */ jsx75(MdKeyboardArrowDown, { className: clsx_default("buyscout-tryon-stage__chevron", expanded && "is-open"), size: 17 })
        ] })
      ]
    }
  );
  const recapLine = hasControls && summaryText && /* @__PURE__ */ jsxs42("div", { className: "buyscout-tryon-stage__recap", children: [
    visualActive?.swatch && /* @__PURE__ */ jsx75("span", { className: "buyscout-tryon-stage__recap-swatch", style: { backgroundColor: visualActive.swatch } }),
    /* @__PURE__ */ jsx75("span", { className: "buyscout-tryon-stage__recap-text", children: summaryText })
  ] });
  const controls = hasControls && /* @__PURE__ */ jsx75(
    "div",
    {
      className: clsx_default("buyscout-tryon-stage__controls", controlsOpen && "is-expanded"),
      id: controlsId,
      children: /* @__PURE__ */ jsx75("div", { className: "buyscout-tryon-stage__controls-clip", children: axisStates.map(({ axis, active, isSwatch }) => /* @__PURE__ */ jsxs42("div", { className: "buyscout-tryon-stage__section", children: [
        /* @__PURE__ */ jsxs42("div", { className: "buyscout-tryon-stage__control-label", children: [
          axis.label,
          isSwatch && active && /* @__PURE__ */ jsxs42(Fragment19, { children: [
            " \xB7 ",
            /* @__PURE__ */ jsx75("strong", { children: active.name })
          ] })
        ] }),
        isSwatch ? /* @__PURE__ */ jsx75(
          RadioGroup4,
          {
            orientation: "horizontal",
            "aria-label": axis.label,
            value: active?.name ?? "",
            onValueChange: (value) => axis.onChange?.(value),
            className: "buyscout-tryon-stage__swatches",
            children: axis.values.map((value) => /* @__PURE__ */ jsx75(
              RadioCard,
              {
                variant: "swatch",
                swatch: value.swatch ?? "",
                value: value.name,
                "aria-label": value.name,
                className: "buyscout-tryon-stage__swatch"
              },
              value.name
            ))
          }
        ) : /* @__PURE__ */ jsx75(
          SegmentedControl,
          {
            size: "md",
            "aria-label": axis.label,
            value: active?.name ?? "",
            onValueChange: (value) => axis.onChange?.(value),
            className: "buyscout-tryon-stage__choices",
            children: axis.values.map((value) => /* @__PURE__ */ jsx75(SegmentedControlItem, { value: value.name, className: "buyscout-tryon-stage__choice", children: value.name }, value.name))
          }
        )
      ] }, axis.label)) })
    }
  );
  const addButton = onAddToCart && product && /* @__PURE__ */ jsx75(
    Button,
    {
      fullWidth: true,
      size: "md",
      color: cartState === "error" ? "error" : "primary",
      className: clsx_default("buyscout-tryon-stage__add buyscout-add-to-cart", cartState),
      "data-cart-state": cartState,
      onClick: () => void addToCart(product),
      loading: cartState === "loading",
      "aria-disabled": cartState === "added" || void 0,
      "aria-label": addToCartAriaLabel(t, cartState, product.title),
      children: cartState === "added" ? /* @__PURE__ */ jsxs42(Fragment19, { children: [
        /* @__PURE__ */ jsx75(DrawnCheck, { drawn: true, className: "buyscout-btn__icon-start", width: 16, height: 16 }),
        t("product.added")
      ] }) : cartState === "error" ? t("product.failed") : /* @__PURE__ */ jsxs42(Fragment19, { children: [
        /* @__PURE__ */ jsx75(MdShoppingCartCheckout, { className: "buyscout-btn__icon-start", size: 16 }),
        t("tryOn.addToCartPlain"),
        cartValues.length > 0 && /* @__PURE__ */ jsx75("span", { className: "buyscout-tryon-stage__add-values", children: ` \xB7 ${cartValues.join(", ")}` })
      ] })
    }
  );
  const cartStatus = onAddToCart && product && /* @__PURE__ */ jsx75(AddToCartStatus, { outcome, t });
  const doneButton = !onAddToCart && onExit && /* @__PURE__ */ jsx75(
    Button,
    {
      fullWidth: true,
      size: "md",
      className: "buyscout-tryon-stage__done",
      onClick: onExit,
      children: t("tryOn.done")
    }
  );
  if (fill) {
    return /* @__PURE__ */ jsxs42("div", { className: clsx_default("buyscout-tryon-stage__preview", held && "is-held"), inert: held || void 0, "aria-hidden": held || void 0, children: [
      /* @__PURE__ */ jsxs42("div", { className: "buyscout-tryon-stage__media", children: [
        imageEl,
        enlargeHint,
        controls
      ] }),
      /* @__PURE__ */ jsxs42("div", { className: "buyscout-tryon-stage__footer", children: [
        summaryToggle,
        addButton,
        cartStatus,
        doneButton
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs42("div", { className: clsx_default("buyscout-tryon-stage__preview", held && "is-held"), inert: held || void 0, "aria-hidden": held || void 0, children: [
    /* @__PURE__ */ jsxs42("div", { className: "buyscout-tryon-stage__media", children: [
      imageEl,
      enlargeHint
    ] }),
    /* @__PURE__ */ jsxs42("div", { className: "buyscout-tryon-stage__panel", children: [
      summaryToggle,
      controls,
      recapLine,
      addButton,
      cartStatus,
      doneButton
    ] })
  ] });
}

// src/components/composite/ChatControls/TryOnStage/TryOnUploadStep.tsx
import { useEffect as useEffect48, useRef as useRef69, useState as useState59 } from "react";
import { MdChevronRight as MdChevronRight2, MdLockOutline, MdOutlineFileUpload, MdOutlinePhotoCamera } from "react-icons/md";
import { Fragment as Fragment20, jsx as jsx76, jsxs as jsxs43 } from "react/jsx-runtime";
var SAMPLE_FRAME_MS = 350;
function TryOnSampleTile({ photo, onSelect }) {
  const { t } = useComponentsTranslation();
  const frames = photo.angles && photo.angles.length > 1 ? photo.angles : [photo.url];
  const [frame, setFrame] = useState59(0);
  const timerRef = useRef69(void 0);
  const stop = () => {
    clearInterval(timerRef.current);
    setFrame(0);
  };
  const play = () => {
    if (frames.length <= 1) return;
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => setFrame((f) => (f + 1) % frames.length), SAMPLE_FRAME_MS);
  };
  useEffect48(() => () => clearInterval(timerRef.current), []);
  return /* @__PURE__ */ jsxs43(
    "button",
    {
      type: "button",
      className: "buyscout-tryon-stage__sample",
      "aria-label": photo.alt ? t("tryOn.sampleAria", { name: photo.alt }) : t("tryOn.sampleDivider"),
      onClick: () => onSelect?.(photo),
      onMouseEnter: play,
      onMouseLeave: stop,
      onFocus: play,
      onBlur: stop,
      children: [
        frames.map((src, i) => /* @__PURE__ */ jsx76(
          "img",
          {
            className: clsx_default("buyscout-tryon-stage__sample-frame", i === frame && "is-active"),
            src,
            alt: "",
            loading: "lazy"
          },
          src
        )),
        photo.alt && /* @__PURE__ */ jsx76("span", { className: "buyscout-tryon-stage__sample-name", children: photo.alt })
      ]
    }
  );
}
function TryOnUploadStep({
  error: error2,
  savedPhoto,
  samplePhotos,
  onUploadPhoto,
  onSelectSavedPhoto,
  onSelectSamplePhoto
}) {
  const { t } = useComponentsTranslation();
  const fileInputRef = useRef69(null);
  const [dragging, setDragging] = useState59(false);
  const acceptFile = (file) => {
    if (file && file.type.startsWith("image/")) {
      onUploadPhoto?.(file);
    }
  };
  const handleFileChange = (e) => {
    acceptFile(e.target.files?.[0]);
    e.target.value = "";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    if (!dragging) setDragging(true);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragging(false);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    acceptFile(e.dataTransfer.files?.[0]);
  };
  const hasSamples = !!samplePhotos && samplePhotos.length > 0;
  return /* @__PURE__ */ jsxs43("div", { className: "buyscout-tryon-stage__upload", children: [
    error2 && /* @__PURE__ */ jsxs43(Callout, { color: "warning", size: "sm", role: "alert", className: "buyscout-tryon-stage__error", children: [
      /* @__PURE__ */ jsx76(CalloutIcon, { children: /* @__PURE__ */ jsx76(MdOutlinePhotoCamera, {}) }),
      /* @__PURE__ */ jsx76(CalloutContent, { children: /* @__PURE__ */ jsx76(CalloutBody, { children: error2 }) })
    ] }),
    savedPhoto && /* @__PURE__ */ jsxs43(
      "button",
      {
        type: "button",
        className: "buyscout-tryon-stage__saved",
        onClick: () => onSelectSavedPhoto?.(savedPhoto),
        children: [
          /* @__PURE__ */ jsx76(ImageFrame, { className: "buyscout-tryon-stage__saved-photo", src: savedPhoto.url, alt: "", loading: "lazy" }),
          /* @__PURE__ */ jsxs43("span", { className: "buyscout-tryon-stage__saved-text", children: [
            /* @__PURE__ */ jsx76("strong", { children: t("tryOn.savedPhotoTitle") }),
            /* @__PURE__ */ jsx76("span", { children: t("tryOn.savedPhotoHint") })
          ] }),
          /* @__PURE__ */ jsx76("span", { className: "buyscout-tryon-stage__saved-go", children: /* @__PURE__ */ jsx76(MdChevronRight2, { size: 18 }) })
        ]
      }
    ),
    /* @__PURE__ */ jsx76(
      "input",
      {
        ref: fileInputRef,
        type: "file",
        accept: "image/*",
        "aria-label": t("tryOn.uploadInputAria"),
        className: "buyscout-tryon-stage__file-input",
        onChange: handleFileChange
      }
    ),
    /* @__PURE__ */ jsxs43(
      "button",
      {
        type: "button",
        className: clsx_default("buyscout-tryon-stage__drop", dragging && "is-dragging"),
        onClick: () => fileInputRef.current?.click(),
        onDragOver: handleDragOver,
        onDragLeave: handleDragLeave,
        onDrop: handleDrop,
        children: [
          /* @__PURE__ */ jsx76(IconTile, { tone: "gold", size: "md", children: /* @__PURE__ */ jsx76(MdOutlinePhotoCamera, { "aria-hidden": true }) }),
          /* @__PURE__ */ jsxs43("span", { className: "buyscout-tryon-stage__drop-text", children: [
            /* @__PURE__ */ jsx76("strong", { children: error2 ? t("tryOn.uploadRetryTitle") : t("tryOn.uploadTitle") }),
            /* @__PURE__ */ jsx76("span", { children: t("tryOn.uploadHint") })
          ] }),
          /* @__PURE__ */ jsx76("span", { className: "buyscout-tryon-stage__drop-go", children: /* @__PURE__ */ jsx76(MdOutlineFileUpload, { size: 17 }) })
        ]
      }
    ),
    hasSamples && /* @__PURE__ */ jsxs43(Fragment20, { children: [
      /* @__PURE__ */ jsx76(Divider, { decorative: true, className: "buyscout-tryon-stage__divider", children: t("tryOn.sampleDivider") }),
      /* @__PURE__ */ jsx76("div", { className: "buyscout-tryon-stage__samples", children: samplePhotos.map((photo) => /* @__PURE__ */ jsx76(TryOnSampleTile, { photo, onSelect: onSelectSamplePhoto }, photo.url)) })
    ] }),
    !savedPhoto && /* @__PURE__ */ jsxs43("div", { className: "buyscout-tryon-stage__privacy", children: [
      /* @__PURE__ */ jsx76(MdLockOutline, { size: 13 }),
      /* @__PURE__ */ jsx76("span", { children: t("tryOn.privacyNote") })
    ] })
  ] });
}

// src/components/composite/ChatControls/TryOnStage/TryOnStage.tsx
import { Fragment as Fragment21, jsx as jsx77, jsxs as jsxs44 } from "react/jsx-runtime";
var THUMB_IMAGE_PX = 16;
var REVEAL_TIMEOUT_MS = 4e3;
var SETTLE_GRACE_MS3 = 400;
function TryOnStage(props) {
  const {
    step,
    product,
    error: error2,
    savedPhoto,
    samplePhotos,
    axes,
    previewImage,
    sourcePhoto,
    defaultExpanded,
    onUploadPhoto,
    onSelectSavedPhoto,
    onSelectSamplePhoto,
    onAddToCart,
    onExit,
    fill = false,
    className
  } = props;
  const { t } = useComponentsTranslation();
  const [shownStep, setShownStep] = useState60(step);
  const [handoff, setHandoff] = useState60("none");
  if (step !== shownStep) {
    setShownStep(step);
    setHandoff(step === "preview" && shownStep === "processing" ? "holding" : "none");
  }
  const reveal = useCallback27(() => {
    setHandoff((prev) => prev === "holding" ? "leaving" : prev);
  }, []);
  const settle = useCallback27(() => {
    setHandoff((prev) => prev === "leaving" ? "none" : prev);
  }, []);
  useEffect49(() => {
    if (handoff === "none") return;
    const timer = handoff === "holding" ? setTimeout(reveal, REVEAL_TIMEOUT_MS) : setTimeout(settle, SETTLE_GRACE_MS3);
    return () => clearTimeout(timer);
  }, [handoff, reveal, settle]);
  const showsProcessing = step === "processing" || step === "preview" && handoff !== "none";
  const leaving = step === "preview" && handoff === "leaving";
  return /* @__PURE__ */ jsxs44("div", { className: clsx_default("buyscout-tryon-stage", fill && "buyscout-tryon-stage--fill", className), children: [
    /* @__PURE__ */ jsxs44("div", { className: "buyscout-tryon-stage__head buyscout-tryon-stage__head--back", children: [
      onExit && /* @__PURE__ */ jsxs44(
        Button,
        {
          type: "button",
          variant: "borderless",
          color: "primary",
          size: "sm",
          className: "buyscout-tryon-stage__back",
          onClick: onExit,
          children: [
            /* @__PURE__ */ jsx77(MdChevronLeft, { size: 20, "aria-hidden": true }),
            t("tryOn.back")
          ]
        }
      ),
      /* @__PURE__ */ jsxs44("span", { className: "buyscout-tryon-stage__kind", children: [
        /* @__PURE__ */ jsx77(MdAutoAwesome, { size: 12 }),
        t("tryOn.badge")
      ] }),
      product && /* @__PURE__ */ jsxs44(Badge, { variant: "outlined", color: "neutral", className: "buyscout-tryon-stage__product", children: [
        product.imageUrl && /* @__PURE__ */ jsx77(ImageFrame, { className: "buyscout-tryon-stage__product-thumb", ...shopifyImageSource(product.imageUrl, THUMB_IMAGE_PX), alt: "", fallback: "bag-filled", loading: "lazy" }),
        /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__product-name", children: product.title })
      ] })
    ] }),
    step === "upload" && /* @__PURE__ */ jsx77(
      TryOnUploadStep,
      {
        error: error2,
        savedPhoto,
        samplePhotos,
        onUploadPhoto,
        onSelectSavedPhoto,
        onSelectSamplePhoto
      }
    ),
    (step === "processing" || step === "preview") && /* @__PURE__ */ jsxs44("div", { className: "buyscout-tryon-stage__body", children: [
      showsProcessing && /* @__PURE__ */ jsxs44(
        "div",
        {
          className: clsx_default("buyscout-tryon-stage__processing", leaving && "is-leaving"),
          "aria-hidden": leaving || void 0,
          onTransitionEnd: (event) => {
            if (event.target === event.currentTarget && leaving) settle();
          },
          children: [
            /* @__PURE__ */ jsx77("div", { className: "buyscout-tryon-stage__processing-frame", children: sourcePhoto ? /* @__PURE__ */ jsxs44(Fragment21, { children: [
              /* @__PURE__ */ jsx77("img", { className: "buyscout-tryon-stage__processing-photo", src: sourcePhoto.url, alt: "" }),
              /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__processing-aura", "aria-hidden": "true" }),
              /* @__PURE__ */ jsxs44("span", { className: "buyscout-tryon-stage__processing-sparkles", "aria-hidden": "true", children: [
                /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__processing-sparkle" }),
                /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__processing-sparkle" }),
                /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__processing-sparkle" }),
                /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__processing-sparkle" }),
                /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__processing-sparkle" }),
                /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__processing-sparkle" }),
                /* @__PURE__ */ jsx77("span", { className: "buyscout-tryon-stage__processing-sparkle" })
              ] })
            ] }) : /* @__PURE__ */ jsx77("div", { className: "buyscout-tryon-stage__figure" }) }),
            /* @__PURE__ */ jsxs44("span", { className: "buyscout-tryon-stage__processing-caption", role: "status", children: [
              /* @__PURE__ */ jsx77(Spinner, { size: "sm", tone: "current", "aria-hidden": true }),
              t("tryOn.processing")
            ] })
          ]
        }
      ),
      step === "preview" && /* @__PURE__ */ jsx77(
        TryOnPreviewStep,
        {
          product,
          axes,
          previewImage,
          defaultExpanded,
          fill,
          onAddToCart,
          onExit,
          held: handoff === "holding",
          onImageReady: reveal
        }
      )
    ] })
  ] });
}
TryOnStage.displayName = "TryOnStage";

// src/components/composite/ChatControls/TryOnStage/useComposerTryOnMorph.ts
import { useCallback as useCallback28, useEffect as useEffect50, useLayoutEffect as useLayoutEffect10, useRef as useRef70, useState as useState61 } from "react";
function useComposerTryOnMorph(active, tryOn, collapsedHeight = 0) {
  const lastTryOnRef = useRef70(tryOn);
  if (tryOn) lastTryOnRef.current = tryOn;
  const [closing, setClosing] = useState61(false);
  const wasActiveRef = useRef70(active);
  if (active !== wasActiveRef.current) {
    wasActiveRef.current = active;
    setClosing(!active);
  }
  const showing = active || closing;
  const wrapperRef = useRef70(null);
  const contentElRef = useRef70(null);
  const observerRef = useRef70(null);
  const armedRef = useRef70(false);
  const activeRef = useRef70(active);
  activeRef.current = active;
  const collapsedRef = useRef70(collapsedHeight);
  collapsedRef.current = collapsedHeight;
  const contentRef = useCallback28((node) => {
    observerRef.current?.disconnect();
    contentElRef.current = node;
    if (node) {
      const observer = new ResizeObserver(() => {
        if (activeRef.current && armedRef.current && wrapperRef.current) {
          wrapperRef.current.style.height = `${node.offsetHeight}px`;
        }
      });
      observer.observe(node);
      observerRef.current = observer;
    }
  }, []);
  useEffect50(() => () => observerRef.current?.disconnect(), []);
  useLayoutEffect10(() => {
    const el = wrapperRef.current;
    if (!el) return;
    if (active) {
      armedRef.current = false;
      el.style.transition = "none";
      el.style.height = `${collapsedRef.current}px`;
      void el.offsetHeight;
      el.style.transition = "";
      let innerRaf = 0;
      const outerRaf = requestAnimationFrame(() => {
        innerRaf = requestAnimationFrame(() => {
          armedRef.current = true;
          if (wrapperRef.current && contentElRef.current) {
            wrapperRef.current.style.height = `${contentElRef.current.offsetHeight}px`;
          }
        });
      });
      return () => {
        cancelAnimationFrame(outerRaf);
        cancelAnimationFrame(innerRaf);
      };
    }
    armedRef.current = false;
    el.style.transition = "";
    el.style.height = `${collapsedRef.current}px`;
  }, [active]);
  useLayoutEffect10(() => {
    if (showing) return;
    const el = wrapperRef.current;
    if (el) {
      el.style.transition = "none";
      el.style.height = "0px";
    }
  }, [showing]);
  useEffect50(() => {
    if (!closing) return;
    const reduceMotion = typeof window !== "undefined" && !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const settleTimer = setTimeout(setClosing, reduceMotion ? 0 : 500, false);
    return () => clearTimeout(settleTimer);
  }, [closing]);
  const onMorphTransitionEnd = useCallback28((event) => {
    if (event.target !== event.currentTarget || active) return;
    if (event.propertyName === "height") setClosing(false);
  }, [active]);
  return {
    showing,
    open: active,
    content: showing ? lastTryOnRef.current : void 0,
    wrapperRef,
    contentRef,
    onMorphTransitionEnd
  };
}

// src/components/composite/ChatControls/useChatSend.ts
import { useCallback as useCallback29 } from "react";
function useChatSend(options) {
  const { inputRef, value, disabled: disabled2, onSend, onEnterPress, isSending = false } = options;
  const handleSendClick = useCallback29(() => {
    if (!inputRef.current) return;
    onSend();
  }, [inputRef, onSend]);
  const handleEnterPress = useCallback29((message) => {
    if (!inputRef.current) return;
    const mentionedProducts = inputRef.current.getMentionedProducts();
    onEnterPress(message, mentionedProducts);
  }, [inputRef, onEnterPress]);
  const isEmpty = !value.trim();
  const sendDisabled = isEmpty || disabled2 || isSending;
  return {
    handleSendClick,
    handleEnterPress,
    isEmpty,
    sendDisabled
  };
}

// src/components/composite/ChatControls/VoiceStage/VoiceStage.tsx
import { useRef as useRef72 } from "react";
import { MdNorthWest } from "react-icons/md";

// src/components/composite/ChatControls/SiriOrb/SiriOrb.tsx
import { useEffect as useEffect51, useRef as useRef71 } from "react";

// src/hooks/usePrefersReducedMotion.ts
import { useSyncExternalStore as useSyncExternalStore3 } from "react";
var QUERY = "(prefers-reduced-motion: reduce)";
function subscribe2(onChange) {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}
function usePrefersReducedMotion() {
  return useSyncExternalStore3(subscribe2, () => window.matchMedia(QUERY).matches, () => false);
}

// src/components/composite/ChatControls/SiriOrb/SiriOrb.tsx
import { jsx as jsx78 } from "react/jsx-runtime";
var SPEED_EASE_S = 0.2;
function SiriOrb({
  size: size5 = "192px",
  animationDuration = 20,
  audioLevelRef,
  running = true
}) {
  const reducedMotion2 = usePrefersReducedMotion();
  const animating = running && !reducedMotion2;
  const sizeValue = Number.parseInt(size5.replace("px", ""), 10);
  const blurAmount = sizeValue < 50 ? Math.max(sizeValue * 8e-3, 1) : Math.max(sizeValue * 0.015, 4);
  const contrastAmount = sizeValue < 50 ? Math.max(sizeValue * 4e-3, 1.2) : Math.max(sizeValue * 8e-3, 1.5);
  const dotSize = sizeValue < 50 ? Math.max(sizeValue * 4e-3, 0.05) : Math.max(sizeValue * 8e-3, 0.1);
  const shadowSpread = sizeValue < 50 ? Math.max(sizeValue * 4e-3, 0.5) : Math.max(sizeValue * 8e-3, 2);
  const maskRadius = sizeValue < 30 ? "0%" : sizeValue < 50 ? "5%" : sizeValue < 100 ? "15%" : "25%";
  const finalContrast = sizeValue < 30 ? 1.1 : sizeValue < 50 ? Math.max(contrastAmount * 1.2, 1.3) : contrastAmount;
  const wrapperRef = useRef71(null);
  const orbRef = useRef71(null);
  const audioRefRef = useRef71(audioLevelRef);
  audioRefRef.current = audioLevelRef;
  const motionRef = useRef71({ angle: 0, baseVelocity: 360 / animationDuration });
  useEffect51(() => {
    if (!animating) return;
    const motion = motionRef.current;
    const baseV = 360 / animationDuration;
    let last = performance.now();
    let velocity = 1;
    let prevAudio = 0;
    let lastShadowAudio = -1;
    let raf = 0;
    const tick = (now) => {
      const dt = Math.max(0, (now - last) / 1e3);
      last = now;
      const audio = audioRefRef.current?.current ?? 0;
      const delta = audio - prevAudio;
      prevAudio = audio;
      if (delta > 0) {
        velocity = Math.min(velocity + Math.sqrt(delta) * 60, 30);
      }
      velocity = 1 + (velocity - 1) * 0.9 ** (dt * 60);
      if (velocity < 1.001) velocity = 1;
      motion.baseVelocity = baseV + (motion.baseVelocity - baseV) * Math.exp(-dt / SPEED_EASE_S);
      motion.angle = (motion.angle + motion.baseVelocity * velocity * dt) % 360;
      orbRef.current?.style.setProperty("--siri-angle", `${motion.angle}deg`);
      const a = audio ** (1 / 3);
      const idleWeight = audio < 0.02 ? 1 - audio / 0.02 : 0;
      const idleBreath = idleWeight === 0 ? 0 : Math.sin(now / 1e3 * (Math.PI * 2 / 3.5)) * 0.015 * idleWeight;
      const scale = 1 + a * 0.6 + idleBreath;
      const wrapper = wrapperRef.current;
      if (wrapper) {
        wrapper.style.transform = `scale(${scale})`;
        wrapper.style.filter = `saturate(${1 + a * 0.3})`;
        if (Math.abs(audio - lastShadowAudio) >= 5e-3) {
          lastShadowAudio = audio;
          wrapper.style.boxShadow = [
            `0 0 ${Math.round(4 + a * 14)}px color-mix(in srgb, var(--color-primary, #ffc000) ${Math.round(35 + a * 45)}%, transparent)`,
            `0 0 ${Math.round(14 + a * 30)}px color-mix(in srgb, var(--color-primary, #ffc000) ${Math.round(18 + a * 32)}%, transparent)`,
            `0 0 ${Math.round(28 + a * 52)}px color-mix(in srgb, var(--color-primary, #ffc000) ${Math.round(8 + a * 20)}%, transparent)`,
            `0 0 ${Math.round(44 + a * 80)}px color-mix(in srgb, var(--color-primary, #ffc000) ${Math.round(3 + a * 10)}%, transparent)`
          ].join(", ");
        }
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [animationDuration, animating]);
  return /* @__PURE__ */ jsx78(
    "div",
    {
      ref: wrapperRef,
      className: "buyscout-siri-orb-reactive",
      "data-running": running ? void 0 : "false",
      children: /* @__PURE__ */ jsx78(
        "div",
        {
          ref: orbRef,
          className: "buyscout-siri-orb",
          style: {
            "width": size5,
            "height": size5,
            "--siri-blur-amount": `${blurAmount}px`,
            "--siri-contrast-amount": finalContrast,
            "--siri-dot-size": `${dotSize}px`,
            "--siri-shadow-spread": `${shadowSpread}px`,
            "--siri-mask-radius": maskRadius
          }
        }
      )
    }
  );
}
SiriOrb.displayName = "SiriOrb";

// src/components/composite/ChatControls/VoiceStage/voiceStageLabel.ts
function voiceStageLabelKey(connectingStage, toolCallActive, turn, error2) {
  if (error2) return `voiceStage.error.${error2}`;
  if (connectingStage === "requesting-mic") return "voiceStage.allowMic";
  if (connectingStage === "connecting") return "voiceStage.connecting";
  if (toolCallActive) return "voiceStage.toolCalling";
  return turn ? `voiceStage.turn.${turn}` : null;
}

// src/components/composite/ChatControls/VoiceStage/VoiceStage.tsx
import { jsx as jsx79, jsxs as jsxs45 } from "react/jsx-runtime";
function VoiceStage(props) {
  const { t } = useComponentsTranslation();
  const { visible, audioLevelRef, connectingStage, toolCallActive = false, turn, error: error2, onRetry } = props;
  const isRequestingMic = connectingStage === "requesting-mic";
  const isConnecting = connectingStage === "connecting";
  const labelKey = voiceStageLabelKey(connectingStage, toolCallActive, turn);
  const isTool = toolCallActive && !isRequestingMic && !isConnecting;
  const labelText = labelKey ? t(labelKey) : null;
  const zeroRef = useRef72({ current: 0 });
  const orbAudioRef = isRequestingMic || isConnecting ? zeroRef.current : audioLevelRef;
  if (error2) {
    return /* @__PURE__ */ jsx79("div", { className: `buyscout-voice-stage__area ${visible ? "buyscout-voice-stage__area--visible" : ""}`, children: /* @__PURE__ */ jsxs45("div", { className: "buyscout-voice-stage__failure", inert: !visible, children: [
      /* @__PURE__ */ jsx79(Text, { as: "p", variant: "body-sm", className: "buyscout-voice-stage__failure-text", children: t(`voiceStage.error.${error2}`) }),
      onRetry && /* @__PURE__ */ jsx79(Button, { size: "sm", onClick: onRetry, children: t("shared.chat.retry") })
    ] }) });
  }
  const columnClassName = [
    "buyscout-voice-stage__column",
    isRequestingMic && "buyscout-voice-stage__column--requesting-mic",
    isConnecting && "buyscout-voice-stage__column--connecting",
    isTool && "buyscout-voice-stage__column--tool-call",
    labelKey && !isRequestingMic && !isConnecting && !isTool && "buyscout-voice-stage__column--caption"
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx79("div", { className: `buyscout-voice-stage__area ${visible ? "buyscout-voice-stage__area--visible" : ""}`, children: /* @__PURE__ */ jsxs45("div", { className: columnClassName, children: [
    isRequestingMic && /* @__PURE__ */ jsx79("div", { className: "buyscout-voice-stage__hint-top", children: /* @__PURE__ */ jsxs45("div", { className: "buyscout-voice-stage__hint", children: [
      /* @__PURE__ */ jsx79(MdNorthWest, { className: "buyscout-voice-stage__hint-arrow" }),
      /* @__PURE__ */ jsx79(Text, { variant: "body-xs", className: "buyscout-voice-stage__hint-text", children: t("voiceStage.permissionHint") })
    ] }) }),
    /* @__PURE__ */ jsx79("div", { className: "buyscout-voice-stage__orb-anchor", children: /* @__PURE__ */ jsx79(SiriOrb, { audioLevelRef: orbAudioRef, size: "80px", running: visible }) }),
    /* @__PURE__ */ jsx79("div", { className: "buyscout-voice-stage__text", children: labelText && /* @__PURE__ */ jsx79("div", { className: "buyscout-voice-stage__prompt", children: /* @__PURE__ */ jsx79(Text, { variant: "body-sm", className: "buyscout-voice-stage__prompt-text", children: labelText }) }, labelText) })
  ] }) });
}
VoiceStage.displayName = "VoiceStage";

// src/components/composite/ChatControls/ChatBar/ChatBar.tsx
import { jsx as jsx80, jsxs as jsxs46 } from "react/jsx-runtime";
var ACTION_TITLE = {
  voice: "chatBar.useVoiceTitle",
  send: "chatBar.sendTitle",
  end: "chatBar.endVoiceTitle"
};
var ACTION_LABEL = {
  voice: "chatBar.switchToVoiceAria",
  send: "chatBar.sendMessageAria",
  end: "chatBar.switchToTextAria"
};
function ChatBar(props) {
  const { t } = useComponentsTranslation();
  const {
    value,
    onChange,
    onEnterPress,
    maxLength = 2e3,
    disabled: disabled2 = false,
    autoFocus = false,
    products,
    knownProducts,
    onProductSearch,
    onProductSearchClear,
    onProductNotFoundChange,
    onSend,
    onAtTrigger,
    isSending = false,
    showMentionButton = false,
    productChipsSlot,
    errorMessage,
    popupMessageId,
    popupMessage,
    productMap,
    popupMessageVisible = false,
    popupMessageReplies,
    popupMessageProduct,
    popupMessageProductLoading,
    onPopupMessageClick,
    onPopupMessageReplyClick,
    onPopupMessageAddToCart,
    onPopupMessageDismiss,
    storeDomain,
    popupMessageAutoDismissMs,
    popupMessageIsStreaming,
    voiceMode = false,
    voiceConnectingStage,
    onVoiceModeChange,
    voiceAudioLevelRef,
    voiceToolCallActive = false,
    voiceTurn,
    voiceError,
    onVoiceRetry,
    tryOn,
    onTryOnClick,
    editMode = false,
    onEditModeClose,
    inputRef: externalInputRef,
    onFocus,
    foldState,
    inert = false,
    className = "",
    containerClassName = "",
    fixed = true
  } = props;
  const tryOnActive = tryOn != null && !voiceMode;
  const collapsedHeightRef = useRef73(0);
  const tryOnMorph = useComposerTryOnMorph(tryOnActive, tryOn, collapsedHeightRef.current);
  const showsEditBanner = editMode && !tryOnMorph.showing;
  const editLabelId = React133.useId();
  const editBanner = (
    // The try-on morph measures the bar without the banner, so the banner leaves it at once.
    /* @__PURE__ */ jsx80(Collapse, { in: showsEditBanner, timeout: tryOnMorph.showing ? 0 : void 0, className: "buyscout-chat-bar__edit-collapse", children: /* @__PURE__ */ jsx80(EditBanner, { labelId: editLabelId, onClose: onEditModeClose }) })
  );
  const morphShowingRef = useRef73(tryOnMorph.showing);
  morphShowingRef.current = tryOnMorph.showing;
  const internalInputRef = useRef73(null);
  const inputRef = externalInputRef || internalInputRef;
  const leadingButtonRef = useRef73(null);
  const [inputFocused, setInputFocused] = useState62(false);
  const containerFocused = inputFocused || voiceMode;
  const {
    containerRef,
    productSelectorRef,
    selectorOpen,
    caretRect,
    getCaretRect,
    handleAtTrigger,
    handleAtClose,
    handleWordMatchTrigger,
    handleWordMatchClose,
    handleProductSelect,
    handleSelectorClose,
    handleContainerKeyDown,
    selectorProducts,
    showSearchBox,
    listboxId,
    activeOptionId,
    handleActiveOptionChange
  } = useProductSelector({ inputRef, products, onProductSearch, onProductSearchClear, onAtTrigger });
  useEffect52(() => {
    if (inert && selectorOpen) handleSelectorClose(false);
  }, [inert, selectorOpen, handleSelectorClose]);
  const { handleSendClick, handleEnterPress, isEmpty, sendDisabled } = useChatSend({
    inputRef,
    value,
    disabled: disabled2,
    onSend,
    onEnterPress,
    isSending
  });
  let actionState = "send";
  if (onVoiceModeChange && voiceMode) actionState = "end";
  else if (onVoiceModeChange && isEmpty) actionState = "voice";
  useEffect52(() => {
    const container = containerRef.current;
    if (!container) return;
    const measure2 = () => {
      if (morphShowingRef.current) return;
      const heightOf = (selector) => {
        const el = container.querySelector(selector);
        return el ? el.offsetHeight : 0;
      };
      const total = heightOf(".buyscout-chat-bar__row") + heightOf(".buyscout-chat-bar__chip-row") + heightOf(".buyscout-chat-bar__hint");
      if (total > 0) collapsedHeightRef.current = total;
    };
    measure2();
    const observer = new ResizeObserver(measure2);
    observer.observe(container);
    return () => observer.disconnect();
  }, [containerRef]);
  return /* @__PURE__ */ jsxs46("div", { className: `buyscout-chat-bar ${fixed ? "buyscout-chat-bar--fixed" : ""} ${className}`, children: [
    popupMessageVisible && (popupMessage || popupMessageProduct) && /* @__PURE__ */ jsx80("div", { className: "buyscout-chat-bar__message", children: /* @__PURE__ */ jsx80(
      PopupMessage,
      {
        message: popupMessage ?? "",
        productMap,
        replies: popupMessageReplies,
        product: popupMessageProduct,
        productLoading: popupMessageProductLoading,
        onClick: onPopupMessageClick,
        onReplyClick: (value2) => {
          onPopupMessageReplyClick?.(value2);
        },
        onAddToCart: onPopupMessageAddToCart,
        onDismiss: onPopupMessageDismiss,
        autoDismissMs: popupMessageAutoDismissMs,
        storeDomain,
        isStreaming: popupMessageIsStreaming
      },
      popupMessageId
    ) }),
    /* @__PURE__ */ jsxs46(
      "div",
      {
        className: `buyscout-chat-bar__wrapper ${containerClassName}`,
        "data-state": foldState,
        inert: inert || void 0,
        onKeyDownCapture: (event) => {
          if (showMentionButton && event.target === leadingButtonRef.current && event.key === "Enter") return;
          handleContainerKeyDown(event);
        },
        children: [
          /* @__PURE__ */ jsxs46("div", { ref: containerRef, className: `buyscout-chat-bar__container ${containerFocused ? "buyscout-chat-bar__container--focused" : ""} ${productChipsSlot ? "buyscout-chat-bar__container--has-chip" : ""} ${tryOnMorph.showing ? "buyscout-chat-bar__container--tryon" : ""} ${tryOnMorph.open ? "buyscout-chat-bar__container--tryon-open" : ""}`, children: [
            /* @__PURE__ */ jsx80(
              "div",
              {
                className: `buyscout-tryon-morph ${tryOnMorph.open ? "is-open" : ""}`,
                ref: tryOnMorph.wrapperRef,
                onTransitionEnd: tryOnMorph.onMorphTransitionEnd,
                children: /* @__PURE__ */ jsx80("div", { className: "buyscout-tryon-morph__clip", ref: tryOnMorph.contentRef, children: tryOnMorph.content && /* @__PURE__ */ jsx80(TryOnStage, { ...tryOnMorph.content }) })
              }
            ),
            errorMessage && /* @__PURE__ */ jsx80("div", { className: "buyscout-chat-bar__hint", role: "alert", children: errorMessage }),
            /* @__PURE__ */ jsxs46("div", { className: "buyscout-chat-bar__row", children: [
              /* @__PURE__ */ jsxs46("div", { className: `buyscout-chat-bar__row-text ${voiceMode ? "buyscout-chat-bar__row-text--hidden" : ""}`, inert: voiceMode, children: [
                showMentionButton && /* @__PURE__ */ jsx80(Tooltip, { title: t("chatBar.mentionProductsTitle"), placement: "top", children: /* @__PURE__ */ jsx80(
                  Button,
                  {
                    ref: leadingButtonRef,
                    type: "button",
                    variant: "borderless",
                    color: "neutral",
                    shape: "circle",
                    size: "lg",
                    iconOnly: true,
                    onClick: () => {
                      if (selectorOpen) handleSelectorClose();
                      else handleAtTrigger();
                    },
                    onMouseDown: (event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      inputRef.current?.saveCursorPosition();
                    },
                    disabled: disabled2,
                    className: "buyscout-chat-bar__leading-button buyscout-chat-bar__leading-button--product-search",
                    "aria-label": t("chatBar.mentionProductAria"),
                    "aria-expanded": selectorOpen,
                    children: /* @__PURE__ */ jsx80(LuPlus, { "aria-hidden": true })
                  }
                ) }),
                /* @__PURE__ */ jsx80(
                  ChatInput,
                  {
                    ref: inputRef,
                    ariaControls: selectorOpen && !inert ? listboxId : void 0,
                    ariaActiveDescendant: selectorOpen && !inert ? activeOptionId ?? void 0 : void 0,
                    ariaDescribedBy: showsEditBanner ? editLabelId : void 0,
                    value,
                    onEnterPress: handleEnterPress,
                    onAtTrigger: handleAtTrigger,
                    onChange,
                    onProductNotFoundChange,
                    onFocus: () => {
                      setInputFocused(true);
                      onFocus?.();
                    },
                    onBlur: () => setInputFocused(false),
                    onWordMatchTrigger: handleWordMatchTrigger,
                    onWordMatchClose: handleWordMatchClose,
                    onAtClose: handleAtClose,
                    products,
                    knownProducts,
                    placeholder: t("chatBar.placeholder"),
                    disabled: disabled2,
                    maxLength,
                    autoFocus,
                    className: "buyscout-chat-bar__input"
                  }
                ),
                onTryOnClick && /* @__PURE__ */ jsxs46(
                  Button,
                  {
                    type: "button",
                    variant: "tinted",
                    color: "primary",
                    size: "sm",
                    shape: "pill",
                    className: "buyscout-chat-bar__tryon-button",
                    onClick: onTryOnClick,
                    disabled: disabled2,
                    children: [
                      /* @__PURE__ */ jsx80(MdCheckroom, { size: 16, "aria-hidden": true }),
                      t("tryOn.button")
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ jsx80(Tooltip, { title: t(ACTION_TITLE[actionState]), placement: "top", children: /* @__PURE__ */ jsx80(
                Button,
                {
                  type: "button",
                  ...actionState === "end" ? { variant: "tinted", color: "error" } : { variant: "prominent", color: "primary" },
                  shape: "circle",
                  size: "md",
                  iconOnly: true,
                  onMouseDown: actionState === "send" ? (event) => event.preventDefault() : void 0,
                  onClick: (event) => {
                    if (actionState !== "send") {
                      onVoiceModeChange?.(actionState === "voice");
                      return;
                    }
                    const hadFocus = event.currentTarget.matches(":focus");
                    handleSendClick();
                    if (hadFocus && !onVoiceModeChange) inputRef.current?.focus();
                  },
                  disabled: actionState === "send" ? sendDisabled : disabled2,
                  className: `buyscout-chat-bar__action-button${actionState === "end" ? " buyscout-chat-bar__action-button--voice-active" : ""}`,
                  "aria-label": t(ACTION_LABEL[actionState]),
                  children: /* @__PURE__ */ jsxs46("span", { className: "buyscout-chat-bar__action-glyphs", "aria-hidden": true, children: [
                    onVoiceModeChange && /* @__PURE__ */ jsx80(LuAudioLines, { className: "buyscout-chat-bar__action-glyph", "data-shown": actionState === "voice" || void 0 }),
                    /* @__PURE__ */ jsx80(LuArrowUp, { className: "buyscout-chat-bar__action-glyph", "data-shown": actionState === "send" || void 0 }),
                    onVoiceModeChange && /* @__PURE__ */ jsx80(LuX, { className: "buyscout-chat-bar__action-glyph", "data-shown": actionState === "end" || void 0 })
                  ] })
                }
              ) })
            ] }),
            onVoiceModeChange && /* @__PURE__ */ jsx80("div", { className: `buyscout-chat-bar__voice-spacer ${voiceMode ? "buyscout-chat-bar__voice-spacer--active" : ""}` }),
            productChipsSlot && /* @__PURE__ */ jsx80("div", { className: `buyscout-chat-bar__chip-row ${voiceMode ? "buyscout-chat-bar__chip-row--voice" : ""} ${voiceMode && voiceConnectingStage === "requesting-mic" ? "buyscout-chat-bar__chip-row--hidden" : ""}`, children: productChipsSlot }),
            onVoiceModeChange ? /* @__PURE__ */ jsx80("div", { className: `buyscout-chat-bar__text-content ${voiceMode ? "buyscout-chat-bar__text-content--collapsed" : ""}`, inert: voiceMode, children: editBanner }) : editBanner,
            onVoiceModeChange && /* @__PURE__ */ jsx80(
              VoiceStage,
              {
                visible: voiceMode,
                audioLevelRef: voiceAudioLevelRef,
                connectingStage: voiceConnectingStage,
                toolCallActive: voiceToolCallActive,
                turn: voiceTurn,
                error: voiceError,
                onRetry: onVoiceRetry
              }
            )
          ] }),
          /* @__PURE__ */ jsx80(
            ProductSelector,
            {
              ref: productSelectorRef,
              className: showMentionButton ? "product-selector--chat-bar" : void 0,
              products: selectorProducts,
              onSelect: handleProductSelect,
              onClose: handleSelectorClose,
              anchorEl: containerRef.current,
              anchorRect: showMentionButton ? null : caretRect,
              getAnchorRect: showMentionButton ? void 0 : getCaretRect,
              open: selectorOpen && !inert,
              onSearch: onProductSearch,
              showSearchBox,
              listboxId,
              onActiveOptionChange: handleActiveOptionChange
            }
          )
        ]
      }
    )
  ] });
}
ChatBar.displayName = "ChatBar";

// src/components/composite/ChatControls/ChatBarIsland/ChatBarIsland.tsx
import { useCallback as useCallback30, useId as useId10, useLayoutEffect as useLayoutEffect11, useRef as useRef74, useState as useState63 } from "react";
import { Icon } from "@iconify/react/offline";

// src/utils/getInitials.ts
var IDEOGRAPHIC = /^[\p{Script=Han}\p{Script=Hiragana}\p{Script=Katakana}\p{Script=Hangul}\p{Script=Bopomofo}]/u;
var segmenter;
function graphemes(text4) {
  if (segmenter === void 0) {
    segmenter = typeof Intl !== "undefined" && typeof Intl.Segmenter === "function" ? new Intl.Segmenter(void 0, { granularity: "grapheme" }) : null;
  }
  return segmenter ? Array.from(segmenter.segment(text4), (part) => part.segment) : Array.from(text4);
}
function firstGrapheme(word) {
  return graphemes(word)[0] ?? "";
}
function getInitials(name2, locale) {
  let text4 = name2.trim();
  const at = text4.indexOf("@");
  const isEmail = at > 0 && !/\s/.test(text4);
  if (isEmail) {
    text4 = text4.slice(0, at).split("+")[0];
  }
  const words = text4.split(isEmail ? /[._-]+/ : /\s+/).filter(Boolean);
  if (words.length === 0) {
    return "";
  }
  const first = firstGrapheme(words[0]);
  if (IDEOGRAPHIC.test(first)) {
    return first;
  }
  const last = words.length > 1 ? firstGrapheme(words[words.length - 1]) : "";
  return (first + last).toLocaleUpperCase(locale);
}

// src/components/composite/ChatControls/ChatBarIsland/chatOutlineIcon.ts
var CHAT_OUTLINE_ICON = {
  body: '<path fill="currentColor" d="M12,3C6.5,3 2,6.58 2,11C2.05,13.15 3.06,15.17 4.75,16.5C4.75,17.1 4.33,18.67 2,21C4.37,20.89 6.64,20 8.47,18.5C9.61,18.83 10.81,19 12,19C17.5,19 22,15.42 22,11C22,6.58 17.5,3 12,3M12,5C16.41,5 20,7.69 20,11C20,14.31 16.41,17 12,17C10.96,17 9.93,16.85 8.94,16.56L8.5,16.43L8.15,16.71C7.34,17.35 6.45,17.87 5.5,18.24C5.71,17.74 5.86,17.21 5.95,16.66L6.05,16.07L5.5,15.43C4.5,14.5 4,13 4,11C4,7.69 7.59,5 12,5Z"/>',
  width: 24,
  height: 24
};

// src/components/composite/ChatControls/ChatBarIsland/ChatBarIsland.tsx
import { jsx as jsx81, jsxs as jsxs47 } from "react/jsx-runtime";
var RESIZE_MS = 420;
var RESIZE_EASING2 = "cubic-bezier(0.22, 1, 0.36, 1)";
var ORB_SIZE = "36px";
var chatBarIslandVariants = cva("buyscout-chat-bar-island", {
  variants: {
    variant: {
      idle: "buyscout-chat-bar-island--idle",
      message: "buyscout-chat-bar-island--message"
    }
  },
  defaultVariants: {
    variant: "idle"
  }
});
function prefersReducedMotion() {
  return typeof window !== "undefined" && !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
}
function sizeOf(el) {
  const style = getComputedStyle(el);
  return { width: Number.parseFloat(style.width), height: Number.parseFloat(style.height) };
}
function ChatBarIsland({
  ref,
  ...props
}) {
  const { t, i18n } = useComponentsTranslation();
  const {
    variant = "idle",
    state = "hidden",
    label = t("chatBar.placeholder"),
    openLabel = t("chatBar.openChatAria"),
    unread = false,
    storeName,
    storeLogo,
    message,
    children,
    onDismiss,
    onOpen,
    onVoice,
    voiceLabel = t("chatBar.switchToVoiceAria"),
    onPointerEnter,
    onPointerLeave,
    onFocus,
    onBlur,
    className
  } = props;
  const id = useId10();
  const heading2 = storeName || t("appBar.storeAssistant");
  const showsCard = variant === "message";
  const hasContent = showsCard && children != null;
  const labelledBy = `${id}-${showsCard ? "name" : "label"} ${id}-open`;
  const describedId = showsCard ? !hasContent && message && "message" : unread && "unread";
  const describedBy = describedId ? `${id}-${describedId}` : void 0;
  const [orbHovered, setOrbHovered] = useState63(false);
  const [orbFocusVisible, setOrbFocusVisible] = useState63(false);
  if (state !== "shown" && (orbHovered || orbFocusVisible)) {
    setOrbHovered(false);
    setOrbFocusVisible(false);
  }
  const rootRef = useRef74(null);
  const resizeRef = useRef74(null);
  const lastSizeRef = useRef74(null);
  const lastVariantRef = useRef74(variant);
  const setRootRef = useCallback30((node) => {
    rootRef.current = node;
    if (typeof ref === "function") {
      const cleanup = ref(node);
      return () => {
        rootRef.current = null;
        if (typeof cleanup === "function") cleanup();
        else ref(null);
      };
    }
    if (ref) ref.current = node;
    return () => {
      rootRef.current = null;
      if (ref) ref.current = null;
    };
  }, [ref]);
  useLayoutEffect11(() => {
    const el = rootRef.current;
    if (!el) return;
    if (lastVariantRef.current !== variant) {
      lastVariantRef.current = variant;
      const running = resizeRef.current;
      const from = running ? sizeOf(el) : lastSizeRef.current;
      running?.cancel();
      resizeRef.current = null;
      el.style.removeProperty("height");
      const to = sizeOf(el);
      if (hasContent) el.style.height = `${to.height}px`;
      lastSizeRef.current = to;
      const animate = from != null && state === "shown" && typeof el.animate === "function" && !prefersReducedMotion() && (from.width !== to.width || from.height !== to.height);
      if (animate) {
        const animation = el.animate(
          [{ width: `${from.width}px`, height: `${from.height}px` }, { width: `${to.width}px`, height: `${to.height}px` }],
          { duration: RESIZE_MS, easing: RESIZE_EASING2 }
        );
        const settle = () => {
          if (resizeRef.current === animation) resizeRef.current = null;
        };
        animation.onfinish = settle;
        animation.oncancel = settle;
        resizeRef.current = animation;
      }
    }
    if (!resizeRef.current && !hasContent) lastSizeRef.current = sizeOf(el);
  });
  useLayoutEffect11(() => {
    const el = rootRef.current;
    const card = el?.querySelector(".buyscout-chat-bar-island__card");
    if (!el || !card || !hasContent || !showsCard || state !== "shown") return;
    if (!resizeRef.current) lastSizeRef.current = sizeOf(el);
    el.style.height = `${lastSizeRef.current.height}px`;
    let previousHeight = Number.parseFloat(getComputedStyle(card).height);
    const observer = new ResizeObserver(() => {
      const height = Number.parseFloat(getComputedStyle(card).height);
      if (height === previousHeight) return;
      previousHeight = height;
      const from = sizeOf(el);
      resizeRef.current?.cancel();
      resizeRef.current = null;
      const style = getComputedStyle(el);
      const to = { width: Number.parseFloat(style.width), height: height + Number.parseFloat(style.paddingTop) + Number.parseFloat(style.paddingBottom) + Number.parseFloat(style.borderTopWidth) + Number.parseFloat(style.borderBottomWidth) };
      el.style.height = `${to.height}px`;
      lastSizeRef.current = to;
      if (prefersReducedMotion() || from.height === to.height) return;
      const animation = el.animate(
        [{ width: `${from.width}px`, height: `${from.height}px` }, { width: `${to.width}px`, height: `${to.height}px` }],
        { duration: 200, easing: "cubic-bezier(0.23, 1, 0.32, 1)" }
      );
      resizeRef.current = animation;
      const settle = () => {
        if (resizeRef.current === animation) resizeRef.current = null;
      };
      animation.onfinish = settle;
      animation.oncancel = settle;
    });
    observer.observe(card);
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const stop = () => {
      resizeRef.current?.cancel();
    };
    motion.addEventListener("change", stop);
    return () => {
      observer.disconnect();
      motion.removeEventListener("change", stop);
    };
  }, [hasContent, showsCard, state]);
  useLayoutEffect11(() => {
    if (state !== "shown") {
      resizeRef.current?.cancel();
      rootRef.current?.style.removeProperty("height");
    }
  }, [state]);
  useLayoutEffect11(() => () => resizeRef.current?.cancel(), []);
  return /* @__PURE__ */ jsxs47(
    "div",
    {
      ref: setRootRef,
      className: clsx_default(chatBarIslandVariants({ variant }), hasContent && "buyscout-chat-bar-island--rich", className),
      "data-state": state,
      onPointerEnter,
      onPointerLeave,
      onFocus,
      onBlur,
      children: [
        /* @__PURE__ */ jsx81(
          "button",
          {
            type: "button",
            className: "buyscout-chat-bar-island__hit",
            "aria-labelledby": labelledBy,
            "aria-describedby": describedBy,
            tabIndex: state === "shown" ? void 0 : -1,
            onClick: onOpen
          }
        ),
        /* @__PURE__ */ jsx81("span", { id: `${id}-open`, hidden: true, children: openLabel }),
        unread && /* @__PURE__ */ jsx81("span", { id: `${id}-unread`, hidden: true, children: t("chatBar.unreadAria") }),
        onVoice && /* @__PURE__ */ jsx81("span", { className: "buyscout-chat-bar-island__voice-slot", children: /* @__PURE__ */ jsx81(Tooltip, { title: t("chatBar.useVoiceTitle"), placement: "top", instant: true, disabled: state !== "shown" || variant === "message", children: /* @__PURE__ */ jsx81(
          "button",
          {
            type: "button",
            className: "buyscout-chat-bar-island__voice",
            "aria-label": voiceLabel,
            tabIndex: state === "shown" ? void 0 : -1,
            onClick: onVoice,
            onPointerEnter: () => setOrbHovered(true),
            onPointerLeave: () => setOrbHovered(false),
            onFocus: (event) => setOrbFocusVisible(event.currentTarget.matches(":focus-visible")),
            onBlur: () => setOrbFocusVisible(false),
            children: state !== "hidden" && /* @__PURE__ */ jsx81(SiriOrb, { size: ORB_SIZE, animationDuration: orbHovered || orbFocusVisible ? 20 : 60 })
          }
        ) }) }),
        /* @__PURE__ */ jsxs47("span", { className: "buyscout-chat-bar-island__idle", "aria-hidden": "true", children: [
          onVoice ? /* @__PURE__ */ jsx81("span", { className: "buyscout-chat-bar-island__sep" }) : /* @__PURE__ */ jsx81(Icon, { icon: CHAT_OUTLINE_ICON, className: "buyscout-chat-bar-island__icon" }),
          /* @__PURE__ */ jsx81("span", { id: `${id}-label`, className: "buyscout-chat-bar-island__label", children: label }),
          unread && /* @__PURE__ */ jsx81("span", { className: "buyscout-chat-bar-island__dot" })
        ] }),
        /* @__PURE__ */ jsxs47("div", { className: "buyscout-chat-bar-island__card", "aria-hidden": hasContent ? void 0 : true, inert: hasContent && state !== "shown", children: [
          /* @__PURE__ */ jsx81(
            Avatar2,
            {
              size: "sm",
              shape: "rounded",
              fit: "contain",
              src: storeLogo,
              fallback: getInitials(heading2, i18n.language),
              className: "buyscout-chat-bar-island__avatar"
            }
          ),
          /* @__PURE__ */ jsxs47("span", { className: "buyscout-chat-bar-island__text", children: [
            /* @__PURE__ */ jsx81("b", { id: `${id}-name`, className: "buyscout-chat-bar-island__name", children: heading2 }),
            !hasContent && /* @__PURE__ */ jsx81("span", { id: `${id}-message`, className: "buyscout-chat-bar-island__message", children: message })
          ] }),
          hasContent && onDismiss && /* @__PURE__ */ jsx81(
            ChromeDismissButton,
            {
              size: "xs",
              className: "buyscout-chat-bar-island__dismiss",
              label: t("popupMessage.dismissAria"),
              onClick: onDismiss
            }
          ),
          hasContent && /* @__PURE__ */ jsx81("div", { className: "buyscout-chat-bar-island__content", children })
        ] })
      ]
    }
  );
}
ChatBarIsland.displayName = "ChatBarIsland";
function ChatBarIslandShade({
  ref,
  visible = false,
  onPress,
  className
}) {
  return /* @__PURE__ */ jsx81(
    "div",
    {
      ref,
      className: clsx_default("buyscout-chat-bar-island__shade", className),
      "data-state": visible ? "visible" : "hidden",
      "aria-hidden": "true",
      onClick: onPress
    }
  );
}
ChatBarIslandShade.displayName = "ChatBarIslandShade";

// src/components/composite/ChatControls/FloatingButton/ChatIcon.tsx
import { useId as useId11 } from "react";
import { jsx as jsx82, jsxs as jsxs48 } from "react/jsx-runtime";
var BUBBLE_PATH = "M40 2 L171 2 A34 34 0 0 1 205 36 L205 116 A34 34 0 0 1 171 150 L98 150 C84 176 66 192 52 192 C60 178 64 164 64 150 L40 150 A34 34 0 0 1 6 116 L6 36 A34 34 0 0 1 40 2 Z";
function ChatIcon(props) {
  const { className = "", width = "40", height = "40", variant = "outlined" } = props;
  const uid = useId11();
  const gradientId = `chat-icon-gradient-${uid}`;
  const isFilled = variant === "filled";
  return /* @__PURE__ */ jsxs48(
    "svg",
    {
      className,
      width,
      height,
      viewBox: "0 0 211.48 205.75",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        !isFilled && /* @__PURE__ */ jsx82("defs", { children: /* @__PURE__ */ jsxs48("linearGradient", { id: gradientId, x1: "0%", y1: "0%", x2: "0%", y2: "100%", children: [
          /* @__PURE__ */ jsx82("stop", { offset: "0%", stopColor: "var(--color-primary-light)" }),
          /* @__PURE__ */ jsx82("stop", { offset: "100%", stopColor: "var(--color-primary)" })
        ] }) }),
        /* @__PURE__ */ jsx82("path", { d: BUBBLE_PATH, fill: isFilled ? "var(--bs-lg-on-accent)" : `url(#${gradientId})` })
      ]
    }
  );
}
ChatIcon.displayName = "ChatIcon";

// src/components/composite/ChatControls/FloatingButton/floatingButtonSize.ts
var FLOATING_BUTTON_FALLBACK_SIZE_PX = 56;
var FLOATING_BUTTON_SIZE = `var(--floating-button-size, var(--floating-button-default-size, ${FLOATING_BUTTON_FALLBACK_SIZE_PX}px))`;

// src/components/composite/ChatControls/FloatingButton/FloatingButton.tsx
import { jsx as jsx83, jsxs as jsxs49 } from "react/jsx-runtime";
var wrapperStyle = {
  "--floating-button-resolved-size": FLOATING_BUTTON_SIZE
};
var floatingButtonVariants = cva("buyscout-floating-button", {
  variants: {
    variant: {
      filled: "buyscout-floating-button--filled",
      outlined: "buyscout-floating-button--outlined"
    }
  },
  defaultVariants: {
    variant: "outlined"
  }
});
function FloatingButton(props) {
  const { t } = useTranslation();
  const {
    onClick,
    variant = "outlined",
    popupMessageId,
    popupMessage,
    productMap,
    popupMessageVisible = false,
    popupMessageReplies,
    popupMessageProduct,
    popupMessageProductLoading,
    onPopupMessageClick,
    onPopupMessageReplyClick,
    onPopupMessageAddToCart,
    onPopupMessageDismiss,
    storeDomain,
    popupMessageAutoDismissMs,
    popupMessageIsStreaming
  } = props;
  return /* @__PURE__ */ jsxs49("div", { className: "buyscout-floating-button-wrapper", style: wrapperStyle, children: [
    popupMessageVisible && (popupMessage || popupMessageProduct) && /* @__PURE__ */ jsx83("div", { className: "buyscout-floating-button-wrapper__message", children: /* @__PURE__ */ jsx83(
      PopupMessage,
      {
        message: popupMessage ?? "",
        productMap,
        replies: popupMessageReplies,
        product: popupMessageProduct,
        productLoading: popupMessageProductLoading,
        onClick: onPopupMessageClick,
        onReplyClick: (value) => {
          onPopupMessageReplyClick?.(value);
        },
        onAddToCart: onPopupMessageAddToCart,
        onDismiss: onPopupMessageDismiss,
        autoDismissMs: popupMessageAutoDismissMs,
        storeDomain,
        isStreaming: popupMessageIsStreaming
      },
      popupMessageId
    ) }),
    /* @__PURE__ */ jsx83(
      "button",
      {
        type: "button",
        "aria-label": t("chatBar.openChatAria"),
        className: floatingButtonVariants({ variant }),
        onClick,
        children: /* @__PURE__ */ jsx83(ChatIcon, { className: "buyscout-floating-button__icon", variant })
      }
    )
  ] });
}
FloatingButton.displayName = "FloatingButton";

// src/components/composite/ChatLog/ChatLog.tsx
import { Fragment as Fragment25, useCallback as useCallback33, useEffect as useEffect57, useLayoutEffect as useLayoutEffect14, useRef as useRef85, useState as useState70 } from "react";
import { MdArrowDownward } from "react-icons/md";

// src/domain/chat/constants.ts
var MAX_MESSAGE_LENGTH = 2e3;
var MAX_MESSAGES_COUNT = 100;
var MAX_CHAT_PRODUCTS = 5;
function getDistinctProductCount(message, currentProductId) {
  const ids = /* @__PURE__ */ new Set();
  if (currentProductId != null && currentProductId !== "") {
    ids.add(String(currentProductId));
  }
  const mentionIds = (message.match(/@\[[^\]]+\]/g) || []).map((s) => s.slice(2, -1));
  mentionIds.forEach((id) => ids.add(id));
  return ids.size;
}

// src/domain/chat/types.ts
var ChatRole = /* @__PURE__ */ ((ChatRole2) => {
  ChatRole2["User"] = "user";
  ChatRole2["Assistant"] = "assistant";
  ChatRole2["System"] = "system";
  return ChatRole2;
})(ChatRole || {});
var ChatStreamStatus = /* @__PURE__ */ ((ChatStreamStatus2) => {
  ChatStreamStatus2["Idle"] = "Idle";
  ChatStreamStatus2["Waiting"] = "Waiting";
  ChatStreamStatus2["InProgress"] = "InProgress";
  ChatStreamStatus2["Success"] = "Success";
  ChatStreamStatus2["Failure"] = "Failure";
  return ChatStreamStatus2;
})(ChatStreamStatus || {});

// src/domain/chat/message-visibility.ts
function shouldRenderChatMessage(message, sessionStatus) {
  if (message.role === "user" /* User */) return !!message.content;
  if (message.role === "assistant" /* Assistant */) return (message.timeline?.length ?? 0) > 0 || isFailedEmptyReply(message, sessionStatus);
  return false;
}
function isFailedReply(message, sessionStatus) {
  return message.role === "assistant" /* Assistant */ && sessionStatus === "Failure" /* Failure */;
}
function isFailedEmptyReply(message, sessionStatus) {
  return message.role === "assistant" /* Assistant */ && isFailedReply(message, sessionStatus) && (message.timeline?.length ?? 0) === 0;
}
function hasSubstantiveAssistantContent(content, timeline) {
  if (content?.trim()) return true;
  return (timeline ?? []).some(
    (item) => item.type === "product_list" && (item.products?.length ?? 0) > 0 || item.type === "product_card" && item.product != null || item.type === "content" && Boolean(item.content?.trim()) || item.type === "clarifying_questions" && (item.questions?.length ?? 0) > 0 || item.type === "inline_form" && (item.fields?.length ?? 0) > 0 || item.type === "possible_replies" && (item.possibleReplies?.length ?? 0) > 0
  );
}

// src/domain/chat/utils.ts
function formatToolName(toolName) {
  return toolName.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase()).trim();
}
function isStreamLive(status) {
  return status === "InProgress" /* InProgress */ || status === "Waiting" /* Waiting */;
}

// src/components/composite/ChatMessage/ChatMessage.tsx
import * as React134 from "react";
import { useRef as useRef83 } from "react";
import { MdEdit as MdEdit2, MdMic, MdOutlineErrorOutline, MdOutlineThumbDown, MdOutlineThumbUp, MdRefresh, MdThumbDown, MdThumbUp } from "react-icons/md";

// src/hooks/useSlideToFit.ts
import { useLayoutEffect as useLayoutEffect12, useRef as useRef75 } from "react";
var SLIDE_MS = 280;
var SLIDE_CURVE = [0.23, 1, 0.32, 1];
var SLIDE_EASE = `cubic-bezier(${SLIDE_CURVE.join(", ")})`;
var REVEALING_CHAR = ".buyscout-char-fade-in";
function release(element2, inner) {
  element2.style.removeProperty("box-sizing");
  element2.style.removeProperty("width");
  element2.style.removeProperty("height");
  element2.style.removeProperty("overflow");
  element2.style.removeProperty("transition");
  inner.style.removeProperty("width");
  inner.style.removeProperty("max-width");
  inner.style.removeProperty("flex");
}
function bezier(u, p1, p2) {
  return 3 * (1 - u) ** 2 * u * p1 + 3 * (1 - u) * u ** 2 * p2 + u ** 3;
}
function slideTimeAt(progress) {
  const [x1, y1, x2, y2] = SLIDE_CURVE;
  let low = 0;
  let high = 1;
  for (let i = 0; i < 20; i++) {
    const mid = (low + high) / 2;
    if (bezier(mid, y1, y2) < progress) low = mid;
    else high = mid;
  }
  return bezier(high, x1, x2);
}
function passedAt(a0, a1, edge0, edge1) {
  if (a0 <= edge0) return 0;
  const closing = edge1 - edge0 - (a1 - a0);
  return closing > 0 ? Math.min(1, (a0 - edge0) / closing) : 1;
}
function centreOf(element2) {
  const { left, right, top, bottom } = element2.getBoundingClientRect();
  return { x: (left + right) / 2, y: (top + bottom) / 2 };
}
function sizeOf2(element2) {
  const { width, height } = element2.getBoundingClientRect();
  return { width, height };
}
function useSlideToFit(ref, content, active) {
  const settledRef = useRef75(null);
  const timerRef = useRef75(void 0);
  const wasActiveRef = useRef75(active);
  useLayoutEffect12(() => {
    const element2 = ref.current;
    const inner = element2?.firstElementChild;
    if (!element2 || !(inner instanceof HTMLElement)) return;
    const sliding = element2.style.width !== "";
    const ending = wasActiveRef.current && !active;
    wasActiveRef.current = active;
    const from = sliding ? sizeOf2(element2) : settledRef.current;
    release(element2, inner);
    const to = sizeOf2(element2);
    settledRef.current = to;
    const unchanged = !from || Math.abs(from.width - to.width) < 0.5 && Math.abs(from.height - to.height) < 0.5;
    if (!(active || sliding || ending) || unchanged || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      clearTimeout(timerRef.current);
      return;
    }
    const revealing = Array.from(inner.querySelectorAll(REVEALING_CHAR));
    const endBox = element2.getBoundingClientRect();
    const endCentres = revealing.map(centreOf);
    inner.style.width = `${inner.getBoundingClientRect().width}px`;
    inner.style.maxWidth = "none";
    inner.style.flex = "none";
    element2.style.boxSizing = "border-box";
    element2.style.overflow = "hidden";
    element2.style.width = `${from.width}px`;
    element2.style.height = `${from.height}px`;
    const startBox = element2.getBoundingClientRect();
    revealing.forEach((char, index2) => {
      const start = centreOf(char);
      const end = endCentres[index2];
      const progress = Math.max(
        passedAt(start.x, end.x, startBox.right, endBox.right),
        passedAt(start.y, end.y, startBox.bottom, endBox.bottom)
      );
      if (progress === 0) return;
      const uncoveredAt = SLIDE_MS * slideTimeAt(progress);
      for (const animation of char.getAnimations()) {
        const current = Number(animation.currentTime ?? 0);
        if (current > -uncoveredAt) animation.currentTime = -uncoveredAt;
      }
    });
    element2.style.transition = `width ${SLIDE_MS}ms ${SLIDE_EASE}, height ${SLIDE_MS}ms ${SLIDE_EASE}`;
    element2.style.width = `${to.width}px`;
    element2.style.height = `${to.height}px`;
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(release, SLIDE_MS, element2, inner);
  }, [ref, content, active]);
  useLayoutEffect12(() => () => clearTimeout(timerRef.current), []);
}

// src/components/composite/Timeline/ClarifyingQuestions/ClarifyingQuestions.tsx
import { useCallback as useCallback31, useEffect as useEffect53, useId as useId12, useImperativeHandle as useImperativeHandle4, useRef as useRef76, useState as useState64 } from "react";

// src/components/composite/Timeline/ClarifyingQuestions/ClarifyingQuestionsHeader.tsx
import { jsx as jsx84, jsxs as jsxs50 } from "react/jsx-runtime";
function ClarifyingQuestionsHeader({ children, titleRef }) {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs50("div", { className: "buyscout-clarifying-header", children: [
    /* @__PURE__ */ jsxs50("div", { className: "buyscout-clarifying-header-left", children: [
      /* @__PURE__ */ jsx84("span", { className: "buyscout-timeline-header-icon", "aria-hidden": "true", children: /* @__PURE__ */ jsx84("span", { className: "buyscout-clarifying-header-question", children: "?" }) }),
      /* @__PURE__ */ jsx84(Text, { ref: titleRef, tabIndex: titleRef ? -1 : void 0, variant: "body-bold", as: "span", className: "buyscout-clarifying-title", children: t("clarifyingQuestions.heading") })
    ] }),
    children
  ] });
}

// src/components/composite/Timeline/ClarifyingQuestions/ClarifyingQuestions.tsx
import { Fragment as Fragment22, jsx as jsx85, jsxs as jsxs51 } from "react/jsx-runtime";
var OTHER_SENTINEL = "__other__";
var NOTHING_PICKED = [];
var ARROW_KEYS3 = /* @__PURE__ */ new Set(["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"]);
var CHOICE_SELECTOR = '[role="radio"], [role="checkbox"]';
function answerFor(question, picked, otherText) {
  const answers = question.options.filter((option) => picked.includes(option));
  if (picked.includes(OTHER_SENTINEL)) answers.push(otherText.trim());
  return answers.join(", ");
}
function summaryAnswerClass(skipped) {
  return skipped ? "buyscout-clarifying-summary-answer buyscout-clarifying-summary-answer--skipped" : "buyscout-clarifying-summary-answer";
}
var CHEVRON_UP = /* @__PURE__ */ jsx85("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: /* @__PURE__ */ jsx85("polyline", { points: "18 15 12 9 6 15" }) });
var CHEVRON_DOWN = /* @__PURE__ */ jsx85("svg", { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: /* @__PURE__ */ jsx85("polyline", { points: "6 9 12 15 18 9" }) });
function ClarifyingQuestions({ ref, questions, onComplete, total: totalExpected, dashboardMode = false }) {
  const { t } = useTranslation();
  const instanceId = useId12();
  const [currentIndex, setCurrentIndex] = useState64(0);
  const [turn, setTurn] = useState64(null);
  const [answers, setAnswers] = useState64(() => /* @__PURE__ */ new Map());
  const [otherTexts, setOtherTexts] = useState64(() => /* @__PURE__ */ new Map());
  const [completedAnswers, setCompletedAnswers] = useState64(null);
  const otherInputRef = useRef76(null);
  const pagesRef = useRef76(null);
  const selectingByArrowRef = useRef76(false);
  const [otherFocusRequest, setOtherFocusRequest] = useState64(0);
  const focusNextPageRef = useRef76(false);
  const cardRef = useRef76(null);
  const titleRef = useRef76(null);
  const focusSummaryRef = useRef76(false);
  const [sentHere, setSentHere] = useState64(false);
  const questionCount = questions.length;
  const isLoadingMore = totalExpected != null && totalExpected > 0 && questionCount < totalExpected;
  const isPreAnswered = questions.some((q) => q.answer != null || q.isSkipped === true);
  useImperativeHandle4(ref, () => ({
    skipAll() {
      if (completedAnswers) return;
      const result = questions.map((_, i) => ({
        questionIndex: i,
        answer: "",
        skipped: true
      }));
      setCompletedAnswers(result);
      onComplete(result);
    }
  }), [questions, onComplete, completedAnswers]);
  const question = questions[currentIndex];
  const picked = answers.get(currentIndex) ?? NOTHING_PICKED;
  const isOtherSelected = picked.includes(OTHER_SENTINEL);
  const canContinue = picked.length > 0 && (!isOtherSelected || (otherTexts.get(currentIndex) ?? "").trim().length > 0);
  useEffect53(() => {
    if (otherFocusRequest > 0) otherInputRef.current?.focus();
  }, [otherFocusRequest]);
  useEffect53(() => {
    if (!focusNextPageRef.current) return;
    focusNextPageRef.current = false;
    const page = pagesRef.current?.children[currentIndex];
    const choice = page?.querySelector('[role="radio"][data-state="checked"], [role="checkbox"][data-state="checked"]') ?? page?.querySelector(CHOICE_SELECTOR);
    choice?.focus();
  }, [currentIndex]);
  const handleSelect = (value) => {
    setAnswers((prev) => new Map(prev).set(currentIndex, [value]));
    if (value === OTHER_SENTINEL && !selectingByArrowRef.current) setOtherFocusRequest((n) => n + 1);
  };
  const handleToggle = (value, checked) => {
    if (value === OTHER_SENTINEL && checked) setOtherFocusRequest((n) => n + 1);
    setAnswers((prev) => {
      const current = prev.get(currentIndex) ?? NOTHING_PICKED;
      const next = checked ? [...current.filter((item) => item !== value), value] : current.filter((item) => item !== value);
      return new Map(prev).set(currentIndex, next);
    });
  };
  const turnTo = (index2) => {
    setTurn({ from: currentIndex, direction: index2 > currentIndex ? "next" : "prev" });
    setCurrentIndex(index2);
  };
  const advance = useCallback31((skipped) => {
    if (currentIndex < questionCount - 1) {
      focusNextPageRef.current = pagesRef.current?.children[currentIndex]?.matches(":focus-within") ?? false;
      setTurn({ from: currentIndex, direction: "next" });
      setCurrentIndex(currentIndex + 1);
    } else {
      const result = questions.map((q, i) => {
        const ans = answers.get(i);
        const wasSkipped = skipped && i === currentIndex ? true : ans == null || ans.length === 0;
        const finalAnswer = wasSkipped || ans == null ? "" : answerFor(q, ans, otherTexts.get(i) ?? "");
        return { questionIndex: i, answer: finalAnswer, skipped: wasSkipped };
      });
      focusSummaryRef.current = cardRef.current?.matches(":focus-within") ?? false;
      setSentHere(true);
      setCompletedAnswers(result);
      onComplete(result);
    }
  }, [currentIndex, questionCount, questions, answers, otherTexts, onComplete]);
  useEffect53(() => {
    if (!completedAnswers || !focusSummaryRef.current) return;
    focusSummaryRef.current = false;
    titleRef.current?.focus();
  }, [completedAnswers]);
  const handleContinue = () => {
    if (!canContinue) return;
    advance(false);
  };
  const handleSkip = () => {
    setAnswers((prev) => {
      const next = new Map(prev);
      next.delete(currentIndex);
      return next;
    });
    advance(true);
  };
  const handleOtherTextChange = (text4) => {
    setOtherTexts((prev) => new Map(prev).set(currentIndex, text4));
  };
  const handleOtherTextKeyDown = (event) => {
    if (event.key !== "Enter" || isImeComposing(event.nativeEvent)) return;
    event.preventDefault();
    handleContinue();
  };
  if (dashboardMode && questions.length > 0) {
    return /* @__PURE__ */ jsxs51("div", { className: "buyscout-clarifying buyscout-clarifying--completed", children: [
      /* @__PURE__ */ jsx85(ClarifyingQuestionsHeader, {}),
      /* @__PURE__ */ jsx85("div", { className: "buyscout-clarifying-summary", children: questions.map((q, i) => /* @__PURE__ */ jsxs51(Field, { layout: "stacked", label: `${i + 1}. ${q.question}`, children: [
        q.options?.length ? /* @__PURE__ */ jsx85(Text, { variant: "caption", as: "div", children: `${t("clarifyingQuestions.options")}: ${q.options.join(", ")}` }) : null,
        (q.answer != null || q.isSkipped === true) && /* @__PURE__ */ jsx85("div", { className: summaryAnswerClass(q.isSkipped === true), children: `${t("clarifyingQuestions.userAnswer")}: ${q.isSkipped ? t("clarifyingQuestions.skipped") : q.answer ?? ""}` })
      ] }, i)) })
    ] });
  }
  if (!questions.length) return null;
  const status = /* @__PURE__ */ jsx85("div", { className: "buyscout-clarifying-status", role: "status", children: sentHere ? t("clarifyingQuestions.sent") : "" });
  const summary = isPreAnswered ? questions.map((q) => ({ skipped: q.isSkipped === true, answer: q.answer ?? "" })) : completedAnswers;
  if (summary) {
    return /* @__PURE__ */ jsxs51("div", { className: "buyscout-clarifying buyscout-clarifying--completed", children: [
      status,
      /* @__PURE__ */ jsx85(ClarifyingQuestionsHeader, { titleRef }),
      /* @__PURE__ */ jsx85("div", { className: "buyscout-clarifying-summary", children: questions.map((q, i) => /* @__PURE__ */ jsx85(Field, { layout: "stacked", label: `${i + 1}. ${q.question}`, children: /* @__PURE__ */ jsx85("div", { className: summaryAnswerClass(summary[i].skipped), children: summary[i].skipped ? t("clarifyingQuestions.skipped") : summary[i].answer }) }, i)) })
    ] });
  }
  if (!question) return null;
  return /* @__PURE__ */ jsxs51("div", { ref: cardRef, className: "buyscout-clarifying", children: [
    status,
    /* @__PURE__ */ jsx85(ClarifyingQuestionsHeader, { titleRef, children: /* @__PURE__ */ jsxs51("div", { className: "buyscout-clarifying-nav", children: [
      /* @__PURE__ */ jsx85(
        Button,
        {
          variant: "borderless",
          color: "neutral",
          size: "xs",
          iconOnly: true,
          disabled: currentIndex === 0,
          onClick: () => turnTo(currentIndex - 1),
          "aria-label": t("clarifyingQuestions.prevQuestion"),
          children: CHEVRON_UP
        }
      ),
      /* @__PURE__ */ jsxs51(Text, { variant: "body-sm", as: "span", className: "buyscout-clarifying-nav-counter", children: [
        currentIndex + 1,
        " ",
        t("clarifyingQuestions.navOf"),
        " ",
        isLoadingMore && totalExpected != null ? totalExpected : questionCount
      ] }),
      isLoadingMore && currentIndex >= questionCount - 1 ? /* @__PURE__ */ jsx85(
        Button,
        {
          variant: "borderless",
          color: "neutral",
          size: "xs",
          iconOnly: true,
          loading: true,
          disabled: true,
          "aria-label": t("clarifyingQuestions.loadingNext"),
          children: CHEVRON_DOWN
        }
      ) : /* @__PURE__ */ jsx85(
        Button,
        {
          variant: "borderless",
          color: "neutral",
          size: "xs",
          iconOnly: true,
          disabled: currentIndex >= questionCount - 1,
          onClick: () => turnTo(currentIndex + 1),
          "aria-label": t("clarifyingQuestions.nextQuestion"),
          children: CHEVRON_DOWN
        }
      )
    ] }) }),
    /* @__PURE__ */ jsx85("div", { ref: pagesRef, className: "buyscout-clarifying-pages", "data-direction": turn?.direction, children: questions.map((q, index2) => {
      const current = index2 === currentIndex;
      const pickedHere = answers.get(index2) ?? NOTHING_PICKED;
      const otherPicked = pickedHere.includes(OTHER_SENTINEL);
      const questionId = `${instanceId}-${index2}-question`;
      const otherId = `${instanceId}-${index2}-other`;
      const control = (id, value, ariaLabel) => q.multi ? /* @__PURE__ */ jsx85(Checkbox2, { id, size: "sm", "aria-label": ariaLabel, checked: pickedHere.includes(value), onCheckedChange: (checked) => handleToggle(value, checked === true) }) : /* @__PURE__ */ jsx85(RadioGroupItem2, { id, value, size: "sm", "aria-label": ariaLabel });
      const options = /* @__PURE__ */ jsxs51(Fragment22, { children: [
        q.options.map((option, optionIndex) => {
          const id = `${instanceId}-${index2}-${optionIndex}`;
          return /* @__PURE__ */ jsxs51("label", { htmlFor: id, className: "buyscout-clarifying-option", children: [
            control(id, option),
            /* @__PURE__ */ jsx85(Text, { variant: "body", as: "span", className: "buyscout-clarifying-option-label", children: option })
          ] }, id);
        }),
        /* @__PURE__ */ jsxs51("div", { className: "buyscout-clarifying-option", "data-typing": otherPicked || void 0, children: [
          control(otherId, OTHER_SENTINEL, otherPicked ? t("clarifyingQuestions.otherOption") : void 0),
          otherPicked ? /* @__PURE__ */ jsx85(
            TextField,
            {
              ref: current ? otherInputRef : void 0,
              size: "sm",
              fullWidth: true,
              className: "buyscout-timeline-field",
              placeholder: t("clarifyingQuestions.answerPlaceholder"),
              "aria-label": t("clarifyingQuestions.otherAnswerAria"),
              value: otherTexts.get(index2) ?? "",
              onChange: (e) => handleOtherTextChange(e.target.value),
              onKeyDown: handleOtherTextKeyDown
            }
          ) : /* @__PURE__ */ jsx85("label", { htmlFor: otherId, className: "buyscout-clarifying-option-label buyscout-clarifying-other-label", children: /* @__PURE__ */ jsx85(Text, { variant: "body", as: "span", children: t("clarifyingQuestions.otherLabel") }) })
        ] })
      ] });
      return /* @__PURE__ */ jsxs51("div", { className: "buyscout-clarifying-page", inert: !current, "aria-hidden": current ? void 0 : true, "data-leaving": !current && turn?.from === index2 || void 0, children: [
        /* @__PURE__ */ jsxs51("div", { className: "buyscout-clarifying-question", id: questionId, children: [
          /* @__PURE__ */ jsxs51(Text, { variant: "body-bold", as: "span", className: "buyscout-clarifying-question-number", children: [
            index2 + 1,
            "."
          ] }),
          /* @__PURE__ */ jsx85(Text, { variant: "body", as: "span", children: q.question })
        ] }),
        q.multi ? /* @__PURE__ */ jsx85("div", { role: "group", "aria-labelledby": questionId, className: "buyscout-clarifying-options", children: options }) : /* @__PURE__ */ jsx85(
          RadioGroup4,
          {
            className: "buyscout-clarifying-options",
            "aria-labelledby": questionId,
            value: pickedHere[0] ?? "",
            onValueChange: handleSelect,
            onKeyDownCapture: (event) => {
              selectingByArrowRef.current = ARROW_KEYS3.has(event.key);
            },
            onPointerDownCapture: () => {
              selectingByArrowRef.current = false;
            },
            children: options
          }
        )
      ] }, index2);
    }) }),
    /* @__PURE__ */ jsxs51("div", { className: "buyscout-clarifying-footer", children: [
      /* @__PURE__ */ jsx85(Button, { variant: "borderless", color: "neutral", type: "button", size: "sm", className: "buyscout-clarifying-skip", disabled: isLoadingMore, onClick: handleSkip, children: t("clarifyingQuestions.skip") }),
      /* @__PURE__ */ jsx85(
        Button,
        {
          variant: "prominent",
          type: "button",
          size: "sm",
          className: "buyscout-clarifying-continue",
          disabled: !canContinue || isLoadingMore,
          onClick: handleContinue,
          children: /* @__PURE__ */ jsx85(StableLabel, { labels: Math.max(questionCount, totalExpected ?? 0) > 1 ? [t("clarifyingQuestions.continue"), t("clarifyingQuestions.submit")] : [t("clarifyingQuestions.submit")], children: currentIndex >= questionCount - 1 ? t("clarifyingQuestions.submit") : t("clarifyingQuestions.continue") })
        }
      )
    ] })
  ] });
}

// src/components/composite/Timeline/ContentChips/ProductMentionText.tsx
import { jsx as jsx86 } from "react/jsx-runtime";
function ProductMentionText({ content, productMap, storeDomain }) {
  if (!productMap) return content;
  const parts = [];
  let lastIndex = 0;
  for (const match of content.matchAll(PRODUCT_MENTION_REGEX)) {
    const [fullMatch, productKey] = match;
    if (match.index > lastIndex) {
      parts.push(content.substring(lastIndex, match.index));
    }
    const product = resolveProductMention(productMap, productKey);
    parts.push(product ? /* @__PURE__ */ jsx86(
      ProductMentionChip,
      {
        product,
        storeDomain
      },
      `mention-${productKey}-${match.index}`
    ) : unresolvedMentionText(productKey));
    lastIndex = match.index + fullMatch.length;
  }
  if (lastIndex < content.length) {
    parts.push(content.substring(lastIndex));
  }
  return parts.length > 0 ? parts : content;
}
ProductMentionText.displayName = "ProductMentionText";

// src/components/composite/Timeline/ContentRenderer/ContentRenderer.tsx
import { useRef as useRef77 } from "react";

// src/components/composite/Timeline/ShimmerText/ShimmerText.tsx
import { jsx as jsx87 } from "react/jsx-runtime";
function ShimmerText({ children, active = true, className, style }) {
  if (!active) {
    return children;
  }
  return /* @__PURE__ */ jsx87(
    "div",
    {
      className: clsx_default("buyscout-shimmer-text", className),
      style,
      children
    }
  );
}
ShimmerText.displayName = "ShimmerText";

// src/components/composite/Timeline/ContentRenderer/ContentRenderer.tsx
import { jsx as jsx88 } from "react/jsx-runtime";
function ContentRenderer({ content, isLastItem, sessionStatus, productMap, storeDomain }) {
  const { t } = useTranslation();
  const isInProgress = isStreamLive(sessionStatus);
  const isStreaming = Boolean(isLastItem && content && content.length > 0 && isInProgress);
  const className = `buyscout-timeline-content${isStreaming ? " streaming" : ""}`;
  const animateState = useRef77({ charStartTimes: /* @__PURE__ */ new Map() });
  if (!isStreaming) {
    animateState.current.charStartTimes.clear();
  }
  const bubbleRef = useRef77(null);
  useSlideToFit(bubbleRef, content, isStreaming);
  if (!content && !isInProgress) {
    return null;
  }
  return /* @__PURE__ */ jsx88("div", { ref: bubbleRef, className, children: content && content.length > 0 ? /* @__PURE__ */ jsx88("div", { children: /* @__PURE__ */ jsx88(CopyableCodesContext, { value: true, children: /* @__PURE__ */ jsx88(ChatMarkdown, { content, productMap, storeDomain, isStreaming, animateState: animateState.current }) }) }) : /* @__PURE__ */ jsx88(ShimmerText, { children: /* @__PURE__ */ jsx88(Text, { variant: "body", as: "span", italic: true, children: t("thinking.placeholder") }) }) });
}

// src/components/composite/Timeline/InlineForm/InlineForm.tsx
import { useCallback as useCallback32, useEffect as useEffect54, useMemo as useMemo31, useRef as useRef78, useState as useState65 } from "react";
import { MdOutlineAssignment } from "react-icons/md";
import { jsx as jsx89, jsxs as jsxs52 } from "react/jsx-runtime";
var EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)*\.[^\s@.]{2,}$/;
var PHONE_PATTERN = /^\+?[\d\s\-().]{6,}$/;
var MASK_VISIBLE_CHARS = 4;
var EMPTY_VALUE = "\u2014";
function maskValue(value) {
  if (value.length <= MASK_VISIBLE_CHARS) return "\u2022".repeat(value.length);
  return `${"\u2022".repeat(value.length - MASK_VISIBLE_CHARS)}${value.slice(-MASK_VISIBLE_CHARS)}`;
}
function summaryValue(field, value) {
  if (!value) return EMPTY_VALUE;
  return field.masked ? maskValue(value) : value;
}
function InlineForm({
  fields,
  title,
  submitLabel,
  onSubmit,
  onDismiss,
  isDismissed = false,
  dashboardMode = false,
  readOnly = false
}) {
  const { t } = useTranslation();
  const [drafts, setDrafts] = useState65({});
  const [submitAttempted, setSubmitAttempted] = useState65(false);
  const [submittedValues, setSubmittedValues] = useState65(null);
  const [isSubmitting, setIsSubmitting] = useState65(false);
  const inputElementsRef = useRef78({});
  const cardRef = useRef78(null);
  const titleRef = useRef78(null);
  const focusSummaryRef = useRef78(false);
  const [sentHere, setSentHere] = useState65(false);
  const prefilledValues = useMemo31(() => {
    if (!fields.some((f) => f.value != null)) return null;
    return Object.fromEntries(fields.map((f) => [f.name, f.value ?? ""]));
  }, [fields]);
  const validate = useCallback32((field, raw) => {
    const value = raw.trim();
    if (!value) return field.required ? t("inlineForm.errorRequired") : null;
    switch (field.type) {
      case "email":
        return EMAIL_PATTERN.test(value) ? null : t("inlineForm.errorEmail");
      case "tel":
        return PHONE_PATTERN.test(value) ? null : t("inlineForm.errorPhone");
      case "number":
        return Number.isFinite(Number(value)) ? null : t("inlineForm.errorNumber");
      default:
        return null;
    }
  }, [t]);
  const errors = useMemo31(() => {
    const next = {};
    for (const field of fields) {
      const error2 = validate(field, drafts[field.name] ?? "");
      if (error2) next[field.name] = error2;
    }
    return next;
  }, [fields, drafts, validate]);
  const handleChange = (name2, value) => {
    setDrafts((prev) => ({ ...prev, [name2]: value }));
  };
  const handleSubmit = async () => {
    if (isSubmitting) return;
    setSubmitAttempted(true);
    const firstInvalid = fields.find((f) => errors[f.name]);
    if (firstInvalid) {
      inputElementsRef.current[firstInvalid.name]?.focus();
      return;
    }
    const values = Object.fromEntries(
      fields.map((f) => [f.name, (drafts[f.name] ?? "").trim()])
    );
    const focusWasInside = cardRef.current?.matches(":focus-within") ?? false;
    setIsSubmitting(true);
    try {
      await onSubmit(values);
      focusSummaryRef.current = focusWasInside;
      setSentHere(true);
      setSubmittedValues(values);
    } catch {
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleDismiss = onDismiss && (() => {
    focusSummaryRef.current = cardRef.current?.matches(":focus-within") ?? false;
    onDismiss();
  });
  useEffect54(() => {
    if (!focusSummaryRef.current || !(submittedValues || isDismissed)) return;
    focusSummaryRef.current = false;
    titleRef.current?.focus();
  }, [submittedValues, isDismissed]);
  if (!fields.length) return null;
  const resolvedValues = submittedValues ?? prefilledValues;
  const heading2 = title ?? t("inlineForm.heading");
  const header = /* @__PURE__ */ jsxs52("div", { className: "buyscout-inline-form-header", children: [
    /* @__PURE__ */ jsx89("span", { className: "buyscout-timeline-header-icon", "aria-hidden": "true", children: /* @__PURE__ */ jsx89(MdOutlineAssignment, {}) }),
    /* @__PURE__ */ jsx89(Text, { ref: titleRef, tabIndex: -1, variant: "body-bold", as: "span", className: "buyscout-inline-form-title", children: heading2 })
  ] });
  const status = /* @__PURE__ */ jsx89("div", { className: "buyscout-inline-form-status", role: "status", children: sentHere ? t("inlineForm.sent") : "" });
  if (dashboardMode || isDismissed || readOnly || resolvedValues) {
    let summary;
    if (isDismissed) {
      summary = /* @__PURE__ */ jsx89(Text, { variant: "body", as: "div", className: "buyscout-inline-form-summary-empty", children: t("inlineForm.skipped") });
    } else if (resolvedValues) {
      summary = fields.map((field) => {
        const value = resolvedValues[field.name] ?? "";
        return /* @__PURE__ */ jsx89(Field, { labelWidth: "sm", align: "start", label: field.label, children: summaryValue(field, value) }, field.name);
      });
    } else {
      summary = /* @__PURE__ */ jsx89(Text, { variant: "body", as: "div", className: "buyscout-inline-form-summary-empty", children: t("inlineForm.notSubmitted") });
    }
    return /* @__PURE__ */ jsxs52("div", { ref: cardRef, className: "buyscout-inline-form buyscout-inline-form--completed", children: [
      status,
      header,
      /* @__PURE__ */ jsx89("div", { className: "buyscout-inline-form-summary", children: summary })
    ] });
  }
  const idleLabel = submitLabel ?? t("inlineForm.submit");
  return /* @__PURE__ */ jsxs52("div", { ref: cardRef, className: "buyscout-inline-form", children: [
    status,
    header,
    /* @__PURE__ */ jsxs52(
      "form",
      {
        className: "buyscout-inline-form-body",
        noValidate: true,
        "aria-busy": isSubmitting || void 0,
        onSubmit: (e) => {
          e.preventDefault();
          void handleSubmit();
        },
        children: [
          /* @__PURE__ */ jsx89("div", { className: "buyscout-inline-form-fields", children: fields.map((field) => {
            const error2 = submitAttempted ? errors[field.name] : void 0;
            return /* @__PURE__ */ jsx89(
              TextField,
              {
                ref: (node) => {
                  inputElementsRef.current[field.name] = node;
                },
                label: field.required ? `${field.label} *` : field.label,
                type: field.type ?? "text",
                size: "sm",
                fullWidth: true,
                className: "buyscout-timeline-field",
                placeholder: field.placeholder,
                autoComplete: field.autocomplete,
                required: field.required,
                disabled: isSubmitting,
                value: drafts[field.name] ?? "",
                error: Boolean(error2),
                helperText: error2,
                onChange: (e) => handleChange(field.name, e.target.value)
              },
              field.name
            );
          }) }),
          /* @__PURE__ */ jsxs52("div", { className: "buyscout-inline-form-footer", children: [
            handleDismiss && /* @__PURE__ */ jsx89(
              Button,
              {
                variant: "borderless",
                color: "neutral",
                type: "button",
                size: "sm",
                className: "buyscout-inline-form-skip",
                disabled: isSubmitting,
                onClick: handleDismiss,
                children: t("inlineForm.skip")
              }
            ),
            /* @__PURE__ */ jsx89(
              Button,
              {
                variant: "prominent",
                type: "submit",
                size: "sm",
                className: "buyscout-inline-form-submit",
                loading: isSubmitting,
                children: idleLabel
              }
            )
          ] })
        ]
      }
    )
  ] });
}
InlineForm.displayName = "InlineForm";

// src/components/composite/Timeline/ProductList/ProductList.tsx
import { useEffect as useEffect55, useRef as useRef79, useState as useState66 } from "react";
import { MdChevronLeft as MdChevronLeft2, MdChevronRight as MdChevronRight3 } from "react-icons/md";
import { Fragment as Fragment23, jsx as jsx90, jsxs as jsxs53 } from "react/jsx-runtime";
var CARD_IMAGE_PX = 120;
function SkeletonCard({ hasAddToCart }) {
  return /* @__PURE__ */ jsxs53("div", { className: "buyscout-product-card buyscout-product-card-skeleton", children: [
    /* @__PURE__ */ jsx90("div", { className: "buyscout-product-image", children: /* @__PURE__ */ jsx90(Skeleton, { variant: "rect", className: "buyscout-product-skeleton-image" }) }),
    /* @__PURE__ */ jsxs53("div", { className: "buyscout-product-info", children: [
      /* @__PURE__ */ jsx90(Skeleton, { height: 14, className: "buyscout-product-skeleton-title" }),
      /* @__PURE__ */ jsx90(Skeleton, { width: "60%", height: 14, className: "buyscout-product-skeleton-title buyscout-product-skeleton-title-line2" }),
      /* @__PURE__ */ jsx90(Skeleton, { width: "60%", height: 22, className: "buyscout-product-skeleton-price" }),
      hasAddToCart && /* @__PURE__ */ jsx90(Skeleton, { variant: "rect", className: "buyscout-product-skeleton-cart" })
    ] })
  ] });
}
function ProductLinkTitle({ product, storeDomain }) {
  const url = resolveProductUrl(product.url, storeDomain);
  return url ? /* @__PURE__ */ jsx90("a", { href: url, target: "_blank", rel: "noopener noreferrer", className: "buyscout-product-link", children: product.title }) : product.title;
}
function ProductList({ products, loading = false, storeDomain, onAddToCart }) {
  const { t } = useTranslation();
  const containerRef = useRef79(null);
  const hadSkeletonsRef = useRef79(false);
  if (loading) {
    hadSkeletonsRef.current = true;
  }
  const skipCardAnimation = hadSkeletonsRef.current && !loading && products.length > 0;
  const entranceIndex = useEntranceStagger(products.map((product) => product.id));
  const [showStartGradient, setShowStartGradient] = useState66(false);
  const [showEndGradient, setShowEndGradient] = useState66(true);
  const { cartStateOf, addToCart, outcome } = useAddToCartState(onAddToCart);
  const trailingRef = useRef79(null);
  const indicatorRef = useRef79(null);
  const previousRef = useRef79(null);
  const nextRef = useRef79(null);
  const { rendered: showTrailing, closing: trailingClosing } = useExitPresence(loading || void 0, trailingRef);
  const { rendered: showIndicator, closing: indicatorClosing } = useExitPresence(loading || void 0, indicatorRef);
  useEffect55(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const updateGradients = () => {
      const { scrollWidth, clientWidth } = container;
      const offset5 = Math.abs(container.scrollLeft);
      const isAtStart = offset5 <= 1;
      const isAtEnd = offset5 >= scrollWidth - clientWidth - 1;
      if (isAtStart && !isAtEnd && previousRef.current?.matches(":focus")) nextRef.current?.focus();
      if (isAtEnd && !isAtStart && nextRef.current?.matches(":focus")) previousRef.current?.focus();
      setShowStartGradient(!isAtStart);
      setShowEndGradient(!isAtEnd);
    };
    updateGradients();
    container.addEventListener("scroll", updateGradients);
    window.addEventListener("resize", updateGradients);
    container.addEventListener("transitionend", updateGradients);
    return () => {
      container.removeEventListener("scroll", updateGradients);
      window.removeEventListener("resize", updateGradients);
      container.removeEventListener("transitionend", updateGradients);
    };
  }, [products, loading]);
  const scrollByPage = (direction) => {
    const container = containerRef.current;
    if (!container) return;
    const { paddingLeft, paddingRight, direction: writing } = getComputedStyle(container);
    const page = container.clientWidth - Number.parseFloat(paddingLeft) - Number.parseFloat(paddingRight);
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const towardEnd = writing === "rtl" ? -1 : 1;
    container.scrollBy({ left: direction * towardEnd * page, behavior: reduced ? "instant" : "smooth" });
  };
  if (!products || products.length === 0) {
    if (!loading) {
      return null;
    }
  }
  const displayProducts = products;
  return /* @__PURE__ */ jsxs53("div", { className: "buyscout-product-list", children: [
    /* @__PURE__ */ jsxs53(
      "ul",
      {
        ref: containerRef,
        role: "list",
        "aria-label": t("product.listLabel", { count: displayProducts.length }),
        "aria-busy": loading || void 0,
        className: "buyscout-product-list-container",
        children: [
          displayProducts.map((product) => /* @__PURE__ */ jsx90("li", { className: "buyscout-product-list-item", children: /* @__PURE__ */ jsxs53(
            "div",
            {
              className: `buyscout-product-card${skipCardAnimation ? " buyscout-product-card-no-animate" : ""}`,
              style: { "--card-enter-delay": staggerDelay(entranceIndex(product.id)) },
              children: [
                /* @__PURE__ */ jsx90(
                  ImageFrame,
                  {
                    ...product.imageUrl ? shopifyImageSource(product.imageUrl, CARD_IMAGE_PX) : void 0,
                    alt: "",
                    fallback: "bag",
                    loading: "lazy",
                    className: "buyscout-product-image",
                    imgClassName: "buyscout-product-image-img"
                  }
                ),
                /* @__PURE__ */ jsxs53("div", { className: "buyscout-product-info", children: [
                  /* @__PURE__ */ jsx90(Text, { variant: "body-bold", as: "h3", className: "buyscout-product-title", children: /* @__PURE__ */ jsx90(ProductLinkTitle, { product, storeDomain }) }),
                  /* @__PURE__ */ jsx90("div", { className: "buyscout-product-price-row", children: /* @__PURE__ */ jsx90(Text, { variant: "body-bold", as: "span", className: "buyscout-product-price", children: product.price }) }),
                  onAddToCart && (() => {
                    const state = cartStateOf(product.id);
                    const isLoading = state === "loading";
                    const isAdded = state === "added";
                    const isError = state === "error";
                    const addedLabel = /* @__PURE__ */ jsxs53(Fragment23, { children: [
                      /* @__PURE__ */ jsx90(DrawnCheck, { drawn: isAdded }),
                      t("product.added")
                    ] });
                    return /* @__PURE__ */ jsx90(
                      Button,
                      {
                        type: "button",
                        variant: "prominent",
                        size: "sm",
                        color: isAdded ? "success" : isError ? "error" : "primary",
                        className: `buyscout-product-add-to-cart buyscout-add-to-cart ${state}`,
                        "data-cart-state": state,
                        onClick: () => {
                          void addToCart(product);
                        },
                        loading: isLoading,
                        "aria-disabled": isAdded || void 0,
                        "aria-label": addToCartAriaLabel(t, state, product.title),
                        children: /* @__PURE__ */ jsx90(StableLabel, { labels: [t("product.addToCart"), addedLabel, t("product.failed")], children: isAdded ? addedLabel : isError ? t("product.failed") : t("product.addToCart") })
                      }
                    );
                  })()
                ] })
              ]
            }
          ) }, product.id)),
          showTrailing && /* @__PURE__ */ jsx90(
            "li",
            {
              ref: trailingRef,
              className: "buyscout-product-list-trailing",
              "data-state": trailingClosing ? "closed" : "open",
              "aria-hidden": true,
              children: /* @__PURE__ */ jsx90(SkeletonCard, { hasAddToCart: !!onAddToCart })
            }
          )
        ]
      }
    ),
    onAddToCart && /* @__PURE__ */ jsx90(AddToCartStatus, { outcome, t }),
    /* @__PURE__ */ jsx90(
      "div",
      {
        className: `buyscout-product-list-gradient buyscout-product-list-gradient-start ${showStartGradient ? "visible" : ""}`
      }
    ),
    /* @__PURE__ */ jsx90(
      "div",
      {
        className: `buyscout-product-list-gradient buyscout-product-list-gradient-end ${showEndGradient ? "visible" : ""}`
      }
    ),
    /* @__PURE__ */ jsx90(
      Button,
      {
        ref: previousRef,
        variant: "glass",
        color: "neutral",
        shape: "circle",
        size: "sm",
        iconOnly: true,
        "aria-label": t("product.scrollPrevious"),
        className: "buyscout-product-list-arrow buyscout-product-list-arrow--previous",
        disabled: !showStartGradient,
        onClick: () => scrollByPage(-1),
        children: /* @__PURE__ */ jsx90(MdChevronLeft2, { "aria-hidden": true })
      }
    ),
    /* @__PURE__ */ jsx90(
      Button,
      {
        ref: nextRef,
        variant: "glass",
        color: "neutral",
        shape: "circle",
        size: "sm",
        iconOnly: true,
        "aria-label": t("product.scrollNext"),
        className: "buyscout-product-list-arrow buyscout-product-list-arrow--next",
        disabled: !showEndGradient,
        onClick: () => scrollByPage(1),
        children: /* @__PURE__ */ jsx90(MdChevronRight3, { "aria-hidden": true })
      }
    ),
    showIndicator && /* @__PURE__ */ jsx90(
      "div",
      {
        ref: indicatorRef,
        className: "buyscout-product-list-loading-indicator",
        "data-state": indicatorClosing ? "closed" : "open",
        "aria-hidden": indicatorClosing || void 0,
        children: /* @__PURE__ */ jsx90(Spinner, { size: "sm" })
      }
    )
  ] });
}

// src/components/composite/Timeline/ThinkingIndicator/ThinkingIndicator.tsx
import { useEffect as useEffect56, useRef as useRef80, useState as useState67 } from "react";
import { jsx as jsx91, jsxs as jsxs54 } from "react/jsx-runtime";
function ThinkingIndicator({ content, isLastItem, sessionStatus }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState67(false);
  const [userInteracted, setUserInteracted] = useState67(false);
  const previousContentRef = useRef80(content);
  const previousIsLastRef = useRef80(isLastItem);
  const isStreaming = isLastItem && isStreamLive(sessionStatus);
  const animateState = useRef80({ charStartTimes: /* @__PURE__ */ new Map() });
  const spinnerRef = useRef80(null);
  const { rendered: showSpinner, closing: spinnerClosing } = useExitPresence(isStreaming || void 0, spinnerRef);
  if (!isStreaming) {
    animateState.current.charStartTimes.clear();
  }
  useEffect56(() => {
    const contentChanged = content !== previousContentRef.current;
    const becameNotLast = previousIsLastRef.current && !isLastItem;
    previousContentRef.current = content;
    previousIsLastRef.current = isLastItem;
    if (contentChanged && isStreaming && !userInteracted) {
      setExpanded(true);
    }
    if (becameNotLast) {
      setUserInteracted(false);
      setExpanded(false);
    }
  }, [content, isLastItem, isStreaming, userInteracted]);
  const handleToggle = () => {
    setExpanded(!expanded);
    if (isStreaming) {
      setUserInteracted(true);
    }
  };
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- the toggle below is the keyboard path; role='button' here would make the reasoning markdown the button's own name and strip the semantics a reader needs to read it
    /* @__PURE__ */ jsxs54(
      "div",
      {
        onClick: handleToggle,
        className: "buyscout-timeline-thinking",
        children: [
          /* @__PURE__ */ jsx91(
            "button",
            {
              type: "button",
              className: "buyscout-timeline-thinking-toggle",
              "aria-expanded": expanded,
              onClick: (event) => {
                event.stopPropagation();
                handleToggle();
              },
              children: t("thinking.toggle")
            }
          ),
          content ? /* @__PURE__ */ jsx91("div", { className: "buyscout-timeline-thinking-content", children: /* @__PURE__ */ jsx91(Collapse, { in: expanded, timeout: 200, collapsedSize: "var(--bs-thinking-collapsed, 21px)", children: /* @__PURE__ */ jsx91(ShimmerText, { active: isStreaming, style: { display: "block" }, children: /* @__PURE__ */ jsx91("div", { className: "buyscout-thinking-process", children: /* @__PURE__ */ jsx91(ChatMarkdown, { content, isStreaming, animateState: animateState.current }) }) }) }) }) : /* @__PURE__ */ jsx91(ShimmerText, { active: isStreaming, children: /* @__PURE__ */ jsx91(Text, { variant: "body", as: "span", italic: true, children: t("thinking.placeholder") }) }),
          showSpinner && /* @__PURE__ */ jsx91(
            "div",
            {
              ref: spinnerRef,
              className: "buyscout-timeline-thinking-spinner",
              "data-state": spinnerClosing ? "closed" : "open",
              "aria-hidden": true,
              children: /* @__PURE__ */ jsx91(Spinner, { size: "sm" })
            }
          )
        ]
      }
    )
  );
}

// src/components/composite/Timeline/ClarifyingQuestions/ClarifyingQuestionsTimelineItem.tsx
import { useLayoutEffect as useLayoutEffect13, useRef as useRef81, useState as useState68 } from "react";
import { jsx as jsx92, jsxs as jsxs55 } from "react/jsx-runtime";
function ClarifyingQuestionsTimelineItem({ questions, total, onComplete, dashboardMode = false }) {
  const { t } = useTranslation();
  const [completed, setCompleted] = useState68(false);
  const isReadOnly = dashboardMode || questions.some((q) => q.isSkipped === true || q.answer != null);
  const isLoadingMore = total != null && total > 0 && questions.length < total;
  const isFullyLoading = isLoadingMore && questions.length === 0;
  const wasLoadingRef = useRef81(isFullyLoading);
  const [expandState, setExpandState] = useState68("idle");
  useLayoutEffect13(() => {
    if (wasLoadingRef.current && !isFullyLoading && questions.length > 0) {
      setExpandState("expanding");
    }
    wasLoadingRef.current = isFullyLoading;
  }, [isFullyLoading, questions.length]);
  if (isFullyLoading) {
    return /* @__PURE__ */ jsx92("div", { className: "buyscout-timeline-clarifying-questions buyscout-timeline-clarifying-questions--loading", children: /* @__PURE__ */ jsxs55("div", { className: "buyscout-clarifying buyscout-clarifying--loading", children: [
      /* @__PURE__ */ jsx92(ClarifyingQuestionsHeader, {}),
      /* @__PURE__ */ jsxs55("div", { className: "buyscout-clarifying-loading", role: "status", children: [
        /* @__PURE__ */ jsx92(ShimmerText, { children: /* @__PURE__ */ jsx92(Text, { variant: "body", as: "span", className: "buyscout-clarifying-loading-text", children: t("clarifyingQuestions.loadingQuestions") }) }),
        /* @__PURE__ */ jsx92(Spinner, { size: "sm", tone: "current", "aria-hidden": true })
      ] })
    ] }) });
  }
  if (!questions || questions.length === 0) return null;
  const handleComplete = (answers) => {
    setCompleted(true);
    onComplete?.(answers);
  };
  const wrapperClass = [
    "buyscout-timeline-clarifying-questions",
    completed ? "buyscout-timeline-clarifying-questions--completed" : isReadOnly ? "buyscout-timeline-clarifying-questions--readonly" : "",
    expandState === "expanding" ? "buyscout-timeline-clarifying-questions--expanding" : "",
    expandState === "expanded" ? "buyscout-timeline-clarifying-questions--expanded" : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ jsx92(
    "div",
    {
      className: wrapperClass,
      onAnimationEnd: expandState === "expanding" ? () => setExpandState("expanded") : void 0,
      children: /* @__PURE__ */ jsx92(
        ClarifyingQuestions,
        {
          questions,
          onComplete: handleComplete,
          total,
          dashboardMode
        }
      )
    }
  );
}

// src/components/composite/Timeline/InlineForm/InlineFormTimelineItem.tsx
import { useState as useState69 } from "react";
import { jsx as jsx93 } from "react/jsx-runtime";
function InlineFormTimelineItem({
  fields,
  title,
  submitLabel,
  isDismissed = false,
  onSubmit,
  onDismiss,
  dashboardMode = false,
  readOnly = false
}) {
  const [outcome, setOutcome] = useState69("pending");
  if (!fields.length) return null;
  const dismissed = isDismissed || outcome === "dismissed";
  const settled = dashboardMode || dismissed || readOnly || outcome === "submitted" || fields.some((f) => f.value != null);
  const handleSubmit = async (values) => {
    await onSubmit?.(values);
    setOutcome("submitted");
  };
  const handleDismiss = onDismiss ? () => {
    setOutcome("dismissed");
    onDismiss();
  } : void 0;
  return /* @__PURE__ */ jsx93("div", { className: `buyscout-timeline-inline-form${settled ? " buyscout-timeline-inline-form--completed" : ""}`, children: /* @__PURE__ */ jsx93(
    InlineForm,
    {
      fields,
      title,
      submitLabel,
      isDismissed: dismissed,
      onSubmit: handleSubmit,
      onDismiss: handleDismiss,
      dashboardMode,
      readOnly
    }
  ) });
}

// src/components/composite/Timeline/ProductList/ProductListTimelineItem.tsx
import { useRef as useRef82 } from "react";
import { jsx as jsx94 } from "react/jsx-runtime";
function ProductListTimelineItem({ products, loading = false, storeDomain, onAddToCart }) {
  const streamedRef = useRef82(loading);
  if (loading) {
    streamedRef.current = true;
  }
  if (!loading && (!products || products.length === 0)) {
    return null;
  }
  const singleProduct = products.length === 1 ? products[0] : void 0;
  if (singleProduct && !loading && !streamedRef.current) {
    return /* @__PURE__ */ jsx94(
      ProductCardTimelineItem,
      {
        product: singleProduct,
        loading,
        storeDomain,
        onAddToCart
      }
    );
  }
  return /* @__PURE__ */ jsx94("div", { className: "buyscout-timeline-product-list", children: /* @__PURE__ */ jsx94(ProductList, { products, loading, storeDomain, onAddToCart }) });
}

// src/components/composite/Timeline/ToolStatusIndicator/ToolStatusIndicator.tsx
import { MdCheckCircle as MdCheckCircle2, MdError as MdError2 } from "react-icons/md";
import { jsx as jsx95, jsxs as jsxs56 } from "react/jsx-runtime";
function ToolStatusIndicator({
  toolName,
  toolCallId,
  status,
  failedReason,
  onToolClick,
  sessionStatus
}) {
  const { t, i18n } = useTranslation();
  const formattedToolName = t(`tool.${toolName}.label`, { defaultValue: formatToolName(toolName) });
  const hasSuccessLabel = i18n.exists(`tool.${toolName}.success`);
  const failedText = t(`tool.${toolName}.failed`, { defaultValue: t("tool.fallback.failed") });
  const isClickable = onToolClick && toolCallId && status !== "running";
  const isRunning = status === "running" && isStreamLive(sessionStatus);
  const isInterrupted = status === "running" && !isRunning;
  const handleClick = () => {
    if (isClickable) {
      onToolClick(toolCallId);
    }
  };
  const getStatusIcon = () => {
    switch (status) {
      case "running":
        return isRunning ? /* @__PURE__ */ jsx95(Spinner, { size: "sm", "aria-hidden": true }) : /* @__PURE__ */ jsx95(MdError2, { size: 16, className: "buyscout-timeline-tool-icon buyscout-timeline-tool-icon--failed" });
      case "success":
        return /* @__PURE__ */ jsx95(MdCheckCircle2, { size: 16, className: "buyscout-timeline-tool-icon buyscout-timeline-tool-icon--success" });
      case "failed":
        return /* @__PURE__ */ jsx95(MdError2, { size: 16, className: "buyscout-timeline-tool-icon buyscout-timeline-tool-icon--failed" });
    }
  };
  return /* @__PURE__ */ jsxs56(
    "div",
    {
      className: `buyscout-timeline-tool${isClickable ? " clickable" : ""}`,
      onClick: handleClick,
      role: isClickable ? "button" : void 0,
      tabIndex: isClickable ? 0 : void 0,
      onKeyDown: isClickable ? (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      } : void 0,
      children: [
        /* @__PURE__ */ jsxs56("div", { className: "buyscout-timeline-tool-header", children: [
          /* @__PURE__ */ jsx95(ShimmerText, { active: isRunning, children: /* @__PURE__ */ jsx95(Text, { variant: "body", italic: true, as: "span", className: "buyscout-timeline-tool-name", children: formattedToolName }) }),
          getStatusIcon()
        ] }),
        status === "success" && hasSuccessLabel && /* @__PURE__ */ jsx95(Text, { variant: "body", as: "div", className: "buyscout-timeline-tool-result", children: t(`tool.${toolName}.success`) }),
        status === "failed" && /* @__PURE__ */ jsx95(Text, { variant: "error", as: "div", className: "buyscout-timeline-tool-error", children: failedReason || failedText }),
        isInterrupted && /* @__PURE__ */ jsx95(Text, { variant: "error", as: "div", className: "buyscout-timeline-tool-error", children: t("tool.fallback.interrupted") })
      ]
    }
  );
}

// src/components/composite/Timeline/TimelineRenderer.tsx
import { Fragment as Fragment24, jsx as jsx96 } from "react/jsx-runtime";
function TimelineRenderer({ timeline, sessionStatus, productMap, storeDomain, onAddToCart, onClarifyingQuestionsComplete, onInlineFormSubmit, onInlineFormDismiss, dashboardMode = false, clarifyingSuperseded = false, inlineFormSuperseded = false, onToolClick }) {
  const filteredTimeline = timeline.filter((item, index2) => {
    const isLastItem = index2 === timeline.length - 1;
    if (item.type === "possible_replies") {
      return false;
    }
    if (item.type === "thinking" && !item.content && !isLastItem) {
      return false;
    }
    return true;
  });
  return /* @__PURE__ */ jsx96(Fragment24, { children: filteredTimeline.map((item, index2) => /* @__PURE__ */ jsx96(
    TimelineItem,
    {
      item,
      isLastItem: index2 === filteredTimeline.length - 1,
      sessionStatus,
      productMap,
      storeDomain,
      onAddToCart,
      onClarifyingQuestionsComplete,
      onInlineFormSubmit,
      onInlineFormDismiss,
      dashboardMode,
      clarifyingSuperseded,
      inlineFormSuperseded,
      onToolClick
    },
    `${item.type}-${index2}`
  )) });
}
function TimelineItem({ item, isLastItem, sessionStatus, productMap, storeDomain, onAddToCart, onClarifyingQuestionsComplete, onInlineFormSubmit, onInlineFormDismiss, dashboardMode, clarifyingSuperseded = false, inlineFormSuperseded = false, onToolClick }) {
  switch (item.type) {
    case "thinking":
      return /* @__PURE__ */ jsx96(ThinkingIndicator, { content: item.content, isLastItem, sessionStatus });
    case "content":
      return /* @__PURE__ */ jsx96(
        ContentRenderer,
        {
          content: item.content,
          isLastItem,
          sessionStatus,
          productMap,
          storeDomain
        }
      );
    case "tool":
      return /* @__PURE__ */ jsx96(
        ToolStatusIndicator,
        {
          toolName: item.toolName,
          toolCallId: item.toolCallId,
          status: item.status,
          failedReason: item.failedReason,
          onToolClick,
          sessionStatus
        }
      );
    case "product_card": {
      return /* @__PURE__ */ jsx96(ProductCardTimelineItem, { product: item.product, loading: item.loading, storeDomain, onAddToCart });
    }
    case "product_list": {
      return /* @__PURE__ */ jsx96(ProductListTimelineItem, { products: item.products, loading: item.loading, storeDomain, onAddToCart });
    }
    case "clarifying_questions": {
      const cqItem = item;
      const superseded = clarifyingSuperseded && (!cqItem.answers || cqItem.answers.length === 0);
      const effectiveAnswers = superseded ? item.questions.map((_, i) => ({ questionIndex: i, answer: "", skipped: true })) : cqItem.answers;
      const mergedQuestions = effectiveAnswers?.length ? item.questions.map((q, i) => {
        const a = effectiveAnswers[i];
        return a ? { ...q, ...a.skipped ? { isSkipped: true } : { answer: a.answer } } : q;
      }) : item.questions;
      return /* @__PURE__ */ jsx96(
        ClarifyingQuestionsTimelineItem,
        {
          questions: mergedQuestions,
          total: "total" in item ? item.total : void 0,
          onComplete: onClarifyingQuestionsComplete,
          dashboardMode
        }
      );
    }
    case "inline_form": {
      const hasSubmittedValues = item.values != null && Object.keys(item.values).length > 0;
      const mergedFields = hasSubmittedValues ? item.fields.map((f) => ({ ...f, value: item.values?.[f.name] ?? "" })) : item.fields;
      const superseded = inlineFormSuperseded && !hasSubmittedValues && !item.isDismissed;
      return /* @__PURE__ */ jsx96(
        InlineFormTimelineItem,
        {
          fields: mergedFields,
          title: item.title,
          submitLabel: item.submitLabel,
          isDismissed: item.isDismissed,
          onSubmit: onInlineFormSubmit,
          onDismiss: onInlineFormDismiss,
          dashboardMode,
          readOnly: superseded
        }
      );
    }
    default:
      return null;
  }
}

// src/components/composite/ChatMessage/messageCopyText.ts
function getMessageCopyText(message) {
  if (message.role === "user" /* User */) return message.content ?? "";
  const fromTimeline = message.timeline?.filter((item) => item.type === "content").map((item) => item.content).join("\n") ?? "";
  const legacyContent = message.content?.trim();
  return fromTimeline || legacyContent || "";
}

// src/components/composite/ChatMessage/ChatMessage.tsx
import { jsx as jsx97, jsxs as jsxs57 } from "react/jsx-runtime";
function ChatMessageImpl({
  message,
  isUser,
  showFadeAnimation = true,
  style = void 0,
  className = void 0,
  sessionStatus,
  isLastMessage = true,
  isLastInAssistantRun = true,
  trailingContent,
  pending = false,
  productMap,
  storeDomain,
  showCopyButton = false,
  onUserMessageEdit,
  onAssistantMessageReload,
  onAssistantMessageLike,
  onAssistantMessageDislike,
  onAddToCart,
  onClarifyingQuestionsComplete,
  onInlineFormSubmit,
  onInlineFormDismiss,
  dashboardMode = false,
  onToolClick
}) {
  const lastStatus = isLastMessage ? sessionStatus : void 0;
  if (!shouldRenderChatMessage(message, lastStatus)) return null;
  const willShowAssistantToolbar = !isUser && isLastInAssistantRun && !isFailedReply(message, lastStatus) && (showCopyButton || onAssistantMessageReload != null || onAssistantMessageLike != null || onAssistantMessageDislike != null);
  return /* @__PURE__ */ jsx97(
    "div",
    {
      className: clsx_default(
        "buyscout-chat-message-container",
        isUser ? "user" : "assistant",
        !isUser && !willShowAssistantToolbar && "buyscout-chat-message-container--no-assistant-toolbar",
        className
      ),
      style,
      "data-message-id": message.id,
      children: /* @__PURE__ */ jsx97("div", { className: clsx_default("buyscout-chat-message-content-wrapper", showFadeAnimation && "buyscout-chat-message-content-wrapper--animated"), children: /* @__PURE__ */ jsx97(
        MessageContent,
        {
          message,
          sessionStatus,
          isLastMessage,
          isLastInAssistantRun,
          trailingContent,
          pending,
          productMap,
          storeDomain,
          showCopyButton,
          onUserMessageEdit,
          onAssistantMessageReload,
          onAssistantMessageLike,
          onAssistantMessageDislike,
          onAddToCart,
          onClarifyingQuestionsComplete,
          onInlineFormSubmit,
          onInlineFormDismiss,
          dashboardMode,
          onToolClick
        }
      ) })
    }
  );
}
var ChatMessage = React134.memo(ChatMessageImpl);
ChatMessage.displayName = "ChatMessage";
function VoiceMessageIcon() {
  const { t } = useComponentsTranslation();
  return /* @__PURE__ */ jsx97(MdMic, { className: "buyscout-chat-message-voice-icon", "aria-label": t("chatMessage.voiceMessageAria") });
}
VoiceMessageIcon.displayName = "VoiceMessageIcon";
function MessageAction({ title, ariaLabel, icon: Icon3, pressedIcon: PressedIcon, onClick, pressed: pressed3 }) {
  return /* @__PURE__ */ jsx97(Tooltip, { title, children: /* @__PURE__ */ jsx97(Button, { variant: "borderless", color: "neutral", size: "xs", iconOnly: true, "aria-label": ariaLabel, "aria-pressed": pressed3, onClick, children: PressedIcon ? /* @__PURE__ */ jsxs57("span", { className: "buyscout-chat-message-action-glyphs", "aria-hidden": true, children: [
    /* @__PURE__ */ jsx97(Icon3, { "data-shown": !pressed3 || void 0 }),
    /* @__PURE__ */ jsx97(PressedIcon, { "data-shown": pressed3 || void 0 })
  ] }) : /* @__PURE__ */ jsx97(Icon3, { "aria-hidden": true }) }) });
}
function MessageContent({
  message,
  sessionStatus,
  isLastMessage = true,
  isLastInAssistantRun = true,
  trailingContent,
  pending = false,
  productMap,
  storeDomain,
  showCopyButton = false,
  onUserMessageEdit,
  onAssistantMessageReload,
  onAssistantMessageLike,
  onAssistantMessageDislike,
  onAddToCart,
  onClarifyingQuestionsComplete,
  onInlineFormSubmit,
  onInlineFormDismiss,
  dashboardMode = false,
  onToolClick
}) {
  const { t } = useComponentsTranslation();
  const animateState = useRef83({ charStartTimes: /* @__PURE__ */ new Map() });
  const isInProgress = isStreamLive(sessionStatus);
  const isStreaming = message.role === "user" /* User */ ? Boolean(message.speaking) : Boolean(isLastMessage && isInProgress && message.role === "assistant" /* Assistant */);
  if (!isStreaming) {
    animateState.current.charStartTimes.clear();
  }
  const userBubbleRef = useRef83(null);
  useSlideToFit(userBubbleRef, message.role === "user" /* User */ ? message.content : void 0, message.role === "user" /* User */ && isStreaming);
  const copyAction = /* @__PURE__ */ jsx97(CopyButton, { value: getMessageCopyText(message), variant: "borderless", size: "xs", "aria-label": t("chatMessage.copyAria") });
  if (message.role === "user" /* User */) {
    const handleEdit = () => {
      onUserMessageEdit?.(message);
    };
    const showUserCopy = showCopyButton;
    const showUserEdit = onUserMessageEdit != null;
    const hasAnyUserAction = showUserCopy || showUserEdit;
    return /* @__PURE__ */ jsxs57("div", { className: "buyscout-chat-message-user-wrapper", children: [
      /* @__PURE__ */ jsxs57(
        "div",
        {
          ref: userBubbleRef,
          "data-testid": "chat-message",
          "data-role": "user",
          className: clsx_default(
            "buyscout-chat-message-bubble",
            "user",
            pending && "is-pending"
          ),
          children: [
            /* @__PURE__ */ jsx97(Text, { variant: "body", as: "div", className: "buyscout-message-content user", children: /* @__PURE__ */ jsx97(ChatMarkdown, { content: message.content, productMap, storeDomain, isStreaming, animateState: animateState.current }) }),
            message.source === "voice" && /* @__PURE__ */ jsx97(VoiceMessageIcon, {})
          ]
        }
      ),
      hasAnyUserAction && /* @__PURE__ */ jsxs57("div", { className: "buyscout-chat-message-user-actions", role: "group", "aria-label": t("chatMessage.actionsAria"), children: [
        showUserCopy && copyAction,
        showUserEdit && /* @__PURE__ */ jsx97(MessageAction, { title: t("chatMessage.editTitle"), ariaLabel: t("chatMessage.editAria"), icon: MdEdit2, onClick: handleEdit })
      ] })
    ] });
  }
  const handleAssistantReload = () => onAssistantMessageReload?.(message);
  const handleAssistantLike = () => onAssistantMessageLike?.(message);
  const handleAssistantDislike = () => onAssistantMessageDislike?.(message);
  const feedback = message.feedback;
  const showCopy = showCopyButton;
  const showResend = onAssistantMessageReload != null;
  const showLike = onAssistantMessageLike != null;
  const showDislike = onAssistantMessageDislike != null;
  const hasAnyAssistantAction = isLastInAssistantRun && (showCopy || showResend || showLike || showDislike);
  const actionsPending = isLastMessage && sessionStatus === "InProgress" /* InProgress */;
  const assistantActions = hasAnyAssistantAction && /* @__PURE__ */ jsxs57(
    "div",
    {
      className: "buyscout-chat-message-assistant-actions",
      role: "group",
      "aria-label": t("chatMessage.actionsAria"),
      inert: actionsPending,
      "data-pending": actionsPending || void 0,
      children: [
        showCopy && copyAction,
        showResend && /* @__PURE__ */ jsx97(MessageAction, { title: t("chatMessage.regenerateTitle"), ariaLabel: t("chatMessage.regenerateAria"), icon: MdRefresh, onClick: handleAssistantReload }),
        showLike && /* @__PURE__ */ jsx97(MessageAction, { title: t("chatMessage.goodResponseTitle"), ariaLabel: t("chatMessage.likeAria"), icon: MdOutlineThumbUp, pressedIcon: MdThumbUp, onClick: handleAssistantLike, pressed: feedback === "like" }),
        showDislike && /* @__PURE__ */ jsx97(MessageAction, { title: t("chatMessage.badResponseTitle"), ariaLabel: t("chatMessage.dislikeAria"), icon: MdOutlineThumbDown, pressedIcon: MdThumbDown, onClick: handleAssistantDislike, pressed: feedback === "dislike" })
      ]
    }
  );
  const failedCard = isFailedReply(message, isLastMessage ? sessionStatus : void 0) && /* @__PURE__ */ jsxs57(Callout, { color: "error", size: "sm", className: "buyscout-chat-message-failed", children: [
    /* @__PURE__ */ jsx97(CalloutIcon, { children: /* @__PURE__ */ jsx97(MdOutlineErrorOutline, {}) }),
    /* @__PURE__ */ jsx97(CalloutContent, { children: /* @__PURE__ */ jsx97(CalloutBody, { className: "buyscout-chat-message-failed__text", children: t("chatMessage.replyFailed") }) }),
    showResend && /* @__PURE__ */ jsx97(CalloutActions, { children: /* @__PURE__ */ jsxs57(Button, { size: "xs", variant: "bordered", color: "neutral", onClick: handleAssistantReload, children: [
      /* @__PURE__ */ jsx97(MdRefresh, { "aria-hidden": true }),
      t("shared.chat.retry")
    ] }) })
  ] });
  if (failedCard && (message.timeline?.length ?? 0) === 0) {
    return /* @__PURE__ */ jsx97("div", { className: "buyscout-chat-message-assistant-wrapper", children: failedCard });
  }
  if (message.timeline !== void 0 && message.timeline.length > 0) {
    const timelineHasContentItem = message.timeline.some((item) => item.type === "content");
    const legacyContent = message.content;
    const effectiveTimeline = !timelineHasContentItem && legacyContent?.trim() ? [...message.timeline, { type: "content", content: legacyContent, timestamp: 0 }] : message.timeline;
    return /* @__PURE__ */ jsxs57("div", { className: "buyscout-chat-message-assistant-wrapper", children: [
      message.source === "voice" && /* @__PURE__ */ jsx97(VoiceMessageIcon, {}),
      /* @__PURE__ */ jsx97("div", { className: "buyscout-chat-message-timeline", children: /* @__PURE__ */ jsx97(
        TimelineRenderer,
        {
          timeline: effectiveTimeline,
          sessionStatus,
          productMap,
          storeDomain,
          onAddToCart,
          onClarifyingQuestionsComplete,
          onInlineFormSubmit,
          onInlineFormDismiss,
          dashboardMode,
          clarifyingSuperseded: !isLastMessage,
          inlineFormSuperseded: !isLastMessage,
          onToolClick
        }
      ) }),
      trailingContent != null && /* @__PURE__ */ jsx97("div", { className: "buyscout-chat-message-assistant-trailing-content", children: trailingContent }),
      failedCard || assistantActions
    ] });
  }
  return null;
}

// src/components/composite/ChatLog/EventMessageLine.tsx
import { jsx as jsx98 } from "react/jsx-runtime";
function EventMessageLine({ eventMeta, productMap, storeDomain }) {
  const product = resolveProductMention(productMap, eventMeta.productKey);
  const chip = product ? /* @__PURE__ */ jsx98(ProductMentionChip, { product, storeDomain }) : /* @__PURE__ */ jsx98("span", { children: eventMeta.productKey });
  return /* @__PURE__ */ jsx98(
    Trans,
    {
      i18n: componentsI18n,
      i18nKey: `chatLog.event.${eventMeta.kind}`,
      components: [chip]
    }
  );
}

// src/components/composite/ChatLog/PendingStatus.tsx
import { useRef as useRef84 } from "react";
import { jsx as jsx99 } from "react/jsx-runtime";
function PendingStatus({ status }) {
  const ref = useRef84(null);
  const bubbleRef = useRef84(null);
  const animateStateRef = useRef84({ charStartTimes: /* @__PURE__ */ new Map() });
  const { rendered, closing } = useExitPresence(status, ref);
  useSlideToFit(bubbleRef, rendered, !closing);
  if (rendered === void 0) return null;
  return /* @__PURE__ */ jsx99(
    "div",
    {
      ref,
      className: "buyscout-chat-log-pending-status",
      "data-state": closing ? "closed" : "open",
      role: closing ? void 0 : "status",
      "aria-hidden": closing || void 0,
      children: /* @__PURE__ */ jsx99("div", { className: "buyscout-chat-log-pending-status__clip", children: /* @__PURE__ */ jsx99("div", { ref: bubbleRef, className: "buyscout-chat-log-pending-status__bubble", children: /* @__PURE__ */ jsx99(Text, { variant: "body", as: "div", children: closing ? Array.from(rendered, (char, index2) => /* @__PURE__ */ jsx99("span", { className: "buyscout-chat-log-pending-status__char", style: { "--bs-char-index": index2 }, children: char }, index2)) : /* @__PURE__ */ jsx99(ChatMarkdown, { content: rendered, isStreaming: true, animateState: animateStateRef.current }) }) }) })
    }
  );
}
PendingStatus.displayName = "PendingStatus";

// src/components/composite/ChatLog/scrollContainers.ts
var SCROLLABLE_OVERFLOW = /* @__PURE__ */ new Set(["auto", "scroll", "overlay"]);
function scrollContainersOf(log) {
  const containers = [];
  for (let el = log; el && el !== el.ownerDocument.body; el = el.parentElement) {
    if (SCROLLABLE_OVERFLOW.has(getComputedStyle(el).overflowY)) containers.push(el);
  }
  return containers;
}
function activeScrollContainer(containers) {
  return containers.find((el) => el.scrollHeight > el.clientHeight);
}

// src/components/composite/ChatLog/scrollIntent.ts
var INPUT_WINDOW_MS = 400;
var MOMENTUM_WINDOW_MS = 1200;
var TOUCH_SLOP_PX = 10;
var SMOOTH_QUIET_MS = 200;
var SCROLL_KEYS = /* @__PURE__ */ new Set(["ArrowDown", "ArrowUp", "PageDown", "PageUp", "Home", "End", " "]);
var CONTROL_KEYS = /* @__PURE__ */ new Set(["ArrowDown", "ArrowUp", " "]);
var CONTROL = 'button, a[href], input, [role="button"], [role="tab"], [role="checkbox"], [role="radio"], [role="switch"], [role="menuitem"], [role="option"]';
var KEEPS_SCROLL_KEYS = 'input:not([type="button"], [type="submit"], [type="reset"], [type="checkbox"], [type="radio"], [type="image"], [type="color"], [type="file"]), textarea, select, [role="slider"], [role="spinbutton"], [role="listbox"], [role="grid"], [role="tree"]';
function trackScrollIntent(target) {
  let until = 0;
  let touchStart = null;
  let touchScrolling = false;
  let draggingScrollbar = false;
  const scrollers = /* @__PURE__ */ new Map();
  const stateOf = (el) => {
    let state = scrollers.get(el);
    if (!state) {
      state = { lastTop: el.scrollTop };
      scrollers.set(el, state);
    }
    return state;
  };
  const endSmooth = (state) => {
    if (!state.smooth) return;
    clearTimeout(state.smooth.timer);
    state.smooth = void 0;
  };
  const armSmooth = (state, target2) => {
    if (state.smooth) clearTimeout(state.smooth.timer);
    state.smooth = { target: target2, timer: setTimeout(endSmooth, SMOOTH_QUIET_MS, state) };
  };
  const readerInput = (ms) => {
    until = Math.max(until, performance.now() + ms);
    for (const state of scrollers.values()) endSmooth(state);
  };
  const wheel2 = (event) => {
    if (!event.ctrlKey) readerInput(INPUT_WINDOW_MS);
  };
  const touchStartListener = (event) => {
    const touch = event.touches[0];
    touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
    touchScrolling = false;
  };
  const touchMove = (event) => {
    const touch = event.touches[0];
    if (touchScrolling || !touchStart || !touch) return;
    if (Math.hypot(touch.clientX - touchStart.x, touch.clientY - touchStart.y) < TOUCH_SLOP_PX) return;
    touchScrolling = true;
    readerInput(0);
  };
  const touchEnd = (event) => {
    if (event.touches.length > 0) return;
    if (touchScrolling) readerInput(MOMENTUM_WINDOW_MS);
    touchStart = null;
    touchScrolling = false;
  };
  const pointerDown = (event) => {
    const el = event.target;
    if (!(el instanceof HTMLElement) || el.scrollHeight <= el.clientHeight) return;
    const box = el.getBoundingClientRect();
    if (event.clientX >= box.left + el.clientLeft + el.clientWidth) {
      draggingScrollbar = true;
      readerInput(0);
    }
  };
  const pointerUp = () => {
    if (!draggingScrollbar) return;
    draggingScrollbar = false;
    readerInput(INPUT_WINDOW_MS);
  };
  const keyDown = (event) => {
    if (!SCROLL_KEYS.has(event.key) || event.altKey || event.ctrlKey || event.metaKey) return;
    const el = event.target;
    if (el instanceof HTMLElement) {
      if (el.isContentEditable || el.closest(KEEPS_SCROLL_KEYS)) return;
      if (CONTROL_KEYS.has(event.key) && el.closest(CONTROL)) return;
    }
    readerInput(INPUT_WINDOW_MS);
  };
  const focusIn = (event) => {
    const el = event.target;
    if (el instanceof Element && matchesFocusVisible(el)) readerInput(INPUT_WINDOW_MS);
  };
  const listeners2 = {
    wheel: wheel2,
    touchstart: touchStartListener,
    touchmove: touchMove,
    touchend: touchEnd,
    touchcancel: touchEnd,
    pointerdown: pointerDown,
    keydown: keyDown,
    focusin: focusIn
  };
  for (const [type, listener] of Object.entries(listeners2)) target.addEventListener(type, listener, { capture: true, passive: true });
  const doc = target.ownerDocument;
  doc.addEventListener("pointerup", pointerUp, { capture: true, passive: true });
  doc.addEventListener("pointercancel", pointerUp, { capture: true, passive: true });
  const active = () => touchScrolling || draggingScrollbar || performance.now() < until;
  return {
    active,
    scrollTo: (el, top, behavior) => {
      const state = stateOf(el);
      const from = el.scrollTop;
      if (behavior === "smooth") {
        const target2 = Math.max(0, Math.min(top, el.scrollHeight - el.clientHeight));
        if (Math.abs(target2 - from) > 1) armSmooth(state, target2);
        el.scrollTo({ top, behavior });
        return;
      }
      el.scrollTo({ top, behavior });
      if (el.scrollTop !== from) state.lastTop = state.pendingTop = el.scrollTop;
    },
    read: (el) => {
      const state = stateOf(el);
      const top = el.scrollTop;
      const upward = top < state.lastTop - 1;
      state.lastTop = top;
      if (state.smooth) {
        if (Math.abs(top - state.smooth.target) <= 1) endSmooth(state);
        else armSmooth(state, state.smooth.target);
        return { cause: "page", upward };
      }
      if (state.pendingTop !== void 0) {
        const ours = Math.abs(top - state.pendingTop) <= 1;
        state.pendingTop = void 0;
        if (ours) return { cause: "page", upward };
      }
      return { cause: active() ? "reader" : "unknown", upward };
    },
    dispose: () => {
      for (const [type, listener] of Object.entries(listeners2)) target.removeEventListener(type, listener, true);
      doc.removeEventListener("pointerup", pointerUp, true);
      doc.removeEventListener("pointercancel", pointerUp, true);
      for (const state of scrollers.values()) endSmooth(state);
      scrollers.clear();
    }
  };
}
function matchesFocusVisible(el) {
  try {
    return el.matches(":focus-visible");
  } catch {
    return true;
  }
}

// src/components/composite/ChatLog/serializeCopyFragment.ts
function serializeFragmentToPlainText(fragment) {
  const parts = [];
  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      parts.push(node.textContent || "");
      return;
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node;
      const id = el.getAttribute("data-product-id") ?? el.getAttribute("data-product-chip") ?? "";
      const isChip = (el.classList.contains("product-mention-chip") || el.hasAttribute("data-product-chip")) && !!id;
      if (isChip) {
        parts.push(`@[${id}]`);
        return;
      }
      el.childNodes.forEach(walk);
    }
  };
  fragment.childNodes.forEach(walk);
  return parts.join("");
}
function serializeFragmentToHtml(fragment) {
  const escape = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const parts = [];
  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      parts.push(escape(node.textContent || ""));
      return;
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node;
      const id = el.getAttribute("data-product-id") ?? el.getAttribute("data-product-chip") ?? "";
      if ((el.classList.contains("product-mention-chip") || el.hasAttribute("data-product-chip")) && id) {
        parts.push(`<span data-product-id="${escape(id)}" data-copy-chip="1">@[${escape(id)}]</span>`);
        return;
      }
      el.childNodes.forEach(walk);
    }
  };
  fragment.childNodes.forEach(walk);
  return parts.join("");
}

// src/components/composite/ChatLog/ChatLog.tsx
import { jsx as jsx100, jsxs as jsxs58 } from "react/jsx-runtime";
var FOLLOW_THRESHOLD_PX = 50;
var LATEST_THRESHOLD_PX = 24;
var renderKey = (message) => message.clientId ?? message.id;
function ChatLog({
  session,
  topContent,
  bottomContent,
  pendingStatus,
  lastAssistantContent,
  enableScrollDetection = true,
  className = "",
  style,
  formHeight,
  typingIndicatorDelay = 1e3,
  productMap,
  storeDomain,
  showCopyButton = false,
  onUserMessageEdit,
  onAssistantMessageReload,
  onAssistantMessageLike,
  onAssistantMessageDislike,
  onAddToCart,
  onClarifyingQuestionsComplete,
  onInlineFormSubmit,
  onInlineFormDismiss,
  presetReplies,
  onPresetReplyClick,
  scrollToBottomKey
}) {
  const { t } = useComponentsTranslation();
  const [showTyping, setShowTyping] = useState70(false);
  const [showLatest, setShowLatest] = useState70(false);
  const hasQuestions = !!presetReplies && presetReplies.length > 0;
  const [displayedQuestions, setDisplayedQuestions] = useState70(presetReplies ?? []);
  const [bubblesExiting, setBubblesExiting] = useState70(false);
  const showBubbles = displayedQuestions.length > 0;
  const hasSession = session != null;
  const rootRef = useRef85(null);
  const scrollContainersRef = useRef85([]);
  const scrollIntentRef = useRef85(null);
  const contentWrapperRef = useRef85(null);
  const bottomAreaRef = useRef85(null);
  const firstRenderRef = useRef85(true);
  const typingTimerRef = useRef85(null);
  const spacerRef = useRef85(null);
  const followRef = useRef85("bottom");
  const anchorTopRef = useRef85(null);
  const anchoredQuestionRef = useRef85(void 0);
  const baselineMessageIdsRef = useRef85(/* @__PURE__ */ new Set());
  const baselinePresetRepliesRef = useRef85(/* @__PURE__ */ new Set());
  const lastSessionIdRef = useRef85(void 0);
  if (session?.id !== lastSessionIdRef.current) {
    lastSessionIdRef.current = session?.id;
    const nextPresetReplies = presetReplies ?? [];
    baselineMessageIdsRef.current = new Set(session?.messages.map(renderKey) ?? []);
    baselinePresetRepliesRef.current = new Set(nextPresetReplies);
    setDisplayedQuestions(nextPresetReplies);
    setBubblesExiting(false);
    if (enableScrollDetection) {
      firstRenderRef.current = true;
    }
  }
  const scroller = () => {
    const containers = scrollContainersRef.current;
    return activeScrollContainer(containers) ?? containers[0];
  };
  const scrollOwn = (el, top, behavior) => {
    if (scrollIntentRef.current) scrollIntentRef.current.scrollTo(el, top, behavior);
    else el.scrollTo({ top, behavior });
  };
  const motion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth";
  const pinToBottom = () => {
    const el = scroller();
    if (el) scrollOwn(el, el.scrollHeight, "instant");
    else bottomAreaRef.current?.scrollIntoView({ behavior: "instant" });
  };
  const fitSpacer = () => {
    const spacer = spacerRef.current;
    if (!spacer) return;
    const el = scroller();
    const anchorTop = anchorTopRef.current;
    const current = spacer.offsetHeight;
    const needed = el && anchorTop !== null ? Math.max(0, Math.ceil(anchorTop + el.clientHeight - (el.scrollHeight - current))) : 0;
    if (needed !== current) spacer.style.height = needed ? `${needed}px` : "";
  };
  const syncLatest = () => {
    const el = scroller();
    let away = false;
    if (el && followRef.current === "anchor" && anchorTopRef.current !== null) {
      away = el.scrollHeight - anchorTopRef.current - el.clientHeight > LATEST_THRESHOLD_PX;
    } else if (el && followRef.current === "free") {
      away = el.scrollHeight - el.scrollTop - el.clientHeight > LATEST_THRESHOLD_PX;
    }
    setShowLatest(away);
  };
  const anchorTo = (messageId) => {
    const el = scroller();
    const log = rootRef.current;
    const message = log?.querySelector(`[data-message-id="${CSS.escape(messageId)}"]`);
    if (!el || !log || !message) return;
    const paddingTop = (node) => Number.parseFloat(getComputedStyle(node).paddingTop) || 0;
    const inset = paddingTop(log) + (el === log ? 0 : paddingTop(el));
    const top = Math.max(0, Math.round(el.scrollTop + message.getBoundingClientRect().top - el.getBoundingClientRect().top - el.clientTop - inset));
    anchorTopRef.current = top;
    followRef.current = "anchor";
    fitSpacer();
    scrollOwn(el, top, motion());
  };
  const jumpToLatest = () => {
    followRef.current = "bottom";
    setShowLatest(false);
    const el = scroller();
    if (el) scrollOwn(el, el.scrollHeight, motion());
  };
  useLayoutEffect14(() => {
    const log = rootRef.current;
    if (!enableScrollDetection || !log) return;
    const containers = scrollContainersOf(log);
    scrollContainersRef.current = containers;
    const intent = trackScrollIntent(containers.at(-1) ?? log);
    scrollIntentRef.current = intent;
    const handleScroll = (event) => {
      const container = event.currentTarget;
      if (!(container instanceof HTMLElement)) return;
      const { cause, upward } = intent.read(container);
      if (container !== activeScrollContainer(containers)) return;
      const atBottom = container.scrollHeight - container.scrollTop - container.clientHeight < FOLLOW_THRESHOLD_PX;
      if (cause === "reader") followRef.current = atBottom ? "bottom" : "free";
      else if (cause === "unknown" && upward && !atBottom && followRef.current === "bottom") followRef.current = "free";
      syncLatest();
    };
    for (const container of containers) container.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      for (const container of containers) container.removeEventListener("scroll", handleScroll);
      intent.dispose();
      scrollIntentRef.current = null;
      scrollContainersRef.current = [];
    };
  }, [enableScrollDetection, hasSession]);
  let lastUserMessageIndex = -1;
  if (session) {
    for (let i = session.messages.length - 1; i >= 0; i--) {
      if (session.messages[i].role === "user" /* User */) {
        lastUserMessageIndex = i;
        break;
      }
    }
  }
  const lastUserMessage = session?.messages[lastUserMessageIndex];
  const lastUserMessageId = lastUserMessage?.id;
  useLayoutEffect14(() => {
    if (!session) return;
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      anchoredQuestionRef.current = lastUserMessage && renderKey(lastUserMessage);
      anchorTopRef.current = null;
      followRef.current = "bottom";
      fitSpacer();
      pinToBottom();
      syncLatest();
      return;
    }
    if (!enableScrollDetection) return;
    if (lastUserMessage && renderKey(lastUserMessage) !== anchoredQuestionRef.current) {
      anchoredQuestionRef.current = renderKey(lastUserMessage);
      anchorTo(lastUserMessage.id);
    } else {
      fitSpacer();
      if (followRef.current === "bottom") pinToBottom();
    }
    syncLatest();
  }, [session?.id, session?.messages.length, session?.messages.at(-1)?.timeline?.length, lastUserMessageId]);
  const isFirstScrollKeyRef = useRef85(true);
  useEffect57(() => {
    if (isFirstScrollKeyRef.current) {
      isFirstScrollKeyRef.current = false;
      return;
    }
    if (scrollToBottomKey === void 0) return;
    followRef.current = "bottom";
    pinToBottom();
    syncLatest();
  }, [scrollToBottomKey]);
  useEffect57(() => {
    if (!enableScrollDetection || !contentWrapperRef.current) return;
    const resizeObserver = new ResizeObserver(() => {
      fitSpacer();
      if (followRef.current === "bottom") pinToBottom();
      syncLatest();
    });
    resizeObserver.observe(contentWrapperRef.current);
    for (const container of scrollContainersRef.current) resizeObserver.observe(container);
    return () => resizeObserver.disconnect();
  }, [enableScrollDetection, hasSession]);
  useEffect57(() => {
    if (!session) {
      setShowTyping(false);
      return;
    }
    const lastMessage = session.messages.at(-1);
    const assistantHasStartedResponding = lastMessage?.role === "assistant" /* Assistant */ && (lastMessage?.timeline?.length ?? 0) > 0;
    const hasTimeline = assistantHasStartedResponding;
    const isInProgress2 = session.status === "Waiting" /* Waiting */ || session.status === "InProgress" /* InProgress */;
    const shouldShowTyping = isInProgress2 && !assistantHasStartedResponding && !hasTimeline;
    if (shouldShowTyping) {
      if (typingTimerRef.current) clearTimeout(typingTimerRef.current);
      typingTimerRef.current = setTimeout(setShowTyping, typingIndicatorDelay, true);
    } else {
      if (typingTimerRef.current) {
        clearTimeout(typingTimerRef.current);
        typingTimerRef.current = null;
      }
      setShowTyping(false);
    }
    return () => {
      if (typingTimerRef.current) {
        clearTimeout(typingTimerRef.current);
        typingTimerRef.current = null;
      }
    };
  }, [session, typingIndicatorDelay]);
  useEffect57(() => {
    if (hasQuestions) {
      setDisplayedQuestions(presetReplies);
      setBubblesExiting(false);
    } else if (displayedQuestions.length > 0 && !bubblesExiting) {
      setBubblesExiting(true);
    }
  }, [hasQuestions, presetReplies]);
  const handleBubblesExitComplete = useCallback33(() => {
    setBubblesExiting(false);
    setDisplayedQuestions([]);
  }, []);
  useEffect57(() => {
    return () => {
      if (typingTimerRef.current) {
        clearTimeout(typingTimerRef.current);
      }
    };
  }, []);
  const handleCopy = (e) => {
    const target = e.currentTarget;
    const root3 = target.getRootNode();
    const isInShadow = root3 instanceof ShadowRoot;
    const sel = isInShadow && typeof root3.getSelection === "function" ? root3.getSelection() : target.ownerDocument?.defaultView?.getSelection?.() ?? null;
    if (!sel || sel.rangeCount === 0) return;
    const range = sel.getRangeAt(0);
    const commonAncestor = range.commonAncestorContainer;
    const contained = target.contains(commonAncestor);
    const intersects = range.intersectsNode(target);
    const selectionRetargetedToHost = isInShadow && commonAncestor === root3.host;
    const selectionInTarget = contained || intersects || selectionRetargetedToHost;
    if (!selectionInTarget) return;
    const fragment = range.cloneContents();
    const plainText = serializeFragmentToPlainText(fragment);
    const html4 = serializeFragmentToHtml(fragment);
    e.clipboardData.setData("text/plain", plainText);
    e.clipboardData.setData("text/html", html4 ? `<div>${html4}</div>` : "");
    e.preventDefault();
    e.stopPropagation();
  };
  const isInProgress = session?.status === "Waiting" /* Waiting */ || session?.status === "InProgress" /* InProgress */;
  const assistantHasStarted = !!session && lastUserMessageIndex !== -1 && session.messages.slice(lastUserMessageIndex + 1).some((m) => m.role === "assistant" /* Assistant */ && (m.timeline?.length ?? 0) > 0);
  const isPendingForLastUser = isInProgress && lastUserMessageIndex !== -1 && !assistantHasStarted;
  const visibleMessages = session?.messages.filter((message, index2, messages) => message.role === "system" /* System */ ? Boolean(message.content || message.eventMeta) : shouldRenderChatMessage(message, index2 === messages.length - 1 ? session.status : void 0)) ?? [];
  const lastAssistantMessage = visibleMessages.reduce((last, message) => message.role === "assistant" /* Assistant */ && (message.timeline?.length ?? 0) > 0 ? message : last, void 0);
  const renderMessages = () => {
    if (!session) return null;
    const showThinkingAfterMessages = (session.isSending || showTyping) && !isPendingForLastUser;
    return visibleMessages.map((message, index2) => {
      const isLastMessage = index2 + 1 === visibleMessages.length;
      const isSystemMessage = message.role === "system" /* System */;
      const nextMessage = visibleMessages[index2 + 1];
      const isLastInAssistantRun = message.role === "assistant" /* Assistant */ && (nextMessage === void 0 || nextMessage.role !== "assistant" /* Assistant */);
      if (isSystemMessage) {
        const sysMsg = message;
        if (!sysMsg.content && !sysMsg.eventMeta) return null;
        const marginBottom = isLastMessage && !showThinkingAfterMessages ? "8px" : "12px";
        const animated = !baselineMessageIdsRef.current.has(renderKey(sysMsg));
        const className2 = animated ? "buyscout-chat-log-system-message buyscout-chat-log-system-message--animated" : "buyscout-chat-log-system-message";
        return /* @__PURE__ */ jsx100("div", { className: className2, style: { marginBottom }, children: sysMsg.eventMeta ? /* @__PURE__ */ jsx100(EventMessageLine, { eventMeta: sysMsg.eventMeta, productMap, storeDomain }) : /* @__PURE__ */ jsx100(ProductMentionText, { content: sysMsg.content, productMap, storeDomain }) }, renderKey(sysMsg));
      }
      const isUser = message.role === "user" /* User */;
      const nonSystemMessage = message;
      return /* @__PURE__ */ jsxs58(Fragment25, { children: [
        /* @__PURE__ */ jsx100(
          ChatMessage,
          {
            message: nonSystemMessage,
            isUser,
            showFadeAnimation: !baselineMessageIdsRef.current.has(renderKey(nonSystemMessage)),
            sessionStatus: isLastMessage ? session.status : void 0,
            isLastMessage,
            isLastInAssistantRun,
            trailingContent: message.id === lastAssistantMessage?.id ? lastAssistantContent : void 0,
            pending: isUser && isPendingForLastUser && message.id === session.messages[lastUserMessageIndex]?.id,
            productMap,
            storeDomain,
            showCopyButton,
            onUserMessageEdit,
            onAssistantMessageReload,
            onAssistantMessageLike,
            onAssistantMessageDislike,
            onAddToCart,
            onClarifyingQuestionsComplete,
            onInlineFormSubmit,
            onInlineFormDismiss
          }
        ),
        isUser && message.id === session.messages[lastUserMessageIndex]?.id && /* @__PURE__ */ jsx100(PendingStatus, { status: pendingStatus })
      ] }, renderKey(nonSystemMessage));
    });
  };
  const renderThinkingIndicator = () => /* @__PURE__ */ jsx100(
    ChatMessage,
    {
      message: {
        id: "__thinking",
        role: "assistant" /* Assistant */,
        timeline: [{ type: "thinking", content: "", timestamp: Date.now() }]
      },
      isUser: false,
      sessionStatus: "InProgress" /* InProgress */,
      isLastMessage: true,
      showFadeAnimation: true
    }
  );
  if (!session) return null;
  const containerStyle = {
    paddingBottom: formHeight ? `${formHeight + 20}px` : "20px",
    ...style
  };
  const containerClass = `buyscout-chat-log ${className}`;
  return /* @__PURE__ */ jsxs58(
    "div",
    {
      ref: rootRef,
      onCopy: handleCopy,
      className: containerClass,
      style: containerStyle,
      role: "log",
      "aria-busy": isInProgress && assistantHasStarted || void 0,
      "data-testid": "chat-log",
      children: [
        /* @__PURE__ */ jsxs58("div", { ref: contentWrapperRef, className: "buyscout-chat-log-content-wrapper", children: [
          topContent,
          renderMessages(),
          !isPendingForLastUser && (session.isSending || showTyping) && renderThinkingIndicator(),
          !lastAssistantMessage && lastAssistantContent,
          bottomContent,
          showBubbles && /* @__PURE__ */ jsx100(
            PresetReplyButton,
            {
              items: displayedQuestions,
              baselineItems: baselinePresetRepliesRef.current,
              onItemClick: onPresetReplyClick,
              exiting: bubblesExiting,
              onExitComplete: handleBubblesExitComplete,
              variant: "chat"
            }
          ),
          !enableScrollDetection && /* @__PURE__ */ jsx100("div", { ref: bottomAreaRef })
        ] }),
        /* @__PURE__ */ jsx100("div", { ref: spacerRef, "aria-hidden": "true" }),
        /* @__PURE__ */ jsx100(
          "div",
          {
            className: "buyscout-chat-log__latest",
            "data-state": showLatest ? "open" : "closed",
            inert: !showLatest,
            "aria-hidden": !showLatest || void 0,
            style: { bottom: `${(formHeight ?? 0) + 12}px` },
            children: /* @__PURE__ */ jsx100(
              Button,
              {
                variant: "glass",
                color: "neutral",
                shape: "circle",
                size: "sm",
                iconOnly: true,
                "aria-label": t("chatLog.jumpToLatest"),
                onClick: jumpToLatest,
                children: /* @__PURE__ */ jsx100(MdArrowDownward, { "aria-hidden": true })
              }
            )
          }
        )
      ]
    }
  );
}

// src/components/composite/Conversations/ConversationComposer.tsx
import { useId as useId13, useLayoutEffect as useLayoutEffect15, useRef as useRef87, useState as useState71 } from "react";
import { MdAttachFile, MdClose as MdClose5, MdDescription, MdFullscreen, MdFullscreenExit } from "react-icons/md";

// src/hooks/usePointerDrag.ts
import { useCallback as useCallback34, useEffect as useEffect58, useRef as useRef86 } from "react";
function usePointerDrag() {
  const detachRef = useRef86(null);
  useEffect58(() => () => detachRef.current?.(), []);
  return useCallback34((event, { onMove, onEnd }) => {
    if (event.button !== 0 || detachRef.current) return false;
    event.preventDefault();
    const handle = event.currentTarget;
    const { pointerId, clientX: startX, clientY: startY } = event;
    const previousUserSelect = document.body.style.userSelect;
    document.body.style.userSelect = "none";
    try {
      handle.setPointerCapture(pointerId);
    } catch {
    }
    const end = (reason) => {
      detachRef.current?.();
      onEnd?.(reason);
    };
    const handleMove = (moveEvent) => {
      if (moveEvent.pointerId === pointerId) onMove(moveEvent.clientX - startX, moveEvent.clientY - startY);
    };
    const handleRelease = (endEvent) => {
      if (endEvent.pointerId === pointerId) end("release");
    };
    const handleCancel = (cancelEvent) => {
      if (cancelEvent.pointerId === pointerId) end("cancel");
    };
    const handleKeyDown = (keyEvent) => {
      if (keyEvent.key !== "Escape") return;
      keyEvent.preventDefault();
      keyEvent.stopPropagation();
      end("escape");
    };
    detachRef.current = () => {
      detachRef.current = null;
      document.body.style.userSelect = previousUserSelect;
      handle.removeEventListener("pointermove", handleMove);
      handle.removeEventListener("pointerup", handleRelease);
      handle.removeEventListener("pointercancel", handleCancel);
      handle.removeEventListener("lostpointercapture", handleRelease);
      window.removeEventListener("pointermove", handleMove);
      window.removeEventListener("pointerup", handleRelease);
      window.removeEventListener("keydown", handleKeyDown, true);
      if (handle.hasPointerCapture(pointerId)) handle.releasePointerCapture(pointerId);
    };
    handle.addEventListener("pointermove", handleMove);
    handle.addEventListener("pointerup", handleRelease);
    handle.addEventListener("pointercancel", handleCancel);
    handle.addEventListener("lostpointercapture", handleRelease);
    if (!handle.hasPointerCapture(pointerId)) {
      window.addEventListener("pointermove", handleMove);
      window.addEventListener("pointerup", handleRelease);
    }
    window.addEventListener("keydown", handleKeyDown, true);
    return true;
  }, []);
}

// src/components/composite/Conversations/composer-draft.ts
function createComposerDraft() {
  return { text: "", attachments: [], busy: null, uploading: 0, sent: false, attachmentError: null };
}

// src/components/composite/Conversations/use-conversations-translation.ts
function useConversationsTranslation() {
  return useTranslation(void 0, { i18n: componentsI18n });
}

// src/components/composite/Conversations/ConversationComposer.tsx
import { Fragment as Fragment26, jsx as jsx101, jsxs as jsxs59 } from "react/jsx-runtime";
var MAX_LENGTH = 1600;
function formatBytes(bytes, locale) {
  const megabytes = bytes >= 1024 * 1024;
  return new Intl.NumberFormat(locale, { style: "unit", unit: megabytes ? "megabyte" : "kilobyte", unitDisplay: "short", maximumFractionDigits: 1 }).format(bytes / (megabytes ? 1024 * 1024 : 1024));
}
function ConversationComposer({ aiPaused, emailReply, draft, onDraftChange, onSend, onResumeAi, attachmentPolicy, onUploadAttachment }) {
  const { t, i18n } = useConversationsTranslation();
  const [localDraft, setLocalDraft] = useState71(createComposerDraft);
  const { text: text4, attachments, busy, uploading, sent, attachmentError } = draft ?? localDraft;
  const updateDraft = onDraftChange ?? setLocalDraft;
  const [expanded, setExpanded] = useState71(false);
  const [inputHeight, setInputHeight] = useState71(null);
  const [range, setRange] = useState71(null);
  const limitId = useId13();
  const inputId = useId13();
  const fileInputRef = useRef87(null);
  const textareaRef = useRef87(null);
  const composerRef = useRef87(null);
  const minInputHeightRef = useRef87(null);
  const draggedRef = useRef87(false);
  const startDrag = usePointerDrag();
  const canAttach = Boolean(attachmentPolicy && onUploadAttachment);
  const hasContent = text4.trim().length > 0 || attachments.length > 0;
  const locked = !!busy || uploading > 0;
  const sendDisabled = locked || !hasContent;
  const attachLabel = emailReply ? t("shared.chat.reply.attach_files") : t("shared.chat.reply.attach");
  const resizeRange = () => {
    const textarea = textareaRef.current;
    const composer = composerRef.current;
    if (!textarea || !composer) return null;
    const styles = getComputedStyle(textarea);
    const height = textarea.getBoundingClientRect().height;
    minInputHeightRef.current ??= height;
    const min2 = minInputHeightRef.current;
    const maxHeight = Number.parseFloat(styles.maxHeight);
    const inputLimit = Number.isFinite(maxHeight) ? maxHeight : height;
    const available = composer.parentElement?.getBoundingClientRect().height ?? 0;
    const max2 = Math.max(min2, Math.min(inputLimit, available ? available * 0.7 - (composer.getBoundingClientRect().height - height) : inputLimit));
    return { height, min: min2, max: max2 };
  };
  useLayoutEffect15(() => {
    if (expanded) return;
    const measure2 = () => {
      const next = resizeRange();
      if (!next) return;
      const rounded = { height: Math.round(next.height), min: Math.round(next.min), max: Math.round(next.max) };
      setRange((current) => current?.height === rounded.height && current.min === rounded.min && current.max === rounded.max ? current : rounded);
    };
    measure2();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(measure2);
    for (const element2 of [textareaRef.current, composerRef.current?.parentElement]) {
      if (element2) observer.observe(element2);
    }
    return () => observer.disconnect();
  }, [expanded]);
  const handleResizeStart = (event) => {
    const range2 = resizeRange();
    if (!range2) return;
    const previous2 = inputHeight;
    const started = startDrag(event, {
      onMove: (_deltaX, deltaY) => {
        if (Math.abs(deltaY) <= 2) return;
        draggedRef.current = true;
        setInputHeight(Math.max(range2.min, Math.min(range2.max, range2.height - deltaY)));
      },
      onEnd: (reason) => {
        if (reason === "escape") {
          setInputHeight(previous2);
          draggedRef.current = true;
        } else if (reason === "cancel") {
          draggedRef.current = false;
        }
      }
    });
    if (started) draggedRef.current = false;
  };
  const handleResizeClick = () => {
    if (draggedRef.current) {
      draggedRef.current = false;
      return;
    }
    const range2 = resizeRange();
    if (range2) setInputHeight(range2.height > range2.min + 8 ? range2.min : range2.max);
  };
  const handleResizeKey = (event) => {
    const range2 = resizeRange();
    if (!range2) return;
    if (event.key === "Enter") {
      event.preventDefault();
      setInputHeight(range2.height > range2.min + 8 ? range2.min : range2.max);
      return;
    }
    const next = event.key === "ArrowUp" ? Math.min(range2.max, range2.height + 16) : event.key === "ArrowDown" ? Math.max(range2.min, range2.height - 16) : event.key === "Home" ? range2.min : event.key === "End" ? range2.max : null;
    if (next === null) return;
    event.preventDefault();
    setInputHeight(next);
  };
  const handleSend = async () => {
    if (sendDisabled) return;
    updateDraft((current) => ({ ...current, busy: "send", sent: false }));
    try {
      if (await onSend(text4.trim(), attachments.map((attachment) => attachment.fileID))) {
        updateDraft((current) => ({ ...current, text: "", attachments: [], attachmentError: null, sent: true }));
      }
    } catch {
      return;
    } finally {
      updateDraft((current) => ({ ...current, busy: null }));
    }
  };
  const handleResume = async () => {
    if (locked) return;
    updateDraft((current) => ({ ...current, busy: "resume" }));
    try {
      await onResumeAi?.();
    } catch {
      return;
    } finally {
      updateDraft((current) => ({ ...current, busy: null }));
    }
  };
  const handlePicked = async (event) => {
    const picked = Array.from(event.target.files ?? []);
    event.target.value = "";
    if (!attachmentPolicy || !onUploadAttachment || picked.length === 0 || locked) return;
    const queuedBytes = attachments.reduce((total, attachment) => total + attachment.size, 0);
    const pickedBytes = picked.reduce((total, file) => total + file.size, 0);
    const error2 = picked.some((file) => !attachmentPolicy.accept.includes(file.type)) ? "unsupported_type" : attachments.length + picked.length > attachmentPolicy.maxCount ? "too_many" : queuedBytes + pickedBytes > attachmentPolicy.maxTotalBytes ? "too_large" : null;
    if (error2) {
      updateDraft((current) => ({ ...current, attachmentError: error2 }));
      return;
    }
    updateDraft((current) => ({ ...current, uploading: picked.length, attachmentError: null, sent: false }));
    for (const file of picked) {
      try {
        const stored = await onUploadAttachment(file);
        if (stored) updateDraft((current) => ({ ...current, attachments: [...current.attachments, { ...stored, fileName: stored.fileName || file.name }] }));
      } catch {
        continue;
      } finally {
        updateDraft((current) => ({ ...current, uploading: current.uploading - 1 }));
      }
    }
  };
  const attachmentErrorText = attachmentError && attachmentPolicy ? {
    unsupported_type: emailReply ? t("shared.chat.reply.attachment_error.unsupported_file_type") : t("shared.chat.reply.attachment_error.unsupported_type"),
    too_many: t("shared.chat.reply.attachment_error.too_many", { count: attachmentPolicy.maxCount }),
    too_large: t("shared.chat.reply.attachment_error.too_large", { limit: formatBytes(attachmentPolicy.maxTotalBytes, i18n.language) })
  }[attachmentError] : null;
  const attachControl = canAttach && /* @__PURE__ */ jsxs59(Fragment26, { children: [
    /* @__PURE__ */ jsx101("input", { ref: fileInputRef, type: "file", "aria-label": attachLabel, accept: attachmentPolicy?.accept.join(","), multiple: (attachmentPolicy?.maxCount ?? 0) > 1, hidden: true, onChange: (event) => void handlePicked(event) }),
    /* @__PURE__ */ jsxs59(Button, { size: "sm", variant: "borderless", color: "neutral", className: emailReply ? "bs-conversations__attach-full" : void 0, iconOnly: !emailReply, "aria-label": attachLabel, title: attachLabel, disabled: locked, onClick: () => fileInputRef.current?.click(), children: [
      /* @__PURE__ */ jsx101("span", { className: "buyscout-btn__icon-start", children: /* @__PURE__ */ jsx101(MdAttachFile, { "aria-hidden": true }) }),
      emailReply && attachLabel
    ] }),
    emailReply && /* @__PURE__ */ jsx101(Button, { className: "bs-conversations__attach-compact", size: "sm", variant: "borderless", color: "neutral", iconOnly: true, "aria-label": attachLabel, title: attachLabel, disabled: locked, onClick: () => fileInputRef.current?.click(), children: /* @__PURE__ */ jsx101("span", { className: "buyscout-btn__icon-start", children: /* @__PURE__ */ jsx101(MdAttachFile, { "aria-hidden": true }) }) })
  ] });
  return /* @__PURE__ */ jsxs59("div", { ref: composerRef, className: "bs-conversations__composer", "data-email": !!emailReply, "data-expanded": expanded, style: { "--bs-conversations-input-height": inputHeight === null ? void 0 : `${inputHeight}px` }, children: [
    !expanded && /* @__PURE__ */ jsx101(
      "div",
      {
        role: "separator",
        tabIndex: 0,
        className: "bs-conversations__resize-handle",
        "aria-orientation": "horizontal",
        "aria-controls": inputId,
        "aria-label": t("shared.chat.reply.resize"),
        "aria-valuenow": range?.height ?? 0,
        "aria-valuemin": range?.min ?? 0,
        "aria-valuemax": range?.max ?? 0,
        "aria-valuetext": range?.max ? t("shared.chat.reply.resize_value", { percent: Math.round(range.height / range.max * 100) }) : void 0,
        title: t("shared.chat.reply.resize_hint"),
        onPointerDown: handleResizeStart,
        onClick: handleResizeClick,
        onKeyDown: handleResizeKey
      }
    ),
    emailReply && /* @__PURE__ */ jsxs59("div", { className: "bs-conversations__compose-header", children: [
      /* @__PURE__ */ jsxs59("div", { className: "bs-conversations__reply-context", children: [
        /* @__PURE__ */ jsx101("strong", { children: t("shared.chat.reply.heading") }),
        emailReply.recipient && /* @__PURE__ */ jsx101("span", { children: t("shared.chat.reply.to", { recipient: emailReply.recipient }) }),
        emailReply.subject && (expanded || emailReply.showSubject) && /* @__PURE__ */ jsx101("span", { className: "bs-conversations__reply-subject", children: emailReply.subject })
      ] }),
      /* @__PURE__ */ jsx101(Button, { size: "sm", variant: "borderless", color: "neutral", iconOnly: true, "aria-label": expanded ? t("shared.chat.reply.collapse") : t("shared.chat.reply.expand"), title: expanded ? t("shared.chat.reply.collapse") : t("shared.chat.reply.expand"), "aria-expanded": expanded, onClick: () => setExpanded((value) => !value), children: expanded ? /* @__PURE__ */ jsx101(MdFullscreenExit, { "aria-hidden": true }) : /* @__PURE__ */ jsx101(MdFullscreen, { "aria-hidden": true }) })
    ] }),
    sent && /* @__PURE__ */ jsx101("p", { role: "status", children: t("shared.chat.reply.sent") }),
    aiPaused && onResumeAi && /* @__PURE__ */ jsxs59("div", { className: "bs-conversations__ai-notice", children: [
      /* @__PURE__ */ jsx101("span", { children: t("shared.chat.reply.ai_paused") }),
      /* @__PURE__ */ jsx101(Button, { size: "sm", variant: "outlined", color: "neutral", loading: busy === "resume", disabled: busy !== "resume" && locked, onClick: () => void handleResume(), children: t("shared.chat.reply.return_to_ai") })
    ] }),
    attachmentErrorText && /* @__PURE__ */ jsx101("p", { role: "alert", children: attachmentErrorText }),
    /* @__PURE__ */ jsxs59("div", { className: "bs-conversations__compose-fields", children: [
      /* @__PURE__ */ jsx101(
        TextField,
        {
          ref: textareaRef,
          id: inputId,
          className: "flex-grow",
          fullWidth: true,
          multiline: true,
          rows: 2,
          dir: "auto",
          "aria-describedby": emailReply ? limitId : void 0,
          disabled: !!busy,
          value: text4,
          maxLength: MAX_LENGTH,
          "aria-label": t("shared.chat.reply.placeholder"),
          placeholder: t("shared.chat.reply.placeholder"),
          onChange: (event) => {
            const value = event.target.value;
            updateDraft((current) => ({ ...current, text: value, sent: false }));
          },
          onKeyDown: (event) => {
            if (event.key === "Enter" && !event.shiftKey && (event.metaKey || event.ctrlKey) && !isImeComposing(event.nativeEvent)) {
              event.preventDefault();
              void handleSend();
            }
          }
        }
      ),
      (attachments.length > 0 || uploading > 0) && /* @__PURE__ */ jsxs59("ul", { className: "bs-conversations__pending-files", "aria-label": t("shared.chat.reply.pending_attachments"), children: [
        attachments.map((attachment) => /* @__PURE__ */ jsxs59("li", { children: [
          attachment.contentType.startsWith("image/") ? /* @__PURE__ */ jsx101(ImageFrame, { className: "bs-conversations__pending-image", src: attachment.url, alt: "" }) : /* @__PURE__ */ jsx101(MdDescription, { "aria-hidden": true }),
          /* @__PURE__ */ jsxs59("span", { className: "bs-conversations__file-info", children: [
            /* @__PURE__ */ jsx101("span", { children: attachment.fileName || t("shared.chat.reply.attachment") }),
            /* @__PURE__ */ jsx101("small", { children: formatBytes(attachment.size, i18n.language) })
          ] }),
          /* @__PURE__ */ jsx101(Button, { size: "sm", variant: "borderless", color: "neutral", iconOnly: true, "aria-label": attachment.fileName ? t("shared.chat.reply.remove_named_attachment", { name: attachment.fileName }) : t("shared.chat.reply.remove_attachment"), disabled: locked, onClick: () => updateDraft((current) => ({ ...current, attachments: current.attachments.filter((item) => item.fileID !== attachment.fileID), attachmentError: null })), children: /* @__PURE__ */ jsx101(MdClose5, { "aria-hidden": true }) })
        ] }, attachment.fileID)),
        uploading > 0 && /* @__PURE__ */ jsxs59("li", { role: "status", children: [
          /* @__PURE__ */ jsx101(Spinner, { size: "sm", "aria-hidden": true }),
          /* @__PURE__ */ jsx101("span", { children: t("shared.chat.reply.uploading_files", { count: uploading }) })
        ] })
      ] }),
      /* @__PURE__ */ jsxs59("div", { className: "bs-conversations__compose-footer", children: [
        canAttach && /* @__PURE__ */ jsx101("div", { className: "bs-conversations__compose-tools", children: attachControl }),
        /* @__PURE__ */ jsxs59("div", { className: "bs-conversations__compose-actions", children: [
          emailReply && /* @__PURE__ */ jsxs59("span", { id: limitId, className: "bs-conversations__compose-limit", children: [
            text4.length.toLocaleString(),
            " / ",
            MAX_LENGTH.toLocaleString()
          ] }),
          /* @__PURE__ */ jsx101(Button, { size: "sm", loading: busy === "send", disabled: busy !== "send" && sendDisabled, title: t("shared.chat.reply.send_hint"), onClick: () => void handleSend(), children: busy === "send" ? t("shared.chat.reply.sending") : t("shared.chat.reply.send") })
        ] })
      ] })
    ] })
  ] });
}
ConversationComposer.displayName = "ConversationComposer";
var ConversationComposer_default = ConversationComposer;

// src/components/composite/Conversations/ConversationMessages.tsx
import { memo as memo6, useCallback as useCallback35, useMemo as useMemo32 } from "react";
import { MdChatBubbleOutline } from "react-icons/md";

// src/components/composite/Conversations/MessageAttachments.tsx
import { Fragment as Fragment27, jsx as jsx102, jsxs as jsxs60 } from "react/jsx-runtime";
function MessageAttachments({ attachments }) {
  const { t } = useConversationsTranslation();
  return /* @__PURE__ */ jsx102("div", { className: "bs-conversations__attachments", children: attachments.map((attachment, index2) => {
    const isImage = typeof attachment.contentType === "string" && attachment.contentType.startsWith("image/");
    const reason = typeof attachment.reason === "string" ? attachment.reason : "unknown";
    const reasonKey = reason.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
    return /* @__PURE__ */ jsxs60("div", { className: "bs-conversations__attachment", children: [
      attachment.url ? /* @__PURE__ */ jsx102("a", { href: attachment.url, target: "_blank", rel: "noopener noreferrer", children: isImage ? /* @__PURE__ */ jsx102(ImageFrame, { className: "bs-conversations__attachment-frame", imgClassName: "bs-conversations__attachment-image", src: attachment.url, alt: t("shared.chat.log.attachment.image_alt"), fallback: "alt", loading: "lazy" }) : t("shared.chat.log.attachment.open") }) : /* @__PURE__ */ jsxs60(Fragment27, { children: [
        /* @__PURE__ */ jsx102("strong", { children: t("shared.chat.log.attachment.unavailable") }),
        /* @__PURE__ */ jsx102("span", { children: t(`shared.chat.log.attachment.reason.${reasonKey}`, { defaultValue: t("shared.chat.log.attachment.reason.unknown") }) })
      ] }),
      attachment.fileName && /* @__PURE__ */ jsx102("span", { children: attachment.fileName }),
      attachment.size != null && /* @__PURE__ */ jsxs60("small", { children: [
        new Intl.NumberFormat(void 0, { maximumFractionDigits: 1 }).format(attachment.size / 1024),
        " KB"
      ] })
    ] }, `${attachment.fileID ?? attachment.url ?? attachment.contentType}-${index2}`);
  }) });
}
MessageAttachments.displayName = "MessageAttachments";

// src/components/composite/Conversations/utils.ts
var ENGLISH_ANONYMOUS_NAMES = { visitor: "Anonymous visitor", user: "Anonymous user" };
function conversationKey(group) {
  return "visitorID" in group ? `website:${group.visitorID ?? group.sessions[0]?.id ?? "anonymous"}` : `${group.channel}:${group.userIdentifier ?? group.sessions[0]?.id ?? "anonymous"}`;
}
function conversationChannel(group) {
  return "visitorID" in group ? "website" : group.channel;
}
function conversationName(group, anonymous = ENGLISH_ANONYMOUS_NAMES) {
  return group.displayName || ("visitorID" in group ? group.customerEmail || anonymous.visitor : group.userIdentifier || anonymous.user);
}
function matchesConversation(group, search, anonymous) {
  const text4 = [conversationName(group, anonymous), ...group.sessions.flatMap((session) => [session.id, session.type, session.subject, ...session.chatMessage.map((message) => message.content)])].join(" ");
  return text4.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase());
}
function storeOrigin(domain2) {
  if (!domain2) return void 0;
  return /^https?:\/\//i.test(domain2) ? domain2 : `https://${domain2}`;
}
function formatConversationDate(value, locale) {
  if (!value || !Number.isFinite(Date.parse(value))) return "\u2014";
  return new Intl.DateTimeFormat(locale, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }).format(new Date(value));
}
function formatConversationDay(value, locale) {
  if (!value || !Number.isFinite(Date.parse(value))) return "\u2014";
  return new Intl.DateTimeFormat(locale, { month: "short", day: "numeric" }).format(new Date(value));
}
function tokenUsageText(usage, t, locale) {
  const format = (value) => value.toLocaleString(locale);
  return [
    usage.inputTokens !== void 0 && t("shared.chat.token_usage.input", { value: format(usage.inputTokens) }),
    usage.cachedTokens !== void 0 && t("shared.chat.token_usage.cached", { value: format(usage.cachedTokens) }),
    usage.outputTokens !== void 0 && t("shared.chat.token_usage.output", { value: format(usage.outputTokens) }),
    usage.reasoningTokens !== void 0 && t("shared.chat.token_usage.reasoning", { value: format(usage.reasoningTokens) }),
    usage.totalTokens !== void 0 && t("shared.chat.token_usage.total", { value: format(usage.totalTokens) })
  ].filter(Boolean).join(" \xB7 ");
}
function totalTokenUsage(group) {
  const total = {};
  for (const session of group.sessions) {
    for (const message of session.chatMessage) {
      const usage = message.metadata?.tokenUsage;
      if (!usage) continue;
      for (const key of ["inputTokens", "cachedTokens", "outputTokens", "reasoningTokens", "totalTokens"]) {
        if (usage[key] !== void 0) total[key] = (total[key] ?? 0) + usage[key];
      }
    }
  }
  return total;
}

// src/components/composite/Conversations/ConversationMessages.tsx
import { jsx as jsx103, jsxs as jsxs61 } from "react/jsx-runtime";
function assistantMessage(message) {
  const timeline = message.metadata?.timeline?.length ? message.metadata.timeline : message.content.trim() ? [{ type: "content", content: message.content, timestamp: Date.parse(message.createdAt) }] : [];
  return { id: message.id, role: "assistant" /* Assistant */, content: message.content, timeline, source: message.source ?? void 0 };
}
var MESSAGE_STYLE = { marginBottom: 0 };
var PLACEHOLDER_BUBBLES = [
  { user: false, width: "62%", height: 70 },
  { user: true, width: "38%", height: 46 },
  { user: false, width: "54%", height: 46 }
];
function ConversationMessagesImpl({ activeChatSession, loading, showTokenUsage, storeDomain, dashboardMode = true, onToolClick }) {
  const { t, i18n } = useConversationsTranslation();
  const locale = i18n.resolvedLanguage || i18n.language;
  const messages = activeChatSession.chatMessage;
  const productMap = useMemo32(() => {
    const products = {};
    const add = (product) => {
      if (product.title) products[product.title] = product;
    };
    for (const message of messages) {
      message.metadata?.mentionedProducts?.forEach(add);
      if (message.metadata?.currentProduct) add(message.metadata.currentProduct);
      for (const item of message.metadata?.timeline ?? []) {
        if (item.type === "product_card") add(item.product);
        if (item.type === "product_list") item.products.forEach(add);
      }
    }
    return products;
  }, [messages]);
  const sessionID = activeChatSession.id;
  const handleToolClick = useCallback35((toolCallId) => onToolClick?.(sessionID, toolCallId), [onToolClick, sessionID]);
  return /* @__PURE__ */ jsxs61("div", { className: "bs-conversations__messages", "aria-busy": loading, children: [
    loading && !messages.length ? PLACEHOLDER_BUBBLES.map((bubble, i) => /* @__PURE__ */ jsx103("div", { className: "bs-conversations__message", "data-user": bubble.user, "aria-hidden": "true", children: /* @__PURE__ */ jsx103(Skeleton, { variant: "rect", className: "bs-conversations__bubble-placeholder", width: bubble.width, height: bubble.height }) }, i)) : messages.map((message) => {
      const isUser = message.role === "user";
      if (message.role === "system" || message.metadata?.triggeredByUpsellAction) return /* @__PURE__ */ jsxs61("div", { className: "bs-conversations__system", children: [
        /* @__PURE__ */ jsx103(ProductMentionText, { content: message.content, productMap, storeDomain }),
        /* @__PURE__ */ jsx103("time", { children: formatConversationDate(message.createdAt, locale) })
      ] }, message.id);
      const rendered = isUser ? { id: message.id, role: "user" /* User */, content: message.content, source: message.source ?? void 0 } : assistantMessage(message);
      const showBubble = shouldRenderChatMessage(rendered);
      if (!showBubble && !message.attachments?.length) return null;
      const replies = message.metadata?.timeline?.find((item) => item.type === "possible_replies");
      const usage = message.metadata?.tokenUsage;
      return /* @__PURE__ */ jsxs61("div", { className: "bs-conversations__message", "data-user": isUser, children: [
        showBubble && /* @__PURE__ */ jsx103(ComponentsI18nProvider, { children: /* @__PURE__ */ jsx103(ChatMessage, { message: rendered, isUser, showFadeAnimation: false, style: MESSAGE_STYLE, productMap, storeDomain, dashboardMode, onToolClick: onToolClick ? handleToolClick : void 0 }) }),
        !!message.attachments?.length && /* @__PURE__ */ jsx103(MessageAttachments, { attachments: message.attachments }),
        /* @__PURE__ */ jsxs61("div", { className: "bs-conversations__message-meta", children: [
          /* @__PURE__ */ jsx103("time", { dateTime: message.createdAt, children: formatConversationDate(message.createdAt, locale) }),
          !isUser && (message.feedback === "like" || message.feedback === "dislike") && /* @__PURE__ */ jsx103("span", { children: message.feedback === "like" ? t("shared.chat.log.feedback.like") : t("shared.chat.log.feedback.dislike") }),
          !isUser && message.sentBy === "human" && /* @__PURE__ */ jsx103("span", { children: t("shared.chat.log.sent_by_you") }),
          !isUser && message.sentBy === "system" && /* @__PURE__ */ jsx103("span", { children: t("shared.chat.log.sent_by_system") }),
          !isUser && replies?.type === "possible_replies" && !!replies.possibleReplies.length && /* @__PURE__ */ jsx103(Tooltip, { title: replies.possibleReplies.join("\n"), children: /* @__PURE__ */ jsx103("button", { type: "button", children: t("shared.chat.log.suggested_replies") }) }),
          !isUser && showTokenUsage && usage?.totalTokens !== void 0 && /* @__PURE__ */ jsx103(Tooltip, { title: tokenUsageText(usage, t, locale), children: /* @__PURE__ */ jsx103("button", { type: "button", children: t("shared.chat.token_usage.tokens", { count: usage.totalTokens, value: usage.totalTokens.toLocaleString(locale) }) }) })
        ] }),
        isUser && message.pageUrl && !message.metadata?.currentProduct && /* @__PURE__ */ jsxs61("div", { className: "bs-conversations__page-link", children: [
          t("shared.chat.log.page_visited_label"),
          " ",
          /* @__PURE__ */ jsx103(Link, { variant: "muted", external: true, href: message.pageUrl, children: message.pageUrl })
        ] }),
        isUser && message.metadata?.currentProduct && /* @__PURE__ */ jsxs61("div", { className: "bs-conversations__page-link", children: [
          t("shared.chat.log.viewing_product_label"),
          " ",
          /* @__PURE__ */ jsx103(ProductMentionChip, { product: { ...message.metadata.currentProduct, imageUrl: message.metadata.currentProduct.imageUrl ?? void 0 }, storeDomain, size: "label" })
        ] })
      ] }, message.id);
    }),
    !loading && !messages.length && /* @__PURE__ */ jsxs61(EmptyState, { variant: "plain", children: [
      /* @__PURE__ */ jsx103(EmptyStateMedia, { children: /* @__PURE__ */ jsx103(MdChatBubbleOutline, {}) }),
      /* @__PURE__ */ jsx103(EmptyStateDescription, { children: t("shared.chat.log.empty_state") })
    ] })
  ] });
}
var ConversationMessages = memo6(ConversationMessagesImpl);
ConversationMessages.displayName = "ConversationMessages";

// src/components/composite/Conversations/Conversations.tsx
import { useEffect as useEffect59, useId as useId15, useLayoutEffect as useLayoutEffect16, useRef as useRef88, useState as useState73 } from "react";
import { MdChatBubbleOutline as MdChatBubbleOutline2, MdChevronLeft as MdChevronLeft4, MdErrorOutline, MdRefresh as MdRefresh2 } from "react-icons/md";

// ../channel-branding/dist/brands.js
var CHANNEL_BRANDS = {
  website: {
    label: "Website",
    icon: "mdi:message-text",
    tint: "linear-gradient(135deg, rgba(255, 255, 255, 0.3), transparent 65%), #efa747"
  },
  instagram: {
    label: "Instagram",
    icon: "mdi:instagram",
    tint: "linear-gradient(45deg, #feda75 0%, #fa7e1e 25%, #d62976 50%, #962fbf 75%, #4f5bd5 100%)"
  },
  messenger: {
    label: "Messenger",
    icon: "mdi:facebook-messenger",
    tint: "linear-gradient(135deg, #00b2ff, #006aff)"
  },
  whatsapp: {
    label: "WhatsApp",
    icon: "mdi:whatsapp",
    tint: "linear-gradient(135deg, #65ee99, #0eb75d)"
  },
  sms: {
    label: "SMS",
    icon: "mdi:message-processing",
    tint: "linear-gradient(135deg, #4ade80, #16a34a)"
  },
  email: {
    label: "Email",
    icon: "mdi:email",
    tint: "linear-gradient(135deg, #78c5ff, #2385ec)"
  },
  tiktok: {
    label: "TikTok",
    icon: "logos:tiktok-icon",
    tint: "linear-gradient(135deg, #303030, #010101)"
  },
  shopify: {
    label: "Shopify",
    icon: "mdi:shopify",
    tint: "#95bf47"
  }
};
function isChannelKey(channel) {
  return Object.hasOwn(CHANNEL_BRANDS, channel);
}
function getChannelBrand(channel) {
  return isChannelKey(channel) ? CHANNEL_BRANDS[channel] : void 0;
}
var FALLBACK_CHANNEL_ICON = "ic:outline-forum";
function channelLabel(channel) {
  return getChannelBrand(channel)?.label ?? channel;
}

// ../channel-branding/dist/ChannelBrandIcon.js
import { jsx as _jsx27 } from "react/jsx-runtime";
import { forwardRef as forwardRef56 } from "react";
import { Icon as Icon2 } from "@iconify/react";

// ../channel-branding/dist/icon-data.js
var iconData = {
  "mdi:message-text": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2M6 9h12v2H6m8 3H6v-2h8m4-4H6V6h12"/>'
  },
  "mdi:instagram": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"/>'
  },
  "mdi:facebook-messenger": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17c.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.06.36-.09.53-.06c.9.27 1.9.4 2.9.4c5.64 0 10-4.13 10-9.7S17.64 2 12 2m6 7.46l-2.93 4.67c-.47.73-1.47.92-2.17.37l-2.34-1.73a.6.6 0 0 0-.72 0l-3.16 2.4c-.42.33-.97-.17-.68-.63l2.93-4.67c.47-.73 1.47-.92 2.17-.4l2.34 1.76a.6.6 0 0 0 .72 0l3.16-2.4c.42-.33.97.17.68.63"/>'
  },
  "mdi:whatsapp": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.23 8.23 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23c-1.48 0-2.93-.39-4.19-1.15l-.3-.17l-3.12.82l.83-3.04l-.2-.32a8.2 8.2 0 0 1-1.26-4.38c.01-4.54 3.7-8.24 8.25-8.24M8.53 7.33c-.16 0-.43.06-.66.31c-.22.25-.87.86-.87 2.07c0 1.22.89 2.39 1 2.56c.14.17 1.76 2.67 4.25 3.73c.59.27 1.05.42 1.41.53c.59.19 1.13.16 1.56.1c.48-.07 1.46-.6 1.67-1.18s.21-1.07.15-1.18c-.07-.1-.23-.16-.48-.27c-.25-.14-1.47-.74-1.69-.82c-.23-.08-.37-.12-.56.12c-.16.25-.64.81-.78.97c-.15.17-.29.19-.53.07c-.26-.13-1.06-.39-2-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.12-.24-.01-.39.11-.5c.11-.11.27-.29.37-.44c.13-.14.17-.25.25-.41c.08-.17.04-.31-.02-.43c-.06-.11-.56-1.35-.77-1.84c-.2-.48-.4-.42-.56-.43c-.14 0-.3-.01-.47-.01"/>'
  },
  "mdi:message-processing": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M17 11h-2V9h2m-4 2h-2V9h2m-4 2H7V9h2m11-7H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2"/>'
  },
  "mdi:email": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="m20 8l-8 5l-8-5V6l8 5l8-5m0-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2"/>'
  },
  "mdi:shopify": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M18.61 5.89c-.01-.1-.11-.16-.17-.16c-.07-.01-1.61-.12-1.61-.12s-1.07-1.06-1.18-1.18c-.12-.12-.35-.08-.44-.06c-.01 0-.21.07-.6.18c-.36-1.05-.99-1.97-2.18-1.97c-.32-.4-.71-.58-1.05-.58c-2.58 0-3.81 3.22-4.2 4.86l-1.81.56c-.55.18-.57.2-.64.72c-.06.4-1.52 11.72-1.52 11.72L14.61 22l6.18-1.34S18.62 6 18.61 5.89M14 4.76c-.31.09-.63.19-1 .3v-.21c0-.64-.07-1.15-.21-1.56c.56.07.94.71 1.21 1.47m-1.92-1.34c.16.4.26.97.26 1.74v.11c-.63.19-1.31.41-1.99.62c.38-1.49 1.1-2.2 1.73-2.47m-.77-.73c.11 0 .22.04.33.11c-.83.39-1.71 1.37-2.09 3.32c-.55.18-1.08.34-1.55.5c.42-1.5 1.46-3.93 3.31-3.93m1.19 6.46l-.74 2.27s-.67-.36-1.49-.36c-1.2 0-1.27.75-1.27.94c0 1.04 2.71 1.43 2.71 3.86c0 1.91-1.21 3.14-2.84 3.14c-1.96 0-2.96-1.22-2.96-1.22l.52-1.73s1.03.88 1.9.88c.57 0 .8-.43.8-.77c0-1.35-2.21-1.41-2.21-3.63c0-1.87 1.34-3.68 4.05-3.68c1.03 0 1.53.3 1.53.3m2.93-3.86l1.32 1.31l.96.08c.34 2.32 1.48 10.05 1.95 13.2l-5 1.09l.77-15.68z"/>'
  },
  "ic:outline-forum": {
    width: 24,
    height: 24,
    body: '<path fill="currentColor" d="M15 4v7H5.17L4 12.17V4zm1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1"/>'
  },
  "logos:tiktok-icon": {
    width: 256,
    height: 290,
    body: '<path fill="#ff004f" d="M189.72 104.421c18.678 13.345 41.56 21.197 66.273 21.197v-47.53a67 67 0 0 1-13.918-1.456v37.413c-24.711 0-47.59-7.851-66.272-21.195v96.996c0 48.523-39.356 87.855-87.9 87.855c-18.113 0-34.949-5.473-48.934-14.86c15.962 16.313 38.222 26.432 62.848 26.432c48.548 0 87.905-39.332 87.905-87.857v-96.995zm17.17-47.952c-9.546-10.423-15.814-23.893-17.17-38.785v-6.113h-13.189c3.32 18.927 14.644 35.097 30.358 44.898M69.673 225.607a40 40 0 0 1-8.203-24.33c0-22.192 18.001-40.186 40.21-40.186a40.3 40.3 0 0 1 12.197 1.883v-48.593c-4.61-.631-9.262-.9-13.912-.801v37.822a40.3 40.3 0 0 0-12.203-1.882c-22.208 0-40.208 17.992-40.208 40.187c0 15.694 8.997 29.281 22.119 35.9"/><path d="M175.803 92.849c18.683 13.344 41.56 21.195 66.272 21.195V76.631c-13.794-2.937-26.005-10.141-35.186-20.162c-15.715-9.802-27.038-25.972-30.358-44.898h-34.643v189.843c-.079 22.132-18.049 40.052-40.21 40.052c-13.058 0-24.66-6.221-32.007-15.86c-13.12-6.618-22.118-20.206-22.118-35.898c0-22.193 18-40.187 40.208-40.187c4.255 0 8.356.662 12.203 1.882v-37.822c-47.692.985-86.047 39.933-86.047 87.834c0 23.912 9.551 45.589 25.053 61.428c13.985 9.385 30.82 14.86 48.934 14.86c48.545 0 87.9-39.335 87.9-87.857z"/><path fill="#00f2ea" d="M242.075 76.63V66.516a66.3 66.3 0 0 1-35.186-10.047a66.47 66.47 0 0 0 35.186 20.163M176.53 11.57a68 68 0 0 1-.728-5.457V0h-47.834v189.845c-.076 22.13-18.046 40.05-40.208 40.05a40.06 40.06 0 0 1-18.09-4.287c7.347 9.637 18.949 15.857 32.007 15.857c22.16 0 40.132-17.918 40.21-40.05V11.571zM99.966 113.58v-10.769a89 89 0 0 0-12.061-.818C39.355 101.993 0 141.327 0 189.845c0 30.419 15.467 57.227 38.971 72.996c-15.502-15.838-25.053-37.516-25.053-61.427c0-47.9 38.354-86.848 86.048-87.833"/>'
  }
};
var icon_data_default = iconData;

// ../channel-branding/dist/ChannelBrandIcon.js
var glyphs = icon_data_default;
var GLYPH_SCALE = { rounded: "77.083333%", circle: "62.5%" };
var ChannelBrandIcon = forwardRef56(function ChannelBrandIcon2({ channel, size: size5 = 40, shape = "rounded", className, style, ...rest }, ref) {
  const brand = getChannelBrand(channel);
  const roundedRadius = brand ? "30%" : "var(--radius-lg, 10px)";
  const tileStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: size5,
    height: size5,
    borderRadius: shape === "circle" ? "50%" : roundedRadius,
    background: brand?.tint ?? "var(--bs-lg-fill-3, var(--bs-bg-hover, color-mix(in srgb, currentColor 8%, transparent)))",
    color: brand ? "#fff" : "var(--bs-lg-ink, var(--bs-text-secondary, inherit))",
    ...style
  };
  return _jsx27("span", { ref, className, style: tileStyle, "aria-hidden": "true", ...rest, children: _jsx27(Icon2, { icon: glyphs[brand?.icon ?? FALLBACK_CHANNEL_ICON], ssr: true, fill: "currentColor", width: GLYPH_SCALE[shape], height: GLYPH_SCALE[shape], style: { display: "block", flexShrink: 0 } }) });
});
ChannelBrandIcon.displayName = "ChannelBrandIcon";

// src/utils/onAccentColor.ts
var BLACK = "#000";
var WHITE = "#FFF";
var BRAND_ACCENT = "FFC000";
function channelLuminance(value) {
  const srgb = value / 255;
  return srgb <= 0.04045 ? srgb / 12.92 : ((srgb + 0.055) / 1.055) ** 2.4;
}
function hexDigits(color) {
  const digits = color.trim().replace(/^#/, "").toUpperCase();
  if (/^[0-9A-F]{3}$/.test(digits)) return [...digits].map((digit) => digit + digit).join("");
  return /^[0-9A-F]{6}$/.test(digits) ? digits : void 0;
}
function onAccentColor(accent) {
  const digits = accent ? hexDigits(accent) : void 0;
  if (!digits || digits === BRAND_ACCENT) return WHITE;
  const value = Number.parseInt(digits, 16);
  const luminance = 0.2126 * channelLuminance(value >> 16 & 255) + 0.7152 * channelLuminance(value >> 8 & 255) + 0.0722 * channelLuminance(value & 255);
  const againstWhite = 1.05 / (luminance + 0.05);
  const againstBlack = (luminance + 0.05) / 0.05;
  return againstBlack > againstWhite ? BLACK : WHITE;
}

// src/components/composite/Pagination/Pagination.tsx
import { MdChevronLeft as MdChevronLeft3, MdChevronRight as MdChevronRight4 } from "react-icons/md";
import { jsx as jsx104, jsxs as jsxs62 } from "react/jsx-runtime";
function Pagination({ ref, page, pageCount, onPageChange, disabled: disabled2 = false, labels, className = "", style, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, ...props }) {
  if (pageCount < 1) return null;
  const currentPage = Math.max(1, Math.min(pageCount, page));
  const start = Math.max(1, Math.min(pageCount - 2, currentPage - 1));
  const pages = Array.from({ length: Math.min(pageCount, 3) }, (_, index2) => start + index2);
  const ariaDisabled = disabled2 || void 0;
  const goTo = (target) => {
    if (!disabled2) onPageChange(target);
  };
  return /* @__PURE__ */ jsxs62("nav", { ...props, ref, style: { ...style, "--buyscout-pagination-digits": String(pageCount).length }, className: ["buyscout-pagination", className].filter(Boolean).join(" "), "aria-label": ariaLabel ?? (ariaLabelledBy ? void 0 : "Pagination"), "aria-labelledby": ariaLabelledBy, children: [
    /* @__PURE__ */ jsx104("button", { type: "button", "aria-label": labels?.previous ?? "Previous page", disabled: currentPage === 1, "aria-disabled": currentPage === 1 ? void 0 : ariaDisabled, onClick: () => goTo(currentPage - 1), children: /* @__PURE__ */ jsx104(MdChevronLeft3, { "aria-hidden": true }) }),
    pages.map((value) => /* @__PURE__ */ jsx104("button", { type: "button", className: "buyscout-pagination__page", "aria-label": labels?.page?.(value) ?? `Page ${value}`, "aria-current": value === currentPage ? "page" : void 0, "aria-disabled": ariaDisabled, onClick: () => goTo(value), children: value }, value)),
    /* @__PURE__ */ jsx104("button", { type: "button", "aria-label": labels?.next ?? "Next page", disabled: currentPage === pageCount, "aria-disabled": currentPage === pageCount ? void 0 : ariaDisabled, onClick: () => goTo(currentPage + 1), children: /* @__PURE__ */ jsx104(MdChevronRight4, { "aria-hidden": true }) })
  ] });
}
Pagination.displayName = "Pagination";

// src/components/composite/Conversations/EmailThread.tsx
import { useId as useId14, useState as useState72 } from "react";
import { MdExpandMore } from "react-icons/md";
import { Fragment as Fragment28, jsx as jsx105, jsxs as jsxs63 } from "react/jsx-runtime";
function mailboxLabel({ address, name: name2 }) {
  return name2 ? `${name2} <${address}>` : address;
}
function EmailAddress({ label, copyLabel, mailbox }) {
  return /* @__PURE__ */ jsxs63("div", { className: "email-address-row", children: [
    /* @__PURE__ */ jsx105("dt", { children: label }),
    /* @__PURE__ */ jsxs63("dd", { children: [
      /* @__PURE__ */ jsx105("span", { className: "email-address-value", children: mailboxLabel(mailbox) }),
      /* @__PURE__ */ jsx105(CopyButton, { variant: "borderless", size: "xs", value: mailbox.address, "aria-label": copyLabel })
    ] })
  ] });
}
EmailAddress.displayName = "EmailAddress";
function EmailMessage({ message, name: name2, initiallyOpen, storeAvatarUrl }) {
  const { t, i18n } = useConversationsTranslation();
  const [open2, setOpen] = useState72(initiallyOpen);
  const [showHtml, setShowHtml] = useState72(false);
  const bodyId = useId14();
  const email = message.email;
  const isMerchantReply = message.role === "assistant" && message.sentBy === "human";
  const from = email?.fromAddress ? { address: email.fromAddress, name: email.fromName } : void 0;
  const to = email?.to ?? [];
  const cc = email?.cc ?? [];
  const replyTo = email?.replyTo && email.replyTo.address !== email.fromAddress ? email.replyTo : void 0;
  const sender = email?.fromName || email?.fromAddress || (message.role === "user" ? name2 : message.sentBy === "human" ? t("shared.chat.log.sent_by_you") : t("shared.chat.log.sent_by_system"));
  return /* @__PURE__ */ jsxs63("article", { className: "email-message", "data-merchant-reply": isMerchantReply || void 0, children: [
    /* @__PURE__ */ jsxs63("button", { type: "button", className: "email-message-toggle", "aria-expanded": open2, "aria-controls": bodyId, onClick: () => setOpen(!open2), children: [
      /* @__PURE__ */ jsx105(Avatar2, { className: "email-avatar", tone: "neutral", fit: "contain", src: isMerchantReply ? storeAvatarUrl?.trim() || void 0 : void 0, alt: "", fallback: getInitials(sender, i18n.resolvedLanguage || i18n.language), "aria-hidden": "true" }),
      /* @__PURE__ */ jsxs63("span", { className: "email-message-summary", children: [
        /* @__PURE__ */ jsxs63("span", { className: "email-message-topline", children: [
          /* @__PURE__ */ jsx105("span", { className: "email-message-sender", children: sender }),
          /* @__PURE__ */ jsx105("time", { dateTime: message.createdAt, children: formatConversationDate(message.createdAt, i18n.resolvedLanguage || i18n.language) })
        ] }),
        !open2 && /* @__PURE__ */ jsx105("span", { className: "email-message-preview", children: message.content })
      ] }),
      /* @__PURE__ */ jsx105(MdExpandMore, { className: "email-chevron", "aria-hidden": "true" })
    ] }),
    /* @__PURE__ */ jsx105("div", { id: bodyId, hidden: !open2, className: "email-message-body", children: open2 && /* @__PURE__ */ jsxs63(Fragment28, { children: [
      (from || to.length > 0) && /* @__PURE__ */ jsxs63("details", { className: "email-addressing", children: [
        /* @__PURE__ */ jsxs63("summary", { children: [
          /* @__PURE__ */ jsx105("span", { children: to.length > 0 ? t("shared.chat.email.to_address", { address: to.map(mailboxLabel).join(", ") }) : t("shared.chat.email.addresses") }),
          /* @__PURE__ */ jsxs63("span", { className: "email-details-label", children: [
            t("shared.chat.email.details"),
            " ",
            /* @__PURE__ */ jsx105(MdExpandMore, { "aria-hidden": "true" })
          ] })
        ] }),
        /* @__PURE__ */ jsxs63("dl", { className: "email-address-list", children: [
          email?.subject && /* @__PURE__ */ jsxs63("div", { className: "email-address-row", children: [
            /* @__PURE__ */ jsx105("dt", { children: t("shared.chat.email.subject") }),
            /* @__PURE__ */ jsx105("dd", { children: /* @__PURE__ */ jsx105("span", { className: "email-address-value", children: email.subject }) })
          ] }),
          from && /* @__PURE__ */ jsx105(EmailAddress, { label: t("shared.chat.email.from"), copyLabel: t("shared.chat.email.copy_from", { address: from.address }), mailbox: from }),
          replyTo && /* @__PURE__ */ jsx105(EmailAddress, { label: t("shared.chat.email.reply_to"), copyLabel: t("shared.chat.email.copy_reply_to", { address: replyTo.address }), mailbox: replyTo }),
          to.map((mailbox) => /* @__PURE__ */ jsx105(EmailAddress, { label: t("shared.chat.email.to"), copyLabel: t("shared.chat.email.copy_to", { address: mailbox.address }), mailbox }, `to-${mailbox.address}`)),
          cc.map((mailbox) => /* @__PURE__ */ jsx105(EmailAddress, { label: t("shared.chat.email.cc"), copyLabel: t("shared.chat.email.copy_cc", { address: mailbox.address }), mailbox }, `cc-${mailbox.address}`))
        ] })
      ] }),
      email?.htmlTooLarge && /* @__PURE__ */ jsx105("p", { className: "email-html-dropped", children: t("shared.chat.email.html_too_large") }),
      email?.html && /* @__PURE__ */ jsx105(Button, { size: "sm", variant: "borderless", color: "neutral", onClick: () => setShowHtml(!showHtml), children: showHtml ? t("shared.chat.email.show_plain_text") : t("shared.chat.email.show_html") }),
      showHtml && email?.html ? /* @__PURE__ */ jsx105(
        "iframe",
        {
          title: t("shared.chat.email.html_title", { sender }),
          sandbox: "",
          referrerPolicy: "no-referrer",
          srcDoc: `<meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data:">${email.html}`,
          className: "email-html-body"
        }
      ) : /* @__PURE__ */ jsx105("p", { className: "email-message-text", children: message.content }),
      email?.quoted && /* @__PURE__ */ jsxs63("details", { className: "email-history", children: [
        /* @__PURE__ */ jsx105("summary", { children: t("shared.chat.email.quoted_history") }),
        /* @__PURE__ */ jsx105("pre", { className: "email-history-body", children: email.quoted })
      ] }),
      !!message.attachments?.length && /* @__PURE__ */ jsx105(MessageAttachments, { attachments: message.attachments })
    ] }) })
  ] });
}
function EmailThread({ session, name: name2, storeAvatarUrl }) {
  const { t } = useConversationsTranslation();
  const subject = session.subject || t("shared.chat.email.untitled");
  return /* @__PURE__ */ jsxs63("section", { className: "email-thread", "aria-label": subject, children: [
    /* @__PURE__ */ jsxs63("header", { className: "email-thread-heading", children: [
      /* @__PURE__ */ jsx105("h2", { children: subject }),
      /* @__PURE__ */ jsx105("span", { className: "bs-conversations__meta", children: t("shared.chat.content.message_count", { count: session.chatMessage.length }) })
    ] }),
    /* @__PURE__ */ jsx105("div", { className: "email-messages", children: session.chatMessage.map((message, index2) => /* @__PURE__ */ jsx105(EmailMessage, { message, name: name2, storeAvatarUrl, initiallyOpen: index2 === session.chatMessage.length - 1 }, message.id)) })
  ] });
}
EmailThread.displayName = "EmailThread";

// src/components/composite/Conversations/Conversations.tsx
import { Fragment as Fragment29, jsx as jsx106, jsxs as jsxs64 } from "react/jsx-runtime";
function AnchorLink({ href, children }) {
  return /* @__PURE__ */ jsx106("a", { href, children });
}
var ROW_TITLE_WIDTHS = ["56%", "44%", "64%", "50%"];
var ROW_META_WIDTHS = ["72%", "60%", "80%", "66%"];
var hexColor = (color) => color && /^#[\da-f]{6}$/i.test(color) ? color : void 0;
var storeAccentStyle = (color) => ({ "--bs-conversations-store-color": color, "--bs-conversations-on-store-color": onAccentColor(color) });
function Conversations({ groupedChatSessions = [], loading = false, error: error2, onRetry, pagination, onFetchChatSessions, searchValue, onSearchValueChange, channels, channel = "all", onChannelChange, engagedOnly, onEngagedChange, highlightedSessionId, showTokenUsage = false, showSessionId = true, storeID, storeAvatarUrl, storeColor, customDomain, onDeleteSession, onToolClick, getUserHref, UserLink = AnchorLink, onSendChannelMessage, onResumeAi, onUploadChannelAttachment, className = "", filterSlot, renderSessionExtra }) {
  const { t, i18n } = useConversationsTranslation();
  const locale = i18n.resolvedLanguage || i18n.language;
  const anonymous = { visitor: t("shared.chat.anonymous_visitor"), user: t("shared.chat.anonymous_user") };
  const genericChannelNames = { website: t("shared.chat.channel.website"), email: t("shared.chat.channel.email"), sms: t("shared.chat.channel.sms") };
  const channelName = (value) => genericChannelNames[value] ?? channelLabel(value);
  const tokens = (value) => t("shared.chat.token_usage.tokens", { count: value, value: value.toLocaleString(locale) });
  const engagedId = useId15();
  const [localSearch, setLocalSearch] = useState73("");
  const [selectedKey, setSelectedKey] = useState73(null);
  const [threadOpen, setThreadOpen] = useState73(false);
  const [drafts, setDrafts] = useState73({});
  const listRef = useRef88(null);
  const readerScrollRef = useRef88(null);
  const backRef = useRef88(null);
  const searchRef = useRef88(null);
  const triggerRef = useRef88(null);
  const sessionRefs = useRef88(/* @__PURE__ */ new Map());
  const query = searchValue ?? localSearch;
  const groups = groupedChatSessions.filter((group) => matchesConversation(group, query, anonymous) && (channel === "all" || conversationChannel(group) === channel));
  const [lastShown, setLastShown] = useState73(6);
  if (!loading && groups.length > 0 && groups.length !== lastShown) setLastShown(groups.length);
  const selected = groups.find((group) => conversationKey(group) === selectedKey);
  const key = selected ? conversationKey(selected) : null;
  const selectedChannel = selected ? conversationChannel(selected) : void 0;
  const capabilities = selected?.capabilities;
  const replyId = selected && "userIdentifier" in selected ? selected.replySessionId : void 0;
  const draftKey = JSON.stringify([storeID, key, replyId]);
  const canReply = Boolean(capabilities?.reply && replyId && onSendChannelMessage);
  const canDelete = !!onDeleteSession && capabilities?.deleteSession !== false;
  const showGroupSessionId = showSessionId && capabilities?.showSessionId !== false;
  const replySession = selected?.sessions.find((session) => session.id === replyId);
  const replyAddress = selected && "userIdentifier" in selected ? selected.replyAddress || void 0 : void 0;
  const userId = selected && !("visitorID" in selected) ? selected.userIdentifier : null;
  const name2 = selected ? conversationName(selected, anonymous) : "";
  const messageCount = selected?.sessions.reduce((count2, session) => count2 + session.chatMessage.length, 0) ?? 0;
  const usage = selected && showTokenUsage ? totalTokenUsage(selected) : void 0;
  useEffect59(() => {
    if (!highlightedSessionId) return;
    const match = groupedChatSessions.find((group) => group.sessions.some((session) => session.id.includes(highlightedSessionId)));
    if (match) {
      setSelectedKey(conversationKey(match));
      setThreadOpen(true);
    }
  }, [highlightedSessionId, groupedChatSessions]);
  useLayoutEffect16(() => {
    if (threadOpen && selected && listRef.current && getComputedStyle(listRef.current).display === "none") backRef.current?.focus({ preventScroll: true });
    else if (!threadOpen && triggerRef.current?.isConnected) triggerRef.current.focus({ preventScroll: true });
  }, [threadOpen, key]);
  useLayoutEffect16(() => {
    const scroll = readerScrollRef.current;
    if (!threadOpen || !key || !scroll) return;
    const sections = Array.from(sessionRefs.current.values());
    const highlighted = highlightedSessionId && sections.find((section) => section.dataset.sessionId?.includes(highlightedSessionId));
    const firstSession = scroll.querySelector(".bs-conversations__session");
    const expandedEmail = firstSession?.querySelector('.email-message:has([aria-expanded="true"])');
    const target = highlighted || expandedEmail || firstSession;
    const padding = Number.parseFloat(getComputedStyle(scroll).paddingTop) || 0;
    scroll.scrollTop = target ? Math.max(0, scroll.scrollTop + target.getBoundingClientRect().top - scroll.getBoundingClientRect().top - padding) : 0;
  }, [highlightedSessionId, key, threadOpen]);
  const search = (value) => {
    setLocalSearch(value);
    onSearchValueChange?.(value);
    setThreadOpen(false);
    triggerRef.current = null;
  };
  const filtered = query.trim() !== "" || channel !== "all";
  const clearFilters = () => {
    search("");
    if (channel !== "all") onChannelChange?.("all");
    searchRef.current?.focus();
  };
  const sortedSessions = selected ? [...selected.sessions].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt)) : [];
  const transcriptAccent = hexColor(storeColor);
  return /* @__PURE__ */ jsx106("div", { className: `bs-conversations ${className}`, children: /* @__PURE__ */ jsxs64("div", { className: "bs-conversations__layout", "data-thread-open": threadOpen && !!selected, children: [
    /* @__PURE__ */ jsxs64("div", { className: "bs-conversations__inbox", ref: listRef, children: [
      /* @__PURE__ */ jsx106("div", { className: "bs-conversations__search", children: /* @__PURE__ */ jsx106(TextField, { ref: searchRef, type: "search", size: "sm", startIcon: "search", fullWidth: true, "aria-label": t("shared.chat.search"), placeholder: t("shared.chat.search"), value: query, onChange: (event) => search(event.target.value) }) }),
      /* @__PURE__ */ jsxs64("div", { className: "bs-conversations__filters", children: [
        channels && /* @__PURE__ */ jsxs64(
          Select,
          {
            value: channel,
            onValueChange: (value) => {
              triggerRef.current = null;
              setThreadOpen(false);
              onChannelChange?.(value);
            },
            children: [
              /* @__PURE__ */ jsxs64(SelectTrigger, { size: "sm", variant: "subtle", "aria-label": t("shared.chat.filter.channel"), className: "bs-conversations__channel-filter", children: [
                /* @__PURE__ */ jsx106(MdChatBubbleOutline2, { "aria-hidden": true, className: "bs-conversations__filter-icon" }),
                /* @__PURE__ */ jsx106(SelectValue, { placeholder: t("shared.chat.filter.all") })
              ] }),
              /* @__PURE__ */ jsxs64(SelectContent, { children: [
                /* @__PURE__ */ jsx106(SelectItem, { value: "all", children: t("shared.chat.filter.all") }),
                channels.map((value) => /* @__PURE__ */ jsx106(SelectItem, { value, children: channelName(value) }, value))
              ] })
            ]
          }
        ),
        engagedOnly !== void 0 && onEngagedChange && /* @__PURE__ */ jsxs64("label", { htmlFor: engagedId, className: "bs-conversations__engaged", children: [
          /* @__PURE__ */ jsx106(Switch2, { id: engagedId, checked: engagedOnly, onCheckedChange: onEngagedChange, "aria-label": t("shared.chat.filter.engaged"), size: "sm" }),
          t("shared.chat.filter.engaged")
        ] }),
        filterSlot
      ] }),
      /* @__PURE__ */ jsx106("div", { className: "bs-conversations__list", "aria-label": t("shared.chat.list_label"), "aria-busy": loading, children: error2 ? /* @__PURE__ */ jsxs64(EmptyState, { variant: "plain", role: "alert", children: [
        /* @__PURE__ */ jsx106(EmptyStateMedia, { children: /* @__PURE__ */ jsx106(MdErrorOutline, {}) }),
        /* @__PURE__ */ jsx106(EmptyStateTitle, { role: "heading", "aria-level": 2, children: error2 }),
        onRetry && /* @__PURE__ */ jsxs64(Fragment29, { children: [
          /* @__PURE__ */ jsx106(EmptyStateDescription, { children: t("shared.chat.retry_hint") }),
          /* @__PURE__ */ jsx106(EmptyStateActions, { children: /* @__PURE__ */ jsxs64(Button, { size: "sm", variant: "outlined", color: "neutral", loading, onClick: onRetry, children: [
            /* @__PURE__ */ jsx106("span", { className: "buyscout-btn__icon-start", children: /* @__PURE__ */ jsx106(MdRefresh2, { "aria-hidden": "true" }) }),
            t(loading ? "shared.chat.retrying" : "shared.chat.retry")
          ] }) })
        ] })
      ] }) : loading && !groups.length ? Array.from({ length: lastShown }, (_, i) => /* @__PURE__ */ jsxs64("div", { className: "bs-conversations__row bs-conversations__row--placeholder", "aria-hidden": "true", children: [
        /* @__PURE__ */ jsx106(Skeleton, { variant: "circle", width: 40, height: 40 }),
        /* @__PURE__ */ jsxs64("span", { className: "bs-conversations__summary", children: [
          /* @__PURE__ */ jsx106("span", { className: "bs-conversations__row-title", children: /* @__PURE__ */ jsx106(Skeleton, { width: ROW_TITLE_WIDTHS[i % ROW_TITLE_WIDTHS.length] }) }),
          /* @__PURE__ */ jsx106("span", { className: "bs-conversations__meta", children: /* @__PURE__ */ jsx106(Skeleton, { width: ROW_META_WIDTHS[i % ROW_META_WIDTHS.length] }) })
        ] })
      ] }, i)) : groups.length ? groups.map((group) => {
        const groupKey = conversationKey(group);
        const sessions = [...group.sessions].sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt));
        const latest = sessions[0];
        const email = conversationChannel(group) === "email";
        return /* @__PURE__ */ jsxs64(
          "button",
          {
            type: "button",
            className: "bs-conversations__row",
            "aria-current": groupKey === key ? "true" : void 0,
            onClick: (event) => {
              triggerRef.current = event.currentTarget;
              setSelectedKey(groupKey);
              setThreadOpen(true);
            },
            children: [
              /* @__PURE__ */ jsx106("span", { className: "bs-conversations__avatar", children: /* @__PURE__ */ jsx106(ChannelBrandIcon, { channel: conversationChannel(group), size: 40, shape: "circle" }) }),
              /* @__PURE__ */ jsxs64("span", { className: "bs-conversations__summary", children: [
                /* @__PURE__ */ jsx106("span", { className: "bs-conversations__row-title", children: conversationName(group, anonymous) }),
                email ? /* @__PURE__ */ jsx106("span", { className: "bs-conversations__subject", children: latest?.subject || t("shared.chat.email.untitled") }) : /* @__PURE__ */ jsxs64("span", { className: "bs-conversations__meta", children: [
                  t("shared.chat.content.session_count", { count: group.sessionCount }),
                  " \xB7 ",
                  t("shared.chat.content.last_active", { date: formatConversationDay(group.lastActivityAt ?? latest?.createdAt, locale) })
                ] })
              ] }),
              /* @__PURE__ */ jsx106("span", { className: "bs-conversations__count", "aria-hidden": "true", children: group.sessionCount })
            ]
          },
          groupKey
        );
      }) : filtered ? /* @__PURE__ */ jsxs64(EmptyState, { variant: "plain", children: [
        /* @__PURE__ */ jsx106(EmptyStateDescription, { children: t("shared.chat.empty_filtered") }),
        /* @__PURE__ */ jsx106(EmptyStateActions, { children: /* @__PURE__ */ jsx106(Button, { size: "sm", variant: "outlined", color: "neutral", onClick: clearFilters, children: t("shared.chat.clear_filters") }) })
      ] }) : /* @__PURE__ */ jsx106(EmptyState, { variant: "plain", children: /* @__PURE__ */ jsx106(EmptyStateDescription, { children: t("shared.chat.empty_state") }) }) }),
      pagination && pagination.total > 0 && /* @__PURE__ */ jsxs64("div", { className: "bs-conversations__footer", children: [
        loading ? /* @__PURE__ */ jsx106("span", { className: "bs-conversations__range", children: /* @__PURE__ */ jsx106(Skeleton, { inline: true, width: "9em" }) }) : /* @__PURE__ */ jsx106("span", { className: "bs-conversations__range", children: t("shared.chat.pagination.summary", { shown: groups.length.toLocaleString(locale), total: pagination.total.toLocaleString(locale) }) }),
        pagination.pageCount > 1 && /* @__PURE__ */ jsx106(Pagination, { "aria-label": t("shared.chat.pagination.label"), labels: { previous: t("shared.chat.pagination.previous"), next: t("shared.chat.pagination.next"), page: (page) => t("shared.chat.pagination.page", { page }) }, className: "bs-conversations__pagination", page: pagination.page, pageCount: pagination.pageCount, disabled: loading, onPageChange: (page) => onFetchChatSessions?.({ page, per: pagination.per }) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs64("div", { className: "bs-conversations__reader", children: [
      /* @__PURE__ */ jsxs64(Button, { ref: backRef, size: "sm", variant: "borderless", color: "neutral", className: "bs-conversations__back", onClick: () => setThreadOpen(false), children: [
        /* @__PURE__ */ jsx106("span", { className: "buyscout-btn__icon-start", children: /* @__PURE__ */ jsx106(MdChevronLeft4, { "aria-hidden": true }) }),
        t("shared.chat.back_to_inbox")
      ] }),
      selected ? /* @__PURE__ */ jsxs64(Fragment29, { children: [
        /* @__PURE__ */ jsxs64("header", { className: "bs-conversations__header", children: [
          /* @__PURE__ */ jsxs64("div", { children: [
            /* @__PURE__ */ jsx106("h2", { children: getUserHref && userId ? /* @__PURE__ */ jsx106(UserLink, { href: getUserHref(userId), children: name2 }) : name2 }),
            /* @__PURE__ */ jsxs64("span", { className: "bs-conversations__meta", children: [
              channelName(selectedChannel ?? ""),
              " \xB7 ",
              selectedChannel === "email" ? t("shared.chat.content.thread_count", { count: selected.sessionCount }) : t("shared.chat.content.session_count", { count: selected.sessionCount }),
              selectedChannel !== "email" && /* @__PURE__ */ jsxs64(Fragment29, { children: [
                " \xB7 ",
                t("shared.chat.content.message_count", { count: messageCount })
              ] })
            ] })
          ] }),
          usage?.totalTokens !== void 0 && /* @__PURE__ */ jsx106(Tooltip, { title: tokenUsageText(usage, t, locale), children: /* @__PURE__ */ jsx106(Button, { size: "sm", variant: "borderless", color: "neutral", children: tokens(usage.totalTokens) }) })
        ] }),
        /* @__PURE__ */ jsx106("div", { className: "bs-conversations__scroll-frame", children: /* @__PURE__ */ jsx106("div", { ref: readerScrollRef, className: "bs-conversations__sessions", children: sortedSessions.map((session, index2) => {
          const sessionUsage = showTokenUsage ? totalTokenUsage({ ...selected, sessions: [session] }) : void 0;
          const domain2 = customDomain || "customDomain" in session && session.customDomain || storeID || ("shopifyStoreID" in session && session.shopifyStoreID || "storeID" in session && session.storeID) || void 0;
          const showSessionHeading = selectedChannel !== "email" || sortedSessions.length > 1 || showGroupSessionId || canDelete;
          const accent = hexColor(session.storeColor) ?? transcriptAccent;
          return /* @__PURE__ */ jsxs64(
            "section",
            {
              ref: (element2) => {
                if (element2) sessionRefs.current.set(session.id, element2);
                else sessionRefs.current.delete(session.id);
              },
              className: "bs-conversations__session",
              "data-session-id": session.id,
              "data-highlighted": !!highlightedSessionId && session.id.includes(highlightedSessionId),
              "data-store-color": accent ? "" : void 0,
              style: accent ? storeAccentStyle(accent) : void 0,
              children: [
                showSessionHeading && /* @__PURE__ */ jsxs64("div", { className: "bs-conversations__session-heading", children: [
                  /* @__PURE__ */ jsxs64("div", { children: [
                    /* @__PURE__ */ jsxs64("strong", { children: [
                      t(selectedChannel === "email" ? "shared.chat.content.thread_number" : "shared.chat.content.session_number", { number: selected.sessionCount - index2 }),
                      showGroupSessionId && /* @__PURE__ */ jsxs64("span", { className: "bs-conversations__session-id", children: [
                        " (",
                        session.id,
                        ")"
                      ] }),
                      selectedChannel !== "email" && /* @__PURE__ */ jsxs64(Fragment29, { children: [
                        " \xB7 ",
                        t("shared.chat.content.message_count", { count: session.chatMessage.length })
                      ] })
                    ] }),
                    /* @__PURE__ */ jsx106("span", { className: "bs-conversations__meta", children: t("shared.chat.content.session_started", { date: formatConversationDate(session.createdAt, locale) }) }),
                    selected.retainedHistory && /* @__PURE__ */ jsx106("span", { className: "bs-conversations__meta", children: t("shared.chat.content.recent_messages_only") }),
                    "customerEmail" in session && session.customerEmail && /* @__PURE__ */ jsx106("span", { className: "bs-conversations__meta", children: t("shared.chat.content.customer_email", { email: session.customerEmail }) }),
                    "customerID" in session && session.customerID && /* @__PURE__ */ jsx106("span", { className: "bs-conversations__meta", children: t("shared.chat.content.customer_id", { id: session.customerID }) })
                  ] }),
                  (sessionUsage?.totalTokens !== void 0 || canDelete) && /* @__PURE__ */ jsxs64("div", { className: "bs-conversations__session-actions", children: [
                    sessionUsage?.totalTokens !== void 0 && /* @__PURE__ */ jsx106(Tooltip, { title: tokenUsageText(sessionUsage, t, locale), children: /* @__PURE__ */ jsx106(Button, { size: "sm", variant: "borderless", color: "neutral", children: tokens(sessionUsage.totalTokens) }) }),
                    canDelete && onDeleteSession && /* @__PURE__ */ jsx106(Button, { size: "sm", variant: "tinted", color: "error", "aria-label": t("shared.chat.content.delete_session"), onClick: () => onDeleteSession(session.id), children: t("shared.chat.content.delete") })
                  ] })
                ] }),
                !showSessionHeading && selected.retainedHistory && /* @__PURE__ */ jsx106("p", { className: "bs-conversations__retention", children: t("shared.chat.content.recent_messages_only") }),
                selectedChannel === "email" ? /* @__PURE__ */ jsx106(EmailThread, { session, name: name2, storeAvatarUrl }, session.id) : /* @__PURE__ */ jsx106("div", { className: "bs-conversations__session-log", children: /* @__PURE__ */ jsx106(ConversationMessages, { activeChatSession: session, loading, showTokenUsage, storeDomain: storeOrigin(domain2), onToolClick }) }),
                renderSessionExtra?.(session.id, selectedChannel ?? "")
              ]
            },
            session.id
          );
        }) }, key) }),
        canReply && replyId && onSendChannelMessage && /* @__PURE__ */ jsx106(ConversationComposer_default, { draft: drafts[draftKey] ?? createComposerDraft(), onDraftChange: (update2) => setDrafts((current) => ({ ...current, [draftKey]: typeof update2 === "function" ? update2(current[draftKey] ?? createComposerDraft()) : update2 })), emailReply: selectedChannel === "email" ? { recipient: replyAddress, subject: replySession?.subject, showSubject: selected.sessionCount > 1 } : void 0, aiPaused: "aiPaused" in selected && selected.aiPaused === true, onSend: (text4, ids) => onSendChannelMessage(replyId, text4, ids), onResumeAi: capabilities?.resumeAi && onResumeAi ? () => onResumeAi(replyId) : void 0, attachmentPolicy: capabilities?.attachmentPolicy, onUploadAttachment: capabilities?.attachmentPolicy && onUploadChannelAttachment ? (file) => onUploadChannelAttachment(replyId, file) : void 0 }, draftKey)
      ] }) : /* @__PURE__ */ jsx106(EmptyState, { variant: "plain", className: "bs-conversations__placeholder", "aria-busy": loading, children: /* @__PURE__ */ jsx106(EmptyStateDescription, { role: "status", children: loading ? t("loadingState.loading") : t("shared.chat.empty_prompt") }) })
    ] })
  ] }) });
}
Conversations.displayName = "Conversations";

// src/components/composite/Conversations/types.ts
var AIScenario = /* @__PURE__ */ ((AIScenario2) => {
  AIScenario2["ShopifyChatGeneral"] = "ShopifyChatGeneral";
  AIScenario2["ShopifyChatProduct"] = "ShopifyChatProduct";
  AIScenario2["ShopifyStoreTemplateSummary"] = "ShopifyStoreTemplateSummary";
  return AIScenario2;
})(AIScenario || {});

// src/components/composite/LiveAnnouncer/Announcer.tsx
import { useSyncExternalStore as useSyncExternalStore4 } from "react";

// src/components/composite/LiveAnnouncer/LiveAnnouncer.tsx
import { jsx as jsx107 } from "react/jsx-runtime";
function LiveRegion({ message }) {
  return /* @__PURE__ */ jsx107("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: "buyscout-live-region", children: message });
}
LiveRegion.displayName = "LiveRegion";

// src/components/composite/LiveAnnouncer/Announcer.tsx
import { jsx as jsx108 } from "react/jsx-runtime";
function Announcer() {
  const message = useSyncExternalStore4(subscribeAnnouncement, getAnnouncement, () => "");
  return /* @__PURE__ */ jsx108(LiveRegion, { message });
}
Announcer.displayName = "Announcer";

// src/components/composite/LiveAnnouncer/useLiveAnnouncer.ts
import { createContext as createContext27, use as use7, useEffect as useEffect60, useMemo as useMemo33, useState as useState74, useSyncExternalStore as useSyncExternalStore5 } from "react";
function useLiveAnnouncer() {
  const [store] = useState74(createAnnouncerStore);
  const message = useSyncExternalStore5(store.subscribe, store.getMessage, store.getMessage);
  useEffect60(() => store.clear, [store]);
  return useMemo33(() => ({ message, announce: store.announce, clear: store.clear }), [message, store]);
}
var LiveAnnouncerContext = createContext27(() => {
});

// src/components/composite/MarkdownContent/MarkdownContent.tsx
import { jsx as jsx109 } from "react/jsx-runtime";
function MarkdownContent({ children, className }) {
  return /* @__PURE__ */ jsx109("div", { className: clsx_default("buyscout-markdown", className), children: /* @__PURE__ */ jsx109(
    Markdown,
    {
      remarkPlugins: [remarkGfm, remarkBreaks],
      components: {
        a: ({ node: _node, children: children2, ...props }) => /* @__PURE__ */ jsx109(Link, { ...props, target: "_blank", rel: "noopener noreferrer", children: children2 }),
        table: ({ node: _node, children: children2 }) => /* @__PURE__ */ jsx109(TableWrapper, { children: children2 })
      },
      children
    }
  ) });
}

// src/components/composite/MerchantAgentChat/MerchantAgentActionCard.tsx
import { useEffect as useEffect61, useId as useId16, useRef as useRef89 } from "react";

// src/components/composite/MerchantAgentChat/MerchantAgentChangeTable.tsx
import { useState as useState75 } from "react";
import { jsx as jsx110, jsxs as jsxs65 } from "react/jsx-runtime";
var ABSENT = "\u2014";
var UNBROKEN_RUN = /\S{21}/;
function unbrokenRun(value) {
  return value !== void 0 && UNBROKEN_RUN.test(value) || void 0;
}
function unbrokenValue(text4, parts) {
  if (!parts) return unbrokenRun(text4);
  return parts.some((part) => [part.value].flat().some((value) => unbrokenRun(value))) || void 0;
}
function PreviewValue({ text: text4, parts }) {
  if (!parts) return text4 ?? ABSENT;
  if (parts.length === 0) return ABSENT;
  return /* @__PURE__ */ jsx110("dl", { className: "bs-merchant-agent-action__parts", children: parts.map((part) => /* @__PURE__ */ jsxs65("div", { children: [
    /* @__PURE__ */ jsx110("dt", { children: humanizeMerchantAgentIdentifier(part.field) }),
    /* @__PURE__ */ jsx110("dd", { children: !Array.isArray(part.value) ? part.value : part.value.length > 0 ? /* @__PURE__ */ jsx110("ul", { children: part.value.map((value) => /* @__PURE__ */ jsx110("li", { children: value }, value)) }) : ABSENT })
  ] }, part.field)) });
}
function MerchantAgentChangeTable({ before, after, inputOnly = false }) {
  const { t, i18n } = useComponentsTranslation();
  const [expanded, setExpanded] = useState75(() => /* @__PURE__ */ new Set());
  const hasBefore = !inputOnly && before !== void 0;
  const hasAfter = inputOnly || after !== void 0;
  const rows = merchantAgentPreviewRows(inputOnly ? void 0 : before, after, {
    language: i18n.language,
    defaultLocaleLabel: t("merchantAgentChat.action.localeDefault")
  });
  if (rows.length === 0) return null;
  const toggle = (field) => setExpanded((open2) => {
    const next = new Set(open2);
    if (!next.delete(field)) next.add(field);
    return next;
  });
  const valueRow = (row) => /* @__PURE__ */ jsxs65("tr", { children: [
    /* @__PURE__ */ jsx110("th", { scope: "row", children: merchantAgentPreviewRowLabel(row) ?? ABSENT }),
    hasBefore && /* @__PURE__ */ jsx110("td", { "data-unbroken": unbrokenValue(row.before, row.beforeParts), children: /* @__PURE__ */ jsx110(PreviewValue, { text: row.before, parts: row.beforeParts }) }),
    hasAfter && /* @__PURE__ */ jsx110("td", { "data-changed": hasBefore && row.changed || void 0, "data-unbroken": unbrokenValue(row.after, row.afterParts), children: /* @__PURE__ */ jsx110(PreviewValue, { text: row.after, parts: row.afterParts }) })
  ] }, merchantAgentPreviewRowLabel(row) ?? row.field);
  return /* @__PURE__ */ jsx110("div", { className: "bs-merchant-agent-action__table", children: /* @__PURE__ */ jsxs65("table", { children: [
    /* @__PURE__ */ jsx110("thead", { children: /* @__PURE__ */ jsxs65("tr", { children: [
      /* @__PURE__ */ jsx110("th", { scope: "col", children: t("merchantAgentChat.action.field") }),
      hasBefore && /* @__PURE__ */ jsx110("th", { scope: "col", children: t("merchantAgentChat.action.before") }),
      hasAfter && /* @__PURE__ */ jsx110("th", { scope: "col", children: t(inputOnly ? "merchantAgentChat.action.value" : "merchantAgentChat.action.after") })
    ] }) }),
    /* @__PURE__ */ jsx110("tbody", { children: rows.flatMap((row) => {
      if (!row.unchanged) return [valueRow(row)];
      const open2 = expanded.has(row.field);
      const summary = t("merchantAgentChat.action.unchanged", { items: formatMerchantAgentPreviewItems(row, i18n.language) });
      return [
        /* @__PURE__ */ jsxs65("tr", { children: [
          /* @__PURE__ */ jsx110("th", { scope: "row", children: merchantAgentPreviewRowLabel(row) ?? ABSENT }),
          /* @__PURE__ */ jsx110("td", { colSpan: Number(hasBefore) + Number(hasAfter), "data-unbroken": unbrokenRun(summary), children: /* @__PURE__ */ jsxs65("div", { className: "bs-merchant-agent-action__unchanged", children: [
            summary,
            /* @__PURE__ */ jsx110(Button, { variant: "borderless", size: "sm", "aria-expanded": open2, onClick: () => toggle(row.field), children: t(open2 ? "merchantAgentChat.action.hideUnchanged" : "merchantAgentChat.action.showUnchanged") })
          ] }) })
        ] }, `${row.field}:unchanged`),
        ...open2 ? row.unchanged.map(valueRow) : []
      ];
    }) })
  ] }) });
}
MerchantAgentChangeTable.displayName = "MerchantAgentChangeTable";

// src/components/composite/MerchantAgentChat/MerchantAgentActionCard.tsx
import { jsx as jsx111, jsxs as jsxs66 } from "react/jsx-runtime";
function assignRef(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref) ref.current = value;
}
function MerchantAgentActionCard({ ref, action, decision, deciding = null, disabled: disabled2 = false, onDecide, focusOnMount = false, className, ...rest }) {
  const { t } = useComponentsTranslation();
  const titleId = useId16();
  const statusId = useId16();
  const rootRef = useRef89(null);
  const { preview } = action;
  const state = decision === "confirm" ? "confirmed" : decision === "decline" ? "declined" : "pending";
  useEffect61(() => {
    if (focusOnMount) rootRef.current?.focus();
  }, [focusOnMount]);
  return /* @__PURE__ */ jsxs66(
    "article",
    {
      ref: (node) => {
        rootRef.current = node;
        assignRef(ref, node);
      },
      className: ["bs-merchant-agent-action", className].filter(Boolean).join(" "),
      "data-state": state,
      "aria-labelledby": titleId,
      "aria-describedby": statusId,
      tabIndex: focusOnMount ? -1 : void 0,
      ...rest,
      children: [
        /* @__PURE__ */ jsxs66("div", { className: "bs-merchant-agent-action__header", children: [
          /* @__PURE__ */ jsx111(Badge, { id: statusId, size: "sm", dot: true, color: state === "confirmed" ? "success" : state === "declined" ? "neutral" : "warning", children: t(`merchantAgentChat.action.${state}`) }),
          /* @__PURE__ */ jsx111("h3", { id: titleId, className: "bs-merchant-agent-action__title", children: preview?.summary ?? humanizeMerchantAgentIdentifier(action.toolName) })
        ] }),
        preview ? /* @__PURE__ */ jsx111(MerchantAgentChangeTable, { before: preview.before, after: preview.after }) : /* @__PURE__ */ jsx111(MerchantAgentChangeTable, { after: action.input, inputOnly: true }),
        !decision && /* @__PURE__ */ jsxs66("div", { className: "bs-merchant-agent-action__actions", children: [
          /* @__PURE__ */ jsx111(
            Button,
            {
              variant: "bordered",
              size: "sm",
              loading: deciding === "decline",
              disabled: disabled2 && deciding === null || deciding === "confirm",
              onClick: () => onDecide?.("decline"),
              children: t("merchantAgentChat.action.decline")
            }
          ),
          /* @__PURE__ */ jsx111(
            Button,
            {
              size: "sm",
              loading: deciding === "confirm",
              disabled: disabled2 && deciding === null || deciding === "decline",
              onClick: () => onDecide?.("confirm"),
              children: t("merchantAgentChat.action.confirm")
            }
          )
        ] })
      ]
    }
  );
}
MerchantAgentActionCard.displayName = "MerchantAgentActionCard";

// src/components/composite/MerchantAgentChat/MerchantAgentChangeCard.tsx
import { useEffect as useEffect62, useId as useId17, useRef as useRef90 } from "react";
import { jsx as jsx112, jsxs as jsxs67 } from "react/jsx-runtime";
function assignRef2(ref, value) {
  if (typeof ref === "function") ref(value);
  else if (ref) ref.current = value;
}
function MerchantAgentChangeCard({ ref, change, refusal, undoing = false, disabled: disabled2 = false, onUndo, focusOnMount = false, className, ...rest }) {
  const { t } = useComponentsTranslation();
  const titleId = useId17();
  const statusId = useId17();
  const rootRef = useRef90(null);
  const wasUndoingRef = useRef90(false);
  const canUndo = change.state === "applied";
  const note = refusal ? null : change.state === "undone" ? "undoneNote" : change.state === "not_undoable" ? "noUndo" : null;
  useEffect62(() => {
    const active = rootRef.current?.ownerDocument.activeElement;
    if (focusOnMount && (!active || active === rootRef.current?.ownerDocument.body)) rootRef.current?.focus();
  }, [focusOnMount]);
  useEffect62(() => {
    if (wasUndoingRef.current && !undoing && !canUndo) rootRef.current?.focus();
    wasUndoingRef.current = undoing;
  }, [undoing, canUndo]);
  return /* @__PURE__ */ jsxs67(
    "article",
    {
      ref: (node) => {
        rootRef.current = node;
        assignRef2(ref, node);
      },
      className: ["bs-merchant-agent-action", "bs-merchant-agent-change", className].filter(Boolean).join(" "),
      "data-state": change.state,
      "aria-labelledby": titleId,
      "aria-describedby": statusId,
      tabIndex: -1,
      ...rest,
      children: [
        /* @__PURE__ */ jsxs67("div", { className: "bs-merchant-agent-action__header", children: [
          /* @__PURE__ */ jsx112(Badge, { id: statusId, size: "sm", dot: true, color: change.state === "undone" ? "neutral" : "success", children: t(change.state === "undone" ? "merchantAgentChat.change.undone" : "merchantAgentChat.change.applied") }),
          /* @__PURE__ */ jsx112("h3", { id: titleId, className: "bs-merchant-agent-action__title", children: change.summary })
        ] }),
        /* @__PURE__ */ jsx112(MerchantAgentChangeTable, { before: change.before, after: change.after }),
        note && /* @__PURE__ */ jsx112("p", { className: "bs-merchant-agent-change__note", children: t(`merchantAgentChat.change.${note}`) }),
        refusal && /* @__PURE__ */ jsx112(Callout, { role: "alert", size: "sm", color: refusal === "failed" ? "error" : "warning", children: /* @__PURE__ */ jsx112(CalloutContent, { children: /* @__PURE__ */ jsx112(CalloutBody, { children: t(`merchantAgentChat.change.refusal.${refusal}`) }) }) }),
        canUndo && /* @__PURE__ */ jsx112("div", { className: "bs-merchant-agent-action__actions", children: /* @__PURE__ */ jsx112(
          Button,
          {
            variant: "bordered",
            size: "sm",
            loading: undoing,
            disabled: disabled2 && !undoing,
            "aria-describedby": titleId,
            onClick: () => onUndo?.(),
            children: t("merchantAgentChat.change.undo")
          }
        ) })
      ]
    }
  );
}
MerchantAgentChangeCard.displayName = "MerchantAgentChangeCard";

// src/components/composite/MerchantAgentChat/MerchantAgentChatNotices.tsx
import { jsx as jsx113, jsxs as jsxs68 } from "react/jsx-runtime";
function MerchantAgentChatNotices({ notice, off = false, capped = false, resetsAt = null, onReload, formatResetDate, className }) {
  const { t, i18n } = useComponentsTranslation();
  const resetDate = (value) => formatResetDate?.(value) ?? new Intl.DateTimeFormat(i18n.language, { dateStyle: "long", timeZone: "UTC" }).format(new Date(value));
  if (!off && !capped && !notice) return null;
  return /* @__PURE__ */ jsxs68("div", { className: ["bs-merchant-agent-notices", className].filter(Boolean).join(" "), children: [
    off && /* @__PURE__ */ jsx113(Callout, { role: "status", size: "sm", children: /* @__PURE__ */ jsx113(CalloutContent, { children: /* @__PURE__ */ jsx113(CalloutBody, { children: t("merchantAgentChat.notice.off") }) }) }),
    !off && capped && /* @__PURE__ */ jsx113(Callout, { role: "status", size: "sm", color: "warning", children: /* @__PURE__ */ jsx113(CalloutContent, { children: /* @__PURE__ */ jsx113(CalloutBody, { children: resetsAt ? t("merchantAgentChat.notice.cap", { date: resetDate(resetsAt) }) : t("merchantAgentChat.notice.capNoDate") }) }) }),
    !off && notice && /* @__PURE__ */ jsxs68(Callout, { role: notice === "failed" ? "alert" : "status", size: "sm", color: notice === "failed" ? "error" : "neutral", children: [
      /* @__PURE__ */ jsx113(CalloutContent, { children: /* @__PURE__ */ jsx113(CalloutBody, { children: t(`merchantAgentChat.notice.${notice}`) }) }),
      notice === "running" && onReload && /* @__PURE__ */ jsx113(CalloutActions, { children: /* @__PURE__ */ jsx113(Button, { variant: "bordered", color: "neutral", size: "xs", onClick: onReload, children: t("merchantAgentChat.notice.reload") }) })
    ] })
  ] });
}
MerchantAgentChatNotices.displayName = "MerchantAgentChatNotices";

// src/components/composite/MerchantAgentChat/MerchantAgentComposer.tsx
import { useRef as useRef91 } from "react";
import { jsx as jsx114, jsxs as jsxs69 } from "react/jsx-runtime";
function MerchantAgentComposer({
  value,
  onChange,
  onSubmit,
  locked = false,
  sending = false,
  disabled: disabled2 = false,
  waitingForDecision = false,
  maxLength = MERCHANT_AGENT_MAX_MESSAGE_LENGTH,
  label,
  placeholder,
  className
}) {
  const { t } = useComponentsTranslation();
  const fieldRef = useRef91(null);
  const message = value.trim();
  const canSend = !locked && !disabled2 && message.length > 0;
  function submit(event) {
    event?.preventDefault();
    if (!canSend) return;
    onSubmit(message);
    fieldRef.current?.focus();
  }
  function handleKeyDown(event) {
    if (event.key !== "Enter" || event.shiftKey || isImeComposing(event.nativeEvent)) return;
    event.preventDefault();
    submit();
  }
  return /* @__PURE__ */ jsxs69("form", { className: ["bs-merchant-agent-composer", className].filter(Boolean).join(" "), onSubmit: submit, children: [
    /* @__PURE__ */ jsx114(
      TextField,
      {
        ref: fieldRef,
        "aria-label": label ?? t("merchantAgentChat.composer.label"),
        placeholder: placeholder ?? t("merchantAgentChat.composer.placeholder"),
        multiline: true,
        rows: 3,
        fullWidth: true,
        value,
        onChange: (event) => onChange(event.target.value),
        onKeyDown: handleKeyDown,
        maxLength,
        autoComplete: "off",
        disabled: disabled2,
        helperText: waitingForDecision ? t("merchantAgentChat.composer.waitingForDecision") : void 0
      }
    ),
    /* @__PURE__ */ jsx114("div", { className: "bs-merchant-agent-composer__actions", children: /* @__PURE__ */ jsx114(Button, { type: "submit", size: "sm", loading: sending, disabled: !sending && !canSend, children: t("merchantAgentChat.composer.send") }) })
  ] });
}
MerchantAgentComposer.displayName = "MerchantAgentComposer";

// src/components/composite/MerchantAgentChat/MerchantAgentConversationList.tsx
import { useId as useId18 } from "react";
import { MdAdd } from "react-icons/md";
import { jsx as jsx115, jsxs as jsxs70 } from "react/jsx-runtime";
function MerchantAgentConversationList({ conversations, selectedID, hasMore = false, loadingMore = false, onSelect, onShowMore, className }) {
  const { t } = useComponentsTranslation();
  const headingId = useId18();
  return /* @__PURE__ */ jsxs70("nav", { "aria-labelledby": headingId, className: ["bs-merchant-agent-conversations", className].filter(Boolean).join(" "), children: [
    /* @__PURE__ */ jsxs70("div", { className: "bs-merchant-agent-conversations__header", children: [
      /* @__PURE__ */ jsx115("h2", { id: headingId, className: "bs-merchant-agent-conversations__title", children: t("merchantAgentChat.conversations.title") }),
      /* @__PURE__ */ jsxs70(Button, { variant: "bordered", size: "sm", onClick: () => onSelect(null), disabled: selectedID === null, children: [
        /* @__PURE__ */ jsx115(MdAdd, { "aria-hidden": true, className: "buyscout-btn__icon-start" }),
        t("merchantAgentChat.conversations.new")
      ] })
    ] }),
    conversations === null && /* @__PURE__ */ jsx115("p", { role: "alert", className: "bs-merchant-agent-conversations__message", "data-tone": "error", children: t("merchantAgentChat.conversations.loadFailed") }),
    conversations?.length === 0 && /* @__PURE__ */ jsx115("p", { className: "bs-merchant-agent-conversations__message", children: t("merchantAgentChat.conversations.empty") }),
    conversations && conversations.length > 0 && /* @__PURE__ */ jsx115("ul", { className: "bs-merchant-agent-conversations__list", children: conversations.map((conversation) => /* @__PURE__ */ jsx115("li", { children: /* @__PURE__ */ jsx115(
      "button",
      {
        type: "button",
        className: "bs-merchant-agent-conversations__row",
        "aria-current": conversation.id === selectedID ? "true" : void 0,
        onClick: () => onSelect(conversation.id),
        children: conversation.title
      }
    ) }, conversation.id)) }),
    hasMore && /* @__PURE__ */ jsx115(Button, { variant: "borderless", color: "neutral", size: "sm", loading: loadingMore, onClick: onShowMore, className: "bs-merchant-agent-conversations__more", children: t("merchantAgentChat.conversations.more") })
  ] });
}
MerchantAgentConversationList.displayName = "MerchantAgentConversationList";

// src/components/composite/MerchantAgentChat/MerchantAgentMarkdown.tsx
import { useMemo as useMemo34 } from "react";
import { jsx as jsx116, jsxs as jsxs71 } from "react/jsx-runtime";
function renderInlines(inlines, resolveLink) {
  return inlines.map((inline4, index2) => {
    switch (inline4.type) {
      case "text":
        return inline4.text;
      case "break":
        return /* @__PURE__ */ jsx116("br", {}, index2);
      case "code":
        return /* @__PURE__ */ jsx116("code", { children: inline4.text }, index2);
      case "strong":
        return /* @__PURE__ */ jsx116("strong", { children: renderInlines(inline4.children, resolveLink) }, index2);
      case "em":
        return /* @__PURE__ */ jsx116("em", { children: renderInlines(inline4.children, resolveLink) }, index2);
      case "link": {
        const children = renderInlines(inline4.children, resolveLink);
        const link2 = resolveLink(inline4.href);
        if (!link2) return /* @__PURE__ */ jsx116("span", { children }, index2);
        return /* @__PURE__ */ jsx116(Link, { href: link2.href, external: link2.external, target: link2.target, onClick: link2.onClick, children }, index2);
      }
    }
    return null;
  });
}
function MerchantAgentMarkdown({ text: text4, resolveLink = resolveMerchantAgentHttpsLink, className, ...rest }) {
  const blocks = useMemo34(() => parseMerchantAgentMarkdown(text4), [text4]);
  const inline4 = (inlines) => renderInlines(inlines, resolveLink);
  return /* @__PURE__ */ jsx116("div", { className: ["bs-merchant-agent-markdown", className].filter(Boolean).join(" "), ...rest, children: blocks.map((block, index2) => {
    switch (block.type) {
      case "paragraph":
        return /* @__PURE__ */ jsx116("p", { children: inline4(block.children) }, index2);
      case "heading":
        return /* @__PURE__ */ jsx116("h3", { children: inline4(block.children) }, index2);
      case "code":
        return /* @__PURE__ */ jsx116("pre", { children: /* @__PURE__ */ jsx116("code", { children: block.text }) }, index2);
      case "list": {
        const List = block.ordered ? "ol" : "ul";
        return /* @__PURE__ */ jsx116(List, { start: block.start, children: block.items.map((item, itemIndex) => /* @__PURE__ */ jsx116("li", { children: inline4(item) }, itemIndex)) }, index2);
      }
      case "table":
        return /* @__PURE__ */ jsx116("div", { className: "bs-merchant-agent-markdown__table", children: /* @__PURE__ */ jsxs71("table", { children: [
          /* @__PURE__ */ jsx116("thead", { children: /* @__PURE__ */ jsx116("tr", { children: block.header.map((cell, column) => /* @__PURE__ */ jsx116("th", { scope: "col", children: inline4(cell) }, column)) }) }),
          /* @__PURE__ */ jsx116("tbody", { children: block.rows.map((row, rowIndex) => /* @__PURE__ */ jsx116("tr", { children: block.header.map((_cell, column) => /* @__PURE__ */ jsx116("td", { children: inline4(row[column] ?? []) }, column)) }, rowIndex)) })
        ] }) }, index2);
    }
    return null;
  }) });
}
MerchantAgentMarkdown.displayName = "MerchantAgentMarkdown";

// src/components/composite/MerchantAgentChat/MerchantAgentMessageList.tsx
import { Fragment as Fragment30, useState as useState76 } from "react";
import { jsx as jsx117, jsxs as jsxs72 } from "react/jsx-runtime";
function MerchantAgentMessageList({
  messages,
  pending = [],
  decided = [],
  deciding = null,
  changes = [],
  undoing = null,
  undoDisabled = false,
  onUndo,
  cards = [],
  renderCard,
  loading = false,
  streaming = false,
  tool = null,
  decisionsDisabled = false,
  onDecide,
  resolveLink,
  empty: empty2,
  className,
  ...rest
}) {
  const { t } = useComponentsTranslation();
  const [decidedHere, setDecidedHere] = useState76(null);
  const lastMessage = messages.at(-1);
  const working = streaming && (tool !== null || lastMessage?.role !== "assistant");
  const decide = (approvalID, decision) => {
    setDecidedHere(approvalID);
    onDecide?.(approvalID, decision);
  };
  const at = (position2, last) => (item) => last ? item.position >= position2 : item.position === position2;
  const applied = new Set(changes.flatMap(({ change }) => change.approvalID ?? []));
  const shownDecided = decided.filter((item) => item.decision !== "confirm" || !applied.has(item.action.approvalID));
  const cardsAt = (position2, last) => [
    ...shownDecided.filter(at(position2, last)).map((item) => /* @__PURE__ */ jsx117(
      MerchantAgentActionCard,
      {
        action: item.action,
        decision: item.decision,
        focusOnMount: item.action.approvalID === decidedHere
      },
      item.action.approvalID
    )),
    ...changes.filter(at(position2, last)).map(({ change, refusal }) => /* @__PURE__ */ jsx117(
      MerchantAgentChangeCard,
      {
        change,
        refusal,
        undoing: undoing === change.changeID,
        disabled: undoDisabled,
        onUndo: () => onUndo?.(change.changeID),
        focusOnMount: change.approvalID !== void 0 && change.approvalID === decidedHere
      },
      change.changeID
    )),
    ...renderCard ? cards.filter(at(position2, last)).map(({ card }, index2) => /* @__PURE__ */ jsx117(Fragment30, { children: renderCard(card) }, card.toolCallID ?? `card-${position2}-${index2}`)) : []
  ];
  return /* @__PURE__ */ jsxs72(
    "div",
    {
      role: "log",
      "aria-label": t("merchantAgentChat.transcript"),
      "aria-busy": streaming || loading || void 0,
      className: ["bs-merchant-agent-messages", className].filter(Boolean).join(" "),
      ...rest,
      children: [
        loading && /* @__PURE__ */ jsx117(Spinner, { size: "sm", className: "bs-merchant-agent-messages__loading", "aria-label": t("merchantAgentChat.loading") }),
        !loading && messages.length === 0 && shownDecided.length === 0 && changes.length === 0 && pending.length === 0 && /* @__PURE__ */ jsx117("p", { className: "bs-merchant-agent-messages__empty", children: empty2 ?? t("merchantAgentChat.empty") }),
        messages.map((message, index2) => /* @__PURE__ */ jsxs72(Fragment30, { children: [
          cardsAt(index2, false),
          message.role === "user" ? /* @__PURE__ */ jsx117("p", { className: "bs-merchant-agent-messages__user", children: message.text }) : /* @__PURE__ */ jsx117(MerchantAgentMarkdown, { className: "bs-merchant-agent-messages__assistant", text: message.text, resolveLink })
        ] }, index2)),
        cardsAt(messages.length, true),
        working && /* @__PURE__ */ jsxs72("div", { role: "status", className: "bs-merchant-agent-messages__working", children: [
          /* @__PURE__ */ jsx117(Spinner, { size: "sm", tone: "current", "aria-hidden": true }),
          /* @__PURE__ */ jsx117("span", { children: t(tool ? "merchantAgentChat.working" : "merchantAgentChat.thinking") })
        ] }),
        pending.map((action) => /* @__PURE__ */ jsx117(
          MerchantAgentActionCard,
          {
            action,
            deciding: deciding?.approvalID === action.approvalID ? deciding.decision : null,
            disabled: decisionsDisabled,
            onDecide: (decision) => decide(action.approvalID, decision)
          },
          action.approvalID
        ))
      ]
    }
  );
}
MerchantAgentMessageList.displayName = "MerchantAgentMessageList";

// src/components/composite/SupportRequest/SupportRequest.tsx
import { forwardRef as forwardRef57, useEffect as useEffect63, useId as useId19, useState as useState77 } from "react";
import { MdCheckCircle as MdCheckCircle3, MdErrorOutline as MdErrorOutline2, MdInfoOutline } from "react-icons/md";
import { Fragment as Fragment31, jsx as jsx118, jsxs as jsxs73 } from "react/jsx-runtime";
var titleKeys = {
  confirmation: "supportRequest.confirmationTitle",
  submitting: "supportRequest.submittingTitle",
  created: "supportRequest.createdTitle",
  failed: "supportRequest.failedTitle",
  unknown: "supportRequest.unknownTitle"
};
var statusIcons = {
  created: MdCheckCircle3,
  failed: MdErrorOutline2,
  unknown: MdInfoOutline
};
var SupportRequest = forwardRef57(function SupportRequest2({ status, issue, summary, email, name: name2, storeName, retryAt, busy = false, error: error2, onConfirm, onRetry, className = "", ...props }, ref) {
  const { t, i18n } = useTranslation();
  const titleId = useId19();
  const issueId = useId19();
  const StatusIcon = status === "confirmation" || status === "submitting" ? void 0 : statusIcons[status];
  const [now, setNow] = useState77(Date.now);
  const retryTime = retryAt ? Date.parse(retryAt) : 0;
  const retryWaiting = (status === "failed" || status === "confirmation") && Number.isFinite(retryTime) && retryTime > now;
  useEffect63(() => {
    if (!retryWaiting) return;
    const timer = setTimeout(() => setNow(Date.now()), Math.min(Math.max(0, retryTime - Date.now() + 1), 2147483647));
    return () => clearTimeout(timer);
  }, [retryWaiting, retryTime, now]);
  return /* @__PURE__ */ jsx118("div", { ref, className: `buyscout-support-request ${className}`, ...props, children: /* @__PURE__ */ jsx118("div", { className: "buyscout-support-request__bubble", "data-state": status, role: "region", "aria-labelledby": `${titleId} ${issueId}`, children: /* @__PURE__ */ jsxs73("div", { className: "buyscout-support-request__content", children: [
    /* @__PURE__ */ jsxs73("div", { className: "buyscout-support-request__header", children: [
      /* @__PURE__ */ jsxs73("span", { className: "buyscout-support-request__header-icon", "aria-hidden": "true", children: [
        status === "confirmation" && /* @__PURE__ */ jsx118("span", { className: "buyscout-support-request__header-question", children: "?" }),
        status === "submitting" && /* @__PURE__ */ jsx118(Spinner, { size: "sm", className: "buyscout-support-request__header-spinner" }),
        StatusIcon && /* @__PURE__ */ jsx118(StatusIcon, { size: 22 })
      ] }),
      /* @__PURE__ */ jsx118(Text, { id: titleId, variant: "body-bold", as: "h3", children: t(titleKeys[status]) })
    ] }),
    status === "confirmation" && /* @__PURE__ */ jsx118(Fragment31, { children: /* @__PURE__ */ jsxs73("div", { className: "buyscout-support-request__details", children: [
      /* @__PURE__ */ jsxs73("div", { className: "buyscout-support-request__detail", children: [
        /* @__PURE__ */ jsx118(Text, { id: issueId, as: "p", variant: "body-bold", className: "buyscout-support-request__issue", children: issue }),
        /* @__PURE__ */ jsx118(Text, { as: "p", children: summary })
      ] }),
      /* @__PURE__ */ jsxs73("div", { className: "buyscout-support-request__detail", children: [
        /* @__PURE__ */ jsx118(Text, { as: "p", variant: "body-xs", className: "buyscout-support-request__label", children: t("supportRequest.contact") }),
        /* @__PURE__ */ jsxs73(Text, { as: "p", children: [
          name2?.trim() && /* @__PURE__ */ jsxs73(Fragment31, { children: [
            /* @__PURE__ */ jsx118("span", { className: "buyscout-support-request__name", children: name2.trim() }),
            /* @__PURE__ */ jsx118("br", {})
          ] }),
          email
        ] })
      ] })
    ] }) }),
    status !== "confirmation" && /* @__PURE__ */ jsx118(Text, { id: issueId, as: "p", title: issue, className: "buyscout-support-request__issue buyscout-support-request__issue--compact", children: issue }),
    /* @__PURE__ */ jsxs73("div", { className: "buyscout-support-request__status", role: "status", "aria-live": "polite", children: [
      status === "submitting" && /* @__PURE__ */ jsx118(Text, { as: "p", children: t("supportRequest.submittingDescription") }),
      status === "created" && /* @__PURE__ */ jsx118(Text, { as: "p", children: storeName?.trim() ? t("supportRequest.createdDescription", { storeName: storeName.trim() }) : t("supportRequest.createdDescriptionFallback") }),
      status === "failed" && /* @__PURE__ */ jsx118(Text, { as: "p", children: t("supportRequest.failedDescription") }),
      retryWaiting && /* @__PURE__ */ jsx118(Text, { as: "p", children: t("supportRequest.retryAfter", { time: Intl.DateTimeFormat(i18n.resolvedLanguage, { timeStyle: "medium" }).format(retryTime) }) }),
      status === "unknown" && /* @__PURE__ */ jsx118(Text, { as: "p", children: t("supportRequest.unknownDescription") })
    ] }),
    /* @__PURE__ */ jsx118(Text, { as: "p", variant: "body-sm", className: "buyscout-support-request__note buyscout-support-request__follow-up", children: status === "confirmation" ? t("supportRequest.confirmationFollowUp") : t("supportRequest.followUp") }),
    error2 && /* @__PURE__ */ jsx118(Text, { as: "p", role: "alert", children: error2 }),
    (status === "confirmation" && onConfirm || status === "failed" && onRetry) && /* @__PURE__ */ jsxs73("div", { className: "buyscout-support-request__actions", children: [
      status === "confirmation" && onConfirm && /* @__PURE__ */ jsx118(Button, { size: "sm", variant: "prominent", disabled: busy || retryWaiting, onClick: onConfirm, children: t("supportRequest.send") }),
      status === "failed" && onRetry && /* @__PURE__ */ jsx118(Button, { size: "sm", variant: "outlined", color: "neutral", disabled: busy || retryWaiting, onClick: onRetry, children: t("supportRequest.retry") })
    ] })
  ] }) }) });
});
SupportRequest.displayName = "SupportRequest";

// src/components/StoreAgentUI/StoreChatUI.tsx
import { useCallback as useCallback39, useEffect as useEffect73, useId as useId21, useLayoutEffect as useLayoutEffect20, useRef as useRef98, useState as useState83 } from "react";

// src/hooks/useMediaQuery.ts
import { useCallback as useCallback36, useSyncExternalStore as useSyncExternalStore6 } from "react";
function mediaQueryList(query) {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(query) : void 0;
}
function useMediaQuery(query) {
  const subscribe3 = useCallback36((onChange) => {
    const media = mediaQueryList(query);
    media?.addEventListener("change", onChange);
    return () => media?.removeEventListener("change", onChange);
  }, [query]);
  return useSyncExternalStore6(subscribe3, () => mediaQueryList(query)?.matches ?? false, () => false);
}

// src/components/composite/ChatPanel/ChatPanel.tsx
import { useEffect as useEffect67, useId as useId20, useLayoutEffect as useLayoutEffect18, useMemo as useMemo35, useRef as useRef93, useState as useState79 } from "react";

// src/utils/htmlEntities.ts
function decodeHtmlEntities(text4) {
  if (!text4) return "";
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text4;
  return textarea.value;
}

// src/components/composite/ChatPanel/AppBar.tsx
import { jsx as jsx119, jsxs as jsxs74 } from "react/jsx-runtime";
function AppBar(props) {
  const { t } = useTranslation();
  const decodedStoreName = decodeHtmlEntities(props.storeName);
  const storeName = decodedStoreName || "BuyScout\xAE";
  const initial2 = Array.from(storeName)[0] ?? "";
  return /* @__PURE__ */ jsxs74("div", { className: "buyscout-appbar", children: [
    /* @__PURE__ */ jsxs74("div", { className: "buyscout-appbar__material", "aria-hidden": "true", children: [
      /* @__PURE__ */ jsx119("span", {}),
      /* @__PURE__ */ jsx119("span", {}),
      /* @__PURE__ */ jsx119("span", {}),
      /* @__PURE__ */ jsx119("span", {})
    ] }),
    /* @__PURE__ */ jsxs74("div", { className: "buyscout-appbar__left", children: [
      /* @__PURE__ */ jsx119(
        Avatar2,
        {
          className: "buyscout-appbar__logo",
          shape: "rounded",
          fit: "contain",
          src: props.logo,
          alt: "",
          fallback: initial2,
          "aria-hidden": true
        }
      ),
      /* @__PURE__ */ jsxs74("div", { className: "buyscout-appbar__text", children: [
        /* @__PURE__ */ jsx119(Text, { variant: "body", as: "h2", id: props.headingId, className: "buyscout-appbar__store-name", children: storeName }),
        /* @__PURE__ */ jsxs74("span", { className: "buyscout-appbar__meta", children: [
          /* @__PURE__ */ jsx119(Text, { variant: "body-sm", as: "span", className: "buyscout-appbar__title", children: props.title ?? t("appBar.storeAssistant") }),
          props.showReplySlaBadge && /* @__PURE__ */ jsx119(Text, { variant: "body-sm", as: "span", className: "buyscout-appbar__reply-badge", children: t("appBar.repliesWithin24h") })
        ] })
      ] })
    ] }),
    props.onClose && /* @__PURE__ */ jsx119(
      ChromeDismissButton,
      {
        className: "buyscout-appbar__icon-btn",
        size: "md",
        label: t("appBar.close"),
        onClick: props.onClose
      }
    )
  ] });
}
AppBar.displayName = "AppBar";

// src/components/composite/ChatPanel/panelScroller.ts
var PANEL_SCROLLER_CLASS = "buyscout-chat-panel__scroller";
function panelScrollerOf(host) {
  if (host.classList.contains(PANEL_SCROLLER_CLASS)) return host;
  return host.querySelector(`:scope > .${PANEL_SCROLLER_CLASS}`) ?? host;
}
function isPanelScroller(node, host) {
  return node instanceof HTMLElement && node.classList.contains(PANEL_SCROLLER_CLASS) && node === panelScrollerOf(host);
}

// src/components/composite/ChatPanel/assets/powered-by-buyscout.png
var powered_by_buyscout_default = "data:image/png;base64,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";

// src/components/composite/ChatPanel/PoweredByBuyScout.tsx
import { jsx as jsx120 } from "react/jsx-runtime";
function PoweredByBuyScout({ utmSource }) {
  const { t } = useTranslation();
  const source = encodeURIComponent(utmSource || "buyscout");
  return /* @__PURE__ */ jsx120(
    Link,
    {
      variant: "muted",
      className: "buyscout-powered-by",
      href: `https://www.buyscout.ai/agent?utm_source=${source}&utm_medium=referral`,
      target: "_blank",
      rel: "noopener noreferrer",
      children: /* @__PURE__ */ jsx120(
        "img",
        {
          src: powered_by_buyscout_default,
          alt: t("poweredBy.alt"),
          className: "buyscout-powered-by__img"
        }
      )
    }
  );
}
PoweredByBuyScout.displayName = "PoweredByBuyScout";

// src/components/composite/ChatPanel/useAnnouncementInset.ts
import { useLayoutEffect as useLayoutEffect17 } from "react";
function useAnnouncementInset(barRef, targetRef, enabled) {
  useLayoutEffect17(() => {
    const target = targetRef.current;
    if (!target) return;
    const bar = enabled ? barRef.current : null;
    if (!bar) {
      target.style.removeProperty("--bs-announcement-height");
      return;
    }
    const write = () => target.style.setProperty("--bs-announcement-height", `${bar.offsetHeight}px`);
    write();
    const observer = new ResizeObserver(write);
    observer.observe(bar);
    return () => {
      observer.disconnect();
      target.style.removeProperty("--bs-announcement-height");
    };
  }, [barRef, targetRef, enabled]);
}

// src/components/composite/ChatPanel/useAppBarScrollEdge.ts
import { useEffect as useEffect64 } from "react";
var EDGE_TRAVEL_PX = 20;
function useAppBarScrollEdge(scrollHostRef, targetRef, enabled, contentKey) {
  useEffect64(() => {
    const host = scrollHostRef.current;
    const target = targetRef.current;
    if (!enabled || !host || !target) return;
    const write = (scrollTop) => {
      const progress = Math.min(Math.max(scrollTop / EDGE_TRAVEL_PX, 0), 1);
      target.style.setProperty("--bs-appbar-edge", progress.toFixed(3));
    };
    const handleScroll = (event) => {
      if (!isPanelScroller(event.target, host)) return;
      write(event.target.scrollTop);
    };
    host.addEventListener("scroll", handleScroll, { capture: true, passive: true });
    write(panelScrollerOf(host).scrollTop);
    return () => {
      host.removeEventListener("scroll", handleScroll, { capture: true });
      target.style.removeProperty("--bs-appbar-edge");
    };
  }, [scrollHostRef, targetRef, enabled, contentKey]);
}

// src/components/composite/ChatPanel/usePanelResize.ts
import { useCallback as useCallback37, useEffect as useEffect65, useRef as useRef92, useState as useState78 } from "react";
var MIN_PANEL_RESIZE_WIDTH = 384;
var MIN_PANEL_RESIZE_HEIGHT = 500;
var KEY_STEP = 16;
var CENTRED_ACROSS = {
  width: ["top-center", "bottom-center", "center"],
  height: ["left-center", "right-center", "center"]
};
function usePanelResize({ onSizeChange, resizeAnchor }) {
  const panelRef = useRef92(null);
  const onSizeChangeRef = useRef92(onSizeChange);
  const [measured, setMeasured] = useState78();
  const frameRef = useRef92(null);
  const startDrag = usePointerDrag();
  useEffect65(() => {
    onSizeChangeRef.current = onSizeChange;
  });
  useEffect65(() => {
    if (!panelRef.current) return;
    const observer = new ResizeObserver(() => {
      if (!panelRef.current) return;
      const { offsetWidth: width, offsetHeight: height } = panelRef.current;
      if (width > 0 && height > 0) {
        const size5 = { width: Math.round(width), height: Math.round(height) };
        setMeasured(size5);
        onSizeChangeRef.current?.(size5, "measurement");
      }
    });
    observer.observe(panelRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect65(() => () => {
    if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
  }, []);
  const bounds = useCallback37(() => {
    const parentRect = panelRef.current?.parentElement?.getBoundingClientRect();
    const maxWidth = parentRect ? parentRect.width : window.innerWidth;
    const maxHeight = parentRect ? parentRect.height : window.innerHeight;
    return {
      minWidth: Math.min(MIN_PANEL_RESIZE_WIDTH, maxWidth),
      minHeight: Math.min(MIN_PANEL_RESIZE_HEIGHT, maxHeight),
      maxWidth,
      maxHeight
    };
  }, []);
  const handlePointerDown = useCallback37((event, edge) => {
    const panel = panelRef.current;
    if (!onSizeChangeRef.current || !panel) return;
    const start = { width: panel.offsetWidth, height: panel.offsetHeight };
    const widthMultiplier = (edge.includes("left") || edge.includes("right")) && CENTRED_ACROSS.width.includes(resizeAnchor) ? 2 : 1;
    const heightMultiplier = (edge.includes("top") || edge.includes("bottom")) && CENTRED_ACROSS.height.includes(resizeAnchor) ? 2 : 1;
    let pending = null;
    let emitted = false;
    const flush = () => {
      frameRef.current = null;
      if (pending) {
        onSizeChangeRef.current?.(pending, "drag");
        emitted = true;
      }
      pending = null;
    };
    const started = startDrag(event, {
      onMove: (deltaX, deltaY) => {
        const widthDelta = edge.includes("right") ? deltaX : edge.includes("left") ? -deltaX : 0;
        const heightDelta = edge.includes("bottom") ? deltaY : edge.includes("top") ? -deltaY : 0;
        const { minWidth, minHeight } = bounds();
        pending = {
          width: Math.max(start.width + widthDelta * widthMultiplier, minWidth),
          height: Math.max(start.height + heightDelta * heightMultiplier, minHeight)
        };
        frameRef.current ??= requestAnimationFrame(flush);
      },
      onEnd: (reason) => {
        if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
        if (reason !== "escape") {
          flush();
          return;
        }
        frameRef.current = null;
        pending = null;
        if (emitted) onSizeChangeRef.current?.(start, "drag");
      }
    });
    if (started) event.stopPropagation();
  }, [bounds, resizeAnchor, startDrag]);
  const handleSeparatorKeyDown = useCallback37((event, edge) => {
    const panel = panelRef.current;
    if (!onSizeChangeRef.current || !panel) return;
    const axis = edge === "left" || edge === "right" ? "width" : "height";
    const grow = { left: "ArrowLeft", right: "ArrowRight", top: "ArrowUp", bottom: "ArrowDown" }[edge];
    const shrink = { left: "ArrowRight", right: "ArrowLeft", top: "ArrowDown", bottom: "ArrowUp" }[edge];
    const { minWidth, minHeight, maxWidth, maxHeight } = bounds();
    const [min2, max2] = axis === "width" ? [minWidth, maxWidth] : [minHeight, maxHeight];
    const current = axis === "width" ? panel.offsetWidth : panel.offsetHeight;
    let next;
    if (event.key === grow) next = current + KEY_STEP;
    else if (event.key === shrink) next = current - KEY_STEP;
    else if (event.key === "Home") next = min2;
    else if (event.key === "End") next = max2;
    else return;
    event.preventDefault();
    const clamped = Math.round(Math.min(Math.max(next, min2), max2));
    onSizeChangeRef.current({ width: panel.offsetWidth, height: panel.offsetHeight, [axis]: clamped }, "drag");
  }, [bounds]);
  return { panelRef, measured, bounds, handlePointerDown, handleSeparatorKeyDown };
}

// src/components/composite/ChatPanel/useScrollbarFade.ts
import { useEffect as useEffect66 } from "react";
var HOLD_MS = 900;
var FADE_MS = 250;
var REACH_PX = 14;
var STYLED_SCROLLBAR_QUERY = "(hover: hover) and (pointer: fine)";
function useScrollbarFade(scrollHostRef, enabled, contentKey) {
  const styled = useMediaQuery(STYLED_SCROLLBAR_QUERY);
  useEffect66(() => {
    const host = scrollHostRef.current;
    if (!enabled || !styled || !host || !platformScrollbarsOverlay(host)) return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    let frame = 0;
    let timer;
    let reaching = false;
    let moveFrame = 0;
    let pointerX = 0;
    const log = () => panelScrollerOf(host);
    let written;
    const write = (el, visibility) => {
      written = el;
      el.style.setProperty("--bs-log-thumb-visibility", visibility.toFixed(3));
    };
    const stop = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      clearTimeout(timer);
      timer = void 0;
    };
    const fade = (el) => {
      if (reduced.matches) {
        write(el, 0);
        return;
      }
      const from = performance.now();
      const step = (now) => {
        const t = Math.min((now - from) / FADE_MS, 1);
        write(el, 1 - t);
        frame = t < 1 ? requestAnimationFrame(step) : 0;
      };
      frame = requestAnimationFrame(step);
    };
    const hold = (el) => {
      stop();
      timer = setTimeout(fade, HOLD_MS, el);
    };
    const show2 = (el) => {
      stop();
      write(el, 1);
      if (!reaching) hold(el);
    };
    const intent = trackScrollIntent(host);
    const handleScroll = (event) => {
      if (!isPanelScroller(event.target, host) || !intent.active()) return;
      show2(event.target);
    };
    const handleMove = (event) => {
      pointerX = event.clientX;
      if (moveFrame) return;
      moveFrame = requestAnimationFrame(() => {
        moveFrame = 0;
        const el = log();
        const box = el.getBoundingClientRect();
        const gutter = box.width - el.clientWidth;
        const next = gutter > 0 && pointerX >= box.right - gutter - REACH_PX;
        if (next === reaching) return;
        reaching = next;
        if (next) show2(el);
        else hold(el);
      });
    };
    const handleLeave = () => {
      if (moveFrame) {
        cancelAnimationFrame(moveFrame);
        moveFrame = 0;
      }
      if (!reaching) return;
      reaching = false;
      hold(log());
    };
    host.addEventListener("scroll", handleScroll, { capture: true, passive: true });
    host.addEventListener("pointermove", handleMove, { passive: true });
    host.addEventListener("pointerleave", handleLeave, { passive: true });
    show2(log());
    return () => {
      stop();
      if (moveFrame) cancelAnimationFrame(moveFrame);
      host.removeEventListener("scroll", handleScroll, { capture: true });
      host.removeEventListener("pointermove", handleMove);
      host.removeEventListener("pointerleave", handleLeave);
      intent.dispose();
      written?.style.removeProperty("--bs-log-thumb-visibility");
    };
  }, [scrollHostRef, enabled, styled, contentKey]);
}
function platformScrollbarsOverlay(host) {
  const probe = document.createElement("div");
  probe.style.cssText = "position:absolute;visibility:hidden;overflow:scroll;width:64px;height:64px";
  host.append(probe);
  const overlay = probe.offsetWidth === probe.clientWidth;
  probe.remove();
  return overlay;
}

// src/components/composite/ChatPanel/ChatPanel.tsx
import { jsx as jsx121, jsxs as jsxs75 } from "react/jsx-runtime";
function ChatPanel(props) {
  const { t } = useTranslation();
  const generatedHeadingId = useId20();
  const {
    visible,
    onClose,
    size: size5,
    onSizeChange,
    resizeEdges,
    resizeAnchor = "bottom-right",
    appBar,
    announcement,
    loading = false,
    chatLog,
    utmSource,
    children,
    className,
    dialog = true
  } = props;
  const headingId = appBar?.headingId ?? generatedHeadingId;
  const [isRenderDOM, setIsRenderDOM] = useState79(false);
  const widthSeparator = onSizeChange ? resizeEdges?.find((edge) => edge === "left" || edge === "right") : void 0;
  const heightSeparator = onSizeChange ? resizeEdges?.find((edge) => edge === "top" || edge === "bottom") : void 0;
  const contentRef = useRef93(null);
  const { panelRef, measured, bounds, handlePointerDown, handleSeparatorKeyDown } = usePanelResize({ onSizeChange, resizeAnchor });
  const announcementRef = useRef93(null);
  const contentKey = children ? "children" : loading ? "loading" : chatLog ? `log:${chatLog.session?.id ?? ""}` : "empty";
  useAppBarScrollEdge(contentRef, panelRef, appBar !== void 0 && isRenderDOM, contentKey);
  const { rendered: shownAnnouncement, closing: announcementClosing } = useExitPresence(announcement, announcementRef);
  useAnnouncementInset(announcementRef, panelRef, shownAnnouncement !== void 0);
  useLayoutEffect18(() => {
    const panel = panelRef.current;
    if (!announcementClosing || !panel) return;
    const active = panel.getRootNode().activeElement;
    if (active && announcementRef.current?.contains(active)) {
      panel.querySelector(".buyscout-appbar__icon-btn")?.focus({ preventScroll: true });
    }
  }, [announcementClosing, panelRef]);
  useScrollbarFade(contentRef, isRenderDOM, contentKey);
  const rendersLog = children == null && !loading && chatLog != null;
  const derivedReplies = useMemo35(() => {
    const session = chatLog?.session;
    const replies = session?.possibleReplies;
    if (!replies || replies.length === 0 || session?.status !== "Success" /* Success */) return void 0;
    return replies;
  }, [chatLog?.session]);
  useEffect67(() => {
    let timer = null;
    if (visible) {
      setIsRenderDOM(true);
    } else {
      timer = setTimeout(() => {
        setIsRenderDOM(false);
      }, 500);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [visible]);
  const panelClassName = [
    "buyscout-chat-panel",
    !visible && "buyscout-chat-panel--hidden",
    className
  ].filter(Boolean).join(" ");
  return (
    // Not modal: the shopper can keep using the store page while the chat is open.
    /* @__PURE__ */ jsxs75(
      "div",
      {
        ref: panelRef,
        className: panelClassName,
        role: dialog ? "dialog" : void 0,
        "aria-labelledby": dialog && appBar !== void 0 ? headingId : void 0,
        "aria-label": dialog && appBar === void 0 ? t("appBar.storeAssistant") : void 0,
        style: {
          minWidth: `min(${MIN_PANEL_RESIZE_WIDTH}px, 100%)`,
          minHeight: `min(${MIN_PANEL_RESIZE_HEIGHT}px, 100%)`,
          ...size5
        },
        children: [
          resizeEdges?.map((edge) => {
            const className2 = `buyscout-chat-panel__resize-handle buyscout-chat-panel__resize-handle--${edge}`;
            if (edge !== widthSeparator && edge !== heightSeparator) {
              return /* @__PURE__ */ jsx121("div", { "aria-hidden": "true", className: className2, onPointerDown: (event) => handlePointerDown(event, edge) }, edge);
            }
            const axis = edge === widthSeparator ? "width" : "height";
            const limits = bounds();
            return /* @__PURE__ */ jsx121(
              "div",
              {
                role: "separator",
                tabIndex: 0,
                "aria-orientation": axis === "width" ? "vertical" : "horizontal",
                "aria-label": t(axis === "width" ? "chatPanel.width" : "chatPanel.height"),
                "aria-valuenow": measured?.[axis],
                "aria-valuemin": Math.round(axis === "width" ? limits.minWidth : limits.minHeight),
                "aria-valuemax": Math.round(axis === "width" ? limits.maxWidth : limits.maxHeight),
                className: className2,
                onPointerDown: (event) => handlePointerDown(event, edge),
                onKeyDown: (event) => handleSeparatorKeyDown(event, edge)
              },
              edge
            );
          }),
          appBar !== void 0 && /* @__PURE__ */ jsx121(AppBar, { ...appBar, headingId, onClose: appBar.onClose ?? onClose }),
          shownAnnouncement && /* @__PURE__ */ jsx121(
            "div",
            {
              ref: announcementRef,
              className: "buyscout-chat-panel__announcement",
              "data-state": announcementClosing ? "closed" : "open",
              inert: announcementClosing,
              children: /* @__PURE__ */ jsx121(AnnouncementBar, { ...shownAnnouncement, dialogContainer: () => panelRef.current })
            }
          ),
          /* @__PURE__ */ jsxs75("div", { className: "buyscout-chat-panel__body", children: [
            isRenderDOM && /* @__PURE__ */ jsx121("div", { ref: contentRef, className: clsx_default("buyscout-chat-panel__content", !rendersLog && PANEL_SCROLLER_CLASS), children: children ?? (loading ? /* @__PURE__ */ jsx121("div", { className: "buyscout-chat-panel__loading", children: /* @__PURE__ */ jsx121(LoadingState, {}) }) : chatLog ? /* @__PURE__ */ jsx121(
              ChatLog,
              {
                ...chatLog,
                className: clsx_default("w-full h-full", chatLog.className, PANEL_SCROLLER_CLASS),
                presetReplies: chatLog.presetReplies ?? derivedReplies
              }
            ) : null) }),
            /* @__PURE__ */ jsx121("div", { className: "buyscout-chat-panel__footer", children: /* @__PURE__ */ jsx121(PoweredByBuyScout, { utmSource }) })
          ] })
        ]
      }
    )
  );
}
ChatPanel.displayName = "ChatPanel";

// src/components/StoreAgentUI/deriveComposerTryOn.ts
function deriveComposerTryOn({ tryOn, input }) {
  const { onEnter: tryOnEnter, step: tryOnStep, ...tryOnRest } = tryOn ?? {};
  const tryOnStageProps = tryOnStep ? { ...tryOnRest, step: tryOnStep } : void 0;
  const tryOnActive = tryOnStep != null;
  const handleTryOnClick = tryOnEnter ? () => {
    input.setVoiceMode(false);
    input.handleEditModeClose();
    tryOnEnter();
  } : void 0;
  return { tryOnStageProps, tryOnActive, handleTryOnClick };
}

// src/components/StoreAgentUI/popupMessage.util.ts
var PLACEHOLDER_OPEN = "\uE000";
var PLACEHOLDER_CLOSE = "\uE001";
var PLACEHOLDER_REGEX = /(\d+)/g;
var MARKDOWN_RULES = [
  [/^[ \t]*(?:>[ \t]?)*(?:#{1,6}[ \t]+|[-*+][ \t]+|\d+[.)][ \t]+)?/gm, ""],
  [/!\[([^\]]*)\]\([^)]*\)/g, "$1"],
  [/\[([^\]]*)\]\([^)]*\)/g, "$1"],
  [/(\*\*|__)(.+?)\1/g, "$2"],
  [/~~(.+?)~~/g, "$1"],
  [/\*(\S(?:.*?\S)?)\*/g, "$1"],
  [/(^|[^\p{L}\p{N}])_(\S(?:.*?\S)?)_(?![\p{L}\p{N}])/gu, "$1$2"],
  [/`+([^`]*)`+/g, "$1"],
  [/\*+|~~|`/g, ""],
  [/(^|[^\p{L}\p{N}])_+|_+(?![\p{L}\p{N}])/gu, "$1"]
];
function toPlainPopupPreview(text4, productMap) {
  if (!text4) return "";
  const titles = [];
  let plain = text4.replace(PRODUCT_MENTION_REGEX, (_match, key) => {
    titles.push(resolveProductMention(productMap, key)?.title ?? key.trim());
    return `${PLACEHOLDER_OPEN}${titles.length - 1}${PLACEHOLDER_CLOSE}`;
  });
  for (const [pattern, replacement] of MARKDOWN_RULES) plain = plain.replace(pattern, replacement);
  return plain.replace(PLACEHOLDER_REGEX, (_match, index2) => titles[Number(index2)] ?? "").replace(/\s+/g, " ").trim();
}
function getAssistantPopupPreviewText(message) {
  if (!message?.timeline?.length) return void 0;
  for (const item of message.timeline) {
    if (item.type === "content") {
      const t = item.content?.trim();
      if (t) return t;
    }
  }
  return void 0;
}
function derivePopupMessageProduct(messages) {
  if (!messages) return void 0;
  for (let i = messages.length - 1; i >= 0; i--) {
    const msg = messages[i];
    if (msg.role !== "assistant" /* Assistant */) continue;
    if (!msg.timeline) return void 0;
    for (const item of msg.timeline) {
      if (item.type === "product_list") {
        const product = item.products[0];
        if (product) return product;
      }
      if (item.type === "product_card") return item.product;
    }
    return void 0;
  }
  return void 0;
}
function derivePopupMessageProductLoading(messages) {
  if (!messages) return false;
  for (let i = messages.length - 1; i >= 0; i--) {
    const msg = messages[i];
    if (msg.role !== "assistant" /* Assistant */) continue;
    if (!msg.timeline) return false;
    for (const item of msg.timeline) {
      if (item.type === "product_list") return !!item.loading;
      if (item.type === "product_card") return !!item.loading;
    }
    return false;
  }
  return false;
}

// src/components/StoreAgentUI/popupMessageVisible.util.ts
function isPopupMessageVisible(options) {
  const { isOpen, popupMessage, hasPopupProduct, lastAssistantMsg, dismissedMsgId, suppressedPopupIds } = options;
  const id = lastAssistantMsg?.id;
  const hasBody = !!(popupMessage && popupMessage.trim()) || hasPopupProduct === true;
  const allowPopup = lastAssistantMsg?.showAsPopup === true;
  return !isOpen && hasBody && allowPopup && id !== dismissedMsgId && (id == null || !suppressedPopupIds.has(id));
}

// src/components/StoreAgentUI/useChatBarTuck.ts
import { useEffect as useEffect68, useLayoutEffect as useLayoutEffect19, useRef as useRef94, useState as useState80 } from "react";

// src/components/StoreAgentUI/chatBarTuck.util.ts
var CHAT_BAR_TUCK = {
  tuckAfterY: 160,
  tuckDown: 40,
  topZone: 60,
  endZone: 120,
  scrubDown: 90,
  snapDelayMs: 140,
  foldSpring: { response: 0.42, damping: 0.82 },
  unfoldSpring: { response: 0.27, damping: 1 },
  // Nothing threw a fold the shopper did not ask for, so it settles without a bounce.
  idleSpring: { response: 0.5, damping: 1 },
  // Under a pixel from the goal, and under a pixel a frame, on a desktop-width fold.
  restDistance: 2e-3,
  restSpeed: 0.05,
  // A long frame advances the spring at most this far, so a stall mid-fold never lands as a jump.
  maxStepS: 0.04,
  barRadius: 20,
  // The shell the fold paints has to arrive at the material the pill already
  // wears, or the handoff at the end of the fold lands as a jump in the glass.
  // These mirror $glass-chat-* in _variables.scss and glassMirror.test.ts fails
  // if they drift; the alpha additionally falls back to 1 where glass is off.
  glassAlpha: 0.78,
  glassBlurPx: 18,
  glassSaturate: 2.2,
  glassContrast: 1.08,
  // Mirrors the two drop-shadow stacks in ChatBar.scss and ChatBarIsland.scss, so the
  // shade the fold paints can travel between them instead of snapping to the pill's.
  barShadow: { ambient: { y: 2, blur: 10 }, contact: { y: 0, blur: 1 } },
  islandShadow: { ambient: { y: 8, blur: 24 }, contact: { y: 1, blur: 2 } }
};
function clamp01(k) {
  return Math.max(0, Math.min(1, k));
}
function lerp(a, b, k) {
  return a + (b - a) * k;
}
function ramp(p, a, b) {
  return clamp01((p - a) / (b - a));
}
function stepSpring({ x, v }, goal, dt, { response, damping }) {
  const w = 2 * Math.PI / response;
  const x0 = x - goal;
  if (damping >= 1) {
    const decay2 = Math.exp(-w * dt);
    const b2 = v + w * x0;
    return { x: goal + decay2 * (x0 + b2 * dt), v: decay2 * (v - w * b2 * dt) };
  }
  const wd = w * Math.sqrt(1 - damping * damping);
  const decay = Math.exp(-damping * w * dt);
  const b = (v + damping * w * x0) / wd;
  const cos = Math.cos(wd * dt);
  const sin = Math.sin(wd * dt);
  return { x: goal + decay * (x0 * cos + b * sin), v: decay * (v * cos - (damping * w * b + wd * x0) * sin) };
}
function isAtRest({ x, v }, goal) {
  return Math.abs(x - goal) < CHAT_BAR_TUCK.restDistance && Math.abs(v) < CHAT_BAR_TUCK.restSpeed;
}
function accumulate(acc, delta) {
  return Math.sign(delta) === Math.sign(acc) ? acc + delta : delta;
}
function isNearEdge(y, maxY) {
  return y < CHAT_BAR_TUCK.topZone || maxY - y < CHAT_BAR_TUCK.endZone;
}
function decideScroll(input) {
  const { y, maxY, delta, acc, goal, mode, canAuto, scrub: scrub2 } = input;
  const t = CHAT_BAR_TUCK;
  if (!canAuto || mode === "pinned") return { kind: "none" };
  if (delta < 0) return { kind: "none" };
  if (y <= t.tuckAfterY || isNearEdge(y, maxY)) return { kind: "none" };
  if (scrub2) {
    const next = clamp01(goal + delta / t.scrubDown);
    if (next === goal) return { kind: "none" };
    if (next >= 1) return { kind: "animate", target: 1 };
    return { kind: "scrub", goal: next };
  }
  if (mode === "bar" && acc > t.tuckDown) return { kind: "animate", target: 1 };
  return { kind: "none" };
}
function snapTarget(goal) {
  return goal > 0.25 ? 1 : 0;
}
function shadowLayer(bar, island, k) {
  return { y: lerp(bar.y, island.y, k), blur: lerp(bar.blur, island.blur, k), mix: k };
}
function foldFrame(bar, island, p, glassAlpha2 = CHAT_BAR_TUCK.glassAlpha) {
  const t = CHAT_BAR_TUCK;
  const q = Math.max(0, p);
  const k = clamp01(p);
  const rect = {
    x: lerp(bar.x, island.x, q),
    y: lerp(bar.y, island.y, q),
    width: lerp(bar.width, island.width, q),
    height: lerp(bar.height, island.height, q)
  };
  return {
    inset: {
      top: rect.y - bar.y,
      right: bar.x + bar.width - (rect.x + rect.width),
      bottom: bar.y + bar.height - (rect.y + rect.height),
      left: rect.x - bar.x
    },
    radius: Math.min(rect.height / 2, lerp(t.barRadius, island.height / 2, clamp01(q))),
    rect,
    backgroundAlpha: lerp(1, glassAlpha2, ramp(k, 0, 0.5)),
    blurPx: lerp(0, t.glassBlurPx, ramp(k, 0, 0.4)),
    saturate: lerp(1, t.glassSaturate, ramp(k, 0, 0.5)),
    contrast: lerp(1, t.glassContrast, ramp(k, 0, 0.5)),
    borderMix: k,
    fadeOut: 1 - ramp(p, 0, 0.45),
    fadeIn: ramp(p, 0.5, 0.9),
    shadow: {
      ambient: shadowLayer(t.barShadow.ambient, t.islandShadow.ambient, k),
      contact: shadowLayer(t.barShadow.contact, t.islandShadow.contact, k)
    }
  };
}

// src/components/StoreAgentUI/pageScrollIntent.ts
function listenForPageScrollIntent(doc, isInside, onIntent, onReset) {
  let touchY;
  let scrollbarPointerId;
  const pointerDown = (event) => {
    if (scrollbarPointerId !== void 0 && event.pointerId !== scrollbarPointerId) return;
    onReset();
    scrollbarPointerId = event.pointerType === "mouse" && event.clientX >= doc.documentElement.clientWidth ? event.pointerId : void 0;
  };
  const pointerMove = (event) => {
    if (scrollbarPointerId !== void 0 && event.pointerId === scrollbarPointerId) onIntent();
  };
  const pointerUp = (event) => {
    if (event.pointerId === scrollbarPointerId) scrollbarPointerId = void 0;
  };
  const wheel2 = (event) => {
    if (!event.ctrlKey && event.deltaY !== 0 && !isInside(event)) onIntent();
  };
  const touchStart = (event) => {
    onReset();
    touchY = !isInside(event) && event.touches.length === 1 ? event.touches[0].clientY : void 0;
  };
  const touchMove = (event) => {
    if (touchY === void 0 || event.touches.length !== 1) return;
    if (Math.abs(event.touches[0].clientY - touchY) > 4) onIntent();
  };
  const touchEnd = () => {
    touchY = void 0;
  };
  const keyDown = (event) => {
    if (isInside(event) || event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.composedPath().some((node) => node instanceof HTMLElement && (node.isContentEditable || /^(?:INPUT|TEXTAREA|SELECT)$/.test(node.tagName)))) return;
    if (["ArrowDown", "ArrowUp", "PageDown", "PageUp", "Home", "End", " "].includes(event.key)) onIntent();
  };
  const listeners2 = { pointerdown: pointerDown, pointermove: pointerMove, pointerup: pointerUp, pointercancel: pointerUp, wheel: wheel2, touchstart: touchStart, touchmove: touchMove, touchend: touchEnd, touchcancel: touchEnd, keydown: keyDown, focusin: onReset };
  for (const [type, listener] of Object.entries(listeners2)) doc.addEventListener(type, listener, { capture: true, passive: true });
  return () => {
    for (const [type, listener] of Object.entries(listeners2)) doc.removeEventListener(type, listener, true);
  };
}

// src/components/StoreAgentUI/useChatBarTuck.ts
var BAR_SELECTOR = ".buyscout-chat-bar";
var CONTAINER_SELECTOR = ".buyscout-chat-bar__container";
var FOLD_OUT_VAR = "--chat-bar-fold-out";
var FOLD_IN_VAR = "--chat-bar-fold-in";
var CONTAINER_FRAME_PROPS = ["clip-path", "background-color", "backdrop-filter", "-webkit-backdrop-filter", "border-color", "box-shadow"];
var MATERIAL_PROPS = ["background-color", "background-image", "border", "box-shadow", "backdrop-filter", "filter"];
var MATERIAL_FRAME_PROPS = MATERIAL_PROPS.flatMap((prop) => [`--store-chat-bar-${prop}`, `--store-chat-circle-${prop}`]);
var SHADE_FRAME_PROPS = ["display", "left", "top", "width", "height", "border-radius", "box-shadow", "--store-chat-material-blend", "background-color", "border", "border-color", "backdrop-filter", "-webkit-backdrop-filter", ...MATERIAL_FRAME_PROPS];
var SOLID_GLASS_QUERY = "(prefers-reduced-transparency: reduce), (prefers-contrast: more)";
var IDLE_ACTIVITY_EVENTS = ["pointerdown", "keydown", "input", "focusin", "focusout"];
function prefersReducedMotion2() {
  return typeof window !== "undefined" && !!window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
}
var backdropSupported;
function supportsBackdrop() {
  if (backdropSupported === void 0) {
    backdropSupported = typeof CSS !== "undefined" && typeof CSS.supports === "function" && (CSS.supports("backdrop-filter", "blur(1px)") || CSS.supports("-webkit-backdrop-filter", "blur(1px)"));
  }
  return backdropSupported;
}
function glassAlpha() {
  if (!supportsBackdrop()) return 1;
  return window.matchMedia?.(SOLID_GLASS_QUERY).matches ? 1 : CHAT_BAR_TUCK.glassAlpha;
}
function deepActiveElement(node) {
  const root3 = node.getRootNode();
  let active = root3 instanceof Document || root3 instanceof ShadowRoot ? root3.activeElement : null;
  while (active?.shadowRoot?.activeElement) active = active.shadowRoot.activeElement;
  return active;
}
function isFocusInsideBar(area) {
  if (!area) return false;
  const bar = area.querySelector(BAR_SELECTOR);
  const active = deepActiveElement(area);
  return !!bar && !!active && bar.contains(active);
}
function readScroll() {
  const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  return { y: Math.min(Math.max(window.scrollY, 0), maxY), maxY };
}
function offsetWithin(el, ancestor) {
  let x = 0;
  let y = 0;
  let node = el;
  while (node instanceof HTMLElement && node !== ancestor) {
    x += node.offsetLeft;
    y += node.offsetTop;
    node = node.offsetParent;
  }
  if (node === ancestor) return { x, y };
  const from = ancestor.getBoundingClientRect();
  const to = el.getBoundingClientRect();
  return { x: to.left - from.left, y: to.top - from.top };
}
function islandBoxWithin(island, area) {
  const rect = island.getBoundingClientRect();
  const origin = area.getBoundingClientRect();
  const width = island.offsetWidth;
  const height = island.offsetHeight;
  return {
    x: rect.left + rect.width / 2 - width / 2 - origin.left,
    y: rect.top + rect.height / 2 - height / 2 - origin.top,
    width,
    height
  };
}
function measure(area, island, shade, layout) {
  const container = area.querySelector(CONTAINER_SELECTOR);
  if (!container || !island) return null;
  const { width, height } = container.getBoundingClientRect();
  if (width <= 0 || height <= 0) return null;
  const origin = offsetWithin(container, area);
  const bar = { x: origin.x, y: origin.y, width, height };
  const launcher = layout === "floating" ? island.querySelector(".buyscout-floating-button") : island;
  if (!launcher) return null;
  const barStyle = layout === "floating" ? getComputedStyle(container) : null;
  const border = { top: Number.parseFloat(barStyle?.borderTopWidth ?? "0"), right: Number.parseFloat(barStyle?.borderRightWidth ?? "0"), bottom: Number.parseFloat(barStyle?.borderBottomWidth ?? "0"), left: Number.parseFloat(barStyle?.borderLeftWidth ?? "0") };
  const contentBox = { x: bar.x + border.left, y: bar.y + border.top, width: bar.width - border.left - border.right, height: bar.height - border.top - border.bottom };
  if (barStyle && shade) {
    const circleStyle = getComputedStyle(launcher);
    area.style.setProperty("--store-chat-circle-filter", circleStyle.filter);
    for (const prop of MATERIAL_PROPS) {
      shade.style.setProperty(`--store-chat-bar-${prop}`, barStyle.getPropertyValue(prop));
      shade.style.setProperty(`--store-chat-circle-${prop}`, circleStyle.getPropertyValue(prop));
    }
  }
  return { area, container, voiceOrb: container.querySelector(".buyscout-voice-stage__orb-anchor"), voiceArea: container.querySelector(".buyscout-voice-stage__area"), shade, bar, contentBox, borderInset: Math.max(...Object.values(border)), island: islandBoxWithin(launcher, area), glassAlpha: glassAlpha(), border: getComputedStyle(container).border, floating: layout === "floating" };
}
var GLASS_TINT = "var(--bs-lg-chat-glass-tint)";
var GLASS_EDGE = "var(--bs-lg-chat-glass-edge)";
var FOLD_EDGE = "var(--bs-lg-chat-fold-edge)";
var ISLAND_CONTACT = "var(--bs-lg-chat-island-shadow-contact)";
var BAR_CONTACT = "var(--bs-lg-chat-bar-shadow-contact)";
var ISLAND_AMBIENT = "var(--bs-lg-chat-island-shadow-ambient)";
var BAR_AMBIENT = "var(--bs-lg-chat-bar-shadow-ambient)";
var px = (n) => `${n.toFixed(2)}px`;
var percent = (k) => `${(k * 100).toFixed(2)}%`;
function writeFrame(geo, p) {
  const { bar } = geo;
  const f = foldFrame(bar, geo.island, p, geo.glassAlpha);
  const clipBox = geo.contentBox;
  const left = Math.max(f.rect.x, clipBox.x);
  const top = Math.max(f.rect.y, clipBox.y);
  const right = Math.min(f.rect.x + f.rect.width, clipBox.x + clipBox.width);
  const bottom = Math.min(f.rect.y + f.rect.height, clipBox.y + clipBox.height);
  const radius = Math.max(0, Math.min(f.radius - geo.borderInset, (bottom - top) / 2));
  const container = geo.container.style;
  container.setProperty(
    "clip-path",
    `inset(${px(top - bar.y)} ${px(bar.x + bar.width - right)} ${px(bar.y + bar.height - bottom)} ${px(left - bar.x)} round ${px(radius)})`
  );
  if (!geo.floating) {
    container.setProperty("background-color", "transparent");
    container.setProperty("backdrop-filter", "none");
    container.setProperty("-webkit-backdrop-filter", "none");
    container.setProperty("border-color", "transparent");
    container.setProperty("box-shadow", "none");
  }
  if (geo.shade) {
    const shade = geo.shade.style;
    shade.setProperty("display", "block");
    const shell = geo.floating ? f.rect : { x: left, y: top, width: right - left, height: bottom - top };
    shade.setProperty("left", px(shell.x));
    shade.setProperty("top", px(shell.y));
    shade.setProperty("width", px(shell.width));
    shade.setProperty("height", px(shell.height));
    shade.setProperty("border-radius", px(geo.floating ? f.radius : radius));
    if (geo.floating) {
      shade.setProperty("--store-chat-material-blend", Math.min(1, Math.max(0, p)).toFixed(3));
    } else {
      shade.setProperty("background-color", `color-mix(in srgb, ${GLASS_TINT} ${percent(f.backgroundAlpha)}, transparent)`);
      shade.setProperty("border", geo.border);
      shade.setProperty("border-color", `color-mix(in srgb, ${GLASS_EDGE} ${percent(f.borderMix)}, ${FOLD_EDGE})`);
      const filter = `blur(${f.blurPx.toFixed(2)}px) saturate(${f.saturate.toFixed(3)}) contrast(${f.contrast.toFixed(3)})`;
      shade.setProperty("backdrop-filter", filter);
      shade.setProperty("-webkit-backdrop-filter", filter);
      const { ambient, contact } = f.shadow;
      shade.setProperty(
        "box-shadow",
        `0 ${px(contact.y)} ${px(contact.blur)} color-mix(in srgb, ${ISLAND_CONTACT} ${percent(contact.mix)}, ${BAR_CONTACT}), 0 ${px(ambient.y)} ${px(ambient.blur)} color-mix(in srgb, ${ISLAND_AMBIENT} ${percent(ambient.mix)}, ${BAR_AMBIENT})`
      );
    }
  }
  if (geo.voiceArea?.classList.contains("buyscout-voice-stage__area--visible")) {
    if (geo.voiceOrb) geo.voiceOrb.style.scale = String(0.65 + 0.35 * f.fadeOut);
    geo.voiceArea.style.opacity = String(Math.min(1, 2 * f.fadeOut));
  } else {
    geo.voiceOrb?.style.removeProperty("scale");
    geo.voiceArea?.style.removeProperty("opacity");
  }
  geo.area.style.setProperty(FOLD_OUT_VAR, f.fadeOut.toFixed(3));
  geo.area.style.setProperty(FOLD_IN_VAR, f.fadeIn.toFixed(3));
}
function clearFrame(area, shade, container = null) {
  const target = container ?? area?.querySelector(CONTAINER_SELECTOR) ?? null;
  if (target) {
    target.querySelector(".buyscout-voice-stage__orb-anchor")?.style.removeProperty("scale");
    target.querySelector(".buyscout-voice-stage__area")?.style.removeProperty("opacity");
    for (const prop of CONTAINER_FRAME_PROPS) target.style.removeProperty(prop);
  }
  if (shade) {
    for (const prop of SHADE_FRAME_PROPS) shade.style.removeProperty(prop);
  }
  area?.style.removeProperty(FOLD_OUT_VAR);
  area?.style.removeProperty(FOLD_IN_VAR);
  area?.style.removeProperty("--store-chat-circle-filter");
}
function createEngine(m, latestRef, setView, setInternalPinned) {
  const T = CHAT_BAR_TUCK;
  const opts = () => latestRef.current.options;
  const publish = () => {
    const next = { shown: m.shown, morphing: m.morphing };
    setView((prev) => prev.shown === next.shown && prev.morphing === next.morphing ? prev : next);
  };
  const stopSpring = () => {
    if (m.springFrame) cancelAnimationFrame(m.springFrame);
    m.springFrame = 0;
    m.target = null;
    m.v = 0;
  };
  const notifyPinned = (next) => {
    if (!latestRef.current.pinnedControlled) setInternalPinned(next);
    opts().onPinnedChange?.(next);
  };
  const canAuto = () => {
    const o = opts();
    return m.mode !== "pinned" && m.target === null && !o.panelOpen && !o.busy && !(o.messagePending && m.shown === "bar") && !isFocusInsideBar(o.areaRef.current);
  };
  const beginMorph = () => {
    if (m.geo) return true;
    const { areaRef, islandRef, shadeRef } = opts();
    const area = areaRef.current;
    if (!area) return false;
    const geo = measure(area, islandRef.current, shadeRef.current, opts().layout);
    if (!geo) return false;
    m.geo = geo;
    writeFrame(geo, m.p);
    m.morphing = true;
    publish();
    return true;
  };
  const frame = (p) => {
    m.p = p;
    if (m.geo) writeFrame(m.geo, p);
  };
  const commit = (target) => {
    stopSpring();
    clearTimeout(m.snapTimer);
    m.p = target;
    m.goal = target;
    m.geo = null;
    m.morphing = false;
    m.shown = target === 1 ? "island" : "bar";
    publish();
    armIdle();
  };
  const tick = (now) => {
    m.springFrame = 0;
    const dt = Math.min(T.maxStepS, Math.max(0, (now - m.lastTick) / 1e3));
    m.lastTick = now;
    const next = stepSpring({ x: m.p, v: m.v }, m.goal, dt, m.spring);
    const resting = isAtRest(next, m.goal);
    if (resting && m.target !== null) {
      commit(m.target);
      return;
    }
    m.v = resting ? 0 : next.v;
    frame(resting ? m.goal : next.x);
    if (!resting) m.springFrame = requestAnimationFrame(tick);
  };
  const runSpring = () => {
    if (m.springFrame) return;
    m.lastTick = performance.now();
    m.springFrame = requestAnimationFrame(tick);
  };
  const animateTo = (target, spring = target === 0 ? T.unfoldSpring : T.foldSpring) => {
    clearTimeout(m.snapTimer);
    if (m.target === target) return;
    if (m.p === target && !m.morphing) return;
    clearIdle();
    if (prefersReducedMotion2() || !beginMorph()) {
      commit(target);
      return;
    }
    m.target = target;
    m.goal = target;
    m.spring = spring;
    runSpring();
  };
  const scrub2 = (goal) => {
    if (!beginMorph()) return;
    clearIdle();
    m.goal = goal;
    m.spring = T.foldSpring;
    runSpring();
    clearTimeout(m.snapTimer);
    m.snapTimer = setTimeout(() => {
      const target = snapTarget(m.goal);
      m.mode = target === 1 ? "tucked" : "bar";
      animateTo(target);
    }, T.snapDelayMs);
  };
  const onScrollFrame = (userInitiated) => {
    const { y, maxY } = readScroll();
    const delta = y - m.lastY;
    m.lastY = y;
    if (opts().onPageMinimize && !userInitiated) {
      m.acc = 0;
      return;
    }
    if (delta === 0) return;
    m.acc = accumulate(m.acc, delta);
    const decision = decideScroll({
      y,
      maxY,
      delta,
      acc: m.acc,
      goal: m.goal,
      mode: m.mode,
      canAuto: opts().onPageMinimize ? !opts().busy : canAuto(),
      scrub: !opts().onPageMinimize && !prefersReducedMotion2()
    });
    switch (decision.kind) {
      case "animate":
        if (opts().onPageMinimize) {
          m.acc = 0;
          opts().onPageMinimize?.();
          break;
        }
        m.mode = decision.target === 1 ? "tucked" : "bar";
        animateTo(decision.target);
        break;
      case "scrub":
        scrub2(decision.goal);
        break;
      case "none":
        break;
    }
  };
  const putAway = () => {
    if (m.mode !== "pinned") notifyPinned(true);
    m.mode = "pinned";
    animateTo(1);
  };
  const reveal = () => {
    if (m.mode === "pinned") notifyPinned(false);
    m.mode = "bar";
    m.acc = 0;
    animateTo(0);
  };
  const pinExternally = () => {
    m.mode = "pinned";
    animateTo(1);
  };
  const unpinExternally = () => {
    m.mode = "bar";
    m.acc = 0;
    animateTo(0);
  };
  const forceBar = () => {
    const settlingAtBar = m.mode === "bar" && (m.morphing ? m.target === 0 : m.shown === "bar");
    if (!settlingAtBar) reveal();
  };
  const dispose = () => {
    const interrupted = m.morphing;
    stopSpring();
    clearTimeout(m.snapTimer);
    clearIdle();
    if (m.geo) clearFrame(m.geo.area, m.geo.shade, m.geo.container);
    m.geo = null;
    m.morphing = false;
    if (!interrupted) return;
    const target = m.mode === "bar" ? 0 : 1;
    m.p = target;
    m.goal = target;
    m.shown = target === 1 ? "island" : "bar";
    publish();
  };
  const reduceMotion = () => {
    if (!m.morphing) return;
    const target = m.target ?? (m.shown === "island" ? 1 : 0);
    commit(target);
  };
  const clearIdle = () => {
    clearTimeout(m.idleTimer);
    m.idleTimer = void 0;
  };
  const armIdle = () => {
    clearIdle();
    const { idleMs } = opts();
    if (idleMs <= 0 || m.mode !== "bar" || m.shown !== "bar" || m.morphing) return;
    m.idleTimer = setTimeout(() => {
      m.idleTimer = void 0;
      if (m.hovering || !canAuto()) {
        armIdle();
        return;
      }
      m.mode = "tucked";
      animateTo(1, T.idleSpring);
    }, idleMs);
  };
  const setHovering = (hovering) => {
    m.hovering = hovering;
    if (!hovering) armIdle();
  };
  return {
    putAway,
    reveal,
    pinExternally,
    unpinExternally,
    forceBar,
    onScrollFrame,
    armIdle,
    setHovering,
    dispose,
    reduceMotion
  };
}
function useChatBarTuck(options) {
  const { pinned, defaultPinned, panelOpen, busy, messagePending, idleMs, areaRef, shadeRef } = options;
  const [internalPinned, setInternalPinned] = useState80(defaultPinned);
  const pinnedControlled = pinned !== void 0;
  const pinnedValue = pinnedControlled ? pinned : internalPinned;
  const [view, setView] = useState80(() => ({
    shown: pinnedValue && !panelOpen && !busy ? "island" : "bar",
    morphing: false
  }));
  const latestRef = useRef94({ options, pinnedControlled, pinnedValue });
  latestRef.current = { options, pinnedControlled, pinnedValue };
  const [machine] = useState80(() => ({
    p: view.shown === "island" ? 1 : 0,
    v: 0,
    goal: view.shown === "island" ? 1 : 0,
    target: null,
    spring: CHAT_BAR_TUCK.foldSpring,
    hovering: false,
    mode: pinnedValue ? "pinned" : "bar",
    shown: view.shown,
    morphing: false,
    springFrame: 0,
    lastTick: 0,
    geo: null,
    lastY: 0,
    acc: 0
  }));
  const [engine] = useState80(() => createEngine(machine, latestRef, setView, setInternalPinned));
  useLayoutEffect19(() => {
    if (view.morphing || machine.morphing) return;
    clearFrame(areaRef.current, shadeRef.current);
  }, [view, machine, areaRef, shadeRef]);
  useEffect68(() => {
    machine.lastY = readScroll().y;
    machine.acc = 0;
    let frame = 0;
    let userInitiated = false;
    let intentIdleTimer;
    const resetIntent = () => {
      userInitiated = false;
      clearTimeout(intentIdleTimer);
      intentIdleTimer = void 0;
    };
    const extendIntent = () => {
      if (!userInitiated) return;
      clearTimeout(intentIdleTimer);
      intentIdleTimer = setTimeout(resetIntent, 200);
    };
    const stopIntent = listenForPageScrollIntent(document, (event) => event.composedPath().some((node) => node instanceof HTMLElement && node.classList.contains("buyscout-store-chat")), () => {
      userInitiated = true;
      extendIntent();
    }, resetIntent);
    const onScroll = () => {
      extendIntent();
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        engine.onScrollFrame(userInitiated);
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      stopIntent();
      cancelAnimationFrame(frame);
      clearTimeout(intentIdleTimer);
    };
  }, [engine, machine]);
  useLayoutEffect19(() => {
    if (pinnedValue && machine.mode !== "pinned") engine.pinExternally();
    else if (!pinnedValue && machine.mode === "pinned") engine.unpinExternally();
  }, [pinnedValue, engine, machine]);
  useEffect68(() => {
    if (pinned === void 0 && (panelOpen || busy)) engine.forceBar();
  }, [panelOpen, busy, pinned, pinnedValue, view, engine]);
  useEffect68(() => {
    const area = areaRef.current;
    if (!area) return;
    const onEnter = () => engine.setHovering(true);
    const onLeave = () => engine.setHovering(false);
    const onActivity = () => engine.armIdle();
    area.addEventListener("pointerenter", onEnter);
    area.addEventListener("pointerleave", onLeave);
    for (const type of IDLE_ACTIVITY_EVENTS) area.addEventListener(type, onActivity);
    return () => {
      area.removeEventListener("pointerenter", onEnter);
      area.removeEventListener("pointerleave", onLeave);
      for (const type of IDLE_ACTIVITY_EVENTS) area.removeEventListener(type, onActivity);
    };
  }, [engine, areaRef]);
  useEffect68(() => {
    engine.armIdle();
  }, [idleMs, panelOpen, busy, messagePending, engine]);
  useEffect68(() => {
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = () => {
      if (preference.matches) engine.reduceMotion();
    };
    preference.addEventListener("change", onChange);
    return () => preference.removeEventListener("change", onChange);
  }, [engine]);
  useEffect68(() => () => engine.dispose(), [engine]);
  return {
    shown: view.shown,
    morphing: view.morphing,
    pinned: pinnedValue,
    putAway: engine.putAway,
    reveal: engine.reveal
  };
}

// src/components/StoreAgentUI/useFocusWrap.ts
import { useEffect as useEffect69 } from "react";
var TABBABLE = 'a[href], button, input, select, textarea, [tabindex], [contenteditable]:not([contenteditable="false"])';
function useFocusWrap(ref, active) {
  useEffect69(() => {
    const root3 = ref.current;
    if (!active || !root3) return;
    const handleKeyDown = (event) => {
      if (event.key !== "Tab" || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.target instanceof Element && event.target.closest('[aria-modal="true"]') !== root3) return;
      const tabbables = tabbablesIn(root3);
      const first = tabbables[0];
      const last = tabbables.at(-1);
      if (!first || !last) return;
      const current = deepActiveElement(root3);
      const outside = !current || !root3.contains(current);
      if (event.shiftKey ? outside || current === first : outside || current === last) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    };
    root3.addEventListener("keydown", handleKeyDown);
    return () => root3.removeEventListener("keydown", handleKeyDown);
  }, [ref, active]);
}
function tabbablesIn(root3) {
  return [...root3.querySelectorAll(TABBABLE)].filter(
    (el) => el.tabIndex >= 0 && !el.disabled && !el.closest("[inert]") && el.getClientRects().length > 0
  );
}

// src/components/StoreAgentUI/useInputLifecycle.ts
import { useCallback as useCallback38, useEffect as useEffect70, useMemo as useMemo36, useRef as useRef95, useState as useState81 } from "react";
function useInputLifecycle({ props, openPanel }) {
  const { t } = useTranslation();
  const { onSendMessage, productMention, session } = props;
  const {
    available: products = [],
    current: currentProduct,
    onSearch: onProductSearch,
    onSearchClear: onProductSearchClear
  } = productMention ?? {};
  const inputRef = useRef95(null);
  const lastBlockedEnterMessageRef = useRef95(null);
  const draftBeforeEditRef = useRef95("");
  const [internalMessage, setInternalMessage] = useState81("");
  const message = props.composer?.value ?? internalMessage;
  const onMessageChange = props.composer?.onValueChange;
  const setMessage = useCallback38((value) => {
    setInternalMessage(value);
    onMessageChange?.(value);
  }, [onMessageChange]);
  const [restoreKey, setRestoreKey] = useState81(0);
  const [editFocusRequest, setEditFocusRequest] = useState81(0);
  const [hasProductNotFound, setHasProductNotFound] = useState81(false);
  const [voiceMode, setVoiceModeRaw] = useState81(false);
  const voiceModeRef = useRef95(voiceMode);
  const onVoiceModeChange = props.onVoiceModeChange;
  const setVoiceMode = useCallback38((value) => {
    const next = typeof value === "function" ? value(voiceModeRef.current) : value;
    if (next === voiceModeRef.current) return;
    voiceModeRef.current = next;
    setVoiceModeRaw(next);
    onVoiceModeChange?.(next);
  }, [onVoiceModeChange]);
  const [editContext, setEditContext] = useState81(null);
  const [draftProducts, setDraftProducts] = useState81([]);
  const holdDraftProducts = useCallback38((held) => {
    setDraftProducts((prev) => {
      const known = new Set(prev.map((product) => String(product.id)));
      const added = held.filter((product) => !known.has(String(product.id)));
      return added.length ? [...prev, ...added] : prev;
    });
  }, []);
  const sessionStatus = session?.status;
  const messageCount = session?.messages?.length ?? 0;
  const isSending = sessionStatus != null && sessionStatus !== "Success" /* Success */ && sessionStatus !== "Failure" /* Failure */;
  const isMessageLimitReached = messageCount >= MAX_MESSAGES_COUNT;
  const isMessageTooLong = message.length > MAX_MESSAGE_LENGTH;
  const totalDistinctProducts = useMemo36(
    () => getDistinctProductCount(message, currentProduct?.id),
    [message, currentProduct?.id]
  );
  const isOverProductLimit = totalDistinctProducts > MAX_CHAT_PRODUCTS;
  const disabled2 = isMessageLimitReached;
  const sendBlocked = disabled2 || isSending || message.trim() === "" || isMessageTooLong || isOverProductLimit || hasProductNotFound;
  const errorMessage = useMemo36(() => {
    if (hasProductNotFound) return t("chatBar.errorProductNotFound");
    if (isOverProductLimit) return t("chatBar.errorProductLimit", { max: MAX_CHAT_PRODUCTS });
    if (isMessageTooLong) return t("chatBar.errorMessageTooLong", { max: MAX_MESSAGE_LENGTH });
    return void 0;
  }, [hasProductNotFound, isOverProductLimit, isMessageTooLong, t]);
  const productsForInput = useMemo36(() => {
    const byId = /* @__PURE__ */ new Map();
    products.forEach((p) => byId.set(String(p.id), p));
    if (currentProduct) {
      byId.set(String(currentProduct.id), currentProduct);
    }
    return Array.from(byId.values());
  }, [products, currentProduct]);
  const presetReplies = useMemo36(() => {
    const replies = session?.possibleReplies;
    if (!replies || replies.length === 0 || session?.status !== "Success" /* Success */) return void 0;
    return replies;
  }, [session]);
  const takeDraftBeforeEdit = useCallback38(() => {
    const draft = draftBeforeEditRef.current;
    draftBeforeEditRef.current = "";
    return draft;
  }, []);
  const doSend = useCallback38((text4, mentionedProducts) => {
    onSendMessage(text4, mentionedProducts, editContext?.messageId);
    const next = editContext ? takeDraftBeforeEdit() : "";
    if (!next) setDraftProducts([]);
    setMessage(next);
    onProductSearchClear?.();
    setEditContext(null);
    return next;
  }, [onSendMessage, editContext, onProductSearchClear, setMessage, takeDraftBeforeEdit]);
  const handleSend = useCallback38(() => {
    if (!inputRef.current) return;
    const msg = inputRef.current.getText();
    if (sendBlocked || !msg.trim()) return;
    const next = doSend(msg, inputRef.current.getMentionedProducts());
    inputRef.current.clear();
    if (next) setMessage(next);
    openPanel();
  }, [sendBlocked, doSend, openPanel, setMessage]);
  const handleEnterPress = useCallback38((msg, mentionedProducts) => {
    if (sendBlocked || !msg.trim()) {
      lastBlockedEnterMessageRef.current = msg;
      holdDraftProducts(mentionedProducts);
      setMessage(msg);
      return;
    }
    doSend(msg, mentionedProducts);
    openPanel();
  }, [sendBlocked, doSend, openPanel, setMessage, holdDraftProducts]);
  const handleChange = useCallback38((v) => {
    if (v === "" && lastBlockedEnterMessageRef.current != null) {
      const restored = lastBlockedEnterMessageRef.current;
      lastBlockedEnterMessageRef.current = null;
      setMessage(restored);
      setRestoreKey((k) => k + 1);
    } else {
      lastBlockedEnterMessageRef.current = null;
      setMessage(v);
    }
  }, [setMessage]);
  const handleAtTrigger = useCallback38(() => {
    onProductSearch?.("");
  }, [onProductSearch]);
  const handleEditModeClose = useCallback38(() => {
    if (editContext == null) return;
    setEditContext(null);
    setMessage(takeDraftBeforeEdit());
  }, [editContext, setMessage, takeDraftBeforeEdit]);
  useEffect70(() => {
    if (voiceMode && editContext != null) {
      handleEditModeClose();
    }
  }, [voiceMode]);
  const editDraftRef = useRef95({ editContext, message });
  useEffect70(() => {
    editDraftRef.current = { editContext, message };
  });
  const handleUserMessageEdit = useCallback38((msg) => {
    if (editDraftRef.current.editContext == null) {
      draftBeforeEditRef.current = editDraftRef.current.message;
      holdDraftProducts(inputRef.current?.getMentionedProducts() ?? []);
    }
    setEditContext({ messageId: msg.id, content: msg.content });
    setMessage(msg.content);
    setRestoreKey((k) => k + 1);
    setEditFocusRequest((n) => n + 1);
    openPanel();
  }, [openPanel, setMessage, holdDraftProducts]);
  useEffect70(() => {
    if (editFocusRequest > 0) inputRef.current?.focus();
  }, [editFocusRequest]);
  const handlePresetReplyClick = useCallback38((value) => {
    onSendMessage(value, []);
  }, [onSendMessage]);
  return {
    inputRef,
    restoreKey,
    message,
    voiceMode,
    setVoiceMode,
    editContext,
    disabled: disabled2,
    isSending,
    sendBlocked,
    errorMessage,
    productsForInput,
    draftProducts,
    presetReplies,
    handleSend,
    handleEnterPress,
    handleChange,
    handleAtTrigger,
    handleEditModeClose,
    handleUserMessageEdit,
    handlePresetReplyClick,
    setHasProductNotFound
  };
}

// src/components/StoreAgentUI/usePopupMessageImpression.ts
import { useEffect as useEffect71, useRef as useRef96 } from "react";
function shouldReportPopupImpression(state) {
  if (state.withdrawn) return true;
  if (!state.visible) return false;
  if (state.productLoading) return false;
  return !(state.streaming && !state.hasProduct);
}
function usePopupMessageImpression(options) {
  const { visible, eligible, streaming, productLoading, product, messageID, onShown } = options;
  const reportedMessageIDRef = useRef96(null);
  const seenMessageIDRef = useRef96(null);
  useEffect71(() => {
    const key = messageID ?? "";
    if (reportedMessageIDRef.current === key) return;
    if (visible) seenMessageIDRef.current = key;
    const withdrawn = !eligible && seenMessageIDRef.current === key;
    if (!shouldReportPopupImpression({ visible, withdrawn, streaming, productLoading, hasProduct: product != null })) return;
    reportedMessageIDRef.current = key;
    onShown?.(product);
  }, [visible, eligible, streaming, productLoading, product, messageID, onShown]);
}

// src/components/StoreAgentUI/useSuppressShowAsPopupWhilePanelOpen.ts
import { useEffect as useEffect72, useRef as useRef97, useState as useState82 } from "react";
function useSuppressShowAsPopupWhilePanelOpen(options) {
  const { sessionStatus, isOpen, lastAssistantMsgId, showAsPopup } = options;
  const suppressedIdsRef = useRef97(/* @__PURE__ */ new Set());
  const [, setTick] = useState82(0);
  const prevStatusRef = useRef97(void 0);
  const prevAssistantIdRef = useRef97(void 0);
  const didInitStatusRef = useRef97(false);
  const didInitAssistantIdRef = useRef97(false);
  useEffect72(() => {
    if (!didInitStatusRef.current) {
      didInitStatusRef.current = true;
      prevStatusRef.current = sessionStatus;
      return;
    }
    const prev = prevStatusRef.current;
    prevStatusRef.current = sessionStatus;
    if (sessionStatus === "Success" /* Success */ && prev !== void 0 && prev !== "Success" /* Success */ && isOpen && showAsPopup === true && lastAssistantMsgId) {
      if (!suppressedIdsRef.current.has(lastAssistantMsgId)) {
        suppressedIdsRef.current.add(lastAssistantMsgId);
        setTick((t) => t + 1);
      }
    }
  }, [sessionStatus, isOpen, lastAssistantMsgId, showAsPopup]);
  useEffect72(() => {
    if (!didInitAssistantIdRef.current) {
      didInitAssistantIdRef.current = true;
      prevAssistantIdRef.current = lastAssistantMsgId;
      return;
    }
    if (lastAssistantMsgId === prevAssistantIdRef.current) return;
    const prevId = prevAssistantIdRef.current;
    prevAssistantIdRef.current = lastAssistantMsgId;
    if (sessionStatus === "Success" /* Success */ && prevId !== void 0 && isOpen && showAsPopup === true && lastAssistantMsgId) {
      if (!suppressedIdsRef.current.has(lastAssistantMsgId)) {
        suppressedIdsRef.current.add(lastAssistantMsgId);
        setTick((t) => t + 1);
      }
    }
  }, [lastAssistantMsgId, sessionStatus, isOpen, showAsPopup]);
  return suppressedIdsRef.current;
}

// src/components/StoreAgentUI/StoreChatUI.tsx
import { jsx as jsx122, jsxs as jsxs76 } from "react/jsx-runtime";
var CHAT_BAR_PANEL_GAP = 4;
var launcherSizeStyle = { "--store-chat-launcher-size": FLOATING_BUTTON_SIZE };
var CHAT_BAR_PANEL_MAX_WIDTH_PX = 640;
var CHAT_BAR_PANEL_MAX_WIDTH_VW = 95;
var CHAT_BAR_PANEL_MAX_HEIGHT_PX = 760;
var CHAT_BAR_PANEL_HEIGHT_OFFSET_PX = 120;
var chatBarPanelSize = {
  width: `min(${CHAT_BAR_PANEL_MAX_WIDTH_PX}px, ${CHAT_BAR_PANEL_MAX_WIDTH_VW}svw)`,
  height: `min(${CHAT_BAR_PANEL_MAX_HEIGHT_PX}px, calc(var(--store-chat-viewport-height, 100svh) - ${CHAT_BAR_PANEL_HEIGHT_OFFSET_PX}px))`
};
var FLOATING_PANEL_MAX_WIDTH_PX = 384;
var FLOATING_PANEL_MAX_WIDTH_VW = 90;
var floatingPanelSize = {
  ...chatBarPanelSize,
  width: `min(${FLOATING_PANEL_MAX_WIDTH_PX}px, ${FLOATING_PANEL_MAX_WIDTH_VW}svw)`
};
var ISLAND_BUTTON_SELECTOR = ".buyscout-chat-bar-island__hit, .buyscout-floating-button";
var LEADING_BUTTON_SELECTOR = ".buyscout-chat-bar__leading-button";
var VOICE_END_BUTTON_SELECTOR = ".buyscout-chat-bar__action-button--voice-active";
var POPUP_MESSAGE_SELECTOR = ".buyscout-popup-message";
var TEXT_ENTRY_SELECTOR = "textarea, select, input:not([type=button], [type=checkbox], [type=radio], [type=reset], [type=submit], [type=image], [type=file], [type=range], [type=color])";
function pageFieldHasFocus(root3) {
  const active = deepActiveElement(document);
  if (!root3 || !(active instanceof HTMLElement)) return false;
  const rootNode = root3.getRootNode();
  if (root3.contains(active) || rootNode instanceof ShadowRoot && active.getRootNode() === rootNode) return false;
  return active instanceof HTMLIFrameElement || active.isContentEditable || active.matches(TEXT_ENTRY_SELECTOR);
}
var SHEET_QUERY = "(max-width: 599.98px)";
function StoreChatUI({ layout, ...props }) {
  const rootRef = useRef98(null);
  const { t } = useComponentsTranslation();
  const { message: announcement, announce: announce2, clear: clearAnnouncement } = useLiveAnnouncer();
  const floating = layout === "floating";
  const viewport = useVisualViewport();
  const {
    open: controlledOpen,
    defaultOpen = false,
    onOpenChange,
    focusOnOpen = false,
    themeMode = "light",
    loading,
    appBar,
    announcement: announcementBar,
    session,
    chatLog,
    utmSource,
    productMention,
    voiceAudioLevelRef,
    voiceConnectingStage,
    voiceToolCallActive,
    voiceTurn,
    voiceError,
    onVoiceRetry,
    popupMessage,
    storeDomain,
    className,
    locale,
    panelSize,
    onPanelSizeChange,
    tryOn,
    minimized,
    defaultMinimized,
    onMinimizedChange,
    autoMinimizeMs = 5e3
  } = props;
  const popupAutoDismissMs = popupMessage?.autoDismissMs ?? 5e3;
  const [internalPanelSize, setInternalPanelSize] = useState83();
  const [measuredPanelWidth, setMeasuredPanelWidth] = useState83();
  const resolvedPanelSize = { ...floating ? floatingPanelSize : chatBarPanelSize, ...internalPanelSize, ...panelSize };
  const panelWidth = typeof resolvedPanelSize.width === "number" ? `${resolvedPanelSize.width}px` : resolvedPanelSize.width;
  const panelHeight = typeof resolvedPanelSize.height === "number" ? `${resolvedPanelSize.height}px` : resolvedPanelSize.height;
  const floatingBarWidth = measuredPanelWidth ?? panelSize?.width ?? internalPanelSize?.width ?? FLOATING_PANEL_MAX_WIDTH_PX;
  const floatingBarStyle = { "--store-chat-panel-width": typeof floatingBarWidth === "number" ? `${floatingBarWidth}px` : floatingBarWidth };
  useLayoutEffect20(() => {
    setInternalPanelSize(void 0);
  }, [panelSize]);
  const handlePanelSizeChange = useCallback39((size5, source) => {
    setMeasuredPanelWidth(size5.width);
    if (source === "drag" && panelSize === void 0) setInternalPanelSize(size5);
    onPanelSizeChange?.(size5, source);
  }, [panelSize, onPanelSizeChange]);
  const [internalOpen, setInternalOpen] = useState83(() => defaultMinimized !== void 0 ? !defaultMinimized : defaultOpen);
  const isControlled = controlledOpen !== void 0 || minimized !== void 0;
  const requestedOpen = controlledOpen ?? (minimized !== void 0 ? !minimized : internalOpen);
  const lastAssistantMsg = session?.messages?.filter((m) => m.role === "assistant" /* Assistant */).at(-1);
  const [dismissedMsgId, setDismissedMsgId] = useState83();
  const [cartPopup, setCartPopup] = useState83();
  const activeCartPopup = cartPopup?.session.id === session?.id ? cartPopup : void 0;
  const popupSession = activeCartPopup?.session ?? session;
  const popupAssistantMsg = popupSession?.messages?.filter((message) => message.role === "assistant" /* Assistant */).at(-1);
  const popupProductMap = activeCartPopup ? activeCartPopup.productMap : chatLog?.productMap;
  const popupCartBusy = activeCartPopup !== void 0;
  const setOpen = useCallback39((next) => {
    if (next === requestedOpen) return;
    if (!isControlled) setInternalOpen(next);
    onOpenChange?.(next);
    onMinimizedChange?.(!next);
  }, [isControlled, requestedOpen, onOpenChange, onMinimizedChange]);
  const popupMessageVisibleRef = useRef98(false);
  const [unread, setUnread] = useState83(false);
  const dismissingVoiceRef = useRef98(false);
  const shopperOpenRef = useRef98(false);
  const openPanel = useCallback39(() => {
    shopperOpenRef.current = true;
    setCartPopup(void 0);
    dismissingVoiceRef.current = false;
    if (popupMessageVisibleRef.current) {
      popupMessage?.onOpenChatPanel?.();
    }
    if (lastAssistantMsg?.id) setDismissedMsgId(lastAssistantMsg.id);
    setOpen(true);
    setUnread(false);
  }, [setOpen, lastAssistantMsg?.id, popupMessage?.onOpenChatPanel]);
  const input = useInputLifecycle({ props, openPanel });
  const { voiceMode, setVoiceMode } = input;
  const handlePopupReplyClick = (value) => {
    openPanel();
    if (popupMessage?.onReplyClick) popupMessage.onReplyClick(value);
    else input.handlePresetReplyClick(value);
  };
  const { tryOnStageProps, tryOnActive, handleTryOnClick } = deriveComposerTryOn({ tryOn, input });
  const barVoiceMode = voiceAudioLevelRef !== void 0 ? voiceMode : void 0;
  const voiceActive = !!barVoiceMode;
  const isOpen = requestedOpen && !tryOnActive;
  const coversViewport = useMediaQuery(SHEET_QUERY);
  const modal = coversViewport && isOpen;
  const headingId = useId21();
  useFocusWrap(rootRef, modal);
  const pendingVoiceRef = useRef98(false);
  const [presentedVoiceMode, setPresentedVoiceMode] = useState83(false);
  const [voiceExiting, setVoiceExiting] = useState83(false);
  const chatBarAreaRef = useRef98(null);
  const wasRequestedOpenRef = useRef98(false);
  const skipOpenFocusRef = useRef98(false);
  useEffect73(() => {
    if (requestedOpen && !wasRequestedOpenRef.current) {
      skipOpenFocusRef.current = !(shopperOpenRef.current || focusOnOpen) || pageFieldHasFocus(rootRef.current);
    }
    if (!requestedOpen) skipOpenFocusRef.current = false;
    shopperOpenRef.current = false;
    wasRequestedOpenRef.current = requestedOpen;
  }, [requestedOpen, focusOnOpen]);
  const focusGateRef = useRef98({ tryOnActive, voiceActive, presentedVoiceMode });
  useEffect73(() => {
    const previous2 = focusGateRef.current;
    if (previous2.tryOnActive !== tryOnActive || previous2.voiceActive !== voiceActive || previous2.presentedVoiceMode !== presentedVoiceMode) {
      skipOpenFocusRef.current = false;
    }
    focusGateRef.current = { tryOnActive, voiceActive, presentedVoiceMode };
  }, [tryOnActive, voiceActive, presentedVoiceMode]);
  useEffect73(() => {
    if (isOpen && !voiceActive && !presentedVoiceMode && !skipOpenFocusRef.current) {
      const t2 = setTimeout(() => input.inputRef.current?.focus(), 0);
      return () => clearTimeout(t2);
    }
  }, [isOpen, voiceActive, presentedVoiceMode]);
  const reloadAssistantMessage = chatLog?.onAssistantMessageReload;
  const wrappedChatLog = chatLog ? {
    ...chatLog,
    // Try again unmounts with the failed reply's card, so focus on it goes to the composer.
    onAssistantMessageReload: reloadAssistantMessage && ((message) => {
      const root3 = rootRef.current;
      const fromFailedCard = !!root3 && !!deepActiveElement(root3)?.closest(".buyscout-chat-message-failed");
      reloadAssistantMessage(message);
      if (fromFailedCard) input.inputRef.current?.focus();
    }),
    session: session ?? null,
    storeDomain,
    showCopyButton: true,
    enableScrollDetection: true,
    typingIndicatorDelay: 500,
    // Editing is unreachable while the try-on workspace replaces the input
    // row — offering it would arm invisible edit state.
    onUserMessageEdit: tryOnStageProps || chatLog.messageEditingDisabled ? void 0 : input.handleUserMessageEdit,
    presetReplies: voiceMode ? void 0 : input.presetReplies,
    onPresetReplyClick: input.handlePresetReplyClick
  } : void 0;
  const sessionStatus = session?.status;
  const popupSessionStatus = popupSession?.status;
  const popupMessageText = getAssistantPopupPreviewText(popupAssistantMsg);
  const isPopupStreaming = Boolean(
    (popupSessionStatus === "InProgress" /* InProgress */ || popupSessionStatus === "Waiting" /* Waiting */) && popupMessageText && popupMessageText.length > 0
  );
  const popupMessageReplies = popupSession?.possibleReplies ?? [];
  const popupMessageProduct = derivePopupMessageProduct(popupSession?.messages);
  const popupMessageProductLoading = derivePopupMessageProductLoading(popupSession?.messages);
  const suppressedPopupIds = useSuppressShowAsPopupWhilePanelOpen({
    sessionStatus,
    isOpen,
    lastAssistantMsgId: lastAssistantMsg?.id,
    showAsPopup: lastAssistantMsg?.showAsPopup
  });
  const handlePopupMessageDismiss = useCallback39((manual) => {
    setCartPopup(void 0);
    setDismissedMsgId(popupAssistantMsg?.id);
    popupMessage?.onDismiss?.(manual);
  }, [popupAssistantMsg?.id, popupMessage?.onDismiss]);
  const handlePopupAddToCart = useCallback39(async (product) => {
    const snapshot = popupSession ? { session: popupSession, productMap: popupProductMap } : void 0;
    setCartPopup(snapshot);
    try {
      await popupMessage?.onAddToCart?.(product);
    } catch (error2) {
      setCartPopup((current) => current === snapshot ? void 0 : current);
      throw error2;
    }
  }, [popupSession, popupProductMap, popupMessage?.onAddToCart]);
  useEffect73(() => setCartPopup(void 0), [session?.id]);
  const productChipsSlot = productMention?.current ? /* @__PURE__ */ jsx122(ProductMentionChip, { product: productMention.current, size: "label" }) : void 0;
  const popupMessageVisible = !tryOnActive && isPopupMessageVisible({
    isOpen,
    popupMessage: popupMessageText,
    hasPopupProduct: popupMessageProduct != null,
    lastAssistantMsg: popupAssistantMsg,
    dismissedMsgId,
    suppressedPopupIds
  });
  const islandRef = useRef98(null);
  const dismissPopupKeepingFocus = useCallback39((manual, surface, land) => {
    const area = chatBarAreaRef.current;
    const active = area ? deepActiveElement(area) : null;
    const focusInPopup = !!active && !!surface()?.contains(active);
    handlePopupMessageDismiss(manual);
    if (focusInPopup) land();
  }, [handlePopupMessageDismiss]);
  const handleBarPopupDismiss = useCallback39((manual) => dismissPopupKeepingFocus(manual, () => chatBarAreaRef.current?.querySelector(POPUP_MESSAGE_SELECTOR), () => {
    const leading = chatBarAreaRef.current?.querySelector(LEADING_BUTTON_SELECTOR);
    if (leading) leading.focus({ preventScroll: true });
    else input.inputRef.current?.focus();
  }), [dismissPopupKeepingFocus, input.inputRef]);
  const handleIslandPopupDismiss = useCallback39((manual) => dismissPopupKeepingFocus(manual, () => islandRef.current, () => {
    islandRef.current?.querySelector(ISLAND_BUTTON_SELECTOR)?.focus({ preventScroll: true });
  }), [dismissPopupKeepingFocus]);
  const shadeRef = useRef98(null);
  const expanded = requestedOpen || tryOnActive;
  const nextVoicePresentation = voiceActive || requestedOpen && pendingVoiceRef.current;
  if (expanded && !dismissingVoiceRef.current && presentedVoiceMode !== nextVoicePresentation) {
    setPresentedVoiceMode(nextVoicePresentation);
    setVoiceExiting(presentedVoiceMode && !nextVoicePresentation);
  }
  const focusIslandOnShowRef = useRef98(false);
  const minimizeOnPageScroll = useCallback39(() => {
    focusIslandOnShowRef.current = false;
    setOpen(false);
  }, [setOpen]);
  const tuck = useChatBarTuck({
    layout,
    pinned: !expanded,
    defaultPinned: !expanded,
    onPageMinimize: minimizeOnPageScroll,
    panelOpen: isOpen,
    busy: tryOnActive || voiceActive,
    messagePending: popupMessageVisible,
    idleMs: autoMinimizeMs,
    areaRef: chatBarAreaRef,
    islandRef,
    shadeRef
  });
  if (!expanded && !tuck.morphing && tuck.shown === "island" && presentedVoiceMode) {
    dismissingVoiceRef.current = false;
    setPresentedVoiceMode(false);
  }
  if (!expanded && !tuck.morphing && tuck.shown === "island" && voiceExiting) setVoiceExiting(false);
  useLayoutEffect20(() => {
    if (requestedOpen && pendingVoiceRef.current) {
      pendingVoiceRef.current = false;
      setVoiceMode(true);
    } else if (!requestedOpen && voiceMode) {
      setVoiceMode(false);
    }
  }, [requestedOpen, voiceMode, setVoiceMode]);
  useLayoutEffect20(() => {
    if (!voiceExiting) return;
    const area = chatBarAreaRef.current?.querySelector(".buyscout-voice-stage__area");
    if (!area) {
      setVoiceExiting(false);
      return;
    }
    let cancelled = false;
    const settle = () => {
      if (!cancelled && getComputedStyle(area).opacity === "0") setVoiceExiting(false);
    };
    const watch = () => {
      settle();
      const animations = area.getAnimations();
      if (animations.length) void Promise.allSettled(animations.map((animation) => animation.finished)).then(settle);
    };
    const handleTransition = (event) => {
      if (event.target === area && event.propertyName === "opacity") watch();
    };
    area.addEventListener("transitionend", handleTransition);
    area.addEventListener("transitioncancel", handleTransition);
    watch();
    return () => {
      cancelled = true;
      area.removeEventListener("transitionend", handleTransition);
      area.removeEventListener("transitioncancel", handleTransition);
    };
  }, [voiceExiting, input.restoreKey]);
  const messageSurface = tuck.morphing ? "hold" : tuck.shown === "island" ? "launcher" : "popup";
  const popupVisibleForBar = popupMessageVisible && messageSurface === "popup";
  const launcherPopupVisible = floating && popupMessageVisible && messageSurface === "launcher";
  const islandPopupVisible = !floating && popupMessageVisible && messageSurface === "launcher";
  const displayedVisible = popupVisibleForBar || islandPopupVisible || launcherPopupVisible;
  popupMessageVisibleRef.current = displayedVisible;
  usePopupMessageImpression({
    visible: displayedVisible,
    eligible: popupMessageVisible,
    streaming: isPopupStreaming,
    productLoading: popupMessageProductLoading,
    product: popupMessageProduct,
    messageID: popupAssistantMsg?.id,
    onShown: popupMessage?.onShown
  });
  useEffect73(() => {
    if (isOpen) clearAnnouncement();
  }, [isOpen, clearAnnouncement]);
  const popupAnnouncement = toPlainPopupPreview(popupMessageText, popupProductMap) || popupMessageProduct?.title;
  const popupSettled = popupSessionStatus !== "InProgress" /* InProgress */ && popupSessionStatus !== "Waiting" /* Waiting */ && !popupMessageProductLoading;
  const announcedPopupIdRef = useRef98(void 0);
  useEffect73(() => {
    const id = popupAssistantMsg?.id;
    if (!displayedVisible || !popupSettled || !id || !popupAnnouncement || announcedPopupIdRef.current === id) return;
    announcedPopupIdRef.current = id;
    announce2(t("popupMessage.newMessage", { message: popupAnnouncement }));
  }, [displayedVisible, popupSettled, popupAssistantMsg?.id, popupAnnouncement, announce2, t]);
  const voiceLabelKey = voiceActive ? voiceStageLabelKey(voiceConnectingStage, !!voiceToolCallActive, voiceTurn, voiceError) : null;
  const announcedVoiceLabelRef = useRef98(null);
  useEffect73(() => {
    const previous2 = announcedVoiceLabelRef.current;
    announcedVoiceLabelRef.current = voiceLabelKey;
    if (voiceLabelKey && voiceLabelKey !== previous2) announce2(t(voiceLabelKey));
  }, [voiceLabelKey, announce2, t]);
  if (islandPopupVisible && !unread) setUnread(true);
  else if (isOpen && unread) setUnread(false);
  const handleCardElapsed = useCallback39(() => handleIslandPopupDismiss(false), [handleIslandPopupDismiss]);
  const cardAutoDismiss = useAutoDismiss({
    ms: popupAutoDismissMs,
    enabled: islandPopupVisible && !popupCartBusy && popupSessionStatus !== "InProgress" /* InProgress */ && popupSessionStatus !== "Waiting" /* Waiting */ && !popupMessageProductLoading && popupAutoDismissMs > 0,
    onElapsed: handleCardElapsed
  });
  const islandContent = /* @__PURE__ */ jsx122(
    PopupMessage,
    {
      message: popupMessageText ?? "",
      productMap: popupProductMap,
      replies: popupMessageReplies,
      product: popupMessageProduct,
      productLoading: popupMessageProductLoading,
      onClick: openPanel,
      onReplyClick: handlePopupReplyClick,
      onAddToCart: popupMessage?.onAddToCart ? handlePopupAddToCart : void 0,
      onDismiss: handleIslandPopupDismiss,
      storeDomain,
      isStreaming: isPopupStreaming
    },
    popupAssistantMsg?.id
  );
  const islandSnapshotRef = useRef98({ visible: false, content: null });
  const islandCard = tuck.morphing ? islandSnapshotRef.current.visible : islandPopupVisible;
  const islandChildren = tuck.morphing ? islandSnapshotRef.current.content : islandContent;
  useLayoutEffect20(() => {
    if (!tuck.morphing) islandSnapshotRef.current = { visible: islandPopupVisible, content: islandContent };
  });
  const islandState = tuck.morphing ? "morph" : tuck.shown === "island" ? "shown" : "hidden";
  useLayoutEffect20(() => {
    if (!focusIslandOnShowRef.current || islandState === "hidden") return;
    focusIslandOnShowRef.current = false;
    islandRef.current?.querySelector(ISLAND_BUTTON_SELECTOR)?.focus({ preventScroll: true });
  }, [islandState]);
  const islandHadFocusRef = useRef98(false);
  const prevIslandStateRef = useRef98(islandState);
  useLayoutEffect20(() => {
    const prev = prevIslandStateRef.current;
    prevIslandStateRef.current = islandState;
    const area = chatBarAreaRef.current;
    const island = islandRef.current;
    if (!area) return;
    const focusInsideIsland = () => {
      const active = deepActiveElement(area);
      return !!island && !!active && island.contains(active);
    };
    if (prev === "shown" && islandState !== "shown") islandHadFocusRef.current = focusInsideIsland();
    if (islandState !== "hidden") return;
    if (!islandHadFocusRef.current) return;
    islandHadFocusRef.current = false;
    const doc = area.ownerDocument;
    const focusLost = !doc.activeElement || doc.activeElement === doc.body;
    if (!focusLost && !focusInsideIsland()) return;
    const landing = voiceActive ? VOICE_END_BUTTON_SELECTOR : LEADING_BUTTON_SELECTOR;
    area.querySelector(landing)?.focus({ preventScroll: true });
  }, [islandState]);
  const closePanel = useCallback39(() => {
    dismissingVoiceRef.current = presentedVoiceMode;
    pendingVoiceRef.current = false;
    focusIslandOnShowRef.current = true;
    setVoiceMode(false);
    setOpen(false);
  }, [presentedVoiceMode, setVoiceMode, setOpen]);
  const editing = input.editContext != null;
  const { handleEditModeClose, inputRef } = input;
  const cancelEdit = useCallback39(() => {
    handleEditModeClose();
    announce2(t("editBanner.cancelled"));
    inputRef.current?.focus();
  }, [handleEditModeClose, announce2, t, inputRef]);
  useEffect73(() => {
    const root3 = rootRef.current;
    if (!root3) return;
    const handleEscape = (event) => {
      if (event.key !== "Escape" || event.defaultPrevented || isImeComposing(event) || !requestedOpen) return;
      event.preventDefault();
      event.stopPropagation();
      if (editing) cancelEdit();
      else closePanel();
    };
    root3.addEventListener("keydown", handleEscape);
    return () => root3.removeEventListener("keydown", handleEscape);
  }, [closePanel, requestedOpen, editing, cancelEdit]);
  const handleVoiceModeChange = useCallback39((active) => {
    if (!active) {
      pendingVoiceRef.current = false;
      setVoiceMode(false);
      return;
    }
    if (requestedOpen || !isControlled) setVoiceMode(true);
    else pendingVoiceRef.current = true;
    openPanel();
  }, [requestedOpen, isControlled, setVoiceMode, openPanel]);
  const handleIslandVoice = useCallback39(() => handleVoiceModeChange(true), [handleVoiceModeChange]);
  const barInert = !expanded;
  const foldState = tuck.morphing ? "folding" : tuck.shown === "island" ? "folded" : "expanded";
  return /* @__PURE__ */ jsx122(ComponentsI18nProvider, { locale, children: /* @__PURE__ */ jsx122(LiveAnnouncerContext, { value: announce2, children: /* @__PURE__ */ jsxs76(
    "div",
    {
      className: `${className ?? ""} buyscout-theme-${themeMode} buyscout-store-chat buyscout-store-chat--${layout}`.trim(),
      ref: rootRef,
      ...{ [PORTAL_HOST_ATTRIBUTE]: "" },
      role: modal ? "dialog" : void 0,
      "aria-modal": modal || void 0,
      "aria-labelledby": modal ? headingId : void 0,
      style: {
        ...launcherSizeStyle,
        ...floatingBarStyle,
        position: "fixed",
        zIndex: 1e3,
        inset: 0,
        ...viewport && { "top": viewport.top, "left": viewport.left, "width": viewport.width, "height": viewport.height, "--store-chat-viewport-height": `${viewport.height}px` },
        pointerEvents: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: floating ? "flex-end" : "center",
        justifyContent: "flex-end"
      },
      children: [
        /* @__PURE__ */ jsx122(
          "div",
          {
            className: "buyscout-store-chat__panel-area",
            inert: !isOpen,
            style: {
              width: "100%",
              flex: 1,
              minHeight: 0,
              display: "flex",
              justifyContent: floating ? "var(--store-chat-panel-justify, flex-end)" : "center",
              alignItems: "flex-end",
              paddingBottom: CHAT_BAR_PANEL_GAP,
              pointerEvents: "none"
            },
            children: /* @__PURE__ */ jsx122(
              ChatPanel,
              {
                visible: isOpen,
                onClose: closePanel,
                loading,
                size: { ...resolvedPanelSize, width: `var(--store-chat-mobile-panel-width, ${panelWidth})`, height: `var(--store-chat-mobile-panel-height, ${panelHeight})` },
                onSizeChange: handlePanelSizeChange,
                resizeEdges: floating ? ["top", "left", "top-left"] : ["top", "left", "right", "top-left", "top-right"],
                resizeAnchor: floating ? "bottom-right" : "bottom-center",
                appBar: { ...appBar, headingId },
                dialog: !modal,
                announcement: announcementBar,
                chatLog: wrappedChatLog,
                utmSource
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs76(
          "div",
          {
            ref: chatBarAreaRef,
            "data-voice-exiting": voiceExiting || void 0,
            style: { width: "100%", flexShrink: 0, pointerEvents: "none", position: "relative" },
            children: [
              /* @__PURE__ */ jsx122(ChatBarIslandShade, { ref: shadeRef, visible: tuck.morphing, onPress: openPanel }),
              /* @__PURE__ */ jsx122(
                ChatBar,
                {
                  value: input.message,
                  onChange: input.handleChange,
                  onEnterPress: input.handleEnterPress,
                  maxLength: 2e3,
                  disabled: input.disabled,
                  isSending: input.isSending,
                  products: input.productsForInput,
                  knownProducts: input.draftProducts,
                  onProductSearch: productMention?.onSearch,
                  onProductSearchClear: productMention?.onSearchClear,
                  onProductNotFoundChange: input.setHasProductNotFound,
                  onSend: input.handleSend,
                  onAtTrigger: input.handleAtTrigger,
                  showMentionButton: true,
                  onFocus: openPanel,
                  productChipsSlot,
                  errorMessage: input.errorMessage,
                  editMode: input.editContext != null,
                  onEditModeClose: cancelEdit,
                  voiceMode: presentedVoiceMode,
                  voiceConnectingStage,
                  onVoiceModeChange: voiceAudioLevelRef !== void 0 ? handleVoiceModeChange : void 0,
                  voiceAudioLevelRef,
                  voiceToolCallActive,
                  voiceTurn,
                  voiceError,
                  onVoiceRetry,
                  tryOn: tryOnStageProps,
                  onTryOnClick: handleTryOnClick,
                  inputRef: input.inputRef,
                  fixed: false,
                  popupMessageId: popupAssistantMsg?.id,
                  popupMessage: popupMessageText,
                  productMap: popupProductMap,
                  popupMessageVisible: popupVisibleForBar,
                  onPopupMessageClick: openPanel,
                  popupMessageReplies,
                  onPopupMessageReplyClick: handlePopupReplyClick,
                  popupMessageProduct,
                  popupMessageProductLoading,
                  onPopupMessageDismiss: handleBarPopupDismiss,
                  onPopupMessageAddToCart: popupMessage?.onAddToCart ? handlePopupAddToCart : void 0,
                  storeDomain,
                  popupMessageAutoDismissMs: popupCartBusy || popupSessionStatus === "InProgress" /* InProgress */ || popupSessionStatus === "Waiting" /* Waiting */ ? void 0 : popupAutoDismissMs || void 0,
                  popupMessageIsStreaming: isPopupStreaming,
                  foldState,
                  inert: barInert
                },
                `chat-bar-${input.restoreKey}`
              ),
              floating && /* @__PURE__ */ jsx122(
                "div",
                {
                  ref: islandRef,
                  className: "buyscout-store-chat__launcher",
                  "data-state": islandState,
                  inert: islandState === "hidden",
                  children: /* @__PURE__ */ jsx122(
                    FloatingButton,
                    {
                      onClick: openPanel,
                      variant: props.floatingButtonVariant,
                      popupMessageId: popupAssistantMsg?.id,
                      popupMessage: popupMessageText,
                      productMap: popupProductMap,
                      popupMessageVisible: launcherPopupVisible,
                      onPopupMessageClick: openPanel,
                      popupMessageReplies,
                      onPopupMessageReplyClick: handlePopupReplyClick,
                      popupMessageProduct,
                      popupMessageProductLoading,
                      onPopupMessageDismiss: handleIslandPopupDismiss,
                      onPopupMessageAddToCart: popupMessage?.onAddToCart ? handlePopupAddToCart : void 0,
                      storeDomain,
                      popupMessageAutoDismissMs: popupCartBusy || popupSessionStatus === "InProgress" /* InProgress */ || popupSessionStatus === "Waiting" /* Waiting */ ? void 0 : popupAutoDismissMs || void 0,
                      popupMessageIsStreaming: isPopupStreaming
                    }
                  )
                }
              ),
              !floating && /* @__PURE__ */ jsx122(
                ChatBarIsland,
                {
                  ref: islandRef,
                  variant: islandCard ? "message" : "idle",
                  storeName: appBar?.title,
                  storeLogo: appBar?.logo,
                  onDismiss: () => {
                    handlePopupMessageDismiss(true);
                    islandRef.current?.querySelector(ISLAND_BUTTON_SELECTOR)?.focus({ preventScroll: true });
                  },
                  state: islandState,
                  unread,
                  onOpen: openPanel,
                  onVoice: voiceAudioLevelRef !== void 0 ? handleIslandVoice : void 0,
                  onPointerEnter: cardAutoDismiss.onPointerEnter,
                  onPointerLeave: cardAutoDismiss.onPointerLeave,
                  onFocus: cardAutoDismiss.onFocus,
                  onBlur: cardAutoDismiss.onBlur,
                  children: islandCard ? islandChildren : null
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx122(LiveRegion, { message: announcement })
      ]
    }
  ) }) });
}
StoreChatUI.displayName = "StoreChatUI";

// src/components/StoreAgentUI/ChatBarUI.tsx
import { jsx as jsx123 } from "react/jsx-runtime";
function ChatBarUI(props) {
  return /* @__PURE__ */ jsx123(StoreChatUI, { ...props, layout: "bar" });
}
ChatBarUI.displayName = "ChatBarUI";

// src/components/StoreAgentUI/FloatingChatUI.tsx
import { jsx as jsx124 } from "react/jsx-runtime";
function FloatingChatUI(props) {
  return /* @__PURE__ */ jsx124(StoreChatUI, { ...props, layout: "floating" });
}
FloatingChatUI.displayName = "FloatingChatUI";

// src/hooks/LoadingActivityProvider.tsx
import { use as use8, useRef as useRef99 } from "react";
import { jsx as jsx125 } from "react/jsx-runtime";
function LoadingActivityProvider({ onActiveChange, children }) {
  const count2 = useRef99(0);
  const active = useRef99(false);
  const onChange = useRef99(onActiveChange);
  onChange.current = onActiveChange;
  const report = useRef99(() => {
    count2.current++;
    if (!active.current) {
      active.current = true;
      onChange.current(true);
    }
    let reported = true;
    return () => {
      if (!reported) return;
      reported = false;
      count2.current--;
      queueMicrotask(() => {
        if (count2.current === 0 && active.current) {
          active.current = false;
          onChange.current(false);
        }
      });
    };
  });
  return /* @__PURE__ */ jsx125(LoadingActivityContext, { value: report.current, children });
}
function LoadingActivityMute({ muted = true, children }) {
  const report = use8(LoadingActivityContext);
  return /* @__PURE__ */ jsx125(LoadingActivityContext, { value: muted ? null : report, children });
}

// src/hooks/useAudioLevel.ts
import { useEffect as useEffect74, useRef as useRef100 } from "react";
function useAudioLevel(stream, opts = {}) {
  const { fftSize = 512, attack = 0.7, release: release2 = 0.18 } = opts;
  const levelRef = useRef100({ current: 0 });
  useEffect74(() => {
    if (!stream) {
      levelRef.current.current = 0;
      return;
    }
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") {
      void ctx.resume();
    }
    const analyser = ctx.createAnalyser();
    analyser.fftSize = fftSize;
    const src = ctx.createMediaStreamSource(stream);
    src.connect(analyser);
    const data = new Uint8Array(analyser.frequencyBinCount);
    const target = levelRef.current;
    let raf = 0;
    const tick = () => {
      analyser.getByteTimeDomainData(data);
      let sum = 0;
      for (let i = 0; i < data.length; i++) {
        const v = (data[i] - 128) / 128;
        sum += v * v;
      }
      const rms = Math.sqrt(sum / data.length);
      const gated = Math.max(0, rms - 0.02) / (1 - 0.02);
      const prev = target.current;
      target.current = gated > prev ? prev + (gated - prev) * attack : prev + (gated - prev) * release2;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      try {
        src.disconnect();
        analyser.disconnect();
        void ctx.close();
      } catch {
      }
      target.current = 0;
    };
  }, [stream, fftSize, attack, release2]);
  return levelRef.current;
}

// src/hooks/useLiveVoice.ts
import { useCallback as useCallback41, useEffect as useEffect76, useRef as useRef102, useState as useState85 } from "react";

// src/hooks/useRealtimeVoice.ts
import { useCallback as useCallback40, useEffect as useEffect75, useRef as useRef101, useState as useState84 } from "react";

// src/hooks/voiceTurn.ts
function nextVoiceTurn(turn, event) {
  switch (event.type) {
    case "input_audio_buffer.speech_started":
      return "listening";
    case "input_audio_buffer.speech_stopped":
      return "thinking";
    case "response.created":
      return turn === "speaking" ? turn : "thinking";
    case "output_audio_buffer.started":
      return "speaking";
    case "output_audio_buffer.stopped":
    case "output_audio_buffer.cleared":
      return "listening";
    case "response.done":
      if (turn === "speaking") return turn;
      return event.response?.output?.some((item) => item.type === "function_call") ? "thinking" : "listening";
    default:
      return turn;
  }
}

// src/hooks/useRealtimeVoice.ts
var TOOL_CALL_STAGE_DELAY_MS = 300;
var VOICE_DISCONNECT_GRACE_MS = 5e3;
var MIC_ERROR_REASONS = {
  NotAllowedError: "mic-blocked",
  SecurityError: "mic-blocked",
  NotFoundError: "mic-missing",
  OverconstrainedError: "mic-missing",
  NotReadableError: "mic-busy",
  AbortError: "mic-busy"
};
function micErrorReason(err) {
  return isNamedError(err) && MIC_ERROR_REASONS[err.name] || "service";
}
function isNamedError(err) {
  return err instanceof Error || err instanceof DOMException;
}
var FATAL_REALTIME_ERROR_CODES = /* @__PURE__ */ new Set(["session_expired"]);
function useRealtimeVoice(options) {
  const { createSession, executeToolCall, saveTranscript, onTranscriptMessage } = options;
  const [status, setStatus] = useState84("idle");
  const [error2, setError] = useState84(null);
  const [errorReason, setErrorReason] = useState84(null);
  const [micStream, setMicStream] = useState84(null);
  const [remoteStream, setRemoteStream] = useState84(null);
  const [transcript, setTranscript] = useState84([]);
  const [toolCallActive, setToolCallActive] = useState84(false);
  const [turn, setTurn] = useState84(null);
  const pendingToolCallsRef = useRef101(0);
  const toolCallTimerRef = useRef101(void 0);
  const pcRef = useRef101(null);
  const dcRef = useRef101(null);
  const streamRef = useRef101(null);
  const audioElRef = useRef101(null);
  const transcriptRef = useRef101([]);
  const toolCallTokenRef = useRef101("");
  const attemptIdRef = useRef101(0);
  const abortRef = useRef101(null);
  const disconnectTimerRef = useRef101(void 0);
  const addTranscriptMessage = useCallback40((msg) => {
    transcriptRef.current = [...transcriptRef.current, msg];
    setTranscript(transcriptRef.current);
    onTranscriptMessage?.(msg);
  }, [onTranscriptMessage]);
  const resetToolCalls = useCallback40(() => {
    pendingToolCallsRef.current = 0;
    clearTimeout(toolCallTimerRef.current);
    setToolCallActive(false);
  }, []);
  const beginToolCall = useCallback40(() => {
    pendingToolCallsRef.current++;
    if (pendingToolCallsRef.current === 1) toolCallTimerRef.current = setTimeout(setToolCallActive, TOOL_CALL_STAGE_DELAY_MS, true);
  }, []);
  const endToolCall = useCallback40(() => {
    if (pendingToolCallsRef.current === 0) return;
    if (--pendingToolCallsRef.current === 0) resetToolCalls();
  }, [resetToolCalls]);
  useEffect75(() => () => {
    clearTimeout(toolCallTimerRef.current);
    clearTimeout(disconnectTimerRef.current);
  }, []);
  const cleanup = useCallback40(() => {
    resetToolCalls();
    clearTimeout(disconnectTimerRef.current);
    setTurn(null);
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
      streamRef.current = null;
      setMicStream(null);
    }
    if (dcRef.current) {
      dcRef.current.close();
      dcRef.current = null;
    }
    if (pcRef.current) {
      pcRef.current.close();
      pcRef.current = null;
    }
    if (audioElRef.current) {
      audioElRef.current.srcObject = null;
      audioElRef.current.remove();
      audioElRef.current = null;
      setRemoteStream(null);
    }
  }, [resetToolCalls]);
  const flushTranscript = useCallback40(() => {
    const messages = transcriptRef.current;
    transcriptRef.current = [];
    if (messages.length === 0) return;
    try {
      const result = saveTranscript(messages);
      if (result && typeof result.catch === "function") {
        result.catch((err) => {
          console.error("Failed to save voice transcript:", err);
        });
      }
    } catch (err) {
      console.error("Failed to save voice transcript:", err);
    }
  }, [saveTranscript]);
  const fail = useCallback40((reason, detail) => {
    abortRef.current?.abort();
    abortRef.current = null;
    flushTranscript();
    cleanup();
    setStatus("error");
    setError(detail);
    setErrorReason(reason);
  }, [cleanup, flushTranscript]);
  const stop = useCallback40(() => {
    attemptIdRef.current++;
    abortRef.current?.abort();
    abortRef.current = null;
    flushTranscript();
    cleanup();
    setStatus("idle");
    setError(null);
    setErrorReason(null);
    setTranscript([]);
  }, [cleanup, flushTranscript]);
  useEffect75(() => {
    const handleUnload = () => {
      const messages = transcriptRef.current;
      if (messages.length === 0) return;
      try {
        saveTranscript(messages, { unloading: true });
      } catch (err) {
        console.error("Failed to flush voice transcript on unload:", err);
      }
    };
    window.addEventListener("pagehide", handleUnload);
    return () => {
      window.removeEventListener("pagehide", handleUnload);
    };
  }, [saveTranscript]);
  const start = useCallback40(async () => {
    const id = ++attemptIdRef.current;
    const ac = new AbortController();
    abortRef.current = ac;
    const isStale = () => id !== attemptIdRef.current;
    try {
      setStatus("requesting-mic");
      setError(null);
      setErrorReason(null);
      resetToolCalls();
      setTurn(null);
      transcriptRef.current = [];
      setTranscript([]);
      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }
        });
      } catch (err) {
        if (isStale()) return;
        console.error("Failed to access the microphone:", err);
        fail(micErrorReason(err), isNamedError(err) ? `${err.name}: ${err.message}` : "Failed to access the microphone");
        return;
      }
      if (isStale()) {
        stream.getTracks().forEach((t) => t.stop());
        return;
      }
      streamRef.current = stream;
      setMicStream(stream);
      setStatus("connecting");
      let session;
      try {
        session = await createSession();
      } catch (err) {
        if (isStale()) return;
        console.error("Failed to create a voice session:", err);
        fail("service", err instanceof Error ? err.message : "Failed to create a voice session");
        return;
      }
      if (isStale()) return;
      toolCallTokenRef.current = session.toolCallToken;
      const pc = new RTCPeerConnection();
      pcRef.current = pc;
      const isLive = () => !isStale() && pcRef.current === pc;
      const failCall = (reason, detail) => {
        if (!isLive()) return;
        console.error("Voice call failed:", detail);
        fail(reason, detail);
      };
      stream.getAudioTracks().forEach((track) => pc.addTrack(track, stream));
      const audioEl = document.createElement("audio");
      audioEl.autoplay = true;
      audioEl.style.display = "none";
      document.body.appendChild(audioEl);
      audioElRef.current = audioEl;
      pc.ontrack = (event) => {
        audioEl.srcObject = event.streams[0];
        audioEl.play().catch(() => {
        });
        setRemoteStream(event.streams[0]);
      };
      const dc = pc.createDataChannel("oai-events");
      dcRef.current = dc;
      dc.onopen = () => {
        if (!isStale()) setTurn("ready");
      };
      dc.onclose = () => failCall("connection", "Voice data channel closed");
      dc.onerror = () => failCall("connection", "Voice data channel error");
      dc.onmessage = async (event) => {
        if (isStale()) return;
        try {
          const data = JSON.parse(event.data);
          setTurn((prev) => prev && nextVoiceTurn(prev, data));
          switch (data.type) {
            case "conversation.item.input_audio_transcription.completed":
              if (data.transcript) addTranscriptMessage({ id: crypto.randomUUID(), role: "user", content: data.transcript });
              break;
            case "response.output_audio_transcript.done":
              if (data.transcript) addTranscriptMessage({ id: crypto.randomUUID(), role: "assistant", content: data.transcript });
              break;
            case "response.function_call_arguments.done": {
              const { call_id, name: name2, arguments: args } = data;
              beginToolCall();
              try {
                const { output, productListItems } = await executeToolCall(name2, args, toolCallTokenRef.current);
                if (isStale()) return;
                if (productListItems && productListItems.length > 0) {
                  addTranscriptMessage({ id: crypto.randomUUID(), role: "assistant", content: "", productListItems });
                }
                dc.send(JSON.stringify({
                  type: "conversation.item.create",
                  item: { type: "function_call_output", call_id, output }
                }));
                dc.send(JSON.stringify({ type: "response.create" }));
              } catch {
                if (isStale()) return;
                dc.send(JSON.stringify({
                  type: "conversation.item.create",
                  item: { type: "function_call_output", call_id, output: JSON.stringify({ error: "Tool execution failed" }) }
                }));
                dc.send(JSON.stringify({ type: "response.create" }));
              } finally {
                if (!isStale()) endToolCall();
              }
              break;
            }
            case "error":
              console.error("Realtime API error:", data.error);
              if (FATAL_REALTIME_ERROR_CODES.has(data.error?.code)) failCall("connection", data.error?.message ?? "Realtime session ended");
              break;
          }
        } catch {
        }
      };
      pc.onconnectionstatechange = () => {
        if (!isLive()) return;
        clearTimeout(disconnectTimerRef.current);
        switch (pc.connectionState) {
          case "connected":
            setStatus("connected");
            break;
          case "disconnected":
            disconnectTimerRef.current = setTimeout(failCall, VOICE_DISCONNECT_GRACE_MS, "connection", "Voice connection lost");
            break;
          case "failed":
            failCall("connection", "Voice connection failed");
            break;
        }
      };
      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);
      let sdpResponse;
      try {
        sdpResponse = await fetch(
          `https://api.openai.com/v1/realtime/calls?model=${encodeURIComponent(session.model)}`,
          {
            method: "POST",
            headers: {
              "Authorization": `Bearer ${session.clientSecretValue}`,
              "Content-Type": "application/sdp"
            },
            body: offer.sdp,
            signal: ac.signal
          }
        );
      } catch (err) {
        if (isStale() || err instanceof DOMException && err.name === "AbortError") return;
        failCall("connection", err instanceof Error ? err.message : "SDP request failed");
        return;
      }
      if (isStale()) return;
      if (!sdpResponse.ok) {
        const errBody = await sdpResponse.text();
        failCall("service", `SDP negotiation failed: ${sdpResponse.status} - ${errBody}`);
        return;
      }
      const answerSdp = await sdpResponse.text();
      if (isStale()) return;
      await pc.setRemoteDescription({ type: "answer", sdp: answerSdp });
    } catch (err) {
      if (isStale()) return;
      if (err instanceof DOMException && err.name === "AbortError") return;
      console.error("Failed to start voice chat:", err);
      fail("service", err instanceof Error ? err.message : "Failed to start voice chat");
    }
  }, [createSession, executeToolCall, addTranscriptMessage, fail, resetToolCalls, beginToolCall, endToolCall]);
  return {
    status,
    error: error2,
    errorReason,
    micStream,
    remoteStream,
    transcript,
    toolCallActive,
    turn,
    start,
    stop
  };
}

// src/hooks/useLiveVoice.ts
var LIVE_TURN_SETTLE_MS = 900;
var LIVE_USER_TURN_HOLD_MS = 4e3;
var SOUND_ANNOTATION = /\[[^\]]*(?:\]|$)/g;
function spokenText(transcript) {
  return transcript.replace(SOUND_ANNOTATION, " ").replace(/\s+/g, " ").trim();
}
var CLOSE_FAILURES = {
  expired: "connection",
  connection_lost: "connection",
  content: "service"
};
function useLiveVoice(options) {
  const [status, setStatus] = useState85("idle");
  const [error2, setError] = useState85(null);
  const [errorReason, setErrorReason] = useState85(null);
  const [micStream, setMicStream] = useState85(null);
  const [remoteStream, setRemoteStream] = useState85(null);
  const [transcript, setTranscript] = useState85([]);
  const [toolCallActive, setToolCallActive] = useState85(false);
  const [turn, setTurn] = useState85(null);
  const [muted, setMuted] = useState85(false);
  const pcRef = useRef102(null);
  const dcRef = useRef102(null);
  const streamRef = useRef102(null);
  const audioElRef = useRef102(null);
  const attemptIdRef = useRef102(0);
  const abortRef = useRef102(null);
  const disconnectTimerRef = useRef102(void 0);
  const settleTimerRef = useRef102(void 0);
  const userTurnRef = useRef102(null);
  const unansweredTurnsRef = useRef102([]);
  const answeredTurnsRef = useRef102([]);
  const assistantTurnRef = useRef102(null);
  const delegatedSpeechRef = useRef102(false);
  const openDelegationsRef = useRef102(/* @__PURE__ */ new Set());
  const acknowledgementRef = useRef102(null);
  const optionsRef = useRef102(options);
  optionsRef.current = options;
  const emit2 = useCallback41((role, turn2, partial) => {
    const content = spokenText(turn2.text);
    if (!content) return;
    const message = { id: turn2.id, role, content, partial };
    setTranscript((prev) => [...prev.filter((m) => m.id !== turn2.id), message]);
    optionsRef.current.onTranscriptMessage?.(message);
  }, []);
  const retract = useCallback41((turn2) => {
    setTranscript((prev) => prev.filter((m) => m.id !== turn2.id));
    optionsRef.current.onTranscriptRetract?.(turn2.id);
  }, []);
  const closeUserTurn = useCallback41(() => {
    const turn2 = userTurnRef.current;
    if (!turn2) return;
    userTurnRef.current = null;
    if (!spokenText(turn2.text)) return;
    unansweredTurnsRef.current.push(turn2);
    emit2("user", turn2, false);
  }, [emit2]);
  const closeAssistantTurn = useCallback41(() => {
    const turn2 = assistantTurnRef.current;
    if (!turn2) return;
    assistantTurnRef.current = null;
    if (unansweredTurnsRef.current.length > 0) {
      answeredTurnsRef.current = unansweredTurnsRef.current;
      unansweredTurnsRef.current = [];
    }
    emit2("assistant", turn2, false);
  }, [emit2]);
  const settleAfter = useCallback41((ms, action) => {
    clearTimeout(settleTimerRef.current);
    settleTimerRef.current = setTimeout(action, ms);
  }, []);
  const settleToListening = useCallback41(() => {
    if (openDelegationsRef.current.size === 0) setTurn((prev) => prev && "listening");
  }, []);
  const appendUser = useCallback41((delta) => {
    closeAssistantTurn();
    if (openDelegationsRef.current.size === 0) delegatedSpeechRef.current = false;
    const turn2 = userTurnRef.current ?? (userTurnRef.current = { id: crypto.randomUUID(), text: "" });
    turn2.text += delta;
    emit2("user", turn2, true);
    settleAfter(LIVE_USER_TURN_HOLD_MS, closeUserTurn);
  }, [closeAssistantTurn, closeUserTurn, emit2, settleAfter]);
  const appendAssistant = useCallback41((delta) => {
    if (delegatedSpeechRef.current) {
      const acknowledgement = acknowledgementRef.current;
      if (acknowledgement) {
        acknowledgement.text += delta;
        const text4 = spokenText(acknowledgement.text);
        if (text4) optionsRef.current.onDelegationAcknowledgement?.(acknowledgement.delegationID, text4);
      }
      settleAfter(LIVE_TURN_SETTLE_MS, settleToListening);
      return;
    }
    closeUserTurn();
    const turn2 = assistantTurnRef.current ?? (assistantTurnRef.current = { id: crypto.randomUUID(), text: "" });
    turn2.text += delta;
    emit2("assistant", turn2, true);
    settleAfter(LIVE_TURN_SETTLE_MS, () => {
      closeAssistantTurn();
      settleToListening();
    });
  }, [closeAssistantTurn, closeUserTurn, emit2, settleAfter, settleToListening]);
  const delegate = useCallback41((id) => {
    clearTimeout(settleTimerRef.current);
    const earlySpeech = assistantTurnRef.current;
    assistantTurnRef.current = null;
    if (earlySpeech) retract(earlySpeech);
    const unanswered = [...unansweredTurnsRef.current, ...userTurnRef.current ? [userTurnRef.current] : []];
    const turns = unanswered.length > 0 ? unanswered : answeredTurnsRef.current;
    userTurnRef.current = null;
    unansweredTurnsRef.current = [];
    answeredTurnsRef.current = [];
    const question = turns.map((t) => spokenText(t.text)).filter(Boolean).join(" ");
    const asked = turns.at(-1);
    if (asked) {
      turns.slice(0, -1).forEach(retract);
      emit2("user", { id: asked.id, text: question }, false);
      setTranscript((prev) => prev.filter((m) => m.id !== asked.id));
    }
    delegatedSpeechRef.current = true;
    acknowledgementRef.current = { delegationID: id, text: earlySpeech?.text ?? "" };
    openDelegationsRef.current.add(id);
    setToolCallActive(true);
    setTurn((prev) => prev && "thinking");
    optionsRef.current.onDelegation?.({ id, question, ...asked && question && { messageID: asked.id } });
    const earlyAcknowledgement = spokenText(earlySpeech?.text ?? "");
    if (earlyAcknowledgement) optionsRef.current.onDelegationAcknowledgement?.(id, earlyAcknowledgement);
  }, [emit2, retract]);
  const sendEvent = useCallback41((event) => {
    if (dcRef.current?.readyState === "open") dcRef.current.send(JSON.stringify(event));
  }, []);
  const appendCommentary = useCallback41((delegationID, content) => {
    if (acknowledgementRef.current?.delegationID === delegationID) acknowledgementRef.current = null;
    sendEvent({ type: "session.commentary.append", delegation_id: delegationID, content });
  }, [sendEvent]);
  const appendThinking = useCallback41((delegationID, content) => {
    sendEvent({ type: "session.thinking.append", delegation_id: delegationID, content });
  }, [sendEvent]);
  const endDelegation = useCallback41((delegationID) => {
    openDelegationsRef.current.delete(delegationID);
    if (openDelegationsRef.current.size === 0) setToolCallActive(false);
  }, []);
  const changeMuted = useCallback41((next) => {
    streamRef.current?.getAudioTracks().forEach((track) => {
      track.enabled = !next;
    });
    setMuted(next);
    sendEvent({ type: next ? "session.input_audio.mute" : "session.input_audio.unmute" });
  }, [sendEvent]);
  const cleanup = useCallback41(() => {
    abortRef.current?.abort();
    abortRef.current = null;
    clearTimeout(settleTimerRef.current);
    clearTimeout(disconnectTimerRef.current);
    closeUserTurn();
    closeAssistantTurn();
    unansweredTurnsRef.current = [];
    answeredTurnsRef.current = [];
    delegatedSpeechRef.current = false;
    acknowledgementRef.current = null;
    openDelegationsRef.current.clear();
    setToolCallActive(false);
    setTurn(null);
    setMuted(false);
    streamRef.current?.getTracks().forEach((t) => t.stop());
    streamRef.current = null;
    setMicStream(null);
    dcRef.current?.close();
    dcRef.current = null;
    pcRef.current?.close();
    pcRef.current = null;
    if (audioElRef.current) {
      audioElRef.current.srcObject = null;
      audioElRef.current.remove();
      audioElRef.current = null;
    }
    setRemoteStream(null);
  }, [closeAssistantTurn, closeUserTurn]);
  useEffect76(() => () => {
    clearTimeout(disconnectTimerRef.current);
    clearTimeout(settleTimerRef.current);
  }, []);
  const fail = useCallback41((reason, detail) => {
    attemptIdRef.current++;
    cleanup();
    setStatus("error");
    setError(detail);
    setErrorReason(reason);
  }, [cleanup]);
  const end = useCallback41(() => {
    attemptIdRef.current++;
    cleanup();
    setStatus("idle");
    setError(null);
    setErrorReason(null);
    setTranscript([]);
  }, [cleanup]);
  const stop = useCallback41(() => {
    sendEvent({ type: "session.close" });
    end();
  }, [end, sendEvent]);
  const start = useCallback41(async () => {
    const id = ++attemptIdRef.current;
    const isStale = () => id !== attemptIdRef.current;
    setStatus("requesting-mic");
    setError(null);
    setErrorReason(null);
    setTurn(null);
    setTranscript([]);
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({
        audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true }
      });
    } catch (err) {
      if (isStale()) return;
      console.error("Failed to access the microphone:", err);
      fail(micErrorReason(err), err instanceof Error ? `${err.name}: ${err.message}` : "Failed to access the microphone");
      return;
    }
    if (isStale()) {
      stream.getTracks().forEach((t) => t.stop());
      return;
    }
    streamRef.current = stream;
    setMicStream(stream);
    setStatus("connecting");
    const ac = new AbortController();
    abortRef.current = ac;
    try {
      const pc = new RTCPeerConnection();
      pcRef.current = pc;
      const isLive = () => !isStale() && pcRef.current === pc;
      const failCall = (reason, detail) => {
        if (!isLive()) return;
        console.error("Live voice call failed:", detail);
        fail(reason, detail);
      };
      stream.getAudioTracks().forEach((track) => pc.addTrack(track, stream));
      const audioEl = document.createElement("audio");
      audioEl.autoplay = true;
      audioEl.style.display = "none";
      document.body.appendChild(audioEl);
      audioElRef.current = audioEl;
      pc.ontrack = (event) => {
        audioEl.srcObject = event.streams[0];
        audioEl.play().catch(() => {
        });
        setRemoteStream(event.streams[0]);
      };
      const dc = pc.createDataChannel("oai-events");
      dcRef.current = dc;
      dc.onclose = () => failCall("connection", "Live data channel closed");
      dc.onerror = () => failCall("connection", "Live data channel error");
      dc.onmessage = (message) => {
        if (isStale()) return;
        let event;
        try {
          event = JSON.parse(message.data);
        } catch {
          return;
        }
        switch (event.type) {
          case "session.started":
            setTurn("ready");
            break;
          case "session.input_transcript.delta":
            setTurn((prev) => prev && (openDelegationsRef.current.size > 0 ? "thinking" : "listening"));
            appendUser(String(event.delta ?? ""));
            break;
          case "session.output_transcript.delta":
            setTurn((prev) => prev && "speaking");
            appendAssistant(String(event.delta ?? ""));
            break;
          case "session.delegation.created": {
            const delegationID = event.delegation?.id;
            if (delegationID) delegate(delegationID);
            break;
          }
          case "session.input_audio.muted":
            setMuted(true);
            break;
          case "session.input_audio.unmuted":
            setMuted(false);
            break;
          case "session.usage.updated":
            optionsRef.current.onUsage?.(event.usage);
            break;
          case "session.closed": {
            if (!isLive()) break;
            const reason = event.reason;
            if (event.usage) optionsRef.current.onUsage?.(event.usage);
            optionsRef.current.onSessionClosed?.(reason);
            const failure = CLOSE_FAILURES[reason];
            if (failure) failCall(failure, `Live session closed: ${reason}`);
            else end();
            break;
          }
          case "error":
            console.error("Live API error:", event.error);
            break;
        }
      };
      pc.onconnectionstatechange = () => {
        if (!isLive()) return;
        clearTimeout(disconnectTimerRef.current);
        switch (pc.connectionState) {
          case "connected":
            setStatus("connected");
            break;
          case "disconnected":
            disconnectTimerRef.current = setTimeout(failCall, VOICE_DISCONNECT_GRACE_MS, "connection", "Live connection lost");
            break;
          case "failed":
            failCall("connection", "Live connection failed");
            break;
        }
      };
      const offer = await pc.createOffer();
      await pc.setLocalDescription(offer);
      const answer = await optionsRef.current.connect(offer.sdp ?? "", ac.signal);
      if (isStale()) return;
      await pc.setRemoteDescription({ type: "answer", sdp: answer.sdp });
    } catch (err) {
      if (isStale()) return;
      console.error("Failed to start the Live voice call:", err);
      fail("service", err instanceof Error ? err.message : "Failed to start the Live voice call");
    }
  }, [appendUser, appendAssistant, delegate, end, fail]);
  return { status, error: error2, errorReason, micStream, remoteStream, transcript, toolCallActive, turn, start, stop, appendCommentary, appendThinking, endDelegation, muted, setMuted: changeMuted };
}

// src/hooks/useResolvedThemeMode.ts
import { useEffect as useEffect77, useState as useState86 } from "react";
var DARK_MEDIA_QUERY = "(prefers-color-scheme: dark)";
function getSystemMode() {
  if (typeof window === "undefined" || !window.matchMedia) return "light";
  return window.matchMedia(DARK_MEDIA_QUERY).matches ? "dark" : "light";
}
function useResolvedThemeMode(theme) {
  const [systemMode, setSystemMode] = useState86(getSystemMode);
  useEffect77(() => {
    if (theme !== "Auto" || typeof window === "undefined" || !window.matchMedia) return;
    const mediaQuery = window.matchMedia(DARK_MEDIA_QUERY);
    const handleChange = (event) => {
      setSystemMode(event.matches ? "dark" : "light");
    };
    setSystemMode(mediaQuery.matches ? "dark" : "light");
    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }
    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, [theme]);
  if (theme === "Dark") return "dark";
  if (theme === "Auto") return systemMode;
  return "light";
}

// src/hooks/useSessionReplay.ts
import { useCallback as useCallback42, useEffect as useEffect78, useMemo as useMemo37, useRef as useRef103, useState as useState87 } from "react";
var TICK_MS = 30;
var CHARS_PER_TICK = 3;
var INITIAL_PAUSE = 10;
var PAUSE_AFTER_ASSISTANT = 10;
var PAUSE_AFTER_USER_DEFAULT = 6;
var PAUSE_USER_TO_ASSISTANT = 38;
var THINK_DELAY_TICKS = 14;
var PAUSE_ASSISTANT_TO_USER = 22;
var PAUSE_BETWEEN_TIMELINE_ITEMS = 6;
var TOOL_RUNNING_TICKS = 20;
var PRODUCT_CARD_LOADING_TICKS = 20;
var PRODUCT_LOADING_TICKS = 25;
var CLARIFYING_INITIAL_TICKS = 18;
var CLARIFYING_QUESTION_TICKS = 24;
function useSessionReplay(session) {
  const [replayActive, setReplayActive] = useState87(false);
  const [visibleCount, setVisibleCount] = useState87(null);
  const [streamingText, setStreamingText] = useState87(null);
  const [thinkingDelay, setThinkingDelay] = useState87(false);
  const [timelineIdx, setTimelineIdx] = useState87(null);
  const [timelineStreamText, setTimelineStreamText] = useState87(null);
  const [toolRunning, setToolRunning] = useState87(false);
  const [productCardLoading, setProductCardLoading] = useState87(false);
  const [productListLoading, setProductListLoading] = useState87(false);
  const [clarifyingLoading, setClarifyingLoading] = useState87(false);
  const [clarifyingQVisible, setClarifyingQVisible] = useState87(0);
  const [replayFinished, setReplayFinished] = useState87(false);
  const replayRef = useRef103({
    timer: null,
    msgIdx: 0,
    charIdx: 0,
    pause: 0,
    thinkDelay: 0,
    tlIdx: 0,
    tlCharIdx: 0,
    toolPhase: 0,
    productCardPhase: 0,
    productPhase: 0,
    clarifyingPhase: 0,
    clarifyingQCount: 0
  });
  const stopReplay = useCallback42(() => {
    const r = replayRef.current;
    if (r.timer) {
      clearInterval(r.timer);
      r.timer = null;
    }
    setReplayActive(false);
    setReplayFinished(false);
    setVisibleCount(null);
    setStreamingText(null);
    setThinkingDelay(false);
    setTimelineIdx(null);
    setTimelineStreamText(null);
    setToolRunning(false);
    setProductCardLoading(false);
    setProductListLoading(false);
    setClarifyingLoading(false);
    setClarifyingQVisible(0);
  }, []);
  const startReplay = useCallback42(() => {
    stopReplay();
    const messages = session.messages;
    if (messages.length === 0) return;
    setReplayActive(true);
    setVisibleCount(0);
    setStreamingText(null);
    setTimelineIdx(null);
    setTimelineStreamText(null);
    setToolRunning(false);
    setProductCardLoading(false);
    setProductListLoading(false);
    setClarifyingLoading(false);
    setClarifyingQVisible(0);
    const r = replayRef.current;
    r.msgIdx = 0;
    r.charIdx = 0;
    r.pause = INITIAL_PAUSE;
    r.thinkDelay = 0;
    r.tlIdx = 0;
    r.tlCharIdx = 0;
    r.toolPhase = 0;
    r.productCardPhase = 0;
    r.productPhase = 0;
    r.clarifyingPhase = 0;
    r.clarifyingQCount = 0;
    r.timer = setInterval(() => {
      if (r.pause > 0) {
        r.pause--;
        if (r.thinkDelay > 0) {
          r.thinkDelay--;
          if (r.thinkDelay === 0) setThinkingDelay(false);
        }
        return;
      }
      if (r.msgIdx >= messages.length) {
        setVisibleCount(null);
        setStreamingText(null);
        setTimelineIdx(null);
        setTimelineStreamText(null);
        setToolRunning(false);
        setProductCardLoading(false);
        setProductListLoading(false);
        setClarifyingLoading(false);
        setClarifyingQVisible(0);
        setReplayActive(false);
        setReplayFinished(true);
        if (r.timer) {
          clearInterval(r.timer);
          r.timer = null;
        }
        return;
      }
      const msg = messages[r.msgIdx];
      const timeline = msg.role === "assistant" /* Assistant */ ? msg.timeline : void 0;
      if (msg.role === "assistant" /* Assistant */ && timeline && timeline.length > 0) {
        if (r.tlIdx >= timeline.length) {
          setVisibleCount(r.msgIdx + 1);
          setStreamingText(null);
          setTimelineIdx(null);
          setTimelineStreamText(null);
          setToolRunning(false);
          setProductCardLoading(false);
          setProductListLoading(false);
          setClarifyingLoading(false);
          setClarifyingQVisible(0);
          r.msgIdx++;
          r.charIdx = 0;
          r.tlIdx = 0;
          r.tlCharIdx = 0;
          r.toolPhase = 0;
          r.productCardPhase = 0;
          r.productPhase = 0;
          r.clarifyingPhase = 0;
          r.clarifyingQCount = 0;
          const next2 = messages[r.msgIdx];
          r.pause = next2 && next2.role !== "assistant" /* Assistant */ ? PAUSE_ASSISTANT_TO_USER : PAUSE_AFTER_ASSISTANT;
          return;
        }
        const item = timeline[r.tlIdx];
        if (item.type === "thinking" || item.type === "content") {
          const text4 = item.content ?? "";
          if (text4.length === 0) {
            setVisibleCount(r.msgIdx);
            setTimelineIdx(r.tlIdx + 1);
            setTimelineStreamText(null);
            setToolRunning(false);
            r.tlIdx++;
            r.tlCharIdx = 0;
            r.pause = PAUSE_BETWEEN_TIMELINE_ITEMS;
            return;
          }
          r.tlCharIdx = Math.min(r.tlCharIdx + CHARS_PER_TICK, text4.length);
          setVisibleCount(r.msgIdx);
          setTimelineIdx(r.tlIdx);
          setTimelineStreamText(text4.substring(0, r.tlCharIdx));
          setToolRunning(false);
          if (r.tlCharIdx >= text4.length) {
            setTimelineIdx(r.tlIdx + 1);
            setTimelineStreamText(null);
            r.tlIdx++;
            r.tlCharIdx = 0;
            r.pause = PAUSE_BETWEEN_TIMELINE_ITEMS;
          }
          return;
        }
        if (item.type === "tool") {
          if (r.toolPhase === 0 && r.tlCharIdx === 0) {
            r.toolPhase = TOOL_RUNNING_TICKS;
            r.tlCharIdx = 1;
          }
          if (r.toolPhase > 0) {
            r.toolPhase--;
            setVisibleCount(r.msgIdx);
            setTimelineIdx(r.tlIdx);
            setTimelineStreamText(null);
            setToolRunning(true);
            if (r.toolPhase === 0) {
              setTimelineIdx(r.tlIdx + 1);
              setToolRunning(false);
              r.tlIdx++;
              r.tlCharIdx = 0;
              r.pause = PAUSE_BETWEEN_TIMELINE_ITEMS;
            }
            return;
          }
          return;
        }
        if (item.type === "product_card") {
          if (r.productCardPhase === 0 && r.tlCharIdx === 0) {
            r.productCardPhase = PRODUCT_CARD_LOADING_TICKS;
            r.tlCharIdx = 1;
          }
          if (r.productCardPhase > 0) {
            r.productCardPhase--;
            setVisibleCount(r.msgIdx);
            setTimelineIdx(r.tlIdx);
            setTimelineStreamText(null);
            setToolRunning(false);
            setProductCardLoading(true);
            if (r.productCardPhase === 0) {
              setTimelineIdx(r.tlIdx + 1);
              setProductCardLoading(false);
              r.tlIdx++;
              r.tlCharIdx = 0;
              r.pause = PAUSE_BETWEEN_TIMELINE_ITEMS;
            }
            return;
          }
          return;
        }
        if (item.type === "product_list") {
          if (r.productPhase === 0 && r.tlCharIdx === 0) {
            r.productPhase = PRODUCT_LOADING_TICKS;
            r.tlCharIdx = 1;
          }
          if (r.productPhase > 0) {
            r.productPhase--;
            setVisibleCount(r.msgIdx);
            setTimelineIdx(r.tlIdx);
            setTimelineStreamText(null);
            setToolRunning(false);
            setProductListLoading(true);
            if (r.productPhase === 0) {
              setTimelineIdx(r.tlIdx + 1);
              setProductListLoading(false);
              r.tlIdx++;
              r.tlCharIdx = 0;
              r.pause = PAUSE_BETWEEN_TIMELINE_ITEMS;
            }
            return;
          }
          return;
        }
        if (item.type === "clarifying_questions") {
          const totalQ = item.questions.length;
          if (r.clarifyingPhase === 0 && r.tlCharIdx === 0) {
            r.clarifyingPhase = CLARIFYING_INITIAL_TICKS;
            r.clarifyingQCount = 0;
            r.tlCharIdx = 1;
          }
          if (r.clarifyingPhase > 0) {
            r.clarifyingPhase--;
            setVisibleCount(r.msgIdx);
            setTimelineIdx(r.tlIdx);
            setTimelineStreamText(null);
            setToolRunning(false);
            setProductListLoading(false);
            setClarifyingLoading(true);
            setClarifyingQVisible(r.clarifyingQCount);
            if (r.clarifyingPhase === 0) {
              r.clarifyingQCount++;
              if (r.clarifyingQCount >= totalQ) {
                setTimelineIdx(r.tlIdx + 1);
                setClarifyingLoading(false);
                setClarifyingQVisible(0);
                r.tlIdx++;
                r.tlCharIdx = 0;
                r.clarifyingQCount = 0;
                r.pause = PAUSE_BETWEEN_TIMELINE_ITEMS;
              } else {
                r.clarifyingPhase = CLARIFYING_QUESTION_TICKS;
              }
            }
            return;
          }
          return;
        }
        setVisibleCount(r.msgIdx);
        setTimelineIdx(r.tlIdx + 1);
        setTimelineStreamText(null);
        setToolRunning(false);
        setProductCardLoading(false);
        setProductListLoading(false);
        setClarifyingLoading(false);
        r.tlIdx++;
        r.tlCharIdx = 0;
        r.pause = PAUSE_BETWEEN_TIMELINE_ITEMS;
        return;
      }
      setVisibleCount(r.msgIdx + 1);
      setStreamingText(null);
      setTimelineIdx(null);
      setTimelineStreamText(null);
      setToolRunning(false);
      setProductCardLoading(false);
      setProductListLoading(false);
      setClarifyingLoading(false);
      setClarifyingQVisible(0);
      r.msgIdx++;
      r.charIdx = 0;
      r.tlIdx = 0;
      r.tlCharIdx = 0;
      r.toolPhase = 0;
      r.productCardPhase = 0;
      r.productPhase = 0;
      r.clarifyingPhase = 0;
      r.clarifyingQCount = 0;
      const next = messages[r.msgIdx];
      if (msg.role === "user" /* User */ && next && next.role === "assistant" /* Assistant */) {
        r.pause = PAUSE_USER_TO_ASSISTANT;
        r.thinkDelay = THINK_DELAY_TICKS;
        setThinkingDelay(true);
      } else if (msg.role === "assistant" /* Assistant */) {
        r.pause = next && next.role !== "assistant" /* Assistant */ ? PAUSE_ASSISTANT_TO_USER : PAUSE_AFTER_ASSISTANT;
      } else {
        r.pause = PAUSE_AFTER_USER_DEFAULT;
      }
    }, TICK_MS);
  }, [session, stopReplay]);
  useEffect78(() => () => {
    if (replayRef.current.timer) clearInterval(replayRef.current.timer);
  }, []);
  const replaySession = useMemo37(() => {
    if (visibleCount === null) return replayFinished ? { ...session, id: `${session.id}--replay` } : session;
    const all = session.messages;
    const isComplete = visibleCount >= all.length;
    const shown = all.slice(0, visibleCount);
    if (!isComplete && visibleCount < all.length) {
      const currentMsg = all[visibleCount];
      if (currentMsg.role === "assistant" /* Assistant */) {
        const tl = currentMsg.timeline;
        if (tl && tl.length > 0 && timelineIdx !== null) {
          const partialTimeline = tl.slice(0, timelineIdx);
          if (timelineIdx < tl.length) {
            const currentItem = tl[timelineIdx];
            if (timelineStreamText !== null && (currentItem.type === "thinking" || currentItem.type === "content")) {
              partialTimeline.push({ ...currentItem, content: timelineStreamText });
            } else if (toolRunning && currentItem.type === "tool") {
              partialTimeline.push({ ...currentItem, status: "running", result: void 0, failedReason: void 0 });
            } else if (productCardLoading && currentItem.type === "product_card") {
              partialTimeline.push({ ...currentItem, loading: true });
            } else if (productListLoading && currentItem.type === "product_list") {
              partialTimeline.push({ ...currentItem, loading: true });
            } else if (clarifyingLoading && currentItem.type === "clarifying_questions") {
              partialTimeline.push({
                ...currentItem,
                questions: currentItem.questions.slice(0, clarifyingQVisible),
                total: currentItem.questions.length || 1
              });
            }
          }
          if (partialTimeline.length > 0) {
            shown.push({ ...currentMsg, timeline: partialTimeline });
          }
        }
      }
    }
    return {
      ...session,
      // Distinct id so ChatLog re-snapshots baseline and animates each replayed message.
      id: `${session.id}--replay`,
      messages: shown,
      status: isComplete ? session.status : "InProgress" /* InProgress */,
      possibleReplies: isComplete ? session.possibleReplies ?? [] : [],
      isSending: !isComplete && streamingText === null && timelineIdx === null && !thinkingDelay && visibleCount < all.length && all[visibleCount].role === "assistant" /* Assistant */
    };
  }, [session, visibleCount, streamingText, thinkingDelay, timelineIdx, timelineStreamText, toolRunning, productCardLoading, productListLoading, clarifyingLoading, clarifyingQVisible, replayFinished]);
  return { replayActive, startReplay, stopReplay, replaySession };
}

// src/utils/listenForOutsidePress.ts
var LISTENER_OPTIONS = { capture: true, passive: true };
var DRAG_THRESHOLD_PX = 16;
function listenForOutsidePress(doc, isInside, onDismiss) {
  let outsidePress2;
  const movedPastThreshold = (press, event) => Math.hypot(event.clientX - press.origin.x, event.clientY - press.origin.y) > DRAG_THRESHOLD_PX;
  const handlePointerDown = (event) => {
    outsidePress2 = isInside(event) ? void 0 : { pointerId: event.pointerId, origin: { x: event.clientX, y: event.clientY }, dragged: false };
  };
  const handlePointerMove = (event) => {
    const press = outsidePress2;
    if (press?.pointerId === event.pointerId && movedPastThreshold(press, event)) press.dragged = true;
  };
  const handlePointerCancel = () => {
    outsidePress2 = void 0;
  };
  const handleClick = (event) => {
    const press = outsidePress2;
    outsidePress2 = void 0;
    if (!press || isInside(event)) return;
    const keyboardOrScripted = event.detail === 0;
    const dragged = press.dragged || movedPastThreshold(press, event);
    if (!keyboardOrScripted && !dragged) onDismiss();
  };
  doc.addEventListener("pointerdown", handlePointerDown, LISTENER_OPTIONS);
  doc.addEventListener("pointermove", handlePointerMove, LISTENER_OPTIONS);
  doc.addEventListener("pointercancel", handlePointerCancel, LISTENER_OPTIONS);
  doc.addEventListener("click", handleClick, LISTENER_OPTIONS);
  return () => {
    doc.removeEventListener("pointerdown", handlePointerDown, LISTENER_OPTIONS);
    doc.removeEventListener("pointermove", handlePointerMove, LISTENER_OPTIONS);
    doc.removeEventListener("pointercancel", handlePointerCancel, LISTENER_OPTIONS);
    doc.removeEventListener("click", handleClick, LISTENER_OPTIONS);
  };
}
export {
  AIScenario,
  Accordion2 as Accordion,
  AccordionContent2 as AccordionContent,
  AccordionHeader2 as AccordionHeader,
  AccordionItem2 as AccordionItem,
  AccordionTrigger2 as AccordionTrigger,
  AlertDialog2 as AlertDialog,
  AlertDialogAction2 as AlertDialogAction,
  AlertDialogCancel2 as AlertDialogCancel,
  AlertDialogContent2 as AlertDialogContent,
  AlertDialogDescription2 as AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay2 as AlertDialogOverlay,
  AlertDialogPortal2 as AlertDialogPortal,
  AlertDialogTitle2 as AlertDialogTitle,
  AlertDialogTrigger2 as AlertDialogTrigger,
  AnnouncementBar,
  Announcer,
  Autocomplete,
  AutocompleteContent,
  AutocompleteEmpty,
  AutocompleteGroup,
  AutocompleteInput,
  AutocompleteItem,
  AutocompleteLabel,
  Avatar2 as Avatar,
  Badge,
  BadgeOverlay,
  Button,
  ButtonGroup,
  ButtonGroupSeparator,
  Callout,
  CalloutActions,
  CalloutBody,
  CalloutContent,
  CalloutIcon,
  CalloutList,
  CalloutTitle,
  Card_default as Card,
  ChatBar,
  ChatBarIsland,
  ChatBarIslandShade,
  ChatBarUI,
  ChatImageView,
  ChatInput,
  ChatLog,
  ChatMarkdown,
  ChatMessage,
  ChatRole,
  ChatStreamStatus,
  Checkbox2 as Checkbox,
  ClarifyingQuestions,
  Collapse,
  Combobox,
  ComboboxChip3 as ComboboxChip,
  ComboboxChips3 as ComboboxChips,
  ComboboxChipsInput,
  ComboboxContent,
  ComboboxCount,
  ComboboxEmpty3 as ComboboxEmpty,
  ComboboxItem3 as ComboboxItem,
  ComboboxList3 as ComboboxList,
  ComboboxTrigger3 as ComboboxTrigger,
  ComboboxValue2 as ComboboxValue,
  ComponentsI18nProvider,
  ContentRenderer,
  ConversationComposer_default as ConversationComposer,
  ConversationMessages,
  Conversations,
  CopyButton,
  CopyField,
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
  Divider,
  DrawnCheck,
  DropdownMenu2 as DropdownMenu,
  DropdownMenuCheckboxItem2 as DropdownMenuCheckboxItem,
  DropdownMenuContent2 as DropdownMenuContent,
  DropdownMenuGroup2 as DropdownMenuGroup,
  DropdownMenuItem2 as DropdownMenuItem,
  DropdownMenuItemCaption,
  DropdownMenuLabel2 as DropdownMenuLabel,
  DropdownMenuRadioGroup2 as DropdownMenuRadioGroup,
  DropdownMenuRadioItem2 as DropdownMenuRadioItem,
  DropdownMenuSeparator2 as DropdownMenuSeparator,
  DropdownMenuSub2 as DropdownMenuSub,
  DropdownMenuSubContent2 as DropdownMenuSubContent,
  DropdownMenuSubTrigger2 as DropdownMenuSubTrigger,
  DropdownMenuTrigger2 as DropdownMenuTrigger,
  EditBanner,
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateMedia,
  EmptyStateTitle,
  Field,
  FloatingButton,
  FloatingChatUI,
  GoogleButton,
  IconTile,
  ImageFrame,
  InfoTip,
  InlineForm,
  LIVE_TURN_SETTLE_MS,
  LIVE_USER_TURN_HOLD_MS,
  Link,
  LoadingActivityMute,
  LoadingActivityProvider,
  LoadingState,
  MAX_CHAT_PRODUCTS,
  MAX_MESSAGES_COUNT,
  MAX_MESSAGE_LENGTH,
  MERCHANT_AGENT_MAX_MESSAGE_LENGTH,
  MarkdownContent,
  MerchantAgentActionCard,
  MerchantAgentChangeCard,
  MerchantAgentChatNotices,
  MerchantAgentComposer,
  MerchantAgentConversationList,
  MerchantAgentMarkdown,
  MerchantAgentMessageList,
  MultiSelect,
  NumberField,
  PageGrid,
  PageGridItem,
  Pagination,
  Popover,
  PopoverAnchor,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
  PopupMessage,
  PresetReplyButton,
  ProductCard,
  ProductCardTimelineItem,
  ProductList,
  ProductMentionChip,
  ProductMentionText,
  ProductSelector,
  Progress,
  PropertyList,
  PropertyListItem,
  RadioCard,
  RadioGroup4 as RadioGroup,
  RadioGroupItem2 as RadioGroupItem,
  SUPPORTED_LOCALES,
  SegmentedControl,
  SegmentedControlItem,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  SettingsGroup,
  SettingsGroupAction,
  SettingsGroupDescription,
  SettingsGroupHeader,
  SettingsGroupTitle,
  SettingsList,
  SettingsRow,
  SettingsRowContent,
  SettingsRowDescription,
  SettingsRowLeading,
  SettingsRowTitle,
  SettingsRowTrailing,
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetOverlay,
  SheetTitle,
  SheetTrigger,
  ShimmerText,
  SiriOrb,
  Skeleton,
  Slider2 as Slider,
  Spinner,
  StatusDot,
  SupportRequest,
  Switch2 as Switch,
  TOOL_CALL_STAGE_DELAY_MS,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Text,
  TextField,
  ThinkingIndicator,
  TimelineRenderer,
  Toaster,
  ToolStatusIndicator,
  Tooltip,
  TryOnStage,
  VOICE_DISCONNECT_GRACE_MS,
  VoiceStage,
  announce,
  applyMerchantAgentChunk,
  createMerchantAgentChatState,
  formatMerchantAgentPreviewItems,
  formatMerchantAgentPreviewValue,
  formatToolName,
  getDistinctProductCount,
  getInitials,
  hasSubstantiveAssistantContent,
  humanizeMerchantAgentIdentifier,
  isFailedEmptyReply,
  isFailedReply,
  isImeComposing,
  isMerchantAgentReloadingNotice,
  isStreamLive,
  listenForOutsidePress,
  loadComponentsLocale,
  markMerchantAgentActionDecided,
  markMerchantAgentChangeUndone,
  markMerchantAgentUndoRefused,
  merchantAgentPreviewRowLabel,
  merchantAgentPreviewRows,
  merchantAgentRefusalNotice,
  merchantAgentStateFromDetail,
  merchantAgentUndoRefusal,
  micErrorReason,
  nextVoiceTurn,
  normalizeLocale,
  onAccentColor,
  parseMerchantAgentEventStream,
  parseMerchantAgentInline,
  parseMerchantAgentMarkdown,
  readMerchantAgentChange,
  readMerchantAgentEventStream,
  readMerchantAgentPreview,
  readMerchantAgentToolCard,
  resolveMerchantAgentHttpsLink,
  setComponentsLocale,
  shouldRenderChatMessage,
  spokenText,
  toast,
  useAudioLevel,
  useComboboxAnchor,
  useLiveVoice,
  useMerchantAgentChat,
  useRealtimeVoice,
  useReportLoading,
  useResolvedThemeMode,
  useSessionReplay
};
//# sourceMappingURL=index.mjs.map